//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.3.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IAccessoryAddService {
    accessoryAdd_AddAccessories(accessoryAddCommand: AccessoryAddCommand): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class AccessoryAddService implements IAccessoryAddService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    accessoryAdd_AddAccessories(accessoryAddCommand: AccessoryAddCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/AccessoryAdd/AddAccesories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(accessoryAddCommand);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccessoryAdd_AddAccessories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccessoryAdd_AddAccessories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAccessoryAdd_AddAccessories(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAccountService {
    account_GetCurrentUser(): Observable<UserViewModel>;
    account_UpdateCurrentUserPUT(user: UserEditViewModel): Observable<FileResponse>;
    account_UpdateCurrentUserPATCH(patch: Operation[] | undefined): Observable<FileResponse>;
    account_GetUserById(id: string): Observable<UserViewModel>;
    account_UpdateUserPUT(id: string, user: UserEditViewModel): Observable<FileResponse>;
    account_UpdateUserPATCH(id: string, patch: Operation[] | undefined): Observable<FileResponse>;
    account_DeleteUser(id: string): Observable<UserViewModel>;
    account_GetUserByUserName(userName: string): Observable<UserViewModel>;
    account_GetUsers(): Observable<UserViewModel[]>;
    account_Register(user: UserEditViewModel): Observable<FileResponse>;
    account_GetUsers2(page: number, pageSize: number): Observable<UserViewModel[]>;
    account_GetUserTypeData(): Observable<FileResponse>;
    account_UnblockUser(id: string): Observable<FileResponse>;
    account_UserPreferencesGET(): Observable<string>;
    account_UserPreferencesPUT(data: string): Observable<FileResponse>;
    account_GetRoleById(id: string): Observable<RoleViewModel>;
    account_UpdateRole(id: string, role: RoleViewModel): Observable<FileResponse>;
    account_DeleteRole(id: string): Observable<RoleViewModel>;
    account_GetRoleByName(name: string): Observable<RoleViewModel>;
    account_GetRoles(): Observable<RoleViewModel[]>;
    account_CreateRole(role: RoleViewModel): Observable<FileResponse>;
    account_GetRoles2(page: number, pageSize: number): Observable<RoleViewModel[]>;
    account_GetAllPermissions(): Observable<PermissionViewModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class AccountService implements IAccountService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    account_GetCurrentUser(): Observable<UserViewModel> {
        let url_ = this.baseUrl + "/api/Account/users/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccount_GetCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccount_GetCurrentUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserViewModel>;
        }));
    }

    protected processAccount_GetCurrentUser(response: HttpResponseBase): Observable<UserViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    account_UpdateCurrentUserPUT(user: UserEditViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Account/users/me";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccount_UpdateCurrentUserPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccount_UpdateCurrentUserPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAccount_UpdateCurrentUserPUT(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    account_UpdateCurrentUserPATCH(patch: Operation[] | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Account/users/me";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccount_UpdateCurrentUserPATCH(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccount_UpdateCurrentUserPATCH(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAccount_UpdateCurrentUserPATCH(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    account_GetUserById(id: string): Observable<UserViewModel> {
        let url_ = this.baseUrl + "/api/Account/users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccount_GetUserById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccount_GetUserById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserViewModel>;
        }));
    }

    protected processAccount_GetUserById(response: HttpResponseBase): Observable<UserViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    account_UpdateUserPUT(id: string, user: UserEditViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Account/users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccount_UpdateUserPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccount_UpdateUserPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAccount_UpdateUserPUT(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    account_UpdateUserPATCH(id: string, patch: Operation[] | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Account/users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccount_UpdateUserPATCH(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccount_UpdateUserPATCH(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAccount_UpdateUserPATCH(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    account_DeleteUser(id: string): Observable<UserViewModel> {
        let url_ = this.baseUrl + "/api/Account/users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccount_DeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccount_DeleteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserViewModel>;
        }));
    }

    protected processAccount_DeleteUser(response: HttpResponseBase): Observable<UserViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    account_GetUserByUserName(userName: string): Observable<UserViewModel> {
        let url_ = this.baseUrl + "/api/Account/users/username/{userName}";
        if (userName === undefined || userName === null)
            throw new Error("The parameter 'userName' must be defined.");
        url_ = url_.replace("{userName}", encodeURIComponent("" + userName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccount_GetUserByUserName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccount_GetUserByUserName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserViewModel>;
        }));
    }

    protected processAccount_GetUserByUserName(response: HttpResponseBase): Observable<UserViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    account_GetUsers(): Observable<UserViewModel[]> {
        let url_ = this.baseUrl + "/api/Account/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccount_GetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccount_GetUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserViewModel[]>;
        }));
    }

    protected processAccount_GetUsers(response: HttpResponseBase): Observable<UserViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    account_Register(user: UserEditViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Account/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccount_Register(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccount_Register(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAccount_Register(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    account_GetUsers2(page: number, pageSize: number): Observable<UserViewModel[]> {
        let url_ = this.baseUrl + "/api/Account/users/{page}/{pageSize}";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccount_GetUsers2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccount_GetUsers2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserViewModel[]>;
        }));
    }

    protected processAccount_GetUsers2(response: HttpResponseBase): Observable<UserViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    account_GetUserTypeData(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Account/userType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccount_GetUserTypeData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccount_GetUserTypeData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAccount_GetUserTypeData(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    account_UnblockUser(id: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Account/users/unblock/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccount_UnblockUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccount_UnblockUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAccount_UnblockUser(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    account_UserPreferencesGET(): Observable<string> {
        let url_ = this.baseUrl + "/api/Account/users/me/preferences";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccount_UserPreferencesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccount_UserPreferencesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAccount_UserPreferencesGET(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    account_UserPreferencesPUT(data: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Account/users/me/preferences";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccount_UserPreferencesPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccount_UserPreferencesPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAccount_UserPreferencesPUT(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    account_GetRoleById(id: string): Observable<RoleViewModel> {
        let url_ = this.baseUrl + "/api/Account/roles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccount_GetRoleById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccount_GetRoleById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleViewModel>;
        }));
    }

    protected processAccount_GetRoleById(response: HttpResponseBase): Observable<RoleViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    account_UpdateRole(id: string, role: RoleViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Account/roles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(role);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccount_UpdateRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccount_UpdateRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAccount_UpdateRole(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    account_DeleteRole(id: string): Observable<RoleViewModel> {
        let url_ = this.baseUrl + "/api/Account/roles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccount_DeleteRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccount_DeleteRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleViewModel>;
        }));
    }

    protected processAccount_DeleteRole(response: HttpResponseBase): Observable<RoleViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    account_GetRoleByName(name: string): Observable<RoleViewModel> {
        let url_ = this.baseUrl + "/api/Account/roles/name/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccount_GetRoleByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccount_GetRoleByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleViewModel>;
        }));
    }

    protected processAccount_GetRoleByName(response: HttpResponseBase): Observable<RoleViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    account_GetRoles(): Observable<RoleViewModel[]> {
        let url_ = this.baseUrl + "/api/Account/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccount_GetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccount_GetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleViewModel[]>;
        }));
    }

    protected processAccount_GetRoles(response: HttpResponseBase): Observable<RoleViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    account_CreateRole(role: RoleViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Account/roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(role);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccount_CreateRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccount_CreateRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAccount_CreateRole(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    account_GetRoles2(page: number, pageSize: number): Observable<RoleViewModel[]> {
        let url_ = this.baseUrl + "/api/Account/roles/{page}/{pageSize}";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccount_GetRoles2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccount_GetRoles2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleViewModel[]>;
        }));
    }

    protected processAccount_GetRoles2(response: HttpResponseBase): Observable<RoleViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    account_GetAllPermissions(): Observable<PermissionViewModel[]> {
        let url_ = this.baseUrl + "/api/Account/permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccount_GetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccount_GetAllPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PermissionViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PermissionViewModel[]>;
        }));
    }

    protected processAccount_GetAllPermissions(response: HttpResponseBase): Observable<PermissionViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PermissionViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IActionService {
    action_GetMercantDetails(searchtext: string): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ActionService implements IActionService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    action_GetMercantDetails(searchtext: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Action/{searchText}";
        if (searchtext === undefined || searchtext === null)
            throw new Error("The parameter 'searchtext' must be defined.");
        url_ = url_.replace("{searchtext}", encodeURIComponent("" + searchtext));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAction_GetMercantDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAction_GetMercantDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAction_GetMercantDetails(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAppAccountService {
    appAccount_CreateUser(user: CreateUserCommand): Observable<number>;
    appAccount_GetAllUsers(): Observable<ApplicationUser[]>;
    appAccount_CreateMerchantUser(merchantUserCommand: CreateMerchantUserCommand): Observable<number>;
    appAccount_CreateBankUser(user: CreateUserCommand): Observable<number>;
    appAccount_GetMerchantUser(deploymentRequestId: string): Observable<MerchantUserViewModel>;
    appAccount_GetAllBankUsersWithRoles(): Observable<UserWithRolesVm[]>;
    appAccount_GetImarkUsersWithRoles(): Observable<UserWithRolesVm[]>;
    appAccount_GetBankUsersWithRoles(): Observable<UserWithRolesVm[]>;
    appAccount_GetMerchantUsers(): Observable<MerchantVm[]>;
    appAccount_GetRecentUserMerchant(): Observable<RecentlyCreatedMerchantUserVm>;
    appAccount_GetBankRolesWithPermissions(): Observable<RolePermissionVM[]>;
    appAccount_GetUserById(userId: string): Observable<UserProfileVm>;
    appAccount_Authenticate(request: AuthenticationRequest): Observable<FileResponse>;
    appAccount_MerchantAuthenticate(request: AuthenticationRequest): Observable<ApiResponseOfAuthResponseDTO>;
    appAccount_GetAppPermissions(): Observable<PermissionVm[]>;
    appAccount_GetAppBankPermissions(): Observable<PermissionVm[]>;
    appAccount_GetAppRoles(): Observable<RolePermissionVM[]>;
    appAccount_CreateRole(roleVm: RoleVm): Observable<FileResponse>;
    appAccount_GetAppBankRoles(): Observable<RolePermissionVM[]>;
    appAccount_CreateBankRole(command: CreateBankRoleCommand): Observable<FileResponse>;
    appAccount_GetAppRolesByUserType(userType: UserType | undefined): Observable<RoleVm[]>;
    appAccount_GetAppRolesByBank(): Observable<RoleVm[]>;
    appAccount_BankPortalPermissions(): Observable<FileResponse>;
    appAccount_AddPermisionsToRole(roleName: string | null | undefined, permissions: number[]): Observable<FileResponse>;
    appAccount_UpdatePermisionsToRole(roleName: string | null | undefined, permissions: number[]): Observable<FileResponse>;
    appAccount_AssignPermissionsToBankUserRole(roleName: string | null | undefined, permissions: number[]): Observable<FileResponse>;
    appAccount_UpdatePermissionsToBankUserRole(roleName: string | null | undefined, permissions: number[]): Observable<FileResponse>;
    appAccount_EditRole(userId: string, command: UpdateRoleCommand): Observable<FileResponse>;
    appAccount_UpdateProfile(userId: string, command: UpdateUserProfileCommand): Observable<FileResponse>;
    appAccount_UpdateUser(userId: string, command: UpdateUserCommand): Observable<FileResponse>;
    appAccount_UpdateBankUser(userId: string, command: UpdateUserCommand): Observable<FileResponse>;
    appAccount_ChangePassword(userId: string, command: ChangePasswordCommand): Observable<FileResponse>;
    appAccount_ResetPassword(userId: string, command: ResetPasswordCommand): Observable<FileResponse>;
    appAccount_ResetBankUserPassword(userId: string, command: ResetPasswordCommand): Observable<FileResponse>;
    appAccount_ChangeUserStatus(userId: string): Observable<FileResponse>;
    appAccount_AddUserToRoles(userId: string, roles: string[]): Observable<FileResponse>;
    appAccount_AddRolesToBankUser(userId: string, roles: string[]): Observable<FileResponse>;
    appAccount_UpdateRolesOfUser(userId: string, roles: string[]): Observable<FileResponse>;
    appAccount_UpdateRolesOfBankUser(userId: string, roles: string[]): Observable<FileResponse>;
    appAccount_ActivateUser(userId: string): Observable<FileResponse>;
    appAccount_DeactivateUser(userId: string): Observable<FileResponse>;
    appAccount_RemoveUsersFromRole(userId: string, roles: string[]): Observable<FileResponse>;
    appAccount_GetPermissionsByApp(appId: App): Observable<PermissionVm[]>;
}

@Injectable({
    providedIn: 'root'
})
export class AppAccountService implements IAppAccountService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    appAccount_CreateUser(user: CreateUserCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_CreateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_CreateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAppAccount_CreateUser(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_GetAllUsers(): Observable<ApplicationUser[]> {
        let url_ = this.baseUrl + "/api/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_GetAllUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_GetAllUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationUser[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationUser[]>;
        }));
    }

    protected processAppAccount_GetAllUsers(response: HttpResponseBase): Observable<ApplicationUser[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApplicationUser.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_CreateMerchantUser(merchantUserCommand: CreateMerchantUserCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/merchant-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(merchantUserCommand);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_CreateMerchantUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_CreateMerchantUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAppAccount_CreateMerchantUser(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_CreateBankUser(user: CreateUserCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/bank-users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_CreateBankUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_CreateBankUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAppAccount_CreateBankUser(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_GetMerchantUser(deploymentRequestId: string): Observable<MerchantUserViewModel> {
        let url_ = this.baseUrl + "/api/merchant-user/{deploymentRequestId}";
        if (deploymentRequestId === undefined || deploymentRequestId === null)
            throw new Error("The parameter 'deploymentRequestId' must be defined.");
        url_ = url_.replace("{deploymentRequestId}", encodeURIComponent("" + deploymentRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_GetMerchantUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_GetMerchantUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MerchantUserViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MerchantUserViewModel>;
        }));
    }

    protected processAppAccount_GetMerchantUser(response: HttpResponseBase): Observable<MerchantUserViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MerchantUserViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_GetAllBankUsersWithRoles(): Observable<UserWithRolesVm[]> {
        let url_ = this.baseUrl + "/api/bank-users-with-roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_GetAllBankUsersWithRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_GetAllBankUsersWithRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserWithRolesVm[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserWithRolesVm[]>;
        }));
    }

    protected processAppAccount_GetAllBankUsersWithRoles(response: HttpResponseBase): Observable<UserWithRolesVm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserWithRolesVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_GetImarkUsersWithRoles(): Observable<UserWithRolesVm[]> {
        let url_ = this.baseUrl + "/api/imark-users-with-roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_GetImarkUsersWithRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_GetImarkUsersWithRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserWithRolesVm[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserWithRolesVm[]>;
        }));
    }

    protected processAppAccount_GetImarkUsersWithRoles(response: HttpResponseBase): Observable<UserWithRolesVm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserWithRolesVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_GetBankUsersWithRoles(): Observable<UserWithRolesVm[]> {
        let url_ = this.baseUrl + "/api/all-bank-users-with-roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_GetBankUsersWithRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_GetBankUsersWithRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserWithRolesVm[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserWithRolesVm[]>;
        }));
    }

    protected processAppAccount_GetBankUsersWithRoles(response: HttpResponseBase): Observable<UserWithRolesVm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserWithRolesVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_GetMerchantUsers(): Observable<MerchantVm[]> {
        let url_ = this.baseUrl + "/api/all-merchant-users-with-roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_GetMerchantUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_GetMerchantUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MerchantVm[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MerchantVm[]>;
        }));
    }

    protected processAppAccount_GetMerchantUsers(response: HttpResponseBase): Observable<MerchantVm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MerchantVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_GetRecentUserMerchant(): Observable<RecentlyCreatedMerchantUserVm> {
        let url_ = this.baseUrl + "/api/recentlyCreatedUserMerchant";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_GetRecentUserMerchant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_GetRecentUserMerchant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecentlyCreatedMerchantUserVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecentlyCreatedMerchantUserVm>;
        }));
    }

    protected processAppAccount_GetRecentUserMerchant(response: HttpResponseBase): Observable<RecentlyCreatedMerchantUserVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecentlyCreatedMerchantUserVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_GetBankRolesWithPermissions(): Observable<RolePermissionVM[]> {
        let url_ = this.baseUrl + "/api/bank-roles-with-permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_GetBankRolesWithPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_GetBankRolesWithPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RolePermissionVM[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RolePermissionVM[]>;
        }));
    }

    protected processAppAccount_GetBankRolesWithPermissions(response: HttpResponseBase): Observable<RolePermissionVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RolePermissionVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_GetUserById(userId: string): Observable<UserProfileVm> {
        let url_ = this.baseUrl + "/api/users/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_GetUserById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_GetUserById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProfileVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProfileVm>;
        }));
    }

    protected processAppAccount_GetUserById(response: HttpResponseBase): Observable<UserProfileVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfileVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_Authenticate(request: AuthenticationRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/users/authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_Authenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_Authenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAppAccount_Authenticate(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_MerchantAuthenticate(request: AuthenticationRequest): Observable<ApiResponseOfAuthResponseDTO> {
        let url_ = this.baseUrl + "/api/merchantusers/merchantauthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_MerchantAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_MerchantAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfAuthResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfAuthResponseDTO>;
        }));
    }

    protected processAppAccount_MerchantAuthenticate(response: HttpResponseBase): Observable<ApiResponseOfAuthResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfAuthResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_GetAppPermissions(): Observable<PermissionVm[]> {
        let url_ = this.baseUrl + "/api/permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_GetAppPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_GetAppPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PermissionVm[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PermissionVm[]>;
        }));
    }

    protected processAppAccount_GetAppPermissions(response: HttpResponseBase): Observable<PermissionVm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PermissionVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_GetAppBankPermissions(): Observable<PermissionVm[]> {
        let url_ = this.baseUrl + "/api/bank-permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_GetAppBankPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_GetAppBankPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PermissionVm[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PermissionVm[]>;
        }));
    }

    protected processAppAccount_GetAppBankPermissions(response: HttpResponseBase): Observable<PermissionVm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PermissionVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_GetAppRoles(): Observable<RolePermissionVM[]> {
        let url_ = this.baseUrl + "/api/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_GetAppRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_GetAppRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RolePermissionVM[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RolePermissionVM[]>;
        }));
    }

    protected processAppAccount_GetAppRoles(response: HttpResponseBase): Observable<RolePermissionVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RolePermissionVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_CreateRole(roleVm: RoleVm): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(roleVm);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_CreateRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_CreateRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAppAccount_CreateRole(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_GetAppBankRoles(): Observable<RolePermissionVM[]> {
        let url_ = this.baseUrl + "/api/bank-roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_GetAppBankRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_GetAppBankRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RolePermissionVM[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RolePermissionVM[]>;
        }));
    }

    protected processAppAccount_GetAppBankRoles(response: HttpResponseBase): Observable<RolePermissionVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RolePermissionVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_CreateBankRole(command: CreateBankRoleCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/bank-roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_CreateBankRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_CreateBankRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAppAccount_CreateBankRole(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_GetAppRolesByUserType(userType: UserType | undefined): Observable<RoleVm[]> {
        let url_ = this.baseUrl + "/api/roles-by-usertype?";
        if (userType === null)
            throw new Error("The parameter 'userType' cannot be null.");
        else if (userType !== undefined)
            url_ += "userType=" + encodeURIComponent("" + userType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_GetAppRolesByUserType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_GetAppRolesByUserType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleVm[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleVm[]>;
        }));
    }

    protected processAppAccount_GetAppRolesByUserType(response: HttpResponseBase): Observable<RoleVm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_GetAppRolesByBank(): Observable<RoleVm[]> {
        let url_ = this.baseUrl + "/api/roles-by-bank";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_GetAppRolesByBank(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_GetAppRolesByBank(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleVm[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleVm[]>;
        }));
    }

    protected processAppAccount_GetAppRolesByBank(response: HttpResponseBase): Observable<RoleVm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_BankPortalPermissions(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/permissions/bank-portal";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_BankPortalPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_BankPortalPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAppAccount_BankPortalPermissions(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_AddPermisionsToRole(roleName: string | null | undefined, permissions: number[]): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/roles/assign-permissions?";
        if (roleName !== undefined && roleName !== null)
            url_ += "roleName=" + encodeURIComponent("" + roleName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(permissions);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_AddPermisionsToRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_AddPermisionsToRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAppAccount_AddPermisionsToRole(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_UpdatePermisionsToRole(roleName: string | null | undefined, permissions: number[]): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/roles/assign-permissions?";
        if (roleName !== undefined && roleName !== null)
            url_ += "roleName=" + encodeURIComponent("" + roleName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(permissions);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_UpdatePermisionsToRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_UpdatePermisionsToRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAppAccount_UpdatePermisionsToRole(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_AssignPermissionsToBankUserRole(roleName: string | null | undefined, permissions: number[]): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/roles/permissions?";
        if (roleName !== undefined && roleName !== null)
            url_ += "roleName=" + encodeURIComponent("" + roleName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(permissions);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_AssignPermissionsToBankUserRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_AssignPermissionsToBankUserRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAppAccount_AssignPermissionsToBankUserRole(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_UpdatePermissionsToBankUserRole(roleName: string | null | undefined, permissions: number[]): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/roles/permissions?";
        if (roleName !== undefined && roleName !== null)
            url_ += "roleName=" + encodeURIComponent("" + roleName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(permissions);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_UpdatePermissionsToBankUserRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_UpdatePermissionsToBankUserRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAppAccount_UpdatePermissionsToBankUserRole(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_EditRole(userId: string, command: UpdateRoleCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/roles/{userId}/edit-role";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_EditRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_EditRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAppAccount_EditRole(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_UpdateProfile(userId: string, command: UpdateUserProfileCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/users/{userId}/update-user-profile";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_UpdateProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_UpdateProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAppAccount_UpdateProfile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_UpdateUser(userId: string, command: UpdateUserCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/users/{userId}/update-user";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_UpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_UpdateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAppAccount_UpdateUser(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_UpdateBankUser(userId: string, command: UpdateUserCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/users/{userId}/bank-user";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_UpdateBankUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_UpdateBankUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAppAccount_UpdateBankUser(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_ChangePassword(userId: string, command: ChangePasswordCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/users/{userId}/change-password";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_ChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_ChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAppAccount_ChangePassword(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_ResetPassword(userId: string, command: ResetPasswordCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/users/{userId}/reset-password";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_ResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_ResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAppAccount_ResetPassword(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_ResetBankUserPassword(userId: string, command: ResetPasswordCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/users/{userId}/bank-user-password-reset";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_ResetBankUserPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_ResetBankUserPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAppAccount_ResetBankUserPassword(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_ChangeUserStatus(userId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/users/{userId}/change-status";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_ChangeUserStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_ChangeUserStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAppAccount_ChangeUserStatus(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_AddUserToRoles(userId: string, roles: string[]): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/users/{userId}/add-roles-to-user";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(roles);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_AddUserToRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_AddUserToRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAppAccount_AddUserToRoles(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_AddRolesToBankUser(userId: string, roles: string[]): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/users/{userId}/roles-to-bank-user";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(roles);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_AddRolesToBankUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_AddRolesToBankUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAppAccount_AddRolesToBankUser(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_UpdateRolesOfUser(userId: string, roles: string[]): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/users/{userId}/update-roles-to-user";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(roles);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_UpdateRolesOfUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_UpdateRolesOfUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAppAccount_UpdateRolesOfUser(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_UpdateRolesOfBankUser(userId: string, roles: string[]): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/users/{userId}/bank-user-role";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(roles);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_UpdateRolesOfBankUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_UpdateRolesOfBankUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAppAccount_UpdateRolesOfBankUser(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_ActivateUser(userId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/user/{userId}/update-user-activate";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_ActivateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_ActivateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAppAccount_ActivateUser(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_DeactivateUser(userId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/user/{userId}/update-user-deactivate";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_DeactivateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_DeactivateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAppAccount_DeactivateUser(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_RemoveUsersFromRole(userId: string, roles: string[]): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/users/{userId}/remove-roles-from-user";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(roles);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_RemoveUsersFromRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_RemoveUsersFromRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAppAccount_RemoveUsersFromRole(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appAccount_GetPermissionsByApp(appId: App): Observable<PermissionVm[]> {
        let url_ = this.baseUrl + "/api/permissions/{appId}";
        if (appId === undefined || appId === null)
            throw new Error("The parameter 'appId' must be defined.");
        url_ = url_.replace("{appId}", encodeURIComponent("" + appId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppAccount_GetPermissionsByApp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppAccount_GetPermissionsByApp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PermissionVm[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PermissionVm[]>;
        }));
    }

    protected processAppAccount_GetPermissionsByApp(response: HttpResponseBase): Observable<PermissionVm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PermissionVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IApplicationVersionService {
    applicationVersion_GetAll(page: number, pageSize: number): Observable<ApplicationVersionViewModel[]>;
    applicationVersion_ApplicationVersionUpdateFormData(deploymentRequestId: string): Observable<ApplicationVersionUpdateFormData>;
    applicationVersion_GetAll2(bankId: string, page: number, pageSize: number): Observable<ApplicationVersionViewModel[]>;
    applicationVersion_Get(id: string): Observable<FileResponse>;
    applicationVersion_Put(id: string, _applicationVersionVM: ApplicationVersionViewModel): Observable<FileResponse>;
    applicationVersion_Delete(id: string): Observable<ApplicationVersionViewModel>;
    applicationVersion_AddApplicationVersion(_applicationVersionVM: ApplicationVersionViewModel): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ApplicationVersionService implements IApplicationVersionService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    applicationVersion_GetAll(page: number, pageSize: number): Observable<ApplicationVersionViewModel[]> {
        let url_ = this.baseUrl + "/api/ApplicationVersion/pagination/{page}/{pageSize}";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplicationVersion_GetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplicationVersion_GetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationVersionViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationVersionViewModel[]>;
        }));
    }

    protected processApplicationVersion_GetAll(response: HttpResponseBase): Observable<ApplicationVersionViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApplicationVersionViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    applicationVersion_ApplicationVersionUpdateFormData(deploymentRequestId: string): Observable<ApplicationVersionUpdateFormData> {
        let url_ = this.baseUrl + "/api/ApplicationVersion/ApplicationVersionUpdateFormData/{deploymentRequestId}";
        if (deploymentRequestId === undefined || deploymentRequestId === null)
            throw new Error("The parameter 'deploymentRequestId' must be defined.");
        url_ = url_.replace("{deploymentRequestId}", encodeURIComponent("" + deploymentRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplicationVersion_ApplicationVersionUpdateFormData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplicationVersion_ApplicationVersionUpdateFormData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationVersionUpdateFormData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationVersionUpdateFormData>;
        }));
    }

    protected processApplicationVersion_ApplicationVersionUpdateFormData(response: HttpResponseBase): Observable<ApplicationVersionUpdateFormData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationVersionUpdateFormData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    applicationVersion_GetAll2(bankId: string, page: number, pageSize: number): Observable<ApplicationVersionViewModel[]> {
        let url_ = this.baseUrl + "/api/ApplicationVersion/{bankId}/{page}/{pageSize}";
        if (bankId === undefined || bankId === null)
            throw new Error("The parameter 'bankId' must be defined.");
        url_ = url_.replace("{bankId}", encodeURIComponent("" + bankId));
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplicationVersion_GetAll2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplicationVersion_GetAll2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationVersionViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationVersionViewModel[]>;
        }));
    }

    protected processApplicationVersion_GetAll2(response: HttpResponseBase): Observable<ApplicationVersionViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApplicationVersionViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    applicationVersion_Get(id: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ApplicationVersion/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplicationVersion_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplicationVersion_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processApplicationVersion_Get(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    applicationVersion_Put(id: string, _applicationVersionVM: ApplicationVersionViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ApplicationVersion/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_applicationVersionVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplicationVersion_Put(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplicationVersion_Put(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processApplicationVersion_Put(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    applicationVersion_Delete(id: string): Observable<ApplicationVersionViewModel> {
        let url_ = this.baseUrl + "/api/ApplicationVersion/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplicationVersion_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplicationVersion_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationVersionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationVersionViewModel>;
        }));
    }

    protected processApplicationVersion_Delete(response: HttpResponseBase): Observable<ApplicationVersionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationVersionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    applicationVersion_AddApplicationVersion(_applicationVersionVM: ApplicationVersionViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ApplicationVersion/AddApplicationVersion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_applicationVersionVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplicationVersion_AddApplicationVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplicationVersion_AddApplicationVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processApplicationVersion_AddApplicationVersion(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IBankService {
    bank_GetBanks(): Observable<BanksViewModel[]>;
    bank_AddBank(createBankCommand: CreateNewBankCommand): Observable<ResponseViewModelOfString>;
    bank_GetSwitches(page: number, pageSize: number): Observable<SwitchViewModel[]>;
    bank_GetPartialRentalBank(page: number, pageSize: number): Observable<BanksViewModel[]>;
    bank_GetRentalBank(page: number, pageSize: number): Observable<BanksViewModel[]>;
    bank_GetBankForSpares(id: string): Observable<BanksViewModel[]>;
    bank_UpdateBankById(id: string, updateBankCommand: UpdateBankCommand): Observable<ResponseViewModelOfString>;
    bank_GetBankIdAndName(): Observable<GetBankIdAndNameQuery[]>;
    bank_GetBureauName(): Observable<BanksBureauVM[]>;
}

@Injectable({
    providedIn: 'root'
})
export class BankService implements IBankService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    bank_GetBanks(): Observable<BanksViewModel[]> {
        let url_ = this.baseUrl + "/api/banks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBank_GetBanks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBank_GetBanks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BanksViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BanksViewModel[]>;
        }));
    }

    protected processBank_GetBanks(response: HttpResponseBase): Observable<BanksViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BanksViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bank_AddBank(createBankCommand: CreateNewBankCommand): Observable<ResponseViewModelOfString> {
        let url_ = this.baseUrl + "/api/banks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createBankCommand);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBank_AddBank(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBank_AddBank(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseViewModelOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseViewModelOfString>;
        }));
    }

    protected processBank_AddBank(response: HttpResponseBase): Observable<ResponseViewModelOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseViewModelOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bank_GetSwitches(page: number, pageSize: number): Observable<SwitchViewModel[]> {
        let url_ = this.baseUrl + "/api/switch/{page}/{pageSize}";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBank_GetSwitches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBank_GetSwitches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwitchViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwitchViewModel[]>;
        }));
    }

    protected processBank_GetSwitches(response: HttpResponseBase): Observable<SwitchViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SwitchViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bank_GetPartialRentalBank(page: number, pageSize: number): Observable<BanksViewModel[]> {
        let url_ = this.baseUrl + "/api/partialRentalBank/{page}/{pageSize}";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBank_GetPartialRentalBank(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBank_GetPartialRentalBank(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BanksViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BanksViewModel[]>;
        }));
    }

    protected processBank_GetPartialRentalBank(response: HttpResponseBase): Observable<BanksViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BanksViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bank_GetRentalBank(page: number, pageSize: number): Observable<BanksViewModel[]> {
        let url_ = this.baseUrl + "/api/rentalBank/{page}/{pageSize}";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBank_GetRentalBank(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBank_GetRentalBank(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BanksViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BanksViewModel[]>;
        }));
    }

    protected processBank_GetRentalBank(response: HttpResponseBase): Observable<BanksViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BanksViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bank_GetBankForSpares(id: string): Observable<BanksViewModel[]> {
        let url_ = this.baseUrl + "/api/sparesSales/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBank_GetBankForSpares(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBank_GetBankForSpares(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BanksViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BanksViewModel[]>;
        }));
    }

    protected processBank_GetBankForSpares(response: HttpResponseBase): Observable<BanksViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BanksViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bank_UpdateBankById(id: string, updateBankCommand: UpdateBankCommand): Observable<ResponseViewModelOfString> {
        let url_ = this.baseUrl + "/api/banks/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateBankCommand);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBank_UpdateBankById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBank_UpdateBankById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseViewModelOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseViewModelOfString>;
        }));
    }

    protected processBank_UpdateBankById(response: HttpResponseBase): Observable<ResponseViewModelOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseViewModelOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bank_GetBankIdAndName(): Observable<GetBankIdAndNameQuery[]> {
        let url_ = this.baseUrl + "/api/banks/getBankIdAndName";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBank_GetBankIdAndName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBank_GetBankIdAndName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBankIdAndNameQuery[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBankIdAndNameQuery[]>;
        }));
    }

    protected processBank_GetBankIdAndName(response: HttpResponseBase): Observable<GetBankIdAndNameQuery[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetBankIdAndNameQuery.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bank_GetBureauName(): Observable<BanksBureauVM[]> {
        let url_ = this.baseUrl + "/api/banks/getBureaunameName";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBank_GetBureauName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBank_GetBureauName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BanksBureauVM[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BanksBureauVM[]>;
        }));
    }

    protected processBank_GetBureauName(response: HttpResponseBase): Observable<BanksBureauVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BanksBureauVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IBankPortalService {
    bankPortal_GetNacNumbers(): Observable<NacNumberViewModel[]>;
    bankPortal_GetMerchants(): Observable<MerchantForDropdownDTO[]>;
    bankPortal_GetTerminals(): Observable<TerminalForDropdownDTO[]>;
    bankPortal_GetTerminalInfo(): Observable<TerminalInfoViewModel[]>;
    bankPortal_GetMerchantCategoryList(): Observable<MerchantCategoryDetailsVM[]>;
    bankPortal_CreateDeploymentRequest(deploymentRequestVm: CreateDeploymentRequestCommand): Observable<FileResponse>;
    bankPortal_CreateSupport(createSupportCommand: CreateSupportCommand): Observable<void>;
    bankPortal_GetHistory(): Observable<DeployedHistoryViewModel[]>;
    bankPortal_GetDeployedTerminal(deploymentRequestId: string): Observable<DeployedHistoryViewModel>;
    bankPortal_PendingDeployList(): Observable<DeploymentAddRequestViewModel[]>;
    bankPortal_RemovalRequestById(id: string): Observable<FileResponse>;
    bankPortal_RejectRemovalById(id: string, _posHistoryVM: PosHistoryViewModel): Observable<FileResponse>;
    bankPortal_GetSupportData(): Observable<SupportViewModel[]>;
    bankPortal_GetRemoveRequestHistory(): Observable<RemovalRequestDetails[]>;
    bankPortal_PostSpareRequestByBank(sparesRequestVM: SpareRequestFromBankCommand): Observable<FileResponse>;
    bankPortal_PostMerchantAccessoriesRequest(merchantAccessoriesRequestVM: MerchantAccessoriesRequestViewModel): Observable<FileResponse>;
    bankPortal_PostMerchantSupportAndAccessoriesRequest(merchantAccessoriesAndSupportRequest: MerchantAccessoriesAndSupportRequestVm): Observable<FileResponse>;
    bankPortal_UpdateSpareRequestbyBank(sparesRequestVM: SparesRequestViewModel): Observable<FileResponse>;
    bankPortal_GetSparesDataInfo(): Observable<AccessoryViewModel[]>;
    bankPortal_GetMerchantCategory(): Observable<MerchantCategoryViewModel[]>;
    bankPortal_GetBankInfo(): Observable<Bank>;
    bankPortal_GetCategoryData(): Observable<CategoryWithBankViewModel[]>;
    bankPortal_GetDashboardData(): Observable<BankPortalDashboardViewModel[]>;
    bankPortal_GetProvinceData(): Observable<BankPortalDashboardViewModel[]>;
    bankPortal_GetDisttrictCountData(): Observable<BankPortalDashboardViewModel[]>;
    bankPortal_GetTotalMerchantCount(): Observable<number>;
    bankPortal_GetMonthlyData(): Observable<BankPortalDashboardViewModel[]>;
    bankPortal_ReplacementRequestById(id: string, posHistoryVm: ReplacementRequestCommand): Observable<FileResponse>;
    bankPortal_GetRetrievedHistory(): Observable<PosHistoryViewModel[]>;
    bankPortal_GetAllNotifications(): Observable<UserNotificationViewModel[]>;
    bankPortal_AddBankBranch(addBankBranchCommand: BranchViewModel[]): Observable<FileResponse>;
    bankPortal_GetBankBranch(): Observable<Branch[]>;
    bankPortal_UpdateBankBranchById(branchId: string, branchVM: BranchViewModel): Observable<FileResponse>;
    bankPortal_DeactivateBranch(branchId: string): Observable<FileResponse>;
    bankPortal_GetPendingRemoval(deploymentRequestId: string): Observable<RemovalStatusViewModel[]>;
    bankPortal_PostCardRequest(cardRequestVm: CardRequestsViewModel): Observable<FileResponse>;
    bankPortal_GetBanksOfBureau(): Observable<BureauDetail>;
    bankPortal_GetCardTypes(): Observable<CardProductViewModel[]>;
    bankPortal_GetAllCardPrintRequest(): Observable<CardRequestViewModel[]>;
    bankPortal_GetAllCardReport(): Observable<CardPrintReportVm[]>;
    bankPortal_GetbankSpecificCardTypes(bankId: string): Observable<CardProductViewModel[]>;
    bankPortal_PostTransaction(transactionVm: CreateTransactionRecordCommand[]): Observable<TransactionViewModel>;
    bankPortal_GetTransactionDetails(): Observable<TransactionRecord[]>;
    bankPortal_GetTransactionHeaders(): Observable<TransactionHeaders[]>;
    bankPortal_PostTransactionHeader(transactionVm: CreateTransactionHeaderCommand): Observable<TransactionViewModel>;
    bankPortal_EditTransactionHeader(transactionVm: UpdateTransactionHeaderCommand): Observable<TransactionViewModel>;
    bankPortal_GetSparesRequests(): Observable<SparesRequestViewModel[]>;
    bankPortal_GetDashboardTransactionData(): Observable<TransactionDashBoardData>;
    bankPortal_GetMerchantAndTerminal(): Observable<MerchantAndTerminalVm>;
    bankPortal_GetTerminalsDeployedThisWeek(fromDate: string | null | undefined, toDate: string | null | undefined): Observable<TerminalTrends[]>;
    bankPortal_GetPendingSupport(): Observable<number>;
    bankPortal_GetDeploymentTodayCount(): Observable<number>;
    bankPortal_GetPendingRemovalCounts(): Observable<number>;
    bankPortal_GetTotalTerminalsCount(): Observable<number>;
    bankPortal_GetPendingDeployment(): Observable<number>;
    bankPortal_GetPosNotReceivedCount(): Observable<number>;
    bankPortal_GetDeployedTodayCount(bankId: string): Observable<number>;
    bankPortal_GetResolvedSupportCount(): Observable<number>;
    bankPortal_GetReceivedTodayCount(): Observable<number>;
    bankPortal_getEstateBreakdown(): Observable<any[]>;
    bankPortal_GetTopMerchant(timePeriodInDays: number | undefined): Observable<MerchantTransaction[]>;
    bankPortal_GetTopMerchantCategory(timePeriodInDays: number | undefined): Observable<MerchantCategoryInfoVM[]>;
    bankPortal_GetTransactionDashboardDetails(): Observable<TransactionDetailDashboardVm[]>;
    bankPortal_GetTransactionDashboardDetailsForSuccessAndFailure(value: string | null | undefined): Observable<TransactionDetailDashboardVm[]>;
    bankPortal_GetPOSTerminalTransactionDetails(): Observable<TransactionDetailViewModel[]>;
    bankPortal_GetBankAccessoriesDistributionHistory(): Observable<OtherStockAddViewModel[]>;
    bankPortal_GetAllTerminalInfo(pageNumber: number | undefined, pageSize: number | undefined, merchantName: string | null | undefined, merchantId: string | null | undefined): Observable<PagedResponseOfTerminalAssociatedWithMerchantVM>;
    bankPortal_GetAllMerchantInfo(deploymentRequestId: string): Observable<MerchantInformationVM>;
    bankPortal_GetTerminalHeartbeatByDepReqId(deploymentRequestId: string): Observable<TerminalHeartbeatList>;
    bankPortal_GetTerminalHeartbeat(deploymentRequestIds: DeploymentRequestId[]): Observable<TerminalHeartbeatList[]>;
    bankPortal_GetTerminalInformation(deploymentRequestId: string): Observable<TerminalInformationViewModel>;
    bankPortal_GetAllDeploymentInfo(deploymentRequestId: string): Observable<DeploymentInformationVM>;
    bankPortal_GetAllDeploymentInfoFromPOSHistory(deploymentRequestId: string): Observable<DeploymentInformationVM>;
    bankPortal_GetAllMerchantSupportHistoryList(deploymentRequestId: string): Observable<MerchnatsHistoryVM[]>;
    bankPortal_GetAllMerchantAccessoriesHistoryList(deploymentRequestId: string): Observable<MerchantsAccessoriesHistoryVM[]>;
    bankPortal_GetImarkMidAndImarkTid(deploymentRequestId: string): Observable<ImarkMidAndTidViewModel>;
    bankPortal_GetAllMerchantsOtherHistoryList(deploymentRequestId: string): Observable<MerchantsOtherHistoryVM[]>;
    bankPortal_GetAllMerchantConfiguration(deploymentRequestId: string): Observable<MerchantConfigurationVM>;
    bankPortal_UpdateMerchantConfiguration(command: UpdateMerchantConfigurationCommand): Observable<FileResponse>;
    bankPortal_GetAllMerchantLocationInfo(deploymentRequestId: string): Observable<MerchantLocationInformationVM>;
    bankPortal_ImarkTerminalAdd(imarkTerminalAddCommands: ImarkTerminalAddCommands): Observable<FileResponse>;
    bankPortal_GetAllBankUsersWithRoles(): Observable<UserWithRolesVm[]>;
    bankPortal_GetAppBankRoles(): Observable<RolePermissionVM[]>;
    bankPortal_CreateBankRole(command: CreateBankRoleCommand): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class BankPortalService implements IBankPortalService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    bankPortal_GetNacNumbers(): Observable<NacNumberViewModel[]> {
        let url_ = this.baseUrl + "/api/BankPortal/nacNumbers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetNacNumbers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetNacNumbers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NacNumberViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NacNumberViewModel[]>;
        }));
    }

    protected processBankPortal_GetNacNumbers(response: HttpResponseBase): Observable<NacNumberViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NacNumberViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetMerchants(): Observable<MerchantForDropdownDTO[]> {
        let url_ = this.baseUrl + "/api/BankPortal/merchants";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetMerchants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetMerchants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MerchantForDropdownDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MerchantForDropdownDTO[]>;
        }));
    }

    protected processBankPortal_GetMerchants(response: HttpResponseBase): Observable<MerchantForDropdownDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MerchantForDropdownDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetTerminals(): Observable<TerminalForDropdownDTO[]> {
        let url_ = this.baseUrl + "/api/BankPortal/terminals";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetTerminals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetTerminals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TerminalForDropdownDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TerminalForDropdownDTO[]>;
        }));
    }

    protected processBankPortal_GetTerminals(response: HttpResponseBase): Observable<TerminalForDropdownDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TerminalForDropdownDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetTerminalInfo(): Observable<TerminalInfoViewModel[]> {
        let url_ = this.baseUrl + "/api/BankPortal/terminalInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetTerminalInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetTerminalInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TerminalInfoViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TerminalInfoViewModel[]>;
        }));
    }

    protected processBankPortal_GetTerminalInfo(response: HttpResponseBase): Observable<TerminalInfoViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TerminalInfoViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetMerchantCategoryList(): Observable<MerchantCategoryDetailsVM[]> {
        let url_ = this.baseUrl + "/api/BankPortal/merchant-category-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetMerchantCategoryList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetMerchantCategoryList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MerchantCategoryDetailsVM[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MerchantCategoryDetailsVM[]>;
        }));
    }

    protected processBankPortal_GetMerchantCategoryList(response: HttpResponseBase): Observable<MerchantCategoryDetailsVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MerchantCategoryDetailsVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_CreateDeploymentRequest(deploymentRequestVm: CreateDeploymentRequestCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/BankPortal/createDeploymentRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deploymentRequestVm);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_CreateDeploymentRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_CreateDeploymentRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processBankPortal_CreateDeploymentRequest(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_CreateSupport(createSupportCommand: CreateSupportCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/BankPortal/supports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createSupportCommand);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_CreateSupport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_CreateSupport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBankPortal_CreateSupport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetHistory(): Observable<DeployedHistoryViewModel[]> {
        let url_ = this.baseUrl + "/api/BankPortal/historyDataDeployed";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeployedHistoryViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeployedHistoryViewModel[]>;
        }));
    }

    protected processBankPortal_GetHistory(response: HttpResponseBase): Observable<DeployedHistoryViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeployedHistoryViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetDeployedTerminal(deploymentRequestId: string): Observable<DeployedHistoryViewModel> {
        let url_ = this.baseUrl + "/api/BankPortal/DeployedTerminal/{deploymentRequestId}";
        if (deploymentRequestId === undefined || deploymentRequestId === null)
            throw new Error("The parameter 'deploymentRequestId' must be defined.");
        url_ = url_.replace("{deploymentRequestId}", encodeURIComponent("" + deploymentRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetDeployedTerminal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetDeployedTerminal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeployedHistoryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeployedHistoryViewModel>;
        }));
    }

    protected processBankPortal_GetDeployedTerminal(response: HttpResponseBase): Observable<DeployedHistoryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeployedHistoryViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_PendingDeployList(): Observable<DeploymentAddRequestViewModel[]> {
        let url_ = this.baseUrl + "/api/BankPortal/pendingDeployList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_PendingDeployList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_PendingDeployList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeploymentAddRequestViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeploymentAddRequestViewModel[]>;
        }));
    }

    protected processBankPortal_PendingDeployList(response: HttpResponseBase): Observable<DeploymentAddRequestViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeploymentAddRequestViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_RemovalRequestById(id: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/BankPortal/removalRequest/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_RemovalRequestById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_RemovalRequestById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processBankPortal_RemovalRequestById(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_RejectRemovalById(id: string, _posHistoryVM: PosHistoryViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/BankPortal/rejectRemovalRequest/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_posHistoryVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_RejectRemovalById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_RejectRemovalById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processBankPortal_RejectRemovalById(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetSupportData(): Observable<SupportViewModel[]> {
        let url_ = this.baseUrl + "/api/BankPortal/supportReport";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetSupportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetSupportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupportViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupportViewModel[]>;
        }));
    }

    protected processBankPortal_GetSupportData(response: HttpResponseBase): Observable<SupportViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SupportViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetRemoveRequestHistory(): Observable<RemovalRequestDetails[]> {
        let url_ = this.baseUrl + "/api/BankPortal/detailsRemoveRequest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetRemoveRequestHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetRemoveRequestHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RemovalRequestDetails[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RemovalRequestDetails[]>;
        }));
    }

    protected processBankPortal_GetRemoveRequestHistory(response: HttpResponseBase): Observable<RemovalRequestDetails[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RemovalRequestDetails.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_PostSpareRequestByBank(sparesRequestVM: SpareRequestFromBankCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/BankPortal/postSpareRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sparesRequestVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_PostSpareRequestByBank(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_PostSpareRequestByBank(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processBankPortal_PostSpareRequestByBank(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_PostMerchantAccessoriesRequest(merchantAccessoriesRequestVM: MerchantAccessoriesRequestViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/BankPortal/merchantAccessoriesRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(merchantAccessoriesRequestVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_PostMerchantAccessoriesRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_PostMerchantAccessoriesRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processBankPortal_PostMerchantAccessoriesRequest(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_PostMerchantSupportAndAccessoriesRequest(merchantAccessoriesAndSupportRequest: MerchantAccessoriesAndSupportRequestVm): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/BankPortal/merchantSupportAndAccessoriesRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(merchantAccessoriesAndSupportRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_PostMerchantSupportAndAccessoriesRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_PostMerchantSupportAndAccessoriesRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processBankPortal_PostMerchantSupportAndAccessoriesRequest(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_UpdateSpareRequestbyBank(sparesRequestVM: SparesRequestViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/BankPortal/updateSpareRequestbyBank";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sparesRequestVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_UpdateSpareRequestbyBank(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_UpdateSpareRequestbyBank(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processBankPortal_UpdateSpareRequestbyBank(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetSparesDataInfo(): Observable<AccessoryViewModel[]> {
        let url_ = this.baseUrl + "/api/BankPortal/sparesDataInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetSparesDataInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetSparesDataInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccessoryViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccessoryViewModel[]>;
        }));
    }

    protected processBankPortal_GetSparesDataInfo(response: HttpResponseBase): Observable<AccessoryViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccessoryViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetMerchantCategory(): Observable<MerchantCategoryViewModel[]> {
        let url_ = this.baseUrl + "/api/BankPortal/merchantCategory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetMerchantCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetMerchantCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MerchantCategoryViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MerchantCategoryViewModel[]>;
        }));
    }

    protected processBankPortal_GetMerchantCategory(response: HttpResponseBase): Observable<MerchantCategoryViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MerchantCategoryViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetBankInfo(): Observable<Bank> {
        let url_ = this.baseUrl + "/api/BankPortal/bankInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetBankInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetBankInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Bank>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Bank>;
        }));
    }

    protected processBankPortal_GetBankInfo(response: HttpResponseBase): Observable<Bank> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Bank.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetCategoryData(): Observable<CategoryWithBankViewModel[]> {
        let url_ = this.baseUrl + "/api/BankPortal/categoryData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetCategoryData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetCategoryData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryWithBankViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryWithBankViewModel[]>;
        }));
    }

    protected processBankPortal_GetCategoryData(response: HttpResponseBase): Observable<CategoryWithBankViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CategoryWithBankViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetDashboardData(): Observable<BankPortalDashboardViewModel[]> {
        let url_ = this.baseUrl + "/api/BankPortal/dashboardData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetDashboardData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetDashboardData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BankPortalDashboardViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BankPortalDashboardViewModel[]>;
        }));
    }

    protected processBankPortal_GetDashboardData(response: HttpResponseBase): Observable<BankPortalDashboardViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BankPortalDashboardViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetProvinceData(): Observable<BankPortalDashboardViewModel[]> {
        let url_ = this.baseUrl + "/api/BankPortal/provinceCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetProvinceData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetProvinceData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BankPortalDashboardViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BankPortalDashboardViewModel[]>;
        }));
    }

    protected processBankPortal_GetProvinceData(response: HttpResponseBase): Observable<BankPortalDashboardViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BankPortalDashboardViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetDisttrictCountData(): Observable<BankPortalDashboardViewModel[]> {
        let url_ = this.baseUrl + "/api/BankPortal/districtCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetDisttrictCountData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetDisttrictCountData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BankPortalDashboardViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BankPortalDashboardViewModel[]>;
        }));
    }

    protected processBankPortal_GetDisttrictCountData(response: HttpResponseBase): Observable<BankPortalDashboardViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BankPortalDashboardViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetTotalMerchantCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/BankPortal/TotalMerchantCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetTotalMerchantCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetTotalMerchantCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processBankPortal_GetTotalMerchantCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetMonthlyData(): Observable<BankPortalDashboardViewModel[]> {
        let url_ = this.baseUrl + "/api/BankPortal/monthlyCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetMonthlyData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetMonthlyData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BankPortalDashboardViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BankPortalDashboardViewModel[]>;
        }));
    }

    protected processBankPortal_GetMonthlyData(response: HttpResponseBase): Observable<BankPortalDashboardViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BankPortalDashboardViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_ReplacementRequestById(id: string, posHistoryVm: ReplacementRequestCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/BankPortal/replacementRequest/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(posHistoryVm);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_ReplacementRequestById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_ReplacementRequestById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processBankPortal_ReplacementRequestById(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetRetrievedHistory(): Observable<PosHistoryViewModel[]> {
        let url_ = this.baseUrl + "/api/BankPortal/retrieveDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetRetrievedHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetRetrievedHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PosHistoryViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PosHistoryViewModel[]>;
        }));
    }

    protected processBankPortal_GetRetrievedHistory(response: HttpResponseBase): Observable<PosHistoryViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PosHistoryViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetAllNotifications(): Observable<UserNotificationViewModel[]> {
        let url_ = this.baseUrl + "/api/BankPortal/notification";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetAllNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetAllNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserNotificationViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserNotificationViewModel[]>;
        }));
    }

    protected processBankPortal_GetAllNotifications(response: HttpResponseBase): Observable<UserNotificationViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserNotificationViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_AddBankBranch(addBankBranchCommand: BranchViewModel[]): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/BankPortal/branches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addBankBranchCommand);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_AddBankBranch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_AddBankBranch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processBankPortal_AddBankBranch(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetBankBranch(): Observable<Branch[]> {
        let url_ = this.baseUrl + "/api/BankPortal/branches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetBankBranch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetBankBranch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Branch[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Branch[]>;
        }));
    }

    protected processBankPortal_GetBankBranch(response: HttpResponseBase): Observable<Branch[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Branch.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_UpdateBankBranchById(branchId: string, branchVM: BranchViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/BankPortal/branches/{branchId}";
        if (branchId === undefined || branchId === null)
            throw new Error("The parameter 'branchId' must be defined.");
        url_ = url_.replace("{branchId}", encodeURIComponent("" + branchId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(branchVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_UpdateBankBranchById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_UpdateBankBranchById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processBankPortal_UpdateBankBranchById(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_DeactivateBranch(branchId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/BankPortal/branches/{branchId}/deactivate";
        if (branchId === undefined || branchId === null)
            throw new Error("The parameter 'branchId' must be defined.");
        url_ = url_.replace("{branchId}", encodeURIComponent("" + branchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_DeactivateBranch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_DeactivateBranch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processBankPortal_DeactivateBranch(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetPendingRemoval(deploymentRequestId: string): Observable<RemovalStatusViewModel[]> {
        let url_ = this.baseUrl + "/api/BankPortal/removalStatus/{deploymentRequestId}";
        if (deploymentRequestId === undefined || deploymentRequestId === null)
            throw new Error("The parameter 'deploymentRequestId' must be defined.");
        url_ = url_.replace("{deploymentRequestId}", encodeURIComponent("" + deploymentRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetPendingRemoval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetPendingRemoval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RemovalStatusViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RemovalStatusViewModel[]>;
        }));
    }

    protected processBankPortal_GetPendingRemoval(response: HttpResponseBase): Observable<RemovalStatusViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RemovalStatusViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_PostCardRequest(cardRequestVm: CardRequestsViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/BankPortal/cardRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cardRequestVm);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_PostCardRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_PostCardRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processBankPortal_PostCardRequest(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetBanksOfBureau(): Observable<BureauDetail> {
        let url_ = this.baseUrl + "/api/BankPortal/printing-banks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetBanksOfBureau(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetBanksOfBureau(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BureauDetail>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BureauDetail>;
        }));
    }

    protected processBankPortal_GetBanksOfBureau(response: HttpResponseBase): Observable<BureauDetail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BureauDetail.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetCardTypes(): Observable<CardProductViewModel[]> {
        let url_ = this.baseUrl + "/api/BankPortal/card-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetCardTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetCardTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CardProductViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CardProductViewModel[]>;
        }));
    }

    protected processBankPortal_GetCardTypes(response: HttpResponseBase): Observable<CardProductViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CardProductViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetAllCardPrintRequest(): Observable<CardRequestViewModel[]> {
        let url_ = this.baseUrl + "/api/BankPortal/totalCardPrintRequest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetAllCardPrintRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetAllCardPrintRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CardRequestViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CardRequestViewModel[]>;
        }));
    }

    protected processBankPortal_GetAllCardPrintRequest(response: HttpResponseBase): Observable<CardRequestViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CardRequestViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetAllCardReport(): Observable<CardPrintReportVm[]> {
        let url_ = this.baseUrl + "/api/BankPortal/totalCardPrintReport";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetAllCardReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetAllCardReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CardPrintReportVm[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CardPrintReportVm[]>;
        }));
    }

    protected processBankPortal_GetAllCardReport(response: HttpResponseBase): Observable<CardPrintReportVm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CardPrintReportVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetbankSpecificCardTypes(bankId: string): Observable<CardProductViewModel[]> {
        let url_ = this.baseUrl + "/api/BankPortal/card-types-bankspecific/{bankId}";
        if (bankId === undefined || bankId === null)
            throw new Error("The parameter 'bankId' must be defined.");
        url_ = url_.replace("{bankId}", encodeURIComponent("" + bankId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetbankSpecificCardTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetbankSpecificCardTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CardProductViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CardProductViewModel[]>;
        }));
    }

    protected processBankPortal_GetbankSpecificCardTypes(response: HttpResponseBase): Observable<CardProductViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CardProductViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_PostTransaction(transactionVm: CreateTransactionRecordCommand[]): Observable<TransactionViewModel> {
        let url_ = this.baseUrl + "/api/BankPortal/transactionRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(transactionVm);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_PostTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_PostTransaction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionViewModel>;
        }));
    }

    protected processBankPortal_PostTransaction(response: HttpResponseBase): Observable<TransactionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetTransactionDetails(): Observable<TransactionRecord[]> {
        let url_ = this.baseUrl + "/api/BankPortal/transactionRecord";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetTransactionDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetTransactionDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionRecord[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionRecord[]>;
        }));
    }

    protected processBankPortal_GetTransactionDetails(response: HttpResponseBase): Observable<TransactionRecord[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransactionRecord.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetTransactionHeaders(): Observable<TransactionHeaders[]> {
        let url_ = this.baseUrl + "/api/BankPortal/transactionHeader";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetTransactionHeaders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetTransactionHeaders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionHeaders[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionHeaders[]>;
        }));
    }

    protected processBankPortal_GetTransactionHeaders(response: HttpResponseBase): Observable<TransactionHeaders[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransactionHeaders.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_PostTransactionHeader(transactionVm: CreateTransactionHeaderCommand): Observable<TransactionViewModel> {
        let url_ = this.baseUrl + "/api/BankPortal/transactionHeader";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(transactionVm);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_PostTransactionHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_PostTransactionHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionViewModel>;
        }));
    }

    protected processBankPortal_PostTransactionHeader(response: HttpResponseBase): Observable<TransactionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_EditTransactionHeader(transactionVm: UpdateTransactionHeaderCommand): Observable<TransactionViewModel> {
        let url_ = this.baseUrl + "/api/BankPortal/bank-transaction-header";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(transactionVm);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_EditTransactionHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_EditTransactionHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionViewModel>;
        }));
    }

    protected processBankPortal_EditTransactionHeader(response: HttpResponseBase): Observable<TransactionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetSparesRequests(): Observable<SparesRequestViewModel[]> {
        let url_ = this.baseUrl + "/api/BankPortal/sparesRequestDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetSparesRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetSparesRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SparesRequestViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SparesRequestViewModel[]>;
        }));
    }

    protected processBankPortal_GetSparesRequests(response: HttpResponseBase): Observable<SparesRequestViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SparesRequestViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetDashboardTransactionData(): Observable<TransactionDashBoardData> {
        let url_ = this.baseUrl + "/api/BankPortal/dashboardTransactionData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetDashboardTransactionData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetDashboardTransactionData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionDashBoardData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionDashBoardData>;
        }));
    }

    protected processBankPortal_GetDashboardTransactionData(response: HttpResponseBase): Observable<TransactionDashBoardData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionDashBoardData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetMerchantAndTerminal(): Observable<MerchantAndTerminalVm> {
        let url_ = this.baseUrl + "/api/BankPortal/get-merchant-and-terminal";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetMerchantAndTerminal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetMerchantAndTerminal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MerchantAndTerminalVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MerchantAndTerminalVm>;
        }));
    }

    protected processBankPortal_GetMerchantAndTerminal(response: HttpResponseBase): Observable<MerchantAndTerminalVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MerchantAndTerminalVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetTerminalsDeployedThisWeek(fromDate: string | null | undefined, toDate: string | null | undefined): Observable<TerminalTrends[]> {
        let url_ = this.baseUrl + "/api/BankPortal/getTerminalTrends?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetTerminalsDeployedThisWeek(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetTerminalsDeployedThisWeek(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TerminalTrends[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TerminalTrends[]>;
        }));
    }

    protected processBankPortal_GetTerminalsDeployedThisWeek(response: HttpResponseBase): Observable<TerminalTrends[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TerminalTrends.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetPendingSupport(): Observable<number> {
        let url_ = this.baseUrl + "/api/BankPortal/PendingSupport";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetPendingSupport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetPendingSupport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processBankPortal_GetPendingSupport(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetDeploymentTodayCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/BankPortal/todayDeployedTerminalCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetDeploymentTodayCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetDeploymentTodayCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processBankPortal_GetDeploymentTodayCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetPendingRemovalCounts(): Observable<number> {
        let url_ = this.baseUrl + "/api/BankPortal/getPendingRemoval";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetPendingRemovalCounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetPendingRemovalCounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processBankPortal_GetPendingRemovalCounts(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetTotalTerminalsCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/BankPortal/TotalTerminals";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetTotalTerminalsCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetTotalTerminalsCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processBankPortal_GetTotalTerminalsCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetPendingDeployment(): Observable<number> {
        let url_ = this.baseUrl + "/api/BankPortal/PendingDeployment";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetPendingDeployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetPendingDeployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processBankPortal_GetPendingDeployment(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetPosNotReceivedCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/BankPortal/PosNotReceived";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetPosNotReceivedCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetPosNotReceivedCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processBankPortal_GetPosNotReceivedCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetDeployedTodayCount(bankId: string): Observable<number> {
        let url_ = this.baseUrl + "/api/BankPortal/DeployedTodayCount/{bankId}";
        if (bankId === undefined || bankId === null)
            throw new Error("The parameter 'bankId' must be defined.");
        url_ = url_.replace("{bankId}", encodeURIComponent("" + bankId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetDeployedTodayCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetDeployedTodayCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processBankPortal_GetDeployedTodayCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetResolvedSupportCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/BankPortal/todayResolvedSupportCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetResolvedSupportCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetResolvedSupportCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processBankPortal_GetResolvedSupportCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetReceivedTodayCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/BankPortal/posReceivedToday";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetReceivedTodayCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetReceivedTodayCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processBankPortal_GetReceivedTodayCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_getEstateBreakdown(): Observable<any[]> {
        let url_ = this.baseUrl + "/api/BankPortal/EstateBreakDown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_getEstateBreakdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_getEstateBreakdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any[]>;
        }));
    }

    protected processBankPortal_getEstateBreakdown(response: HttpResponseBase): Observable<any[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetTopMerchant(timePeriodInDays: number | undefined): Observable<MerchantTransaction[]> {
        let url_ = this.baseUrl + "/api/BankPortal/TopMerchant?";
        if (timePeriodInDays === null)
            throw new Error("The parameter 'timePeriodInDays' cannot be null.");
        else if (timePeriodInDays !== undefined)
            url_ += "timePeriodInDays=" + encodeURIComponent("" + timePeriodInDays) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetTopMerchant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetTopMerchant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MerchantTransaction[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MerchantTransaction[]>;
        }));
    }

    protected processBankPortal_GetTopMerchant(response: HttpResponseBase): Observable<MerchantTransaction[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MerchantTransaction.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetTopMerchantCategory(timePeriodInDays: number | undefined): Observable<MerchantCategoryInfoVM[]> {
        let url_ = this.baseUrl + "/api/BankPortal/TopMerchantCategory?";
        if (timePeriodInDays === null)
            throw new Error("The parameter 'timePeriodInDays' cannot be null.");
        else if (timePeriodInDays !== undefined)
            url_ += "timePeriodInDays=" + encodeURIComponent("" + timePeriodInDays) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetTopMerchantCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetTopMerchantCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MerchantCategoryInfoVM[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MerchantCategoryInfoVM[]>;
        }));
    }

    protected processBankPortal_GetTopMerchantCategory(response: HttpResponseBase): Observable<MerchantCategoryInfoVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MerchantCategoryInfoVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetTransactionDashboardDetails(): Observable<TransactionDetailDashboardVm[]> {
        let url_ = this.baseUrl + "/api/BankPortal/getTransactionDashboardDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetTransactionDashboardDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetTransactionDashboardDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionDetailDashboardVm[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionDetailDashboardVm[]>;
        }));
    }

    protected processBankPortal_GetTransactionDashboardDetails(response: HttpResponseBase): Observable<TransactionDetailDashboardVm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransactionDetailDashboardVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetTransactionDashboardDetailsForSuccessAndFailure(value: string | null | undefined): Observable<TransactionDetailDashboardVm[]> {
        let url_ = this.baseUrl + "/api/BankPortal/transactionDashboardDetailsForSuccessAndFailure?";
        if (value !== undefined && value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetTransactionDashboardDetailsForSuccessAndFailure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetTransactionDashboardDetailsForSuccessAndFailure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionDetailDashboardVm[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionDetailDashboardVm[]>;
        }));
    }

    protected processBankPortal_GetTransactionDashboardDetailsForSuccessAndFailure(response: HttpResponseBase): Observable<TransactionDetailDashboardVm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransactionDetailDashboardVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetPOSTerminalTransactionDetails(): Observable<TransactionDetailViewModel[]> {
        let url_ = this.baseUrl + "/api/BankPortal/POS-TerminalTransactionDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetPOSTerminalTransactionDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetPOSTerminalTransactionDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionDetailViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionDetailViewModel[]>;
        }));
    }

    protected processBankPortal_GetPOSTerminalTransactionDetails(response: HttpResponseBase): Observable<TransactionDetailViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransactionDetailViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetBankAccessoriesDistributionHistory(): Observable<OtherStockAddViewModel[]> {
        let url_ = this.baseUrl + "/api/BankPortal/bankAccessoriesDistributionHistory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetBankAccessoriesDistributionHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetBankAccessoriesDistributionHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OtherStockAddViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OtherStockAddViewModel[]>;
        }));
    }

    protected processBankPortal_GetBankAccessoriesDistributionHistory(response: HttpResponseBase): Observable<OtherStockAddViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OtherStockAddViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetAllTerminalInfo(pageNumber: number | undefined, pageSize: number | undefined, merchantName: string | null | undefined, merchantId: string | null | undefined): Observable<PagedResponseOfTerminalAssociatedWithMerchantVM> {
        let url_ = this.baseUrl + "/api/BankPortal/getAllTerminalInfo?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (merchantName !== undefined && merchantName !== null)
            url_ += "merchantName=" + encodeURIComponent("" + merchantName) + "&";
        if (merchantId !== undefined && merchantId !== null)
            url_ += "merchantId=" + encodeURIComponent("" + merchantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetAllTerminalInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetAllTerminalInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfTerminalAssociatedWithMerchantVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfTerminalAssociatedWithMerchantVM>;
        }));
    }

    protected processBankPortal_GetAllTerminalInfo(response: HttpResponseBase): Observable<PagedResponseOfTerminalAssociatedWithMerchantVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfTerminalAssociatedWithMerchantVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetAllMerchantInfo(deploymentRequestId: string): Observable<MerchantInformationVM> {
        let url_ = this.baseUrl + "/api/BankPortal/getAllMerchantInfo/{deploymentRequestId}";
        if (deploymentRequestId === undefined || deploymentRequestId === null)
            throw new Error("The parameter 'deploymentRequestId' must be defined.");
        url_ = url_.replace("{deploymentRequestId}", encodeURIComponent("" + deploymentRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetAllMerchantInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetAllMerchantInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MerchantInformationVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MerchantInformationVM>;
        }));
    }

    protected processBankPortal_GetAllMerchantInfo(response: HttpResponseBase): Observable<MerchantInformationVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MerchantInformationVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetTerminalHeartbeatByDepReqId(deploymentRequestId: string): Observable<TerminalHeartbeatList> {
        let url_ = this.baseUrl + "/api/BankPortal/TerminalHeartbeat/{deploymentRequestId}";
        if (deploymentRequestId === undefined || deploymentRequestId === null)
            throw new Error("The parameter 'deploymentRequestId' must be defined.");
        url_ = url_.replace("{deploymentRequestId}", encodeURIComponent("" + deploymentRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetTerminalHeartbeatByDepReqId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetTerminalHeartbeatByDepReqId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TerminalHeartbeatList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TerminalHeartbeatList>;
        }));
    }

    protected processBankPortal_GetTerminalHeartbeatByDepReqId(response: HttpResponseBase): Observable<TerminalHeartbeatList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TerminalHeartbeatList.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetTerminalHeartbeat(deploymentRequestIds: DeploymentRequestId[]): Observable<TerminalHeartbeatList[]> {
        let url_ = this.baseUrl + "/api/BankPortal/TerminalHeartbeat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deploymentRequestIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetTerminalHeartbeat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetTerminalHeartbeat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TerminalHeartbeatList[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TerminalHeartbeatList[]>;
        }));
    }

    protected processBankPortal_GetTerminalHeartbeat(response: HttpResponseBase): Observable<TerminalHeartbeatList[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TerminalHeartbeatList.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetTerminalInformation(deploymentRequestId: string): Observable<TerminalInformationViewModel> {
        let url_ = this.baseUrl + "/api/BankPortal/TerminalInformation/{deploymentRequestId}";
        if (deploymentRequestId === undefined || deploymentRequestId === null)
            throw new Error("The parameter 'deploymentRequestId' must be defined.");
        url_ = url_.replace("{deploymentRequestId}", encodeURIComponent("" + deploymentRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetTerminalInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetTerminalInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TerminalInformationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TerminalInformationViewModel>;
        }));
    }

    protected processBankPortal_GetTerminalInformation(response: HttpResponseBase): Observable<TerminalInformationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TerminalInformationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetAllDeploymentInfo(deploymentRequestId: string): Observable<DeploymentInformationVM> {
        let url_ = this.baseUrl + "/api/BankPortal/getAllDeploymentInfo/{deploymentRequestId}";
        if (deploymentRequestId === undefined || deploymentRequestId === null)
            throw new Error("The parameter 'deploymentRequestId' must be defined.");
        url_ = url_.replace("{deploymentRequestId}", encodeURIComponent("" + deploymentRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetAllDeploymentInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetAllDeploymentInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeploymentInformationVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeploymentInformationVM>;
        }));
    }

    protected processBankPortal_GetAllDeploymentInfo(response: HttpResponseBase): Observable<DeploymentInformationVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeploymentInformationVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetAllDeploymentInfoFromPOSHistory(deploymentRequestId: string): Observable<DeploymentInformationVM> {
        let url_ = this.baseUrl + "/api/BankPortal/deploymentInfoFromPosHistory/{deploymentRequestId}";
        if (deploymentRequestId === undefined || deploymentRequestId === null)
            throw new Error("The parameter 'deploymentRequestId' must be defined.");
        url_ = url_.replace("{deploymentRequestId}", encodeURIComponent("" + deploymentRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetAllDeploymentInfoFromPOSHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetAllDeploymentInfoFromPOSHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeploymentInformationVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeploymentInformationVM>;
        }));
    }

    protected processBankPortal_GetAllDeploymentInfoFromPOSHistory(response: HttpResponseBase): Observable<DeploymentInformationVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeploymentInformationVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetAllMerchantSupportHistoryList(deploymentRequestId: string): Observable<MerchnatsHistoryVM[]> {
        let url_ = this.baseUrl + "/api/BankPortal/getAllMerchantSupportHistoryList/{deploymentRequestId}";
        if (deploymentRequestId === undefined || deploymentRequestId === null)
            throw new Error("The parameter 'deploymentRequestId' must be defined.");
        url_ = url_.replace("{deploymentRequestId}", encodeURIComponent("" + deploymentRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetAllMerchantSupportHistoryList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetAllMerchantSupportHistoryList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MerchnatsHistoryVM[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MerchnatsHistoryVM[]>;
        }));
    }

    protected processBankPortal_GetAllMerchantSupportHistoryList(response: HttpResponseBase): Observable<MerchnatsHistoryVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MerchnatsHistoryVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetAllMerchantAccessoriesHistoryList(deploymentRequestId: string): Observable<MerchantsAccessoriesHistoryVM[]> {
        let url_ = this.baseUrl + "/api/BankPortal/getAllMerchantAccessoriesHistoryList/{deploymentRequestId}";
        if (deploymentRequestId === undefined || deploymentRequestId === null)
            throw new Error("The parameter 'deploymentRequestId' must be defined.");
        url_ = url_.replace("{deploymentRequestId}", encodeURIComponent("" + deploymentRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetAllMerchantAccessoriesHistoryList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetAllMerchantAccessoriesHistoryList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MerchantsAccessoriesHistoryVM[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MerchantsAccessoriesHistoryVM[]>;
        }));
    }

    protected processBankPortal_GetAllMerchantAccessoriesHistoryList(response: HttpResponseBase): Observable<MerchantsAccessoriesHistoryVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MerchantsAccessoriesHistoryVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetImarkMidAndImarkTid(deploymentRequestId: string): Observable<ImarkMidAndTidViewModel> {
        let url_ = this.baseUrl + "/api/BankPortal/Imid-Itid-retrieval/{DeploymentRequestId}";
        if (deploymentRequestId === undefined || deploymentRequestId === null)
            throw new Error("The parameter 'deploymentRequestId' must be defined.");
        url_ = url_.replace("{DeploymentRequestId}", encodeURIComponent("" + deploymentRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetImarkMidAndImarkTid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetImarkMidAndImarkTid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImarkMidAndTidViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImarkMidAndTidViewModel>;
        }));
    }

    protected processBankPortal_GetImarkMidAndImarkTid(response: HttpResponseBase): Observable<ImarkMidAndTidViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImarkMidAndTidViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetAllMerchantsOtherHistoryList(deploymentRequestId: string): Observable<MerchantsOtherHistoryVM[]> {
        let url_ = this.baseUrl + "/api/BankPortal/getAllMerchantsOtherHistoryList/{deploymentRequestId}";
        if (deploymentRequestId === undefined || deploymentRequestId === null)
            throw new Error("The parameter 'deploymentRequestId' must be defined.");
        url_ = url_.replace("{deploymentRequestId}", encodeURIComponent("" + deploymentRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetAllMerchantsOtherHistoryList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetAllMerchantsOtherHistoryList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MerchantsOtherHistoryVM[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MerchantsOtherHistoryVM[]>;
        }));
    }

    protected processBankPortal_GetAllMerchantsOtherHistoryList(response: HttpResponseBase): Observable<MerchantsOtherHistoryVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MerchantsOtherHistoryVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetAllMerchantConfiguration(deploymentRequestId: string): Observable<MerchantConfigurationVM> {
        let url_ = this.baseUrl + "/api/BankPortal/getAllMerchantConfiguration/{deploymentRequestId}";
        if (deploymentRequestId === undefined || deploymentRequestId === null)
            throw new Error("The parameter 'deploymentRequestId' must be defined.");
        url_ = url_.replace("{deploymentRequestId}", encodeURIComponent("" + deploymentRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetAllMerchantConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetAllMerchantConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MerchantConfigurationVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MerchantConfigurationVM>;
        }));
    }

    protected processBankPortal_GetAllMerchantConfiguration(response: HttpResponseBase): Observable<MerchantConfigurationVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MerchantConfigurationVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_UpdateMerchantConfiguration(command: UpdateMerchantConfigurationCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/BankPortal/updateMerchantConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_UpdateMerchantConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_UpdateMerchantConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processBankPortal_UpdateMerchantConfiguration(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetAllMerchantLocationInfo(deploymentRequestId: string): Observable<MerchantLocationInformationVM> {
        let url_ = this.baseUrl + "/api/BankPortal/getAllMerchantLocationInfo/{deploymentRequestId}";
        if (deploymentRequestId === undefined || deploymentRequestId === null)
            throw new Error("The parameter 'deploymentRequestId' must be defined.");
        url_ = url_.replace("{deploymentRequestId}", encodeURIComponent("" + deploymentRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetAllMerchantLocationInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetAllMerchantLocationInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MerchantLocationInformationVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MerchantLocationInformationVM>;
        }));
    }

    protected processBankPortal_GetAllMerchantLocationInfo(response: HttpResponseBase): Observable<MerchantLocationInformationVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MerchantLocationInformationVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_ImarkTerminalAdd(imarkTerminalAddCommands: ImarkTerminalAddCommands): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/BankPortal/createImarkTerminalAdd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(imarkTerminalAddCommands);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_ImarkTerminalAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_ImarkTerminalAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processBankPortal_ImarkTerminalAdd(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetAllBankUsersWithRoles(): Observable<UserWithRolesVm[]> {
        let url_ = this.baseUrl + "/api/BankPortal/users-with-roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetAllBankUsersWithRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetAllBankUsersWithRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserWithRolesVm[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserWithRolesVm[]>;
        }));
    }

    protected processBankPortal_GetAllBankUsersWithRoles(response: HttpResponseBase): Observable<UserWithRolesVm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserWithRolesVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_GetAppBankRoles(): Observable<RolePermissionVM[]> {
        let url_ = this.baseUrl + "/api/BankPortal/bank-roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_GetAppBankRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_GetAppBankRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RolePermissionVM[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RolePermissionVM[]>;
        }));
    }

    protected processBankPortal_GetAppBankRoles(response: HttpResponseBase): Observable<RolePermissionVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RolePermissionVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bankPortal_CreateBankRole(command: CreateBankRoleCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/BankPortal/bank-roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBankPortal_CreateBankRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBankPortal_CreateBankRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processBankPortal_CreateBankRole(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICardPersoService {
    /**
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @return Get all the pending card print request.
     */
    cardPerso_GetCardPersoRequest(pageNumber: number | undefined, pageSize: number | undefined): Observable<PaginatedListOfCardPersoRequestVm>;
    /**
     * @return Card print request.
     */
    cardPerso_UpdateCardPrintRequest(_cardpersorequestVm: CardPersoRequestVm): Observable<CardPersoRequestVm>;
    /**
     * @param bankid (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @return Get all the Hardware list
     */
    cardPerso_GetHardwareBanks(bankid: string | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<PaginatedListOfHardwareListBanksVm>;
    /**
     * @param bankid (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @return Get all the bnak wise card product  list
     */
    cardPerso_GetCardProductsByBank(bankid: string | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<PaginatedListOfCardProductViewModel>;
    /**
     * @return Get all the bureau  list
     */
    cardPerso_GetBureauName(): Observable<PaginatedListOfBureauDetail>;
    /**
     * @return new Card request.
     */
    cardPerso_Post(cardRequestCommand: CreateCardRequestCommand): Observable<CreateCardRequestCommand>;
}

@Injectable({
    providedIn: 'root'
})
export class CardPersoService implements ICardPersoService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @return Get all the pending card print request.
     */
    cardPerso_GetCardPersoRequest(pageNumber: number | undefined, pageSize: number | undefined): Observable<PaginatedListOfCardPersoRequestVm> {
        let url_ = this.baseUrl + "/api/GetCardPersoRequest?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCardPerso_GetCardPersoRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCardPerso_GetCardPersoRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedListOfCardPersoRequestVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedListOfCardPersoRequestVm>;
        }));
    }

    protected processCardPerso_GetCardPersoRequest(response: HttpResponseBase): Observable<PaginatedListOfCardPersoRequestVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfCardPersoRequestVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Card print request.
     */
    cardPerso_UpdateCardPrintRequest(_cardpersorequestVm: CardPersoRequestVm): Observable<CardPersoRequestVm> {
        let url_ = this.baseUrl + "/api/UpdateCardPrintRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_cardpersorequestVm);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCardPerso_UpdateCardPrintRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCardPerso_UpdateCardPrintRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CardPersoRequestVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CardPersoRequestVm>;
        }));
    }

    protected processCardPerso_UpdateCardPrintRequest(response: HttpResponseBase): Observable<CardPersoRequestVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData422) {
                result422 = {} as any;
                for (let key in resultData422) {
                    if (resultData422.hasOwnProperty(key))
                        (<any>result422)![key] = resultData422[key] ? resultData422[key].map((i: any) => CustomizedValidationError.fromJS(i)) : [];
                }
            }
            else {
                result422 = <any>null;
            }
            return throwException("Response on Validation Errors.", status, _responseText, _headers, result422);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CardPersoRequestVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param bankid (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @return Get all the Hardware list
     */
    cardPerso_GetHardwareBanks(bankid: string | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<PaginatedListOfHardwareListBanksVm> {
        let url_ = this.baseUrl + "/api/GetHardwareListBanks?";
        if (bankid === null)
            throw new Error("The parameter 'bankid' cannot be null.");
        else if (bankid !== undefined)
            url_ += "bankid=" + encodeURIComponent("" + bankid) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCardPerso_GetHardwareBanks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCardPerso_GetHardwareBanks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedListOfHardwareListBanksVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedListOfHardwareListBanksVm>;
        }));
    }

    protected processCardPerso_GetHardwareBanks(response: HttpResponseBase): Observable<PaginatedListOfHardwareListBanksVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfHardwareListBanksVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param bankid (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @return Get all the bnak wise card product  list
     */
    cardPerso_GetCardProductsByBank(bankid: string | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<PaginatedListOfCardProductViewModel> {
        let url_ = this.baseUrl + "/api/GetCardProduct/BankProduct/bankid?";
        if (bankid === null)
            throw new Error("The parameter 'bankid' cannot be null.");
        else if (bankid !== undefined)
            url_ += "bankid=" + encodeURIComponent("" + bankid) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCardPerso_GetCardProductsByBank(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCardPerso_GetCardProductsByBank(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedListOfCardProductViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedListOfCardProductViewModel>;
        }));
    }

    protected processCardPerso_GetCardProductsByBank(response: HttpResponseBase): Observable<PaginatedListOfCardProductViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfCardProductViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Get all the bureau  list
     */
    cardPerso_GetBureauName(): Observable<PaginatedListOfBureauDetail> {
        let url_ = this.baseUrl + "/api/GetBureau/BankList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCardPerso_GetBureauName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCardPerso_GetBureauName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedListOfBureauDetail>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedListOfBureauDetail>;
        }));
    }

    protected processCardPerso_GetBureauName(response: HttpResponseBase): Observable<PaginatedListOfBureauDetail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfBureauDetail.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return new Card request.
     */
    cardPerso_Post(cardRequestCommand: CreateCardRequestCommand): Observable<CreateCardRequestCommand> {
        let url_ = this.baseUrl + "/api/PostNewCardRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cardRequestCommand);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCardPerso_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCardPerso_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateCardRequestCommand>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateCardRequestCommand>;
        }));
    }

    protected processCardPerso_Post(response: HttpResponseBase): Observable<CreateCardRequestCommand> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData422) {
                result422 = {} as any;
                for (let key in resultData422) {
                    if (resultData422.hasOwnProperty(key))
                        (<any>result422)![key] = resultData422[key] ? resultData422[key].map((i: any) => CustomizedValidationError.fromJS(i)) : [];
                }
            }
            else {
                result422 = <any>null;
            }
            return throwException("Response on Validation Errors.", status, _responseText, _headers, result422);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateCardRequestCommand.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICardProductService {
    cardProduct_Post(_cardVM: CardProductViewModel): Observable<FileResponse>;
    cardProduct_Put(_cardVM: CardProductViewModel): Observable<FileResponse>;
    cardProduct_GetCardProduct(): Observable<CardProductViewModel[]>;
    cardProduct_GetCardProductsByBank(bankId: string): Observable<CardProductViewModel[]>;
    cardProduct_GetCardType(): Observable<FileResponse>;
    cardProduct_GetCardBrand(): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class CardProductService implements ICardProductService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    cardProduct_Post(_cardVM: CardProductViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/CardProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_cardVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCardProduct_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCardProduct_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processCardProduct_Post(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cardProduct_Put(_cardVM: CardProductViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/CardProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_cardVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCardProduct_Put(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCardProduct_Put(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processCardProduct_Put(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cardProduct_GetCardProduct(): Observable<CardProductViewModel[]> {
        let url_ = this.baseUrl + "/api/CardProduct";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCardProduct_GetCardProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCardProduct_GetCardProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CardProductViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CardProductViewModel[]>;
        }));
    }

    protected processCardProduct_GetCardProduct(response: HttpResponseBase): Observable<CardProductViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CardProductViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cardProduct_GetCardProductsByBank(bankId: string): Observable<CardProductViewModel[]> {
        let url_ = this.baseUrl + "/api/CardProduct/BankProduct/{bankId}";
        if (bankId === undefined || bankId === null)
            throw new Error("The parameter 'bankId' must be defined.");
        url_ = url_.replace("{bankId}", encodeURIComponent("" + bankId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCardProduct_GetCardProductsByBank(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCardProduct_GetCardProductsByBank(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CardProductViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CardProductViewModel[]>;
        }));
    }

    protected processCardProduct_GetCardProductsByBank(response: HttpResponseBase): Observable<CardProductViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CardProductViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cardProduct_GetCardType(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/CardProduct/Type";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCardProduct_GetCardType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCardProduct_GetCardType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processCardProduct_GetCardType(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cardProduct_GetCardBrand(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/CardProduct/Brand";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCardProduct_GetCardBrand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCardProduct_GetCardBrand(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processCardProduct_GetCardBrand(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICardRequestService {
    cardRequest_Post(cardRequestCommand: CreateCardRequestCommand): Observable<FileResponse>;
    cardRequest_Put(_cardReqVm: CardRequestViewModel): Observable<FileResponse>;
    cardRequest_GetCardRequests(): Observable<CardRequestViewModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class CardRequestService implements ICardRequestService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    cardRequest_Post(cardRequestCommand: CreateCardRequestCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/CardRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cardRequestCommand);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCardRequest_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCardRequest_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processCardRequest_Post(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cardRequest_Put(_cardReqVm: CardRequestViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/CardRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_cardReqVm);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCardRequest_Put(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCardRequest_Put(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processCardRequest_Put(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cardRequest_GetCardRequests(): Observable<CardRequestViewModel[]> {
        let url_ = this.baseUrl + "/api/CardRequest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCardRequest_GetCardRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCardRequest_GetCardRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CardRequestViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CardRequestViewModel[]>;
        }));
    }

    protected processCardRequest_GetCardRequests(response: HttpResponseBase): Observable<CardRequestViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CardRequestViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICardRequestTransactionService {
    cardRequestTransaction_Post(_cardReqTransVm: CardRequestTransactionViewModel): Observable<FileResponse>;
    cardRequestTransaction_Put(_cardReqTransVm: CardRequestTransactionViewModel): Observable<FileResponse>;
    cardRequestTransaction_GetTransactions(): Observable<CardRequestTransactionViewModel[]>;
    cardRequestTransaction_GetProductPrintInfo(): Observable<CardRequestTransactionViewModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class CardRequestTransactionService implements ICardRequestTransactionService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    cardRequestTransaction_Post(_cardReqTransVm: CardRequestTransactionViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/CardRequestTransaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_cardReqTransVm);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCardRequestTransaction_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCardRequestTransaction_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processCardRequestTransaction_Post(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cardRequestTransaction_Put(_cardReqTransVm: CardRequestTransactionViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/CardRequestTransaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_cardReqTransVm);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCardRequestTransaction_Put(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCardRequestTransaction_Put(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processCardRequestTransaction_Put(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cardRequestTransaction_GetTransactions(): Observable<CardRequestTransactionViewModel[]> {
        let url_ = this.baseUrl + "/api/CardRequestTransaction";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCardRequestTransaction_GetTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCardRequestTransaction_GetTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CardRequestTransactionViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CardRequestTransactionViewModel[]>;
        }));
    }

    protected processCardRequestTransaction_GetTransactions(response: HttpResponseBase): Observable<CardRequestTransactionViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CardRequestTransactionViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cardRequestTransaction_GetProductPrintInfo(): Observable<CardRequestTransactionViewModel[]> {
        let url_ = this.baseUrl + "/api/CardProductPrint";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCardRequestTransaction_GetProductPrintInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCardRequestTransaction_GetProductPrintInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CardRequestTransactionViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CardRequestTransactionViewModel[]>;
        }));
    }

    protected processCardRequestTransaction_GetProductPrintInfo(response: HttpResponseBase): Observable<CardRequestTransactionViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CardRequestTransactionViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICheckerService {
    checker_Get(page: number, pageSize: number): Observable<CheckerViewModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class CheckerService implements ICheckerService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    checker_Get(page: number, pageSize: number): Observable<CheckerViewModel[]> {
        let url_ = this.baseUrl + "/api/Checker/pagination/{page}/{pageSize}";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChecker_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChecker_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckerViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckerViewModel[]>;
        }));
    }

    protected processChecker_Get(response: HttpResponseBase): Observable<CheckerViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CheckerViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IConfigurationService {
    configuration_GetAll(page: number, pageSize: number): Observable<ConfigurationViewModel[]>;
    configuration_Get(id: string): Observable<FileResponse>;
    configuration_Put(id: string, configurationVM: ConfigurationViewModel): Observable<FileResponse>;
    configuration_Delete(id: string): Observable<ConfigurationViewModel>;
    configuration_NotReceived(_configurationVM: ConfigurationViewModel): Observable<FileResponse>;
    configuration_Post(configurationVM: ConfigurationViewModel): Observable<FileResponse>;
    configuration_PostConfiguration(command: CreateConfigurationCommand): Observable<ApiResponseOfString>;
    configuration_PostStatus(id: string, _configurationVM: ConfigurationViewModel): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ConfigurationService implements IConfigurationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    configuration_GetAll(page: number, pageSize: number): Observable<ConfigurationViewModel[]> {
        let url_ = this.baseUrl + "/api/Configuration/pagination/{page}/{pageSize}";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfiguration_GetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfiguration_GetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfigurationViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfigurationViewModel[]>;
        }));
    }

    protected processConfiguration_GetAll(response: HttpResponseBase): Observable<ConfigurationViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConfigurationViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    configuration_Get(id: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Configuration/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfiguration_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfiguration_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processConfiguration_Get(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    configuration_Put(id: string, configurationVM: ConfigurationViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Configuration/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(configurationVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfiguration_Put(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfiguration_Put(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processConfiguration_Put(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    configuration_Delete(id: string): Observable<ConfigurationViewModel> {
        let url_ = this.baseUrl + "/api/Configuration/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfiguration_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfiguration_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfigurationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfigurationViewModel>;
        }));
    }

    protected processConfiguration_Delete(response: HttpResponseBase): Observable<ConfigurationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfigurationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    configuration_NotReceived(_configurationVM: ConfigurationViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Configuration/notReceivedPos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_configurationVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfiguration_NotReceived(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfiguration_NotReceived(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processConfiguration_NotReceived(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    configuration_Post(configurationVM: ConfigurationViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Configuration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(configurationVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfiguration_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfiguration_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processConfiguration_Post(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    configuration_PostConfiguration(command: CreateConfigurationCommand): Observable<ApiResponseOfString> {
        let url_ = this.baseUrl + "/api/Configuration/postConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfiguration_PostConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfiguration_PostConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfString>;
        }));
    }

    protected processConfiguration_PostConfiguration(response: HttpResponseBase): Observable<ApiResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    configuration_PostStatus(id: string, _configurationVM: ConfigurationViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Configuration/addConfigStatus/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_configurationVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfiguration_PostStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfiguration_PostStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processConfiguration_PostStatus(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICustomerService {
    customer_Get(): Observable<FileResponse>;
    customer_Post(value: string): Observable<void>;
    customer_Throw(): Observable<CustomerViewModel[]>;
    customer_Email(): Observable<string>;
    customer_Get2(id: number): Observable<string>;
    customer_Put(id: number, value: string): Observable<void>;
    customer_Delete(id: number): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class CustomerService implements ICustomerService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    customer_Get(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Customer";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomer_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomer_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processCustomer_Get(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customer_Post(value: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Customer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomer_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomer_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCustomer_Post(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customer_Throw(): Observable<CustomerViewModel[]> {
        let url_ = this.baseUrl + "/api/Customer/throw";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomer_Throw(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomer_Throw(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerViewModel[]>;
        }));
    }

    protected processCustomer_Throw(response: HttpResponseBase): Observable<CustomerViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customer_Email(): Observable<string> {
        let url_ = this.baseUrl + "/api/Customer/email";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomer_Email(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomer_Email(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCustomer_Email(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customer_Get2(id: number): Observable<string> {
        let url_ = this.baseUrl + "/api/Customer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomer_Get2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomer_Get2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCustomer_Get2(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customer_Put(id: number, value: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Customer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomer_Put(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomer_Put(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCustomer_Put(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customer_Delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Customer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomer_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomer_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCustomer_Delete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IDamagePosService {
    damagePos_Get(page: number, pageSize: number): Observable<DamagePoseViewModel[]>;
    damagePos_NotReceivedPos(_configurationVM: ConfigurationViewModel): Observable<FileResponse>;
    damagePos_CreateDamageMaintenance(deploymentRequestId: string, command: CreateDamagePosFromMaintenanceCommand): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class DamagePosService implements IDamagePosService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    damagePos_Get(page: number, pageSize: number): Observable<DamagePoseViewModel[]> {
        let url_ = this.baseUrl + "/api/DamagePos/pagination/{page}/{pageSize}";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDamagePos_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDamagePos_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DamagePoseViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DamagePoseViewModel[]>;
        }));
    }

    protected processDamagePos_Get(response: HttpResponseBase): Observable<DamagePoseViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DamagePoseViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    damagePos_NotReceivedPos(_configurationVM: ConfigurationViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/DamagePos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_configurationVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDamagePos_NotReceivedPos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDamagePos_NotReceivedPos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDamagePos_NotReceivedPos(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    damagePos_CreateDamageMaintenance(deploymentRequestId: string, command: CreateDamagePosFromMaintenanceCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/DamagePos/api/maintenanceDamage/{deploymentRequestId}/createMaintenanceDamage";
        if (deploymentRequestId === undefined || deploymentRequestId === null)
            throw new Error("The parameter 'deploymentRequestId' must be defined.");
        url_ = url_.replace("{deploymentRequestId}", encodeURIComponent("" + deploymentRequestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDamagePos_CreateDamageMaintenance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDamagePos_CreateDamageMaintenance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDamagePos_CreateDamageMaintenance(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IDashboardService {
    dashboard_GetBank(): Observable<BankWiseTerminalDataQuery[]>;
    dashboard_GetNotifiy(page: number, pageSize: number): Observable<BankDashboardViewModel[]>;
    dashboard_GetStock(): Observable<TotalPosStatusQuery[]>;
    dashboard_GetLastWeekTrends(): Observable<DashboardWeeklyQuery[]>;
    dashboard_GetDataBySatges(): Observable<PosDeploymentStageQuery>;
    dashboard_GetSupportDashboard(): Observable<SupportDataDashboardQuery>;
    dashboard_GetdashboardDaily(): Observable<FileResponse>;
    dashboard_GetDataForBars(): Observable<BarsForDashboardQuery>;
    dashboard_GetTotalPosStatusDetails(): Observable<TotalPosStatusQuery[]>;
}

@Injectable({
    providedIn: 'root'
})
export class DashboardService implements IDashboardService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    dashboard_GetBank(): Observable<BankWiseTerminalDataQuery[]> {
        let url_ = this.baseUrl + "/api/dashboard/totalPosDeployForBank";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDashboard_GetBank(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDashboard_GetBank(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BankWiseTerminalDataQuery[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BankWiseTerminalDataQuery[]>;
        }));
    }

    protected processDashboard_GetBank(response: HttpResponseBase): Observable<BankWiseTerminalDataQuery[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BankWiseTerminalDataQuery.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    dashboard_GetNotifiy(page: number, pageSize: number): Observable<BankDashboardViewModel[]> {
        let url_ = this.baseUrl + "/api/Dashboard/notification/{page}/{pageSize}";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDashboard_GetNotifiy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDashboard_GetNotifiy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BankDashboardViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BankDashboardViewModel[]>;
        }));
    }

    protected processDashboard_GetNotifiy(response: HttpResponseBase): Observable<BankDashboardViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BankDashboardViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    dashboard_GetStock(): Observable<TotalPosStatusQuery[]> {
        let url_ = this.baseUrl + "/api/dashboard/totalPosStock";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDashboard_GetStock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDashboard_GetStock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TotalPosStatusQuery[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TotalPosStatusQuery[]>;
        }));
    }

    protected processDashboard_GetStock(response: HttpResponseBase): Observable<TotalPosStatusQuery[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TotalPosStatusQuery.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    dashboard_GetLastWeekTrends(): Observable<DashboardWeeklyQuery[]> {
        let url_ = this.baseUrl + "/api/dashboard/lastWeekTrends";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDashboard_GetLastWeekTrends(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDashboard_GetLastWeekTrends(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardWeeklyQuery[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardWeeklyQuery[]>;
        }));
    }

    protected processDashboard_GetLastWeekTrends(response: HttpResponseBase): Observable<DashboardWeeklyQuery[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DashboardWeeklyQuery.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    dashboard_GetDataBySatges(): Observable<PosDeploymentStageQuery> {
        let url_ = this.baseUrl + "/api/dashboard/stagesData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDashboard_GetDataBySatges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDashboard_GetDataBySatges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PosDeploymentStageQuery>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PosDeploymentStageQuery>;
        }));
    }

    protected processDashboard_GetDataBySatges(response: HttpResponseBase): Observable<PosDeploymentStageQuery> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PosDeploymentStageQuery.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    dashboard_GetSupportDashboard(): Observable<SupportDataDashboardQuery> {
        let url_ = this.baseUrl + "/api/dashboard/supportDashboard";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDashboard_GetSupportDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDashboard_GetSupportDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupportDataDashboardQuery>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupportDataDashboardQuery>;
        }));
    }

    protected processDashboard_GetSupportDashboard(response: HttpResponseBase): Observable<SupportDataDashboardQuery> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupportDataDashboardQuery.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    dashboard_GetdashboardDaily(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Dashboard/GetReport";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDashboard_GetdashboardDaily(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDashboard_GetdashboardDaily(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDashboard_GetdashboardDaily(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    dashboard_GetDataForBars(): Observable<BarsForDashboardQuery> {
        let url_ = this.baseUrl + "/api/dashboard/dataBars";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDashboard_GetDataForBars(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDashboard_GetDataForBars(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BarsForDashboardQuery>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BarsForDashboardQuery>;
        }));
    }

    protected processDashboard_GetDataForBars(response: HttpResponseBase): Observable<BarsForDashboardQuery> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BarsForDashboardQuery.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    dashboard_GetTotalPosStatusDetails(): Observable<TotalPosStatusQuery[]> {
        let url_ = this.baseUrl + "/api/dashboard/totalPosStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDashboard_GetTotalPosStatusDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDashboard_GetTotalPosStatusDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TotalPosStatusQuery[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TotalPosStatusQuery[]>;
        }));
    }

    protected processDashboard_GetTotalPosStatusDetails(response: HttpResponseBase): Observable<TotalPosStatusQuery[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TotalPosStatusQuery.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IDeployListService {
    deployList_GetPendingDeploymentList(page: number, pageSize: number): Observable<DeploymentAddRequestViewModel[]>;
    deployList_GetAllPendingDeploymentList(): Observable<PendingDeploymentQuery[]>;
    deployList_Get(id: string): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class DeployListService implements IDeployListService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    deployList_GetPendingDeploymentList(page: number, pageSize: number): Observable<DeploymentAddRequestViewModel[]> {
        let url_ = this.baseUrl + "/api/deployLists/pagination/{page}/{pageSize}";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeployList_GetPendingDeploymentList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeployList_GetPendingDeploymentList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeploymentAddRequestViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeploymentAddRequestViewModel[]>;
        }));
    }

    protected processDeployList_GetPendingDeploymentList(response: HttpResponseBase): Observable<DeploymentAddRequestViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeploymentAddRequestViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deployList_GetAllPendingDeploymentList(): Observable<PendingDeploymentQuery[]> {
        let url_ = this.baseUrl + "/api/deployLists/pending-deployment-lists";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeployList_GetAllPendingDeploymentList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeployList_GetAllPendingDeploymentList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendingDeploymentQuery[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendingDeploymentQuery[]>;
        }));
    }

    protected processDeployList_GetAllPendingDeploymentList(response: HttpResponseBase): Observable<PendingDeploymentQuery[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PendingDeploymentQuery.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deployList_Get(id: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/deployLists/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeployList_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeployList_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeployList_Get(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IDeploymentActivityLogService {
    deploymentActivityLog_GetDeploymentActivityLogByDeploymentRequestId(deploymentRequestId: string): Observable<DeploymentActivityLogs[]>;
}

@Injectable({
    providedIn: 'root'
})
export class DeploymentActivityLogService implements IDeploymentActivityLogService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    deploymentActivityLog_GetDeploymentActivityLogByDeploymentRequestId(deploymentRequestId: string): Observable<DeploymentActivityLogs[]> {
        let url_ = this.baseUrl + "/api/DeploymentActivityLog/{deploymentRequestId}";
        if (deploymentRequestId === undefined || deploymentRequestId === null)
            throw new Error("The parameter 'deploymentRequestId' must be defined.");
        url_ = url_.replace("{deploymentRequestId}", encodeURIComponent("" + deploymentRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeploymentActivityLog_GetDeploymentActivityLogByDeploymentRequestId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeploymentActivityLog_GetDeploymentActivityLogByDeploymentRequestId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeploymentActivityLogs[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeploymentActivityLogs[]>;
        }));
    }

    protected processDeploymentActivityLog_GetDeploymentActivityLogByDeploymentRequestId(response: HttpResponseBase): Observable<DeploymentActivityLogs[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeploymentActivityLogs.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IDeploymentService {
    deployment_GetAll(page: number, pageSize: number): Observable<DeploymentViewModel[]>;
    deployment_CreateImarkTerminalIDByDeploymentRequestId(deploymentRequestID: string): Observable<FileResponse>;
    deployment_GetAllDeployedTerminals(fromDate: string, toDate: string): Observable<SP_DeployedTerminalListPOSReportVm[]>;
    deployment_BankWisePosReport(fromDate: string, toDate: string, banks: string[] | null | undefined): Observable<SP_BankWisePosReportVm[]>;
    deployment_Get(id: string): Observable<FileResponse>;
    deployment_Delete(id: string): Observable<DeploymentViewModel>;
    deployment_Post(_deploymentVM: DeploymentViewModel): Observable<FileResponse>;
    deployment_PostDeployment(command: CreateDeploymentCommand): Observable<FileResponse>;
    deployment_UpdateDeploymentForReDeployment(command: UpdateDeploymentCommand): Observable<FileResponse>;
    deployment_Put(dispatch: boolean, id: string, _deploymentVM: DeploymentViewModel): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class DeploymentService implements IDeploymentService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    deployment_GetAll(page: number, pageSize: number): Observable<DeploymentViewModel[]> {
        let url_ = this.baseUrl + "/api/Deployment/pagination/{page}/{pageSize}";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeployment_GetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeployment_GetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeploymentViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeploymentViewModel[]>;
        }));
    }

    protected processDeployment_GetAll(response: HttpResponseBase): Observable<DeploymentViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeploymentViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deployment_CreateImarkTerminalIDByDeploymentRequestId(deploymentRequestID: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Deployment/Imark-terminal-ID-creation/{deploymentRequestID}";
        if (deploymentRequestID === undefined || deploymentRequestID === null)
            throw new Error("The parameter 'deploymentRequestID' must be defined.");
        url_ = url_.replace("{deploymentRequestID}", encodeURIComponent("" + deploymentRequestID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeployment_CreateImarkTerminalIDByDeploymentRequestId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeployment_CreateImarkTerminalIDByDeploymentRequestId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeployment_CreateImarkTerminalIDByDeploymentRequestId(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deployment_GetAllDeployedTerminals(fromDate: string, toDate: string): Observable<SP_DeployedTerminalListPOSReportVm[]> {
        let url_ = this.baseUrl + "/api/Deployment/getDeployedTerminals/{fromDate}/{toDate}";
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined.");
        url_ = url_.replace("{fromDate}", encodeURIComponent("" + fromDate));
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent("" + toDate));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeployment_GetAllDeployedTerminals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeployment_GetAllDeployedTerminals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SP_DeployedTerminalListPOSReportVm[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SP_DeployedTerminalListPOSReportVm[]>;
        }));
    }

    protected processDeployment_GetAllDeployedTerminals(response: HttpResponseBase): Observable<SP_DeployedTerminalListPOSReportVm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SP_DeployedTerminalListPOSReportVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deployment_BankWisePosReport(fromDate: string, toDate: string, banks: string[] | null | undefined): Observable<SP_BankWisePosReportVm[]> {
        let url_ = this.baseUrl + "/api/deployments/{fromDate}/{toDate}/bank-wise-pos-report?";
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined.");
        url_ = url_.replace("{fromDate}", encodeURIComponent("" + fromDate));
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent("" + toDate));
        if (banks !== undefined && banks !== null)
            banks && banks.forEach(item => { url_ += "banks=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeployment_BankWisePosReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeployment_BankWisePosReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SP_BankWisePosReportVm[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SP_BankWisePosReportVm[]>;
        }));
    }

    protected processDeployment_BankWisePosReport(response: HttpResponseBase): Observable<SP_BankWisePosReportVm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SP_BankWisePosReportVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deployment_Get(id: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Deployment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeployment_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeployment_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeployment_Get(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deployment_Delete(id: string): Observable<DeploymentViewModel> {
        let url_ = this.baseUrl + "/api/Deployment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeployment_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeployment_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeploymentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeploymentViewModel>;
        }));
    }

    protected processDeployment_Delete(response: HttpResponseBase): Observable<DeploymentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeploymentViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deployment_Post(_deploymentVM: DeploymentViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Deployment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_deploymentVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeployment_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeployment_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeployment_Post(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deployment_PostDeployment(command: CreateDeploymentCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Deployment/createDeployment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeployment_PostDeployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeployment_PostDeployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeployment_PostDeployment(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deployment_UpdateDeploymentForReDeployment(command: UpdateDeploymentCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Deployment/updateDeployment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeployment_UpdateDeploymentForReDeployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeployment_UpdateDeploymentForReDeployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeployment_UpdateDeploymentForReDeployment(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deployment_Put(dispatch: boolean, id: string, _deploymentVM: DeploymentViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Deployment/{id}/{dispatch}";
        if (dispatch === undefined || dispatch === null)
            throw new Error("The parameter 'dispatch' must be defined.");
        url_ = url_.replace("{dispatch}", encodeURIComponent("" + dispatch));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_deploymentVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeployment_Put(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeployment_Put(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeployment_Put(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IDeploymentRequestService {
    deploymentRequest_GetAllDeploymentRequest(): Observable<AllDeploymentRequestVm[]>;
    deploymentRequest_GetDeploymentRequest(): Observable<DeploymentRequestListViewModel[]>;
    deploymentRequest_Post(_depRequestVM: DeploymentRequestViewModel): Observable<FileResponse>;
    deploymentRequest_GetConfiqurationDeploymentRequest(): Observable<DeploymentRequestConfigurationViewModel[]>;
    deploymentRequest_GetReplacementRequest(): Observable<ReplacementRequestViewModel[]>;
    deploymentRequest_Get(page: number | undefined, pageSize: number | undefined): Observable<DeploymentAddRequestViewModel[]>;
    deploymentRequest_GetUndeployed(bankId: string, deploymentReqId: string, page: number, pageSize: number): Observable<InventoryandAddViewModel[]>;
    deploymentRequest_GetDeploymentRequestById(id: string): Observable<DeploymentRequestByIdTerminalQuery>;
    deploymentRequest_Put(id: string, depRequestVm: DeploymentRequestViewModel): Observable<FileResponse>;
    deploymentRequest_Delete(id: string): Observable<DeploymentRequestViewModel>;
    deploymentRequest_UpdateDeploymentRequest(command: UpdateAndVerifyNewDeploymentrequestCommand): Observable<FileResponse>;
    deploymentRequest_DeploymentRequestVerify(id: string | undefined): Observable<FileResponse>;
    deploymentRequest_ReplacementRequestVerification(command: UpdateReplacementRequestCommand): Observable<ApiResponseOfString>;
    deploymentRequest_UpdateDeploymentRequestKeyComponent(command: UpdateKeyComponentCommand): Observable<FileResponse>;
    deploymentRequest_UpdateReplacementDeploymentRequest(command: UpdateReplacementDeploymentRequestCommand): Observable<FileResponse>;
    deploymentRequest_UpdateMerchantDetails(command: UpdateMerchantDetailsCommand): Observable<ApiResponseOfString>;
    deploymentRequest_GetPanNumberDetails(panNumber: string | null | undefined, bankId: string | undefined): Observable<ApiResponseOfString>;
    deploymentRequest_SyncMerchantDetails(command: SyncMerchantCommand): Observable<ApiResponseOfString>;
    deploymentRequest_ReplacementRequestReject(command: RejectDeploymentRequestCommand): Observable<FileResponse>;
    deploymentRequest_RejectDeploymentRequestFromPendingDeployment(command: RejectDeploymentRequestCommand): Observable<FileResponse>;
    deploymentRequest_RejectDeploymentRequestFromNewRequest(command: RejectDeploymentRequestCommand): Observable<FileResponse>;
    deploymentRequest_RejectRemovalRequest(id: string): Observable<FileResponse>;
    deploymentRequest_AddStatusForPendingDeployment(id: string, remarks: string): Observable<FileResponse>;
    deploymentRequest_RejectedDeploymentRequests(): Observable<RejectDeploymentRequestVm[]>;
    deploymentRequest_ApproveRejectedRequests(deploymentRequestId: string): Observable<RejectDeploymentRequestVm[]>;
}

@Injectable({
    providedIn: 'root'
})
export class DeploymentRequestService implements IDeploymentRequestService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    deploymentRequest_GetAllDeploymentRequest(): Observable<AllDeploymentRequestVm[]> {
        let url_ = this.baseUrl + "/api/DeploymentRequest/AllDeploymentRequest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeploymentRequest_GetAllDeploymentRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeploymentRequest_GetAllDeploymentRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllDeploymentRequestVm[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllDeploymentRequestVm[]>;
        }));
    }

    protected processDeploymentRequest_GetAllDeploymentRequest(response: HttpResponseBase): Observable<AllDeploymentRequestVm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AllDeploymentRequestVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deploymentRequest_GetDeploymentRequest(): Observable<DeploymentRequestListViewModel[]> {
        let url_ = this.baseUrl + "/api/DeploymentRequest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeploymentRequest_GetDeploymentRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeploymentRequest_GetDeploymentRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeploymentRequestListViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeploymentRequestListViewModel[]>;
        }));
    }

    protected processDeploymentRequest_GetDeploymentRequest(response: HttpResponseBase): Observable<DeploymentRequestListViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeploymentRequestListViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deploymentRequest_Post(_depRequestVM: DeploymentRequestViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/DeploymentRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_depRequestVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeploymentRequest_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeploymentRequest_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeploymentRequest_Post(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deploymentRequest_GetConfiqurationDeploymentRequest(): Observable<DeploymentRequestConfigurationViewModel[]> {
        let url_ = this.baseUrl + "/api/DeploymentRequest/configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeploymentRequest_GetConfiqurationDeploymentRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeploymentRequest_GetConfiqurationDeploymentRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeploymentRequestConfigurationViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeploymentRequestConfigurationViewModel[]>;
        }));
    }

    protected processDeploymentRequest_GetConfiqurationDeploymentRequest(response: HttpResponseBase): Observable<DeploymentRequestConfigurationViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeploymentRequestConfigurationViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deploymentRequest_GetReplacementRequest(): Observable<ReplacementRequestViewModel[]> {
        let url_ = this.baseUrl + "/api/DeploymentRequest/replacementRequest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeploymentRequest_GetReplacementRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeploymentRequest_GetReplacementRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReplacementRequestViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReplacementRequestViewModel[]>;
        }));
    }

    protected processDeploymentRequest_GetReplacementRequest(response: HttpResponseBase): Observable<ReplacementRequestViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReplacementRequestViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deploymentRequest_Get(page: number | undefined, pageSize: number | undefined): Observable<DeploymentAddRequestViewModel[]> {
        let url_ = this.baseUrl + "/api/DeploymentRequest/PosMaster?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeploymentRequest_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeploymentRequest_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeploymentAddRequestViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeploymentAddRequestViewModel[]>;
        }));
    }

    protected processDeploymentRequest_Get(response: HttpResponseBase): Observable<DeploymentAddRequestViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeploymentAddRequestViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deploymentRequest_GetUndeployed(bankId: string, deploymentReqId: string, page: number, pageSize: number): Observable<InventoryandAddViewModel[]> {
        let url_ = this.baseUrl + "/api/DeploymentRequest/Undeployedpartial/{bankId}/{deploymentReqId}/{page}/{pageSize}";
        if (bankId === undefined || bankId === null)
            throw new Error("The parameter 'bankId' must be defined.");
        url_ = url_.replace("{bankId}", encodeURIComponent("" + bankId));
        if (deploymentReqId === undefined || deploymentReqId === null)
            throw new Error("The parameter 'deploymentReqId' must be defined.");
        url_ = url_.replace("{deploymentReqId}", encodeURIComponent("" + deploymentReqId));
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeploymentRequest_GetUndeployed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeploymentRequest_GetUndeployed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryandAddViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryandAddViewModel[]>;
        }));
    }

    protected processDeploymentRequest_GetUndeployed(response: HttpResponseBase): Observable<InventoryandAddViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InventoryandAddViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deploymentRequest_GetDeploymentRequestById(id: string): Observable<DeploymentRequestByIdTerminalQuery> {
        let url_ = this.baseUrl + "/api/deploymentRequests/{id}/search-by-terminal-id";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeploymentRequest_GetDeploymentRequestById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeploymentRequest_GetDeploymentRequestById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeploymentRequestByIdTerminalQuery>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeploymentRequestByIdTerminalQuery>;
        }));
    }

    protected processDeploymentRequest_GetDeploymentRequestById(response: HttpResponseBase): Observable<DeploymentRequestByIdTerminalQuery> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeploymentRequestByIdTerminalQuery.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deploymentRequest_Put(id: string, depRequestVm: DeploymentRequestViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/DeploymentRequest/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(depRequestVm);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeploymentRequest_Put(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeploymentRequest_Put(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeploymentRequest_Put(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deploymentRequest_Delete(id: string): Observable<DeploymentRequestViewModel> {
        let url_ = this.baseUrl + "/api/DeploymentRequest/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeploymentRequest_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeploymentRequest_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeploymentRequestViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeploymentRequestViewModel>;
        }));
    }

    protected processDeploymentRequest_Delete(response: HttpResponseBase): Observable<DeploymentRequestViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeploymentRequestViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deploymentRequest_UpdateDeploymentRequest(command: UpdateAndVerifyNewDeploymentrequestCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/DeploymentRequest/updateDeploymentRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeploymentRequest_UpdateDeploymentRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeploymentRequest_UpdateDeploymentRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeploymentRequest_UpdateDeploymentRequest(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deploymentRequest_DeploymentRequestVerify(id: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/DeploymentRequest/deploymentRequestVerified?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeploymentRequest_DeploymentRequestVerify(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeploymentRequest_DeploymentRequestVerify(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeploymentRequest_DeploymentRequestVerify(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deploymentRequest_ReplacementRequestVerification(command: UpdateReplacementRequestCommand): Observable<ApiResponseOfString> {
        let url_ = this.baseUrl + "/api/DeploymentRequest/replacementVerification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeploymentRequest_ReplacementRequestVerification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeploymentRequest_ReplacementRequestVerification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfString>;
        }));
    }

    protected processDeploymentRequest_ReplacementRequestVerification(response: HttpResponseBase): Observable<ApiResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deploymentRequest_UpdateDeploymentRequestKeyComponent(command: UpdateKeyComponentCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/DeploymentRequest/updateKeyComponent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeploymentRequest_UpdateDeploymentRequestKeyComponent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeploymentRequest_UpdateDeploymentRequestKeyComponent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeploymentRequest_UpdateDeploymentRequestKeyComponent(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deploymentRequest_UpdateReplacementDeploymentRequest(command: UpdateReplacementDeploymentRequestCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/DeploymentRequest/replacementDeploymentUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeploymentRequest_UpdateReplacementDeploymentRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeploymentRequest_UpdateReplacementDeploymentRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeploymentRequest_UpdateReplacementDeploymentRequest(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deploymentRequest_UpdateMerchantDetails(command: UpdateMerchantDetailsCommand): Observable<ApiResponseOfString> {
        let url_ = this.baseUrl + "/api/DeploymentRequest/updateMerchantDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeploymentRequest_UpdateMerchantDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeploymentRequest_UpdateMerchantDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfString>;
        }));
    }

    protected processDeploymentRequest_UpdateMerchantDetails(response: HttpResponseBase): Observable<ApiResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deploymentRequest_GetPanNumberDetails(panNumber: string | null | undefined, bankId: string | undefined): Observable<ApiResponseOfString> {
        let url_ = this.baseUrl + "/api/DeploymentRequest/panNumberDetails?";
        if (panNumber !== undefined && panNumber !== null)
            url_ += "panNumber=" + encodeURIComponent("" + panNumber) + "&";
        if (bankId === null)
            throw new Error("The parameter 'bankId' cannot be null.");
        else if (bankId !== undefined)
            url_ += "bankId=" + encodeURIComponent("" + bankId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeploymentRequest_GetPanNumberDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeploymentRequest_GetPanNumberDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfString>;
        }));
    }

    protected processDeploymentRequest_GetPanNumberDetails(response: HttpResponseBase): Observable<ApiResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deploymentRequest_SyncMerchantDetails(command: SyncMerchantCommand): Observable<ApiResponseOfString> {
        let url_ = this.baseUrl + "/api/DeploymentRequest/syncMerchantDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeploymentRequest_SyncMerchantDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeploymentRequest_SyncMerchantDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfString>;
        }));
    }

    protected processDeploymentRequest_SyncMerchantDetails(response: HttpResponseBase): Observable<ApiResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deploymentRequest_ReplacementRequestReject(command: RejectDeploymentRequestCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/DeploymentRequest/replacementRequestReject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeploymentRequest_ReplacementRequestReject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeploymentRequest_ReplacementRequestReject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeploymentRequest_ReplacementRequestReject(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deploymentRequest_RejectDeploymentRequestFromPendingDeployment(command: RejectDeploymentRequestCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/DeploymentRequest/rejectDeploymentFromPendingDeployment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeploymentRequest_RejectDeploymentRequestFromPendingDeployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeploymentRequest_RejectDeploymentRequestFromPendingDeployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeploymentRequest_RejectDeploymentRequestFromPendingDeployment(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deploymentRequest_RejectDeploymentRequestFromNewRequest(command: RejectDeploymentRequestCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/DeploymentRequest/rejectDeploymentFromNewRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeploymentRequest_RejectDeploymentRequestFromNewRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeploymentRequest_RejectDeploymentRequestFromNewRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeploymentRequest_RejectDeploymentRequestFromNewRequest(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deploymentRequest_RejectRemovalRequest(id: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/deploymentRequests/{id}/rejectRemovalRequest";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeploymentRequest_RejectRemovalRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeploymentRequest_RejectRemovalRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeploymentRequest_RejectRemovalRequest(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deploymentRequest_AddStatusForPendingDeployment(id: string, remarks: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/deploymentRequests/{id}/add-status-for-pending-deployment";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(remarks);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeploymentRequest_AddStatusForPendingDeployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeploymentRequest_AddStatusForPendingDeployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeploymentRequest_AddStatusForPendingDeployment(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deploymentRequest_RejectedDeploymentRequests(): Observable<RejectDeploymentRequestVm[]> {
        let url_ = this.baseUrl + "/api/deploymentRequests/rejectedDeploymentRequests";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeploymentRequest_RejectedDeploymentRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeploymentRequest_RejectedDeploymentRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RejectDeploymentRequestVm[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RejectDeploymentRequestVm[]>;
        }));
    }

    protected processDeploymentRequest_RejectedDeploymentRequests(response: HttpResponseBase): Observable<RejectDeploymentRequestVm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RejectDeploymentRequestVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deploymentRequest_ApproveRejectedRequests(deploymentRequestId: string): Observable<RejectDeploymentRequestVm[]> {
        let url_ = this.baseUrl + "/api/deploymentRequests/approveRejectedTerminal/{deploymentRequestId}";
        if (deploymentRequestId === undefined || deploymentRequestId === null)
            throw new Error("The parameter 'deploymentRequestId' must be defined.");
        url_ = url_.replace("{deploymentRequestId}", encodeURIComponent("" + deploymentRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeploymentRequest_ApproveRejectedRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeploymentRequest_ApproveRejectedRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RejectDeploymentRequestVm[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RejectDeploymentRequestVm[]>;
        }));
    }

    protected processDeploymentRequest_ApproveRejectedRequests(response: HttpResponseBase): Observable<RejectDeploymentRequestVm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RejectDeploymentRequestVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IFewaMerchantService {
    fewaMerchant_getMerchantDetailsByImarkMerchantId(imarkMerchantId: string): Observable<ImarkTerminalIdListViewModel>;
    fewaMerchant_GetMerchantSupportByIMId(imarkMerchantId: string, fromDate: string | null | undefined, toDate: string | null | undefined): Observable<MerchantwiseSupportList>;
    fewaMerchant_CreateMerchantSupport(command: CreateMerchantSupportCommand): Observable<FileResponse>;
    fewaMerchant_GetInventoryDetails(): Observable<FileResponse>;
    fewaMerchant_MerchantSpareRequest(command: CreateMerchantSpareRequestCommand): Observable<FileResponse>;
    fewaMerchant_GetMerchantwiseSpareRequests(imarkMerchantId: string, fromDate: string | null | undefined, toDate: string | null | undefined): Observable<MerchantwiseSpareRequestListVM>;
    fewaMerchant_ChangePassword(userId: string, command: ChangePasswordCommand): Observable<FileResponse>;
    fewaMerchant_FewaMerchantAuthenticate(request: AuthenticationRequest2): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class FewaMerchantService implements IFewaMerchantService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    fewaMerchant_getMerchantDetailsByImarkMerchantId(imarkMerchantId: string): Observable<ImarkTerminalIdListViewModel> {
        let url_ = this.baseUrl + "/api/FewaMerchant/TerminalDetails/{ImarkMerchantId}";
        if (imarkMerchantId === undefined || imarkMerchantId === null)
            throw new Error("The parameter 'imarkMerchantId' must be defined.");
        url_ = url_.replace("{ImarkMerchantId}", encodeURIComponent("" + imarkMerchantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFewaMerchant_getMerchantDetailsByImarkMerchantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFewaMerchant_getMerchantDetailsByImarkMerchantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImarkTerminalIdListViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImarkTerminalIdListViewModel>;
        }));
    }

    protected processFewaMerchant_getMerchantDetailsByImarkMerchantId(response: HttpResponseBase): Observable<ImarkTerminalIdListViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImarkTerminalIdListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    fewaMerchant_GetMerchantSupportByIMId(imarkMerchantId: string, fromDate: string | null | undefined, toDate: string | null | undefined): Observable<MerchantwiseSupportList> {
        let url_ = this.baseUrl + "/api/FewaMerchant/getMerchantSupport/{ImarkMerchantId}?";
        if (imarkMerchantId === undefined || imarkMerchantId === null)
            throw new Error("The parameter 'imarkMerchantId' must be defined.");
        url_ = url_.replace("{ImarkMerchantId}", encodeURIComponent("" + imarkMerchantId));
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFewaMerchant_GetMerchantSupportByIMId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFewaMerchant_GetMerchantSupportByIMId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MerchantwiseSupportList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MerchantwiseSupportList>;
        }));
    }

    protected processFewaMerchant_GetMerchantSupportByIMId(response: HttpResponseBase): Observable<MerchantwiseSupportList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MerchantwiseSupportList.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    fewaMerchant_CreateMerchantSupport(command: CreateMerchantSupportCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/FewaMerchant/createMerchantSupport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFewaMerchant_CreateMerchantSupport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFewaMerchant_CreateMerchantSupport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processFewaMerchant_CreateMerchantSupport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    fewaMerchant_GetInventoryDetails(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/FewaMerchant/AccessoriyDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFewaMerchant_GetInventoryDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFewaMerchant_GetInventoryDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processFewaMerchant_GetInventoryDetails(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    fewaMerchant_MerchantSpareRequest(command: CreateMerchantSpareRequestCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/FewaMerchant/merchantSpareRequests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFewaMerchant_MerchantSpareRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFewaMerchant_MerchantSpareRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processFewaMerchant_MerchantSpareRequest(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    fewaMerchant_GetMerchantwiseSpareRequests(imarkMerchantId: string, fromDate: string | null | undefined, toDate: string | null | undefined): Observable<MerchantwiseSpareRequestListVM> {
        let url_ = this.baseUrl + "/api/FewaMerchant/merchantSpareRequestList/{ImarkMerchantId}?";
        if (imarkMerchantId === undefined || imarkMerchantId === null)
            throw new Error("The parameter 'imarkMerchantId' must be defined.");
        url_ = url_.replace("{ImarkMerchantId}", encodeURIComponent("" + imarkMerchantId));
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFewaMerchant_GetMerchantwiseSpareRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFewaMerchant_GetMerchantwiseSpareRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MerchantwiseSpareRequestListVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MerchantwiseSpareRequestListVM>;
        }));
    }

    protected processFewaMerchant_GetMerchantwiseSpareRequests(response: HttpResponseBase): Observable<MerchantwiseSpareRequestListVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MerchantwiseSpareRequestListVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    fewaMerchant_ChangePassword(userId: string, command: ChangePasswordCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/FewaMerchant/change-password/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFewaMerchant_ChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFewaMerchant_ChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processFewaMerchant_ChangePassword(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    fewaMerchant_FewaMerchantAuthenticate(request: AuthenticationRequest2): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/fewamerchantusers/fewamerchantauthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFewaMerchant_FewaMerchantAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFewaMerchant_FewaMerchantAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processFewaMerchant_FewaMerchantAuthenticate(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IFewaMerchantTransactionService {
    fewaMerchantTransaction_GetTransactionSummaryByImid(imid: string, bankId: string | null | undefined, itid: string | null | undefined): Observable<TransactionSummaryVM>;
    fewaMerchantTransaction_GetTransactionListByImid(imid: string, bankId: string | null | undefined, itid: string | null | undefined, fromDate: string | null | undefined, toDate: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<PagedResponseOfTransactionListVM>;
    fewaMerchantTransaction_GetTransactionListByTransactionStatus(imid: string, transactionStatus: number, itid: string | null | undefined, bankId: string | null | undefined, fromDate: string | null | undefined, toDate: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<PagedResponseOfTransactionListVM>;
    fewaMerchantTransaction_GetRecentTransactionByImid(imid: string, requiredRecords: number, itid: string | null | undefined, bankId: string | null | undefined): Observable<ResponseViewModelOfTransactionListVM>;
    fewaMerchantTransaction_GetSettlementListByImid(imid: string, itid: string | null | undefined, bankId: string | null | undefined, fromDate: string | null | undefined, toDate: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<PagedResponseOfSettlementListVM>;
    fewaMerchantTransaction_GetSettlementListBySettlementStatus(imid: string, settlementStatus: number, itid: string | null | undefined, bankId: string | null | undefined, fromDate: string | null | undefined, toDate: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<PagedResponseOfSettlementListVM>;
}

@Injectable({
    providedIn: 'root'
})
export class FewaMerchantTransactionService implements IFewaMerchantTransactionService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    fewaMerchantTransaction_GetTransactionSummaryByImid(imid: string, bankId: string | null | undefined, itid: string | null | undefined): Observable<TransactionSummaryVM> {
        let url_ = this.baseUrl + "/api/FewaMerchantTransaction/transaction-summary/{Imid}?";
        if (imid === undefined || imid === null)
            throw new Error("The parameter 'imid' must be defined.");
        url_ = url_.replace("{Imid}", encodeURIComponent("" + imid));
        if (bankId !== undefined && bankId !== null)
            url_ += "bankId=" + encodeURIComponent("" + bankId) + "&";
        if (itid !== undefined && itid !== null)
            url_ += "Itid=" + encodeURIComponent("" + itid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFewaMerchantTransaction_GetTransactionSummaryByImid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFewaMerchantTransaction_GetTransactionSummaryByImid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionSummaryVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionSummaryVM>;
        }));
    }

    protected processFewaMerchantTransaction_GetTransactionSummaryByImid(response: HttpResponseBase): Observable<TransactionSummaryVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionSummaryVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    fewaMerchantTransaction_GetTransactionListByImid(imid: string, bankId: string | null | undefined, itid: string | null | undefined, fromDate: string | null | undefined, toDate: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<PagedResponseOfTransactionListVM> {
        let url_ = this.baseUrl + "/api/FewaMerchantTransaction/transaction-list/{Imid}?";
        if (imid === undefined || imid === null)
            throw new Error("The parameter 'imid' must be defined.");
        url_ = url_.replace("{Imid}", encodeURIComponent("" + imid));
        if (bankId !== undefined && bankId !== null)
            url_ += "bankId=" + encodeURIComponent("" + bankId) + "&";
        if (itid !== undefined && itid !== null)
            url_ += "Itid=" + encodeURIComponent("" + itid) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFewaMerchantTransaction_GetTransactionListByImid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFewaMerchantTransaction_GetTransactionListByImid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfTransactionListVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfTransactionListVM>;
        }));
    }

    protected processFewaMerchantTransaction_GetTransactionListByImid(response: HttpResponseBase): Observable<PagedResponseOfTransactionListVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfTransactionListVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    fewaMerchantTransaction_GetTransactionListByTransactionStatus(imid: string, transactionStatus: number, itid: string | null | undefined, bankId: string | null | undefined, fromDate: string | null | undefined, toDate: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<PagedResponseOfTransactionListVM> {
        let url_ = this.baseUrl + "/api/FewaMerchantTransaction/transaction-list-by-status/{Imid}/{transactionStatus}?";
        if (imid === undefined || imid === null)
            throw new Error("The parameter 'imid' must be defined.");
        url_ = url_.replace("{Imid}", encodeURIComponent("" + imid));
        if (transactionStatus === undefined || transactionStatus === null)
            throw new Error("The parameter 'transactionStatus' must be defined.");
        url_ = url_.replace("{transactionStatus}", encodeURIComponent("" + transactionStatus));
        if (itid !== undefined && itid !== null)
            url_ += "Itid=" + encodeURIComponent("" + itid) + "&";
        if (bankId !== undefined && bankId !== null)
            url_ += "bankId=" + encodeURIComponent("" + bankId) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFewaMerchantTransaction_GetTransactionListByTransactionStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFewaMerchantTransaction_GetTransactionListByTransactionStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfTransactionListVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfTransactionListVM>;
        }));
    }

    protected processFewaMerchantTransaction_GetTransactionListByTransactionStatus(response: HttpResponseBase): Observable<PagedResponseOfTransactionListVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfTransactionListVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    fewaMerchantTransaction_GetRecentTransactionByImid(imid: string, requiredRecords: number, itid: string | null | undefined, bankId: string | null | undefined): Observable<ResponseViewModelOfTransactionListVM> {
        let url_ = this.baseUrl + "/api/FewaMerchantTransaction/recent-transaction-list/{Imid}/{requiredRecords}?";
        if (imid === undefined || imid === null)
            throw new Error("The parameter 'imid' must be defined.");
        url_ = url_.replace("{Imid}", encodeURIComponent("" + imid));
        if (requiredRecords === undefined || requiredRecords === null)
            throw new Error("The parameter 'requiredRecords' must be defined.");
        url_ = url_.replace("{requiredRecords}", encodeURIComponent("" + requiredRecords));
        if (itid !== undefined && itid !== null)
            url_ += "Itid=" + encodeURIComponent("" + itid) + "&";
        if (bankId !== undefined && bankId !== null)
            url_ += "bankId=" + encodeURIComponent("" + bankId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFewaMerchantTransaction_GetRecentTransactionByImid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFewaMerchantTransaction_GetRecentTransactionByImid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseViewModelOfTransactionListVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseViewModelOfTransactionListVM>;
        }));
    }

    protected processFewaMerchantTransaction_GetRecentTransactionByImid(response: HttpResponseBase): Observable<ResponseViewModelOfTransactionListVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseViewModelOfTransactionListVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    fewaMerchantTransaction_GetSettlementListByImid(imid: string, itid: string | null | undefined, bankId: string | null | undefined, fromDate: string | null | undefined, toDate: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<PagedResponseOfSettlementListVM> {
        let url_ = this.baseUrl + "/api/FewaMerchantTransaction/settlement-list/{Imid}?";
        if (imid === undefined || imid === null)
            throw new Error("The parameter 'imid' must be defined.");
        url_ = url_.replace("{Imid}", encodeURIComponent("" + imid));
        if (itid !== undefined && itid !== null)
            url_ += "Itid=" + encodeURIComponent("" + itid) + "&";
        if (bankId !== undefined && bankId !== null)
            url_ += "bankId=" + encodeURIComponent("" + bankId) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFewaMerchantTransaction_GetSettlementListByImid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFewaMerchantTransaction_GetSettlementListByImid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfSettlementListVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfSettlementListVM>;
        }));
    }

    protected processFewaMerchantTransaction_GetSettlementListByImid(response: HttpResponseBase): Observable<PagedResponseOfSettlementListVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfSettlementListVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    fewaMerchantTransaction_GetSettlementListBySettlementStatus(imid: string, settlementStatus: number, itid: string | null | undefined, bankId: string | null | undefined, fromDate: string | null | undefined, toDate: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<PagedResponseOfSettlementListVM> {
        let url_ = this.baseUrl + "/api/FewaMerchantTransaction/settlement-list-by-status/{Imid}/{SettlementStatus}?";
        if (imid === undefined || imid === null)
            throw new Error("The parameter 'imid' must be defined.");
        url_ = url_.replace("{Imid}", encodeURIComponent("" + imid));
        if (settlementStatus === undefined || settlementStatus === null)
            throw new Error("The parameter 'settlementStatus' must be defined.");
        url_ = url_.replace("{SettlementStatus}", encodeURIComponent("" + settlementStatus));
        if (itid !== undefined && itid !== null)
            url_ += "Itid=" + encodeURIComponent("" + itid) + "&";
        if (bankId !== undefined && bankId !== null)
            url_ += "bankId=" + encodeURIComponent("" + bankId) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFewaMerchantTransaction_GetSettlementListBySettlementStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFewaMerchantTransaction_GetSettlementListBySettlementStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfSettlementListVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfSettlementListVM>;
        }));
    }

    protected processFewaMerchantTransaction_GetSettlementListBySettlementStatus(response: HttpResponseBase): Observable<PagedResponseOfSettlementListVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfSettlementListVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IHardwareService {
    hardware_Get(page: number, pageSize: number): Observable<HardwareViewModel[]>;
    hardware_GetAllHardwareList(): Observable<GetAllHardwareQuery[]>;
    hardware_Post(_hardwareVM: HardwareViewModel): Observable<FileResponse>;
    hardware_CreateHardware(command: CreateHardwareCommand): Observable<FileResponse>;
    hardware_Put(id: string, _hardwareVM: HardwareViewModel): Observable<FileResponse>;
    hardware_Delete(id: string): Observable<HardwareViewModel>;
    hardware_UpdateHardware(id: string, command: UpdateHardwareCommand): Observable<FileResponse>;
    hardware_Get2(id: string): Observable<HardwareViewModel[]>;
    hardware_GetHardwareBanks(): Observable<HardwareViewModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class HardwareService implements IHardwareService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    hardware_Get(page: number, pageSize: number): Observable<HardwareViewModel[]> {
        let url_ = this.baseUrl + "/api/Hardware/pagination/{page}/{pageSize}";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHardware_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHardware_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HardwareViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HardwareViewModel[]>;
        }));
    }

    protected processHardware_Get(response: HttpResponseBase): Observable<HardwareViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HardwareViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    hardware_GetAllHardwareList(): Observable<GetAllHardwareQuery[]> {
        let url_ = this.baseUrl + "/api/hardwares/getAllHardwareList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHardware_GetAllHardwareList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHardware_GetAllHardwareList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllHardwareQuery[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllHardwareQuery[]>;
        }));
    }

    protected processHardware_GetAllHardwareList(response: HttpResponseBase): Observable<GetAllHardwareQuery[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAllHardwareQuery.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    hardware_Post(_hardwareVM: HardwareViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Hardware/newHardware";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_hardwareVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHardware_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHardware_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processHardware_Post(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    hardware_CreateHardware(command: CreateHardwareCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/hardwares/createHardware";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHardware_CreateHardware(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHardware_CreateHardware(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processHardware_CreateHardware(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    hardware_Put(id: string, _hardwareVM: HardwareViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Hardware/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_hardwareVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHardware_Put(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHardware_Put(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processHardware_Put(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    hardware_Delete(id: string): Observable<HardwareViewModel> {
        let url_ = this.baseUrl + "/api/Hardware/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHardware_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHardware_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HardwareViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HardwareViewModel>;
        }));
    }

    protected processHardware_Delete(response: HttpResponseBase): Observable<HardwareViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HardwareViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    hardware_UpdateHardware(id: string, command: UpdateHardwareCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/hardawares/{id}/updateHardware";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHardware_UpdateHardware(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHardware_UpdateHardware(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processHardware_UpdateHardware(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    hardware_Get2(id: string): Observable<HardwareViewModel[]> {
        let url_ = this.baseUrl + "/api/Hardware/banksHardware/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHardware_Get2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHardware_Get2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HardwareViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HardwareViewModel[]>;
        }));
    }

    protected processHardware_Get2(response: HttpResponseBase): Observable<HardwareViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HardwareViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    hardware_GetHardwareBanks(): Observable<HardwareViewModel[]> {
        let url_ = this.baseUrl + "/api/Hardware/printingBanks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHardware_GetHardwareBanks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHardware_GetHardwareBanks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HardwareViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HardwareViewModel[]>;
        }));
    }

    protected processHardware_GetHardwareBanks(response: HttpResponseBase): Observable<HardwareViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HardwareViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IHomeService {
    home_Get(): Observable<string[]>;
}

@Injectable({
    providedIn: 'root'
})
export class HomeService implements IHomeService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    home_Get(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/Home";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHome_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHome_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processHome_Get(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IImarkMerchantService {
    imarkMerchant_CreateMerchantDetails(merchantDetailsAddCommands: MerchantDetailsAddCommands): Observable<ApiResponseOfString>;
    imarkMerchant_GetAllImarkMerchantlist(): Observable<ImarkMerchantListVM[]>;
    imarkMerchant_getImarkMerchantByPANNumber(pAN: string): Observable<ImarkMerchantListVM[]>;
    imarkMerchant_GetAllMerchantImarkTidAndImarkMid(serialNumber: string): Observable<MerchantImarkTidAndImarkMidVM>;
    imarkMerchant_DeleteTerminalFromMerchant(id: string | undefined, iTid: string): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ImarkMerchantService implements IImarkMerchantService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    imarkMerchant_CreateMerchantDetails(merchantDetailsAddCommands: MerchantDetailsAddCommands): Observable<ApiResponseOfString> {
        let url_ = this.baseUrl + "/api/ImarkMerchant/CreateMerchantDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(merchantDetailsAddCommands);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImarkMerchant_CreateMerchantDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImarkMerchant_CreateMerchantDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfString>;
        }));
    }

    protected processImarkMerchant_CreateMerchantDetails(response: HttpResponseBase): Observable<ApiResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    imarkMerchant_GetAllImarkMerchantlist(): Observable<ImarkMerchantListVM[]> {
        let url_ = this.baseUrl + "/api/ImarkMerchant/getAllImarkMerchantlist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImarkMerchant_GetAllImarkMerchantlist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImarkMerchant_GetAllImarkMerchantlist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImarkMerchantListVM[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImarkMerchantListVM[]>;
        }));
    }

    protected processImarkMerchant_GetAllImarkMerchantlist(response: HttpResponseBase): Observable<ImarkMerchantListVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImarkMerchantListVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    imarkMerchant_getImarkMerchantByPANNumber(pAN: string): Observable<ImarkMerchantListVM[]> {
        let url_ = this.baseUrl + "/api/ImarkMerchant/imark-merchant-id-by-PAN-number/{PAN}";
        if (pAN === undefined || pAN === null)
            throw new Error("The parameter 'pAN' must be defined.");
        url_ = url_.replace("{PAN}", encodeURIComponent("" + pAN));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImarkMerchant_getImarkMerchantByPANNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImarkMerchant_getImarkMerchantByPANNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImarkMerchantListVM[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImarkMerchantListVM[]>;
        }));
    }

    protected processImarkMerchant_getImarkMerchantByPANNumber(response: HttpResponseBase): Observable<ImarkMerchantListVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImarkMerchantListVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    imarkMerchant_GetAllMerchantImarkTidAndImarkMid(serialNumber: string): Observable<MerchantImarkTidAndImarkMidVM> {
        let url_ = this.baseUrl + "/api/ImarkMerchant/getAllMerchantImarkTidAndImarkMid/{SerialNumber}";
        if (serialNumber === undefined || serialNumber === null)
            throw new Error("The parameter 'serialNumber' must be defined.");
        url_ = url_.replace("{SerialNumber}", encodeURIComponent("" + serialNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImarkMerchant_GetAllMerchantImarkTidAndImarkMid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImarkMerchant_GetAllMerchantImarkTidAndImarkMid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MerchantImarkTidAndImarkMidVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MerchantImarkTidAndImarkMidVM>;
        }));
    }

    protected processImarkMerchant_GetAllMerchantImarkTidAndImarkMid(response: HttpResponseBase): Observable<MerchantImarkTidAndImarkMidVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MerchantImarkTidAndImarkMidVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    imarkMerchant_DeleteTerminalFromMerchant(id: string | undefined, iTid: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ImarkMerchant/deleteTerminalFromMerchant/{iTid}?";
        if (iTid === undefined || iTid === null)
            throw new Error("The parameter 'iTid' must be defined.");
        url_ = url_.replace("{iTid}", encodeURIComponent("" + iTid));
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImarkMerchant_DeleteTerminalFromMerchant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImarkMerchant_DeleteTerminalFromMerchant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processImarkMerchant_DeleteTerminalFromMerchant(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IInventoryAddService {
    inventoryAdd_GetAllInventoryAddList(page: number, pageSize: number): Observable<InventoryandAddViewModel[]>;
    inventoryAdd_GetInventoryAdd(page: number, pageSize: number): Observable<InventoryandAddViewModel[]>;
    inventoryAdd_GetStock(page: number, pageSize: number): Observable<InventoryAddPosSalesViewModel[]>;
    inventoryAdd_Get(id: string): Observable<InventoryAddViewModel>;
    inventoryAdd_Put(id: string, inventoryAddVm: InventoryAddViewModel): Observable<FileResponse>;
    inventoryAdd_GetInventoryAddSpares(page: number, pageSize: number): Observable<SparesForPosViewModel[]>;
    inventoryAdd_Post(inventoryAddVm: InventoryAddViewModel): Observable<FileResponse>;
    inventoryAdd_GetSpares(page: number, pageSize: number, id: string): Observable<AccessoryDistributtonViewModel[]>;
    inventoryAdd_updateAccessoryAdd(id: string, updateAccessoryAddCommand: UpdateAccessoryAddCommand): Observable<FileResponse>;
    inventoryAdd_GetPosStockList(): Observable<GetInventroysAddQuery[]>;
}

@Injectable({
    providedIn: 'root'
})
export class InventoryAddService implements IInventoryAddService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    inventoryAdd_GetAllInventoryAddList(page: number, pageSize: number): Observable<InventoryandAddViewModel[]> {
        let url_ = this.baseUrl + "/api/InventoryAdd/terminalType/{page}/{pageSize}";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInventoryAdd_GetAllInventoryAddList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInventoryAdd_GetAllInventoryAddList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryandAddViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryandAddViewModel[]>;
        }));
    }

    protected processInventoryAdd_GetAllInventoryAddList(response: HttpResponseBase): Observable<InventoryandAddViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InventoryandAddViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    inventoryAdd_GetInventoryAdd(page: number, pageSize: number): Observable<InventoryandAddViewModel[]> {
        let url_ = this.baseUrl + "/api/InventoryAdd/pagination/{page}/{pageSize}";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInventoryAdd_GetInventoryAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInventoryAdd_GetInventoryAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryandAddViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryandAddViewModel[]>;
        }));
    }

    protected processInventoryAdd_GetInventoryAdd(response: HttpResponseBase): Observable<InventoryandAddViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InventoryandAddViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    inventoryAdd_GetStock(page: number, pageSize: number): Observable<InventoryAddPosSalesViewModel[]> {
        let url_ = this.baseUrl + "/api/InventoryAdd/posStock/{page}/{pageSize}";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInventoryAdd_GetStock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInventoryAdd_GetStock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryAddPosSalesViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryAddPosSalesViewModel[]>;
        }));
    }

    protected processInventoryAdd_GetStock(response: HttpResponseBase): Observable<InventoryAddPosSalesViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InventoryAddPosSalesViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    inventoryAdd_Get(id: string): Observable<InventoryAddViewModel> {
        let url_ = this.baseUrl + "/api/InventoryAdd/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInventoryAdd_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInventoryAdd_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryAddViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryAddViewModel>;
        }));
    }

    protected processInventoryAdd_Get(response: HttpResponseBase): Observable<InventoryAddViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InventoryAddViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    inventoryAdd_Put(id: string, inventoryAddVm: InventoryAddViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/InventoryAdd/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inventoryAddVm);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInventoryAdd_Put(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInventoryAdd_Put(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processInventoryAdd_Put(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    inventoryAdd_GetInventoryAddSpares(page: number, pageSize: number): Observable<SparesForPosViewModel[]> {
        let url_ = this.baseUrl + "/api/InventoryAdd/paginationSpares/{page}/{pageSize}";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInventoryAdd_GetInventoryAddSpares(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInventoryAdd_GetInventoryAddSpares(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SparesForPosViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SparesForPosViewModel[]>;
        }));
    }

    protected processInventoryAdd_GetInventoryAddSpares(response: HttpResponseBase): Observable<SparesForPosViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SparesForPosViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    inventoryAdd_Post(inventoryAddVm: InventoryAddViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/InventoryAdd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inventoryAddVm);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInventoryAdd_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInventoryAdd_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processInventoryAdd_Post(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    inventoryAdd_GetSpares(page: number, pageSize: number, id: string): Observable<AccessoryDistributtonViewModel[]> {
        let url_ = this.baseUrl + "/api/InventoryAdd/sparesData/{page}/{pageSize}/{Id}";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInventoryAdd_GetSpares(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInventoryAdd_GetSpares(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccessoryDistributtonViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccessoryDistributtonViewModel[]>;
        }));
    }

    protected processInventoryAdd_GetSpares(response: HttpResponseBase): Observable<AccessoryDistributtonViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccessoryDistributtonViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    inventoryAdd_updateAccessoryAdd(id: string, updateAccessoryAddCommand: UpdateAccessoryAddCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/InventoryAdd/accessories-add-update/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateAccessoryAddCommand);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInventoryAdd_updateAccessoryAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInventoryAdd_updateAccessoryAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processInventoryAdd_updateAccessoryAdd(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    inventoryAdd_GetPosStockList(): Observable<GetInventroysAddQuery[]> {
        let url_ = this.baseUrl + "/api/inventorysAdd/getPosStockList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInventoryAdd_GetPosStockList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInventoryAdd_GetPosStockList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetInventroysAddQuery[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetInventroysAddQuery[]>;
        }));
    }

    protected processInventoryAdd_GetPosStockList(response: HttpResponseBase): Observable<GetInventroysAddQuery[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetInventroysAddQuery.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IInventoryService {
    inventory_GetAllTerminalModels(page: number | undefined, pageSize: number | undefined): Observable<InventoryViewModel[]>;
    inventory_Get(id: string): Observable<FileResponse>;
    inventory_Delete(id: string): Observable<InventoryCommand>;
    inventory_CreateTerminalType(inventoryCommand: InventoryCommand): Observable<FileResponse>;
    inventory_CreateAccessoryType(accessoryCommand: AcccesssoryCommand): Observable<FileResponse>;
    inventory_UpdateAccessoryType(id: string, accessoryCommand: AcccesssoryCommand): Observable<FileResponse>;
    inventory_UpdateTerminalType(id: string, inventoryCommand: InventoryCommand): Observable<FileResponse>;
    inventory_GetInventoryDetails(): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class InventoryService implements IInventoryService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    inventory_GetAllTerminalModels(page: number | undefined, pageSize: number | undefined): Observable<InventoryViewModel[]> {
        let url_ = this.baseUrl + "/api/Inventory/getAllTerminalModels?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInventory_GetAllTerminalModels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInventory_GetAllTerminalModels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryViewModel[]>;
        }));
    }

    protected processInventory_GetAllTerminalModels(response: HttpResponseBase): Observable<InventoryViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InventoryViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    inventory_Get(id: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Inventory/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInventory_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInventory_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processInventory_Get(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    inventory_Delete(id: string): Observable<InventoryCommand> {
        let url_ = this.baseUrl + "/api/Inventory/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInventory_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInventory_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryCommand>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryCommand>;
        }));
    }

    protected processInventory_Delete(response: HttpResponseBase): Observable<InventoryCommand> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InventoryCommand.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    inventory_CreateTerminalType(inventoryCommand: InventoryCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Inventory/addTerminalPOSType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inventoryCommand);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInventory_CreateTerminalType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInventory_CreateTerminalType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processInventory_CreateTerminalType(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    inventory_CreateAccessoryType(accessoryCommand: AcccesssoryCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Inventory/addAccesssoriesType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(accessoryCommand);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInventory_CreateAccessoryType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInventory_CreateAccessoryType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processInventory_CreateAccessoryType(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    inventory_UpdateAccessoryType(id: string, accessoryCommand: AcccesssoryCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Inventory/AccesssoriesType/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(accessoryCommand);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInventory_UpdateAccessoryType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInventory_UpdateAccessoryType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processInventory_UpdateAccessoryType(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    inventory_UpdateTerminalType(id: string, inventoryCommand: InventoryCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Inventory/TerminalType/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inventoryCommand);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInventory_UpdateTerminalType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInventory_UpdateTerminalType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processInventory_UpdateTerminalType(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    inventory_GetInventoryDetails(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/getInventoryDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInventory_GetInventoryDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInventory_GetInventoryDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processInventory_GetInventoryDetails(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ILogoService {
    logo_UploadFile(): Observable<FileResponse>;
    logo_UploadSlider(): Observable<FileResponse>;
    logo_UploadExcelFile(): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class LogoService implements ILogoService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    logo_UploadFile(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Logo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogo_UploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogo_UploadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processLogo_UploadFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    logo_UploadSlider(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Logo/slider";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogo_UploadSlider(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogo_UploadSlider(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processLogo_UploadSlider(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    logo_UploadExcelFile(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Logo/excel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogo_UploadExcelFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogo_UploadExcelFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processLogo_UploadExcelFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMaintenanceService {
    maintenance_GetAllMaintenances(): Observable<MaintenanceViewModel[]>;
    maintenance_GetMaintenanceDetails(): Observable<MaintenanceViewModel[]>;
    maintenance_GetMaintenanceIssues(id: string): Observable<MaintenanceIssuesQuery[]>;
    maintenance_Post(serialId: string, _maintenanceVM: MaintenanceViewModel): Observable<FileResponse>;
    maintenance_PostMaintenance(deploymentRequestId: string, _maintenanceVM: MaintenanceViewModel): Observable<FileResponse>;
    maintenance_AddMaintenance(deploymentRequestId: string, _maintenanceVM: MaintenanceViewModel): Observable<FileResponse>;
    maintenance_CreateMaintenanceFromNotReceivedPos(deploymentRequestId: string, command: CreateMaintenanceFromNotReceivedPosCommand): Observable<FileResponse>;
    maintenance_Put(id: string, _maintenanceVM: MaintenanceViewModel): Observable<FileResponse>;
    maintenance_Delete(id: string): Observable<MaintenanceViewModel>;
    maintenance_SendToStock(maintenanceId: string): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class MaintenanceService implements IMaintenanceService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    maintenance_GetAllMaintenances(): Observable<MaintenanceViewModel[]> {
        let url_ = this.baseUrl + "/api/maintenances/getAllMaintenance";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMaintenance_GetAllMaintenances(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMaintenance_GetAllMaintenances(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaintenanceViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaintenanceViewModel[]>;
        }));
    }

    protected processMaintenance_GetAllMaintenances(response: HttpResponseBase): Observable<MaintenanceViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaintenanceViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    maintenance_GetMaintenanceDetails(): Observable<MaintenanceViewModel[]> {
        let url_ = this.baseUrl + "/api/Maintenance/GetMaintenanceDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMaintenance_GetMaintenanceDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMaintenance_GetMaintenanceDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaintenanceViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaintenanceViewModel[]>;
        }));
    }

    protected processMaintenance_GetMaintenanceDetails(response: HttpResponseBase): Observable<MaintenanceViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaintenanceViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    maintenance_GetMaintenanceIssues(id: string): Observable<MaintenanceIssuesQuery[]> {
        let url_ = this.baseUrl + "/api/maintenances/{id}/getMaintenanceIssue";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMaintenance_GetMaintenanceIssues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMaintenance_GetMaintenanceIssues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaintenanceIssuesQuery[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaintenanceIssuesQuery[]>;
        }));
    }

    protected processMaintenance_GetMaintenanceIssues(response: HttpResponseBase): Observable<MaintenanceIssuesQuery[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaintenanceIssuesQuery.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    maintenance_Post(serialId: string, _maintenanceVM: MaintenanceViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Maintenance/{serialId}";
        if (serialId === undefined || serialId === null)
            throw new Error("The parameter 'serialId' must be defined.");
        url_ = url_.replace("{serialId}", encodeURIComponent("" + serialId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_maintenanceVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMaintenance_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMaintenance_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processMaintenance_Post(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    maintenance_PostMaintenance(deploymentRequestId: string, _maintenanceVM: MaintenanceViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Maintenance/fromDeployment/{deploymentRequestId}";
        if (deploymentRequestId === undefined || deploymentRequestId === null)
            throw new Error("The parameter 'deploymentRequestId' must be defined.");
        url_ = url_.replace("{deploymentRequestId}", encodeURIComponent("" + deploymentRequestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_maintenanceVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMaintenance_PostMaintenance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMaintenance_PostMaintenance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processMaintenance_PostMaintenance(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    maintenance_AddMaintenance(deploymentRequestId: string, _maintenanceVM: MaintenanceViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Maintenance/postMaintenanceFromNotReceive/{deploymentRequestId}";
        if (deploymentRequestId === undefined || deploymentRequestId === null)
            throw new Error("The parameter 'deploymentRequestId' must be defined.");
        url_ = url_.replace("{deploymentRequestId}", encodeURIComponent("" + deploymentRequestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_maintenanceVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMaintenance_AddMaintenance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMaintenance_AddMaintenance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processMaintenance_AddMaintenance(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    maintenance_CreateMaintenanceFromNotReceivedPos(deploymentRequestId: string, command: CreateMaintenanceFromNotReceivedPosCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/maintenances/{deploymentRequestId}/sendToMaintenanceFromNotReceivedPos";
        if (deploymentRequestId === undefined || deploymentRequestId === null)
            throw new Error("The parameter 'deploymentRequestId' must be defined.");
        url_ = url_.replace("{deploymentRequestId}", encodeURIComponent("" + deploymentRequestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMaintenance_CreateMaintenanceFromNotReceivedPos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMaintenance_CreateMaintenanceFromNotReceivedPos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processMaintenance_CreateMaintenanceFromNotReceivedPos(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    maintenance_Put(id: string, _maintenanceVM: MaintenanceViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Maintenance/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_maintenanceVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMaintenance_Put(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMaintenance_Put(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processMaintenance_Put(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    maintenance_Delete(id: string): Observable<MaintenanceViewModel> {
        let url_ = this.baseUrl + "/api/Maintenance/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMaintenance_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMaintenance_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaintenanceViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaintenanceViewModel>;
        }));
    }

    protected processMaintenance_Delete(response: HttpResponseBase): Observable<MaintenanceViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MaintenanceViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    maintenance_SendToStock(maintenanceId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/maintenances/{maintenanceId}/sendToStockFromNotReceivedPos";
        if (maintenanceId === undefined || maintenanceId === null)
            throw new Error("The parameter 'maintenanceId' must be defined.");
        url_ = url_.replace("{maintenanceId}", encodeURIComponent("" + maintenanceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMaintenance_SendToStock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMaintenance_SendToStock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processMaintenance_SendToStock(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMaintenanceIssueService {
    maintenanceIssue_CreateMaintenanceIssueFromMaintenance(maintenanceId: string, commmand: CreateMaintenanceIssueFromMaintenanceCommand): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class MaintenanceIssueService implements IMaintenanceIssueService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    maintenanceIssue_CreateMaintenanceIssueFromMaintenance(maintenanceId: string, commmand: CreateMaintenanceIssueFromMaintenanceCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/MaintenanceIssue/api/maintenanceIssues/{maintenanceId}/createMaintenanceIssue";
        if (maintenanceId === undefined || maintenanceId === null)
            throw new Error("The parameter 'maintenanceId' must be defined.");
        url_ = url_.replace("{maintenanceId}", encodeURIComponent("" + maintenanceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commmand);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMaintenanceIssue_CreateMaintenanceIssueFromMaintenance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMaintenanceIssue_CreateMaintenanceIssueFromMaintenance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processMaintenanceIssue_CreateMaintenanceIssueFromMaintenance(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMerchantCategoryService {
    merchantCategory_GetAll(): Observable<MerchantCategoryViewModel[]>;
    merchantCategory_Get(id: string): Observable<FileResponse>;
    merchantCategory_AddMerchantCategory(command: CreateMerchantCategoryCommand): Observable<FileResponse>;
    merchantCategory_Put(id: string, command: UpdateMerchantCategoryCommand): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class MerchantCategoryService implements IMerchantCategoryService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    merchantCategory_GetAll(): Observable<MerchantCategoryViewModel[]> {
        let url_ = this.baseUrl + "/api/MerchantCategory/getAllCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMerchantCategory_GetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMerchantCategory_GetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MerchantCategoryViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MerchantCategoryViewModel[]>;
        }));
    }

    protected processMerchantCategory_GetAll(response: HttpResponseBase): Observable<MerchantCategoryViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MerchantCategoryViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    merchantCategory_Get(id: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/MerchantCategory/getmerchantCategory/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMerchantCategory_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMerchantCategory_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processMerchantCategory_Get(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    merchantCategory_AddMerchantCategory(command: CreateMerchantCategoryCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/MerchantCategory/merchantCategoryAdd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMerchantCategory_AddMerchantCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMerchantCategory_AddMerchantCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processMerchantCategory_AddMerchantCategory(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    merchantCategory_Put(id: string, command: UpdateMerchantCategoryCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/MerchantCategory/updateMerchantCategory/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMerchantCategory_Put(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMerchantCategory_Put(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processMerchantCategory_Put(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMerchantInfoService {
    merchantInfo_Get(page: number, pageSize: number): Observable<MerchantInfoViewModel[]>;
    merchantInfo_GetMerchant(id: string): Observable<MerchantInfoViewModel[]>;
    merchantInfo_Post(_merchantVM: MerchantInfoViewModel): Observable<FileResponse>;
    merchantInfo_Put(id: string, merchantVM: MerchantInfoViewModel): Observable<FileResponse>;
    merchantInfo_Delete(id: string): Observable<MerchantInfoViewModel>;
}

@Injectable({
    providedIn: 'root'
})
export class MerchantInfoService implements IMerchantInfoService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    merchantInfo_Get(page: number, pageSize: number): Observable<MerchantInfoViewModel[]> {
        let url_ = this.baseUrl + "/api/MerchantInfo/pagination/{page}/{pageSize}";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMerchantInfo_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMerchantInfo_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MerchantInfoViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MerchantInfoViewModel[]>;
        }));
    }

    protected processMerchantInfo_Get(response: HttpResponseBase): Observable<MerchantInfoViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MerchantInfoViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    merchantInfo_GetMerchant(id: string): Observable<MerchantInfoViewModel[]> {
        let url_ = this.baseUrl + "/api/MerchantInfo/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMerchantInfo_GetMerchant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMerchantInfo_GetMerchant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MerchantInfoViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MerchantInfoViewModel[]>;
        }));
    }

    protected processMerchantInfo_GetMerchant(response: HttpResponseBase): Observable<MerchantInfoViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MerchantInfoViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    merchantInfo_Post(_merchantVM: MerchantInfoViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/MerchantInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_merchantVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMerchantInfo_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMerchantInfo_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processMerchantInfo_Post(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    merchantInfo_Put(id: string, merchantVM: MerchantInfoViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/MerchantInfo/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(merchantVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMerchantInfo_Put(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMerchantInfo_Put(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processMerchantInfo_Put(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    merchantInfo_Delete(id: string): Observable<MerchantInfoViewModel> {
        let url_ = this.baseUrl + "/api/MerchantInfo/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMerchantInfo_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMerchantInfo_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MerchantInfoViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MerchantInfoViewModel>;
        }));
    }

    protected processMerchantInfo_Delete(response: HttpResponseBase): Observable<MerchantInfoViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MerchantInfoViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMerchantMasterService {
    merchantMaster_CreateMerchantDetails(merchantDetailsAddCommands: MerchantDetailsAddCommands): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class MerchantMasterService implements IMerchantMasterService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    merchantMaster_CreateMerchantDetails(merchantDetailsAddCommands: MerchantDetailsAddCommands): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/MerchantMaster/CreateMerchantDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(merchantDetailsAddCommands);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMerchantMaster_CreateMerchantDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMerchantMaster_CreateMerchantDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processMerchantMaster_CreateMerchantDetails(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMerchantPortalService {
    merchantPortal_GetTransactionSummary(): Observable<TransactionSummary>;
    merchantPortal_GetTransactionDetails(timePeriodInDays: number | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<PaginatedListOfTransactionDetail>;
    merchantPortal_getMerchantDetailsByImarkMerchantId(imarkMerchantId: string): Observable<ImarkTerminalIdListViewModel>;
}

@Injectable({
    providedIn: 'root'
})
export class MerchantPortalService implements IMerchantPortalService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    merchantPortal_GetTransactionSummary(): Observable<TransactionSummary> {
        let url_ = this.baseUrl + "/merchant-api/transactions-summary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMerchantPortal_GetTransactionSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMerchantPortal_GetTransactionSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionSummary>;
        }));
    }

    protected processMerchantPortal_GetTransactionSummary(response: HttpResponseBase): Observable<TransactionSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionSummary.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    merchantPortal_GetTransactionDetails(timePeriodInDays: number | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<PaginatedListOfTransactionDetail> {
        let url_ = this.baseUrl + "/merchant-api/transactions?";
        if (timePeriodInDays === null)
            throw new Error("The parameter 'timePeriodInDays' cannot be null.");
        else if (timePeriodInDays !== undefined)
            url_ += "timePeriodInDays=" + encodeURIComponent("" + timePeriodInDays) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMerchantPortal_GetTransactionDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMerchantPortal_GetTransactionDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedListOfTransactionDetail>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedListOfTransactionDetail>;
        }));
    }

    protected processMerchantPortal_GetTransactionDetails(response: HttpResponseBase): Observable<PaginatedListOfTransactionDetail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfTransactionDetail.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    merchantPortal_getMerchantDetailsByImarkMerchantId(imarkMerchantId: string): Observable<ImarkTerminalIdListViewModel> {
        let url_ = this.baseUrl + "/merchant-api/TerminalDetails/{ImarkMerchantId}";
        if (imarkMerchantId === undefined || imarkMerchantId === null)
            throw new Error("The parameter 'imarkMerchantId' must be defined.");
        url_ = url_.replace("{ImarkMerchantId}", encodeURIComponent("" + imarkMerchantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMerchantPortal_getMerchantDetailsByImarkMerchantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMerchantPortal_getMerchantDetailsByImarkMerchantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImarkTerminalIdListViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImarkTerminalIdListViewModel>;
        }));
    }

    protected processMerchantPortal_getMerchantDetailsByImarkMerchantId(response: HttpResponseBase): Observable<ImarkTerminalIdListViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImarkTerminalIdListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMerchantSupportService {
    merchantSupport_Post(_issuesVM: IssuesViewModel): Observable<FileResponse>;
    merchantSupport_GetIssues(): Observable<FileResponse>;
    merchantSupport_Put(id: string | undefined, _issuesVM: IssuesViewModel): Observable<FileResponse>;
    merchantSupport_Post2(_sliderVM: SliderViewModel): Observable<FileResponse>;
    merchantSupport_GetSlider(): Observable<FileResponse>;
    merchantSupport_Put2(_sliderVM: SliderViewModel): Observable<FileResponse>;
    merchantSupport_DeleteSlider(id: string | undefined): Observable<void>;
    merchantSupport_Post3(_rollrequestVM: RollRequestViewModel): Observable<FileResponse>;
    merchantSupport_Put3(_rollrequestVM: RollRequestViewModel): Observable<FileResponse>;
    merchantSupport_GetRolllist(): Observable<FileResponse>;
    merchantSupport_DeleteRollRequest(id: string | undefined): Observable<void>;
    merchantSupport_GetIssueTypes(): Observable<FileResponse>;
    merchantSupport_GetStatus(): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class MerchantSupportService implements IMerchantSupportService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    merchantSupport_Post(_issuesVM: IssuesViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/MerchantSupport/Issue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_issuesVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMerchantSupport_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMerchantSupport_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processMerchantSupport_Post(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    merchantSupport_GetIssues(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/MerchantSupport/Issue";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMerchantSupport_GetIssues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMerchantSupport_GetIssues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processMerchantSupport_GetIssues(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    merchantSupport_Put(id: string | undefined, _issuesVM: IssuesViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/MerchantSupport/Issue?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_issuesVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMerchantSupport_Put(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMerchantSupport_Put(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processMerchantSupport_Put(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    merchantSupport_Post2(_sliderVM: SliderViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/MerchantSupport/Slider";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_sliderVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMerchantSupport_Post2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMerchantSupport_Post2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processMerchantSupport_Post2(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    merchantSupport_GetSlider(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/MerchantSupport/Slider";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMerchantSupport_GetSlider(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMerchantSupport_GetSlider(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processMerchantSupport_GetSlider(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    merchantSupport_Put2(_sliderVM: SliderViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/MerchantSupport/Slider";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_sliderVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMerchantSupport_Put2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMerchantSupport_Put2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processMerchantSupport_Put2(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    merchantSupport_DeleteSlider(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/MerchantSupport/Slider?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMerchantSupport_DeleteSlider(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMerchantSupport_DeleteSlider(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMerchantSupport_DeleteSlider(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    merchantSupport_Post3(_rollrequestVM: RollRequestViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/MerchantSupport/RollRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_rollrequestVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMerchantSupport_Post3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMerchantSupport_Post3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processMerchantSupport_Post3(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    merchantSupport_Put3(_rollrequestVM: RollRequestViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/MerchantSupport/RollRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_rollrequestVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMerchantSupport_Put3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMerchantSupport_Put3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processMerchantSupport_Put3(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    merchantSupport_GetRolllist(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/MerchantSupport/RollRequest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMerchantSupport_GetRolllist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMerchantSupport_GetRolllist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processMerchantSupport_GetRolllist(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    merchantSupport_DeleteRollRequest(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/MerchantSupport/RollRequest?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMerchantSupport_DeleteRollRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMerchantSupport_DeleteRollRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMerchantSupport_DeleteRollRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    merchantSupport_GetIssueTypes(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/MerchantSupport/IssueType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMerchantSupport_GetIssueTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMerchantSupport_GetIssueTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processMerchantSupport_GetIssueTypes(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    merchantSupport_GetStatus(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/MerchantSupport/Status";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMerchantSupport_GetStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMerchantSupport_GetStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processMerchantSupport_GetStatus(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMerchantTerminalMapService {
    merchantTerminalMap_CreateMerchantTerminalMap(command: CreateMerchantTerminalMapCommand): Observable<FileResponse>;
    merchantTerminalMap_GetMerchantUserTerminalId(userId: string): Observable<MerchantTerminalMapVm[]>;
}

@Injectable({
    providedIn: 'root'
})
export class MerchantTerminalMapService implements IMerchantTerminalMapService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    merchantTerminalMap_CreateMerchantTerminalMap(command: CreateMerchantTerminalMapCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/merchantTerminalMaps/map-merchant-user-to-terminalId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMerchantTerminalMap_CreateMerchantTerminalMap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMerchantTerminalMap_CreateMerchantTerminalMap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processMerchantTerminalMap_CreateMerchantTerminalMap(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    merchantTerminalMap_GetMerchantUserTerminalId(userId: string): Observable<MerchantTerminalMapVm[]> {
        let url_ = this.baseUrl + "/api/merchantTerminalMaps/{userId}/merchant-user-terminalId";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMerchantTerminalMap_GetMerchantUserTerminalId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMerchantTerminalMap_GetMerchantUserTerminalId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MerchantTerminalMapVm[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MerchantTerminalMapVm[]>;
        }));
    }

    protected processMerchantTerminalMap_GetMerchantUserTerminalId(response: HttpResponseBase): Observable<MerchantTerminalMapVm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MerchantTerminalMapVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMobileCardRequestService {
    mobileCardRequest_GetCardRequest(): Observable<CardRequestViewModel[]>;
    mobileCardRequest_Get(id: number): Observable<string>;
    mobileCardRequest_Get2(id: number): Observable<string>;
    mobileCardRequest_CardRequestUpdatePUT(id: number, mobileCardRequest: MobileCardRequest): Observable<FileResponse>;
    mobileCardRequest_Delete(id: number): Observable<void>;
    mobileCardRequest_CardRequest(mobileCardRequest: MobileCardRequest): Observable<FileResponse>;
    mobileCardRequest_CardRequestUpdatePOST(id: number, mobileCardRequest: MobileCardRequest): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class MobileCardRequestService implements IMobileCardRequestService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    mobileCardRequest_GetCardRequest(): Observable<CardRequestViewModel[]> {
        let url_ = this.baseUrl + "/api/MobileCardRequest/CardRequestList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMobileCardRequest_GetCardRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMobileCardRequest_GetCardRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CardRequestViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CardRequestViewModel[]>;
        }));
    }

    protected processMobileCardRequest_GetCardRequest(response: HttpResponseBase): Observable<CardRequestViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CardRequestViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    mobileCardRequest_Get(id: number): Observable<string> {
        let url_ = this.baseUrl + "/api/MobileCardRequest/CardRequest/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMobileCardRequest_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMobileCardRequest_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processMobileCardRequest_Get(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    mobileCardRequest_Get2(id: number): Observable<string> {
        let url_ = this.baseUrl + "/api/MobileCardRequest/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMobileCardRequest_Get2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMobileCardRequest_Get2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processMobileCardRequest_Get2(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    mobileCardRequest_CardRequestUpdatePUT(id: number, mobileCardRequest: MobileCardRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/MobileCardRequest/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mobileCardRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMobileCardRequest_CardRequestUpdatePUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMobileCardRequest_CardRequestUpdatePUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processMobileCardRequest_CardRequestUpdatePUT(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    mobileCardRequest_Delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/MobileCardRequest/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMobileCardRequest_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMobileCardRequest_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMobileCardRequest_Delete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    mobileCardRequest_CardRequest(mobileCardRequest: MobileCardRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/MobileCardRequest/CardRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mobileCardRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMobileCardRequest_CardRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMobileCardRequest_CardRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processMobileCardRequest_CardRequest(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    mobileCardRequest_CardRequestUpdatePOST(id: number, mobileCardRequest: MobileCardRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/MobileCardRequest/CardRequest/{id}/Update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mobileCardRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMobileCardRequest_CardRequestUpdatePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMobileCardRequest_CardRequestUpdatePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processMobileCardRequest_CardRequestUpdatePOST(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface INacNumberService {
    nacNumber_GetAll(page: number, pageSize: number): Observable<NacNumberViewModel[]>;
    nacNumber_GetAll2(id: string, page: number, pageSize: number): Observable<ApplicationVersionViewModel[]>;
    nacNumber_Get(id: string): Observable<FileResponse>;
    nacNumber_Put(id: string, nacNumberVm: NacNumberViewModel): Observable<FileResponse>;
    nacNumber_Post(nacNumberVm: NacNumberVm): Observable<FileResponse>;
    nacNumber_GetNacNumber(bankId: string, page: number, pageSize: number): Observable<NacNumberViewModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class NacNumberService implements INacNumberService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    nacNumber_GetAll(page: number, pageSize: number): Observable<NacNumberViewModel[]> {
        let url_ = this.baseUrl + "/api/NacNumber/pagination/{page}/{pageSize}";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNacNumber_GetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNacNumber_GetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NacNumberViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NacNumberViewModel[]>;
        }));
    }

    protected processNacNumber_GetAll(response: HttpResponseBase): Observable<NacNumberViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NacNumberViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    nacNumber_GetAll2(id: string, page: number, pageSize: number): Observable<ApplicationVersionViewModel[]> {
        let url_ = this.baseUrl + "/api/NacNumber/{id}/{page}/{pageSize}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNacNumber_GetAll2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNacNumber_GetAll2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationVersionViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationVersionViewModel[]>;
        }));
    }

    protected processNacNumber_GetAll2(response: HttpResponseBase): Observable<ApplicationVersionViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApplicationVersionViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    nacNumber_Get(id: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/NacNumber/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNacNumber_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNacNumber_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processNacNumber_Get(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    nacNumber_Put(id: string, nacNumberVm: NacNumberViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/NacNumber/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(nacNumberVm);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNacNumber_Put(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNacNumber_Put(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processNacNumber_Put(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    nacNumber_Post(nacNumberVm: NacNumberVm): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/NacNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(nacNumberVm);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNacNumber_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNacNumber_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processNacNumber_Post(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    nacNumber_GetNacNumber(bankId: string, page: number, pageSize: number): Observable<NacNumberViewModel[]> {
        let url_ = this.baseUrl + "/api/NacNumber/getNacNumber/{bankId}/{page}/{pageSize}";
        if (bankId === undefined || bankId === null)
            throw new Error("The parameter 'bankId' must be defined.");
        url_ = url_.replace("{bankId}", encodeURIComponent("" + bankId));
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNacNumber_GetNacNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNacNumber_GetNacNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NacNumberViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NacNumberViewModel[]>;
        }));
    }

    protected processNacNumber_GetNacNumber(response: HttpResponseBase): Observable<NacNumberViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NacNumberViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface INarayanService {
    narayan_Index(): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class NarayanService implements INarayanService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    narayan_Index(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/narayan";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNarayan_Index(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNarayan_Index(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processNarayan_Index(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface INonSerialService {
    nonSerial_Get(): Observable<AccessoryAddViewModel[]>;
    nonSerial_GetAllAccessories(): Observable<AccessoryListVM[]>;
    nonSerial_GetPosAccessoriesSales(): Observable<GetPosAccessorySalesQuery[]>;
}

@Injectable({
    providedIn: 'root'
})
export class NonSerialService implements INonSerialService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    nonSerial_Get(): Observable<AccessoryAddViewModel[]> {
        let url_ = this.baseUrl + "/api/NonSerial";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNonSerial_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNonSerial_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccessoryAddViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccessoryAddViewModel[]>;
        }));
    }

    protected processNonSerial_Get(response: HttpResponseBase): Observable<AccessoryAddViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccessoryAddViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    nonSerial_GetAllAccessories(): Observable<AccessoryListVM[]> {
        let url_ = this.baseUrl + "/api/NonSerial/accessory-type-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNonSerial_GetAllAccessories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNonSerial_GetAllAccessories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccessoryListVM[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccessoryListVM[]>;
        }));
    }

    protected processNonSerial_GetAllAccessories(response: HttpResponseBase): Observable<AccessoryListVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccessoryListVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    nonSerial_GetPosAccessoriesSales(): Observable<GetPosAccessorySalesQuery[]> {
        let url_ = this.baseUrl + "/api/nonSerials/posAccessoriesSales";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNonSerial_GetPosAccessoriesSales(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNonSerial_GetPosAccessoriesSales(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPosAccessorySalesQuery[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPosAccessorySalesQuery[]>;
        }));
    }

    protected processNonSerial_GetPosAccessoriesSales(response: HttpResponseBase): Observable<GetPosAccessorySalesQuery[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetPosAccessorySalesQuery.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface INotificationUserService {
    notificationUser_Index(): Observable<FileResponse>;
    notificationUser_getAllNotifications(): Observable<FileResponse>;
    notificationUser_updateNotifications(seenVM: MarkAsSeenViewModel[]): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class NotificationUserService implements INotificationUserService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    notificationUser_Index(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/NotificationUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotificationUser_Index(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotificationUser_Index(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processNotificationUser_Index(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    notificationUser_getAllNotifications(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/NotificationUser/api/UserNotifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotificationUser_getAllNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotificationUser_getAllNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processNotificationUser_getAllNotifications(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    notificationUser_updateNotifications(seenVM: MarkAsSeenViewModel[]): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/NotificationUser/api/UserNotifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(seenVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotificationUser_updateNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotificationUser_updateNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processNotificationUser_updateNotifications(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface INotReceivedPosService {
    notReceivedPos_NotRecievedPos(page: number, pageSize: number): Observable<NotReceivedPosViewModel[]>;
    notReceivedPos_AddStatusReason(id: string, statusReason: string | null | undefined): Observable<FileResponse>;
    notReceivedPos_GetAllNotReceivedPos(): Observable<PosNotReceivedVm[]>;
    notReceivedPos_Put(id: string, notReceivedVM: NotReceivedPosViewModel): Observable<FileResponse>;
    notReceivedPos_SendToStockFromNotReceivedPos(deploymentRequestId: string, command: SendToStockFomNotReceivedPosCommand): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class NotReceivedPosService implements INotReceivedPosService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    notReceivedPos_NotRecievedPos(page: number, pageSize: number): Observable<NotReceivedPosViewModel[]> {
        let url_ = this.baseUrl + "/api/NotReceivedPos/pagination/{page}/{pageSize}";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotReceivedPos_NotRecievedPos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotReceivedPos_NotRecievedPos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotReceivedPosViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotReceivedPosViewModel[]>;
        }));
    }

    protected processNotReceivedPos_NotRecievedPos(response: HttpResponseBase): Observable<NotReceivedPosViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotReceivedPosViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    notReceivedPos_AddStatusReason(id: string, statusReason: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/notReceivedPos/{id}/addStatusReason?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (statusReason !== undefined && statusReason !== null)
            url_ += "statusReason=" + encodeURIComponent("" + statusReason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotReceivedPos_AddStatusReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotReceivedPos_AddStatusReason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processNotReceivedPos_AddStatusReason(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    notReceivedPos_GetAllNotReceivedPos(): Observable<PosNotReceivedVm[]> {
        let url_ = this.baseUrl + "/api/notReceivedPos/getNotReceivedPos";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotReceivedPos_GetAllNotReceivedPos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotReceivedPos_GetAllNotReceivedPos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PosNotReceivedVm[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PosNotReceivedVm[]>;
        }));
    }

    protected processNotReceivedPos_GetAllNotReceivedPos(response: HttpResponseBase): Observable<PosNotReceivedVm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PosNotReceivedVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    notReceivedPos_Put(id: string, notReceivedVM: NotReceivedPosViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/NotReceivedPos/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(notReceivedVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotReceivedPos_Put(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotReceivedPos_Put(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processNotReceivedPos_Put(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    notReceivedPos_SendToStockFromNotReceivedPos(deploymentRequestId: string, command: SendToStockFomNotReceivedPosCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/notReceivedPos/{deploymentRequestId}/sendToStock";
        if (deploymentRequestId === undefined || deploymentRequestId === null)
            throw new Error("The parameter 'deploymentRequestId' must be defined.");
        url_ = url_.replace("{deploymentRequestId}", encodeURIComponent("" + deploymentRequestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotReceivedPos_SendToStockFromNotReceivedPos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotReceivedPos_SendToStockFromNotReceivedPos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processNotReceivedPos_SendToStockFromNotReceivedPos(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IOtherPartyService {
    otherParty_Get(page: number, pageSize: number): Observable<OtherPartyViewModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class OtherPartyService implements IOtherPartyService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    otherParty_Get(page: number, pageSize: number): Observable<OtherPartyViewModel[]> {
        let url_ = this.baseUrl + "/api/OtherParty/pagination/{page}/{pageSize}";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOtherParty_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOtherParty_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OtherPartyViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OtherPartyViewModel[]>;
        }));
    }

    protected processOtherParty_Get(response: HttpResponseBase): Observable<OtherPartyViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OtherPartyViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IOtherStockService {
    otherStock_Post(_otherStockVM: OtherStockAddViewModel): Observable<FileResponse>;
    otherStock_CreateOtherStocks(deploymentRequestId: string | undefined, command: CreateOtherStockCommand[]): Observable<FileResponse>;
    otherStock_Delete(id: string): Observable<OtherStockAddViewModel>;
    otherStock_AccessoryRequestDetailsFormData(deploymentRequestId: string): Observable<AccessoryRequestDetailsFormData>;
    otherStock_GetAccessoryList(fromDate: string | null | undefined, toDate: string | null | undefined): Observable<AccessoriesHistoryViewModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class OtherStockService implements IOtherStockService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    otherStock_Post(_otherStockVM: OtherStockAddViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/OtherStock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_otherStockVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOtherStock_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOtherStock_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processOtherStock_Post(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    otherStock_CreateOtherStocks(deploymentRequestId: string | undefined, command: CreateOtherStockCommand[]): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/OtherStock/createOtherStocks?";
        if (deploymentRequestId === null)
            throw new Error("The parameter 'deploymentRequestId' cannot be null.");
        else if (deploymentRequestId !== undefined)
            url_ += "deploymentRequestId=" + encodeURIComponent("" + deploymentRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOtherStock_CreateOtherStocks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOtherStock_CreateOtherStocks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processOtherStock_CreateOtherStocks(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    otherStock_Delete(id: string): Observable<OtherStockAddViewModel> {
        let url_ = this.baseUrl + "/api/OtherStock/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOtherStock_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOtherStock_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OtherStockAddViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OtherStockAddViewModel>;
        }));
    }

    protected processOtherStock_Delete(response: HttpResponseBase): Observable<OtherStockAddViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OtherStockAddViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    otherStock_AccessoryRequestDetailsFormData(deploymentRequestId: string): Observable<AccessoryRequestDetailsFormData> {
        let url_ = this.baseUrl + "/api/OtherStock/AccessoryRequestDetailsFormData/{deploymentRequestId}";
        if (deploymentRequestId === undefined || deploymentRequestId === null)
            throw new Error("The parameter 'deploymentRequestId' must be defined.");
        url_ = url_.replace("{deploymentRequestId}", encodeURIComponent("" + deploymentRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOtherStock_AccessoryRequestDetailsFormData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOtherStock_AccessoryRequestDetailsFormData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccessoryRequestDetailsFormData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccessoryRequestDetailsFormData>;
        }));
    }

    protected processOtherStock_AccessoryRequestDetailsFormData(response: HttpResponseBase): Observable<AccessoryRequestDetailsFormData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccessoryRequestDetailsFormData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    otherStock_GetAccessoryList(fromDate: string | null | undefined, toDate: string | null | undefined): Observable<AccessoriesHistoryViewModel[]> {
        let url_ = this.baseUrl + "/api/OtherStock/AccessoryList?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOtherStock_GetAccessoryList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOtherStock_GetAccessoryList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccessoriesHistoryViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccessoriesHistoryViewModel[]>;
        }));
    }

    protected processOtherStock_GetAccessoryList(response: HttpResponseBase): Observable<AccessoriesHistoryViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccessoriesHistoryViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IPendingRemovalService {
    pendingRemoval_GetAllPendingRemovalRequest(pageNumber: number | undefined, pageSize: number | undefined, searchValue: string | null | undefined): Observable<PaginatedListOfRemovalRequestViewModel>;
    pendingRemoval_GetPendingRemoval(deploymentRequestId: string): Observable<RemovalStatusViewModel[]>;
    pendingRemoval_GetPendingRemovalByDepId(deploymentRequestId: string): Observable<PendingRemovalByIdViewModel>;
    pendingRemoval_UpdateRemovalStatus(pendingRemovalVm: AddRemovalStatusViewModel): Observable<FileResponse>;
    pendingRemoval_GetRemovalStatus(): Observable<any[]>;
}

@Injectable({
    providedIn: 'root'
})
export class PendingRemovalService implements IPendingRemovalService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    pendingRemoval_GetAllPendingRemovalRequest(pageNumber: number | undefined, pageSize: number | undefined, searchValue: string | null | undefined): Observable<PaginatedListOfRemovalRequestViewModel> {
        let url_ = this.baseUrl + "/api/PendingRemoval/pending-removal-request-list?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchValue !== undefined && searchValue !== null)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPendingRemoval_GetAllPendingRemovalRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPendingRemoval_GetAllPendingRemovalRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedListOfRemovalRequestViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedListOfRemovalRequestViewModel>;
        }));
    }

    protected processPendingRemoval_GetAllPendingRemovalRequest(response: HttpResponseBase): Observable<PaginatedListOfRemovalRequestViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfRemovalRequestViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    pendingRemoval_GetPendingRemoval(deploymentRequestId: string): Observable<RemovalStatusViewModel[]> {
        let url_ = this.baseUrl + "/api/PendingRemoval/{deploymentRequestId}";
        if (deploymentRequestId === undefined || deploymentRequestId === null)
            throw new Error("The parameter 'deploymentRequestId' must be defined.");
        url_ = url_.replace("{deploymentRequestId}", encodeURIComponent("" + deploymentRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPendingRemoval_GetPendingRemoval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPendingRemoval_GetPendingRemoval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RemovalStatusViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RemovalStatusViewModel[]>;
        }));
    }

    protected processPendingRemoval_GetPendingRemoval(response: HttpResponseBase): Observable<RemovalStatusViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RemovalStatusViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    pendingRemoval_GetPendingRemovalByDepId(deploymentRequestId: string): Observable<PendingRemovalByIdViewModel> {
        let url_ = this.baseUrl + "/api/PendingRemoval/PendingRemovalById/{deploymentRequestId}";
        if (deploymentRequestId === undefined || deploymentRequestId === null)
            throw new Error("The parameter 'deploymentRequestId' must be defined.");
        url_ = url_.replace("{deploymentRequestId}", encodeURIComponent("" + deploymentRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPendingRemoval_GetPendingRemovalByDepId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPendingRemoval_GetPendingRemovalByDepId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendingRemovalByIdViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendingRemovalByIdViewModel>;
        }));
    }

    protected processPendingRemoval_GetPendingRemovalByDepId(response: HttpResponseBase): Observable<PendingRemovalByIdViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PendingRemovalByIdViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    pendingRemoval_UpdateRemovalStatus(pendingRemovalVm: AddRemovalStatusViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/PendingRemoval/updateRemovalStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pendingRemovalVm);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPendingRemoval_UpdateRemovalStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPendingRemoval_UpdateRemovalStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPendingRemoval_UpdateRemovalStatus(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    pendingRemoval_GetRemovalStatus(): Observable<any[]> {
        let url_ = this.baseUrl + "/api/PendingRemoval/removalStatusEnums";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPendingRemoval_GetRemovalStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPendingRemoval_GetRemovalStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any[]>;
        }));
    }

    protected processPendingRemoval_GetRemovalStatus(response: HttpResponseBase): Observable<any[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IPosHistoryService {
    posHistory_GetPosCurrentlyInMerchantLocation(fromDate: string, toDate: string, banks: string[] | null | undefined): Observable<PosHistoryViewModel[]>;
    posHistory_GetMerchantDetailsBySearchField(terminalId: string | null | undefined, serialKey: string | null | undefined, bank: string | null | undefined, merchant: string | null | undefined): Observable<PosHistoryViewModel[]>;
    posHistory_GetposmasterData(page: number, pageSize: number): Observable<PosHistoryViewModel[]>;
    posHistory_GetremoveData(page: number, pageSize: number): Observable<PosHistoryViewModel[]>;
    posHistory_GetretrieveTerminal(fromDate: string | null | undefined, toDate: string | null | undefined): Observable<RetrieveTerminalViewModel[]>;
    posHistory_Get(id: string): Observable<DeploymentRequestViewModel>;
    posHistory_Put(id: string, _posHistoryVM: PosHistoryViewModel): Observable<FileResponse>;
    posHistory_UpdateApplicationPOST(command: CreatePosHistoryCommand): Observable<FileResponse>;
    posHistory_Post(_posHistoryVM: PosHistoryViewModel): Observable<FileResponse>;
    posHistory_POST(retrieve: string | null | undefined, id: string, posHistoryVm: PosHistoryViewModel): Observable<FileResponse>;
    posHistory_RetrieveTerminal(id: string, command: RetrieveTerminalCommand): Observable<ApiResponseOfString>;
    posHistory_PUT(id: string, _posHistoryVM: PosHistoryViewModel): Observable<FileResponse>;
    posHistory_PutRejectRemoval(id: string, _posHistoryVM: PosHistoryViewModel): Observable<FileResponse>;
    posHistory_PutMaintenance(maintenancePos: string | null | undefined, id: string): Observable<FileResponse>;
    posHistory_DamagePos(id: string, _damagePosVM: DamagePoseViewModel): Observable<FileResponse>;
    posHistory_Put2(id: string): Observable<FileResponse>;
    posHistory_GetDailyReportCount(): Observable<FileResponse>;
    posHistory_GetDailyReport(fromDate: string, toDate: string, banks: string[] | null | undefined): Observable<FileResponse>;
    posHistory_UpdateApplicationPUT(id: string, _Pos: ConfigurationViewModel): Observable<FileResponse>;
    posHistory_UpdateMerchantDetails(deploymentRequestId: string, pos: DeploymentRequestViewModel): Observable<FileResponse>;
    posHistory_DeploymentRequestVerify(): Observable<FileResponse>;
    posHistory_DeploymentReconfigure(): Observable<FileResponse>;
    posHistory_DeploymentRequest(): Observable<FileResponse>;
    posHistory_Serial(): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class PosHistoryService implements IPosHistoryService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    posHistory_GetPosCurrentlyInMerchantLocation(fromDate: string, toDate: string, banks: string[] | null | undefined): Observable<PosHistoryViewModel[]> {
        let url_ = this.baseUrl + "/api/PosHistory/BankWisePOSReport/{fromDate}/{toDate}?";
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined.");
        url_ = url_.replace("{fromDate}", encodeURIComponent("" + fromDate));
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent("" + toDate));
        if (banks !== undefined && banks !== null)
            banks && banks.forEach(item => { url_ += "banks=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosHistory_GetPosCurrentlyInMerchantLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosHistory_GetPosCurrentlyInMerchantLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PosHistoryViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PosHistoryViewModel[]>;
        }));
    }

    protected processPosHistory_GetPosCurrentlyInMerchantLocation(response: HttpResponseBase): Observable<PosHistoryViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PosHistoryViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    posHistory_GetMerchantDetailsBySearchField(terminalId: string | null | undefined, serialKey: string | null | undefined, bank: string | null | undefined, merchant: string | null | undefined): Observable<PosHistoryViewModel[]> {
        let url_ = this.baseUrl + "/api/PosHistory/BankWisePOSReportBySearchField?";
        if (terminalId !== undefined && terminalId !== null)
            url_ += "terminalId=" + encodeURIComponent("" + terminalId) + "&";
        if (serialKey !== undefined && serialKey !== null)
            url_ += "serialKey=" + encodeURIComponent("" + serialKey) + "&";
        if (bank !== undefined && bank !== null)
            url_ += "bank=" + encodeURIComponent("" + bank) + "&";
        if (merchant !== undefined && merchant !== null)
            url_ += "merchant=" + encodeURIComponent("" + merchant) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosHistory_GetMerchantDetailsBySearchField(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosHistory_GetMerchantDetailsBySearchField(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PosHistoryViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PosHistoryViewModel[]>;
        }));
    }

    protected processPosHistory_GetMerchantDetailsBySearchField(response: HttpResponseBase): Observable<PosHistoryViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PosHistoryViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    posHistory_GetposmasterData(page: number, pageSize: number): Observable<PosHistoryViewModel[]> {
        let url_ = this.baseUrl + "/api/PosHistory/paginationForRemoveReconfigure/{page}/{pageSize}";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosHistory_GetposmasterData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosHistory_GetposmasterData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PosHistoryViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PosHistoryViewModel[]>;
        }));
    }

    protected processPosHistory_GetposmasterData(response: HttpResponseBase): Observable<PosHistoryViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PosHistoryViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    posHistory_GetremoveData(page: number, pageSize: number): Observable<PosHistoryViewModel[]> {
        let url_ = this.baseUrl + "/api/PosHistory/removalRequestHistory/{page}/{pageSize}";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosHistory_GetremoveData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosHistory_GetremoveData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PosHistoryViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PosHistoryViewModel[]>;
        }));
    }

    protected processPosHistory_GetremoveData(response: HttpResponseBase): Observable<PosHistoryViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PosHistoryViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    posHistory_GetretrieveTerminal(fromDate: string | null | undefined, toDate: string | null | undefined): Observable<RetrieveTerminalViewModel[]> {
        let url_ = this.baseUrl + "/api/PosHistory/retrieveTerminal?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosHistory_GetretrieveTerminal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosHistory_GetretrieveTerminal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RetrieveTerminalViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RetrieveTerminalViewModel[]>;
        }));
    }

    protected processPosHistory_GetretrieveTerminal(response: HttpResponseBase): Observable<RetrieveTerminalViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RetrieveTerminalViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    posHistory_Get(id: string): Observable<DeploymentRequestViewModel> {
        let url_ = this.baseUrl + "/api/PosHistory/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosHistory_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosHistory_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeploymentRequestViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeploymentRequestViewModel>;
        }));
    }

    protected processPosHistory_Get(response: HttpResponseBase): Observable<DeploymentRequestViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeploymentRequestViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    posHistory_Put(id: string, _posHistoryVM: PosHistoryViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/PosHistory/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_posHistoryVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosHistory_Put(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosHistory_Put(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPosHistory_Put(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    posHistory_UpdateApplicationPOST(command: CreatePosHistoryCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/PosHistory/createPosHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosHistory_UpdateApplicationPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosHistory_UpdateApplicationPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPosHistory_UpdateApplicationPOST(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    posHistory_Post(_posHistoryVM: PosHistoryViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/PosHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_posHistoryVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosHistory_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosHistory_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPosHistory_Post(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    posHistory_POST(retrieve: string | null | undefined, id: string, posHistoryVm: PosHistoryViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/PosHistory/retrieve/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (retrieve !== undefined && retrieve !== null)
            url_ += "retrieve=" + encodeURIComponent("" + retrieve) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(posHistoryVm);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosHistory_POST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosHistory_POST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPosHistory_POST(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    posHistory_RetrieveTerminal(id: string, command: RetrieveTerminalCommand): Observable<ApiResponseOfString> {
        let url_ = this.baseUrl + "/api/posHistroys/{id}/retrieveTerminal";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosHistory_RetrieveTerminal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosHistory_RetrieveTerminal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfString>;
        }));
    }

    protected processPosHistory_RetrieveTerminal(response: HttpResponseBase): Observable<ApiResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    posHistory_PUT(id: string, _posHistoryVM: PosHistoryViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/PosHistory/removalRequest/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_posHistoryVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosHistory_PUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosHistory_PUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPosHistory_PUT(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    posHistory_PutRejectRemoval(id: string, _posHistoryVM: PosHistoryViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/PosHistory/rejectRemovalRequest/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_posHistoryVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosHistory_PutRejectRemoval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosHistory_PutRejectRemoval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPosHistory_PutRejectRemoval(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    posHistory_PutMaintenance(maintenancePos: string | null | undefined, id: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/PosHistory/maintenancePos/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (maintenancePos !== undefined && maintenancePos !== null)
            url_ += "maintenancePos=" + encodeURIComponent("" + maintenancePos) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosHistory_PutMaintenance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosHistory_PutMaintenance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPosHistory_PutMaintenance(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    posHistory_DamagePos(id: string, _damagePosVM: DamagePoseViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/PosHistory/damagePos/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_damagePosVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosHistory_DamagePos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosHistory_DamagePos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPosHistory_DamagePos(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    posHistory_Put2(id: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/PosHistory/retrieveVerify/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosHistory_Put2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosHistory_Put2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPosHistory_Put2(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    posHistory_GetDailyReportCount(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/PosHistory/GetDailyReportCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosHistory_GetDailyReportCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosHistory_GetDailyReportCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPosHistory_GetDailyReportCount(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    posHistory_GetDailyReport(fromDate: string, toDate: string, banks: string[] | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/PosHistory/GetDailyReportBank/{FromDate}/{ToDate}?";
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined.");
        url_ = url_.replace("{fromDate}", encodeURIComponent("" + fromDate));
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent("" + toDate));
        if (banks !== undefined && banks !== null)
            banks && banks.forEach(item => { url_ += "banks=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosHistory_GetDailyReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosHistory_GetDailyReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPosHistory_GetDailyReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    posHistory_UpdateApplicationPUT(id: string, _Pos: ConfigurationViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/PosHistory/UpdateApplicationVersion/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_Pos);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosHistory_UpdateApplicationPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosHistory_UpdateApplicationPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPosHistory_UpdateApplicationPUT(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    posHistory_UpdateMerchantDetails(deploymentRequestId: string, pos: DeploymentRequestViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/PosHistory/UpdateMerchantDetails/{deploymentRequestId}";
        if (deploymentRequestId === undefined || deploymentRequestId === null)
            throw new Error("The parameter 'deploymentRequestId' must be defined.");
        url_ = url_.replace("{deploymentRequestId}", encodeURIComponent("" + deploymentRequestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pos);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosHistory_UpdateMerchantDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosHistory_UpdateMerchantDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPosHistory_UpdateMerchantDetails(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    posHistory_DeploymentRequestVerify(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/PosHistory/requestverify";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosHistory_DeploymentRequestVerify(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosHistory_DeploymentRequestVerify(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPosHistory_DeploymentRequestVerify(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    posHistory_DeploymentReconfigure(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/PosHistory/reconfigure";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosHistory_DeploymentReconfigure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosHistory_DeploymentReconfigure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPosHistory_DeploymentReconfigure(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    posHistory_DeploymentRequest(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/PosHistory/request";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosHistory_DeploymentRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosHistory_DeploymentRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPosHistory_DeploymentRequest(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    posHistory_Serial(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/PosHistory/serial";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosHistory_Serial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosHistory_Serial(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPosHistory_Serial(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IPosRecordService {
    posRecord_GetAllPOSHistories(fromDate: string, toDate: string): Observable<PosHistoryViewModel[]>;
    posRecord_GetRetrieve(page: number, pageSize: number): Observable<PosHistoryViewModel[]>;
    posRecord_Get(page: number, pageSize: number, deploymentRequestId: string): Observable<PosHistoryViewModel[]>;
    posRecord_GetPreviousApplicationVersion(deploymentRequestId: string): Observable<PosHistoryViewModel[]>;
    posRecord_GetSpares(page: number, pageSize: number): Observable<PosHistoryViewModel[]>;
    posRecord_GetReport(): Observable<FileResponse>;
    posRecord_GetReport1(): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class PosRecordService implements IPosRecordService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    posRecord_GetAllPOSHistories(fromDate: string, toDate: string): Observable<PosHistoryViewModel[]> {
        let url_ = this.baseUrl + "/api/PosRecord/allPosHistories/{fromDate}/{toDate}";
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined.");
        url_ = url_.replace("{fromDate}", encodeURIComponent("" + fromDate));
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent("" + toDate));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosRecord_GetAllPOSHistories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosRecord_GetAllPOSHistories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PosHistoryViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PosHistoryViewModel[]>;
        }));
    }

    protected processPosRecord_GetAllPOSHistories(response: HttpResponseBase): Observable<PosHistoryViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PosHistoryViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    posRecord_GetRetrieve(page: number, pageSize: number): Observable<PosHistoryViewModel[]> {
        let url_ = this.baseUrl + "/api/PosRecord/RetrievePagination/{page}/{pageSize}";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosRecord_GetRetrieve(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosRecord_GetRetrieve(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PosHistoryViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PosHistoryViewModel[]>;
        }));
    }

    protected processPosRecord_GetRetrieve(response: HttpResponseBase): Observable<PosHistoryViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PosHistoryViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    posRecord_Get(page: number, pageSize: number, deploymentRequestId: string): Observable<PosHistoryViewModel[]> {
        let url_ = this.baseUrl + "/api/PosRecord/individual/{page}/{pageSize}/{deploymentRequestId}";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        if (deploymentRequestId === undefined || deploymentRequestId === null)
            throw new Error("The parameter 'deploymentRequestId' must be defined.");
        url_ = url_.replace("{deploymentRequestId}", encodeURIComponent("" + deploymentRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosRecord_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosRecord_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PosHistoryViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PosHistoryViewModel[]>;
        }));
    }

    protected processPosRecord_Get(response: HttpResponseBase): Observable<PosHistoryViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PosHistoryViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    posRecord_GetPreviousApplicationVersion(deploymentRequestId: string): Observable<PosHistoryViewModel[]> {
        let url_ = this.baseUrl + "/api/PosRecord/getApplicationUpdateInfo/{deploymentRequestId}";
        if (deploymentRequestId === undefined || deploymentRequestId === null)
            throw new Error("The parameter 'deploymentRequestId' must be defined.");
        url_ = url_.replace("{deploymentRequestId}", encodeURIComponent("" + deploymentRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosRecord_GetPreviousApplicationVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosRecord_GetPreviousApplicationVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PosHistoryViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PosHistoryViewModel[]>;
        }));
    }

    protected processPosRecord_GetPreviousApplicationVersion(response: HttpResponseBase): Observable<PosHistoryViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PosHistoryViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    posRecord_GetSpares(page: number, pageSize: number): Observable<PosHistoryViewModel[]> {
        let url_ = this.baseUrl + "/api/PosRecord/posSpares/{page}/{pageSize}";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosRecord_GetSpares(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosRecord_GetSpares(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PosHistoryViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PosHistoryViewModel[]>;
        }));
    }

    protected processPosRecord_GetSpares(response: HttpResponseBase): Observable<PosHistoryViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PosHistoryViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    posRecord_GetReport(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/PosRecord/Retrieved";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosRecord_GetReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosRecord_GetReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPosRecord_GetReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    posRecord_GetReport1(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/PosRecord/Reconfigure";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosRecord_GetReport1(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosRecord_GetReport1(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPosRecord_GetReport1(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IPosStockService {
    posStock_Get(page: number, pageSize: number, id: string): Observable<PosStockViewModel[]>;
    posStock_GetSoldHistory(page: number, pageSize: number): Observable<PosStockViewModel[]>;
    posStock_GetposStockCount(page: number, pageSize: number): Observable<PosStockViewModel[]>;
    posStock_Post(id: string, isSale: boolean, _posStockVM: PosStockViewModel): Observable<FileResponse>;
    posStock_PostBulk(_bulkSaleCommand: BulkSaleCommand): Observable<FileResponse>;
    posStock_Put(id: string, _posStockVM: PosStockViewModel): Observable<FileResponse>;
    posStock_Delete(id: string): Observable<PosStockViewModel>;
}

@Injectable({
    providedIn: 'root'
})
export class PosStockService implements IPosStockService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    posStock_Get(page: number, pageSize: number, id: string): Observable<PosStockViewModel[]> {
        let url_ = this.baseUrl + "/api/PosStock/pagination/{page}/{pageSize}/{id}";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosStock_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosStock_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PosStockViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PosStockViewModel[]>;
        }));
    }

    protected processPosStock_Get(response: HttpResponseBase): Observable<PosStockViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PosStockViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    posStock_GetSoldHistory(page: number, pageSize: number): Observable<PosStockViewModel[]> {
        let url_ = this.baseUrl + "/api/PosStock/soldHistory/{page}/{pageSize}";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosStock_GetSoldHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosStock_GetSoldHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PosStockViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PosStockViewModel[]>;
        }));
    }

    protected processPosStock_GetSoldHistory(response: HttpResponseBase): Observable<PosStockViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PosStockViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    posStock_GetposStockCount(page: number, pageSize: number): Observable<PosStockViewModel[]> {
        let url_ = this.baseUrl + "/api/PosStock/countOnPosStock/{page}/{pageSize}";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosStock_GetposStockCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosStock_GetposStockCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PosStockViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PosStockViewModel[]>;
        }));
    }

    protected processPosStock_GetposStockCount(response: HttpResponseBase): Observable<PosStockViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PosStockViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    posStock_Post(id: string, isSale: boolean, _posStockVM: PosStockViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/PosStock/{id}/{isSale}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (isSale === undefined || isSale === null)
            throw new Error("The parameter 'isSale' must be defined.");
        url_ = url_.replace("{isSale}", encodeURIComponent("" + isSale));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_posStockVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosStock_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosStock_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPosStock_Post(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    posStock_PostBulk(_bulkSaleCommand: BulkSaleCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/PosStock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_bulkSaleCommand);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosStock_PostBulk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosStock_PostBulk(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPosStock_PostBulk(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    posStock_Put(id: string, _posStockVM: PosStockViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/PosStock/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_posStockVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosStock_Put(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosStock_Put(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPosStock_Put(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    posStock_Delete(id: string): Observable<PosStockViewModel> {
        let url_ = this.baseUrl + "/api/PosStock/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPosStock_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosStock_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PosStockViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PosStockViewModel>;
        }));
    }

    protected processPosStock_Delete(response: HttpResponseBase): Observable<PosStockViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PosStockViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IPrintReceiptService {
    printReceipt_Post(id: string, _printVm: PrintReceiptViewModel): Observable<FileResponse>;
    printReceipt_CreatePrintReceipt(command: CreatePrintReceiptCommand): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class PrintReceiptService implements IPrintReceiptService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    printReceipt_Post(id: string, _printVm: PrintReceiptViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/PrintReceipt/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_printVm);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrintReceipt_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrintReceipt_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPrintReceipt_Post(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    printReceipt_CreatePrintReceipt(command: CreatePrintReceiptCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/PrintReceipt/createPrintReceipt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrintReceipt_CreatePrintReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrintReceipt_CreatePrintReceipt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPrintReceipt_CreatePrintReceipt(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IRequestTypeService {
    requestType_Get(page: number, pageSize: number): Observable<RequestTypeViewModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class RequestTypeService implements IRequestTypeService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    requestType_Get(page: number, pageSize: number): Observable<RequestTypeViewModel[]> {
        let url_ = this.baseUrl + "/api/RequestType/pagination/{page}/{pageSize}";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestType_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestType_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequestTypeViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequestTypeViewModel[]>;
        }));
    }

    protected processRequestType_Get(response: HttpResponseBase): Observable<RequestTypeViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RequestTypeViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISerialNumberService {
    serialNumber_Get(id: string, config: string): Observable<SerialNumberViewModel[]>;
    serialNumber_GetConfigureSerialNumber(deploymentRequestId: string | undefined, inventoryId: string | null | undefined): Observable<SerialNumberConfigurationViewModel[]>;
    serialNumber_GetConfigureSerialNumberForBothStatus(deploymentRequestId: string | undefined, inventoryId: string | undefined, rentalType: string | null | undefined): Observable<SerialNumberConfigurationViewModel[]>;
    serialNumber_GetConfigureSerialNumber2(deploymentRequestId: string, inventoryId: string): Observable<SerialNumberConfigurationViewModel[]>;
    serialNumber_GetPosStockListById(id: string): Observable<SerialNumberViewModel[]>;
    serialNumber_GetSerialStock(id: string): Observable<SerialNumberViewModel[]>;
    serialNumber_Put(id: string, _serialVM: SerialNumberViewModel): Observable<FileResponse>;
    serialNumber_Delete(id: string): Observable<void>;
    serialNumber_Get2(page: number, pageSize: number, id: string): Observable<SerialNumberViewModel[]>;
    serialNumber_GetAllSerials(page: number, pageSize: number): Observable<SerialNumberViewModel[]>;
    serialNumber_GetAllSerialNumbers(): Observable<AllSerialNumberListVm[]>;
    serialNumber_Post(serialNumberVM: SerialNumberViewModel): Observable<FileResponse>;
    serialNumber_SingleEntrySerialNumber(command: SerialNumberEntryCommand): Observable<FileResponse>;
    serialNumber_BulkUploadSerialNumber(command: BulkSerialEntryCommand): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class SerialNumberService implements ISerialNumberService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    serialNumber_Get(id: string, config: string): Observable<SerialNumberViewModel[]> {
        let url_ = this.baseUrl + "/api/SerialNumber/{id}/{config}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (config === undefined || config === null)
            throw new Error("The parameter 'config' must be defined.");
        url_ = url_.replace("{config}", encodeURIComponent("" + config));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSerialNumber_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSerialNumber_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SerialNumberViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SerialNumberViewModel[]>;
        }));
    }

    protected processSerialNumber_Get(response: HttpResponseBase): Observable<SerialNumberViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SerialNumberViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    serialNumber_GetConfigureSerialNumber(deploymentRequestId: string | undefined, inventoryId: string | null | undefined): Observable<SerialNumberConfigurationViewModel[]> {
        let url_ = this.baseUrl + "/api/SerialNumber/config?";
        if (deploymentRequestId === null)
            throw new Error("The parameter 'deploymentRequestId' cannot be null.");
        else if (deploymentRequestId !== undefined)
            url_ += "deploymentRequestId=" + encodeURIComponent("" + deploymentRequestId) + "&";
        if (inventoryId !== undefined && inventoryId !== null)
            url_ += "inventoryId=" + encodeURIComponent("" + inventoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSerialNumber_GetConfigureSerialNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSerialNumber_GetConfigureSerialNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SerialNumberConfigurationViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SerialNumberConfigurationViewModel[]>;
        }));
    }

    protected processSerialNumber_GetConfigureSerialNumber(response: HttpResponseBase): Observable<SerialNumberConfigurationViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SerialNumberConfigurationViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    serialNumber_GetConfigureSerialNumberForBothStatus(deploymentRequestId: string | undefined, inventoryId: string | undefined, rentalType: string | null | undefined): Observable<SerialNumberConfigurationViewModel[]> {
        let url_ = this.baseUrl + "/api/SerialNumber/configForBoth?";
        if (deploymentRequestId === null)
            throw new Error("The parameter 'deploymentRequestId' cannot be null.");
        else if (deploymentRequestId !== undefined)
            url_ += "deploymentRequestId=" + encodeURIComponent("" + deploymentRequestId) + "&";
        if (inventoryId === null)
            throw new Error("The parameter 'inventoryId' cannot be null.");
        else if (inventoryId !== undefined)
            url_ += "inventoryId=" + encodeURIComponent("" + inventoryId) + "&";
        if (rentalType !== undefined && rentalType !== null)
            url_ += "rentalType=" + encodeURIComponent("" + rentalType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSerialNumber_GetConfigureSerialNumberForBothStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSerialNumber_GetConfigureSerialNumberForBothStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SerialNumberConfigurationViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SerialNumberConfigurationViewModel[]>;
        }));
    }

    protected processSerialNumber_GetConfigureSerialNumberForBothStatus(response: HttpResponseBase): Observable<SerialNumberConfigurationViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SerialNumberConfigurationViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    serialNumber_GetConfigureSerialNumber2(deploymentRequestId: string, inventoryId: string): Observable<SerialNumberConfigurationViewModel[]> {
        let url_ = this.baseUrl + "/api/SerialNumber/serialNumberConfiguration/{deploymentRequestId}/{inventoryId}";
        if (deploymentRequestId === undefined || deploymentRequestId === null)
            throw new Error("The parameter 'deploymentRequestId' must be defined.");
        url_ = url_.replace("{deploymentRequestId}", encodeURIComponent("" + deploymentRequestId));
        if (inventoryId === undefined || inventoryId === null)
            throw new Error("The parameter 'inventoryId' must be defined.");
        url_ = url_.replace("{inventoryId}", encodeURIComponent("" + inventoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSerialNumber_GetConfigureSerialNumber2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSerialNumber_GetConfigureSerialNumber2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SerialNumberConfigurationViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SerialNumberConfigurationViewModel[]>;
        }));
    }

    protected processSerialNumber_GetConfigureSerialNumber2(response: HttpResponseBase): Observable<SerialNumberConfigurationViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SerialNumberConfigurationViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    serialNumber_GetPosStockListById(id: string): Observable<SerialNumberViewModel[]> {
        let url_ = this.baseUrl + "/api/SerialNumber/posStock/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSerialNumber_GetPosStockListById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSerialNumber_GetPosStockListById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SerialNumberViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SerialNumberViewModel[]>;
        }));
    }

    protected processSerialNumber_GetPosStockListById(response: HttpResponseBase): Observable<SerialNumberViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SerialNumberViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    serialNumber_GetSerialStock(id: string): Observable<SerialNumberViewModel[]> {
        let url_ = this.baseUrl + "/api/SerialNumber/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSerialNumber_GetSerialStock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSerialNumber_GetSerialStock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SerialNumberViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SerialNumberViewModel[]>;
        }));
    }

    protected processSerialNumber_GetSerialStock(response: HttpResponseBase): Observable<SerialNumberViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SerialNumberViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    serialNumber_Put(id: string, _serialVM: SerialNumberViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/SerialNumber/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_serialVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSerialNumber_Put(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSerialNumber_Put(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSerialNumber_Put(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    serialNumber_Delete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/SerialNumber/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSerialNumber_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSerialNumber_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSerialNumber_Delete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    serialNumber_Get2(page: number, pageSize: number, id: string): Observable<SerialNumberViewModel[]> {
        let url_ = this.baseUrl + "/api/SerialNumber/pagination/{page}/{pageSize}/{id}";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSerialNumber_Get2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSerialNumber_Get2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SerialNumberViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SerialNumberViewModel[]>;
        }));
    }

    protected processSerialNumber_Get2(response: HttpResponseBase): Observable<SerialNumberViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SerialNumberViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    serialNumber_GetAllSerials(page: number, pageSize: number): Observable<SerialNumberViewModel[]> {
        let url_ = this.baseUrl + "/api/SerialNumber/paginationAllSerials/{page}/{pageSize}";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSerialNumber_GetAllSerials(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSerialNumber_GetAllSerials(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SerialNumberViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SerialNumberViewModel[]>;
        }));
    }

    protected processSerialNumber_GetAllSerials(response: HttpResponseBase): Observable<SerialNumberViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SerialNumberViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    serialNumber_GetAllSerialNumbers(): Observable<AllSerialNumberListVm[]> {
        let url_ = this.baseUrl + "/api/serialNumbers/all-serial-numbers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSerialNumber_GetAllSerialNumbers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSerialNumber_GetAllSerialNumbers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllSerialNumberListVm[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllSerialNumberListVm[]>;
        }));
    }

    protected processSerialNumber_GetAllSerialNumbers(response: HttpResponseBase): Observable<AllSerialNumberListVm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AllSerialNumberListVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    serialNumber_Post(serialNumberVM: SerialNumberViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/SerialNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(serialNumberVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSerialNumber_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSerialNumber_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSerialNumber_Post(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    serialNumber_SingleEntrySerialNumber(command: SerialNumberEntryCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/SerialNumber/api/singleEntry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSerialNumber_SingleEntrySerialNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSerialNumber_SingleEntrySerialNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSerialNumber_SingleEntrySerialNumber(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    serialNumber_BulkUploadSerialNumber(command: BulkSerialEntryCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/SerialNumber/api/bulkEntry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSerialNumber_BulkUploadSerialNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSerialNumber_BulkUploadSerialNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSerialNumber_BulkUploadSerialNumber(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISparesRequestService {
    sparesRequest_Get(): Observable<SparesRequestViewModel[]>;
    sparesRequest_GetAllSpareRequests(): Observable<GetAllSpareRequestQuery[]>;
    sparesRequest_GetSpareRequestByDepReqId(depReqId: string): Observable<FileResponse>;
    sparesRequest_GetPendingSpareRequestForMerchant(): Observable<PendingSpareRequestViewModel[]>;
    sparesRequest_Post(_sparesRequestVM: SparesRequestViewModel): Observable<FileResponse>;
    sparesRequest_AccessoriesDispatch(id: string, _sparesRequestVM: AccessoriesDispatchViewModel): Observable<FileResponse>;
    sparesRequest_Put(id: string, _sparesRequestVM: SparesRequestViewModel): Observable<FileResponse>;
    sparesRequest_CancelAccessoryToBank(id: string, command: CancelSpareRequestCommand): Observable<FileResponse>;
    sparesRequest_DeliverAccessoryToBank(id: string, command: CreateSpareSalesFromSpareRequestCommand): Observable<FileResponse>;
    sparesRequest_DeleteSparesRequest(id: string): Observable<FileResponse>;
    sparesRequest_Delete(id: string): Observable<SparesRequestViewModel>;
    sparesRequest_MerchantSpareRequest(command: CreateMerchantSpareRequestCommand): Observable<FileResponse>;
    sparesRequest_GetSpareRequestByDepReqIdAll(imarkTerminalId: string | null | undefined, fromDate: string | null | undefined, toDate: string | null | undefined): Observable<MerchantSpareRequestListVM[]>;
}

@Injectable({
    providedIn: 'root'
})
export class SparesRequestService implements ISparesRequestService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    sparesRequest_Get(): Observable<SparesRequestViewModel[]> {
        let url_ = this.baseUrl + "/api/SparesRequest/allSpareRequests";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSparesRequest_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSparesRequest_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SparesRequestViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SparesRequestViewModel[]>;
        }));
    }

    protected processSparesRequest_Get(response: HttpResponseBase): Observable<SparesRequestViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SparesRequestViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sparesRequest_GetAllSpareRequests(): Observable<GetAllSpareRequestQuery[]> {
        let url_ = this.baseUrl + "/api/spareRequests/getAllRequests";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSparesRequest_GetAllSpareRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSparesRequest_GetAllSpareRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllSpareRequestQuery[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllSpareRequestQuery[]>;
        }));
    }

    protected processSparesRequest_GetAllSpareRequests(response: HttpResponseBase): Observable<GetAllSpareRequestQuery[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAllSpareRequestQuery.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sparesRequest_GetSpareRequestByDepReqId(depReqId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/SparesRequest/allSpareRequestsByDeploymentReqId/{depReqId}";
        if (depReqId === undefined || depReqId === null)
            throw new Error("The parameter 'depReqId' must be defined.");
        url_ = url_.replace("{depReqId}", encodeURIComponent("" + depReqId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSparesRequest_GetSpareRequestByDepReqId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSparesRequest_GetSpareRequestByDepReqId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSparesRequest_GetSpareRequestByDepReqId(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sparesRequest_GetPendingSpareRequestForMerchant(): Observable<PendingSpareRequestViewModel[]> {
        let url_ = this.baseUrl + "/api/SparesRequest/pendingSpareRequest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSparesRequest_GetPendingSpareRequestForMerchant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSparesRequest_GetPendingSpareRequestForMerchant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendingSpareRequestViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendingSpareRequestViewModel[]>;
        }));
    }

    protected processSparesRequest_GetPendingSpareRequestForMerchant(response: HttpResponseBase): Observable<PendingSpareRequestViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PendingSpareRequestViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sparesRequest_Post(_sparesRequestVM: SparesRequestViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/SparesRequest/registerSpareRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_sparesRequestVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSparesRequest_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSparesRequest_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSparesRequest_Post(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sparesRequest_AccessoriesDispatch(id: string, _sparesRequestVM: AccessoriesDispatchViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/SparesRequest/AccessoriesDispatch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_sparesRequestVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSparesRequest_AccessoriesDispatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSparesRequest_AccessoriesDispatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSparesRequest_AccessoriesDispatch(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sparesRequest_Put(id: string, _sparesRequestVM: SparesRequestViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/SparesRequest/UpdateSpareRequests/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_sparesRequestVM);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSparesRequest_Put(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSparesRequest_Put(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSparesRequest_Put(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sparesRequest_CancelAccessoryToBank(id: string, command: CancelSpareRequestCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/spareSales/{id}/cancelAccessoryToBank";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSparesRequest_CancelAccessoryToBank(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSparesRequest_CancelAccessoryToBank(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSparesRequest_CancelAccessoryToBank(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sparesRequest_DeliverAccessoryToBank(id: string, command: CreateSpareSalesFromSpareRequestCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/spareSales/{id}/deliverAccessoryToBank";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSparesRequest_DeliverAccessoryToBank(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSparesRequest_DeliverAccessoryToBank(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSparesRequest_DeliverAccessoryToBank(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sparesRequest_DeleteSparesRequest(id: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/spareRequests/{id}/deleteSparesRequest";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSparesRequest_DeleteSparesRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSparesRequest_DeleteSparesRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSparesRequest_DeleteSparesRequest(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sparesRequest_Delete(id: string): Observable<SparesRequestViewModel> {
        let url_ = this.baseUrl + "/api/SparesRequest/deleteSpareRequest/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSparesRequest_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSparesRequest_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SparesRequestViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SparesRequestViewModel>;
        }));
    }

    protected processSparesRequest_Delete(response: HttpResponseBase): Observable<SparesRequestViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SparesRequestViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sparesRequest_MerchantSpareRequest(command: CreateMerchantSpareRequestCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/merchantSpareRequests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSparesRequest_MerchantSpareRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSparesRequest_MerchantSpareRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSparesRequest_MerchantSpareRequest(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sparesRequest_GetSpareRequestByDepReqIdAll(imarkTerminalId: string | null | undefined, fromDate: string | null | undefined, toDate: string | null | undefined): Observable<MerchantSpareRequestListVM[]> {
        let url_ = this.baseUrl + "/api/merchantSpareRequestList?";
        if (imarkTerminalId !== undefined && imarkTerminalId !== null)
            url_ += "imarkTerminalId=" + encodeURIComponent("" + imarkTerminalId) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSparesRequest_GetSpareRequestByDepReqIdAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSparesRequest_GetSpareRequestByDepReqIdAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MerchantSpareRequestListVM[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MerchantSpareRequestListVM[]>;
        }));
    }

    protected processSparesRequest_GetSpareRequestByDepReqIdAll(response: HttpResponseBase): Observable<MerchantSpareRequestListVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MerchantSpareRequestListVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISparesSalesService {
    sparesSales_Get(id: string): Observable<FileResponse>;
    sparesSales_Post(id: string, _sparesSalesVm: SparesSales): Observable<FileResponse>;
    sparesSales_Put(id: string, _sparesSalesVm: SparesSalesViewModel): Observable<FileResponse>;
    sparesSales_Delete(id: string): Observable<SparesSalesViewModel>;
    sparesSales_GetSparesSalesData(page: number, pageSize: number, id: string): Observable<SparesSalesViewModel[]>;
    sparesSales_GetSpareSalesHistory(accessoryId: string): Observable<GetSparesHistoryQuery[]>;
    sparesSales_CreateSpareSales(accessoryId: string, command: CreateSpareSalesCommand): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class SparesSalesService implements ISparesSalesService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    sparesSales_Get(id: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/SparesSales/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSparesSales_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSparesSales_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSparesSales_Get(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sparesSales_Post(id: string, _sparesSalesVm: SparesSales): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/SparesSales/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_sparesSalesVm);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSparesSales_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSparesSales_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSparesSales_Post(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sparesSales_Put(id: string, _sparesSalesVm: SparesSalesViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/SparesSales/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(_sparesSalesVm);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSparesSales_Put(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSparesSales_Put(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSparesSales_Put(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sparesSales_Delete(id: string): Observable<SparesSalesViewModel> {
        let url_ = this.baseUrl + "/api/SparesSales/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSparesSales_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSparesSales_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SparesSalesViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SparesSalesViewModel>;
        }));
    }

    protected processSparesSales_Delete(response: HttpResponseBase): Observable<SparesSalesViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SparesSalesViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sparesSales_GetSparesSalesData(page: number, pageSize: number, id: string): Observable<SparesSalesViewModel[]> {
        let url_ = this.baseUrl + "/api/SparesSales/pagination/{page}/{pageSize}/{id}";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSparesSales_GetSparesSalesData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSparesSales_GetSparesSalesData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SparesSalesViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SparesSalesViewModel[]>;
        }));
    }

    protected processSparesSales_GetSparesSalesData(response: HttpResponseBase): Observable<SparesSalesViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SparesSalesViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sparesSales_GetSpareSalesHistory(accessoryId: string): Observable<GetSparesHistoryQuery[]> {
        let url_ = this.baseUrl + "/api/spareSales/{accessoryId}/getSpareSalesHistory";
        if (accessoryId === undefined || accessoryId === null)
            throw new Error("The parameter 'accessoryId' must be defined.");
        url_ = url_.replace("{accessoryId}", encodeURIComponent("" + accessoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSparesSales_GetSpareSalesHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSparesSales_GetSpareSalesHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSparesHistoryQuery[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSparesHistoryQuery[]>;
        }));
    }

    protected processSparesSales_GetSpareSalesHistory(response: HttpResponseBase): Observable<GetSparesHistoryQuery[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetSparesHistoryQuery.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sparesSales_CreateSpareSales(accessoryId: string, command: CreateSpareSalesCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/spareSales/{accessoryId}/sendToBank";
        if (accessoryId === undefined || accessoryId === null)
            throw new Error("The parameter 'accessoryId' must be defined.");
        url_ = url_.replace("{accessoryId}", encodeURIComponent("" + accessoryId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSparesSales_CreateSpareSales(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSparesSales_CreateSpareSales(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSparesSales_CreateSpareSales(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IStatusService {
    status_Get(page: number, pageSize: number): Observable<StatusViewModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class StatusService implements IStatusService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    status_Get(page: number, pageSize: number): Observable<StatusViewModel[]> {
        let url_ = this.baseUrl + "/api/Status/pagination/{page}/{pageSize}";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatus_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatus_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusViewModel[]>;
        }));
    }

    protected processStatus_Get(response: HttpResponseBase): Observable<StatusViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StatusViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISupportService {
    support_GetPendingSupport(page: number, pageSize: number, deploymentRequestId: string): Observable<SupportViewModel[]>;
    support_GetAllPendingSupport(): Observable<GetAllPendingSupportVm[]>;
    support_UnresolvedSupportExistenceCheck(deploymentRequestId: string | null | undefined): Observable<boolean>;
    support_GetProvidedSupport(fromDate: string | null | undefined, toDate: string | null | undefined): Observable<SupportViewModel[]>;
    support_GetPendingSupport2(): Observable<SupportViewModel[]>;
    support_SupportRequestDetailsFormData(deploymentRequestId: string): Observable<SupportRequestDetailsFormData>;
    support_Get(id: string): Observable<FileResponse>;
    support_GetSupportByDeploymentRequestId(id: string): Observable<FileResponse>;
    support_Post(supportVm: SupportViewModel): Observable<FileResponse>;
    support_Put(id: string, command: UpdateSupportCommand): Observable<FileResponse>;
    support_Delete(id: string): Observable<void>;
    support_CreateSupport(command: CreateSupportCommand): Observable<FileResponse>;
    support_CreateMerchantSupport(command: CreateMerchantSupportCommand): Observable<FileResponse>;
    support_GetMerchantSupport(imarkTerminalId: string | null | undefined, fromDate: string | null | undefined, toDate: string | null | undefined): Observable<MerchantSupportListVM[]>;
    support_GetMerchantSupportByIMId(imarkMerchantId: string, fromDate: string | null | undefined, toDate: string | null | undefined): Observable<MerchantwiseSupportList>;
}

@Injectable({
    providedIn: 'root'
})
export class SupportService implements ISupportService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    support_GetPendingSupport(page: number, pageSize: number, deploymentRequestId: string): Observable<SupportViewModel[]> {
        let url_ = this.baseUrl + "/api/Support/pagination/{page}/{pageSize}/{deploymentRequestId}";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        if (deploymentRequestId === undefined || deploymentRequestId === null)
            throw new Error("The parameter 'deploymentRequestId' must be defined.");
        url_ = url_.replace("{deploymentRequestId}", encodeURIComponent("" + deploymentRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupport_GetPendingSupport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupport_GetPendingSupport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupportViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupportViewModel[]>;
        }));
    }

    protected processSupport_GetPendingSupport(response: HttpResponseBase): Observable<SupportViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SupportViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    support_GetAllPendingSupport(): Observable<GetAllPendingSupportVm[]> {
        let url_ = this.baseUrl + "/api/supports/get-all-pending-support";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupport_GetAllPendingSupport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupport_GetAllPendingSupport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllPendingSupportVm[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllPendingSupportVm[]>;
        }));
    }

    protected processSupport_GetAllPendingSupport(response: HttpResponseBase): Observable<GetAllPendingSupportVm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAllPendingSupportVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    support_UnresolvedSupportExistenceCheck(deploymentRequestId: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/supportAvailabliltyCheck/deploymentRequestId?";
        if (deploymentRequestId !== undefined && deploymentRequestId !== null)
            url_ += "deploymentRequestId=" + encodeURIComponent("" + deploymentRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupport_UnresolvedSupportExistenceCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupport_UnresolvedSupportExistenceCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSupport_UnresolvedSupportExistenceCheck(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    support_GetProvidedSupport(fromDate: string | null | undefined, toDate: string | null | undefined): Observable<SupportViewModel[]> {
        let url_ = this.baseUrl + "/api/Support/SupportProvidedList?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupport_GetProvidedSupport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupport_GetProvidedSupport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupportViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupportViewModel[]>;
        }));
    }

    protected processSupport_GetProvidedSupport(response: HttpResponseBase): Observable<SupportViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SupportViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    support_GetPendingSupport2(): Observable<SupportViewModel[]> {
        let url_ = this.baseUrl + "/api/Support/pendingSupport";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupport_GetPendingSupport2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupport_GetPendingSupport2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupportViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupportViewModel[]>;
        }));
    }

    protected processSupport_GetPendingSupport2(response: HttpResponseBase): Observable<SupportViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SupportViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    support_SupportRequestDetailsFormData(deploymentRequestId: string): Observable<SupportRequestDetailsFormData> {
        let url_ = this.baseUrl + "/api/Support/SupportRequestDetailsFormData/{deploymentRequestId}";
        if (deploymentRequestId === undefined || deploymentRequestId === null)
            throw new Error("The parameter 'deploymentRequestId' must be defined.");
        url_ = url_.replace("{deploymentRequestId}", encodeURIComponent("" + deploymentRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupport_SupportRequestDetailsFormData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupport_SupportRequestDetailsFormData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupportRequestDetailsFormData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupportRequestDetailsFormData>;
        }));
    }

    protected processSupport_SupportRequestDetailsFormData(response: HttpResponseBase): Observable<SupportRequestDetailsFormData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupportRequestDetailsFormData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    support_Get(id: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Support/PendingSupportBySupportId/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupport_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupport_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSupport_Get(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    support_GetSupportByDeploymentRequestId(id: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Support/support/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupport_GetSupportByDeploymentRequestId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupport_GetSupportByDeploymentRequestId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSupport_GetSupportByDeploymentRequestId(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    support_Post(supportVm: SupportViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Support";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(supportVm);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupport_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupport_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSupport_Post(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    support_Put(id: string, command: UpdateSupportCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Support/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupport_Put(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupport_Put(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSupport_Put(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    support_Delete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Support/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupport_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupport_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSupport_Delete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    support_CreateSupport(command: CreateSupportCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Support/CreateSupport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupport_CreateSupport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupport_CreateSupport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSupport_CreateSupport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    support_CreateMerchantSupport(command: CreateMerchantSupportCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/createMerchantSupport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupport_CreateMerchantSupport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupport_CreateMerchantSupport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSupport_CreateMerchantSupport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    support_GetMerchantSupport(imarkTerminalId: string | null | undefined, fromDate: string | null | undefined, toDate: string | null | undefined): Observable<MerchantSupportListVM[]> {
        let url_ = this.baseUrl + "/api/getMerchantSupport?";
        if (imarkTerminalId !== undefined && imarkTerminalId !== null)
            url_ += "imarkTerminalId=" + encodeURIComponent("" + imarkTerminalId) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupport_GetMerchantSupport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupport_GetMerchantSupport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MerchantSupportListVM[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MerchantSupportListVM[]>;
        }));
    }

    protected processSupport_GetMerchantSupport(response: HttpResponseBase): Observable<MerchantSupportListVM[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MerchantSupportListVM.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    support_GetMerchantSupportByIMId(imarkMerchantId: string, fromDate: string | null | undefined, toDate: string | null | undefined): Observable<MerchantwiseSupportList> {
        let url_ = this.baseUrl + "/api/getMerchantSupport/{ImarkMerchantId}?";
        if (imarkMerchantId === undefined || imarkMerchantId === null)
            throw new Error("The parameter 'imarkMerchantId' must be defined.");
        url_ = url_.replace("{ImarkMerchantId}", encodeURIComponent("" + imarkMerchantId));
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupport_GetMerchantSupportByIMId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupport_GetMerchantSupportByIMId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MerchantwiseSupportList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MerchantwiseSupportList>;
        }));
    }

    protected processSupport_GetMerchantSupportByIMId(response: HttpResponseBase): Observable<MerchantwiseSupportList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MerchantwiseSupportList.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISupportToMerchantService {
    /**
     * @param terminalId (optional) 
     * @param location (optional) 
     * @param ticketNumber (optional) 
     * @param merchantName (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @return Get all the pending support requests.
     */
    supportToMerchant_GetSupports(terminalId: string | null | undefined, location: string | null | undefined, ticketNumber: string | null | undefined, merchantName: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<PaginatedListOfMerchantSupportsVm>;
    /**
     * @return Get a Merchant detail.
     */
    supportToMerchant_GetMerchantDetails(id: string): Observable<MerchantDetailsVm>;
    /**
     * @return Resolve a New Request.
     */
    supportToMerchant_SupportResolve(id: string, supportResolvedDto: SupportResolvedVm): Observable<SupportResolvedVm>;
    /**
     * @return Get a current location.
     */
    supportToMerchant_GetCurrentLocation(deploymentid: string): Observable<LocationVm>;
    /**
     * @return Get a pending deployment location.
     */
    supportToMerchant_GetPendingDeploymentLocaation(deploymentRequestId: string): Observable<DeploymentPendingVm>;
    /**
     * @return Update a Merchant detail.
     */
    supportToMerchant_UpdateMerchant(merchantUpdate: UpdateMerchantVm): Observable<UpdateMerchantVm>;
    /**
     * @param terminalId (optional) 
     * @param merchantName (optional) 
     * @param serialNo (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @return Get all the deployed terminals.
     */
    supportToMerchant_GetTerminalsByParameters(terminalId: string | null | undefined, merchantName: string | null | undefined, serialNo: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<TerminalVm>;
    /**
     * @return Update the location.
     */
    supportToMerchant_UpdateLocation(deploymentid: string, model: LocationVm): Observable<LocationVm>;
    /**
     * @return Move a New Request to Pending.
     */
    supportToMerchant_MoveToPending(id: string, supportpendingDto: SupportPendingVm): Observable<SupportPendingVm>;
    /**
     * @return Close Support Request.
     */
    supportToMerchant_closeSupport(id: string, supportCloseCommand: SupportCloseCommand): Observable<SupportCloseCommand>;
    /**
     * @param terminalId (optional) 
     * @param merchantName (optional) 
     * @param serialNo (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Get all Pending Deployments.
     */
    supportToMerchant_GetPendingDeployment(terminalId: string | null | undefined, merchantName: string | null | undefined, serialNo: string | null | undefined, page: number | undefined, pageSize: number | undefined): Observable<ISupportPendingDeploymentViewModel>;
    /**
     * @return Get all the deployed terminals.
     */
    supportToMerchant_ISupportDeployment(deploymentRequestId: string, command: CreateISupportDeploymentCommand): Observable<CreateISupportDeploymentCommand>;
    /**
     * @return Get the list of Pending Reasons.
     */
    supportToMerchant_ReasonsToMove(): Observable<SupportPendingReason>;
    supportToMerchant_GetSupportIssueTypesForSupportApp(): Observable<FileResponse>;
    supportToMerchant_RetreiveTerminalForMerchant(id: string | undefined, command: RetrieveTerminalCommand): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class SupportToMerchantService implements ISupportToMerchantService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param terminalId (optional) 
     * @param location (optional) 
     * @param ticketNumber (optional) 
     * @param merchantName (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @return Get all the pending support requests.
     */
    supportToMerchant_GetSupports(terminalId: string | null | undefined, location: string | null | undefined, ticketNumber: string | null | undefined, merchantName: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<PaginatedListOfMerchantSupportsVm> {
        let url_ = this.baseUrl + "/api/supports?";
        if (terminalId !== undefined && terminalId !== null)
            url_ += "terminalId=" + encodeURIComponent("" + terminalId) + "&";
        if (location !== undefined && location !== null)
            url_ += "location=" + encodeURIComponent("" + location) + "&";
        if (ticketNumber !== undefined && ticketNumber !== null)
            url_ += "ticketNumber=" + encodeURIComponent("" + ticketNumber) + "&";
        if (merchantName !== undefined && merchantName !== null)
            url_ += "merchantName=" + encodeURIComponent("" + merchantName) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupportToMerchant_GetSupports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupportToMerchant_GetSupports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedListOfMerchantSupportsVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedListOfMerchantSupportsVm>;
        }));
    }

    protected processSupportToMerchant_GetSupports(response: HttpResponseBase): Observable<PaginatedListOfMerchantSupportsVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfMerchantSupportsVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Get a Merchant detail.
     */
    supportToMerchant_GetMerchantDetails(id: string): Observable<MerchantDetailsVm> {
        let url_ = this.baseUrl + "/api/supports/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupportToMerchant_GetMerchantDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupportToMerchant_GetMerchantDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MerchantDetailsVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MerchantDetailsVm>;
        }));
    }

    protected processSupportToMerchant_GetMerchantDetails(response: HttpResponseBase): Observable<MerchantDetailsVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MerchantDetailsVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Resolve a New Request.
     */
    supportToMerchant_SupportResolve(id: string, supportResolvedDto: SupportResolvedVm): Observable<SupportResolvedVm> {
        let url_ = this.baseUrl + "/api/supports/{id}/resolve";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(supportResolvedDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupportToMerchant_SupportResolve(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupportToMerchant_SupportResolve(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupportResolvedVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupportResolvedVm>;
        }));
    }

    protected processSupportToMerchant_SupportResolve(response: HttpResponseBase): Observable<SupportResolvedVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData422) {
                result422 = {} as any;
                for (let key in resultData422) {
                    if (resultData422.hasOwnProperty(key))
                        (<any>result422)![key] = resultData422[key] ? resultData422[key].map((i: any) => CustomizedValidationError.fromJS(i)) : [];
                }
            }
            else {
                result422 = <any>null;
            }
            return throwException("Response on Validation Errors.", status, _responseText, _headers, result422);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupportResolvedVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Get a current location.
     */
    supportToMerchant_GetCurrentLocation(deploymentid: string): Observable<LocationVm> {
        let url_ = this.baseUrl + "/api/supports/{deploymentid}/location";
        if (deploymentid === undefined || deploymentid === null)
            throw new Error("The parameter 'deploymentid' must be defined.");
        url_ = url_.replace("{deploymentid}", encodeURIComponent("" + deploymentid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupportToMerchant_GetCurrentLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupportToMerchant_GetCurrentLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationVm>;
        }));
    }

    protected processSupportToMerchant_GetCurrentLocation(response: HttpResponseBase): Observable<LocationVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Get a pending deployment location.
     */
    supportToMerchant_GetPendingDeploymentLocaation(deploymentRequestId: string): Observable<DeploymentPendingVm> {
        let url_ = this.baseUrl + "/api/pendingDeployment/{deploymentRequestId}/location";
        if (deploymentRequestId === undefined || deploymentRequestId === null)
            throw new Error("The parameter 'deploymentRequestId' must be defined.");
        url_ = url_.replace("{deploymentRequestId}", encodeURIComponent("" + deploymentRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupportToMerchant_GetPendingDeploymentLocaation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupportToMerchant_GetPendingDeploymentLocaation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeploymentPendingVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeploymentPendingVm>;
        }));
    }

    protected processSupportToMerchant_GetPendingDeploymentLocaation(response: HttpResponseBase): Observable<DeploymentPendingVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeploymentPendingVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Update a Merchant detail.
     */
    supportToMerchant_UpdateMerchant(merchantUpdate: UpdateMerchantVm): Observable<UpdateMerchantVm> {
        let url_ = this.baseUrl + "/api/supports/update-merchant-details";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(merchantUpdate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupportToMerchant_UpdateMerchant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupportToMerchant_UpdateMerchant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateMerchantVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateMerchantVm>;
        }));
    }

    protected processSupportToMerchant_UpdateMerchant(response: HttpResponseBase): Observable<UpdateMerchantVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateMerchantVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData422) {
                result422 = {} as any;
                for (let key in resultData422) {
                    if (resultData422.hasOwnProperty(key))
                        (<any>result422)![key] = resultData422[key] ? resultData422[key].map((i: any) => CustomizedValidationError.fromJS(i)) : [];
                }
            }
            else {
                result422 = <any>null;
            }
            return throwException("Response on Validation Errors.", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param terminalId (optional) 
     * @param merchantName (optional) 
     * @param serialNo (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @return Get all the deployed terminals.
     */
    supportToMerchant_GetTerminalsByParameters(terminalId: string | null | undefined, merchantName: string | null | undefined, serialNo: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<TerminalVm> {
        let url_ = this.baseUrl + "/api/supports/terminals?";
        if (terminalId !== undefined && terminalId !== null)
            url_ += "terminalId=" + encodeURIComponent("" + terminalId) + "&";
        if (merchantName !== undefined && merchantName !== null)
            url_ += "merchantName=" + encodeURIComponent("" + merchantName) + "&";
        if (serialNo !== undefined && serialNo !== null)
            url_ += "serialNo=" + encodeURIComponent("" + serialNo) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupportToMerchant_GetTerminalsByParameters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupportToMerchant_GetTerminalsByParameters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TerminalVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TerminalVm>;
        }));
    }

    protected processSupportToMerchant_GetTerminalsByParameters(response: HttpResponseBase): Observable<TerminalVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TerminalVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Update the location.
     */
    supportToMerchant_UpdateLocation(deploymentid: string, model: LocationVm): Observable<LocationVm> {
        let url_ = this.baseUrl + "/api/supports/terminals/{deploymentid}/update-location";
        if (deploymentid === undefined || deploymentid === null)
            throw new Error("The parameter 'deploymentid' must be defined.");
        url_ = url_.replace("{deploymentid}", encodeURIComponent("" + deploymentid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupportToMerchant_UpdateLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupportToMerchant_UpdateLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationVm>;
        }));
    }

    protected processSupportToMerchant_UpdateLocation(response: HttpResponseBase): Observable<LocationVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Move a New Request to Pending.
     */
    supportToMerchant_MoveToPending(id: string, supportpendingDto: SupportPendingVm): Observable<SupportPendingVm> {
        let url_ = this.baseUrl + "/api/supports/{id}/move-to-pending";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(supportpendingDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupportToMerchant_MoveToPending(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupportToMerchant_MoveToPending(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupportPendingVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupportPendingVm>;
        }));
    }

    protected processSupportToMerchant_MoveToPending(response: HttpResponseBase): Observable<SupportPendingVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupportPendingVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Close Support Request.
     */
    supportToMerchant_closeSupport(id: string, supportCloseCommand: SupportCloseCommand): Observable<SupportCloseCommand> {
        let url_ = this.baseUrl + "/api/supports/{id}/close";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(supportCloseCommand);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupportToMerchant_closeSupport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupportToMerchant_closeSupport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupportCloseCommand>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupportCloseCommand>;
        }));
    }

    protected processSupportToMerchant_closeSupport(response: HttpResponseBase): Observable<SupportCloseCommand> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupportCloseCommand.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param terminalId (optional) 
     * @param merchantName (optional) 
     * @param serialNo (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Get all Pending Deployments.
     */
    supportToMerchant_GetPendingDeployment(terminalId: string | null | undefined, merchantName: string | null | undefined, serialNo: string | null | undefined, page: number | undefined, pageSize: number | undefined): Observable<ISupportPendingDeploymentViewModel> {
        let url_ = this.baseUrl + "/api/supports/pending-deployment?";
        if (terminalId !== undefined && terminalId !== null)
            url_ += "terminalId=" + encodeURIComponent("" + terminalId) + "&";
        if (merchantName !== undefined && merchantName !== null)
            url_ += "merchantName=" + encodeURIComponent("" + merchantName) + "&";
        if (serialNo !== undefined && serialNo !== null)
            url_ += "serialNo=" + encodeURIComponent("" + serialNo) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupportToMerchant_GetPendingDeployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupportToMerchant_GetPendingDeployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ISupportPendingDeploymentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ISupportPendingDeploymentViewModel>;
        }));
    }

    protected processSupportToMerchant_GetPendingDeployment(response: HttpResponseBase): Observable<ISupportPendingDeploymentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ISupportPendingDeploymentViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Get all the deployed terminals.
     */
    supportToMerchant_ISupportDeployment(deploymentRequestId: string, command: CreateISupportDeploymentCommand): Observable<CreateISupportDeploymentCommand> {
        let url_ = this.baseUrl + "/api/supports/{deploymentRequestId}/pending-deployment";
        if (deploymentRequestId === undefined || deploymentRequestId === null)
            throw new Error("The parameter 'deploymentRequestId' must be defined.");
        url_ = url_.replace("{deploymentRequestId}", encodeURIComponent("" + deploymentRequestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupportToMerchant_ISupportDeployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupportToMerchant_ISupportDeployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateISupportDeploymentCommand>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateISupportDeploymentCommand>;
        }));
    }

    protected processSupportToMerchant_ISupportDeployment(response: HttpResponseBase): Observable<CreateISupportDeploymentCommand> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateISupportDeploymentCommand.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Get the list of Pending Reasons.
     */
    supportToMerchant_ReasonsToMove(): Observable<SupportPendingReason> {
        let url_ = this.baseUrl + "/api/supports/pending-reasons";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupportToMerchant_ReasonsToMove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupportToMerchant_ReasonsToMove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupportPendingReason>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupportPendingReason>;
        }));
    }

    protected processSupportToMerchant_ReasonsToMove(response: HttpResponseBase): Observable<SupportPendingReason> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    supportToMerchant_GetSupportIssueTypesForSupportApp(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/supportsIssueTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupportToMerchant_GetSupportIssueTypesForSupportApp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupportToMerchant_GetSupportIssueTypesForSupportApp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSupportToMerchant_GetSupportIssueTypesForSupportApp(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    supportToMerchant_RetreiveTerminalForMerchant(id: string | undefined, command: RetrieveTerminalCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/api/retrieveTerminalForMerchants?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupportToMerchant_RetreiveTerminalForMerchant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupportToMerchant_RetreiveTerminalForMerchant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSupportToMerchant_RetreiveTerminalForMerchant(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IThirdPartyApiService {
    thirdPartyApi_CreateSupport(command: CreateMerchantSupportCommand): Observable<ApiResponseOfString>;
    thirdPartyApi_GetSupports(iMid: number | undefined, pageNumber: number | undefined, pageSize: number | undefined, tid: string | null | undefined, contactPerson: string | null | undefined, contactNumber: string | null | undefined): Observable<ApiResponseOfPagedResponsesOfSupportForMerchantVM>;
    thirdPartyApi_GetSupportIssueTypesForSupportApp(): Observable<ApiResponseOfListOfSupportIssueTypeVM>;
    thirdPartyApi_GetTerminalsForDropdown(iMid: number | undefined): Observable<ApiResponseOfListOfTerminalForMerchantVM>;
    thirdPartyApi_GetaccessoriesIssue(): Observable<ApiResponseOfListOfAccessoryViewModel>;
    thirdPartyApi_CreateMerchantAccessoriesRequest(command: CreateAccessoriesRequestCommand): Observable<ApiResponseOfString>;
    thirdPartyApi_GetAllSpareRequests(iMid: number | undefined, pageNumber: number | undefined, pageSize: number | undefined, iTid: string | null | undefined): Observable<ApiResponseOfPagedResponsesOfAccessoriesListForMerchantVM>;
    thirdPartyApi_GetAccountAndSettingDetails(iMid: number | undefined): Observable<ApiResponseOfAccountAndSettingForMerchantVM>;
    thirdPartyApi_CreateIssuerBank(createMemberBankCommand: CreateMemberBankCommand): Observable<ApiResponseOfString>;
    thirdPartyApi_GetIssuerBank(): Observable<ApiResponseOfListOfIssuerBankVM>;
    thirdPartyApi_UpdateIssuerBank(updateMemberBankCommand: UpdateMemberBankCommand): Observable<ApiResponseOfString>;
    thirdPartyApi_CreateUser(command: CreateUserCommand2): Observable<ApiResponseOfString>;
    thirdPartyApi_GetIssuerBankUser(): Observable<ApiResponseOfListOfIssuerMemberBankUserViewModel>;
    thirdPartyApi_GetIssuerBankUserForDropdown(): Observable<ApiResponseOfListOfIssuerBankDropdownVM>;
    thirdPartyApi_DeactivateIssuingBankUser(userId: string | null | undefined): Observable<ApiResponseOfString>;
    thirdPartyApi_ActivateIssuingBankUser(userId: string | null | undefined): Observable<ApiResponseOfString>;
    thirdPartyApi_ChangePassword(userId: string | null | undefined, command: ChangePasswordCommand): Observable<ApiResponseOfString>;
    thirdPartyApi_ResetPassword(userId: string | null | undefined): Observable<ApiResponseOfString>;
    thirdPartyApi_UpdateUser(command: UpdateUserOfMerchantCommand): Observable<ApiResponseOfString>;
    thirdPartyApi_ResetDevice(userId: string | null | undefined): Observable<ApiResponseOfString>;
}

@Injectable({
    providedIn: 'root'
})
export class ThirdPartyApiService implements IThirdPartyApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    thirdPartyApi_CreateSupport(command: CreateMerchantSupportCommand): Observable<ApiResponseOfString> {
        let url_ = this.baseUrl + "/api/fewaPOS/supports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processThirdPartyApi_CreateSupport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processThirdPartyApi_CreateSupport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfString>;
        }));
    }

    protected processThirdPartyApi_CreateSupport(response: HttpResponseBase): Observable<ApiResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    thirdPartyApi_GetSupports(iMid: number | undefined, pageNumber: number | undefined, pageSize: number | undefined, tid: string | null | undefined, contactPerson: string | null | undefined, contactNumber: string | null | undefined): Observable<ApiResponseOfPagedResponsesOfSupportForMerchantVM> {
        let url_ = this.baseUrl + "/api/fewaPOS/supportsList?";
        if (iMid === null)
            throw new Error("The parameter 'iMid' cannot be null.");
        else if (iMid !== undefined)
            url_ += "iMid=" + encodeURIComponent("" + iMid) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (tid !== undefined && tid !== null)
            url_ += "tid=" + encodeURIComponent("" + tid) + "&";
        if (contactPerson !== undefined && contactPerson !== null)
            url_ += "contactPerson=" + encodeURIComponent("" + contactPerson) + "&";
        if (contactNumber !== undefined && contactNumber !== null)
            url_ += "contactNumber=" + encodeURIComponent("" + contactNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processThirdPartyApi_GetSupports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processThirdPartyApi_GetSupports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfPagedResponsesOfSupportForMerchantVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfPagedResponsesOfSupportForMerchantVM>;
        }));
    }

    protected processThirdPartyApi_GetSupports(response: HttpResponseBase): Observable<ApiResponseOfPagedResponsesOfSupportForMerchantVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfPagedResponsesOfSupportForMerchantVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    thirdPartyApi_GetSupportIssueTypesForSupportApp(): Observable<ApiResponseOfListOfSupportIssueTypeVM> {
        let url_ = this.baseUrl + "/api/fewaPOS/supportsIssueTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processThirdPartyApi_GetSupportIssueTypesForSupportApp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processThirdPartyApi_GetSupportIssueTypesForSupportApp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfSupportIssueTypeVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfSupportIssueTypeVM>;
        }));
    }

    protected processThirdPartyApi_GetSupportIssueTypesForSupportApp(response: HttpResponseBase): Observable<ApiResponseOfListOfSupportIssueTypeVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfListOfSupportIssueTypeVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    thirdPartyApi_GetTerminalsForDropdown(iMid: number | undefined): Observable<ApiResponseOfListOfTerminalForMerchantVM> {
        let url_ = this.baseUrl + "/api/fewaPOS/terminals?";
        if (iMid === null)
            throw new Error("The parameter 'iMid' cannot be null.");
        else if (iMid !== undefined)
            url_ += "iMid=" + encodeURIComponent("" + iMid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processThirdPartyApi_GetTerminalsForDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processThirdPartyApi_GetTerminalsForDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfTerminalForMerchantVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfTerminalForMerchantVM>;
        }));
    }

    protected processThirdPartyApi_GetTerminalsForDropdown(response: HttpResponseBase): Observable<ApiResponseOfListOfTerminalForMerchantVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfListOfTerminalForMerchantVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    thirdPartyApi_GetaccessoriesIssue(): Observable<ApiResponseOfListOfAccessoryViewModel> {
        let url_ = this.baseUrl + "/api/fewaPOS/accessoriesIssue";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processThirdPartyApi_GetaccessoriesIssue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processThirdPartyApi_GetaccessoriesIssue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfAccessoryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfAccessoryViewModel>;
        }));
    }

    protected processThirdPartyApi_GetaccessoriesIssue(response: HttpResponseBase): Observable<ApiResponseOfListOfAccessoryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfListOfAccessoryViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    thirdPartyApi_CreateMerchantAccessoriesRequest(command: CreateAccessoriesRequestCommand): Observable<ApiResponseOfString> {
        let url_ = this.baseUrl + "/api/fewaPOS/accessoriesRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processThirdPartyApi_CreateMerchantAccessoriesRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processThirdPartyApi_CreateMerchantAccessoriesRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfString>;
        }));
    }

    protected processThirdPartyApi_CreateMerchantAccessoriesRequest(response: HttpResponseBase): Observable<ApiResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    thirdPartyApi_GetAllSpareRequests(iMid: number | undefined, pageNumber: number | undefined, pageSize: number | undefined, iTid: string | null | undefined): Observable<ApiResponseOfPagedResponsesOfAccessoriesListForMerchantVM> {
        let url_ = this.baseUrl + "/api/fewaPOS/accessoriesList?";
        if (iMid === null)
            throw new Error("The parameter 'iMid' cannot be null.");
        else if (iMid !== undefined)
            url_ += "iMid=" + encodeURIComponent("" + iMid) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (iTid !== undefined && iTid !== null)
            url_ += "iTid=" + encodeURIComponent("" + iTid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processThirdPartyApi_GetAllSpareRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processThirdPartyApi_GetAllSpareRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfPagedResponsesOfAccessoriesListForMerchantVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfPagedResponsesOfAccessoriesListForMerchantVM>;
        }));
    }

    protected processThirdPartyApi_GetAllSpareRequests(response: HttpResponseBase): Observable<ApiResponseOfPagedResponsesOfAccessoriesListForMerchantVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfPagedResponsesOfAccessoriesListForMerchantVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    thirdPartyApi_GetAccountAndSettingDetails(iMid: number | undefined): Observable<ApiResponseOfAccountAndSettingForMerchantVM> {
        let url_ = this.baseUrl + "/api/fewaPOS/account-settings?";
        if (iMid === null)
            throw new Error("The parameter 'iMid' cannot be null.");
        else if (iMid !== undefined)
            url_ += "iMid=" + encodeURIComponent("" + iMid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processThirdPartyApi_GetAccountAndSettingDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processThirdPartyApi_GetAccountAndSettingDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfAccountAndSettingForMerchantVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfAccountAndSettingForMerchantVM>;
        }));
    }

    protected processThirdPartyApi_GetAccountAndSettingDetails(response: HttpResponseBase): Observable<ApiResponseOfAccountAndSettingForMerchantVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfAccountAndSettingForMerchantVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    thirdPartyApi_CreateIssuerBank(createMemberBankCommand: CreateMemberBankCommand): Observable<ApiResponseOfString> {
        let url_ = this.baseUrl + "/api/fewaPOS/issuer-bank";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createMemberBankCommand);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processThirdPartyApi_CreateIssuerBank(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processThirdPartyApi_CreateIssuerBank(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfString>;
        }));
    }

    protected processThirdPartyApi_CreateIssuerBank(response: HttpResponseBase): Observable<ApiResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    thirdPartyApi_GetIssuerBank(): Observable<ApiResponseOfListOfIssuerBankVM> {
        let url_ = this.baseUrl + "/api/fewaPOS/issuer-bank";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processThirdPartyApi_GetIssuerBank(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processThirdPartyApi_GetIssuerBank(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfIssuerBankVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfIssuerBankVM>;
        }));
    }

    protected processThirdPartyApi_GetIssuerBank(response: HttpResponseBase): Observable<ApiResponseOfListOfIssuerBankVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfListOfIssuerBankVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    thirdPartyApi_UpdateIssuerBank(updateMemberBankCommand: UpdateMemberBankCommand): Observable<ApiResponseOfString> {
        let url_ = this.baseUrl + "/api/fewaPOS/issuer-bank";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateMemberBankCommand);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processThirdPartyApi_UpdateIssuerBank(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processThirdPartyApi_UpdateIssuerBank(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfString>;
        }));
    }

    protected processThirdPartyApi_UpdateIssuerBank(response: HttpResponseBase): Observable<ApiResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    thirdPartyApi_CreateUser(command: CreateUserCommand2): Observable<ApiResponseOfString> {
        let url_ = this.baseUrl + "/api/fewaPOS/users/create-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processThirdPartyApi_CreateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processThirdPartyApi_CreateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfString>;
        }));
    }

    protected processThirdPartyApi_CreateUser(response: HttpResponseBase): Observable<ApiResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    thirdPartyApi_GetIssuerBankUser(): Observable<ApiResponseOfListOfIssuerMemberBankUserViewModel> {
        let url_ = this.baseUrl + "/api/fewaPOS/users/issuer-bank-user";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processThirdPartyApi_GetIssuerBankUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processThirdPartyApi_GetIssuerBankUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfIssuerMemberBankUserViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfIssuerMemberBankUserViewModel>;
        }));
    }

    protected processThirdPartyApi_GetIssuerBankUser(response: HttpResponseBase): Observable<ApiResponseOfListOfIssuerMemberBankUserViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfListOfIssuerMemberBankUserViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    thirdPartyApi_GetIssuerBankUserForDropdown(): Observable<ApiResponseOfListOfIssuerBankDropdownVM> {
        let url_ = this.baseUrl + "/api/fewaPOS/issuer-banks-for-dropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processThirdPartyApi_GetIssuerBankUserForDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processThirdPartyApi_GetIssuerBankUserForDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfIssuerBankDropdownVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfIssuerBankDropdownVM>;
        }));
    }

    protected processThirdPartyApi_GetIssuerBankUserForDropdown(response: HttpResponseBase): Observable<ApiResponseOfListOfIssuerBankDropdownVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfListOfIssuerBankDropdownVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    thirdPartyApi_DeactivateIssuingBankUser(userId: string | null | undefined): Observable<ApiResponseOfString> {
        let url_ = this.baseUrl + "/api/fewaPOS/user/deactivate?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processThirdPartyApi_DeactivateIssuingBankUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processThirdPartyApi_DeactivateIssuingBankUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfString>;
        }));
    }

    protected processThirdPartyApi_DeactivateIssuingBankUser(response: HttpResponseBase): Observable<ApiResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    thirdPartyApi_ActivateIssuingBankUser(userId: string | null | undefined): Observable<ApiResponseOfString> {
        let url_ = this.baseUrl + "/api/fewaPOS/user/activate?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processThirdPartyApi_ActivateIssuingBankUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processThirdPartyApi_ActivateIssuingBankUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfString>;
        }));
    }

    protected processThirdPartyApi_ActivateIssuingBankUser(response: HttpResponseBase): Observable<ApiResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    thirdPartyApi_ChangePassword(userId: string | null | undefined, command: ChangePasswordCommand): Observable<ApiResponseOfString> {
        let url_ = this.baseUrl + "/api/fewaPOS/user/change-password?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processThirdPartyApi_ChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processThirdPartyApi_ChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfString>;
        }));
    }

    protected processThirdPartyApi_ChangePassword(response: HttpResponseBase): Observable<ApiResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    thirdPartyApi_ResetPassword(userId: string | null | undefined): Observable<ApiResponseOfString> {
        let url_ = this.baseUrl + "/api/fewaPOS/user/reset-password?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processThirdPartyApi_ResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processThirdPartyApi_ResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfString>;
        }));
    }

    protected processThirdPartyApi_ResetPassword(response: HttpResponseBase): Observable<ApiResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    thirdPartyApi_UpdateUser(command: UpdateUserOfMerchantCommand): Observable<ApiResponseOfString> {
        let url_ = this.baseUrl + "/api/fewaPOS/user/update-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processThirdPartyApi_UpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processThirdPartyApi_UpdateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfString>;
        }));
    }

    protected processThirdPartyApi_UpdateUser(response: HttpResponseBase): Observable<ApiResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    thirdPartyApi_ResetDevice(userId: string | null | undefined): Observable<ApiResponseOfString> {
        let url_ = this.baseUrl + "/api/fewaPOS/user/reset-device?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processThirdPartyApi_ResetDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processThirdPartyApi_ResetDevice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfString>;
        }));
    }

    protected processThirdPartyApi_ResetDevice(response: HttpResponseBase): Observable<ApiResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IThirdPartyAuthService {
    thirdPartyAuth_Authenticate(request: AuthenticationRequest2): Observable<ThirdPartyApiResponseOfAuthenticateSetupViewModel>;
    thirdPartyAuth_VerifyWithout2FA(request: AuthenticationRequest2): Observable<ThirdPartyApiResponseOfAuthResponseDTO>;
    thirdPartyAuth_SwitchBank(iBankId: string): Observable<ThirdPartyApiResponseOfChangeBankDTO>;
    thirdPartyAuth_Verify2FA(twoFactorAuthentication: TwoFactorAuthentication): Observable<ThirdPartyApiResponseOfAuthResponseDTO>;
    thirdPartyAuth_GenerateToken(mID: string | null | undefined, oID: string | null | undefined, userId: string | undefined, firstName: string | null | undefined, lastName: string | null | undefined, email: string | null | undefined, userType: string | null | undefined, merchantName: string | null | undefined, outletName: string | null | undefined, financialInstitutionId: string | null | undefined, merchantId: string | null | undefined, outletId: string | null | undefined, securityStamp: string | null | undefined, iBankId: string | null | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class ThirdPartyAuthService implements IThirdPartyAuthService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    thirdPartyAuth_Authenticate(request: AuthenticationRequest2): Observable<ThirdPartyApiResponseOfAuthenticateSetupViewModel> {
        let url_ = this.baseUrl + "/api/fewaPOS/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processThirdPartyAuth_Authenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processThirdPartyAuth_Authenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ThirdPartyApiResponseOfAuthenticateSetupViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ThirdPartyApiResponseOfAuthenticateSetupViewModel>;
        }));
    }

    protected processThirdPartyAuth_Authenticate(response: HttpResponseBase): Observable<ThirdPartyApiResponseOfAuthenticateSetupViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ThirdPartyApiResponseOfAuthenticateSetupViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    thirdPartyAuth_VerifyWithout2FA(request: AuthenticationRequest2): Observable<ThirdPartyApiResponseOfAuthResponseDTO> {
        let url_ = this.baseUrl + "/api/fewaPOS/auth/without2FA";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processThirdPartyAuth_VerifyWithout2FA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processThirdPartyAuth_VerifyWithout2FA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ThirdPartyApiResponseOfAuthResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ThirdPartyApiResponseOfAuthResponseDTO>;
        }));
    }

    protected processThirdPartyAuth_VerifyWithout2FA(response: HttpResponseBase): Observable<ThirdPartyApiResponseOfAuthResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ThirdPartyApiResponseOfAuthResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    thirdPartyAuth_SwitchBank(iBankId: string): Observable<ThirdPartyApiResponseOfChangeBankDTO> {
        let url_ = this.baseUrl + "/api/fewaPOS/switch-bank/{iBankId}";
        if (iBankId === undefined || iBankId === null)
            throw new Error("The parameter 'iBankId' must be defined.");
        url_ = url_.replace("{iBankId}", encodeURIComponent("" + iBankId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processThirdPartyAuth_SwitchBank(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processThirdPartyAuth_SwitchBank(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ThirdPartyApiResponseOfChangeBankDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ThirdPartyApiResponseOfChangeBankDTO>;
        }));
    }

    protected processThirdPartyAuth_SwitchBank(response: HttpResponseBase): Observable<ThirdPartyApiResponseOfChangeBankDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ThirdPartyApiResponseOfChangeBankDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    thirdPartyAuth_Verify2FA(twoFactorAuthentication: TwoFactorAuthentication): Observable<ThirdPartyApiResponseOfAuthResponseDTO> {
        let url_ = this.baseUrl + "/api/fewaPOS/two-factor-authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(twoFactorAuthentication);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processThirdPartyAuth_Verify2FA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processThirdPartyAuth_Verify2FA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ThirdPartyApiResponseOfAuthResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ThirdPartyApiResponseOfAuthResponseDTO>;
        }));
    }

    protected processThirdPartyAuth_Verify2FA(response: HttpResponseBase): Observable<ThirdPartyApiResponseOfAuthResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ThirdPartyApiResponseOfAuthResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    thirdPartyAuth_GenerateToken(mID: string | null | undefined, oID: string | null | undefined, userId: string | undefined, firstName: string | null | undefined, lastName: string | null | undefined, email: string | null | undefined, userType: string | null | undefined, merchantName: string | null | undefined, outletName: string | null | undefined, financialInstitutionId: string | null | undefined, merchantId: string | null | undefined, outletId: string | null | undefined, securityStamp: string | null | undefined, iBankId: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/fewaPOS?";
        if (mID !== undefined && mID !== null)
            url_ += "MID=" + encodeURIComponent("" + mID) + "&";
        if (oID !== undefined && oID !== null)
            url_ += "OID=" + encodeURIComponent("" + oID) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (firstName !== undefined && firstName !== null)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (userType !== undefined && userType !== null)
            url_ += "UserType=" + encodeURIComponent("" + userType) + "&";
        if (merchantName !== undefined && merchantName !== null)
            url_ += "MerchantName=" + encodeURIComponent("" + merchantName) + "&";
        if (outletName !== undefined && outletName !== null)
            url_ += "OutletName=" + encodeURIComponent("" + outletName) + "&";
        if (financialInstitutionId !== undefined && financialInstitutionId !== null)
            url_ += "FinancialInstitutionId=" + encodeURIComponent("" + financialInstitutionId) + "&";
        if (merchantId !== undefined && merchantId !== null)
            url_ += "MerchantId=" + encodeURIComponent("" + merchantId) + "&";
        if (outletId !== undefined && outletId !== null)
            url_ += "OutletId=" + encodeURIComponent("" + outletId) + "&";
        if (securityStamp !== undefined && securityStamp !== null)
            url_ += "securityStamp=" + encodeURIComponent("" + securityStamp) + "&";
        if (iBankId !== undefined && iBankId !== null)
            url_ += "iBankId=" + encodeURIComponent("" + iBankId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processThirdPartyAuth_GenerateToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processThirdPartyAuth_GenerateToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processThirdPartyAuth_GenerateToken(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ITransactionDashboardService {
    transactionDashboard_GetTransactionDashboardSummary(): Observable<TransactionDashboardSummaryViewModel>;
    transactionDashboard_Post(switchTransaction: SwitchTransactionEntryCommand): Observable<FileResponse>;
    transactionDashboard_getAllTransactionLogsIMidandITid(iMid: string, iTid: string, fromDate: string | null | undefined, toDate: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<PagedResponseOfTransactionDashboardViewModel>;
    transactionDashboard_getCardTransactionLogByImidandITid(iMid: string, iTid: string, fromDate: string | null | undefined, toDate: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<PagedResponseOfTransactionDashboardViewModel>;
    transactionDashboard_getQRTransactionLogByImidandITid(iMid: string, iTid: string, fromDate: string | null | undefined, toDate: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<PagedResponseOfTransactionDashboardViewModel>;
    transactionDashboard_getTransactionLogByStatus(iMid: string, iTid: string, transactionStatus: number, fromDate: string | null | undefined, toDate: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<PagedResponseOfTransactionDashboardViewModel>;
    transactionDashboard_getCardTransactionLogByStatus(iMid: string, iTid: string, transactionStatus: number, fromDate: string | null | undefined, toDate: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<PagedResponseOfTransactionDashboardViewModel>;
    transactionDashboard_getQRTransactionLogByStatus(iMid: string, iTid: string, transactionStatus: number, fromDate: string | null | undefined, toDate: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<PagedResponseOfTransactionDashboardViewModel>;
    transactionDashboard_getTransactionLogSummaryByIMidAndITid(iMid: string, iTid: string): Observable<TidMidSpecifiedDashboardSummaryViewModel>;
    transactionDashboard_getCardTransactionSummary(): Observable<CardTransactionSummaryViewModel>;
    transactionDashboard_getCardTransactionSummaryByIMidAndITid(iMid: string, iTid: string): Observable<TidMidSpecifiedDashboardSummaryViewModel>;
    transactionDashboard_getCardTransactionSummaryByIMid(iMid: string): Observable<CardTransactionSummaryViewModel>;
    transactionDashboard_getQRTransactionSummaryByIMidAndITid(iMid: string, iTid: string): Observable<QRTransactionSummaryViewModel>;
    transactionDashboard_getQRTransactionSummaryByIMid(iMid: string): Observable<QRTransactionSummaryViewModel>;
    transactionDashboard_getQRTransactionSummary(): Observable<QRTransactionSummaryViewModel>;
    transactionDashboard_GetTransactionLogSummaryByIMid(iMid: string): Observable<TidMidSpecifiedDashboardSummaryViewModel>;
    transactionDashboard_getTransactionTrendsByIMid(iMid: string, fromDate: string | null | undefined, toDate: string | null | undefined): Observable<TransactionTrendsViewModel[]>;
    transactionDashboard_getCardTransactionTrendsByIMid(iMid: string, fromDate: string | null | undefined, toDate: string | null | undefined): Observable<TransactionTrendsViewModel[]>;
    transactionDashboard_getQRTransactionTrendsByIMid(iMid: string, fromDate: string | null | undefined, toDate: string | null | undefined): Observable<TransactionTrendsViewModel[]>;
    transactionDashboard_getTransactionTrends(fromDate: string | null | undefined, toDate: string | null | undefined): Observable<TransactionTrendsViewModel[]>;
    transactionDashboard_getCardTransactionTrends(fromDate: string | null | undefined, toDate: string | null | undefined): Observable<TransactionTrendsViewModel[]>;
    transactionDashboard_getQRTransactionTrends(fromDate: string | null | undefined, toDate: string | null | undefined): Observable<TransactionTrendsViewModel[]>;
    transactionDashboard_GetTerminalStatus(): Observable<TransactionSpecificTerminalStatusViewModel>;
    transactionDashboard_TransactionRate(fromDate: string | null | undefined, toDate: string | null | undefined): Observable<TransactionRateViewModel[]>;
    transactionDashboard_getTransactionStatusByIMid(iMid: string): Observable<TransactionSpecificTerminalStatusViewModel>;
    transactionDashboard_getMerchantTransactionStatus(iMid: string, fromDate: string | null | undefined, toDate: string | null | undefined): Observable<MerchantTransactionStatus>;
    transactionDashboard_getCardTransactionStatusByImid(iMid: string, fromDate: string | null | undefined, toDate: string | null | undefined): Observable<MerchantTransactionStatus>;
    transactionDashboard_getQRTransactionStatusByImid(iMid: string, fromDate: string | null | undefined, toDate: string | null | undefined): Observable<MerchantTransactionStatus>;
    transactionDashboard_GetTransactionDetails(rrn: string): Observable<TransactionDetailsViewModel[]>;
    transactionDashboard_GetTransactionLogReceipt(itid: string | null | undefined, rrn: string, transactionType: number): Observable<TransactionLogReceiptViewModel>;
    transactionDashboard_GetNepalpayReceiptData(refId: string): Observable<NepalpayTransactionReceiptVM>;
    transactionDashboard_GetFonepayReceiptData(refId: string): Observable<FonepayTransactionReceiptVM>;
    transactionDashboard_GetAllTransactions(mid: string | null | undefined, tid: string | null | undefined, fromDate: string | null | undefined, toDate: string | null | undefined, transactionStatus: number | undefined, paymentMode: number | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<PagedResponseOfAllTransactionsVM>;
    transactionDashboard_ExportAllTransactions(fromDate: string | null | undefined, toDate: string | null | undefined, mid: string | null | undefined, tid: string | null | undefined, transactionStatus: number | undefined, paymentMode: number | undefined): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class TransactionDashboardService implements ITransactionDashboardService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    transactionDashboard_GetTransactionDashboardSummary(): Observable<TransactionDashboardSummaryViewModel> {
        let url_ = this.baseUrl + "/api/TransactionDashboard/TransactionDashboardSummary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionDashboard_GetTransactionDashboardSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionDashboard_GetTransactionDashboardSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionDashboardSummaryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionDashboardSummaryViewModel>;
        }));
    }

    protected processTransactionDashboard_GetTransactionDashboardSummary(response: HttpResponseBase): Observable<TransactionDashboardSummaryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionDashboardSummaryViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transactionDashboard_Post(switchTransaction: SwitchTransactionEntryCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/TransactionDashboard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(switchTransaction);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionDashboard_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionDashboard_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processTransactionDashboard_Post(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transactionDashboard_getAllTransactionLogsIMidandITid(iMid: string, iTid: string, fromDate: string | null | undefined, toDate: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<PagedResponseOfTransactionDashboardViewModel> {
        let url_ = this.baseUrl + "/api/TransactionDashboard/GetAllTransactionLogs/{iMid}/{iTid}?";
        if (iMid === undefined || iMid === null)
            throw new Error("The parameter 'iMid' must be defined.");
        url_ = url_.replace("{iMid}", encodeURIComponent("" + iMid));
        if (iTid === undefined || iTid === null)
            throw new Error("The parameter 'iTid' must be defined.");
        url_ = url_.replace("{iTid}", encodeURIComponent("" + iTid));
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionDashboard_getAllTransactionLogsIMidandITid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionDashboard_getAllTransactionLogsIMidandITid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfTransactionDashboardViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfTransactionDashboardViewModel>;
        }));
    }

    protected processTransactionDashboard_getAllTransactionLogsIMidandITid(response: HttpResponseBase): Observable<PagedResponseOfTransactionDashboardViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfTransactionDashboardViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transactionDashboard_getCardTransactionLogByImidandITid(iMid: string, iTid: string, fromDate: string | null | undefined, toDate: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<PagedResponseOfTransactionDashboardViewModel> {
        let url_ = this.baseUrl + "/api/TransactionDashboard/CardTransactionLogByIMidandITid/{iMid}/{iTid}?";
        if (iMid === undefined || iMid === null)
            throw new Error("The parameter 'iMid' must be defined.");
        url_ = url_.replace("{iMid}", encodeURIComponent("" + iMid));
        if (iTid === undefined || iTid === null)
            throw new Error("The parameter 'iTid' must be defined.");
        url_ = url_.replace("{iTid}", encodeURIComponent("" + iTid));
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionDashboard_getCardTransactionLogByImidandITid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionDashboard_getCardTransactionLogByImidandITid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfTransactionDashboardViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfTransactionDashboardViewModel>;
        }));
    }

    protected processTransactionDashboard_getCardTransactionLogByImidandITid(response: HttpResponseBase): Observable<PagedResponseOfTransactionDashboardViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfTransactionDashboardViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transactionDashboard_getQRTransactionLogByImidandITid(iMid: string, iTid: string, fromDate: string | null | undefined, toDate: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<PagedResponseOfTransactionDashboardViewModel> {
        let url_ = this.baseUrl + "/api/TransactionDashboard/QRTransactionLogByIMidandITid/{iMid}/{iTid}?";
        if (iMid === undefined || iMid === null)
            throw new Error("The parameter 'iMid' must be defined.");
        url_ = url_.replace("{iMid}", encodeURIComponent("" + iMid));
        if (iTid === undefined || iTid === null)
            throw new Error("The parameter 'iTid' must be defined.");
        url_ = url_.replace("{iTid}", encodeURIComponent("" + iTid));
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionDashboard_getQRTransactionLogByImidandITid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionDashboard_getQRTransactionLogByImidandITid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfTransactionDashboardViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfTransactionDashboardViewModel>;
        }));
    }

    protected processTransactionDashboard_getQRTransactionLogByImidandITid(response: HttpResponseBase): Observable<PagedResponseOfTransactionDashboardViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfTransactionDashboardViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transactionDashboard_getTransactionLogByStatus(iMid: string, iTid: string, transactionStatus: number, fromDate: string | null | undefined, toDate: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<PagedResponseOfTransactionDashboardViewModel> {
        let url_ = this.baseUrl + "/api/TransactionDashboard/TransactionLogByStatus/{iMid}/{iTid}/{transactionStatus}?";
        if (iMid === undefined || iMid === null)
            throw new Error("The parameter 'iMid' must be defined.");
        url_ = url_.replace("{iMid}", encodeURIComponent("" + iMid));
        if (iTid === undefined || iTid === null)
            throw new Error("The parameter 'iTid' must be defined.");
        url_ = url_.replace("{iTid}", encodeURIComponent("" + iTid));
        if (transactionStatus === undefined || transactionStatus === null)
            throw new Error("The parameter 'transactionStatus' must be defined.");
        url_ = url_.replace("{transactionStatus}", encodeURIComponent("" + transactionStatus));
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionDashboard_getTransactionLogByStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionDashboard_getTransactionLogByStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfTransactionDashboardViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfTransactionDashboardViewModel>;
        }));
    }

    protected processTransactionDashboard_getTransactionLogByStatus(response: HttpResponseBase): Observable<PagedResponseOfTransactionDashboardViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfTransactionDashboardViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transactionDashboard_getCardTransactionLogByStatus(iMid: string, iTid: string, transactionStatus: number, fromDate: string | null | undefined, toDate: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<PagedResponseOfTransactionDashboardViewModel> {
        let url_ = this.baseUrl + "/api/TransactionDashboard/CardTransactionLogByStatus/{iMid}/{iTid}/{transactionStatus}?";
        if (iMid === undefined || iMid === null)
            throw new Error("The parameter 'iMid' must be defined.");
        url_ = url_.replace("{iMid}", encodeURIComponent("" + iMid));
        if (iTid === undefined || iTid === null)
            throw new Error("The parameter 'iTid' must be defined.");
        url_ = url_.replace("{iTid}", encodeURIComponent("" + iTid));
        if (transactionStatus === undefined || transactionStatus === null)
            throw new Error("The parameter 'transactionStatus' must be defined.");
        url_ = url_.replace("{transactionStatus}", encodeURIComponent("" + transactionStatus));
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionDashboard_getCardTransactionLogByStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionDashboard_getCardTransactionLogByStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfTransactionDashboardViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfTransactionDashboardViewModel>;
        }));
    }

    protected processTransactionDashboard_getCardTransactionLogByStatus(response: HttpResponseBase): Observable<PagedResponseOfTransactionDashboardViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfTransactionDashboardViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transactionDashboard_getQRTransactionLogByStatus(iMid: string, iTid: string, transactionStatus: number, fromDate: string | null | undefined, toDate: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<PagedResponseOfTransactionDashboardViewModel> {
        let url_ = this.baseUrl + "/api/TransactionDashboard/QRTransactionLogByStatus/{iMid}/{iTid}/{transactionStatus}?";
        if (iMid === undefined || iMid === null)
            throw new Error("The parameter 'iMid' must be defined.");
        url_ = url_.replace("{iMid}", encodeURIComponent("" + iMid));
        if (iTid === undefined || iTid === null)
            throw new Error("The parameter 'iTid' must be defined.");
        url_ = url_.replace("{iTid}", encodeURIComponent("" + iTid));
        if (transactionStatus === undefined || transactionStatus === null)
            throw new Error("The parameter 'transactionStatus' must be defined.");
        url_ = url_.replace("{transactionStatus}", encodeURIComponent("" + transactionStatus));
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionDashboard_getQRTransactionLogByStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionDashboard_getQRTransactionLogByStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfTransactionDashboardViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfTransactionDashboardViewModel>;
        }));
    }

    protected processTransactionDashboard_getQRTransactionLogByStatus(response: HttpResponseBase): Observable<PagedResponseOfTransactionDashboardViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfTransactionDashboardViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transactionDashboard_getTransactionLogSummaryByIMidAndITid(iMid: string, iTid: string): Observable<TidMidSpecifiedDashboardSummaryViewModel> {
        let url_ = this.baseUrl + "/api/TransactionDashboard/TransactionSummaryByIMidAndITid/{iMid}/{iTid}";
        if (iMid === undefined || iMid === null)
            throw new Error("The parameter 'iMid' must be defined.");
        url_ = url_.replace("{iMid}", encodeURIComponent("" + iMid));
        if (iTid === undefined || iTid === null)
            throw new Error("The parameter 'iTid' must be defined.");
        url_ = url_.replace("{iTid}", encodeURIComponent("" + iTid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionDashboard_getTransactionLogSummaryByIMidAndITid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionDashboard_getTransactionLogSummaryByIMidAndITid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TidMidSpecifiedDashboardSummaryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TidMidSpecifiedDashboardSummaryViewModel>;
        }));
    }

    protected processTransactionDashboard_getTransactionLogSummaryByIMidAndITid(response: HttpResponseBase): Observable<TidMidSpecifiedDashboardSummaryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TidMidSpecifiedDashboardSummaryViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transactionDashboard_getCardTransactionSummary(): Observable<CardTransactionSummaryViewModel> {
        let url_ = this.baseUrl + "/api/TransactionDashboard/CardTransactionSummary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionDashboard_getCardTransactionSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionDashboard_getCardTransactionSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CardTransactionSummaryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CardTransactionSummaryViewModel>;
        }));
    }

    protected processTransactionDashboard_getCardTransactionSummary(response: HttpResponseBase): Observable<CardTransactionSummaryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CardTransactionSummaryViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transactionDashboard_getCardTransactionSummaryByIMidAndITid(iMid: string, iTid: string): Observable<TidMidSpecifiedDashboardSummaryViewModel> {
        let url_ = this.baseUrl + "/api/TransactionDashboard/CardTransactionSummaryByITidAndIMid/{iMid}/{iTid}";
        if (iMid === undefined || iMid === null)
            throw new Error("The parameter 'iMid' must be defined.");
        url_ = url_.replace("{iMid}", encodeURIComponent("" + iMid));
        if (iTid === undefined || iTid === null)
            throw new Error("The parameter 'iTid' must be defined.");
        url_ = url_.replace("{iTid}", encodeURIComponent("" + iTid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionDashboard_getCardTransactionSummaryByIMidAndITid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionDashboard_getCardTransactionSummaryByIMidAndITid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TidMidSpecifiedDashboardSummaryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TidMidSpecifiedDashboardSummaryViewModel>;
        }));
    }

    protected processTransactionDashboard_getCardTransactionSummaryByIMidAndITid(response: HttpResponseBase): Observable<TidMidSpecifiedDashboardSummaryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TidMidSpecifiedDashboardSummaryViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transactionDashboard_getCardTransactionSummaryByIMid(iMid: string): Observable<CardTransactionSummaryViewModel> {
        let url_ = this.baseUrl + "/api/TransactionDashboard/CardTransactionSummaryByIMid/{iMid}";
        if (iMid === undefined || iMid === null)
            throw new Error("The parameter 'iMid' must be defined.");
        url_ = url_.replace("{iMid}", encodeURIComponent("" + iMid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionDashboard_getCardTransactionSummaryByIMid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionDashboard_getCardTransactionSummaryByIMid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CardTransactionSummaryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CardTransactionSummaryViewModel>;
        }));
    }

    protected processTransactionDashboard_getCardTransactionSummaryByIMid(response: HttpResponseBase): Observable<CardTransactionSummaryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CardTransactionSummaryViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transactionDashboard_getQRTransactionSummaryByIMidAndITid(iMid: string, iTid: string): Observable<QRTransactionSummaryViewModel> {
        let url_ = this.baseUrl + "/api/TransactionDashboard/QRTransactionSummaryByITidAndIMid/{iMid}/{iTid}";
        if (iMid === undefined || iMid === null)
            throw new Error("The parameter 'iMid' must be defined.");
        url_ = url_.replace("{iMid}", encodeURIComponent("" + iMid));
        if (iTid === undefined || iTid === null)
            throw new Error("The parameter 'iTid' must be defined.");
        url_ = url_.replace("{iTid}", encodeURIComponent("" + iTid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionDashboard_getQRTransactionSummaryByIMidAndITid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionDashboard_getQRTransactionSummaryByIMidAndITid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QRTransactionSummaryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QRTransactionSummaryViewModel>;
        }));
    }

    protected processTransactionDashboard_getQRTransactionSummaryByIMidAndITid(response: HttpResponseBase): Observable<QRTransactionSummaryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QRTransactionSummaryViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transactionDashboard_getQRTransactionSummaryByIMid(iMid: string): Observable<QRTransactionSummaryViewModel> {
        let url_ = this.baseUrl + "/api/TransactionDashboard/QRTransactionSummaryByIMid/{iMid}";
        if (iMid === undefined || iMid === null)
            throw new Error("The parameter 'iMid' must be defined.");
        url_ = url_.replace("{iMid}", encodeURIComponent("" + iMid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionDashboard_getQRTransactionSummaryByIMid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionDashboard_getQRTransactionSummaryByIMid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QRTransactionSummaryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QRTransactionSummaryViewModel>;
        }));
    }

    protected processTransactionDashboard_getQRTransactionSummaryByIMid(response: HttpResponseBase): Observable<QRTransactionSummaryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QRTransactionSummaryViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transactionDashboard_getQRTransactionSummary(): Observable<QRTransactionSummaryViewModel> {
        let url_ = this.baseUrl + "/api/TransactionDashboard/QRTransactionSummary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionDashboard_getQRTransactionSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionDashboard_getQRTransactionSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QRTransactionSummaryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QRTransactionSummaryViewModel>;
        }));
    }

    protected processTransactionDashboard_getQRTransactionSummary(response: HttpResponseBase): Observable<QRTransactionSummaryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QRTransactionSummaryViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transactionDashboard_GetTransactionLogSummaryByIMid(iMid: string): Observable<TidMidSpecifiedDashboardSummaryViewModel> {
        let url_ = this.baseUrl + "/api/TransactionDashboard/TransactionSummaryByIMid/{iMid}";
        if (iMid === undefined || iMid === null)
            throw new Error("The parameter 'iMid' must be defined.");
        url_ = url_.replace("{iMid}", encodeURIComponent("" + iMid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionDashboard_GetTransactionLogSummaryByIMid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionDashboard_GetTransactionLogSummaryByIMid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TidMidSpecifiedDashboardSummaryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TidMidSpecifiedDashboardSummaryViewModel>;
        }));
    }

    protected processTransactionDashboard_GetTransactionLogSummaryByIMid(response: HttpResponseBase): Observable<TidMidSpecifiedDashboardSummaryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TidMidSpecifiedDashboardSummaryViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transactionDashboard_getTransactionTrendsByIMid(iMid: string, fromDate: string | null | undefined, toDate: string | null | undefined): Observable<TransactionTrendsViewModel[]> {
        let url_ = this.baseUrl + "/api/TransactionDashboard/TransactionTrendsByIMid/{iMid}?";
        if (iMid === undefined || iMid === null)
            throw new Error("The parameter 'iMid' must be defined.");
        url_ = url_.replace("{iMid}", encodeURIComponent("" + iMid));
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionDashboard_getTransactionTrendsByIMid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionDashboard_getTransactionTrendsByIMid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionTrendsViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionTrendsViewModel[]>;
        }));
    }

    protected processTransactionDashboard_getTransactionTrendsByIMid(response: HttpResponseBase): Observable<TransactionTrendsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransactionTrendsViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transactionDashboard_getCardTransactionTrendsByIMid(iMid: string, fromDate: string | null | undefined, toDate: string | null | undefined): Observable<TransactionTrendsViewModel[]> {
        let url_ = this.baseUrl + "/api/TransactionDashboard/CardTransactionTrendsByIMid/{iMid}?";
        if (iMid === undefined || iMid === null)
            throw new Error("The parameter 'iMid' must be defined.");
        url_ = url_.replace("{iMid}", encodeURIComponent("" + iMid));
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionDashboard_getCardTransactionTrendsByIMid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionDashboard_getCardTransactionTrendsByIMid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionTrendsViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionTrendsViewModel[]>;
        }));
    }

    protected processTransactionDashboard_getCardTransactionTrendsByIMid(response: HttpResponseBase): Observable<TransactionTrendsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransactionTrendsViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transactionDashboard_getQRTransactionTrendsByIMid(iMid: string, fromDate: string | null | undefined, toDate: string | null | undefined): Observable<TransactionTrendsViewModel[]> {
        let url_ = this.baseUrl + "/api/TransactionDashboard/QRTransactionTrendsByIMid/{iMid}?";
        if (iMid === undefined || iMid === null)
            throw new Error("The parameter 'iMid' must be defined.");
        url_ = url_.replace("{iMid}", encodeURIComponent("" + iMid));
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionDashboard_getQRTransactionTrendsByIMid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionDashboard_getQRTransactionTrendsByIMid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionTrendsViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionTrendsViewModel[]>;
        }));
    }

    protected processTransactionDashboard_getQRTransactionTrendsByIMid(response: HttpResponseBase): Observable<TransactionTrendsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransactionTrendsViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transactionDashboard_getTransactionTrends(fromDate: string | null | undefined, toDate: string | null | undefined): Observable<TransactionTrendsViewModel[]> {
        let url_ = this.baseUrl + "/api/TransactionDashboard/TransactionTrends?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionDashboard_getTransactionTrends(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionDashboard_getTransactionTrends(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionTrendsViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionTrendsViewModel[]>;
        }));
    }

    protected processTransactionDashboard_getTransactionTrends(response: HttpResponseBase): Observable<TransactionTrendsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransactionTrendsViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transactionDashboard_getCardTransactionTrends(fromDate: string | null | undefined, toDate: string | null | undefined): Observable<TransactionTrendsViewModel[]> {
        let url_ = this.baseUrl + "/api/TransactionDashboard/CardTransactionTrends?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionDashboard_getCardTransactionTrends(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionDashboard_getCardTransactionTrends(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionTrendsViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionTrendsViewModel[]>;
        }));
    }

    protected processTransactionDashboard_getCardTransactionTrends(response: HttpResponseBase): Observable<TransactionTrendsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransactionTrendsViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transactionDashboard_getQRTransactionTrends(fromDate: string | null | undefined, toDate: string | null | undefined): Observable<TransactionTrendsViewModel[]> {
        let url_ = this.baseUrl + "/api/TransactionDashboard/QRTransactionTrends?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionDashboard_getQRTransactionTrends(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionDashboard_getQRTransactionTrends(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionTrendsViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionTrendsViewModel[]>;
        }));
    }

    protected processTransactionDashboard_getQRTransactionTrends(response: HttpResponseBase): Observable<TransactionTrendsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransactionTrendsViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transactionDashboard_GetTerminalStatus(): Observable<TransactionSpecificTerminalStatusViewModel> {
        let url_ = this.baseUrl + "/api/TransactionDashboard/getTerminalStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionDashboard_GetTerminalStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionDashboard_GetTerminalStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionSpecificTerminalStatusViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionSpecificTerminalStatusViewModel>;
        }));
    }

    protected processTransactionDashboard_GetTerminalStatus(response: HttpResponseBase): Observable<TransactionSpecificTerminalStatusViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionSpecificTerminalStatusViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transactionDashboard_TransactionRate(fromDate: string | null | undefined, toDate: string | null | undefined): Observable<TransactionRateViewModel[]> {
        let url_ = this.baseUrl + "/api/TransactionDashboard/getTransactionRate?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionDashboard_TransactionRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionDashboard_TransactionRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionRateViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionRateViewModel[]>;
        }));
    }

    protected processTransactionDashboard_TransactionRate(response: HttpResponseBase): Observable<TransactionRateViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransactionRateViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transactionDashboard_getTransactionStatusByIMid(iMid: string): Observable<TransactionSpecificTerminalStatusViewModel> {
        let url_ = this.baseUrl + "/api/TransactionDashboard/GetTransactionStatusByIMid/{iMid}";
        if (iMid === undefined || iMid === null)
            throw new Error("The parameter 'iMid' must be defined.");
        url_ = url_.replace("{iMid}", encodeURIComponent("" + iMid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionDashboard_getTransactionStatusByIMid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionDashboard_getTransactionStatusByIMid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionSpecificTerminalStatusViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionSpecificTerminalStatusViewModel>;
        }));
    }

    protected processTransactionDashboard_getTransactionStatusByIMid(response: HttpResponseBase): Observable<TransactionSpecificTerminalStatusViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionSpecificTerminalStatusViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transactionDashboard_getMerchantTransactionStatus(iMid: string, fromDate: string | null | undefined, toDate: string | null | undefined): Observable<MerchantTransactionStatus> {
        let url_ = this.baseUrl + "/api/TransactionDashboard/GetMerchantTransactionStatus/{iMid}?";
        if (iMid === undefined || iMid === null)
            throw new Error("The parameter 'iMid' must be defined.");
        url_ = url_.replace("{iMid}", encodeURIComponent("" + iMid));
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionDashboard_getMerchantTransactionStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionDashboard_getMerchantTransactionStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MerchantTransactionStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MerchantTransactionStatus>;
        }));
    }

    protected processTransactionDashboard_getMerchantTransactionStatus(response: HttpResponseBase): Observable<MerchantTransactionStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MerchantTransactionStatus.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transactionDashboard_getCardTransactionStatusByImid(iMid: string, fromDate: string | null | undefined, toDate: string | null | undefined): Observable<MerchantTransactionStatus> {
        let url_ = this.baseUrl + "/api/TransactionDashboard/GetCardTransactionStatus/{iMid}?";
        if (iMid === undefined || iMid === null)
            throw new Error("The parameter 'iMid' must be defined.");
        url_ = url_.replace("{iMid}", encodeURIComponent("" + iMid));
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionDashboard_getCardTransactionStatusByImid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionDashboard_getCardTransactionStatusByImid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MerchantTransactionStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MerchantTransactionStatus>;
        }));
    }

    protected processTransactionDashboard_getCardTransactionStatusByImid(response: HttpResponseBase): Observable<MerchantTransactionStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MerchantTransactionStatus.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transactionDashboard_getQRTransactionStatusByImid(iMid: string, fromDate: string | null | undefined, toDate: string | null | undefined): Observable<MerchantTransactionStatus> {
        let url_ = this.baseUrl + "/api/TransactionDashboard/QRTransactionStatus/{iMid}?";
        if (iMid === undefined || iMid === null)
            throw new Error("The parameter 'iMid' must be defined.");
        url_ = url_.replace("{iMid}", encodeURIComponent("" + iMid));
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionDashboard_getQRTransactionStatusByImid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionDashboard_getQRTransactionStatusByImid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MerchantTransactionStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MerchantTransactionStatus>;
        }));
    }

    protected processTransactionDashboard_getQRTransactionStatusByImid(response: HttpResponseBase): Observable<MerchantTransactionStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MerchantTransactionStatus.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transactionDashboard_GetTransactionDetails(rrn: string): Observable<TransactionDetailsViewModel[]> {
        let url_ = this.baseUrl + "/api/TransactionDashboard/settlement/{rrn}/sale-transaction-details";
        if (rrn === undefined || rrn === null)
            throw new Error("The parameter 'rrn' must be defined.");
        url_ = url_.replace("{rrn}", encodeURIComponent("" + rrn));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionDashboard_GetTransactionDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionDashboard_GetTransactionDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionDetailsViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionDetailsViewModel[]>;
        }));
    }

    protected processTransactionDashboard_GetTransactionDetails(response: HttpResponseBase): Observable<TransactionDetailsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransactionDetailsViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transactionDashboard_GetTransactionLogReceipt(itid: string | null | undefined, rrn: string, transactionType: number): Observable<TransactionLogReceiptViewModel> {
        let url_ = this.baseUrl + "/api/TransactionDashboard/transaction-log-receipt/{rrn}/{transactionType}?";
        if (rrn === undefined || rrn === null)
            throw new Error("The parameter 'rrn' must be defined.");
        url_ = url_.replace("{rrn}", encodeURIComponent("" + rrn));
        if (transactionType === undefined || transactionType === null)
            throw new Error("The parameter 'transactionType' must be defined.");
        url_ = url_.replace("{transactionType}", encodeURIComponent("" + transactionType));
        if (itid !== undefined && itid !== null)
            url_ += "itid=" + encodeURIComponent("" + itid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionDashboard_GetTransactionLogReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionDashboard_GetTransactionLogReceipt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionLogReceiptViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionLogReceiptViewModel>;
        }));
    }

    protected processTransactionDashboard_GetTransactionLogReceipt(response: HttpResponseBase): Observable<TransactionLogReceiptViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionLogReceiptViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transactionDashboard_GetNepalpayReceiptData(refId: string): Observable<NepalpayTransactionReceiptVM> {
        let url_ = this.baseUrl + "/api/TransactionDashboard/nepalpay-receipt-data/{refId}";
        if (refId === undefined || refId === null)
            throw new Error("The parameter 'refId' must be defined.");
        url_ = url_.replace("{refId}", encodeURIComponent("" + refId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionDashboard_GetNepalpayReceiptData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionDashboard_GetNepalpayReceiptData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NepalpayTransactionReceiptVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NepalpayTransactionReceiptVM>;
        }));
    }

    protected processTransactionDashboard_GetNepalpayReceiptData(response: HttpResponseBase): Observable<NepalpayTransactionReceiptVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NepalpayTransactionReceiptVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transactionDashboard_GetFonepayReceiptData(refId: string): Observable<FonepayTransactionReceiptVM> {
        let url_ = this.baseUrl + "/api/TransactionDashboard/fonepay-receipt-data/{refId}";
        if (refId === undefined || refId === null)
            throw new Error("The parameter 'refId' must be defined.");
        url_ = url_.replace("{refId}", encodeURIComponent("" + refId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionDashboard_GetFonepayReceiptData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionDashboard_GetFonepayReceiptData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FonepayTransactionReceiptVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FonepayTransactionReceiptVM>;
        }));
    }

    protected processTransactionDashboard_GetFonepayReceiptData(response: HttpResponseBase): Observable<FonepayTransactionReceiptVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FonepayTransactionReceiptVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transactionDashboard_GetAllTransactions(mid: string | null | undefined, tid: string | null | undefined, fromDate: string | null | undefined, toDate: string | null | undefined, transactionStatus: number | undefined, paymentMode: number | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<PagedResponseOfAllTransactionsVM> {
        let url_ = this.baseUrl + "/api/TransactionDashboard/transactions?";
        if (mid !== undefined && mid !== null)
            url_ += "Mid=" + encodeURIComponent("" + mid) + "&";
        if (tid !== undefined && tid !== null)
            url_ += "Tid=" + encodeURIComponent("" + tid) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (transactionStatus === null)
            throw new Error("The parameter 'transactionStatus' cannot be null.");
        else if (transactionStatus !== undefined)
            url_ += "transactionStatus=" + encodeURIComponent("" + transactionStatus) + "&";
        if (paymentMode === null)
            throw new Error("The parameter 'paymentMode' cannot be null.");
        else if (paymentMode !== undefined)
            url_ += "paymentMode=" + encodeURIComponent("" + paymentMode) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionDashboard_GetAllTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionDashboard_GetAllTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfAllTransactionsVM>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfAllTransactionsVM>;
        }));
    }

    protected processTransactionDashboard_GetAllTransactions(response: HttpResponseBase): Observable<PagedResponseOfAllTransactionsVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfAllTransactionsVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transactionDashboard_ExportAllTransactions(fromDate: string | null | undefined, toDate: string | null | undefined, mid: string | null | undefined, tid: string | null | undefined, transactionStatus: number | undefined, paymentMode: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/TransactionDashboard/export/transactions?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (mid !== undefined && mid !== null)
            url_ += "mid=" + encodeURIComponent("" + mid) + "&";
        if (tid !== undefined && tid !== null)
            url_ += "tid=" + encodeURIComponent("" + tid) + "&";
        if (transactionStatus === null)
            throw new Error("The parameter 'transactionStatus' cannot be null.");
        else if (transactionStatus !== undefined)
            url_ += "transactionStatus=" + encodeURIComponent("" + transactionStatus) + "&";
        if (paymentMode === null)
            throw new Error("The parameter 'paymentMode' cannot be null.");
        else if (paymentMode !== undefined)
            url_ += "paymentMode=" + encodeURIComponent("" + paymentMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionDashboard_ExportAllTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionDashboard_ExportAllTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processTransactionDashboard_ExportAllTransactions(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AccessoryAddCommand implements IAccessoryAddCommand {
    totalNumber?: number;
    vendorName?: string | undefined;
    accessoryId?: string;
    buyDate?: Date;

    constructor(data?: IAccessoryAddCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalNumber = _data["totalNumber"];
            this.vendorName = _data["vendorName"];
            this.accessoryId = _data["accessoryId"];
            this.buyDate = _data["buyDate"] ? new Date(_data["buyDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AccessoryAddCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AccessoryAddCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalNumber"] = this.totalNumber;
        data["vendorName"] = this.vendorName;
        data["accessoryId"] = this.accessoryId;
        data["buyDate"] = this.buyDate ? this.buyDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAccessoryAddCommand {
    totalNumber?: number;
    vendorName?: string | undefined;
    accessoryId?: string;
    buyDate?: Date;
}

export class UserViewModel implements IUserViewModel {
    id?: string | undefined;
    userName!: string;
    fullName?: string | undefined;
    email!: string;
    jobTitle?: string | undefined;
    userType?: UserType;
    userTypeName?: string | undefined;
    phoneNumber?: string | undefined;
    configuration?: string | undefined;
    isEnabled?: boolean;
    bankId?: string | undefined;
    isLockedOut?: boolean;
    roles?: string[] | undefined;

    constructor(data?: IUserViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.jobTitle = _data["jobTitle"];
            this.userType = _data["userType"];
            this.userTypeName = _data["userTypeName"];
            this.phoneNumber = _data["phoneNumber"];
            this.configuration = _data["configuration"];
            this.isEnabled = _data["isEnabled"];
            this.bankId = _data["bankId"];
            this.isLockedOut = _data["isLockedOut"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): UserViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["jobTitle"] = this.jobTitle;
        data["userType"] = this.userType;
        data["userTypeName"] = this.userTypeName;
        data["phoneNumber"] = this.phoneNumber;
        data["configuration"] = this.configuration;
        data["isEnabled"] = this.isEnabled;
        data["bankId"] = this.bankId;
        data["isLockedOut"] = this.isLockedOut;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface IUserViewModel {
    id?: string | undefined;
    userName: string;
    fullName?: string | undefined;
    email: string;
    jobTitle?: string | undefined;
    userType?: UserType;
    userTypeName?: string | undefined;
    phoneNumber?: string | undefined;
    configuration?: string | undefined;
    isEnabled?: boolean;
    bankId?: string | undefined;
    isLockedOut?: boolean;
    roles?: string[] | undefined;
}

export enum UserType {
    BankUser = 1,
    ImarkUser = 2,
    MerchantUser = 3,
    OutletUser = 4,
    MemberBankUser = 5,
}

export class UserEditViewModel extends UserViewModel implements IUserEditViewModel {
    currentPassword?: string | undefined;
    newPassword?: string | undefined;

    constructor(data?: IUserEditViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static override fromJS(data: any): UserEditViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserEditViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        super.toJSON(data);
        return data;
    }
}

export interface IUserEditViewModel extends IUserViewModel {
    currentPassword?: string | undefined;
    newPassword?: string | undefined;
}

export class OperationBase implements IOperationBase {
    path?: string | undefined;
    op?: string | undefined;
    from?: string | undefined;

    constructor(data?: IOperationBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.path = _data["path"];
            this.op = _data["op"];
            this.from = _data["from"];
        }
    }

    static fromJS(data: any): OperationBase {
        data = typeof data === 'object' ? data : {};
        let result = new OperationBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["path"] = this.path;
        data["op"] = this.op;
        data["from"] = this.from;
        return data;
    }
}

export interface IOperationBase {
    path?: string | undefined;
    op?: string | undefined;
    from?: string | undefined;
}

export class Operation extends OperationBase implements IOperation {
    value?: any | undefined;

    constructor(data?: IOperation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): Operation {
        data = typeof data === 'object' ? data : {};
        let result = new Operation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IOperation extends IOperationBase {
    value?: any | undefined;
}

export class RoleViewModel implements IRoleViewModel {
    id?: string | undefined;
    name!: string;
    bankId?: string | undefined;
    bankName?: string | undefined;
    description?: string | undefined;
    usersCount?: number;
    permissions?: PermissionViewModel[] | undefined;

    constructor(data?: IRoleViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.bankId = _data["bankId"];
            this.bankName = _data["bankName"];
            this.description = _data["description"];
            this.usersCount = _data["usersCount"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(PermissionViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RoleViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["bankId"] = this.bankId;
        data["bankName"] = this.bankName;
        data["description"] = this.description;
        data["usersCount"] = this.usersCount;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRoleViewModel {
    id?: string | undefined;
    name: string;
    bankId?: string | undefined;
    bankName?: string | undefined;
    description?: string | undefined;
    usersCount?: number;
    permissions?: PermissionViewModel[] | undefined;
}

export class PermissionViewModel implements IPermissionViewModel {
    name?: string | undefined;
    value?: string | undefined;
    groupName?: string | undefined;
    description?: string | undefined;

    constructor(data?: IPermissionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
            this.groupName = _data["groupName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PermissionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        data["groupName"] = this.groupName;
        data["description"] = this.description;
        return data;
    }
}

export interface IPermissionViewModel {
    name?: string | undefined;
    value?: string | undefined;
    groupName?: string | undefined;
    description?: string | undefined;
}

export class CreateUserCommand implements ICreateUserCommand {
    userId?: string | undefined;
    jobTitle?: string | undefined;
    fullName?: string | undefined;
    bankId?: string | undefined;
    branchId?: string | undefined;
    userType?: UserType;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;

    constructor(data?: ICreateUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.jobTitle = _data["jobTitle"];
            this.fullName = _data["fullName"];
            this.bankId = _data["bankId"];
            this.branchId = _data["branchId"];
            this.userType = _data["userType"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
        }
    }

    static fromJS(data: any): CreateUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["jobTitle"] = this.jobTitle;
        data["fullName"] = this.fullName;
        data["bankId"] = this.bankId;
        data["branchId"] = this.branchId;
        data["userType"] = this.userType;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        return data;
    }
}

export interface ICreateUserCommand {
    userId?: string | undefined;
    jobTitle?: string | undefined;
    fullName?: string | undefined;
    bankId?: string | undefined;
    branchId?: string | undefined;
    userType?: UserType;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
}

export class CreateMerchantUserCommand implements ICreateMerchantUserCommand {
    jobTitle?: string | undefined;
    fullName?: string | undefined;
    userType?: UserType;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;

    constructor(data?: ICreateMerchantUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobTitle = _data["jobTitle"];
            this.fullName = _data["fullName"];
            this.userType = _data["userType"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
        }
    }

    static fromJS(data: any): CreateMerchantUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMerchantUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobTitle"] = this.jobTitle;
        data["fullName"] = this.fullName;
        data["userType"] = this.userType;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        return data;
    }
}

export interface ICreateMerchantUserCommand {
    jobTitle?: string | undefined;
    fullName?: string | undefined;
    userType?: UserType;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
}

/** Represents a user in the identity system */
export class IdentityUserOfString implements IIdentityUserOfString {
    /** Gets or sets the primary key for this user. */
    id?: string | undefined;
    /** Gets or sets the user name for this user. */
    userName?: string | undefined;
    /** Gets or sets the normalized user name for this user. */
    normalizedUserName?: string | undefined;
    /** Gets or sets the email address for this user. */
    email?: string | undefined;
    /** Gets or sets the normalized email address for this user. */
    normalizedEmail?: string | undefined;
    /** Gets or sets a flag indicating if a user has confirmed their email address. */
    emailConfirmed?: boolean;
    /** Gets or sets a salted and hashed representation of the password for this user. */
    passwordHash?: string | undefined;
    /** A random value that must change whenever a users credentials change (password changed, login removed) */
    securityStamp?: string | undefined;
    /** A random value that must change whenever a user is persisted to the store */
    concurrencyStamp?: string | undefined;
    /** Gets or sets a telephone number for the user. */
    phoneNumber?: string | undefined;
    /** Gets or sets a flag indicating if a user has confirmed their telephone address. */
    phoneNumberConfirmed?: boolean;
    /** Gets or sets a flag indicating if two factor authentication is enabled for this user. */
    twoFactorEnabled?: boolean;
    /** Gets or sets the date and time, in UTC, when any user lockout ends. */
    lockoutEnd?: Date | undefined;
    /** Gets or sets a flag indicating if the user could be locked out. */
    lockoutEnabled?: boolean;
    /** Gets or sets the number of failed login attempts for the current user. */
    accessFailedCount?: number;

    constructor(data?: IIdentityUserOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.email = _data["email"];
            this.normalizedEmail = _data["normalizedEmail"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.passwordHash = _data["passwordHash"];
            this.securityStamp = _data["securityStamp"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
            this.twoFactorEnabled = _data["twoFactorEnabled"];
            this.lockoutEnd = _data["lockoutEnd"] ? new Date(_data["lockoutEnd"].toString()) : <any>undefined;
            this.lockoutEnabled = _data["lockoutEnabled"];
            this.accessFailedCount = _data["accessFailedCount"];
        }
    }

    static fromJS(data: any): IdentityUserOfString {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityUserOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["normalizedUserName"] = this.normalizedUserName;
        data["email"] = this.email;
        data["normalizedEmail"] = this.normalizedEmail;
        data["emailConfirmed"] = this.emailConfirmed;
        data["passwordHash"] = this.passwordHash;
        data["securityStamp"] = this.securityStamp;
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["twoFactorEnabled"] = this.twoFactorEnabled;
        data["lockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : <any>undefined;
        data["lockoutEnabled"] = this.lockoutEnabled;
        data["accessFailedCount"] = this.accessFailedCount;
        return data;
    }
}

/** Represents a user in the identity system */
export interface IIdentityUserOfString {
    /** Gets or sets the primary key for this user. */
    id?: string | undefined;
    /** Gets or sets the user name for this user. */
    userName?: string | undefined;
    /** Gets or sets the normalized user name for this user. */
    normalizedUserName?: string | undefined;
    /** Gets or sets the email address for this user. */
    email?: string | undefined;
    /** Gets or sets the normalized email address for this user. */
    normalizedEmail?: string | undefined;
    /** Gets or sets a flag indicating if a user has confirmed their email address. */
    emailConfirmed?: boolean;
    /** Gets or sets a salted and hashed representation of the password for this user. */
    passwordHash?: string | undefined;
    /** A random value that must change whenever a users credentials change (password changed, login removed) */
    securityStamp?: string | undefined;
    /** A random value that must change whenever a user is persisted to the store */
    concurrencyStamp?: string | undefined;
    /** Gets or sets a telephone number for the user. */
    phoneNumber?: string | undefined;
    /** Gets or sets a flag indicating if a user has confirmed their telephone address. */
    phoneNumberConfirmed?: boolean;
    /** Gets or sets a flag indicating if two factor authentication is enabled for this user. */
    twoFactorEnabled?: boolean;
    /** Gets or sets the date and time, in UTC, when any user lockout ends. */
    lockoutEnd?: Date | undefined;
    /** Gets or sets a flag indicating if the user could be locked out. */
    lockoutEnabled?: boolean;
    /** Gets or sets the number of failed login attempts for the current user. */
    accessFailedCount?: number;
}

/** The default implementation of IdentityUser`1 which uses a string as a primary key. */
export class IdentityUser extends IdentityUserOfString implements IIdentityUser {

    constructor(data?: IIdentityUser) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): IdentityUser {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityUser();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** The default implementation of IdentityUser`1 which uses a string as a primary key. */
export interface IIdentityUser extends IIdentityUserOfString {
}

export class ApplicationUser extends IdentityUser implements IApplicationUser {
    friendlyName?: string | undefined;
    jobTitle?: string | undefined;
    fullName?: string | undefined;
    configuration?: string | undefined;
    isEnabled?: boolean;
    bankId?: string | undefined;
    isLockedOut?: boolean;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    createdDate?: Date;
    updatedDate?: Date;
    branchId?: string | undefined;
    branch?: Branch | undefined;
    userType?: UserType | undefined;
    memberBankId?: string | undefined;
    memberBank?: MemberBanks | undefined;
    isQRScanned?: boolean;
    isInitialLogin?: boolean;
    isEmailConfirmed?: boolean;
    userRoles?: IdentityUserRoleOfString[] | undefined;
    claims?: IdentityUserClaimOfString[] | undefined;
    orders?: Order[] | undefined;
    roles?: ApplicationRole[] | undefined;

    constructor(data?: IApplicationUser) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.friendlyName = _data["friendlyName"];
            this.jobTitle = _data["jobTitle"];
            this.fullName = _data["fullName"];
            this.configuration = _data["configuration"];
            this.isEnabled = _data["isEnabled"];
            this.bankId = _data["bankId"];
            this.isLockedOut = _data["isLockedOut"];
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.branchId = _data["branchId"];
            this.branch = _data["branch"] ? Branch.fromJS(_data["branch"]) : <any>undefined;
            this.userType = _data["userType"];
            this.memberBankId = _data["memberBankId"];
            this.memberBank = _data["memberBank"] ? MemberBanks.fromJS(_data["memberBank"]) : <any>undefined;
            this.isQRScanned = _data["isQRScanned"];
            this.isInitialLogin = _data["isInitialLogin"];
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            if (Array.isArray(_data["userRoles"])) {
                this.userRoles = [] as any;
                for (let item of _data["userRoles"])
                    this.userRoles!.push(IdentityUserRoleOfString.fromJS(item));
            }
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims!.push(IdentityUserClaimOfString.fromJS(item));
            }
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(Order.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(ApplicationRole.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ApplicationUser {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationUser();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["friendlyName"] = this.friendlyName;
        data["jobTitle"] = this.jobTitle;
        data["fullName"] = this.fullName;
        data["configuration"] = this.configuration;
        data["isEnabled"] = this.isEnabled;
        data["bankId"] = this.bankId;
        data["isLockedOut"] = this.isLockedOut;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["branchId"] = this.branchId;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["userType"] = this.userType;
        data["memberBankId"] = this.memberBankId;
        data["memberBank"] = this.memberBank ? this.memberBank.toJSON() : <any>undefined;
        data["isQRScanned"] = this.isQRScanned;
        data["isInitialLogin"] = this.isInitialLogin;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        if (Array.isArray(this.userRoles)) {
            data["userRoles"] = [];
            for (let item of this.userRoles)
                data["userRoles"].push(item.toJSON());
        }
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IApplicationUser extends IIdentityUser {
    friendlyName?: string | undefined;
    jobTitle?: string | undefined;
    fullName?: string | undefined;
    configuration?: string | undefined;
    isEnabled?: boolean;
    bankId?: string | undefined;
    isLockedOut?: boolean;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    createdDate?: Date;
    updatedDate?: Date;
    branchId?: string | undefined;
    branch?: Branch | undefined;
    userType?: UserType | undefined;
    memberBankId?: string | undefined;
    memberBank?: MemberBanks | undefined;
    isQRScanned?: boolean;
    isInitialLogin?: boolean;
    isEmailConfirmed?: boolean;
    userRoles?: IdentityUserRoleOfString[] | undefined;
    claims?: IdentityUserClaimOfString[] | undefined;
    orders?: Order[] | undefined;
    roles?: ApplicationRole[] | undefined;
}

export class AuditableEntity implements IAuditableEntity {
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    updatedDate?: Date;
    createdDate?: Date;

    constructor(data?: IAuditableEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AuditableEntity {
        data = typeof data === 'object' ? data : {};
        let result = new AuditableEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAuditableEntity {
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    updatedDate?: Date;
    createdDate?: Date;
}

export class Branch extends AuditableEntity implements IBranch {
    branchId?: string;
    branchName?: string | undefined;
    branchCode?: string | undefined;
    bankId?: string;
    bank?: Bank | undefined;
    isActive?: boolean;

    constructor(data?: IBranch) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.branchId = _data["branchId"];
            this.branchName = _data["branchName"];
            this.branchCode = _data["branchCode"];
            this.bankId = _data["bankId"];
            this.bank = _data["bank"] ? Bank.fromJS(_data["bank"]) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static override fromJS(data: any): Branch {
        data = typeof data === 'object' ? data : {};
        let result = new Branch();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchId"] = this.branchId;
        data["branchName"] = this.branchName;
        data["branchCode"] = this.branchCode;
        data["bankId"] = this.bankId;
        data["bank"] = this.bank ? this.bank.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        super.toJSON(data);
        return data;
    }
}

export interface IBranch extends IAuditableEntity {
    branchId?: string;
    branchName?: string | undefined;
    branchCode?: string | undefined;
    bankId?: string;
    bank?: Bank | undefined;
    isActive?: boolean;
}

export class Bank extends AuditableEntity implements IBank {
    id?: string;
    bankName?: string | undefined;
    bankCode?: string | undefined;
    contactNo1?: string | undefined;
    address?: string | undefined;
    status?: string | undefined;
    contactPerson1?: string | undefined;
    contactPerson2?: string | undefined;
    contactNo2?: string | undefined;
    logo?: string | undefined;
    branches?: Branch[] | undefined;
    switchId?: string;
    switch?: Switch | undefined;
    cardOptions?: string | undefined;
    iBankId?: string | undefined;
    isTxnDbRegistered?: boolean;
    posHistory?: PosHistory | undefined;
    deployments?: Deployment[] | undefined;
    hardware?: Hardware[] | undefined;
    deploymentRequests?: DeploymentRequest[] | undefined;
    maintenances?: Maintenance[] | undefined;

    constructor(data?: IBank) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.bankName = _data["bankName"];
            this.bankCode = _data["bankCode"];
            this.contactNo1 = _data["contactNo1"];
            this.address = _data["address"];
            this.status = _data["status"];
            this.contactPerson1 = _data["contactPerson1"];
            this.contactPerson2 = _data["contactPerson2"];
            this.contactNo2 = _data["contactNo2"];
            this.logo = _data["logo"];
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(Branch.fromJS(item));
            }
            this.switchId = _data["switchId"];
            this.switch = _data["switch"] ? Switch.fromJS(_data["switch"]) : <any>undefined;
            this.cardOptions = _data["cardOptions"];
            this.iBankId = _data["iBankId"];
            this.isTxnDbRegistered = _data["isTxnDbRegistered"];
            this.posHistory = _data["posHistory"] ? PosHistory.fromJS(_data["posHistory"]) : <any>undefined;
            if (Array.isArray(_data["deployments"])) {
                this.deployments = [] as any;
                for (let item of _data["deployments"])
                    this.deployments!.push(Deployment.fromJS(item));
            }
            if (Array.isArray(_data["hardware"])) {
                this.hardware = [] as any;
                for (let item of _data["hardware"])
                    this.hardware!.push(Hardware.fromJS(item));
            }
            if (Array.isArray(_data["deploymentRequests"])) {
                this.deploymentRequests = [] as any;
                for (let item of _data["deploymentRequests"])
                    this.deploymentRequests!.push(DeploymentRequest.fromJS(item));
            }
            if (Array.isArray(_data["maintenances"])) {
                this.maintenances = [] as any;
                for (let item of _data["maintenances"])
                    this.maintenances!.push(Maintenance.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Bank {
        data = typeof data === 'object' ? data : {};
        let result = new Bank();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankName"] = this.bankName;
        data["bankCode"] = this.bankCode;
        data["contactNo1"] = this.contactNo1;
        data["address"] = this.address;
        data["status"] = this.status;
        data["contactPerson1"] = this.contactPerson1;
        data["contactPerson2"] = this.contactPerson2;
        data["contactNo2"] = this.contactNo2;
        data["logo"] = this.logo;
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item.toJSON());
        }
        data["switchId"] = this.switchId;
        data["switch"] = this.switch ? this.switch.toJSON() : <any>undefined;
        data["cardOptions"] = this.cardOptions;
        data["iBankId"] = this.iBankId;
        data["isTxnDbRegistered"] = this.isTxnDbRegistered;
        data["posHistory"] = this.posHistory ? this.posHistory.toJSON() : <any>undefined;
        if (Array.isArray(this.deployments)) {
            data["deployments"] = [];
            for (let item of this.deployments)
                data["deployments"].push(item.toJSON());
        }
        if (Array.isArray(this.hardware)) {
            data["hardware"] = [];
            for (let item of this.hardware)
                data["hardware"].push(item.toJSON());
        }
        if (Array.isArray(this.deploymentRequests)) {
            data["deploymentRequests"] = [];
            for (let item of this.deploymentRequests)
                data["deploymentRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.maintenances)) {
            data["maintenances"] = [];
            for (let item of this.maintenances)
                data["maintenances"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IBank extends IAuditableEntity {
    id?: string;
    bankName?: string | undefined;
    bankCode?: string | undefined;
    contactNo1?: string | undefined;
    address?: string | undefined;
    status?: string | undefined;
    contactPerson1?: string | undefined;
    contactPerson2?: string | undefined;
    contactNo2?: string | undefined;
    logo?: string | undefined;
    branches?: Branch[] | undefined;
    switchId?: string;
    switch?: Switch | undefined;
    cardOptions?: string | undefined;
    iBankId?: string | undefined;
    isTxnDbRegistered?: boolean;
    posHistory?: PosHistory | undefined;
    deployments?: Deployment[] | undefined;
    hardware?: Hardware[] | undefined;
    deploymentRequests?: DeploymentRequest[] | undefined;
    maintenances?: Maintenance[] | undefined;
}

export class Switch extends AuditableEntity implements ISwitch {
    id?: string;
    switchName?: string | undefined;
    banks?: Bank[] | undefined;

    constructor(data?: ISwitch) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.switchName = _data["switchName"];
            if (Array.isArray(_data["banks"])) {
                this.banks = [] as any;
                for (let item of _data["banks"])
                    this.banks!.push(Bank.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Switch {
        data = typeof data === 'object' ? data : {};
        let result = new Switch();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["switchName"] = this.switchName;
        if (Array.isArray(this.banks)) {
            data["banks"] = [];
            for (let item of this.banks)
                data["banks"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISwitch extends IAuditableEntity {
    id?: string;
    switchName?: string | undefined;
    banks?: Bank[] | undefined;
}

export class PosHistory extends AuditableEntity implements IPosHistory {
    id?: string;
    deploymentRequestId?: string;
    deploymentRequest?: DeploymentRequest | undefined;
    bankId?: string;
    bankName?: string | undefined;
    merchant?: string | undefined;
    outlet?: string | undefined;
    district?: string | undefined;
    address?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    terminalType?: string | undefined;
    currency?: string | undefined;
    tipAdjustment?: boolean;
    manualTransaction?: boolean;
    preAuthorization?: boolean;
    refund?: boolean;
    previousMerchantId?: string | undefined;
    previousTerminalId?: string | undefined;
    primaryTxnNumber?: string | undefined;
    secondaryTxnNumber?: string | undefined;
    primaryNacNumber?: string | undefined;
    secondaryNacNumber?: string | undefined;
    province?: string | undefined;
    merchantCategory?: string | undefined;
    priority?: boolean;
    remarks?: string | undefined;
    replacementReason?: ReplacementReason;
    statusId?: string;
    statusName?: string | undefined;
    requestName?: string | undefined;
    inventoryId?: string;
    serialNumberId?: string;
    serialNumber?: SerialNumber | undefined;
    serialKey?: string | undefined;
    applicationVersionId?: string;
    applicationDateVersion?: string | undefined;
    receivedBy?: string | undefined;
    connectivity?: string | undefined;
    merchantLocation?: string | undefined;
    latitude?: string | undefined;
    longitude?: string | undefined;
    image?: string | undefined;
    scanned?: string | undefined;
    remarksDeploy?: string | undefined;
    verifiedBy?: string | undefined;
    verifiedDate?: Date;
    deployDate?: Date;
    isReceived?: string | undefined;
    chargerStatus?: string | undefined;
    rollsReceived?: string | undefined;
    cableReceived?: string | undefined;
    inventory?: Inventory | undefined;
    bank?: Bank | undefined;
    applicationVersion?: ApplicationVersion | undefined;

    constructor(data?: IPosHistory) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.deploymentRequest = _data["deploymentRequest"] ? DeploymentRequest.fromJS(_data["deploymentRequest"]) : <any>undefined;
            this.bankId = _data["bankId"];
            this.bankName = _data["bankName"];
            this.merchant = _data["merchant"];
            this.outlet = _data["outlet"];
            this.district = _data["district"];
            this.address = _data["address"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo = _data["contactNo"];
            this.terminalType = _data["terminalType"];
            this.currency = _data["currency"];
            this.tipAdjustment = _data["tipAdjustment"];
            this.manualTransaction = _data["manualTransaction"];
            this.preAuthorization = _data["preAuthorization"];
            this.refund = _data["refund"];
            this.previousMerchantId = _data["previousMerchantId"];
            this.previousTerminalId = _data["previousTerminalId"];
            this.primaryTxnNumber = _data["primaryTxnNumber"];
            this.secondaryTxnNumber = _data["secondaryTxnNumber"];
            this.primaryNacNumber = _data["primaryNacNumber"];
            this.secondaryNacNumber = _data["secondaryNacNumber"];
            this.province = _data["province"];
            this.merchantCategory = _data["merchantCategory"];
            this.priority = _data["priority"];
            this.remarks = _data["remarks"];
            this.replacementReason = _data["replacementReason"];
            this.statusId = _data["statusId"];
            this.statusName = _data["statusName"];
            this.requestName = _data["requestName"];
            this.inventoryId = _data["inventoryId"];
            this.serialNumberId = _data["serialNumberId"];
            this.serialNumber = _data["serialNumber"] ? SerialNumber.fromJS(_data["serialNumber"]) : <any>undefined;
            this.serialKey = _data["serialKey"];
            this.applicationVersionId = _data["applicationVersionId"];
            this.applicationDateVersion = _data["applicationDateVersion"];
            this.receivedBy = _data["receivedBy"];
            this.connectivity = _data["connectivity"];
            this.merchantLocation = _data["merchantLocation"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.image = _data["image"];
            this.scanned = _data["scanned"];
            this.remarksDeploy = _data["remarksDeploy"];
            this.verifiedBy = _data["verifiedBy"];
            this.verifiedDate = _data["verifiedDate"] ? new Date(_data["verifiedDate"].toString()) : <any>undefined;
            this.deployDate = _data["deployDate"] ? new Date(_data["deployDate"].toString()) : <any>undefined;
            this.isReceived = _data["isReceived"];
            this.chargerStatus = _data["chargerStatus"];
            this.rollsReceived = _data["rollsReceived"];
            this.cableReceived = _data["cableReceived"];
            this.inventory = _data["inventory"] ? Inventory.fromJS(_data["inventory"]) : <any>undefined;
            this.bank = _data["bank"] ? Bank.fromJS(_data["bank"]) : <any>undefined;
            this.applicationVersion = _data["applicationVersion"] ? ApplicationVersion.fromJS(_data["applicationVersion"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): PosHistory {
        data = typeof data === 'object' ? data : {};
        let result = new PosHistory();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["deploymentRequest"] = this.deploymentRequest ? this.deploymentRequest.toJSON() : <any>undefined;
        data["bankId"] = this.bankId;
        data["bankName"] = this.bankName;
        data["merchant"] = this.merchant;
        data["outlet"] = this.outlet;
        data["district"] = this.district;
        data["address"] = this.address;
        data["contactPerson"] = this.contactPerson;
        data["contactNo"] = this.contactNo;
        data["terminalType"] = this.terminalType;
        data["currency"] = this.currency;
        data["tipAdjustment"] = this.tipAdjustment;
        data["manualTransaction"] = this.manualTransaction;
        data["preAuthorization"] = this.preAuthorization;
        data["refund"] = this.refund;
        data["previousMerchantId"] = this.previousMerchantId;
        data["previousTerminalId"] = this.previousTerminalId;
        data["primaryTxnNumber"] = this.primaryTxnNumber;
        data["secondaryTxnNumber"] = this.secondaryTxnNumber;
        data["primaryNacNumber"] = this.primaryNacNumber;
        data["secondaryNacNumber"] = this.secondaryNacNumber;
        data["province"] = this.province;
        data["merchantCategory"] = this.merchantCategory;
        data["priority"] = this.priority;
        data["remarks"] = this.remarks;
        data["replacementReason"] = this.replacementReason;
        data["statusId"] = this.statusId;
        data["statusName"] = this.statusName;
        data["requestName"] = this.requestName;
        data["inventoryId"] = this.inventoryId;
        data["serialNumberId"] = this.serialNumberId;
        data["serialNumber"] = this.serialNumber ? this.serialNumber.toJSON() : <any>undefined;
        data["serialKey"] = this.serialKey;
        data["applicationVersionId"] = this.applicationVersionId;
        data["applicationDateVersion"] = this.applicationDateVersion;
        data["receivedBy"] = this.receivedBy;
        data["connectivity"] = this.connectivity;
        data["merchantLocation"] = this.merchantLocation;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["image"] = this.image;
        data["scanned"] = this.scanned;
        data["remarksDeploy"] = this.remarksDeploy;
        data["verifiedBy"] = this.verifiedBy;
        data["verifiedDate"] = this.verifiedDate ? this.verifiedDate.toISOString() : <any>undefined;
        data["deployDate"] = this.deployDate ? this.deployDate.toISOString() : <any>undefined;
        data["isReceived"] = this.isReceived;
        data["chargerStatus"] = this.chargerStatus;
        data["rollsReceived"] = this.rollsReceived;
        data["cableReceived"] = this.cableReceived;
        data["inventory"] = this.inventory ? this.inventory.toJSON() : <any>undefined;
        data["bank"] = this.bank ? this.bank.toJSON() : <any>undefined;
        data["applicationVersion"] = this.applicationVersion ? this.applicationVersion.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPosHistory extends IAuditableEntity {
    id?: string;
    deploymentRequestId?: string;
    deploymentRequest?: DeploymentRequest | undefined;
    bankId?: string;
    bankName?: string | undefined;
    merchant?: string | undefined;
    outlet?: string | undefined;
    district?: string | undefined;
    address?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    terminalType?: string | undefined;
    currency?: string | undefined;
    tipAdjustment?: boolean;
    manualTransaction?: boolean;
    preAuthorization?: boolean;
    refund?: boolean;
    previousMerchantId?: string | undefined;
    previousTerminalId?: string | undefined;
    primaryTxnNumber?: string | undefined;
    secondaryTxnNumber?: string | undefined;
    primaryNacNumber?: string | undefined;
    secondaryNacNumber?: string | undefined;
    province?: string | undefined;
    merchantCategory?: string | undefined;
    priority?: boolean;
    remarks?: string | undefined;
    replacementReason?: ReplacementReason;
    statusId?: string;
    statusName?: string | undefined;
    requestName?: string | undefined;
    inventoryId?: string;
    serialNumberId?: string;
    serialNumber?: SerialNumber | undefined;
    serialKey?: string | undefined;
    applicationVersionId?: string;
    applicationDateVersion?: string | undefined;
    receivedBy?: string | undefined;
    connectivity?: string | undefined;
    merchantLocation?: string | undefined;
    latitude?: string | undefined;
    longitude?: string | undefined;
    image?: string | undefined;
    scanned?: string | undefined;
    remarksDeploy?: string | undefined;
    verifiedBy?: string | undefined;
    verifiedDate?: Date;
    deployDate?: Date;
    isReceived?: string | undefined;
    chargerStatus?: string | undefined;
    rollsReceived?: string | undefined;
    cableReceived?: string | undefined;
    inventory?: Inventory | undefined;
    bank?: Bank | undefined;
    applicationVersion?: ApplicationVersion | undefined;
}

export class DeploymentRequest extends AuditableEntity implements IDeploymentRequest {
    id?: string;
    bankId?: string;
    bank?: Bank | undefined;
    merchant?: string | undefined;
    idMerchant?: string | undefined;
    outlet?: string | undefined;
    district?: string | undefined;
    address?: string | undefined;
    contactPerson?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    idTerminal?: string | undefined;
    terminalType?: string | undefined;
    inventoryId?: string;
    inventory?: Inventory | undefined;
    rentalInventoryAdd?: string | undefined;
    currency?: string | undefined;
    tipAdjustment?: boolean;
    manualTransaction?: boolean;
    preAuthorization?: boolean;
    refund?: boolean;
    cashAdvance?: boolean;
    pinChange?: boolean;
    component1?: string | undefined;
    component2?: string | undefined;
    combineValue?: string | undefined;
    finalValue?: string | undefined;
    kvc1?: string | undefined;
    kvc2?: string | undefined;
    branchName?: string | undefined;
    mcc?: string | undefined;
    priority?: boolean;
    statusId?: string;
    status?: Status | undefined;
    remarks?: string | undefined;
    emailAddress?: string | undefined;
    panNumber?: string | undefined;
    businessNature?: string | undefined;
    remarksForDeploy?: string | undefined;
    verification?: string | undefined;
    requestTypeId?: string;
    requestType?: RequestType | undefined;
    deployment?: Deployment | undefined;
    configuration?: Configuration | undefined;
    requestedDate?: Date;
    rejected?: boolean;
    province?: string | undefined;
    merchantCategory?: string | undefined;
    bankRemarks?: string | undefined;
    settlementPrimaryId?: string | undefined;
    settlementSecondaryId?: string | undefined;
    transactionPrimaryId?: string | undefined;
    transactionSecondaryId?: string | undefined;
    merchantCategoryId?: string | undefined;
    ticketNumber?: string | undefined;
    removalStatuses?: RemovalStatus[] | undefined;
    additionalServices?: AdditionalService[] | undefined;
    sparesRequests?: SparesRequest[] | undefined;
    supports?: Support[] | undefined;
    deploymentStatus?: DeploymentStatus;
    maintenance?: Maintenance | undefined;
    notReceivedPos?: NotReceivedPos | undefined;
    imarkTerminal?: ImarkTerminal | undefined;
    deploymentActivityLogs?: DeploymentActivityLog[] | undefined;
    posHistory?: PosHistory[] | undefined;
    otherStocks?: OtherStock[] | undefined;

    constructor(data?: IDeploymentRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.bankId = _data["bankId"];
            this.bank = _data["bank"] ? Bank.fromJS(_data["bank"]) : <any>undefined;
            this.merchant = _data["merchant"];
            this.idMerchant = _data["idMerchant"];
            this.outlet = _data["outlet"];
            this.district = _data["district"];
            this.address = _data["address"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo1 = _data["contactNo1"];
            this.contactNo2 = _data["contactNo2"];
            this.idTerminal = _data["idTerminal"];
            this.terminalType = _data["terminalType"];
            this.inventoryId = _data["inventoryId"];
            this.inventory = _data["inventory"] ? Inventory.fromJS(_data["inventory"]) : <any>undefined;
            this.rentalInventoryAdd = _data["rentalInventoryAdd"];
            this.currency = _data["currency"];
            this.tipAdjustment = _data["tipAdjustment"];
            this.manualTransaction = _data["manualTransaction"];
            this.preAuthorization = _data["preAuthorization"];
            this.refund = _data["refund"];
            this.cashAdvance = _data["cashAdvance"];
            this.pinChange = _data["pinChange"];
            this.component1 = _data["component1"];
            this.component2 = _data["component2"];
            this.combineValue = _data["combineValue"];
            this.finalValue = _data["finalValue"];
            this.kvc1 = _data["kvc1"];
            this.kvc2 = _data["kvc2"];
            this.branchName = _data["branchName"];
            this.mcc = _data["mcc"];
            this.priority = _data["priority"];
            this.statusId = _data["statusId"];
            this.status = _data["status"] ? Status.fromJS(_data["status"]) : <any>undefined;
            this.remarks = _data["remarks"];
            this.emailAddress = _data["emailAddress"];
            this.panNumber = _data["panNumber"];
            this.businessNature = _data["businessNature"];
            this.remarksForDeploy = _data["remarksForDeploy"];
            this.verification = _data["verification"];
            this.requestTypeId = _data["requestTypeId"];
            this.requestType = _data["requestType"] ? RequestType.fromJS(_data["requestType"]) : <any>undefined;
            this.deployment = _data["deployment"] ? Deployment.fromJS(_data["deployment"]) : <any>undefined;
            this.configuration = _data["configuration"] ? Configuration.fromJS(_data["configuration"]) : <any>undefined;
            this.requestedDate = _data["requestedDate"] ? new Date(_data["requestedDate"].toString()) : <any>undefined;
            this.rejected = _data["rejected"];
            this.province = _data["province"];
            this.merchantCategory = _data["merchantCategory"];
            this.bankRemarks = _data["bankRemarks"];
            this.settlementPrimaryId = _data["settlementPrimaryId"];
            this.settlementSecondaryId = _data["settlementSecondaryId"];
            this.transactionPrimaryId = _data["transactionPrimaryId"];
            this.transactionSecondaryId = _data["transactionSecondaryId"];
            this.merchantCategoryId = _data["merchantCategoryId"];
            this.ticketNumber = _data["ticketNumber"];
            if (Array.isArray(_data["removalStatuses"])) {
                this.removalStatuses = [] as any;
                for (let item of _data["removalStatuses"])
                    this.removalStatuses!.push(RemovalStatus.fromJS(item));
            }
            if (Array.isArray(_data["additionalServices"])) {
                this.additionalServices = [] as any;
                for (let item of _data["additionalServices"])
                    this.additionalServices!.push(AdditionalService.fromJS(item));
            }
            if (Array.isArray(_data["sparesRequests"])) {
                this.sparesRequests = [] as any;
                for (let item of _data["sparesRequests"])
                    this.sparesRequests!.push(SparesRequest.fromJS(item));
            }
            if (Array.isArray(_data["supports"])) {
                this.supports = [] as any;
                for (let item of _data["supports"])
                    this.supports!.push(Support.fromJS(item));
            }
            this.deploymentStatus = _data["deploymentStatus"];
            this.maintenance = _data["maintenance"] ? Maintenance.fromJS(_data["maintenance"]) : <any>undefined;
            this.notReceivedPos = _data["notReceivedPos"] ? NotReceivedPos.fromJS(_data["notReceivedPos"]) : <any>undefined;
            this.imarkTerminal = _data["imarkTerminal"] ? ImarkTerminal.fromJS(_data["imarkTerminal"]) : <any>undefined;
            if (Array.isArray(_data["deploymentActivityLogs"])) {
                this.deploymentActivityLogs = [] as any;
                for (let item of _data["deploymentActivityLogs"])
                    this.deploymentActivityLogs!.push(DeploymentActivityLog.fromJS(item));
            }
            if (Array.isArray(_data["posHistory"])) {
                this.posHistory = [] as any;
                for (let item of _data["posHistory"])
                    this.posHistory!.push(PosHistory.fromJS(item));
            }
            if (Array.isArray(_data["otherStocks"])) {
                this.otherStocks = [] as any;
                for (let item of _data["otherStocks"])
                    this.otherStocks!.push(OtherStock.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): DeploymentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeploymentRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankId"] = this.bankId;
        data["bank"] = this.bank ? this.bank.toJSON() : <any>undefined;
        data["merchant"] = this.merchant;
        data["idMerchant"] = this.idMerchant;
        data["outlet"] = this.outlet;
        data["district"] = this.district;
        data["address"] = this.address;
        data["contactPerson"] = this.contactPerson;
        data["contactNo1"] = this.contactNo1;
        data["contactNo2"] = this.contactNo2;
        data["idTerminal"] = this.idTerminal;
        data["terminalType"] = this.terminalType;
        data["inventoryId"] = this.inventoryId;
        data["inventory"] = this.inventory ? this.inventory.toJSON() : <any>undefined;
        data["rentalInventoryAdd"] = this.rentalInventoryAdd;
        data["currency"] = this.currency;
        data["tipAdjustment"] = this.tipAdjustment;
        data["manualTransaction"] = this.manualTransaction;
        data["preAuthorization"] = this.preAuthorization;
        data["refund"] = this.refund;
        data["cashAdvance"] = this.cashAdvance;
        data["pinChange"] = this.pinChange;
        data["component1"] = this.component1;
        data["component2"] = this.component2;
        data["combineValue"] = this.combineValue;
        data["finalValue"] = this.finalValue;
        data["kvc1"] = this.kvc1;
        data["kvc2"] = this.kvc2;
        data["branchName"] = this.branchName;
        data["mcc"] = this.mcc;
        data["priority"] = this.priority;
        data["statusId"] = this.statusId;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["remarks"] = this.remarks;
        data["emailAddress"] = this.emailAddress;
        data["panNumber"] = this.panNumber;
        data["businessNature"] = this.businessNature;
        data["remarksForDeploy"] = this.remarksForDeploy;
        data["verification"] = this.verification;
        data["requestTypeId"] = this.requestTypeId;
        data["requestType"] = this.requestType ? this.requestType.toJSON() : <any>undefined;
        data["deployment"] = this.deployment ? this.deployment.toJSON() : <any>undefined;
        data["configuration"] = this.configuration ? this.configuration.toJSON() : <any>undefined;
        data["requestedDate"] = this.requestedDate ? this.requestedDate.toISOString() : <any>undefined;
        data["rejected"] = this.rejected;
        data["province"] = this.province;
        data["merchantCategory"] = this.merchantCategory;
        data["bankRemarks"] = this.bankRemarks;
        data["settlementPrimaryId"] = this.settlementPrimaryId;
        data["settlementSecondaryId"] = this.settlementSecondaryId;
        data["transactionPrimaryId"] = this.transactionPrimaryId;
        data["transactionSecondaryId"] = this.transactionSecondaryId;
        data["merchantCategoryId"] = this.merchantCategoryId;
        data["ticketNumber"] = this.ticketNumber;
        if (Array.isArray(this.removalStatuses)) {
            data["removalStatuses"] = [];
            for (let item of this.removalStatuses)
                data["removalStatuses"].push(item.toJSON());
        }
        if (Array.isArray(this.additionalServices)) {
            data["additionalServices"] = [];
            for (let item of this.additionalServices)
                data["additionalServices"].push(item.toJSON());
        }
        if (Array.isArray(this.sparesRequests)) {
            data["sparesRequests"] = [];
            for (let item of this.sparesRequests)
                data["sparesRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.supports)) {
            data["supports"] = [];
            for (let item of this.supports)
                data["supports"].push(item.toJSON());
        }
        data["deploymentStatus"] = this.deploymentStatus;
        data["maintenance"] = this.maintenance ? this.maintenance.toJSON() : <any>undefined;
        data["notReceivedPos"] = this.notReceivedPos ? this.notReceivedPos.toJSON() : <any>undefined;
        data["imarkTerminal"] = this.imarkTerminal ? this.imarkTerminal.toJSON() : <any>undefined;
        if (Array.isArray(this.deploymentActivityLogs)) {
            data["deploymentActivityLogs"] = [];
            for (let item of this.deploymentActivityLogs)
                data["deploymentActivityLogs"].push(item.toJSON());
        }
        if (Array.isArray(this.posHistory)) {
            data["posHistory"] = [];
            for (let item of this.posHistory)
                data["posHistory"].push(item.toJSON());
        }
        if (Array.isArray(this.otherStocks)) {
            data["otherStocks"] = [];
            for (let item of this.otherStocks)
                data["otherStocks"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDeploymentRequest extends IAuditableEntity {
    id?: string;
    bankId?: string;
    bank?: Bank | undefined;
    merchant?: string | undefined;
    idMerchant?: string | undefined;
    outlet?: string | undefined;
    district?: string | undefined;
    address?: string | undefined;
    contactPerson?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    idTerminal?: string | undefined;
    terminalType?: string | undefined;
    inventoryId?: string;
    inventory?: Inventory | undefined;
    rentalInventoryAdd?: string | undefined;
    currency?: string | undefined;
    tipAdjustment?: boolean;
    manualTransaction?: boolean;
    preAuthorization?: boolean;
    refund?: boolean;
    cashAdvance?: boolean;
    pinChange?: boolean;
    component1?: string | undefined;
    component2?: string | undefined;
    combineValue?: string | undefined;
    finalValue?: string | undefined;
    kvc1?: string | undefined;
    kvc2?: string | undefined;
    branchName?: string | undefined;
    mcc?: string | undefined;
    priority?: boolean;
    statusId?: string;
    status?: Status | undefined;
    remarks?: string | undefined;
    emailAddress?: string | undefined;
    panNumber?: string | undefined;
    businessNature?: string | undefined;
    remarksForDeploy?: string | undefined;
    verification?: string | undefined;
    requestTypeId?: string;
    requestType?: RequestType | undefined;
    deployment?: Deployment | undefined;
    configuration?: Configuration | undefined;
    requestedDate?: Date;
    rejected?: boolean;
    province?: string | undefined;
    merchantCategory?: string | undefined;
    bankRemarks?: string | undefined;
    settlementPrimaryId?: string | undefined;
    settlementSecondaryId?: string | undefined;
    transactionPrimaryId?: string | undefined;
    transactionSecondaryId?: string | undefined;
    merchantCategoryId?: string | undefined;
    ticketNumber?: string | undefined;
    removalStatuses?: RemovalStatus[] | undefined;
    additionalServices?: AdditionalService[] | undefined;
    sparesRequests?: SparesRequest[] | undefined;
    supports?: Support[] | undefined;
    deploymentStatus?: DeploymentStatus;
    maintenance?: Maintenance | undefined;
    notReceivedPos?: NotReceivedPos | undefined;
    imarkTerminal?: ImarkTerminal | undefined;
    deploymentActivityLogs?: DeploymentActivityLog[] | undefined;
    posHistory?: PosHistory[] | undefined;
    otherStocks?: OtherStock[] | undefined;
}

export class Inventory extends AuditableEntity implements IInventory {
    id?: string;
    os?: string | undefined;
    series?: string | undefined;
    model?: string | undefined;
    description?: string | undefined;
    connectivity?: string | undefined;
    shortName?: string | undefined;
    serialLength?: string | undefined;
    isConfigurations?: boolean;
    brandName?: string | undefined;
    cless?: boolean;
    ram?: string | undefined;
    rom?: string | undefined;
    osVersion?: string | undefined;
    inventorysAdd?: InventoryAdd[] | undefined;
    configurations?: Configuration[] | undefined;
    deploymentRequests?: DeploymentRequest[] | undefined;
    deployments?: Deployment[] | undefined;
    posStocks?: PosStock[] | undefined;
    maintenances?: Maintenance[] | undefined;
    notReceivedPos?: NotReceivedPos[] | undefined;
    damagePos?: DamagePos[] | undefined;

    constructor(data?: IInventory) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.os = _data["os"];
            this.series = _data["series"];
            this.model = _data["model"];
            this.description = _data["description"];
            this.connectivity = _data["connectivity"];
            this.shortName = _data["shortName"];
            this.serialLength = _data["serialLength"];
            this.isConfigurations = _data["isConfigurations"];
            this.brandName = _data["brandName"];
            this.cless = _data["cless"];
            this.ram = _data["ram"];
            this.rom = _data["rom"];
            this.osVersion = _data["osVersion"];
            if (Array.isArray(_data["inventorysAdd"])) {
                this.inventorysAdd = [] as any;
                for (let item of _data["inventorysAdd"])
                    this.inventorysAdd!.push(InventoryAdd.fromJS(item));
            }
            if (Array.isArray(_data["configurations"])) {
                this.configurations = [] as any;
                for (let item of _data["configurations"])
                    this.configurations!.push(Configuration.fromJS(item));
            }
            if (Array.isArray(_data["deploymentRequests"])) {
                this.deploymentRequests = [] as any;
                for (let item of _data["deploymentRequests"])
                    this.deploymentRequests!.push(DeploymentRequest.fromJS(item));
            }
            if (Array.isArray(_data["deployments"])) {
                this.deployments = [] as any;
                for (let item of _data["deployments"])
                    this.deployments!.push(Deployment.fromJS(item));
            }
            if (Array.isArray(_data["posStocks"])) {
                this.posStocks = [] as any;
                for (let item of _data["posStocks"])
                    this.posStocks!.push(PosStock.fromJS(item));
            }
            if (Array.isArray(_data["maintenances"])) {
                this.maintenances = [] as any;
                for (let item of _data["maintenances"])
                    this.maintenances!.push(Maintenance.fromJS(item));
            }
            if (Array.isArray(_data["notReceivedPos"])) {
                this.notReceivedPos = [] as any;
                for (let item of _data["notReceivedPos"])
                    this.notReceivedPos!.push(NotReceivedPos.fromJS(item));
            }
            if (Array.isArray(_data["damagePos"])) {
                this.damagePos = [] as any;
                for (let item of _data["damagePos"])
                    this.damagePos!.push(DamagePos.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Inventory {
        data = typeof data === 'object' ? data : {};
        let result = new Inventory();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["os"] = this.os;
        data["series"] = this.series;
        data["model"] = this.model;
        data["description"] = this.description;
        data["connectivity"] = this.connectivity;
        data["shortName"] = this.shortName;
        data["serialLength"] = this.serialLength;
        data["isConfigurations"] = this.isConfigurations;
        data["brandName"] = this.brandName;
        data["cless"] = this.cless;
        data["ram"] = this.ram;
        data["rom"] = this.rom;
        data["osVersion"] = this.osVersion;
        if (Array.isArray(this.inventorysAdd)) {
            data["inventorysAdd"] = [];
            for (let item of this.inventorysAdd)
                data["inventorysAdd"].push(item.toJSON());
        }
        if (Array.isArray(this.configurations)) {
            data["configurations"] = [];
            for (let item of this.configurations)
                data["configurations"].push(item.toJSON());
        }
        if (Array.isArray(this.deploymentRequests)) {
            data["deploymentRequests"] = [];
            for (let item of this.deploymentRequests)
                data["deploymentRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.deployments)) {
            data["deployments"] = [];
            for (let item of this.deployments)
                data["deployments"].push(item.toJSON());
        }
        if (Array.isArray(this.posStocks)) {
            data["posStocks"] = [];
            for (let item of this.posStocks)
                data["posStocks"].push(item.toJSON());
        }
        if (Array.isArray(this.maintenances)) {
            data["maintenances"] = [];
            for (let item of this.maintenances)
                data["maintenances"].push(item.toJSON());
        }
        if (Array.isArray(this.notReceivedPos)) {
            data["notReceivedPos"] = [];
            for (let item of this.notReceivedPos)
                data["notReceivedPos"].push(item.toJSON());
        }
        if (Array.isArray(this.damagePos)) {
            data["damagePos"] = [];
            for (let item of this.damagePos)
                data["damagePos"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IInventory extends IAuditableEntity {
    id?: string;
    os?: string | undefined;
    series?: string | undefined;
    model?: string | undefined;
    description?: string | undefined;
    connectivity?: string | undefined;
    shortName?: string | undefined;
    serialLength?: string | undefined;
    isConfigurations?: boolean;
    brandName?: string | undefined;
    cless?: boolean;
    ram?: string | undefined;
    rom?: string | undefined;
    osVersion?: string | undefined;
    inventorysAdd?: InventoryAdd[] | undefined;
    configurations?: Configuration[] | undefined;
    deploymentRequests?: DeploymentRequest[] | undefined;
    deployments?: Deployment[] | undefined;
    posStocks?: PosStock[] | undefined;
    maintenances?: Maintenance[] | undefined;
    notReceivedPos?: NotReceivedPos[] | undefined;
    damagePos?: DamagePos[] | undefined;
}

export class InventoryAdd extends AuditableEntity implements IInventoryAdd {
    id?: string;
    totalNumber?: number;
    buyDate?: Date;
    vendorName?: string | undefined;
    inventoryId?: string;
    inventory?: Inventory | undefined;
    posStocks?: PosStock[] | undefined;
    configurations?: Configuration[] | undefined;
    deployments?: Deployment[] | undefined;
    maintenances?: Maintenance[] | undefined;
    notReceivedPosList?: NotReceivedPos[] | undefined;
    damagePosList?: DamagePos[] | undefined;
    serialNumbers?: SerialNumber[] | undefined;

    constructor(data?: IInventoryAdd) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.totalNumber = _data["totalNumber"];
            this.buyDate = _data["buyDate"] ? new Date(_data["buyDate"].toString()) : <any>undefined;
            this.vendorName = _data["vendorName"];
            this.inventoryId = _data["inventoryId"];
            this.inventory = _data["inventory"] ? Inventory.fromJS(_data["inventory"]) : <any>undefined;
            if (Array.isArray(_data["posStocks"])) {
                this.posStocks = [] as any;
                for (let item of _data["posStocks"])
                    this.posStocks!.push(PosStock.fromJS(item));
            }
            if (Array.isArray(_data["configurations"])) {
                this.configurations = [] as any;
                for (let item of _data["configurations"])
                    this.configurations!.push(Configuration.fromJS(item));
            }
            if (Array.isArray(_data["deployments"])) {
                this.deployments = [] as any;
                for (let item of _data["deployments"])
                    this.deployments!.push(Deployment.fromJS(item));
            }
            if (Array.isArray(_data["maintenances"])) {
                this.maintenances = [] as any;
                for (let item of _data["maintenances"])
                    this.maintenances!.push(Maintenance.fromJS(item));
            }
            if (Array.isArray(_data["notReceivedPosList"])) {
                this.notReceivedPosList = [] as any;
                for (let item of _data["notReceivedPosList"])
                    this.notReceivedPosList!.push(NotReceivedPos.fromJS(item));
            }
            if (Array.isArray(_data["damagePosList"])) {
                this.damagePosList = [] as any;
                for (let item of _data["damagePosList"])
                    this.damagePosList!.push(DamagePos.fromJS(item));
            }
            if (Array.isArray(_data["serialNumbers"])) {
                this.serialNumbers = [] as any;
                for (let item of _data["serialNumbers"])
                    this.serialNumbers!.push(SerialNumber.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): InventoryAdd {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryAdd();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["totalNumber"] = this.totalNumber;
        data["buyDate"] = this.buyDate ? this.buyDate.toISOString() : <any>undefined;
        data["vendorName"] = this.vendorName;
        data["inventoryId"] = this.inventoryId;
        data["inventory"] = this.inventory ? this.inventory.toJSON() : <any>undefined;
        if (Array.isArray(this.posStocks)) {
            data["posStocks"] = [];
            for (let item of this.posStocks)
                data["posStocks"].push(item.toJSON());
        }
        if (Array.isArray(this.configurations)) {
            data["configurations"] = [];
            for (let item of this.configurations)
                data["configurations"].push(item.toJSON());
        }
        if (Array.isArray(this.deployments)) {
            data["deployments"] = [];
            for (let item of this.deployments)
                data["deployments"].push(item.toJSON());
        }
        if (Array.isArray(this.maintenances)) {
            data["maintenances"] = [];
            for (let item of this.maintenances)
                data["maintenances"].push(item.toJSON());
        }
        if (Array.isArray(this.notReceivedPosList)) {
            data["notReceivedPosList"] = [];
            for (let item of this.notReceivedPosList)
                data["notReceivedPosList"].push(item.toJSON());
        }
        if (Array.isArray(this.damagePosList)) {
            data["damagePosList"] = [];
            for (let item of this.damagePosList)
                data["damagePosList"].push(item.toJSON());
        }
        if (Array.isArray(this.serialNumbers)) {
            data["serialNumbers"] = [];
            for (let item of this.serialNumbers)
                data["serialNumbers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IInventoryAdd extends IAuditableEntity {
    id?: string;
    totalNumber?: number;
    buyDate?: Date;
    vendorName?: string | undefined;
    inventoryId?: string;
    inventory?: Inventory | undefined;
    posStocks?: PosStock[] | undefined;
    configurations?: Configuration[] | undefined;
    deployments?: Deployment[] | undefined;
    maintenances?: Maintenance[] | undefined;
    notReceivedPosList?: NotReceivedPos[] | undefined;
    damagePosList?: DamagePos[] | undefined;
    serialNumbers?: SerialNumber[] | undefined;
}

export class PosStock extends AuditableEntity implements IPosStock {
    id?: string;
    bankId?: string;
    bankName?: string | undefined;
    bank?: Bank | undefined;
    serialNumberId?: string;
    inventoryId?: string;
    serialNumberEntity?: SerialNumber | undefined;
    inventory?: Inventory | undefined;
    inventoryAddId?: string;
    deploymentId?: string | undefined;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    serialNumber?: string | undefined;
    stockDate?: Date;
    status?: string | undefined;
    remarks?: string | undefined;
    location?: string | undefined;

    constructor(data?: IPosStock) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.bankId = _data["bankId"];
            this.bankName = _data["bankName"];
            this.bank = _data["bank"] ? Bank.fromJS(_data["bank"]) : <any>undefined;
            this.serialNumberId = _data["serialNumberId"];
            this.inventoryId = _data["inventoryId"];
            this.serialNumberEntity = _data["serialNumberEntity"] ? SerialNumber.fromJS(_data["serialNumberEntity"]) : <any>undefined;
            this.inventory = _data["inventory"] ? Inventory.fromJS(_data["inventory"]) : <any>undefined;
            this.inventoryAddId = _data["inventoryAddId"];
            this.deploymentId = _data["deploymentId"];
            this.primaryItem = _data["primaryItem"];
            this.secondaryItem = _data["secondaryItem"];
            this.tertiaryItem = _data["tertiaryItem"];
            this.detailItem = _data["detailItem"];
            this.serialNumber = _data["serialNumber"];
            this.stockDate = _data["stockDate"] ? new Date(_data["stockDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.remarks = _data["remarks"];
            this.location = _data["location"];
        }
    }

    static override fromJS(data: any): PosStock {
        data = typeof data === 'object' ? data : {};
        let result = new PosStock();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankId"] = this.bankId;
        data["bankName"] = this.bankName;
        data["bank"] = this.bank ? this.bank.toJSON() : <any>undefined;
        data["serialNumberId"] = this.serialNumberId;
        data["inventoryId"] = this.inventoryId;
        data["serialNumberEntity"] = this.serialNumberEntity ? this.serialNumberEntity.toJSON() : <any>undefined;
        data["inventory"] = this.inventory ? this.inventory.toJSON() : <any>undefined;
        data["inventoryAddId"] = this.inventoryAddId;
        data["deploymentId"] = this.deploymentId;
        data["primaryItem"] = this.primaryItem;
        data["secondaryItem"] = this.secondaryItem;
        data["tertiaryItem"] = this.tertiaryItem;
        data["detailItem"] = this.detailItem;
        data["serialNumber"] = this.serialNumber;
        data["stockDate"] = this.stockDate ? this.stockDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["remarks"] = this.remarks;
        data["location"] = this.location;
        super.toJSON(data);
        return data;
    }
}

export interface IPosStock extends IAuditableEntity {
    id?: string;
    bankId?: string;
    bankName?: string | undefined;
    bank?: Bank | undefined;
    serialNumberId?: string;
    inventoryId?: string;
    serialNumberEntity?: SerialNumber | undefined;
    inventory?: Inventory | undefined;
    inventoryAddId?: string;
    deploymentId?: string | undefined;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    serialNumber?: string | undefined;
    stockDate?: Date;
    status?: string | undefined;
    remarks?: string | undefined;
    location?: string | undefined;
}

export class SerialNumber extends AuditableEntity implements ISerialNumber {
    id?: string;
    serialKey?: string | undefined;
    inventoryAdd?: InventoryAdd | undefined;
    inventoryAddId?: string;
    isSold?: boolean;
    isDeployed?: boolean;
    serialLength?: string | undefined;
    status?: SerialStatus;
    posStock?: PosStock | undefined;
    configuration?: Configuration | undefined;
    lostTerminal?: LostTerminal | undefined;
    maintenance?: Maintenance | undefined;
    notReceivedPos?: NotReceivedPos | undefined;
    posHistories?: PosHistory[] | undefined;

    constructor(data?: ISerialNumber) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.serialKey = _data["serialKey"];
            this.inventoryAdd = _data["inventoryAdd"] ? InventoryAdd.fromJS(_data["inventoryAdd"]) : <any>undefined;
            this.inventoryAddId = _data["inventoryAddId"];
            this.isSold = _data["isSold"];
            this.isDeployed = _data["isDeployed"];
            this.serialLength = _data["serialLength"];
            this.status = _data["status"];
            this.posStock = _data["posStock"] ? PosStock.fromJS(_data["posStock"]) : <any>undefined;
            this.configuration = _data["configuration"] ? Configuration.fromJS(_data["configuration"]) : <any>undefined;
            this.lostTerminal = _data["lostTerminal"] ? LostTerminal.fromJS(_data["lostTerminal"]) : <any>undefined;
            this.maintenance = _data["maintenance"] ? Maintenance.fromJS(_data["maintenance"]) : <any>undefined;
            this.notReceivedPos = _data["notReceivedPos"] ? NotReceivedPos.fromJS(_data["notReceivedPos"]) : <any>undefined;
            if (Array.isArray(_data["posHistories"])) {
                this.posHistories = [] as any;
                for (let item of _data["posHistories"])
                    this.posHistories!.push(PosHistory.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SerialNumber {
        data = typeof data === 'object' ? data : {};
        let result = new SerialNumber();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serialKey"] = this.serialKey;
        data["inventoryAdd"] = this.inventoryAdd ? this.inventoryAdd.toJSON() : <any>undefined;
        data["inventoryAddId"] = this.inventoryAddId;
        data["isSold"] = this.isSold;
        data["isDeployed"] = this.isDeployed;
        data["serialLength"] = this.serialLength;
        data["status"] = this.status;
        data["posStock"] = this.posStock ? this.posStock.toJSON() : <any>undefined;
        data["configuration"] = this.configuration ? this.configuration.toJSON() : <any>undefined;
        data["lostTerminal"] = this.lostTerminal ? this.lostTerminal.toJSON() : <any>undefined;
        data["maintenance"] = this.maintenance ? this.maintenance.toJSON() : <any>undefined;
        data["notReceivedPos"] = this.notReceivedPos ? this.notReceivedPos.toJSON() : <any>undefined;
        if (Array.isArray(this.posHistories)) {
            data["posHistories"] = [];
            for (let item of this.posHistories)
                data["posHistories"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISerialNumber extends IAuditableEntity {
    id?: string;
    serialKey?: string | undefined;
    inventoryAdd?: InventoryAdd | undefined;
    inventoryAddId?: string;
    isSold?: boolean;
    isDeployed?: boolean;
    serialLength?: string | undefined;
    status?: SerialStatus;
    posStock?: PosStock | undefined;
    configuration?: Configuration | undefined;
    lostTerminal?: LostTerminal | undefined;
    maintenance?: Maintenance | undefined;
    notReceivedPos?: NotReceivedPos | undefined;
    posHistories?: PosHistory[] | undefined;
}

export enum SerialStatus {
    InStock = 0,
    MerchantLocation = 1,
    NotReceived = 2,
    Configured = 3,
    InMaintainance = 4,
    Damaged = 5,
}

export class Configuration extends AuditableEntity implements IConfiguration {
    id?: string;
    deploymentRequestId?: string;
    deploymentRequest?: DeploymentRequest | undefined;
    verification?: string | undefined;
    serialNumberId?: string;
    serialNumber?: SerialNumber | undefined;
    applicationVersionId?: string;
    applicationVersion?: ApplicationVersion | undefined;
    serialKey?: string | undefined;
    inventoryId?: string;
    inventory?: Inventory | undefined;
    inventoryAddId?: string;
    inventoryAdd?: InventoryAdd | undefined;
    status?: string | undefined;
    isSale?: boolean;
    previousSerial?: string | undefined;
    contactOfPos?: string | undefined;
    limit?: string | undefined;
    isActive?: boolean;

    constructor(data?: IConfiguration) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.deploymentRequest = _data["deploymentRequest"] ? DeploymentRequest.fromJS(_data["deploymentRequest"]) : <any>undefined;
            this.verification = _data["verification"];
            this.serialNumberId = _data["serialNumberId"];
            this.serialNumber = _data["serialNumber"] ? SerialNumber.fromJS(_data["serialNumber"]) : <any>undefined;
            this.applicationVersionId = _data["applicationVersionId"];
            this.applicationVersion = _data["applicationVersion"] ? ApplicationVersion.fromJS(_data["applicationVersion"]) : <any>undefined;
            this.serialKey = _data["serialKey"];
            this.inventoryId = _data["inventoryId"];
            this.inventory = _data["inventory"] ? Inventory.fromJS(_data["inventory"]) : <any>undefined;
            this.inventoryAddId = _data["inventoryAddId"];
            this.inventoryAdd = _data["inventoryAdd"] ? InventoryAdd.fromJS(_data["inventoryAdd"]) : <any>undefined;
            this.status = _data["status"];
            this.isSale = _data["isSale"];
            this.previousSerial = _data["previousSerial"];
            this.contactOfPos = _data["contactOfPos"];
            this.limit = _data["limit"];
            this.isActive = _data["isActive"];
        }
    }

    static override fromJS(data: any): Configuration {
        data = typeof data === 'object' ? data : {};
        let result = new Configuration();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["deploymentRequest"] = this.deploymentRequest ? this.deploymentRequest.toJSON() : <any>undefined;
        data["verification"] = this.verification;
        data["serialNumberId"] = this.serialNumberId;
        data["serialNumber"] = this.serialNumber ? this.serialNumber.toJSON() : <any>undefined;
        data["applicationVersionId"] = this.applicationVersionId;
        data["applicationVersion"] = this.applicationVersion ? this.applicationVersion.toJSON() : <any>undefined;
        data["serialKey"] = this.serialKey;
        data["inventoryId"] = this.inventoryId;
        data["inventory"] = this.inventory ? this.inventory.toJSON() : <any>undefined;
        data["inventoryAddId"] = this.inventoryAddId;
        data["inventoryAdd"] = this.inventoryAdd ? this.inventoryAdd.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["isSale"] = this.isSale;
        data["previousSerial"] = this.previousSerial;
        data["contactOfPos"] = this.contactOfPos;
        data["limit"] = this.limit;
        data["isActive"] = this.isActive;
        super.toJSON(data);
        return data;
    }
}

export interface IConfiguration extends IAuditableEntity {
    id?: string;
    deploymentRequestId?: string;
    deploymentRequest?: DeploymentRequest | undefined;
    verification?: string | undefined;
    serialNumberId?: string;
    serialNumber?: SerialNumber | undefined;
    applicationVersionId?: string;
    applicationVersion?: ApplicationVersion | undefined;
    serialKey?: string | undefined;
    inventoryId?: string;
    inventory?: Inventory | undefined;
    inventoryAddId?: string;
    inventoryAdd?: InventoryAdd | undefined;
    status?: string | undefined;
    isSale?: boolean;
    previousSerial?: string | undefined;
    contactOfPos?: string | undefined;
    limit?: string | undefined;
    isActive?: boolean;
}

export class ApplicationVersion extends AuditableEntity implements IApplicationVersion {
    id?: string;
    applicationDate?: Date | undefined;
    bankId?: string | undefined;
    bank?: Bank | undefined;
    applicationVer?: string | undefined;
    kernelType?: string | undefined;
    remarks?: string | undefined;
    comments?: string | undefined;
    outdated?: string | undefined;
    configurations?: Configuration[] | undefined;

    constructor(data?: IApplicationVersion) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.applicationDate = _data["applicationDate"] ? new Date(_data["applicationDate"].toString()) : <any>undefined;
            this.bankId = _data["bankId"];
            this.bank = _data["bank"] ? Bank.fromJS(_data["bank"]) : <any>undefined;
            this.applicationVer = _data["applicationVer"];
            this.kernelType = _data["kernelType"];
            this.remarks = _data["remarks"];
            this.comments = _data["comments"];
            this.outdated = _data["outdated"];
            if (Array.isArray(_data["configurations"])) {
                this.configurations = [] as any;
                for (let item of _data["configurations"])
                    this.configurations!.push(Configuration.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ApplicationVersion {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationVersion();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["applicationDate"] = this.applicationDate ? this.applicationDate.toISOString() : <any>undefined;
        data["bankId"] = this.bankId;
        data["bank"] = this.bank ? this.bank.toJSON() : <any>undefined;
        data["applicationVer"] = this.applicationVer;
        data["kernelType"] = this.kernelType;
        data["remarks"] = this.remarks;
        data["comments"] = this.comments;
        data["outdated"] = this.outdated;
        if (Array.isArray(this.configurations)) {
            data["configurations"] = [];
            for (let item of this.configurations)
                data["configurations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IApplicationVersion extends IAuditableEntity {
    id?: string;
    applicationDate?: Date | undefined;
    bankId?: string | undefined;
    bank?: Bank | undefined;
    applicationVer?: string | undefined;
    kernelType?: string | undefined;
    remarks?: string | undefined;
    comments?: string | undefined;
    outdated?: string | undefined;
    configurations?: Configuration[] | undefined;
}

export class LostTerminal implements ILostTerminal {
    id?: string;
    idTerminal?: string | undefined;
    deploymentRequestId?: string;
    deploymentRequest?: DeploymentRequest | undefined;
    serialNumberId?: string;
    serialNumber?: SerialNumber | undefined;

    constructor(data?: ILostTerminal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idTerminal = _data["idTerminal"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.deploymentRequest = _data["deploymentRequest"] ? DeploymentRequest.fromJS(_data["deploymentRequest"]) : <any>undefined;
            this.serialNumberId = _data["serialNumberId"];
            this.serialNumber = _data["serialNumber"] ? SerialNumber.fromJS(_data["serialNumber"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LostTerminal {
        data = typeof data === 'object' ? data : {};
        let result = new LostTerminal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idTerminal"] = this.idTerminal;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["deploymentRequest"] = this.deploymentRequest ? this.deploymentRequest.toJSON() : <any>undefined;
        data["serialNumberId"] = this.serialNumberId;
        data["serialNumber"] = this.serialNumber ? this.serialNumber.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILostTerminal {
    id?: string;
    idTerminal?: string | undefined;
    deploymentRequestId?: string;
    deploymentRequest?: DeploymentRequest | undefined;
    serialNumberId?: string;
    serialNumber?: SerialNumber | undefined;
}

export class Maintenance extends AuditableEntity implements IMaintenance {
    id?: string;
    serialNumberId?: string;
    bankId?: string;
    inventoryId?: string;
    inventoryAddId?: string;
    serialNumber?: string | undefined;
    serialNumbers?: SerialNumber | undefined;
    deploymentRequestId?: string;
    applicationVersionId?: string;
    status?: string | undefined;
    terminate?: string | undefined;
    issue?: string | undefined;
    resolvedBy?: string | undefined;
    remarks?: string | undefined;
    verification?: string | undefined;
    verifiedBy?: string | undefined;
    verifiedDate?: Date;
    maintenanceIssue?: MaintenanceIssue[] | undefined;
    merchant?: string | undefined;
    outlet?: string | undefined;
    district?: string | undefined;
    address?: string | undefined;
    province?: string | undefined;
    merchantCategory?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    bank?: Bank | undefined;
    deploymentRequest?: DeploymentRequest | undefined;
    applicationVersion?: ApplicationVersion | undefined;
    inventory?: Inventory | undefined;

    constructor(data?: IMaintenance) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.serialNumberId = _data["serialNumberId"];
            this.bankId = _data["bankId"];
            this.inventoryId = _data["inventoryId"];
            this.inventoryAddId = _data["inventoryAddId"];
            this.serialNumber = _data["serialNumber"];
            this.serialNumbers = _data["serialNumbers"] ? SerialNumber.fromJS(_data["serialNumbers"]) : <any>undefined;
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.applicationVersionId = _data["applicationVersionId"];
            this.status = _data["status"];
            this.terminate = _data["terminate"];
            this.issue = _data["issue"];
            this.resolvedBy = _data["resolvedBy"];
            this.remarks = _data["remarks"];
            this.verification = _data["verification"];
            this.verifiedBy = _data["verifiedBy"];
            this.verifiedDate = _data["verifiedDate"] ? new Date(_data["verifiedDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["maintenanceIssue"])) {
                this.maintenanceIssue = [] as any;
                for (let item of _data["maintenanceIssue"])
                    this.maintenanceIssue!.push(MaintenanceIssue.fromJS(item));
            }
            this.merchant = _data["merchant"];
            this.outlet = _data["outlet"];
            this.district = _data["district"];
            this.address = _data["address"];
            this.province = _data["province"];
            this.merchantCategory = _data["merchantCategory"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo = _data["contactNo"];
            this.bank = _data["bank"] ? Bank.fromJS(_data["bank"]) : <any>undefined;
            this.deploymentRequest = _data["deploymentRequest"] ? DeploymentRequest.fromJS(_data["deploymentRequest"]) : <any>undefined;
            this.applicationVersion = _data["applicationVersion"] ? ApplicationVersion.fromJS(_data["applicationVersion"]) : <any>undefined;
            this.inventory = _data["inventory"] ? Inventory.fromJS(_data["inventory"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): Maintenance {
        data = typeof data === 'object' ? data : {};
        let result = new Maintenance();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serialNumberId"] = this.serialNumberId;
        data["bankId"] = this.bankId;
        data["inventoryId"] = this.inventoryId;
        data["inventoryAddId"] = this.inventoryAddId;
        data["serialNumber"] = this.serialNumber;
        data["serialNumbers"] = this.serialNumbers ? this.serialNumbers.toJSON() : <any>undefined;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["applicationVersionId"] = this.applicationVersionId;
        data["status"] = this.status;
        data["terminate"] = this.terminate;
        data["issue"] = this.issue;
        data["resolvedBy"] = this.resolvedBy;
        data["remarks"] = this.remarks;
        data["verification"] = this.verification;
        data["verifiedBy"] = this.verifiedBy;
        data["verifiedDate"] = this.verifiedDate ? this.verifiedDate.toISOString() : <any>undefined;
        if (Array.isArray(this.maintenanceIssue)) {
            data["maintenanceIssue"] = [];
            for (let item of this.maintenanceIssue)
                data["maintenanceIssue"].push(item.toJSON());
        }
        data["merchant"] = this.merchant;
        data["outlet"] = this.outlet;
        data["district"] = this.district;
        data["address"] = this.address;
        data["province"] = this.province;
        data["merchantCategory"] = this.merchantCategory;
        data["contactPerson"] = this.contactPerson;
        data["contactNo"] = this.contactNo;
        data["bank"] = this.bank ? this.bank.toJSON() : <any>undefined;
        data["deploymentRequest"] = this.deploymentRequest ? this.deploymentRequest.toJSON() : <any>undefined;
        data["applicationVersion"] = this.applicationVersion ? this.applicationVersion.toJSON() : <any>undefined;
        data["inventory"] = this.inventory ? this.inventory.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IMaintenance extends IAuditableEntity {
    id?: string;
    serialNumberId?: string;
    bankId?: string;
    inventoryId?: string;
    inventoryAddId?: string;
    serialNumber?: string | undefined;
    serialNumbers?: SerialNumber | undefined;
    deploymentRequestId?: string;
    applicationVersionId?: string;
    status?: string | undefined;
    terminate?: string | undefined;
    issue?: string | undefined;
    resolvedBy?: string | undefined;
    remarks?: string | undefined;
    verification?: string | undefined;
    verifiedBy?: string | undefined;
    verifiedDate?: Date;
    maintenanceIssue?: MaintenanceIssue[] | undefined;
    merchant?: string | undefined;
    outlet?: string | undefined;
    district?: string | undefined;
    address?: string | undefined;
    province?: string | undefined;
    merchantCategory?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    bank?: Bank | undefined;
    deploymentRequest?: DeploymentRequest | undefined;
    applicationVersion?: ApplicationVersion | undefined;
    inventory?: Inventory | undefined;
}

export class MaintenanceIssue extends AuditableEntity implements IMaintenanceIssue {
    id?: number;
    issue?: string | undefined;
    remarks?: string | undefined;
    maintenance?: Maintenance | undefined;
    maintenanceId?: string;

    constructor(data?: IMaintenanceIssue) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.issue = _data["issue"];
            this.remarks = _data["remarks"];
            this.maintenance = _data["maintenance"] ? Maintenance.fromJS(_data["maintenance"]) : <any>undefined;
            this.maintenanceId = _data["maintenanceId"];
        }
    }

    static override fromJS(data: any): MaintenanceIssue {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceIssue();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["issue"] = this.issue;
        data["remarks"] = this.remarks;
        data["maintenance"] = this.maintenance ? this.maintenance.toJSON() : <any>undefined;
        data["maintenanceId"] = this.maintenanceId;
        super.toJSON(data);
        return data;
    }
}

export interface IMaintenanceIssue extends IAuditableEntity {
    id?: number;
    issue?: string | undefined;
    remarks?: string | undefined;
    maintenance?: Maintenance | undefined;
    maintenanceId?: string;
}

export class NotReceivedPos extends AuditableEntity implements INotReceivedPos {
    id?: string;
    deploymentRequestId?: string;
    deploymentRequest?: DeploymentRequest | undefined;
    applicationVersionId?: string;
    applicationVersion?: ApplicationVersion | undefined;
    inventoryId?: string;
    inventory?: Inventory | undefined;
    inventoryAddId?: string;
    inventoryAdd?: InventoryAdd | undefined;
    status?: string | undefined;
    deployedLocation?: string | undefined;
    receivedBy?: string | undefined;
    receivedContactNo?: string | undefined;
    serialNumberId?: string;
    serialNumber?: SerialNumber | undefined;
    merchant?: string | undefined;
    outlet?: string | undefined;
    district?: string | undefined;
    address?: string | undefined;
    province?: string | undefined;
    merchantCategory?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    statusReason?: string | undefined;
    posNotReceivedStatus?: PosNotReceivedStatus | undefined;

    constructor(data?: INotReceivedPos) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.deploymentRequest = _data["deploymentRequest"] ? DeploymentRequest.fromJS(_data["deploymentRequest"]) : <any>undefined;
            this.applicationVersionId = _data["applicationVersionId"];
            this.applicationVersion = _data["applicationVersion"] ? ApplicationVersion.fromJS(_data["applicationVersion"]) : <any>undefined;
            this.inventoryId = _data["inventoryId"];
            this.inventory = _data["inventory"] ? Inventory.fromJS(_data["inventory"]) : <any>undefined;
            this.inventoryAddId = _data["inventoryAddId"];
            this.inventoryAdd = _data["inventoryAdd"] ? InventoryAdd.fromJS(_data["inventoryAdd"]) : <any>undefined;
            this.status = _data["status"];
            this.deployedLocation = _data["deployedLocation"];
            this.receivedBy = _data["receivedBy"];
            this.receivedContactNo = _data["receivedContactNo"];
            this.serialNumberId = _data["serialNumberId"];
            this.serialNumber = _data["serialNumber"] ? SerialNumber.fromJS(_data["serialNumber"]) : <any>undefined;
            this.merchant = _data["merchant"];
            this.outlet = _data["outlet"];
            this.district = _data["district"];
            this.address = _data["address"];
            this.province = _data["province"];
            this.merchantCategory = _data["merchantCategory"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo = _data["contactNo"];
            this.statusReason = _data["statusReason"];
            this.posNotReceivedStatus = _data["posNotReceivedStatus"];
        }
    }

    static override fromJS(data: any): NotReceivedPos {
        data = typeof data === 'object' ? data : {};
        let result = new NotReceivedPos();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["deploymentRequest"] = this.deploymentRequest ? this.deploymentRequest.toJSON() : <any>undefined;
        data["applicationVersionId"] = this.applicationVersionId;
        data["applicationVersion"] = this.applicationVersion ? this.applicationVersion.toJSON() : <any>undefined;
        data["inventoryId"] = this.inventoryId;
        data["inventory"] = this.inventory ? this.inventory.toJSON() : <any>undefined;
        data["inventoryAddId"] = this.inventoryAddId;
        data["inventoryAdd"] = this.inventoryAdd ? this.inventoryAdd.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["deployedLocation"] = this.deployedLocation;
        data["receivedBy"] = this.receivedBy;
        data["receivedContactNo"] = this.receivedContactNo;
        data["serialNumberId"] = this.serialNumberId;
        data["serialNumber"] = this.serialNumber ? this.serialNumber.toJSON() : <any>undefined;
        data["merchant"] = this.merchant;
        data["outlet"] = this.outlet;
        data["district"] = this.district;
        data["address"] = this.address;
        data["province"] = this.province;
        data["merchantCategory"] = this.merchantCategory;
        data["contactPerson"] = this.contactPerson;
        data["contactNo"] = this.contactNo;
        data["statusReason"] = this.statusReason;
        data["posNotReceivedStatus"] = this.posNotReceivedStatus;
        super.toJSON(data);
        return data;
    }
}

export interface INotReceivedPos extends IAuditableEntity {
    id?: string;
    deploymentRequestId?: string;
    deploymentRequest?: DeploymentRequest | undefined;
    applicationVersionId?: string;
    applicationVersion?: ApplicationVersion | undefined;
    inventoryId?: string;
    inventory?: Inventory | undefined;
    inventoryAddId?: string;
    inventoryAdd?: InventoryAdd | undefined;
    status?: string | undefined;
    deployedLocation?: string | undefined;
    receivedBy?: string | undefined;
    receivedContactNo?: string | undefined;
    serialNumberId?: string;
    serialNumber?: SerialNumber | undefined;
    merchant?: string | undefined;
    outlet?: string | undefined;
    district?: string | undefined;
    address?: string | undefined;
    province?: string | undefined;
    merchantCategory?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    statusReason?: string | undefined;
    posNotReceivedStatus?: PosNotReceivedStatus | undefined;
}

export enum PosNotReceivedStatus {
    Retrieved = 1,
    ReConfigure = 2,
}

export class Deployment extends AuditableEntity implements IDeployment {
    id?: string;
    receivedBy?: string | undefined;
    connectivity?: string | undefined;
    merchantLocation?: string | undefined;
    deployedBy?: string | undefined;
    receivedContactNo?: string | undefined;
    latitude?: string | undefined;
    longitude?: string | undefined;
    image?: string | undefined;
    scanned?: string | undefined;
    remarks?: string | undefined;
    statusForDeploy?: string | undefined;
    deploymentRequestId?: string;
    deploymentRequest?: DeploymentRequest | undefined;
    deployDate?: Date;
    verification?: string | undefined;
    bankId?: string;
    bankName?: string | undefined;
    inventoryId?: string;
    inventoryAddId?: string | undefined;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    dispatch?: boolean;
    stickersleft?: string | undefined;
    rollsdelivered?: string | undefined;
    bank?: Bank | undefined;
    deployedAt?: DeployedAtLocation;

    constructor(data?: IDeployment) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.receivedBy = _data["receivedBy"];
            this.connectivity = _data["connectivity"];
            this.merchantLocation = _data["merchantLocation"];
            this.deployedBy = _data["deployedBy"];
            this.receivedContactNo = _data["receivedContactNo"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.image = _data["image"];
            this.scanned = _data["scanned"];
            this.remarks = _data["remarks"];
            this.statusForDeploy = _data["statusForDeploy"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.deploymentRequest = _data["deploymentRequest"] ? DeploymentRequest.fromJS(_data["deploymentRequest"]) : <any>undefined;
            this.deployDate = _data["deployDate"] ? new Date(_data["deployDate"].toString()) : <any>undefined;
            this.verification = _data["verification"];
            this.bankId = _data["bankId"];
            this.bankName = _data["bankName"];
            this.inventoryId = _data["inventoryId"];
            this.inventoryAddId = _data["inventoryAddId"];
            this.primaryItem = _data["primaryItem"];
            this.secondaryItem = _data["secondaryItem"];
            this.tertiaryItem = _data["tertiaryItem"];
            this.detailItem = _data["detailItem"];
            this.dispatch = _data["dispatch"];
            this.stickersleft = _data["stickersleft"];
            this.rollsdelivered = _data["rollsdelivered"];
            this.bank = _data["bank"] ? Bank.fromJS(_data["bank"]) : <any>undefined;
            this.deployedAt = _data["deployedAt"];
        }
    }

    static override fromJS(data: any): Deployment {
        data = typeof data === 'object' ? data : {};
        let result = new Deployment();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["receivedBy"] = this.receivedBy;
        data["connectivity"] = this.connectivity;
        data["merchantLocation"] = this.merchantLocation;
        data["deployedBy"] = this.deployedBy;
        data["receivedContactNo"] = this.receivedContactNo;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["image"] = this.image;
        data["scanned"] = this.scanned;
        data["remarks"] = this.remarks;
        data["statusForDeploy"] = this.statusForDeploy;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["deploymentRequest"] = this.deploymentRequest ? this.deploymentRequest.toJSON() : <any>undefined;
        data["deployDate"] = this.deployDate ? this.deployDate.toISOString() : <any>undefined;
        data["verification"] = this.verification;
        data["bankId"] = this.bankId;
        data["bankName"] = this.bankName;
        data["inventoryId"] = this.inventoryId;
        data["inventoryAddId"] = this.inventoryAddId;
        data["primaryItem"] = this.primaryItem;
        data["secondaryItem"] = this.secondaryItem;
        data["tertiaryItem"] = this.tertiaryItem;
        data["detailItem"] = this.detailItem;
        data["dispatch"] = this.dispatch;
        data["stickersleft"] = this.stickersleft;
        data["rollsdelivered"] = this.rollsdelivered;
        data["bank"] = this.bank ? this.bank.toJSON() : <any>undefined;
        data["deployedAt"] = this.deployedAt;
        super.toJSON(data);
        return data;
    }
}

export interface IDeployment extends IAuditableEntity {
    id?: string;
    receivedBy?: string | undefined;
    connectivity?: string | undefined;
    merchantLocation?: string | undefined;
    deployedBy?: string | undefined;
    receivedContactNo?: string | undefined;
    latitude?: string | undefined;
    longitude?: string | undefined;
    image?: string | undefined;
    scanned?: string | undefined;
    remarks?: string | undefined;
    statusForDeploy?: string | undefined;
    deploymentRequestId?: string;
    deploymentRequest?: DeploymentRequest | undefined;
    deployDate?: Date;
    verification?: string | undefined;
    bankId?: string;
    bankName?: string | undefined;
    inventoryId?: string;
    inventoryAddId?: string | undefined;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    dispatch?: boolean;
    stickersleft?: string | undefined;
    rollsdelivered?: string | undefined;
    bank?: Bank | undefined;
    deployedAt?: DeployedAtLocation;
}

export enum DeployedAtLocation {
    Bank = 1,
    MerchantLocation = 2,
}

export class DamagePos extends AuditableEntity implements IDamagePos {
    id?: string;
    deploymentRequestId?: string;
    applicationVersionId?: string;
    inventoryId?: string;
    inventory?: Inventory | undefined;
    inventoryAddId?: string;
    inventoryAdd?: InventoryAdd | undefined;
    status?: string | undefined;
    serialNumberId?: string;
    merchant?: string | undefined;
    outlet?: string | undefined;
    district?: string | undefined;
    province?: string | undefined;
    merchantCategory?: string | undefined;
    address?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    deploymentRequest?: DeploymentRequest | undefined;

    constructor(data?: IDamagePos) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.applicationVersionId = _data["applicationVersionId"];
            this.inventoryId = _data["inventoryId"];
            this.inventory = _data["inventory"] ? Inventory.fromJS(_data["inventory"]) : <any>undefined;
            this.inventoryAddId = _data["inventoryAddId"];
            this.inventoryAdd = _data["inventoryAdd"] ? InventoryAdd.fromJS(_data["inventoryAdd"]) : <any>undefined;
            this.status = _data["status"];
            this.serialNumberId = _data["serialNumberId"];
            this.merchant = _data["merchant"];
            this.outlet = _data["outlet"];
            this.district = _data["district"];
            this.province = _data["province"];
            this.merchantCategory = _data["merchantCategory"];
            this.address = _data["address"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo = _data["contactNo"];
            this.deploymentRequest = _data["deploymentRequest"] ? DeploymentRequest.fromJS(_data["deploymentRequest"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): DamagePos {
        data = typeof data === 'object' ? data : {};
        let result = new DamagePos();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["applicationVersionId"] = this.applicationVersionId;
        data["inventoryId"] = this.inventoryId;
        data["inventory"] = this.inventory ? this.inventory.toJSON() : <any>undefined;
        data["inventoryAddId"] = this.inventoryAddId;
        data["inventoryAdd"] = this.inventoryAdd ? this.inventoryAdd.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["serialNumberId"] = this.serialNumberId;
        data["merchant"] = this.merchant;
        data["outlet"] = this.outlet;
        data["district"] = this.district;
        data["province"] = this.province;
        data["merchantCategory"] = this.merchantCategory;
        data["address"] = this.address;
        data["contactPerson"] = this.contactPerson;
        data["contactNo"] = this.contactNo;
        data["deploymentRequest"] = this.deploymentRequest ? this.deploymentRequest.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IDamagePos extends IAuditableEntity {
    id?: string;
    deploymentRequestId?: string;
    applicationVersionId?: string;
    inventoryId?: string;
    inventory?: Inventory | undefined;
    inventoryAddId?: string;
    inventoryAdd?: InventoryAdd | undefined;
    status?: string | undefined;
    serialNumberId?: string;
    merchant?: string | undefined;
    outlet?: string | undefined;
    district?: string | undefined;
    province?: string | undefined;
    merchantCategory?: string | undefined;
    address?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    deploymentRequest?: DeploymentRequest | undefined;
}

export class Status extends AuditableEntity implements IStatus {
    id?: string;
    statusName?: string | undefined;

    constructor(data?: IStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.statusName = _data["statusName"];
        }
    }

    static override fromJS(data: any): Status {
        data = typeof data === 'object' ? data : {};
        let result = new Status();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statusName"] = this.statusName;
        super.toJSON(data);
        return data;
    }
}

export interface IStatus extends IAuditableEntity {
    id?: string;
    statusName?: string | undefined;
}

export class RequestType extends AuditableEntity implements IRequestType {
    id?: string;
    requestName?: string | undefined;

    constructor(data?: IRequestType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.requestName = _data["requestName"];
        }
    }

    static override fromJS(data: any): RequestType {
        data = typeof data === 'object' ? data : {};
        let result = new RequestType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["requestName"] = this.requestName;
        super.toJSON(data);
        return data;
    }
}

export interface IRequestType extends IAuditableEntity {
    id?: string;
    requestName?: string | undefined;
}

export class RemovalStatus extends AuditableEntity implements IRemovalStatus {
    id?: string;
    deploymentRequest?: DeploymentRequest | undefined;
    deploymentRequestId?: string;
    pendingRemovalReason?: RemovalStatusReason;

    constructor(data?: IRemovalStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.deploymentRequest = _data["deploymentRequest"] ? DeploymentRequest.fromJS(_data["deploymentRequest"]) : <any>undefined;
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.pendingRemovalReason = _data["pendingRemovalReason"];
        }
    }

    static override fromJS(data: any): RemovalStatus {
        data = typeof data === 'object' ? data : {};
        let result = new RemovalStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deploymentRequest"] = this.deploymentRequest ? this.deploymentRequest.toJSON() : <any>undefined;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["pendingRemovalReason"] = this.pendingRemovalReason;
        super.toJSON(data);
        return data;
    }
}

export interface IRemovalStatus extends IAuditableEntity {
    id?: string;
    deploymentRequest?: DeploymentRequest | undefined;
    deploymentRequestId?: string;
    pendingRemovalReason?: RemovalStatusReason;
}

export enum RemovalStatusReason {
    AlreadyRemovedByBank = 1,
    CallNotReachable = 2,
    CallNotReceived = 3,
    ContactNumberNotAvailable = 4,
    OutletIsTemporarilyClosed = 5,
    DeniedToHandOver = 6,
    HoldByBank = 8,
    MerchantWillDelieverTheTerminalToNearestBranch = 11,
    OutletIsPermanentlyClosed = 13,
    ReadyToRemove = 14,
    RequestCancelledByBank = 15,
    PhoneSwitchedOff = 16,
    TerminalLost = 17,
    TerminalNotFoundAtLocation = 18,
    WrongNumber = 19,
    UnreachableLocation = 23,
    MerchantWantsToContinue = 25,
    MerchantIsCurrentlyOutOfHisOutlet = 27,
    MerchantNotReceivedPOS = 29,
    TerminalMisplacedByMerchant = 30,
    MerchantNotFoundAtPreviouslyDeployedLocation = 31,
    MerchantHadAlreadyDeliveredToBank = 33,
    MerchantHasSoldTheBusiness = 34,
    TerminalDamagedByMerchant = 35,
}

export class AdditionalService extends AuditableEntity implements IAdditionalService {
    id?: string;
    deploymentRequestId?: string;
    paymentScheme?: PaymentScheme;
    isActive?: boolean;
    acquirerMerchantId?: string | undefined;
    acquirerTerminalId?: string | undefined;
    imid?: number;
    itid?: number;

    constructor(data?: IAdditionalService) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.paymentScheme = _data["paymentScheme"];
            this.isActive = _data["isActive"];
            this.acquirerMerchantId = _data["acquirerMerchantId"];
            this.acquirerTerminalId = _data["acquirerTerminalId"];
            this.imid = _data["imid"];
            this.itid = _data["itid"];
        }
    }

    static override fromJS(data: any): AdditionalService {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalService();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["paymentScheme"] = this.paymentScheme;
        data["isActive"] = this.isActive;
        data["acquirerMerchantId"] = this.acquirerMerchantId;
        data["acquirerTerminalId"] = this.acquirerTerminalId;
        data["imid"] = this.imid;
        data["itid"] = this.itid;
        super.toJSON(data);
        return data;
    }
}

export interface IAdditionalService extends IAuditableEntity {
    id?: string;
    deploymentRequestId?: string;
    paymentScheme?: PaymentScheme;
    isActive?: boolean;
    acquirerMerchantId?: string | undefined;
    acquirerTerminalId?: string | undefined;
    imid?: number;
    itid?: number;
}

export enum PaymentScheme {
    Card = 1,
    NepalPay = 2,
    Fonepay = 3,
}

export class SparesRequest extends AuditableEntity implements ISparesRequest {
    id?: string;
    bankId?: string;
    bank?: Bank | undefined;
    merchantId?: string | undefined;
    accessoryId?: string;
    accessory?: Accessory | undefined;
    requested_Quantity?: number;
    dispatch_Quantity?: number;
    requested_Date?: Date;
    dispatch_Date?: Date;
    cancelRemarks?: string | undefined;
    status?: boolean;
    location?: string | undefined;
    verification?: string | undefined;
    contactNumber?: string | undefined;
    contactPerson?: string | undefined;
    remarks?: string | undefined;
    deploymentRequestId?: string | undefined;
    deploymentRequest?: DeploymentRequest | undefined;
    spareRequestStatus?: SpareRequestStatus;

    constructor(data?: ISparesRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.bankId = _data["bankId"];
            this.bank = _data["bank"] ? Bank.fromJS(_data["bank"]) : <any>undefined;
            this.merchantId = _data["merchantId"];
            this.accessoryId = _data["accessoryId"];
            this.accessory = _data["accessory"] ? Accessory.fromJS(_data["accessory"]) : <any>undefined;
            this.requested_Quantity = _data["requested_Quantity"];
            this.dispatch_Quantity = _data["dispatch_Quantity"];
            this.requested_Date = _data["requested_Date"] ? new Date(_data["requested_Date"].toString()) : <any>undefined;
            this.dispatch_Date = _data["dispatch_Date"] ? new Date(_data["dispatch_Date"].toString()) : <any>undefined;
            this.cancelRemarks = _data["cancelRemarks"];
            this.status = _data["status"];
            this.location = _data["location"];
            this.verification = _data["verification"];
            this.contactNumber = _data["contactNumber"];
            this.contactPerson = _data["contactPerson"];
            this.remarks = _data["remarks"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.deploymentRequest = _data["deploymentRequest"] ? DeploymentRequest.fromJS(_data["deploymentRequest"]) : <any>undefined;
            this.spareRequestStatus = _data["spareRequestStatus"];
        }
    }

    static override fromJS(data: any): SparesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SparesRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankId"] = this.bankId;
        data["bank"] = this.bank ? this.bank.toJSON() : <any>undefined;
        data["merchantId"] = this.merchantId;
        data["accessoryId"] = this.accessoryId;
        data["accessory"] = this.accessory ? this.accessory.toJSON() : <any>undefined;
        data["requested_Quantity"] = this.requested_Quantity;
        data["dispatch_Quantity"] = this.dispatch_Quantity;
        data["requested_Date"] = this.requested_Date ? this.requested_Date.toISOString() : <any>undefined;
        data["dispatch_Date"] = this.dispatch_Date ? this.dispatch_Date.toISOString() : <any>undefined;
        data["cancelRemarks"] = this.cancelRemarks;
        data["status"] = this.status;
        data["location"] = this.location;
        data["verification"] = this.verification;
        data["contactNumber"] = this.contactNumber;
        data["contactPerson"] = this.contactPerson;
        data["remarks"] = this.remarks;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["deploymentRequest"] = this.deploymentRequest ? this.deploymentRequest.toJSON() : <any>undefined;
        data["spareRequestStatus"] = this.spareRequestStatus;
        super.toJSON(data);
        return data;
    }
}

export interface ISparesRequest extends IAuditableEntity {
    id?: string;
    bankId?: string;
    bank?: Bank | undefined;
    merchantId?: string | undefined;
    accessoryId?: string;
    accessory?: Accessory | undefined;
    requested_Quantity?: number;
    dispatch_Quantity?: number;
    requested_Date?: Date;
    dispatch_Date?: Date;
    cancelRemarks?: string | undefined;
    status?: boolean;
    location?: string | undefined;
    verification?: string | undefined;
    contactNumber?: string | undefined;
    contactPerson?: string | undefined;
    remarks?: string | undefined;
    deploymentRequestId?: string | undefined;
    deploymentRequest?: DeploymentRequest | undefined;
    spareRequestStatus?: SpareRequestStatus;
}

export class Accessory extends AuditableEntity implements IAccessory {
    id?: string;
    bank?: Bank | undefined;
    bankId?: string | undefined;
    detailItem?: string | undefined;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    accessoryAdds?: AccessoryAdd[] | undefined;
    otherStocks?: OtherStock[] | undefined;
    sparesSales?: SparesSales[] | undefined;
    sparesRequests?: SparesRequest[] | undefined;

    constructor(data?: IAccessory) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.bank = _data["bank"] ? Bank.fromJS(_data["bank"]) : <any>undefined;
            this.bankId = _data["bankId"];
            this.detailItem = _data["detailItem"];
            this.primaryItem = _data["primaryItem"];
            this.secondaryItem = _data["secondaryItem"];
            this.tertiaryItem = _data["tertiaryItem"];
            if (Array.isArray(_data["accessoryAdds"])) {
                this.accessoryAdds = [] as any;
                for (let item of _data["accessoryAdds"])
                    this.accessoryAdds!.push(AccessoryAdd.fromJS(item));
            }
            if (Array.isArray(_data["otherStocks"])) {
                this.otherStocks = [] as any;
                for (let item of _data["otherStocks"])
                    this.otherStocks!.push(OtherStock.fromJS(item));
            }
            if (Array.isArray(_data["sparesSales"])) {
                this.sparesSales = [] as any;
                for (let item of _data["sparesSales"])
                    this.sparesSales!.push(SparesSales.fromJS(item));
            }
            if (Array.isArray(_data["sparesRequests"])) {
                this.sparesRequests = [] as any;
                for (let item of _data["sparesRequests"])
                    this.sparesRequests!.push(SparesRequest.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Accessory {
        data = typeof data === 'object' ? data : {};
        let result = new Accessory();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bank"] = this.bank ? this.bank.toJSON() : <any>undefined;
        data["bankId"] = this.bankId;
        data["detailItem"] = this.detailItem;
        data["primaryItem"] = this.primaryItem;
        data["secondaryItem"] = this.secondaryItem;
        data["tertiaryItem"] = this.tertiaryItem;
        if (Array.isArray(this.accessoryAdds)) {
            data["accessoryAdds"] = [];
            for (let item of this.accessoryAdds)
                data["accessoryAdds"].push(item.toJSON());
        }
        if (Array.isArray(this.otherStocks)) {
            data["otherStocks"] = [];
            for (let item of this.otherStocks)
                data["otherStocks"].push(item.toJSON());
        }
        if (Array.isArray(this.sparesSales)) {
            data["sparesSales"] = [];
            for (let item of this.sparesSales)
                data["sparesSales"].push(item.toJSON());
        }
        if (Array.isArray(this.sparesRequests)) {
            data["sparesRequests"] = [];
            for (let item of this.sparesRequests)
                data["sparesRequests"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IAccessory extends IAuditableEntity {
    id?: string;
    bank?: Bank | undefined;
    bankId?: string | undefined;
    detailItem?: string | undefined;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    accessoryAdds?: AccessoryAdd[] | undefined;
    otherStocks?: OtherStock[] | undefined;
    sparesSales?: SparesSales[] | undefined;
    sparesRequests?: SparesRequest[] | undefined;
}

export class AccessoryAdd extends AuditableEntity implements IAccessoryAdd {
    id?: string;
    totalNumber?: number;
    buyDate?: Date;
    vendorName?: string | undefined;
    accessoryId?: string;
    accessory?: Accessory | undefined;

    constructor(data?: IAccessoryAdd) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.totalNumber = _data["totalNumber"];
            this.buyDate = _data["buyDate"] ? new Date(_data["buyDate"].toString()) : <any>undefined;
            this.vendorName = _data["vendorName"];
            this.accessoryId = _data["accessoryId"];
            this.accessory = _data["accessory"] ? Accessory.fromJS(_data["accessory"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): AccessoryAdd {
        data = typeof data === 'object' ? data : {};
        let result = new AccessoryAdd();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["totalNumber"] = this.totalNumber;
        data["buyDate"] = this.buyDate ? this.buyDate.toISOString() : <any>undefined;
        data["vendorName"] = this.vendorName;
        data["accessoryId"] = this.accessoryId;
        data["accessory"] = this.accessory ? this.accessory.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAccessoryAdd extends IAuditableEntity {
    id?: string;
    totalNumber?: number;
    buyDate?: Date;
    vendorName?: string | undefined;
    accessoryId?: string;
    accessory?: Accessory | undefined;
}

export class OtherStock extends AuditableEntity implements IOtherStock {
    id?: string;
    deploymentRequestId?: string;
    deploymentRequest?: DeploymentRequest | undefined;
    bankId?: string;
    accessory?: Accessory | undefined;
    accessoryId?: string;
    otherPartyId?: string | undefined;
    stockDate?: Date;
    soldOut?: number;
    remarks?: string | undefined;
    receivedBy?: string | undefined;
    distributedBy?: string | undefined;
    contactNo?: string | undefined;
    spareListModel?: SpareListModel[] | undefined;

    constructor(data?: IOtherStock) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.deploymentRequest = _data["deploymentRequest"] ? DeploymentRequest.fromJS(_data["deploymentRequest"]) : <any>undefined;
            this.bankId = _data["bankId"];
            this.accessory = _data["accessory"] ? Accessory.fromJS(_data["accessory"]) : <any>undefined;
            this.accessoryId = _data["accessoryId"];
            this.otherPartyId = _data["otherPartyId"];
            this.stockDate = _data["stockDate"] ? new Date(_data["stockDate"].toString()) : <any>undefined;
            this.soldOut = _data["soldOut"];
            this.remarks = _data["remarks"];
            this.receivedBy = _data["receivedBy"];
            this.distributedBy = _data["distributedBy"];
            this.contactNo = _data["contactNo"];
            if (Array.isArray(_data["spareListModel"])) {
                this.spareListModel = [] as any;
                for (let item of _data["spareListModel"])
                    this.spareListModel!.push(SpareListModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): OtherStock {
        data = typeof data === 'object' ? data : {};
        let result = new OtherStock();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["deploymentRequest"] = this.deploymentRequest ? this.deploymentRequest.toJSON() : <any>undefined;
        data["bankId"] = this.bankId;
        data["accessory"] = this.accessory ? this.accessory.toJSON() : <any>undefined;
        data["accessoryId"] = this.accessoryId;
        data["otherPartyId"] = this.otherPartyId;
        data["stockDate"] = this.stockDate ? this.stockDate.toISOString() : <any>undefined;
        data["soldOut"] = this.soldOut;
        data["remarks"] = this.remarks;
        data["receivedBy"] = this.receivedBy;
        data["distributedBy"] = this.distributedBy;
        data["contactNo"] = this.contactNo;
        if (Array.isArray(this.spareListModel)) {
            data["spareListModel"] = [];
            for (let item of this.spareListModel)
                data["spareListModel"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IOtherStock extends IAuditableEntity {
    id?: string;
    deploymentRequestId?: string;
    deploymentRequest?: DeploymentRequest | undefined;
    bankId?: string;
    accessory?: Accessory | undefined;
    accessoryId?: string;
    otherPartyId?: string | undefined;
    stockDate?: Date;
    soldOut?: number;
    remarks?: string | undefined;
    receivedBy?: string | undefined;
    distributedBy?: string | undefined;
    contactNo?: string | undefined;
    spareListModel?: SpareListModel[] | undefined;
}

export class SpareListModel implements ISpareListModel {
    id?: string;
    soldOut?: number;
    remarks?: string | undefined;
    receivedBy?: string | undefined;
    distributedBy?: string | undefined;
    contactNo?: string | undefined;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;

    constructor(data?: ISpareListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.soldOut = _data["soldOut"];
            this.remarks = _data["remarks"];
            this.receivedBy = _data["receivedBy"];
            this.distributedBy = _data["distributedBy"];
            this.contactNo = _data["contactNo"];
            this.primaryItem = _data["primaryItem"];
            this.secondaryItem = _data["secondaryItem"];
            this.tertiaryItem = _data["tertiaryItem"];
            this.detailItem = _data["detailItem"];
        }
    }

    static fromJS(data: any): SpareListModel {
        data = typeof data === 'object' ? data : {};
        let result = new SpareListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["soldOut"] = this.soldOut;
        data["remarks"] = this.remarks;
        data["receivedBy"] = this.receivedBy;
        data["distributedBy"] = this.distributedBy;
        data["contactNo"] = this.contactNo;
        data["primaryItem"] = this.primaryItem;
        data["secondaryItem"] = this.secondaryItem;
        data["tertiaryItem"] = this.tertiaryItem;
        data["detailItem"] = this.detailItem;
        return data;
    }
}

export interface ISpareListModel {
    id?: string;
    soldOut?: number;
    remarks?: string | undefined;
    receivedBy?: string | undefined;
    distributedBy?: string | undefined;
    contactNo?: string | undefined;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
}

export class SparesSales extends AuditableEntity implements ISparesSales {
    id?: string;
    bankId?: string;
    bankName?: string | undefined;
    accessory?: Accessory | undefined;
    accessoryId?: string;
    soldDate?: Date;
    remarks?: string | undefined;
    status?: string | undefined;
    totalSold?: number;

    constructor(data?: ISparesSales) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.bankId = _data["bankId"];
            this.bankName = _data["bankName"];
            this.accessory = _data["accessory"] ? Accessory.fromJS(_data["accessory"]) : <any>undefined;
            this.accessoryId = _data["accessoryId"];
            this.soldDate = _data["soldDate"] ? new Date(_data["soldDate"].toString()) : <any>undefined;
            this.remarks = _data["remarks"];
            this.status = _data["status"];
            this.totalSold = _data["totalSold"];
        }
    }

    static override fromJS(data: any): SparesSales {
        data = typeof data === 'object' ? data : {};
        let result = new SparesSales();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankId"] = this.bankId;
        data["bankName"] = this.bankName;
        data["accessory"] = this.accessory ? this.accessory.toJSON() : <any>undefined;
        data["accessoryId"] = this.accessoryId;
        data["soldDate"] = this.soldDate ? this.soldDate.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        data["status"] = this.status;
        data["totalSold"] = this.totalSold;
        super.toJSON(data);
        return data;
    }
}

export interface ISparesSales extends IAuditableEntity {
    id?: string;
    bankId?: string;
    bankName?: string | undefined;
    accessory?: Accessory | undefined;
    accessoryId?: string;
    soldDate?: Date;
    remarks?: string | undefined;
    status?: string | undefined;
    totalSold?: number;
}

export enum SpareRequestStatus {
    Pending = 1,
    PartialDelivered = 2,
    Delivered = 3,
    Cancelled = 4,
}

export class Support extends AuditableEntity implements ISupport {
    id?: string;
    deploymentRequestId?: string;
    deploymentRequest?: DeploymentRequest | undefined;
    bankId?: string;
    bank?: Bank | undefined;
    ticketNumber?: string | undefined;
    phone?: boolean;
    field?: boolean;
    status?: boolean;
    priority?: boolean;
    issue?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    resolvedBy?: string | undefined;
    remarks?: string | undefined;
    resolvedRemarks?: string | undefined;
    supportDate?: Date;
    verification?: string | undefined;
    verifiedBy?: string | undefined;
    verifiedDate?: Date;
    serialNumberId?: string;
    serialNumber?: SerialNumber | undefined;
    merchantLocation?: string | undefined;
    serialKey?: string | undefined;
    applicationVersionId?: string;
    applicationVersion?: ApplicationVersion | undefined;
    statusSupport?: SupportStatus;
    pendingSupport?: SupportPendingReason | undefined;
    description?: string | undefined;

    constructor(data?: ISupport) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.deploymentRequest = _data["deploymentRequest"] ? DeploymentRequest.fromJS(_data["deploymentRequest"]) : <any>undefined;
            this.bankId = _data["bankId"];
            this.bank = _data["bank"] ? Bank.fromJS(_data["bank"]) : <any>undefined;
            this.ticketNumber = _data["ticketNumber"];
            this.phone = _data["phone"];
            this.field = _data["field"];
            this.status = _data["status"];
            this.priority = _data["priority"];
            this.issue = _data["issue"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo = _data["contactNo"];
            this.resolvedBy = _data["resolvedBy"];
            this.remarks = _data["remarks"];
            this.resolvedRemarks = _data["resolvedRemarks"];
            this.supportDate = _data["supportDate"] ? new Date(_data["supportDate"].toString()) : <any>undefined;
            this.verification = _data["verification"];
            this.verifiedBy = _data["verifiedBy"];
            this.verifiedDate = _data["verifiedDate"] ? new Date(_data["verifiedDate"].toString()) : <any>undefined;
            this.serialNumberId = _data["serialNumberId"];
            this.serialNumber = _data["serialNumber"] ? SerialNumber.fromJS(_data["serialNumber"]) : <any>undefined;
            this.merchantLocation = _data["merchantLocation"];
            this.serialKey = _data["serialKey"];
            this.applicationVersionId = _data["applicationVersionId"];
            this.applicationVersion = _data["applicationVersion"] ? ApplicationVersion.fromJS(_data["applicationVersion"]) : <any>undefined;
            this.statusSupport = _data["statusSupport"];
            this.pendingSupport = _data["pendingSupport"];
            this.description = _data["description"];
        }
    }

    static override fromJS(data: any): Support {
        data = typeof data === 'object' ? data : {};
        let result = new Support();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["deploymentRequest"] = this.deploymentRequest ? this.deploymentRequest.toJSON() : <any>undefined;
        data["bankId"] = this.bankId;
        data["bank"] = this.bank ? this.bank.toJSON() : <any>undefined;
        data["ticketNumber"] = this.ticketNumber;
        data["phone"] = this.phone;
        data["field"] = this.field;
        data["status"] = this.status;
        data["priority"] = this.priority;
        data["issue"] = this.issue;
        data["contactPerson"] = this.contactPerson;
        data["contactNo"] = this.contactNo;
        data["resolvedBy"] = this.resolvedBy;
        data["remarks"] = this.remarks;
        data["resolvedRemarks"] = this.resolvedRemarks;
        data["supportDate"] = this.supportDate ? this.supportDate.toISOString() : <any>undefined;
        data["verification"] = this.verification;
        data["verifiedBy"] = this.verifiedBy;
        data["verifiedDate"] = this.verifiedDate ? this.verifiedDate.toISOString() : <any>undefined;
        data["serialNumberId"] = this.serialNumberId;
        data["serialNumber"] = this.serialNumber ? this.serialNumber.toJSON() : <any>undefined;
        data["merchantLocation"] = this.merchantLocation;
        data["serialKey"] = this.serialKey;
        data["applicationVersionId"] = this.applicationVersionId;
        data["applicationVersion"] = this.applicationVersion ? this.applicationVersion.toJSON() : <any>undefined;
        data["statusSupport"] = this.statusSupport;
        data["pendingSupport"] = this.pendingSupport;
        data["description"] = this.description;
        super.toJSON(data);
        return data;
    }
}

export interface ISupport extends IAuditableEntity {
    id?: string;
    deploymentRequestId?: string;
    deploymentRequest?: DeploymentRequest | undefined;
    bankId?: string;
    bank?: Bank | undefined;
    ticketNumber?: string | undefined;
    phone?: boolean;
    field?: boolean;
    status?: boolean;
    priority?: boolean;
    issue?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    resolvedBy?: string | undefined;
    remarks?: string | undefined;
    resolvedRemarks?: string | undefined;
    supportDate?: Date;
    verification?: string | undefined;
    verifiedBy?: string | undefined;
    verifiedDate?: Date;
    serialNumberId?: string;
    serialNumber?: SerialNumber | undefined;
    merchantLocation?: string | undefined;
    serialKey?: string | undefined;
    applicationVersionId?: string;
    applicationVersion?: ApplicationVersion | undefined;
    statusSupport?: SupportStatus;
    pendingSupport?: SupportPendingReason | undefined;
    description?: string | undefined;
}

export enum SupportStatus {
    Requested = "Requested",
    Pending = "Pending",
    Resolved = "Resolved",
    Closed = "Closed",
}

export enum SupportPendingReason {
    CallNotReachable = 1,
    CallNotRecieved = 2,
    MerchantIsCurrentlyOutOfHisOutlet = 3,
    SimCardValidityExpired = 4,
    InsufficientBalanceInSimCard = 5,
    WrongNumber = 6,
    OutletIsTemporarilyClosed = 7,
    MerchantHadAlreadyDeliveredAtBank = 8,
    HardwareIssueNeedToReplace = 9,
    SwitchedOff = 10,
    ApplicationUpdateRequired = 11,
    VisitSupportRequired = 12,
    TerminalLostByMerchant = 13,
    OutletIsPermanentlyClosed = 14,
    CableDamaged = 15,
    LowBatteryBackup = 16,
    PendingToFollowUp = 17,
    TerminalMisplacedByMerchant = 18,
    ChargerDamaged = 19,
    ContactNumberNotAvailable = 20,
    MerchantNotFoundAtPreviouslyDeployedLocation = 21,
    MerchantWantsToDiscontinue = 22,
    MerchantHasTheirInternetIssue = 23,
    MerchantIsNotUsingDueToHighCharge = 24,
    StoreUnderMaintenance = 25,
    MerchantHasNotReceivedPOSYet = 26,
    TerminalRetrieved = 27,
}

export enum DeploymentStatus {
    NewRequested = 1,
    NewRequestedVerified = 2,
    NewConfigured = 3,
    NewDeployed = 4,
    ReplacementRequested = 5,
    ReplacementConfigured = 6,
    ReDeployed = 7,
    RemovalRequest = 8,
    Retrieval = 9,
    Rejected = 10,
}

export class ImarkTerminal extends AuditableEntity implements IImarkTerminal {
    id?: string;
    terminalId?: number;
    imarkMerchantId?: string;
    imarkMerchant?: ImarkMerchant | undefined;
    bankId?: string;
    bank?: Bank | undefined;
    paymentProviderData?: string | undefined;
    deploymentRequestId?: string;
    deploymentRequest?: DeploymentRequest | undefined;

    constructor(data?: IImarkTerminal) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.terminalId = _data["terminalId"];
            this.imarkMerchantId = _data["imarkMerchantId"];
            this.imarkMerchant = _data["imarkMerchant"] ? ImarkMerchant.fromJS(_data["imarkMerchant"]) : <any>undefined;
            this.bankId = _data["bankId"];
            this.bank = _data["bank"] ? Bank.fromJS(_data["bank"]) : <any>undefined;
            this.paymentProviderData = _data["paymentProviderData"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.deploymentRequest = _data["deploymentRequest"] ? DeploymentRequest.fromJS(_data["deploymentRequest"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ImarkTerminal {
        data = typeof data === 'object' ? data : {};
        let result = new ImarkTerminal();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["terminalId"] = this.terminalId;
        data["imarkMerchantId"] = this.imarkMerchantId;
        data["imarkMerchant"] = this.imarkMerchant ? this.imarkMerchant.toJSON() : <any>undefined;
        data["bankId"] = this.bankId;
        data["bank"] = this.bank ? this.bank.toJSON() : <any>undefined;
        data["paymentProviderData"] = this.paymentProviderData;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["deploymentRequest"] = this.deploymentRequest ? this.deploymentRequest.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IImarkTerminal extends IAuditableEntity {
    id?: string;
    terminalId?: number;
    imarkMerchantId?: string;
    imarkMerchant?: ImarkMerchant | undefined;
    bankId?: string;
    bank?: Bank | undefined;
    paymentProviderData?: string | undefined;
    deploymentRequestId?: string;
    deploymentRequest?: DeploymentRequest | undefined;
}

export class ImarkMerchant extends AuditableEntity implements IImarkMerchant {
    id?: string;
    merchantId?: number;
    userId?: string;
    applicationUsers?: ApplicationUser | undefined;
    address?: string | undefined;
    panNumber?: string | undefined;

    constructor(data?: IImarkMerchant) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.merchantId = _data["merchantId"];
            this.userId = _data["userId"];
            this.applicationUsers = _data["applicationUsers"] ? ApplicationUser.fromJS(_data["applicationUsers"]) : <any>undefined;
            this.address = _data["address"];
            this.panNumber = _data["panNumber"];
        }
    }

    static override fromJS(data: any): ImarkMerchant {
        data = typeof data === 'object' ? data : {};
        let result = new ImarkMerchant();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["merchantId"] = this.merchantId;
        data["userId"] = this.userId;
        data["applicationUsers"] = this.applicationUsers ? this.applicationUsers.toJSON() : <any>undefined;
        data["address"] = this.address;
        data["panNumber"] = this.panNumber;
        super.toJSON(data);
        return data;
    }
}

export interface IImarkMerchant extends IAuditableEntity {
    id?: string;
    merchantId?: number;
    userId?: string;
    applicationUsers?: ApplicationUser | undefined;
    address?: string | undefined;
    panNumber?: string | undefined;
}

export class DeploymentActivityLog extends AuditableEntity implements IDeploymentActivityLog {
    id?: string;
    deploymentRequestId?: string;
    deploymentRequest?: DeploymentRequest | undefined;
    deploymentStatus?: DeploymentStatus;
    remarks?: string | undefined;
    deploymentsActivityLogDetails?: DeploymentsActivityLogDetail[] | undefined;

    constructor(data?: IDeploymentActivityLog) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.deploymentRequest = _data["deploymentRequest"] ? DeploymentRequest.fromJS(_data["deploymentRequest"]) : <any>undefined;
            this.deploymentStatus = _data["deploymentStatus"];
            this.remarks = _data["remarks"];
            if (Array.isArray(_data["deploymentsActivityLogDetails"])) {
                this.deploymentsActivityLogDetails = [] as any;
                for (let item of _data["deploymentsActivityLogDetails"])
                    this.deploymentsActivityLogDetails!.push(DeploymentsActivityLogDetail.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): DeploymentActivityLog {
        data = typeof data === 'object' ? data : {};
        let result = new DeploymentActivityLog();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["deploymentRequest"] = this.deploymentRequest ? this.deploymentRequest.toJSON() : <any>undefined;
        data["deploymentStatus"] = this.deploymentStatus;
        data["remarks"] = this.remarks;
        if (Array.isArray(this.deploymentsActivityLogDetails)) {
            data["deploymentsActivityLogDetails"] = [];
            for (let item of this.deploymentsActivityLogDetails)
                data["deploymentsActivityLogDetails"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDeploymentActivityLog extends IAuditableEntity {
    id?: string;
    deploymentRequestId?: string;
    deploymentRequest?: DeploymentRequest | undefined;
    deploymentStatus?: DeploymentStatus;
    remarks?: string | undefined;
    deploymentsActivityLogDetails?: DeploymentsActivityLogDetail[] | undefined;
}

export class DeploymentsActivityLogDetail implements IDeploymentsActivityLogDetail {
    id?: string;
    deploymentActivityLog?: DeploymentActivityLog | undefined;
    deploymentActivityLogId?: string;
    requestedInventoryId?: string;
    previousSerialNoId?: string;

    constructor(data?: IDeploymentsActivityLogDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.deploymentActivityLog = _data["deploymentActivityLog"] ? DeploymentActivityLog.fromJS(_data["deploymentActivityLog"]) : <any>undefined;
            this.deploymentActivityLogId = _data["deploymentActivityLogId"];
            this.requestedInventoryId = _data["requestedInventoryId"];
            this.previousSerialNoId = _data["previousSerialNoId"];
        }
    }

    static fromJS(data: any): DeploymentsActivityLogDetail {
        data = typeof data === 'object' ? data : {};
        let result = new DeploymentsActivityLogDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deploymentActivityLog"] = this.deploymentActivityLog ? this.deploymentActivityLog.toJSON() : <any>undefined;
        data["deploymentActivityLogId"] = this.deploymentActivityLogId;
        data["requestedInventoryId"] = this.requestedInventoryId;
        data["previousSerialNoId"] = this.previousSerialNoId;
        return data;
    }
}

export interface IDeploymentsActivityLogDetail {
    id?: string;
    deploymentActivityLog?: DeploymentActivityLog | undefined;
    deploymentActivityLogId?: string;
    requestedInventoryId?: string;
    previousSerialNoId?: string;
}

export enum ReplacementReason {
    HARDWAREISSUE = 1,
    SWITCHINGOFMODEL = 2,
    LOSTOFTERMINAL = 3,
    BATTERYISSUE = 4,
    BUGFIXINGANDFEATUREENHANCEMENTS = 5,
    ENDOFLIFE = 6,
    MIGRATION = 7,
    OTHERS = 8,
}

export class Hardware extends AuditableEntity implements IHardware {
    id?: string;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    purchaseDate?: Date;
    serialNo?: string | undefined;
    manufacturer?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    bankId?: string;
    bank?: Bank | undefined;
    cardRequestTransactions?: CardRequestTransaction[] | undefined;

    constructor(data?: IHardware) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.primaryItem = _data["primaryItem"];
            this.secondaryItem = _data["secondaryItem"];
            this.tertiaryItem = _data["tertiaryItem"];
            this.detailItem = _data["detailItem"];
            this.purchaseDate = _data["purchaseDate"] ? new Date(_data["purchaseDate"].toString()) : <any>undefined;
            this.serialNo = _data["serialNo"];
            this.manufacturer = _data["manufacturer"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo = _data["contactNo"];
            this.bankId = _data["bankId"];
            this.bank = _data["bank"] ? Bank.fromJS(_data["bank"]) : <any>undefined;
            if (Array.isArray(_data["cardRequestTransactions"])) {
                this.cardRequestTransactions = [] as any;
                for (let item of _data["cardRequestTransactions"])
                    this.cardRequestTransactions!.push(CardRequestTransaction.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Hardware {
        data = typeof data === 'object' ? data : {};
        let result = new Hardware();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["primaryItem"] = this.primaryItem;
        data["secondaryItem"] = this.secondaryItem;
        data["tertiaryItem"] = this.tertiaryItem;
        data["detailItem"] = this.detailItem;
        data["purchaseDate"] = this.purchaseDate ? this.purchaseDate.toISOString() : <any>undefined;
        data["serialNo"] = this.serialNo;
        data["manufacturer"] = this.manufacturer;
        data["contactPerson"] = this.contactPerson;
        data["contactNo"] = this.contactNo;
        data["bankId"] = this.bankId;
        data["bank"] = this.bank ? this.bank.toJSON() : <any>undefined;
        if (Array.isArray(this.cardRequestTransactions)) {
            data["cardRequestTransactions"] = [];
            for (let item of this.cardRequestTransactions)
                data["cardRequestTransactions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IHardware extends IAuditableEntity {
    id?: string;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    purchaseDate?: Date;
    serialNo?: string | undefined;
    manufacturer?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    bankId?: string;
    bank?: Bank | undefined;
    cardRequestTransactions?: CardRequestTransaction[] | undefined;
}

export class CardRequestTransaction extends AuditableEntity implements ICardRequestTransaction {
    id?: number;
    cardRequest?: CardRequest | undefined;
    cardRequestId?: number;
    hardware?: Hardware | undefined;
    hardwareId?: string;
    totalPrinted?: number;
    totalDamaged?: number;
    checkIn?: string;
    checkOut?: string;

    constructor(data?: ICardRequestTransaction) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.cardRequest = _data["cardRequest"] ? CardRequest.fromJS(_data["cardRequest"]) : <any>undefined;
            this.cardRequestId = _data["cardRequestId"];
            this.hardware = _data["hardware"] ? Hardware.fromJS(_data["hardware"]) : <any>undefined;
            this.hardwareId = _data["hardwareId"];
            this.totalPrinted = _data["totalPrinted"];
            this.totalDamaged = _data["totalDamaged"];
            this.checkIn = _data["checkIn"];
            this.checkOut = _data["checkOut"];
        }
    }

    static override fromJS(data: any): CardRequestTransaction {
        data = typeof data === 'object' ? data : {};
        let result = new CardRequestTransaction();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cardRequest"] = this.cardRequest ? this.cardRequest.toJSON() : <any>undefined;
        data["cardRequestId"] = this.cardRequestId;
        data["hardware"] = this.hardware ? this.hardware.toJSON() : <any>undefined;
        data["hardwareId"] = this.hardwareId;
        data["totalPrinted"] = this.totalPrinted;
        data["totalDamaged"] = this.totalDamaged;
        data["checkIn"] = this.checkIn;
        data["checkOut"] = this.checkOut;
        super.toJSON(data);
        return data;
    }
}

export interface ICardRequestTransaction extends IAuditableEntity {
    id?: number;
    cardRequest?: CardRequest | undefined;
    cardRequestId?: number;
    hardware?: Hardware | undefined;
    hardwareId?: string;
    totalPrinted?: number;
    totalDamaged?: number;
    checkIn?: string;
    checkOut?: string;
}

export class CardRequest extends AuditableEntity implements ICardRequest {
    id?: number;
    cardProductId?: number;
    cardProducts?: CardProduct | undefined;
    bureauId?: string;
    bureau?: Bank | undefined;
    totalRequested?: number;
    totalDamaged?: number;
    totalPrinted?: number;
    fileName?: string | undefined;
    cardPrintLogs?: CardPrintLog[] | undefined;
    cardRequestTransactions?: CardRequestTransaction[] | undefined;

    constructor(data?: ICardRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.cardProductId = _data["cardProductId"];
            this.cardProducts = _data["cardProducts"] ? CardProduct.fromJS(_data["cardProducts"]) : <any>undefined;
            this.bureauId = _data["bureauId"];
            this.bureau = _data["bureau"] ? Bank.fromJS(_data["bureau"]) : <any>undefined;
            this.totalRequested = _data["totalRequested"];
            this.totalDamaged = _data["totalDamaged"];
            this.totalPrinted = _data["totalPrinted"];
            this.fileName = _data["fileName"];
            if (Array.isArray(_data["cardPrintLogs"])) {
                this.cardPrintLogs = [] as any;
                for (let item of _data["cardPrintLogs"])
                    this.cardPrintLogs!.push(CardPrintLog.fromJS(item));
            }
            if (Array.isArray(_data["cardRequestTransactions"])) {
                this.cardRequestTransactions = [] as any;
                for (let item of _data["cardRequestTransactions"])
                    this.cardRequestTransactions!.push(CardRequestTransaction.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): CardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CardRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cardProductId"] = this.cardProductId;
        data["cardProducts"] = this.cardProducts ? this.cardProducts.toJSON() : <any>undefined;
        data["bureauId"] = this.bureauId;
        data["bureau"] = this.bureau ? this.bureau.toJSON() : <any>undefined;
        data["totalRequested"] = this.totalRequested;
        data["totalDamaged"] = this.totalDamaged;
        data["totalPrinted"] = this.totalPrinted;
        data["fileName"] = this.fileName;
        if (Array.isArray(this.cardPrintLogs)) {
            data["cardPrintLogs"] = [];
            for (let item of this.cardPrintLogs)
                data["cardPrintLogs"].push(item.toJSON());
        }
        if (Array.isArray(this.cardRequestTransactions)) {
            data["cardRequestTransactions"] = [];
            for (let item of this.cardRequestTransactions)
                data["cardRequestTransactions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICardRequest extends IAuditableEntity {
    id?: number;
    cardProductId?: number;
    cardProducts?: CardProduct | undefined;
    bureauId?: string;
    bureau?: Bank | undefined;
    totalRequested?: number;
    totalDamaged?: number;
    totalPrinted?: number;
    fileName?: string | undefined;
    cardPrintLogs?: CardPrintLog[] | undefined;
    cardRequestTransactions?: CardRequestTransaction[] | undefined;
}

export class CardProduct extends AuditableEntity implements ICardProduct {
    id?: number;
    bankId?: string;
    bank?: Bank | undefined;
    productCode?: string | undefined;
    productName?: string | undefined;
    type?: ProductType;
    brand?: ProductBrand;
    active?: boolean;
    cardRequests?: CardRequest[] | undefined;

    constructor(data?: ICardProduct) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.bankId = _data["bankId"];
            this.bank = _data["bank"] ? Bank.fromJS(_data["bank"]) : <any>undefined;
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.type = _data["type"];
            this.brand = _data["brand"];
            this.active = _data["active"];
            if (Array.isArray(_data["cardRequests"])) {
                this.cardRequests = [] as any;
                for (let item of _data["cardRequests"])
                    this.cardRequests!.push(CardRequest.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): CardProduct {
        data = typeof data === 'object' ? data : {};
        let result = new CardProduct();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankId"] = this.bankId;
        data["bank"] = this.bank ? this.bank.toJSON() : <any>undefined;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["type"] = this.type;
        data["brand"] = this.brand;
        data["active"] = this.active;
        if (Array.isArray(this.cardRequests)) {
            data["cardRequests"] = [];
            for (let item of this.cardRequests)
                data["cardRequests"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICardProduct extends IAuditableEntity {
    id?: number;
    bankId?: string;
    bank?: Bank | undefined;
    productCode?: string | undefined;
    productName?: string | undefined;
    type?: ProductType;
    brand?: ProductBrand;
    active?: boolean;
    cardRequests?: CardRequest[] | undefined;
}

export enum ProductType {
    Debit = 1,
    Credit = 2,
    Others = 3,
}

export enum ProductBrand {
    Visa = 1,
    MasterCard = 2,
    SCT = 3,
    UnionPay = 4,
}

export class CardPrintLog extends AuditableEntity implements ICardPrintLog {
    id?: number;
    cardRequestId?: number;
    cardRequest?: CardRequest | undefined;
    printed?: number;

    constructor(data?: ICardPrintLog) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.cardRequestId = _data["cardRequestId"];
            this.cardRequest = _data["cardRequest"] ? CardRequest.fromJS(_data["cardRequest"]) : <any>undefined;
            this.printed = _data["printed"];
        }
    }

    static override fromJS(data: any): CardPrintLog {
        data = typeof data === 'object' ? data : {};
        let result = new CardPrintLog();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cardRequestId"] = this.cardRequestId;
        data["cardRequest"] = this.cardRequest ? this.cardRequest.toJSON() : <any>undefined;
        data["printed"] = this.printed;
        super.toJSON(data);
        return data;
    }
}

export interface ICardPrintLog extends IAuditableEntity {
    id?: number;
    cardRequestId?: number;
    cardRequest?: CardRequest | undefined;
    printed?: number;
}

export class MemberBanks extends AuditableEntity implements IMemberBanks {
    id?: string;
    bankName?: string | undefined;
    swiftCode?: string | undefined;
    isActive?: boolean;
    merchantId?: string;
    merchant?: ImarkMerchant | undefined;
    applicationUsers?: ApplicationUser[] | undefined;

    constructor(data?: IMemberBanks) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.bankName = _data["bankName"];
            this.swiftCode = _data["swiftCode"];
            this.isActive = _data["isActive"];
            this.merchantId = _data["merchantId"];
            this.merchant = _data["merchant"] ? ImarkMerchant.fromJS(_data["merchant"]) : <any>undefined;
            if (Array.isArray(_data["applicationUsers"])) {
                this.applicationUsers = [] as any;
                for (let item of _data["applicationUsers"])
                    this.applicationUsers!.push(ApplicationUser.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): MemberBanks {
        data = typeof data === 'object' ? data : {};
        let result = new MemberBanks();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankName"] = this.bankName;
        data["swiftCode"] = this.swiftCode;
        data["isActive"] = this.isActive;
        data["merchantId"] = this.merchantId;
        data["merchant"] = this.merchant ? this.merchant.toJSON() : <any>undefined;
        if (Array.isArray(this.applicationUsers)) {
            data["applicationUsers"] = [];
            for (let item of this.applicationUsers)
                data["applicationUsers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IMemberBanks extends IAuditableEntity {
    id?: string;
    bankName?: string | undefined;
    swiftCode?: string | undefined;
    isActive?: boolean;
    merchantId?: string;
    merchant?: ImarkMerchant | undefined;
    applicationUsers?: ApplicationUser[] | undefined;
}

/** Represents the link between a user and a role. */
export class IdentityUserRoleOfString implements IIdentityUserRoleOfString {
    /** Gets or sets the primary key of the user that is linked to a role. */
    userId?: string | undefined;
    /** Gets or sets the primary key of the role that is linked to the user. */
    roleId?: string | undefined;

    constructor(data?: IIdentityUserRoleOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): IdentityUserRoleOfString {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityUserRoleOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        return data;
    }
}

/** Represents the link between a user and a role. */
export interface IIdentityUserRoleOfString {
    /** Gets or sets the primary key of the user that is linked to a role. */
    userId?: string | undefined;
    /** Gets or sets the primary key of the role that is linked to the user. */
    roleId?: string | undefined;
}

/** Represents a claim that a user possesses. */
export class IdentityUserClaimOfString implements IIdentityUserClaimOfString {
    /** Gets or sets the identifier for this user claim. */
    id?: number;
    /** Gets or sets the primary key of the user associated with this claim. */
    userId?: string | undefined;
    /** Gets or sets the claim type for this claim. */
    claimType?: string | undefined;
    /** Gets or sets the claim value for this claim. */
    claimValue?: string | undefined;

    constructor(data?: IIdentityUserClaimOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.claimType = _data["claimType"];
            this.claimValue = _data["claimValue"];
        }
    }

    static fromJS(data: any): IdentityUserClaimOfString {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityUserClaimOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        return data;
    }
}

/** Represents a claim that a user possesses. */
export interface IIdentityUserClaimOfString {
    /** Gets or sets the identifier for this user claim. */
    id?: number;
    /** Gets or sets the primary key of the user associated with this claim. */
    userId?: string | undefined;
    /** Gets or sets the claim type for this claim. */
    claimType?: string | undefined;
    /** Gets or sets the claim value for this claim. */
    claimValue?: string | undefined;
}

export class Order extends AuditableEntity implements IOrder {
    id?: number;
    discount?: number;
    comments?: string | undefined;
    dateCreated?: Date;
    dateModified?: Date;
    cashierId?: string | undefined;
    cashier?: ApplicationUser | undefined;
    customerId?: number;
    customer?: Customer | undefined;
    orderDetails?: OrderDetail[] | undefined;

    constructor(data?: IOrder) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.discount = _data["discount"];
            this.comments = _data["comments"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
            this.cashierId = _data["cashierId"];
            this.cashier = _data["cashier"] ? ApplicationUser.fromJS(_data["cashier"]) : <any>undefined;
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
            if (Array.isArray(_data["orderDetails"])) {
                this.orderDetails = [] as any;
                for (let item of _data["orderDetails"])
                    this.orderDetails!.push(OrderDetail.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Order {
        data = typeof data === 'object' ? data : {};
        let result = new Order();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["discount"] = this.discount;
        data["comments"] = this.comments;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        data["cashierId"] = this.cashierId;
        data["cashier"] = this.cashier ? this.cashier.toJSON() : <any>undefined;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        if (Array.isArray(this.orderDetails)) {
            data["orderDetails"] = [];
            for (let item of this.orderDetails)
                data["orderDetails"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IOrder extends IAuditableEntity {
    id?: number;
    discount?: number;
    comments?: string | undefined;
    dateCreated?: Date;
    dateModified?: Date;
    cashierId?: string | undefined;
    cashier?: ApplicationUser | undefined;
    customerId?: number;
    customer?: Customer | undefined;
    orderDetails?: OrderDetail[] | undefined;
}

export class Customer extends AuditableEntity implements ICustomer {
    id?: number;
    name?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    gender?: Gender;
    dateCreated?: Date;
    dateModified?: Date;
    orders?: Order[] | undefined;

    constructor(data?: ICustomer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.gender = _data["gender"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(Order.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Customer {
        data = typeof data === 'object' ? data : {};
        let result = new Customer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["address"] = this.address;
        data["city"] = this.city;
        data["gender"] = this.gender;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICustomer extends IAuditableEntity {
    id?: number;
    name?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    gender?: Gender;
    dateCreated?: Date;
    dateModified?: Date;
    orders?: Order[] | undefined;
}

export enum Gender {
    None = 0,
    Female = 1,
    Male = 2,
}

export class OrderDetail extends AuditableEntity implements IOrderDetail {
    id?: number;
    unitPrice?: number;
    quantity?: number;
    discount?: number;
    productId?: number;
    product?: Product | undefined;
    orderId?: number;
    order?: Order | undefined;

    constructor(data?: IOrderDetail) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.unitPrice = _data["unitPrice"];
            this.quantity = _data["quantity"];
            this.discount = _data["discount"];
            this.productId = _data["productId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.orderId = _data["orderId"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): OrderDetail {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetail();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["unitPrice"] = this.unitPrice;
        data["quantity"] = this.quantity;
        data["discount"] = this.discount;
        data["productId"] = this.productId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["orderId"] = this.orderId;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IOrderDetail extends IAuditableEntity {
    id?: number;
    unitPrice?: number;
    quantity?: number;
    discount?: number;
    productId?: number;
    product?: Product | undefined;
    orderId?: number;
    order?: Order | undefined;
}

export class Product extends AuditableEntity implements IProduct {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    icon?: string | undefined;
    buyingPrice?: number;
    sellingPrice?: number;
    unitsInStock?: number;
    isActive?: boolean;
    isDiscontinued?: boolean;
    dateCreated?: Date;
    dateModified?: Date;
    parentId?: number | undefined;
    parent?: Product | undefined;
    productCategoryId?: number;
    productCategory?: ProductCategory | undefined;
    children?: Product[] | undefined;
    orderDetails?: OrderDetail[] | undefined;

    constructor(data?: IProduct) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.icon = _data["icon"];
            this.buyingPrice = _data["buyingPrice"];
            this.sellingPrice = _data["sellingPrice"];
            this.unitsInStock = _data["unitsInStock"];
            this.isActive = _data["isActive"];
            this.isDiscontinued = _data["isDiscontinued"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
            this.parentId = _data["parentId"];
            this.parent = _data["parent"] ? Product.fromJS(_data["parent"]) : <any>undefined;
            this.productCategoryId = _data["productCategoryId"];
            this.productCategory = _data["productCategory"] ? ProductCategory.fromJS(_data["productCategory"]) : <any>undefined;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(Product.fromJS(item));
            }
            if (Array.isArray(_data["orderDetails"])) {
                this.orderDetails = [] as any;
                for (let item of _data["orderDetails"])
                    this.orderDetails!.push(OrderDetail.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Product {
        data = typeof data === 'object' ? data : {};
        let result = new Product();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["icon"] = this.icon;
        data["buyingPrice"] = this.buyingPrice;
        data["sellingPrice"] = this.sellingPrice;
        data["unitsInStock"] = this.unitsInStock;
        data["isActive"] = this.isActive;
        data["isDiscontinued"] = this.isDiscontinued;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        data["parentId"] = this.parentId;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        data["productCategoryId"] = this.productCategoryId;
        data["productCategory"] = this.productCategory ? this.productCategory.toJSON() : <any>undefined;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        if (Array.isArray(this.orderDetails)) {
            data["orderDetails"] = [];
            for (let item of this.orderDetails)
                data["orderDetails"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IProduct extends IAuditableEntity {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    icon?: string | undefined;
    buyingPrice?: number;
    sellingPrice?: number;
    unitsInStock?: number;
    isActive?: boolean;
    isDiscontinued?: boolean;
    dateCreated?: Date;
    dateModified?: Date;
    parentId?: number | undefined;
    parent?: Product | undefined;
    productCategoryId?: number;
    productCategory?: ProductCategory | undefined;
    children?: Product[] | undefined;
    orderDetails?: OrderDetail[] | undefined;
}

export class ProductCategory extends AuditableEntity implements IProductCategory {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    icon?: string | undefined;
    dateCreated?: Date;
    dateModified?: Date;
    products?: Product[] | undefined;

    constructor(data?: IProductCategory) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.icon = _data["icon"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(Product.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ProductCategory {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCategory();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["icon"] = this.icon;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IProductCategory extends IAuditableEntity {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    icon?: string | undefined;
    dateCreated?: Date;
    dateModified?: Date;
    products?: Product[] | undefined;
}

/** Represents a role in the identity system */
export class IdentityRoleOfString implements IIdentityRoleOfString {
    /** Gets or sets the primary key for this role. */
    id?: string | undefined;
    /** Gets or sets the name for this role. */
    name?: string | undefined;
    /** Gets or sets the normalized name for this role. */
    normalizedName?: string | undefined;
    /** A random value that should change whenever a role is persisted to the store */
    concurrencyStamp?: string | undefined;

    constructor(data?: IIdentityRoleOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.normalizedName = _data["normalizedName"];
            this.concurrencyStamp = _data["concurrencyStamp"];
        }
    }

    static fromJS(data: any): IdentityRoleOfString {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityRoleOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["normalizedName"] = this.normalizedName;
        data["concurrencyStamp"] = this.concurrencyStamp;
        return data;
    }
}

/** Represents a role in the identity system */
export interface IIdentityRoleOfString {
    /** Gets or sets the primary key for this role. */
    id?: string | undefined;
    /** Gets or sets the name for this role. */
    name?: string | undefined;
    /** Gets or sets the normalized name for this role. */
    normalizedName?: string | undefined;
    /** A random value that should change whenever a role is persisted to the store */
    concurrencyStamp?: string | undefined;
}

/** The default implementation of IdentityRole`1 which uses a string as the primary key. */
export class IdentityRole extends IdentityRoleOfString implements IIdentityRole {

    constructor(data?: IIdentityRole) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): IdentityRole {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityRole();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** The default implementation of IdentityRole`1 which uses a string as the primary key. */
export interface IIdentityRole extends IIdentityRoleOfString {
}

export class ApplicationRole extends IdentityRole implements IApplicationRole {
    description?: string | undefined;
    userType?: UserType;
    bankId?: string | undefined;
    bank?: Bank | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    createdDate?: Date;
    updatedDate?: Date;
    roleUsers?: IdentityUserRoleOfString[] | undefined;
    claims?: IdentityRoleClaimOfString[] | undefined;
    users?: ApplicationUser[] | undefined;

    constructor(data?: IApplicationRole) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.description = _data["description"];
            this.userType = _data["userType"];
            this.bankId = _data["bankId"];
            this.bank = _data["bank"] ? Bank.fromJS(_data["bank"]) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["roleUsers"])) {
                this.roleUsers = [] as any;
                for (let item of _data["roleUsers"])
                    this.roleUsers!.push(IdentityUserRoleOfString.fromJS(item));
            }
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims!.push(IdentityRoleClaimOfString.fromJS(item));
            }
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(ApplicationUser.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ApplicationRole {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationRole();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["userType"] = this.userType;
        data["bankId"] = this.bankId;
        data["bank"] = this.bank ? this.bank.toJSON() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        if (Array.isArray(this.roleUsers)) {
            data["roleUsers"] = [];
            for (let item of this.roleUsers)
                data["roleUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IApplicationRole extends IIdentityRole {
    description?: string | undefined;
    userType?: UserType;
    bankId?: string | undefined;
    bank?: Bank | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    createdDate?: Date;
    updatedDate?: Date;
    roleUsers?: IdentityUserRoleOfString[] | undefined;
    claims?: IdentityRoleClaimOfString[] | undefined;
    users?: ApplicationUser[] | undefined;
}

/** Represents a claim that is granted to all users within a role. */
export class IdentityRoleClaimOfString implements IIdentityRoleClaimOfString {
    /** Gets or sets the identifier for this role claim. */
    id?: number;
    /** Gets or sets the of the primary key of the role associated with this claim. */
    roleId?: string | undefined;
    /** Gets or sets the claim type for this claim. */
    claimType?: string | undefined;
    /** Gets or sets the claim value for this claim. */
    claimValue?: string | undefined;

    constructor(data?: IIdentityRoleClaimOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.roleId = _data["roleId"];
            this.claimType = _data["claimType"];
            this.claimValue = _data["claimValue"];
        }
    }

    static fromJS(data: any): IdentityRoleClaimOfString {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityRoleClaimOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["roleId"] = this.roleId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        return data;
    }
}

/** Represents a claim that is granted to all users within a role. */
export interface IIdentityRoleClaimOfString {
    /** Gets or sets the identifier for this role claim. */
    id?: number;
    /** Gets or sets the of the primary key of the role associated with this claim. */
    roleId?: string | undefined;
    /** Gets or sets the claim type for this claim. */
    claimType?: string | undefined;
    /** Gets or sets the claim value for this claim. */
    claimValue?: string | undefined;
}

export class MerchantUserViewModel implements IMerchantUserViewModel {
    id?: string;
    merchantName?: string | undefined;
    panNumber?: string | undefined;

    constructor(data?: IMerchantUserViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.merchantName = _data["merchantName"];
            this.panNumber = _data["panNumber"];
        }
    }

    static fromJS(data: any): MerchantUserViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantUserViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["merchantName"] = this.merchantName;
        data["panNumber"] = this.panNumber;
        return data;
    }
}

export interface IMerchantUserViewModel {
    id?: string;
    merchantName?: string | undefined;
    panNumber?: string | undefined;
}

export class UserWithRolesVm implements IUserWithRolesVm {
    id?: string | undefined;
    userName?: string | undefined;
    phoneNumber?: string | undefined;
    jobTitle?: string | undefined;
    email?: string | undefined;
    fullName?: string | undefined;
    bankId?: string | undefined;
    branchName?: string | undefined;
    userType?: UserType | undefined;
    isEnabled?: boolean;
    roles?: UserRoleVm[] | undefined;

    constructor(data?: IUserWithRolesVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.phoneNumber = _data["phoneNumber"];
            this.jobTitle = _data["jobTitle"];
            this.email = _data["email"];
            this.fullName = _data["fullName"];
            this.bankId = _data["bankId"];
            this.branchName = _data["branchName"];
            this.userType = _data["userType"];
            this.isEnabled = _data["isEnabled"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserRoleVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserWithRolesVm {
        data = typeof data === 'object' ? data : {};
        let result = new UserWithRolesVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["phoneNumber"] = this.phoneNumber;
        data["jobTitle"] = this.jobTitle;
        data["email"] = this.email;
        data["fullName"] = this.fullName;
        data["bankId"] = this.bankId;
        data["branchName"] = this.branchName;
        data["userType"] = this.userType;
        data["isEnabled"] = this.isEnabled;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserWithRolesVm {
    id?: string | undefined;
    userName?: string | undefined;
    phoneNumber?: string | undefined;
    jobTitle?: string | undefined;
    email?: string | undefined;
    fullName?: string | undefined;
    bankId?: string | undefined;
    branchName?: string | undefined;
    userType?: UserType | undefined;
    isEnabled?: boolean;
    roles?: UserRoleVm[] | undefined;
}

export class UserRoleVm implements IUserRoleVm {
    roleName?: string | undefined;
    description?: string | undefined;
    userType?: UserType;
    bankId?: string | undefined;

    constructor(data?: IUserRoleVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleName = _data["roleName"];
            this.description = _data["description"];
            this.userType = _data["userType"];
            this.bankId = _data["bankId"];
        }
    }

    static fromJS(data: any): UserRoleVm {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleName"] = this.roleName;
        data["description"] = this.description;
        data["userType"] = this.userType;
        data["bankId"] = this.bankId;
        return data;
    }
}

export interface IUserRoleVm {
    roleName?: string | undefined;
    description?: string | undefined;
    userType?: UserType;
    bankId?: string | undefined;
}

export class MerchantVm implements IMerchantVm {
    id?: string | undefined;
    userName?: string | undefined;
    phoneNumber?: string | undefined;
    jobTitle?: string | undefined;
    email?: string | undefined;
    fullName?: string | undefined;
    bankId?: string | undefined;
    branchName?: string | undefined;
    panNumber?: string | undefined;
    address?: string | undefined;
    userType?: UserType | undefined;
    isEnabled?: boolean;
    imarkMerchantId?: number | undefined;

    constructor(data?: IMerchantVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.phoneNumber = _data["phoneNumber"];
            this.jobTitle = _data["jobTitle"];
            this.email = _data["email"];
            this.fullName = _data["fullName"];
            this.bankId = _data["bankId"];
            this.branchName = _data["branchName"];
            this.panNumber = _data["panNumber"];
            this.address = _data["address"];
            this.userType = _data["userType"];
            this.isEnabled = _data["isEnabled"];
            this.imarkMerchantId = _data["imarkMerchantId"];
        }
    }

    static fromJS(data: any): MerchantVm {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["phoneNumber"] = this.phoneNumber;
        data["jobTitle"] = this.jobTitle;
        data["email"] = this.email;
        data["fullName"] = this.fullName;
        data["bankId"] = this.bankId;
        data["branchName"] = this.branchName;
        data["panNumber"] = this.panNumber;
        data["address"] = this.address;
        data["userType"] = this.userType;
        data["isEnabled"] = this.isEnabled;
        data["imarkMerchantId"] = this.imarkMerchantId;
        return data;
    }
}

export interface IMerchantVm {
    id?: string | undefined;
    userName?: string | undefined;
    phoneNumber?: string | undefined;
    jobTitle?: string | undefined;
    email?: string | undefined;
    fullName?: string | undefined;
    bankId?: string | undefined;
    branchName?: string | undefined;
    panNumber?: string | undefined;
    address?: string | undefined;
    userType?: UserType | undefined;
    isEnabled?: boolean;
    imarkMerchantId?: number | undefined;
}

export class RecentlyCreatedMerchantUserVm implements IRecentlyCreatedMerchantUserVm {
    id?: string | undefined;
    fullName?: string | undefined;

    constructor(data?: IRecentlyCreatedMerchantUserVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): RecentlyCreatedMerchantUserVm {
        data = typeof data === 'object' ? data : {};
        let result = new RecentlyCreatedMerchantUserVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IRecentlyCreatedMerchantUserVm {
    id?: string | undefined;
    fullName?: string | undefined;
}

export class RolePermissionVM implements IRolePermissionVM {
    id?: string | undefined;
    roleName?: string | undefined;
    description?: string | undefined;
    userType?: UserType;
    roleTypeValue?: number;
    roleType?: string | undefined;
    permissions?: PermissionDto[] | undefined;
    bankName?: string | undefined;
    bankId?: string;

    constructor(data?: IRolePermissionVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.roleName = _data["roleName"];
            this.description = _data["description"];
            this.userType = _data["userType"];
            this.roleTypeValue = _data["roleTypeValue"];
            this.roleType = _data["roleType"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(PermissionDto.fromJS(item));
            }
            this.bankName = _data["bankName"];
            this.bankId = _data["bankId"];
        }
    }

    static fromJS(data: any): RolePermissionVM {
        data = typeof data === 'object' ? data : {};
        let result = new RolePermissionVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["roleName"] = this.roleName;
        data["description"] = this.description;
        data["userType"] = this.userType;
        data["roleTypeValue"] = this.roleTypeValue;
        data["roleType"] = this.roleType;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        data["bankName"] = this.bankName;
        data["bankId"] = this.bankId;
        return data;
    }
}

export interface IRolePermissionVM {
    id?: string | undefined;
    roleName?: string | undefined;
    description?: string | undefined;
    userType?: UserType;
    roleTypeValue?: number;
    roleType?: string | undefined;
    permissions?: PermissionDto[] | undefined;
    bankName?: string | undefined;
    bankId?: string;
}

export class PermissionDto implements IPermissionDto {
    name?: string | undefined;
    group?: string | undefined;
    description?: string | undefined;
    value?: number;

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.group = _data["group"];
            this.description = _data["description"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["group"] = this.group;
        data["description"] = this.description;
        data["value"] = this.value;
        return data;
    }
}

export interface IPermissionDto {
    name?: string | undefined;
    group?: string | undefined;
    description?: string | undefined;
    value?: number;
}

export class UserProfileVm implements IUserProfileVm {
    userId?: string | undefined;
    jobTitle?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    userType?: string | undefined;
    phoneNumber?: string | undefined;
    userName?: string | undefined;

    constructor(data?: IUserProfileVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.jobTitle = _data["jobTitle"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.userType = _data["userType"];
            this.phoneNumber = _data["phoneNumber"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): UserProfileVm {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["jobTitle"] = this.jobTitle;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["userType"] = this.userType;
        data["phoneNumber"] = this.phoneNumber;
        data["userName"] = this.userName;
        return data;
    }
}

export interface IUserProfileVm {
    userId?: string | undefined;
    jobTitle?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    userType?: string | undefined;
    phoneNumber?: string | undefined;
    userName?: string | undefined;
}

export class AuthenticationRequest implements IAuthenticationRequest {
    userName!: string;
    password!: string;

    constructor(data?: IAuthenticationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): AuthenticationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }
}

export interface IAuthenticationRequest {
    userName: string;
    password: string;
}

export class ApiResponseOfAuthResponseDTO implements IApiResponseOfAuthResponseDTO {
    success?: boolean;
    status?: string | undefined;
    message?: string | undefined;
    data?: AuthResponseDTO | undefined;

    constructor(data?: IApiResponseOfAuthResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? AuthResponseDTO.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ApiResponseOfAuthResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfAuthResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IApiResponseOfAuthResponseDTO {
    success?: boolean;
    status?: string | undefined;
    message?: string | undefined;
    data?: AuthResponseDTO | undefined;
}

export class AuthResponseDTO implements IAuthResponseDTO {
    token?: string | undefined;
    signature?: string | undefined;
    user?: UserInfo | undefined;
    expireAt?: string | undefined;

    constructor(data?: IAuthResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.signature = _data["signature"];
            this.user = _data["user"] ? UserInfo.fromJS(_data["user"]) : <any>undefined;
            this.expireAt = _data["expireAt"];
        }
    }

    static fromJS(data: any): AuthResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AuthResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["signature"] = this.signature;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["expireAt"] = this.expireAt;
        return data;
    }
}

export interface IAuthResponseDTO {
    token?: string | undefined;
    signature?: string | undefined;
    user?: UserInfo | undefined;
    expireAt?: string | undefined;
}

export class UserInfo implements IUserInfo {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    address?: string | undefined;
    email?: string | undefined;
    userName?: string | undefined;
    mid?: string | undefined;
    oid?: string | undefined;
    merchantName?: string | undefined;
    outletName?: string | undefined;
    userType?: UserType | undefined;
    userTypeName?: string | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: IUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.address = _data["address"];
            this.email = _data["email"];
            this.userName = _data["userName"];
            this.mid = _data["mid"];
            this.oid = _data["oid"];
            this.merchantName = _data["merchantName"];
            this.outletName = _data["outletName"];
            this.userType = _data["userType"];
            this.userTypeName = _data["userTypeName"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): UserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["address"] = this.address;
        data["email"] = this.email;
        data["userName"] = this.userName;
        data["mid"] = this.mid;
        data["oid"] = this.oid;
        data["merchantName"] = this.merchantName;
        data["outletName"] = this.outletName;
        data["userType"] = this.userType;
        data["userTypeName"] = this.userTypeName;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IUserInfo {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    address?: string | undefined;
    email?: string | undefined;
    userName?: string | undefined;
    mid?: string | undefined;
    oid?: string | undefined;
    merchantName?: string | undefined;
    outletName?: string | undefined;
    userType?: UserType | undefined;
    userTypeName?: string | undefined;
    phoneNumber?: string | undefined;
}

export class PermissionVm implements IPermissionVm {
    group?: string | undefined;
    permissions?: PermissionDto[] | undefined;

    constructor(data?: IPermissionVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.group = _data["group"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(PermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionVm {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["group"] = this.group;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPermissionVm {
    group?: string | undefined;
    permissions?: PermissionDto[] | undefined;
}

export class RoleVm implements IRoleVm {
    roleName?: string | undefined;
    description?: string | undefined;
    userType?: UserType;
    bankId?: string | undefined;

    constructor(data?: IRoleVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleName = _data["roleName"];
            this.description = _data["description"];
            this.userType = _data["userType"];
            this.bankId = _data["bankId"];
        }
    }

    static fromJS(data: any): RoleVm {
        data = typeof data === 'object' ? data : {};
        let result = new RoleVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleName"] = this.roleName;
        data["description"] = this.description;
        data["userType"] = this.userType;
        data["bankId"] = this.bankId;
        return data;
    }
}

export interface IRoleVm {
    roleName?: string | undefined;
    description?: string | undefined;
    userType?: UserType;
    bankId?: string | undefined;
}

export class UpdateRoleCommand implements IUpdateRoleCommand {
    roleId?: string;
    roleName?: string | undefined;
    description?: string | undefined;

    constructor(data?: IUpdateRoleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdateRoleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRoleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["description"] = this.description;
        return data;
    }
}

export interface IUpdateRoleCommand {
    roleId?: string;
    roleName?: string | undefined;
    description?: string | undefined;
}

export class CreateBankRoleCommand implements ICreateBankRoleCommand {
    roleName?: string | undefined;
    description?: string | undefined;

    constructor(data?: ICreateBankRoleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleName = _data["roleName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateBankRoleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBankRoleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleName"] = this.roleName;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateBankRoleCommand {
    roleName?: string | undefined;
    description?: string | undefined;
}

export class UpdateUserProfileCommand implements IUpdateUserProfileCommand {
    userId?: string | undefined;
    userName?: string | undefined;
    email?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: IUpdateUserProfileCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.fullName = _data["fullName"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): UpdateUserProfileCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserProfileCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IUpdateUserProfileCommand {
    userId?: string | undefined;
    userName?: string | undefined;
    email?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
}

export class UpdateUserCommand implements IUpdateUserCommand {
    jobTitle?: string | undefined;
    userName?: string | undefined;
    email?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: IUpdateUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobTitle = _data["jobTitle"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.fullName = _data["fullName"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): UpdateUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobTitle"] = this.jobTitle;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IUpdateUserCommand {
    jobTitle?: string | undefined;
    userName?: string | undefined;
    email?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
}

export class ChangePasswordCommand implements IChangePasswordCommand {
    userId?: string | undefined;
    currentPassword?: string | undefined;
    newPassword?: string | undefined;
    confirmPassword?: string | undefined;

    constructor(data?: IChangePasswordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
            this.confirmPassword = _data["confirmPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        data["confirmPassword"] = this.confirmPassword;
        return data;
    }
}

export interface IChangePasswordCommand {
    userId?: string | undefined;
    currentPassword?: string | undefined;
    newPassword?: string | undefined;
    confirmPassword?: string | undefined;
}

export class ResetPasswordCommand implements IResetPasswordCommand {
    newPassword?: string | undefined;
    confirmPassword?: string | undefined;

    constructor(data?: IResetPasswordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newPassword = _data["newPassword"];
            this.confirmPassword = _data["confirmPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPassword"] = this.newPassword;
        data["confirmPassword"] = this.confirmPassword;
        return data;
    }
}

export interface IResetPasswordCommand {
    newPassword?: string | undefined;
    confirmPassword?: string | undefined;
}

export enum App {
    BankPortal = 1,
    IPOS = 2,
    MerchantPortal = 3,
}

export class ApplicationVersionViewModel implements IApplicationVersionViewModel {
    id?: string;
    applicationDate?: Date | undefined;
    bankId?: string | undefined;
    bankCode?: string | undefined;
    bankName?: string | undefined;
    applicationVer?: string | undefined;
    kernelType?: string | undefined;
    remarks?: string | undefined;
    comments?: string | undefined;
    outdated?: string | undefined;
    item?: string | undefined;
    applicationVersionDate?: string | undefined;

    constructor(data?: IApplicationVersionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.applicationDate = _data["applicationDate"] ? new Date(_data["applicationDate"].toString()) : <any>undefined;
            this.bankId = _data["bankId"];
            this.bankCode = _data["bankCode"];
            this.bankName = _data["bankName"];
            this.applicationVer = _data["applicationVer"];
            this.kernelType = _data["kernelType"];
            this.remarks = _data["remarks"];
            this.comments = _data["comments"];
            this.outdated = _data["outdated"];
            this.item = _data["item"];
            this.applicationVersionDate = _data["applicationVersionDate"];
        }
    }

    static fromJS(data: any): ApplicationVersionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationVersionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["applicationDate"] = this.applicationDate ? this.applicationDate.toISOString() : <any>undefined;
        data["bankId"] = this.bankId;
        data["bankCode"] = this.bankCode;
        data["bankName"] = this.bankName;
        data["applicationVer"] = this.applicationVer;
        data["kernelType"] = this.kernelType;
        data["remarks"] = this.remarks;
        data["comments"] = this.comments;
        data["outdated"] = this.outdated;
        data["item"] = this.item;
        data["applicationVersionDate"] = this.applicationVersionDate;
        return data;
    }
}

export interface IApplicationVersionViewModel {
    id?: string;
    applicationDate?: Date | undefined;
    bankId?: string | undefined;
    bankCode?: string | undefined;
    bankName?: string | undefined;
    applicationVer?: string | undefined;
    kernelType?: string | undefined;
    remarks?: string | undefined;
    comments?: string | undefined;
    outdated?: string | undefined;
    item?: string | undefined;
    applicationVersionDate?: string | undefined;
}

export class ApplicationVersionUpdateFormData implements IApplicationVersionUpdateFormData {
    id?: string;
    bankId?: string;
    applicationVersionId?: string;
    bankName?: string | undefined;
    merchantName?: string | undefined;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    contactPerson?: string | undefined;
    merchantCategory?: string | undefined;
    district?: string | undefined;
    address?: string | undefined;
    contactNo1?: string | undefined;
    item?: string | undefined;
    receivedBy?: string | undefined;
    serialKey?: string | undefined;
    terminalType?: string | undefined;
    receivedContactNo?: string | undefined;
    connectivity?: string | undefined;
    merchantLocation?: string | undefined;
    contactOfPos?: string | undefined;
    manualTransaction?: boolean;

    constructor(data?: IApplicationVersionUpdateFormData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bankId = _data["bankId"];
            this.applicationVersionId = _data["applicationVersionId"];
            this.bankName = _data["bankName"];
            this.merchantName = _data["merchantName"];
            this.idMerchant = _data["idMerchant"];
            this.idTerminal = _data["idTerminal"];
            this.contactPerson = _data["contactPerson"];
            this.merchantCategory = _data["merchantCategory"];
            this.district = _data["district"];
            this.address = _data["address"];
            this.contactNo1 = _data["contactNo1"];
            this.item = _data["item"];
            this.receivedBy = _data["receivedBy"];
            this.serialKey = _data["serialKey"];
            this.terminalType = _data["terminalType"];
            this.receivedContactNo = _data["receivedContactNo"];
            this.connectivity = _data["connectivity"];
            this.merchantLocation = _data["merchantLocation"];
            this.contactOfPos = _data["contactOfPos"];
            this.manualTransaction = _data["manualTransaction"];
        }
    }

    static fromJS(data: any): ApplicationVersionUpdateFormData {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationVersionUpdateFormData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankId"] = this.bankId;
        data["applicationVersionId"] = this.applicationVersionId;
        data["bankName"] = this.bankName;
        data["merchantName"] = this.merchantName;
        data["idMerchant"] = this.idMerchant;
        data["idTerminal"] = this.idTerminal;
        data["contactPerson"] = this.contactPerson;
        data["merchantCategory"] = this.merchantCategory;
        data["district"] = this.district;
        data["address"] = this.address;
        data["contactNo1"] = this.contactNo1;
        data["item"] = this.item;
        data["receivedBy"] = this.receivedBy;
        data["serialKey"] = this.serialKey;
        data["terminalType"] = this.terminalType;
        data["receivedContactNo"] = this.receivedContactNo;
        data["connectivity"] = this.connectivity;
        data["merchantLocation"] = this.merchantLocation;
        data["contactOfPos"] = this.contactOfPos;
        data["manualTransaction"] = this.manualTransaction;
        return data;
    }
}

export interface IApplicationVersionUpdateFormData {
    id?: string;
    bankId?: string;
    applicationVersionId?: string;
    bankName?: string | undefined;
    merchantName?: string | undefined;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    contactPerson?: string | undefined;
    merchantCategory?: string | undefined;
    district?: string | undefined;
    address?: string | undefined;
    contactNo1?: string | undefined;
    item?: string | undefined;
    receivedBy?: string | undefined;
    serialKey?: string | undefined;
    terminalType?: string | undefined;
    receivedContactNo?: string | undefined;
    connectivity?: string | undefined;
    merchantLocation?: string | undefined;
    contactOfPos?: string | undefined;
    manualTransaction?: boolean;
}

export class BanksViewModel implements IBanksViewModel {
    id?: string;
    bankName?: string | undefined;
    bankCode?: string | undefined;
    contactNo1?: string | undefined;
    address?: string | undefined;
    status?: string | undefined;
    contactPerson1?: string | undefined;
    contactPerson2?: string | undefined;
    contactNo2?: string | undefined;
    logo?: string | undefined;
    isLogoUploaded?: boolean;
    switchName?: string | undefined;
    switchId?: string;
    cardOptions?: CardAcceptanceOptions[] | undefined;
    banksList?: BankList[] | undefined;
    createdDate?: Date;
    iBankId?: string | undefined;
    isTxnDbRegistered?: boolean;

    constructor(data?: IBanksViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bankName = _data["bankName"];
            this.bankCode = _data["bankCode"];
            this.contactNo1 = _data["contactNo1"];
            this.address = _data["address"];
            this.status = _data["status"];
            this.contactPerson1 = _data["contactPerson1"];
            this.contactPerson2 = _data["contactPerson2"];
            this.contactNo2 = _data["contactNo2"];
            this.logo = _data["logo"];
            this.isLogoUploaded = _data["isLogoUploaded"];
            this.switchName = _data["switchName"];
            this.switchId = _data["switchId"];
            if (Array.isArray(_data["cardOptions"])) {
                this.cardOptions = [] as any;
                for (let item of _data["cardOptions"])
                    this.cardOptions!.push(item);
            }
            if (Array.isArray(_data["banksList"])) {
                this.banksList = [] as any;
                for (let item of _data["banksList"])
                    this.banksList!.push(BankList.fromJS(item));
            }
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.iBankId = _data["iBankId"];
            this.isTxnDbRegistered = _data["isTxnDbRegistered"];
        }
    }

    static fromJS(data: any): BanksViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BanksViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankName"] = this.bankName;
        data["bankCode"] = this.bankCode;
        data["contactNo1"] = this.contactNo1;
        data["address"] = this.address;
        data["status"] = this.status;
        data["contactPerson1"] = this.contactPerson1;
        data["contactPerson2"] = this.contactPerson2;
        data["contactNo2"] = this.contactNo2;
        data["logo"] = this.logo;
        data["isLogoUploaded"] = this.isLogoUploaded;
        data["switchName"] = this.switchName;
        data["switchId"] = this.switchId;
        if (Array.isArray(this.cardOptions)) {
            data["cardOptions"] = [];
            for (let item of this.cardOptions)
                data["cardOptions"].push(item);
        }
        if (Array.isArray(this.banksList)) {
            data["banksList"] = [];
            for (let item of this.banksList)
                data["banksList"].push(item.toJSON());
        }
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["iBankId"] = this.iBankId;
        data["isTxnDbRegistered"] = this.isTxnDbRegistered;
        return data;
    }
}

export interface IBanksViewModel {
    id?: string;
    bankName?: string | undefined;
    bankCode?: string | undefined;
    contactNo1?: string | undefined;
    address?: string | undefined;
    status?: string | undefined;
    contactPerson1?: string | undefined;
    contactPerson2?: string | undefined;
    contactNo2?: string | undefined;
    logo?: string | undefined;
    isLogoUploaded?: boolean;
    switchName?: string | undefined;
    switchId?: string;
    cardOptions?: CardAcceptanceOptions[] | undefined;
    banksList?: BankList[] | undefined;
    createdDate?: Date;
    iBankId?: string | undefined;
    isTxnDbRegistered?: boolean;
}

export enum CardAcceptanceOptions {
    VISA = 1,
    MASTERCARD = 2,
    UNIONPAY = 3,
    RUPAY = 4,
    AMERICANEXPRESS = 5,
    JCB = 6,
    SCT = 7,
    DISCOVER = 8,
}

export class BankList implements IBankList {
    id?: string;
    bankName?: string | undefined;
    bankCode?: string | undefined;
    logo?: string | undefined;
    contactNo1?: string | undefined;
    address?: string | undefined;
    status?: string | undefined;
    contactPerson1?: string | undefined;
    contactPerson2?: string | undefined;
    contactNo2?: string | undefined;

    constructor(data?: IBankList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bankName = _data["bankName"];
            this.bankCode = _data["bankCode"];
            this.logo = _data["logo"];
            this.contactNo1 = _data["contactNo1"];
            this.address = _data["address"];
            this.status = _data["status"];
            this.contactPerson1 = _data["contactPerson1"];
            this.contactPerson2 = _data["contactPerson2"];
            this.contactNo2 = _data["contactNo2"];
        }
    }

    static fromJS(data: any): BankList {
        data = typeof data === 'object' ? data : {};
        let result = new BankList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankName"] = this.bankName;
        data["bankCode"] = this.bankCode;
        data["logo"] = this.logo;
        data["contactNo1"] = this.contactNo1;
        data["address"] = this.address;
        data["status"] = this.status;
        data["contactPerson1"] = this.contactPerson1;
        data["contactPerson2"] = this.contactPerson2;
        data["contactNo2"] = this.contactNo2;
        return data;
    }
}

export interface IBankList {
    id?: string;
    bankName?: string | undefined;
    bankCode?: string | undefined;
    logo?: string | undefined;
    contactNo1?: string | undefined;
    address?: string | undefined;
    status?: string | undefined;
    contactPerson1?: string | undefined;
    contactPerson2?: string | undefined;
    contactNo2?: string | undefined;
}

export class SwitchViewModel implements ISwitchViewModel {
    id?: string;
    switchName?: string | undefined;

    constructor(data?: ISwitchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.switchName = _data["switchName"];
        }
    }

    static fromJS(data: any): SwitchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["switchName"] = this.switchName;
        return data;
    }
}

export interface ISwitchViewModel {
    id?: string;
    switchName?: string | undefined;
}

export class ResponseViewModelOfString implements IResponseViewModelOfString {
    data?: string[] | undefined;
    succeeded?: boolean;
    errors?: string[] | undefined;
    message?: string | undefined;

    constructor(data?: IResponseViewModelOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(item);
            }
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ResponseViewModelOfString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseViewModelOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}

export interface IResponseViewModelOfString {
    data?: string[] | undefined;
    succeeded?: boolean;
    errors?: string[] | undefined;
    message?: string | undefined;
}

export class CreateNewBankCommand implements ICreateNewBankCommand {
    id?: string;
    bankName?: string | undefined;
    bankCode?: string | undefined;
    contactNo1?: string | undefined;
    address?: string | undefined;
    status?: string | undefined;
    contactPerson1?: string | undefined;
    contactPerson2?: string | undefined;
    contactNo2?: string | undefined;
    logo?: string | undefined;
    isLogoUploaded?: boolean;
    switchName?: string | undefined;
    switchId?: string;
    isTxnDbRegistered?: boolean;
    cardOptions?: CardAcceptanceOptions[] | undefined;

    constructor(data?: ICreateNewBankCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bankName = _data["bankName"];
            this.bankCode = _data["bankCode"];
            this.contactNo1 = _data["contactNo1"];
            this.address = _data["address"];
            this.status = _data["status"];
            this.contactPerson1 = _data["contactPerson1"];
            this.contactPerson2 = _data["contactPerson2"];
            this.contactNo2 = _data["contactNo2"];
            this.logo = _data["logo"];
            this.isLogoUploaded = _data["isLogoUploaded"];
            this.switchName = _data["switchName"];
            this.switchId = _data["switchId"];
            this.isTxnDbRegistered = _data["isTxnDbRegistered"];
            if (Array.isArray(_data["cardOptions"])) {
                this.cardOptions = [] as any;
                for (let item of _data["cardOptions"])
                    this.cardOptions!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateNewBankCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNewBankCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankName"] = this.bankName;
        data["bankCode"] = this.bankCode;
        data["contactNo1"] = this.contactNo1;
        data["address"] = this.address;
        data["status"] = this.status;
        data["contactPerson1"] = this.contactPerson1;
        data["contactPerson2"] = this.contactPerson2;
        data["contactNo2"] = this.contactNo2;
        data["logo"] = this.logo;
        data["isLogoUploaded"] = this.isLogoUploaded;
        data["switchName"] = this.switchName;
        data["switchId"] = this.switchId;
        data["isTxnDbRegistered"] = this.isTxnDbRegistered;
        if (Array.isArray(this.cardOptions)) {
            data["cardOptions"] = [];
            for (let item of this.cardOptions)
                data["cardOptions"].push(item);
        }
        return data;
    }
}

export interface ICreateNewBankCommand {
    id?: string;
    bankName?: string | undefined;
    bankCode?: string | undefined;
    contactNo1?: string | undefined;
    address?: string | undefined;
    status?: string | undefined;
    contactPerson1?: string | undefined;
    contactPerson2?: string | undefined;
    contactNo2?: string | undefined;
    logo?: string | undefined;
    isLogoUploaded?: boolean;
    switchName?: string | undefined;
    switchId?: string;
    isTxnDbRegistered?: boolean;
    cardOptions?: CardAcceptanceOptions[] | undefined;
}

export class UpdateBankCommand implements IUpdateBankCommand {
    id?: string;
    bankName?: string | undefined;
    bankCode?: string | undefined;
    contactNo1?: string | undefined;
    address?: string | undefined;
    status?: string | undefined;
    contactPerson1?: string | undefined;
    contactPerson2?: string | undefined;
    contactNo2?: string | undefined;
    logo?: string | undefined;
    isLogoUploaded?: boolean;
    switchName?: string | undefined;
    switchId?: string;
    iBankId?: string | undefined;
    cardOptions?: CardAcceptanceOptions[] | undefined;

    constructor(data?: IUpdateBankCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bankName = _data["bankName"];
            this.bankCode = _data["bankCode"];
            this.contactNo1 = _data["contactNo1"];
            this.address = _data["address"];
            this.status = _data["status"];
            this.contactPerson1 = _data["contactPerson1"];
            this.contactPerson2 = _data["contactPerson2"];
            this.contactNo2 = _data["contactNo2"];
            this.logo = _data["logo"];
            this.isLogoUploaded = _data["isLogoUploaded"];
            this.switchName = _data["switchName"];
            this.switchId = _data["switchId"];
            this.iBankId = _data["iBankId"];
            if (Array.isArray(_data["cardOptions"])) {
                this.cardOptions = [] as any;
                for (let item of _data["cardOptions"])
                    this.cardOptions!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateBankCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBankCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankName"] = this.bankName;
        data["bankCode"] = this.bankCode;
        data["contactNo1"] = this.contactNo1;
        data["address"] = this.address;
        data["status"] = this.status;
        data["contactPerson1"] = this.contactPerson1;
        data["contactPerson2"] = this.contactPerson2;
        data["contactNo2"] = this.contactNo2;
        data["logo"] = this.logo;
        data["isLogoUploaded"] = this.isLogoUploaded;
        data["switchName"] = this.switchName;
        data["switchId"] = this.switchId;
        data["iBankId"] = this.iBankId;
        if (Array.isArray(this.cardOptions)) {
            data["cardOptions"] = [];
            for (let item of this.cardOptions)
                data["cardOptions"].push(item);
        }
        return data;
    }
}

export interface IUpdateBankCommand {
    id?: string;
    bankName?: string | undefined;
    bankCode?: string | undefined;
    contactNo1?: string | undefined;
    address?: string | undefined;
    status?: string | undefined;
    contactPerson1?: string | undefined;
    contactPerson2?: string | undefined;
    contactNo2?: string | undefined;
    logo?: string | undefined;
    isLogoUploaded?: boolean;
    switchName?: string | undefined;
    switchId?: string;
    iBankId?: string | undefined;
    cardOptions?: CardAcceptanceOptions[] | undefined;
}

export class GetBankIdAndNameQuery implements IGetBankIdAndNameQuery {
    id?: string;
    bankName?: string | undefined;

    constructor(data?: IGetBankIdAndNameQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bankName = _data["bankName"];
        }
    }

    static fromJS(data: any): GetBankIdAndNameQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetBankIdAndNameQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankName"] = this.bankName;
        return data;
    }
}

export interface IGetBankIdAndNameQuery {
    id?: string;
    bankName?: string | undefined;
}

export class BanksBureauVM implements IBanksBureauVM {
    bankId?: string;
    bankName?: string | undefined;
    bankCode?: string | undefined;

    constructor(data?: IBanksBureauVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankId = _data["bankId"];
            this.bankName = _data["bankName"];
            this.bankCode = _data["bankCode"];
        }
    }

    static fromJS(data: any): BanksBureauVM {
        data = typeof data === 'object' ? data : {};
        let result = new BanksBureauVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankId"] = this.bankId;
        data["bankName"] = this.bankName;
        data["bankCode"] = this.bankCode;
        return data;
    }
}

export interface IBanksBureauVM {
    bankId?: string;
    bankName?: string | undefined;
    bankCode?: string | undefined;
}

export class NacNumberViewModel implements INacNumberViewModel {
    id?: string;
    bankId?: string | undefined;
    bankCode?: string | undefined;
    bankName?: string | undefined;
    phoneNumber?: string | undefined;
    status?: string | undefined;

    constructor(data?: INacNumberViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bankId = _data["bankId"];
            this.bankCode = _data["bankCode"];
            this.bankName = _data["bankName"];
            this.phoneNumber = _data["phoneNumber"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): NacNumberViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new NacNumberViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankId"] = this.bankId;
        data["bankCode"] = this.bankCode;
        data["bankName"] = this.bankName;
        data["phoneNumber"] = this.phoneNumber;
        data["status"] = this.status;
        return data;
    }
}

export interface INacNumberViewModel {
    id?: string;
    bankId?: string | undefined;
    bankCode?: string | undefined;
    bankName?: string | undefined;
    phoneNumber?: string | undefined;
    status?: string | undefined;
}

export class MerchantForDropdownDTO implements IMerchantForDropdownDTO {
    mid?: string | undefined;
    merchantName?: string | undefined;
    id?: string;

    constructor(data?: IMerchantForDropdownDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mid = _data["mid"];
            this.merchantName = _data["merchantName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MerchantForDropdownDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantForDropdownDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mid"] = this.mid;
        data["merchantName"] = this.merchantName;
        data["id"] = this.id;
        return data;
    }
}

export interface IMerchantForDropdownDTO {
    mid?: string | undefined;
    merchantName?: string | undefined;
    id?: string;
}

export class TerminalForDropdownDTO implements ITerminalForDropdownDTO {
    tid?: string | undefined;
    terminalType?: string | undefined;
    mid?: string | undefined;

    constructor(data?: ITerminalForDropdownDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tid = _data["tid"];
            this.terminalType = _data["terminalType"];
            this.mid = _data["mid"];
        }
    }

    static fromJS(data: any): TerminalForDropdownDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TerminalForDropdownDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tid"] = this.tid;
        data["terminalType"] = this.terminalType;
        data["mid"] = this.mid;
        return data;
    }
}

export interface ITerminalForDropdownDTO {
    tid?: string | undefined;
    terminalType?: string | undefined;
    mid?: string | undefined;
}

export class TerminalInfoViewModel implements ITerminalInfoViewModel {
    shortName?: string | undefined;
    inventoryId?: string;

    constructor(data?: ITerminalInfoViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shortName = _data["shortName"];
            this.inventoryId = _data["inventoryId"];
        }
    }

    static fromJS(data: any): TerminalInfoViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TerminalInfoViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shortName"] = this.shortName;
        data["inventoryId"] = this.inventoryId;
        return data;
    }
}

export interface ITerminalInfoViewModel {
    shortName?: string | undefined;
    inventoryId?: string;
}

export class MerchantCategoryDetailsVM implements IMerchantCategoryDetailsVM {
    id?: string;
    merchantCategoryName?: string | undefined;
    mcc?: string | undefined;

    constructor(data?: IMerchantCategoryDetailsVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.merchantCategoryName = _data["merchantCategoryName"];
            this.mcc = _data["mcc"];
        }
    }

    static fromJS(data: any): MerchantCategoryDetailsVM {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantCategoryDetailsVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["merchantCategoryName"] = this.merchantCategoryName;
        data["mcc"] = this.mcc;
        return data;
    }
}

export interface IMerchantCategoryDetailsVM {
    id?: string;
    merchantCategoryName?: string | undefined;
    mcc?: string | undefined;
}

export class CreateDeploymentRequestCommand implements ICreateDeploymentRequestCommand {
    bankPortalDepReqVM?: BankPortalDeploymentRequestViewModel[] | undefined;

    constructor(data?: ICreateDeploymentRequestCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["bankPortalDepReqVM"])) {
                this.bankPortalDepReqVM = [] as any;
                for (let item of _data["bankPortalDepReqVM"])
                    this.bankPortalDepReqVM!.push(BankPortalDeploymentRequestViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateDeploymentRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDeploymentRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bankPortalDepReqVM)) {
            data["bankPortalDepReqVM"] = [];
            for (let item of this.bankPortalDepReqVM)
                data["bankPortalDepReqVM"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateDeploymentRequestCommand {
    bankPortalDepReqVM?: BankPortalDeploymentRequestViewModel[] | undefined;
}

export class BankPortalDeploymentRequestViewModel implements IBankPortalDeploymentRequestViewModel {
    merchant?: string | undefined;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    address?: string | undefined;
    contactPerson?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    emailAddress?: string | undefined;
    province?: string | undefined;
    merchantCategory?: string | undefined;
    tipAdjustment?: boolean;
    refund?: boolean;
    manualTransaction?: boolean;
    district?: string | undefined;
    currency?: string | undefined;
    preAuthorization?: boolean;
    priority?: boolean;
    component1?: string | undefined;
    component2?: string | undefined;
    combineValue?: string | undefined;
    finalValue?: string | undefined;
    kvc1?: string | undefined;
    pinChange?: boolean;
    cashAdvance?: boolean;
    bankRemarks?: string | undefined;
    kvc2?: string | undefined;
    branchName?: string | undefined;
    mcc?: string | undefined;
    terminalType?: string | undefined;
    panNumber?: string | undefined;
    businessNature?: string | undefined;
    merchantCategoryId?: string | undefined;
    inventoryId?: string | undefined;
    bankId?: string | undefined;

    constructor(data?: IBankPortalDeploymentRequestViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.merchant = _data["merchant"];
            this.idMerchant = _data["idMerchant"];
            this.idTerminal = _data["idTerminal"];
            this.address = _data["address"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo1 = _data["contactNo1"];
            this.contactNo2 = _data["contactNo2"];
            this.emailAddress = _data["emailAddress"];
            this.province = _data["province"];
            this.merchantCategory = _data["merchantCategory"];
            this.tipAdjustment = _data["tipAdjustment"];
            this.refund = _data["refund"];
            this.manualTransaction = _data["manualTransaction"];
            this.district = _data["district"];
            this.currency = _data["currency"];
            this.preAuthorization = _data["preAuthorization"];
            this.priority = _data["priority"];
            this.component1 = _data["component1"];
            this.component2 = _data["component2"];
            this.combineValue = _data["combineValue"];
            this.finalValue = _data["finalValue"];
            this.kvc1 = _data["kvc1"];
            this.pinChange = _data["pinChange"];
            this.cashAdvance = _data["cashAdvance"];
            this.bankRemarks = _data["bankRemarks"];
            this.kvc2 = _data["kvc2"];
            this.branchName = _data["branchName"];
            this.mcc = _data["mcc"];
            this.terminalType = _data["terminalType"];
            this.panNumber = _data["panNumber"];
            this.businessNature = _data["businessNature"];
            this.merchantCategoryId = _data["merchantCategoryId"];
            this.inventoryId = _data["inventoryId"];
            this.bankId = _data["bankId"];
        }
    }

    static fromJS(data: any): BankPortalDeploymentRequestViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BankPortalDeploymentRequestViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["merchant"] = this.merchant;
        data["idMerchant"] = this.idMerchant;
        data["idTerminal"] = this.idTerminal;
        data["address"] = this.address;
        data["contactPerson"] = this.contactPerson;
        data["contactNo1"] = this.contactNo1;
        data["contactNo2"] = this.contactNo2;
        data["emailAddress"] = this.emailAddress;
        data["province"] = this.province;
        data["merchantCategory"] = this.merchantCategory;
        data["tipAdjustment"] = this.tipAdjustment;
        data["refund"] = this.refund;
        data["manualTransaction"] = this.manualTransaction;
        data["district"] = this.district;
        data["currency"] = this.currency;
        data["preAuthorization"] = this.preAuthorization;
        data["priority"] = this.priority;
        data["component1"] = this.component1;
        data["component2"] = this.component2;
        data["combineValue"] = this.combineValue;
        data["finalValue"] = this.finalValue;
        data["kvc1"] = this.kvc1;
        data["pinChange"] = this.pinChange;
        data["cashAdvance"] = this.cashAdvance;
        data["bankRemarks"] = this.bankRemarks;
        data["kvc2"] = this.kvc2;
        data["branchName"] = this.branchName;
        data["mcc"] = this.mcc;
        data["terminalType"] = this.terminalType;
        data["panNumber"] = this.panNumber;
        data["businessNature"] = this.businessNature;
        data["merchantCategoryId"] = this.merchantCategoryId;
        data["inventoryId"] = this.inventoryId;
        data["bankId"] = this.bankId;
        return data;
    }
}

export interface IBankPortalDeploymentRequestViewModel {
    merchant?: string | undefined;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    address?: string | undefined;
    contactPerson?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    emailAddress?: string | undefined;
    province?: string | undefined;
    merchantCategory?: string | undefined;
    tipAdjustment?: boolean;
    refund?: boolean;
    manualTransaction?: boolean;
    district?: string | undefined;
    currency?: string | undefined;
    preAuthorization?: boolean;
    priority?: boolean;
    component1?: string | undefined;
    component2?: string | undefined;
    combineValue?: string | undefined;
    finalValue?: string | undefined;
    kvc1?: string | undefined;
    pinChange?: boolean;
    cashAdvance?: boolean;
    bankRemarks?: string | undefined;
    kvc2?: string | undefined;
    branchName?: string | undefined;
    mcc?: string | undefined;
    terminalType?: string | undefined;
    panNumber?: string | undefined;
    businessNature?: string | undefined;
    merchantCategoryId?: string | undefined;
    inventoryId?: string | undefined;
    bankId?: string | undefined;
}

export class CreateSupportCommand implements ICreateSupportCommand {
    phone?: boolean;
    field?: boolean;
    priority?: boolean;
    issue?: string | undefined;
    contactPerson?: string | undefined;
    createdBy?: string | undefined;
    contactNo?: string | undefined;
    resolvedRemarks?: string | undefined;
    ticketNumber?: string | undefined;
    isFieldSupport?: boolean;
    supportStatus?: SupportStatus;
    applicationVersionId?: string;
    serialKey?: string | undefined;
    serialNumberId?: string;
    deploymentRequestId?: string;
    bankId?: string;
    merchantLocation?: string | undefined;
    remarks?: string | undefined;
    supportDate?: Date;
    verification?: string | undefined;
    imarkTerminalId?: string | undefined;

    constructor(data?: ICreateSupportCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phone = _data["phone"];
            this.field = _data["field"];
            this.priority = _data["priority"];
            this.issue = _data["issue"];
            this.contactPerson = _data["contactPerson"];
            this.createdBy = _data["createdBy"];
            this.contactNo = _data["contactNo"];
            this.resolvedRemarks = _data["resolvedRemarks"];
            this.ticketNumber = _data["ticketNumber"];
            this.isFieldSupport = _data["isFieldSupport"];
            this.supportStatus = _data["supportStatus"];
            this.applicationVersionId = _data["applicationVersionId"];
            this.serialKey = _data["serialKey"];
            this.serialNumberId = _data["serialNumberId"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.bankId = _data["bankId"];
            this.merchantLocation = _data["merchantLocation"];
            this.remarks = _data["remarks"];
            this.supportDate = _data["supportDate"] ? new Date(_data["supportDate"].toString()) : <any>undefined;
            this.verification = _data["verification"];
            this.imarkTerminalId = _data["imarkTerminalId"];
        }
    }

    static fromJS(data: any): CreateSupportCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSupportCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phone"] = this.phone;
        data["field"] = this.field;
        data["priority"] = this.priority;
        data["issue"] = this.issue;
        data["contactPerson"] = this.contactPerson;
        data["createdBy"] = this.createdBy;
        data["contactNo"] = this.contactNo;
        data["resolvedRemarks"] = this.resolvedRemarks;
        data["ticketNumber"] = this.ticketNumber;
        data["isFieldSupport"] = this.isFieldSupport;
        data["supportStatus"] = this.supportStatus;
        data["applicationVersionId"] = this.applicationVersionId;
        data["serialKey"] = this.serialKey;
        data["serialNumberId"] = this.serialNumberId;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["bankId"] = this.bankId;
        data["merchantLocation"] = this.merchantLocation;
        data["remarks"] = this.remarks;
        data["supportDate"] = this.supportDate ? this.supportDate.toISOString() : <any>undefined;
        data["verification"] = this.verification;
        data["imarkTerminalId"] = this.imarkTerminalId;
        return data;
    }
}

export interface ICreateSupportCommand {
    phone?: boolean;
    field?: boolean;
    priority?: boolean;
    issue?: string | undefined;
    contactPerson?: string | undefined;
    createdBy?: string | undefined;
    contactNo?: string | undefined;
    resolvedRemarks?: string | undefined;
    ticketNumber?: string | undefined;
    isFieldSupport?: boolean;
    supportStatus?: SupportStatus;
    applicationVersionId?: string;
    serialKey?: string | undefined;
    serialNumberId?: string;
    deploymentRequestId?: string;
    bankId?: string;
    merchantLocation?: string | undefined;
    remarks?: string | undefined;
    supportDate?: Date;
    verification?: string | undefined;
    imarkTerminalId?: string | undefined;
}

export class DeployedHistoryViewModel implements IDeployedHistoryViewModel {
    id?: string;
    deploymentRequestId?: string;
    bankId?: string;
    bankCode?: string | undefined;
    bankName?: string | undefined;
    idTerminal?: string | undefined;
    idMerchant?: string | undefined;
    emailAddress?: string | undefined;
    address?: string | undefined;
    province?: string | undefined;
    district?: string | undefined;
    merchantCategory?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    contactPerson?: string | undefined;
    inventoryId?: string;
    combineValue?: string | undefined;
    finalValue?: string | undefined;
    component1?: string | undefined;
    component2?: string | undefined;
    kvc1?: string | undefined;
    kvc2?: string | undefined;
    terminalType?: string | undefined;
    remarks?: string | undefined;
    serialNumberId?: string;
    branchName?: string | undefined;
    serialKey?: string | undefined;
    previousSerial?: string | undefined;
    isSold?: boolean;
    configStatus?: string | undefined;
    item?: string | undefined;
    verification?: string | undefined;
    receivedBy?: string | undefined;
    receivedContactNo?: string | undefined;
    merchantLocation?: string | undefined;
    deployedby?: string | undefined;
    remarksDeploy?: string | undefined;
    statusId?: string;
    statusName?: string | undefined;
    requestName?: string | undefined;
    requestedDate?: string | undefined;
    applicationFormat?: string | undefined;
    connectivities?: Connectivity[] | undefined;
    deployDate?: string | undefined;
    depDate?: string | undefined;
    isSupportPresent?: boolean;
    rentalInventoryAdd?: string | undefined;
    panNumber?: string | undefined;
    merchant?: string | undefined;
    deploymentStatus?: string | undefined;

    constructor(data?: IDeployedHistoryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.bankId = _data["bankId"];
            this.bankCode = _data["bankCode"];
            this.bankName = _data["bankName"];
            this.idTerminal = _data["idTerminal"];
            this.idMerchant = _data["idMerchant"];
            this.emailAddress = _data["emailAddress"];
            this.address = _data["address"];
            this.province = _data["province"];
            this.district = _data["district"];
            this.merchantCategory = _data["merchantCategory"];
            this.contactNo1 = _data["contactNo1"];
            this.contactNo2 = _data["contactNo2"];
            this.contactPerson = _data["contactPerson"];
            this.inventoryId = _data["inventoryId"];
            this.combineValue = _data["combineValue"];
            this.finalValue = _data["finalValue"];
            this.component1 = _data["component1"];
            this.component2 = _data["component2"];
            this.kvc1 = _data["kvc1"];
            this.kvc2 = _data["kvc2"];
            this.terminalType = _data["terminalType"];
            this.remarks = _data["remarks"];
            this.serialNumberId = _data["serialNumberId"];
            this.branchName = _data["branchName"];
            this.serialKey = _data["serialKey"];
            this.previousSerial = _data["previousSerial"];
            this.isSold = _data["isSold"];
            this.configStatus = _data["configStatus"];
            this.item = _data["item"];
            this.verification = _data["verification"];
            this.receivedBy = _data["receivedBy"];
            this.receivedContactNo = _data["receivedContactNo"];
            this.merchantLocation = _data["merchantLocation"];
            this.deployedby = _data["deployedby"];
            this.remarksDeploy = _data["remarksDeploy"];
            this.statusId = _data["statusId"];
            this.statusName = _data["statusName"];
            this.requestName = _data["requestName"];
            this.requestedDate = _data["requestedDate"];
            this.applicationFormat = _data["applicationFormat"];
            if (Array.isArray(_data["connectivities"])) {
                this.connectivities = [] as any;
                for (let item of _data["connectivities"])
                    this.connectivities!.push(item);
            }
            this.deployDate = _data["deployDate"];
            this.depDate = _data["depDate"];
            this.isSupportPresent = _data["isSupportPresent"];
            this.rentalInventoryAdd = _data["rentalInventoryAdd"];
            this.panNumber = _data["panNumber"];
            this.merchant = _data["merchant"];
            this.deploymentStatus = _data["deploymentStatus"];
        }
    }

    static fromJS(data: any): DeployedHistoryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeployedHistoryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["bankId"] = this.bankId;
        data["bankCode"] = this.bankCode;
        data["bankName"] = this.bankName;
        data["idTerminal"] = this.idTerminal;
        data["idMerchant"] = this.idMerchant;
        data["emailAddress"] = this.emailAddress;
        data["address"] = this.address;
        data["province"] = this.province;
        data["district"] = this.district;
        data["merchantCategory"] = this.merchantCategory;
        data["contactNo1"] = this.contactNo1;
        data["contactNo2"] = this.contactNo2;
        data["contactPerson"] = this.contactPerson;
        data["inventoryId"] = this.inventoryId;
        data["combineValue"] = this.combineValue;
        data["finalValue"] = this.finalValue;
        data["component1"] = this.component1;
        data["component2"] = this.component2;
        data["kvc1"] = this.kvc1;
        data["kvc2"] = this.kvc2;
        data["terminalType"] = this.terminalType;
        data["remarks"] = this.remarks;
        data["serialNumberId"] = this.serialNumberId;
        data["branchName"] = this.branchName;
        data["serialKey"] = this.serialKey;
        data["previousSerial"] = this.previousSerial;
        data["isSold"] = this.isSold;
        data["configStatus"] = this.configStatus;
        data["item"] = this.item;
        data["verification"] = this.verification;
        data["receivedBy"] = this.receivedBy;
        data["receivedContactNo"] = this.receivedContactNo;
        data["merchantLocation"] = this.merchantLocation;
        data["deployedby"] = this.deployedby;
        data["remarksDeploy"] = this.remarksDeploy;
        data["statusId"] = this.statusId;
        data["statusName"] = this.statusName;
        data["requestName"] = this.requestName;
        data["requestedDate"] = this.requestedDate;
        data["applicationFormat"] = this.applicationFormat;
        if (Array.isArray(this.connectivities)) {
            data["connectivities"] = [];
            for (let item of this.connectivities)
                data["connectivities"].push(item);
        }
        data["deployDate"] = this.deployDate;
        data["depDate"] = this.depDate;
        data["isSupportPresent"] = this.isSupportPresent;
        data["rentalInventoryAdd"] = this.rentalInventoryAdd;
        data["panNumber"] = this.panNumber;
        data["merchant"] = this.merchant;
        data["deploymentStatus"] = this.deploymentStatus;
        return data;
    }
}

export interface IDeployedHistoryViewModel {
    id?: string;
    deploymentRequestId?: string;
    bankId?: string;
    bankCode?: string | undefined;
    bankName?: string | undefined;
    idTerminal?: string | undefined;
    idMerchant?: string | undefined;
    emailAddress?: string | undefined;
    address?: string | undefined;
    province?: string | undefined;
    district?: string | undefined;
    merchantCategory?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    contactPerson?: string | undefined;
    inventoryId?: string;
    combineValue?: string | undefined;
    finalValue?: string | undefined;
    component1?: string | undefined;
    component2?: string | undefined;
    kvc1?: string | undefined;
    kvc2?: string | undefined;
    terminalType?: string | undefined;
    remarks?: string | undefined;
    serialNumberId?: string;
    branchName?: string | undefined;
    serialKey?: string | undefined;
    previousSerial?: string | undefined;
    isSold?: boolean;
    configStatus?: string | undefined;
    item?: string | undefined;
    verification?: string | undefined;
    receivedBy?: string | undefined;
    receivedContactNo?: string | undefined;
    merchantLocation?: string | undefined;
    deployedby?: string | undefined;
    remarksDeploy?: string | undefined;
    statusId?: string;
    statusName?: string | undefined;
    requestName?: string | undefined;
    requestedDate?: string | undefined;
    applicationFormat?: string | undefined;
    connectivities?: Connectivity[] | undefined;
    deployDate?: string | undefined;
    depDate?: string | undefined;
    isSupportPresent?: boolean;
    rentalInventoryAdd?: string | undefined;
    panNumber?: string | undefined;
    merchant?: string | undefined;
    deploymentStatus?: string | undefined;
}

export enum Connectivity {
    ETHERNET = 1,
    GPRS = 2,
    PSTN = 3,
    UNKNOWN = 4,
    WIFI = 5,
}

export class DeploymentAddRequestViewModel implements IDeploymentAddRequestViewModel {
    id?: string;
    bankId?: string;
    bankName?: string | undefined;
    reqDate?: string | undefined;
    bankCode?: string | undefined;
    merchant?: string | undefined;
    idMerchant?: string | undefined;
    outlet?: string | undefined;
    district?: string | undefined;
    address?: string | undefined;
    province?: string | undefined;
    merchantCategory?: string | undefined;
    contactPerson?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    emailAddress?: string | undefined;
    idTerminal?: string | undefined;
    terminalType?: string | undefined;
    item?: string | undefined;
    panNumber?: string | undefined;
    inventoryId?: string;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    currency?: string | undefined;
    tipAdjustment?: boolean;
    manualTransaction?: boolean;
    preAuthorization?: boolean;
    cashAdvance?: boolean;
    pinChange?: boolean;
    dispatch?: boolean;
    component1?: string | undefined;
    component2?: string | undefined;
    combineValue?: string | undefined;
    finalValue?: string | undefined;
    kvc1?: string | undefined;
    kvc2?: string | undefined;
    isActive?: boolean;
    branchName?: string | undefined;
    mcc?: string | undefined;
    priority?: boolean;
    statusId?: string;
    statusName?: string | undefined;
    remarks?: string | undefined;
    rejected?: boolean;
    businessNature?: string | undefined;
    requestedDate?: string | undefined;
    remarksForDeploy?: string | undefined;
    verification?: string | undefined;
    name?: string | undefined;
    requestTypeId?: string;
    requestName?: string | undefined;
    checkerId?: string;
    refund?: boolean;
    serialKey?: string | undefined;
    previousSerial?: string | undefined;
    configStatus?: string | undefined;
    applicationVersion?: string | undefined;
    statusForDeploy?: string | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    createdDate?: Date;
    updatedDate?: Date;
    settlementPrimaryId?: string | undefined;
    settlementSecondaryId?: string | undefined;
    transactionPrimaryId?: string | undefined;
    transactionSecondaryId?: string | undefined;
    merchantCategoryId?: string | undefined;
    bankRemarks?: string | undefined;
    shortName?: string | undefined;
    ticketNumber?: string | undefined;
    longitude?: string | undefined;
    requestedDateInString?: string | undefined;
    requestStatus?: string | undefined;
    deploymentStatus?: string | undefined;

    constructor(data?: IDeploymentAddRequestViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bankId = _data["bankId"];
            this.bankName = _data["bankName"];
            this.reqDate = _data["reqDate"];
            this.bankCode = _data["bankCode"];
            this.merchant = _data["merchant"];
            this.idMerchant = _data["idMerchant"];
            this.outlet = _data["outlet"];
            this.district = _data["district"];
            this.address = _data["address"];
            this.province = _data["province"];
            this.merchantCategory = _data["merchantCategory"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo1 = _data["contactNo1"];
            this.contactNo2 = _data["contactNo2"];
            this.emailAddress = _data["emailAddress"];
            this.idTerminal = _data["idTerminal"];
            this.terminalType = _data["terminalType"];
            this.item = _data["item"];
            this.panNumber = _data["panNumber"];
            this.inventoryId = _data["inventoryId"];
            this.primaryItem = _data["primaryItem"];
            this.secondaryItem = _data["secondaryItem"];
            this.tertiaryItem = _data["tertiaryItem"];
            this.detailItem = _data["detailItem"];
            this.currency = _data["currency"];
            this.tipAdjustment = _data["tipAdjustment"];
            this.manualTransaction = _data["manualTransaction"];
            this.preAuthorization = _data["preAuthorization"];
            this.cashAdvance = _data["cashAdvance"];
            this.pinChange = _data["pinChange"];
            this.dispatch = _data["dispatch"];
            this.component1 = _data["component1"];
            this.component2 = _data["component2"];
            this.combineValue = _data["combineValue"];
            this.finalValue = _data["finalValue"];
            this.kvc1 = _data["kvc1"];
            this.kvc2 = _data["kvc2"];
            this.isActive = _data["isActive"];
            this.branchName = _data["branchName"];
            this.mcc = _data["mcc"];
            this.priority = _data["priority"];
            this.statusId = _data["statusId"];
            this.statusName = _data["statusName"];
            this.remarks = _data["remarks"];
            this.rejected = _data["rejected"];
            this.businessNature = _data["businessNature"];
            this.requestedDate = _data["requestedDate"];
            this.remarksForDeploy = _data["remarksForDeploy"];
            this.verification = _data["verification"];
            this.name = _data["name"];
            this.requestTypeId = _data["requestTypeId"];
            this.requestName = _data["requestName"];
            this.checkerId = _data["checkerId"];
            this.refund = _data["refund"];
            this.serialKey = _data["serialKey"];
            this.previousSerial = _data["previousSerial"];
            this.configStatus = _data["configStatus"];
            this.applicationVersion = _data["applicationVersion"];
            this.statusForDeploy = _data["statusForDeploy"];
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.settlementPrimaryId = _data["settlementPrimaryId"];
            this.settlementSecondaryId = _data["settlementSecondaryId"];
            this.transactionPrimaryId = _data["transactionPrimaryId"];
            this.transactionSecondaryId = _data["transactionSecondaryId"];
            this.merchantCategoryId = _data["merchantCategoryId"];
            this.bankRemarks = _data["bankRemarks"];
            this.shortName = _data["shortName"];
            this.ticketNumber = _data["ticketNumber"];
            this.longitude = _data["longitude"];
            this.requestedDateInString = _data["requestedDateInString"];
            this.requestStatus = _data["requestStatus"];
            this.deploymentStatus = _data["deploymentStatus"];
        }
    }

    static fromJS(data: any): DeploymentAddRequestViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeploymentAddRequestViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankId"] = this.bankId;
        data["bankName"] = this.bankName;
        data["reqDate"] = this.reqDate;
        data["bankCode"] = this.bankCode;
        data["merchant"] = this.merchant;
        data["idMerchant"] = this.idMerchant;
        data["outlet"] = this.outlet;
        data["district"] = this.district;
        data["address"] = this.address;
        data["province"] = this.province;
        data["merchantCategory"] = this.merchantCategory;
        data["contactPerson"] = this.contactPerson;
        data["contactNo1"] = this.contactNo1;
        data["contactNo2"] = this.contactNo2;
        data["emailAddress"] = this.emailAddress;
        data["idTerminal"] = this.idTerminal;
        data["terminalType"] = this.terminalType;
        data["item"] = this.item;
        data["panNumber"] = this.panNumber;
        data["inventoryId"] = this.inventoryId;
        data["primaryItem"] = this.primaryItem;
        data["secondaryItem"] = this.secondaryItem;
        data["tertiaryItem"] = this.tertiaryItem;
        data["detailItem"] = this.detailItem;
        data["currency"] = this.currency;
        data["tipAdjustment"] = this.tipAdjustment;
        data["manualTransaction"] = this.manualTransaction;
        data["preAuthorization"] = this.preAuthorization;
        data["cashAdvance"] = this.cashAdvance;
        data["pinChange"] = this.pinChange;
        data["dispatch"] = this.dispatch;
        data["component1"] = this.component1;
        data["component2"] = this.component2;
        data["combineValue"] = this.combineValue;
        data["finalValue"] = this.finalValue;
        data["kvc1"] = this.kvc1;
        data["kvc2"] = this.kvc2;
        data["isActive"] = this.isActive;
        data["branchName"] = this.branchName;
        data["mcc"] = this.mcc;
        data["priority"] = this.priority;
        data["statusId"] = this.statusId;
        data["statusName"] = this.statusName;
        data["remarks"] = this.remarks;
        data["rejected"] = this.rejected;
        data["businessNature"] = this.businessNature;
        data["requestedDate"] = this.requestedDate;
        data["remarksForDeploy"] = this.remarksForDeploy;
        data["verification"] = this.verification;
        data["name"] = this.name;
        data["requestTypeId"] = this.requestTypeId;
        data["requestName"] = this.requestName;
        data["checkerId"] = this.checkerId;
        data["refund"] = this.refund;
        data["serialKey"] = this.serialKey;
        data["previousSerial"] = this.previousSerial;
        data["configStatus"] = this.configStatus;
        data["applicationVersion"] = this.applicationVersion;
        data["statusForDeploy"] = this.statusForDeploy;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["settlementPrimaryId"] = this.settlementPrimaryId;
        data["settlementSecondaryId"] = this.settlementSecondaryId;
        data["transactionPrimaryId"] = this.transactionPrimaryId;
        data["transactionSecondaryId"] = this.transactionSecondaryId;
        data["merchantCategoryId"] = this.merchantCategoryId;
        data["bankRemarks"] = this.bankRemarks;
        data["shortName"] = this.shortName;
        data["ticketNumber"] = this.ticketNumber;
        data["longitude"] = this.longitude;
        data["requestedDateInString"] = this.requestedDateInString;
        data["requestStatus"] = this.requestStatus;
        data["deploymentStatus"] = this.deploymentStatus;
        return data;
    }
}

export interface IDeploymentAddRequestViewModel {
    id?: string;
    bankId?: string;
    bankName?: string | undefined;
    reqDate?: string | undefined;
    bankCode?: string | undefined;
    merchant?: string | undefined;
    idMerchant?: string | undefined;
    outlet?: string | undefined;
    district?: string | undefined;
    address?: string | undefined;
    province?: string | undefined;
    merchantCategory?: string | undefined;
    contactPerson?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    emailAddress?: string | undefined;
    idTerminal?: string | undefined;
    terminalType?: string | undefined;
    item?: string | undefined;
    panNumber?: string | undefined;
    inventoryId?: string;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    currency?: string | undefined;
    tipAdjustment?: boolean;
    manualTransaction?: boolean;
    preAuthorization?: boolean;
    cashAdvance?: boolean;
    pinChange?: boolean;
    dispatch?: boolean;
    component1?: string | undefined;
    component2?: string | undefined;
    combineValue?: string | undefined;
    finalValue?: string | undefined;
    kvc1?: string | undefined;
    kvc2?: string | undefined;
    isActive?: boolean;
    branchName?: string | undefined;
    mcc?: string | undefined;
    priority?: boolean;
    statusId?: string;
    statusName?: string | undefined;
    remarks?: string | undefined;
    rejected?: boolean;
    businessNature?: string | undefined;
    requestedDate?: string | undefined;
    remarksForDeploy?: string | undefined;
    verification?: string | undefined;
    name?: string | undefined;
    requestTypeId?: string;
    requestName?: string | undefined;
    checkerId?: string;
    refund?: boolean;
    serialKey?: string | undefined;
    previousSerial?: string | undefined;
    configStatus?: string | undefined;
    applicationVersion?: string | undefined;
    statusForDeploy?: string | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    createdDate?: Date;
    updatedDate?: Date;
    settlementPrimaryId?: string | undefined;
    settlementSecondaryId?: string | undefined;
    transactionPrimaryId?: string | undefined;
    transactionSecondaryId?: string | undefined;
    merchantCategoryId?: string | undefined;
    bankRemarks?: string | undefined;
    shortName?: string | undefined;
    ticketNumber?: string | undefined;
    longitude?: string | undefined;
    requestedDateInString?: string | undefined;
    requestStatus?: string | undefined;
    deploymentStatus?: string | undefined;
}

export class PosHistoryViewModel implements IPosHistoryViewModel {
    id?: string;
    deploymentRequestId?: string;
    inventoryId?: string;
    bankId?: string;
    bankName?: string | undefined;
    bankCode?: string | undefined;
    merchant?: string | undefined;
    idMerchant?: string | undefined;
    outlet?: string | undefined;
    district?: string | undefined;
    address?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    idTerminal?: string | undefined;
    terminalType?: string | undefined;
    item?: string | undefined;
    currency?: string | undefined;
    tipAdjustment?: boolean;
    manualTransaction?: boolean;
    preAuthorization?: boolean;
    refund?: boolean;
    cashAdvance?: boolean;
    pinChange?: boolean;
    primaryTxnNumber?: string | undefined;
    branchName?: string | undefined;
    secondaryTxnNumber?: string | undefined;
    province?: string | undefined;
    merchantCategory?: string | undefined;
    primaryNacNumber?: string | undefined;
    secondaryNacNumber?: string | undefined;
    component1?: string | undefined;
    component2?: string | undefined;
    combineValue?: string | undefined;
    finalValue?: string | undefined;
    kvc1?: string | undefined;
    kvc2?: string | undefined;
    priority?: boolean;
    remarks?: string | undefined;
    statusId?: string;
    statusName?: string | undefined;
    requestName?: string | undefined;
    remarksDeploy?: string | undefined;
    serialNumberId?: string;
    serialKey?: string | undefined;
    depDate?: string | undefined;
    createdDate?: Date;
    deployedRequestedDate?: string | undefined;
    applicationVersionId?: string;
    applicationVersion?: string | undefined;
    applicationDate?: Date | undefined;
    applicationDateVersion?: string | undefined;
    applicationFormat?: string | undefined;
    contactOfPos?: string | undefined;
    limit?: string | undefined;
    receivedBy?: string | undefined;
    receivedContactNo?: string | undefined;
    connectivity?: string | undefined;
    merchantLocation?: string | undefined;
    latitude?: string | undefined;
    longitude?: string | undefined;
    image?: string | undefined;
    verification?: string | undefined;
    scanned?: string | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    connectivities?: Connectivity[] | undefined;
    verifiedBy?: string | undefined;
    verifiedDate?: Date;
    deployDate?: Date;
    requestedDate?: Date;
    requestedDateInString?: string | undefined;
    createdDateInString?: string | undefined;
    deployDateInString?: string | undefined;
    deployedby?: string | undefined;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    isReceived?: string | undefined;
    isSale?: boolean;
    isSold?: boolean;
    previousSerial?: string | undefined;
    configStatus?: string | undefined;
    emailAddress?: string | undefined;
    chargerStatus?: string | undefined;
    rollsReceived?: string | undefined;
    cableReceived?: string | undefined;
    ticketNumber?: string | undefined;
    previousMerchantId?: string | undefined;
    previousTerminalId?: string | undefined;
    currentStatusValue?: RemovalStatusReason | undefined;
    currentStatus?: string | undefined;
    statusUpdatedDate?: Date | undefined;
    statusUpdatedOn?: string | undefined;
    requestedOn?: string | undefined;
    isSupportPresent?: boolean;
    panNumber?: string | undefined;
    rentalInventoryAdd?: string | undefined;

    constructor(data?: IPosHistoryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.inventoryId = _data["inventoryId"];
            this.bankId = _data["bankId"];
            this.bankName = _data["bankName"];
            this.bankCode = _data["bankCode"];
            this.merchant = _data["merchant"];
            this.idMerchant = _data["idMerchant"];
            this.outlet = _data["outlet"];
            this.district = _data["district"];
            this.address = _data["address"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo = _data["contactNo"];
            this.contactNo1 = _data["contactNo1"];
            this.contactNo2 = _data["contactNo2"];
            this.idTerminal = _data["idTerminal"];
            this.terminalType = _data["terminalType"];
            this.item = _data["item"];
            this.currency = _data["currency"];
            this.tipAdjustment = _data["tipAdjustment"];
            this.manualTransaction = _data["manualTransaction"];
            this.preAuthorization = _data["preAuthorization"];
            this.refund = _data["refund"];
            this.cashAdvance = _data["cashAdvance"];
            this.pinChange = _data["pinChange"];
            this.primaryTxnNumber = _data["primaryTxnNumber"];
            this.branchName = _data["branchName"];
            this.secondaryTxnNumber = _data["secondaryTxnNumber"];
            this.province = _data["province"];
            this.merchantCategory = _data["merchantCategory"];
            this.primaryNacNumber = _data["primaryNacNumber"];
            this.secondaryNacNumber = _data["secondaryNacNumber"];
            this.component1 = _data["component1"];
            this.component2 = _data["component2"];
            this.combineValue = _data["combineValue"];
            this.finalValue = _data["finalValue"];
            this.kvc1 = _data["kvc1"];
            this.kvc2 = _data["kvc2"];
            this.priority = _data["priority"];
            this.remarks = _data["remarks"];
            this.statusId = _data["statusId"];
            this.statusName = _data["statusName"];
            this.requestName = _data["requestName"];
            this.remarksDeploy = _data["remarksDeploy"];
            this.serialNumberId = _data["serialNumberId"];
            this.serialKey = _data["serialKey"];
            this.depDate = _data["depDate"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.deployedRequestedDate = _data["deployedRequestedDate"];
            this.applicationVersionId = _data["applicationVersionId"];
            this.applicationVersion = _data["applicationVersion"];
            this.applicationDate = _data["applicationDate"] ? new Date(_data["applicationDate"].toString()) : <any>undefined;
            this.applicationDateVersion = _data["applicationDateVersion"];
            this.applicationFormat = _data["applicationFormat"];
            this.contactOfPos = _data["contactOfPos"];
            this.limit = _data["limit"];
            this.receivedBy = _data["receivedBy"];
            this.receivedContactNo = _data["receivedContactNo"];
            this.connectivity = _data["connectivity"];
            this.merchantLocation = _data["merchantLocation"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.image = _data["image"];
            this.verification = _data["verification"];
            this.scanned = _data["scanned"];
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            if (Array.isArray(_data["connectivities"])) {
                this.connectivities = [] as any;
                for (let item of _data["connectivities"])
                    this.connectivities!.push(item);
            }
            this.verifiedBy = _data["verifiedBy"];
            this.verifiedDate = _data["verifiedDate"] ? new Date(_data["verifiedDate"].toString()) : <any>undefined;
            this.deployDate = _data["deployDate"] ? new Date(_data["deployDate"].toString()) : <any>undefined;
            this.requestedDate = _data["requestedDate"] ? new Date(_data["requestedDate"].toString()) : <any>undefined;
            this.requestedDateInString = _data["requestedDateInString"];
            this.createdDateInString = _data["createdDateInString"];
            this.deployDateInString = _data["deployDateInString"];
            this.deployedby = _data["deployedby"];
            this.primaryItem = _data["primaryItem"];
            this.secondaryItem = _data["secondaryItem"];
            this.tertiaryItem = _data["tertiaryItem"];
            this.detailItem = _data["detailItem"];
            this.isReceived = _data["isReceived"];
            this.isSale = _data["isSale"];
            this.isSold = _data["isSold"];
            this.previousSerial = _data["previousSerial"];
            this.configStatus = _data["configStatus"];
            this.emailAddress = _data["emailAddress"];
            this.chargerStatus = _data["chargerStatus"];
            this.rollsReceived = _data["rollsReceived"];
            this.cableReceived = _data["cableReceived"];
            this.ticketNumber = _data["ticketNumber"];
            this.previousMerchantId = _data["previousMerchantId"];
            this.previousTerminalId = _data["previousTerminalId"];
            this.currentStatusValue = _data["currentStatusValue"];
            this.currentStatus = _data["currentStatus"];
            this.statusUpdatedDate = _data["statusUpdatedDate"] ? new Date(_data["statusUpdatedDate"].toString()) : <any>undefined;
            this.statusUpdatedOn = _data["statusUpdatedOn"];
            this.requestedOn = _data["requestedOn"];
            this.isSupportPresent = _data["isSupportPresent"];
            this.panNumber = _data["panNumber"];
            this.rentalInventoryAdd = _data["rentalInventoryAdd"];
        }
    }

    static fromJS(data: any): PosHistoryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PosHistoryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["inventoryId"] = this.inventoryId;
        data["bankId"] = this.bankId;
        data["bankName"] = this.bankName;
        data["bankCode"] = this.bankCode;
        data["merchant"] = this.merchant;
        data["idMerchant"] = this.idMerchant;
        data["outlet"] = this.outlet;
        data["district"] = this.district;
        data["address"] = this.address;
        data["contactPerson"] = this.contactPerson;
        data["contactNo"] = this.contactNo;
        data["contactNo1"] = this.contactNo1;
        data["contactNo2"] = this.contactNo2;
        data["idTerminal"] = this.idTerminal;
        data["terminalType"] = this.terminalType;
        data["item"] = this.item;
        data["currency"] = this.currency;
        data["tipAdjustment"] = this.tipAdjustment;
        data["manualTransaction"] = this.manualTransaction;
        data["preAuthorization"] = this.preAuthorization;
        data["refund"] = this.refund;
        data["cashAdvance"] = this.cashAdvance;
        data["pinChange"] = this.pinChange;
        data["primaryTxnNumber"] = this.primaryTxnNumber;
        data["branchName"] = this.branchName;
        data["secondaryTxnNumber"] = this.secondaryTxnNumber;
        data["province"] = this.province;
        data["merchantCategory"] = this.merchantCategory;
        data["primaryNacNumber"] = this.primaryNacNumber;
        data["secondaryNacNumber"] = this.secondaryNacNumber;
        data["component1"] = this.component1;
        data["component2"] = this.component2;
        data["combineValue"] = this.combineValue;
        data["finalValue"] = this.finalValue;
        data["kvc1"] = this.kvc1;
        data["kvc2"] = this.kvc2;
        data["priority"] = this.priority;
        data["remarks"] = this.remarks;
        data["statusId"] = this.statusId;
        data["statusName"] = this.statusName;
        data["requestName"] = this.requestName;
        data["remarksDeploy"] = this.remarksDeploy;
        data["serialNumberId"] = this.serialNumberId;
        data["serialKey"] = this.serialKey;
        data["depDate"] = this.depDate;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["deployedRequestedDate"] = this.deployedRequestedDate;
        data["applicationVersionId"] = this.applicationVersionId;
        data["applicationVersion"] = this.applicationVersion;
        data["applicationDate"] = this.applicationDate ? this.applicationDate.toISOString() : <any>undefined;
        data["applicationDateVersion"] = this.applicationDateVersion;
        data["applicationFormat"] = this.applicationFormat;
        data["contactOfPos"] = this.contactOfPos;
        data["limit"] = this.limit;
        data["receivedBy"] = this.receivedBy;
        data["receivedContactNo"] = this.receivedContactNo;
        data["connectivity"] = this.connectivity;
        data["merchantLocation"] = this.merchantLocation;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["image"] = this.image;
        data["verification"] = this.verification;
        data["scanned"] = this.scanned;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        if (Array.isArray(this.connectivities)) {
            data["connectivities"] = [];
            for (let item of this.connectivities)
                data["connectivities"].push(item);
        }
        data["verifiedBy"] = this.verifiedBy;
        data["verifiedDate"] = this.verifiedDate ? this.verifiedDate.toISOString() : <any>undefined;
        data["deployDate"] = this.deployDate ? this.deployDate.toISOString() : <any>undefined;
        data["requestedDate"] = this.requestedDate ? this.requestedDate.toISOString() : <any>undefined;
        data["requestedDateInString"] = this.requestedDateInString;
        data["createdDateInString"] = this.createdDateInString;
        data["deployDateInString"] = this.deployDateInString;
        data["deployedby"] = this.deployedby;
        data["primaryItem"] = this.primaryItem;
        data["secondaryItem"] = this.secondaryItem;
        data["tertiaryItem"] = this.tertiaryItem;
        data["detailItem"] = this.detailItem;
        data["isReceived"] = this.isReceived;
        data["isSale"] = this.isSale;
        data["isSold"] = this.isSold;
        data["previousSerial"] = this.previousSerial;
        data["configStatus"] = this.configStatus;
        data["emailAddress"] = this.emailAddress;
        data["chargerStatus"] = this.chargerStatus;
        data["rollsReceived"] = this.rollsReceived;
        data["cableReceived"] = this.cableReceived;
        data["ticketNumber"] = this.ticketNumber;
        data["previousMerchantId"] = this.previousMerchantId;
        data["previousTerminalId"] = this.previousTerminalId;
        data["currentStatusValue"] = this.currentStatusValue;
        data["currentStatus"] = this.currentStatus;
        data["statusUpdatedDate"] = this.statusUpdatedDate ? this.statusUpdatedDate.toISOString() : <any>undefined;
        data["statusUpdatedOn"] = this.statusUpdatedOn;
        data["requestedOn"] = this.requestedOn;
        data["isSupportPresent"] = this.isSupportPresent;
        data["panNumber"] = this.panNumber;
        data["rentalInventoryAdd"] = this.rentalInventoryAdd;
        return data;
    }
}

export interface IPosHistoryViewModel {
    id?: string;
    deploymentRequestId?: string;
    inventoryId?: string;
    bankId?: string;
    bankName?: string | undefined;
    bankCode?: string | undefined;
    merchant?: string | undefined;
    idMerchant?: string | undefined;
    outlet?: string | undefined;
    district?: string | undefined;
    address?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    idTerminal?: string | undefined;
    terminalType?: string | undefined;
    item?: string | undefined;
    currency?: string | undefined;
    tipAdjustment?: boolean;
    manualTransaction?: boolean;
    preAuthorization?: boolean;
    refund?: boolean;
    cashAdvance?: boolean;
    pinChange?: boolean;
    primaryTxnNumber?: string | undefined;
    branchName?: string | undefined;
    secondaryTxnNumber?: string | undefined;
    province?: string | undefined;
    merchantCategory?: string | undefined;
    primaryNacNumber?: string | undefined;
    secondaryNacNumber?: string | undefined;
    component1?: string | undefined;
    component2?: string | undefined;
    combineValue?: string | undefined;
    finalValue?: string | undefined;
    kvc1?: string | undefined;
    kvc2?: string | undefined;
    priority?: boolean;
    remarks?: string | undefined;
    statusId?: string;
    statusName?: string | undefined;
    requestName?: string | undefined;
    remarksDeploy?: string | undefined;
    serialNumberId?: string;
    serialKey?: string | undefined;
    depDate?: string | undefined;
    createdDate?: Date;
    deployedRequestedDate?: string | undefined;
    applicationVersionId?: string;
    applicationVersion?: string | undefined;
    applicationDate?: Date | undefined;
    applicationDateVersion?: string | undefined;
    applicationFormat?: string | undefined;
    contactOfPos?: string | undefined;
    limit?: string | undefined;
    receivedBy?: string | undefined;
    receivedContactNo?: string | undefined;
    connectivity?: string | undefined;
    merchantLocation?: string | undefined;
    latitude?: string | undefined;
    longitude?: string | undefined;
    image?: string | undefined;
    verification?: string | undefined;
    scanned?: string | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    connectivities?: Connectivity[] | undefined;
    verifiedBy?: string | undefined;
    verifiedDate?: Date;
    deployDate?: Date;
    requestedDate?: Date;
    requestedDateInString?: string | undefined;
    createdDateInString?: string | undefined;
    deployDateInString?: string | undefined;
    deployedby?: string | undefined;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    isReceived?: string | undefined;
    isSale?: boolean;
    isSold?: boolean;
    previousSerial?: string | undefined;
    configStatus?: string | undefined;
    emailAddress?: string | undefined;
    chargerStatus?: string | undefined;
    rollsReceived?: string | undefined;
    cableReceived?: string | undefined;
    ticketNumber?: string | undefined;
    previousMerchantId?: string | undefined;
    previousTerminalId?: string | undefined;
    currentStatusValue?: RemovalStatusReason | undefined;
    currentStatus?: string | undefined;
    statusUpdatedDate?: Date | undefined;
    statusUpdatedOn?: string | undefined;
    requestedOn?: string | undefined;
    isSupportPresent?: boolean;
    panNumber?: string | undefined;
    rentalInventoryAdd?: string | undefined;
}

export class SupportViewModel implements ISupportViewModel {
    id?: string;
    deploymentRequestId?: string;
    phone?: boolean;
    field?: boolean;
    status?: boolean;
    priority?: boolean;
    issue?: string | undefined;
    contactPerson?: string | undefined;
    createdBy?: string | undefined;
    contactNo?: string | undefined;
    resolvedBy?: string | undefined;
    remarks?: string | undefined;
    resolvedRemarks?: string | undefined;
    closedRemarks?: string | undefined;
    verification?: string | undefined;
    verifiedBy?: string | undefined;
    verifiedDate?: Date;
    bankName?: string | undefined;
    merchant?: string | undefined;
    merchantLocation?: string | undefined;
    idMerchant?: string | undefined;
    outlet?: string | undefined;
    idTerminal?: string | undefined;
    address?: string | undefined;
    province?: string | undefined;
    merchantCategory?: string | undefined;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    serialKey?: string | undefined;
    item?: string | undefined;
    applicationVersionId?: string;
    bankId?: string | undefined;
    bankCode?: string | undefined;
    applicationVer?: string | undefined;
    applicationDate?: string | undefined;
    kernelType?: string | undefined;
    applicationFormat?: string | undefined;
    receivedBy?: string | undefined;
    receivedContactNo?: string | undefined;
    supportDate?: Date;
    supportstringDate?: string | undefined;
    supportDateString?: string | undefined;
    createdDate?: Date;
    supDate?: string | undefined;
    verDate?: string | undefined;
    district?: string | undefined;
    serialNumberId?: string;
    ticketNumber?: string | undefined;
    supportStatus?: SupportStatus;
    pendingSupport?: SupportPendingReason | undefined;
    accesoriesRequestCount?: number;
    statusName?: string | undefined;
    statusSupport?: boolean;
    pendingSupportDescription?: string | undefined;
    updatedDate?: Date;
    requestedDate?: string | undefined;
    description?: string | undefined;

    constructor(data?: ISupportViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.phone = _data["phone"];
            this.field = _data["field"];
            this.status = _data["status"];
            this.priority = _data["priority"];
            this.issue = _data["issue"];
            this.contactPerson = _data["contactPerson"];
            this.createdBy = _data["createdBy"];
            this.contactNo = _data["contactNo"];
            this.resolvedBy = _data["resolvedBy"];
            this.remarks = _data["remarks"];
            this.resolvedRemarks = _data["resolvedRemarks"];
            this.closedRemarks = _data["closedRemarks"];
            this.verification = _data["verification"];
            this.verifiedBy = _data["verifiedBy"];
            this.verifiedDate = _data["verifiedDate"] ? new Date(_data["verifiedDate"].toString()) : <any>undefined;
            this.bankName = _data["bankName"];
            this.merchant = _data["merchant"];
            this.merchantLocation = _data["merchantLocation"];
            this.idMerchant = _data["idMerchant"];
            this.outlet = _data["outlet"];
            this.idTerminal = _data["idTerminal"];
            this.address = _data["address"];
            this.province = _data["province"];
            this.merchantCategory = _data["merchantCategory"];
            this.primaryItem = _data["primaryItem"];
            this.secondaryItem = _data["secondaryItem"];
            this.tertiaryItem = _data["tertiaryItem"];
            this.detailItem = _data["detailItem"];
            this.serialKey = _data["serialKey"];
            this.item = _data["item"];
            this.applicationVersionId = _data["applicationVersionId"];
            this.bankId = _data["bankId"];
            this.bankCode = _data["bankCode"];
            this.applicationVer = _data["applicationVer"];
            this.applicationDate = _data["applicationDate"];
            this.kernelType = _data["kernelType"];
            this.applicationFormat = _data["applicationFormat"];
            this.receivedBy = _data["receivedBy"];
            this.receivedContactNo = _data["receivedContactNo"];
            this.supportDate = _data["supportDate"] ? new Date(_data["supportDate"].toString()) : <any>undefined;
            this.supportstringDate = _data["supportstringDate"];
            this.supportDateString = _data["supportDateString"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.supDate = _data["supDate"];
            this.verDate = _data["verDate"];
            this.district = _data["district"];
            this.serialNumberId = _data["serialNumberId"];
            this.ticketNumber = _data["ticketNumber"];
            this.supportStatus = _data["supportStatus"];
            this.pendingSupport = _data["pendingSupport"];
            this.accesoriesRequestCount = _data["accesoriesRequestCount"];
            this.statusName = _data["statusName"];
            this.statusSupport = _data["statusSupport"];
            this.pendingSupportDescription = _data["pendingSupportDescription"];
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.requestedDate = _data["requestedDate"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): SupportViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SupportViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["phone"] = this.phone;
        data["field"] = this.field;
        data["status"] = this.status;
        data["priority"] = this.priority;
        data["issue"] = this.issue;
        data["contactPerson"] = this.contactPerson;
        data["createdBy"] = this.createdBy;
        data["contactNo"] = this.contactNo;
        data["resolvedBy"] = this.resolvedBy;
        data["remarks"] = this.remarks;
        data["resolvedRemarks"] = this.resolvedRemarks;
        data["closedRemarks"] = this.closedRemarks;
        data["verification"] = this.verification;
        data["verifiedBy"] = this.verifiedBy;
        data["verifiedDate"] = this.verifiedDate ? this.verifiedDate.toISOString() : <any>undefined;
        data["bankName"] = this.bankName;
        data["merchant"] = this.merchant;
        data["merchantLocation"] = this.merchantLocation;
        data["idMerchant"] = this.idMerchant;
        data["outlet"] = this.outlet;
        data["idTerminal"] = this.idTerminal;
        data["address"] = this.address;
        data["province"] = this.province;
        data["merchantCategory"] = this.merchantCategory;
        data["primaryItem"] = this.primaryItem;
        data["secondaryItem"] = this.secondaryItem;
        data["tertiaryItem"] = this.tertiaryItem;
        data["detailItem"] = this.detailItem;
        data["serialKey"] = this.serialKey;
        data["item"] = this.item;
        data["applicationVersionId"] = this.applicationVersionId;
        data["bankId"] = this.bankId;
        data["bankCode"] = this.bankCode;
        data["applicationVer"] = this.applicationVer;
        data["applicationDate"] = this.applicationDate;
        data["kernelType"] = this.kernelType;
        data["applicationFormat"] = this.applicationFormat;
        data["receivedBy"] = this.receivedBy;
        data["receivedContactNo"] = this.receivedContactNo;
        data["supportDate"] = this.supportDate ? this.supportDate.toISOString() : <any>undefined;
        data["supportstringDate"] = this.supportstringDate;
        data["supportDateString"] = this.supportDateString;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["supDate"] = this.supDate;
        data["verDate"] = this.verDate;
        data["district"] = this.district;
        data["serialNumberId"] = this.serialNumberId;
        data["ticketNumber"] = this.ticketNumber;
        data["supportStatus"] = this.supportStatus;
        data["pendingSupport"] = this.pendingSupport;
        data["accesoriesRequestCount"] = this.accesoriesRequestCount;
        data["statusName"] = this.statusName;
        data["statusSupport"] = this.statusSupport;
        data["pendingSupportDescription"] = this.pendingSupportDescription;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["requestedDate"] = this.requestedDate;
        data["description"] = this.description;
        return data;
    }
}

export interface ISupportViewModel {
    id?: string;
    deploymentRequestId?: string;
    phone?: boolean;
    field?: boolean;
    status?: boolean;
    priority?: boolean;
    issue?: string | undefined;
    contactPerson?: string | undefined;
    createdBy?: string | undefined;
    contactNo?: string | undefined;
    resolvedBy?: string | undefined;
    remarks?: string | undefined;
    resolvedRemarks?: string | undefined;
    closedRemarks?: string | undefined;
    verification?: string | undefined;
    verifiedBy?: string | undefined;
    verifiedDate?: Date;
    bankName?: string | undefined;
    merchant?: string | undefined;
    merchantLocation?: string | undefined;
    idMerchant?: string | undefined;
    outlet?: string | undefined;
    idTerminal?: string | undefined;
    address?: string | undefined;
    province?: string | undefined;
    merchantCategory?: string | undefined;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    serialKey?: string | undefined;
    item?: string | undefined;
    applicationVersionId?: string;
    bankId?: string | undefined;
    bankCode?: string | undefined;
    applicationVer?: string | undefined;
    applicationDate?: string | undefined;
    kernelType?: string | undefined;
    applicationFormat?: string | undefined;
    receivedBy?: string | undefined;
    receivedContactNo?: string | undefined;
    supportDate?: Date;
    supportstringDate?: string | undefined;
    supportDateString?: string | undefined;
    createdDate?: Date;
    supDate?: string | undefined;
    verDate?: string | undefined;
    district?: string | undefined;
    serialNumberId?: string;
    ticketNumber?: string | undefined;
    supportStatus?: SupportStatus;
    pendingSupport?: SupportPendingReason | undefined;
    accesoriesRequestCount?: number;
    statusName?: string | undefined;
    statusSupport?: boolean;
    pendingSupportDescription?: string | undefined;
    updatedDate?: Date;
    requestedDate?: string | undefined;
    description?: string | undefined;
}

export class RemovalRequestDetails implements IRemovalRequestDetails {
    id?: string;
    deploymentRequestId?: string;
    inventoryId?: string;
    bankId?: string;
    bankName?: string | undefined;
    bankCode?: string | undefined;
    merchant?: string | undefined;
    idMerchant?: string | undefined;
    outlet?: string | undefined;
    district?: string | undefined;
    address?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    idTerminal?: string | undefined;
    terminalType?: string | undefined;
    item?: string | undefined;
    currency?: string | undefined;
    tipAdjustment?: boolean;
    manualTransaction?: boolean;
    preAuthorization?: boolean;
    refund?: boolean;
    primaryTxnNumber?: string | undefined;
    branchName?: string | undefined;
    secondaryTxnNumber?: string | undefined;
    province?: string | undefined;
    merchantCategory?: string | undefined;
    primaryNacNumber?: string | undefined;
    secondaryNacNumber?: string | undefined;
    component1?: string | undefined;
    component2?: string | undefined;
    combineValue?: string | undefined;
    finalValue?: string | undefined;
    kvc1?: string | undefined;
    kvc2?: string | undefined;
    priority?: boolean;
    remarks?: string | undefined;
    currentStatus?: string | undefined;
    statusId?: string;
    statusName?: string | undefined;
    requestName?: string | undefined;
    remarksDeploy?: string | undefined;
    serialNumberId?: string;
    serialKey?: string | undefined;
    depDate?: string | undefined;
    createdDate?: Date;
    applicationVersionId?: string;
    applicationVersion?: string | undefined;
    applicationDate?: Date | undefined;
    applicationDateVersion?: string | undefined;
    applicationFormat?: string | undefined;
    contactOfPos?: string | undefined;
    limit?: string | undefined;
    receivedBy?: string | undefined;
    receivedContactNo?: string | undefined;
    connectivity?: string | undefined;
    merchantLocation?: string | undefined;
    latitude?: string | undefined;
    longitude?: string | undefined;
    image?: string | undefined;
    verification?: string | undefined;
    scanned?: string | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    connectivities?: Connectivity[] | undefined;
    verifiedBy?: string | undefined;
    verifiedDate?: Date;
    deployDate?: Date;
    requestedDate?: Date;
    requestedDateInString?: string | undefined;
    createdDateInString?: string | undefined;
    deployDateInString?: string | undefined;
    deployedby?: string | undefined;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    isReceived?: string | undefined;
    isSale?: boolean;
    isSold?: boolean;
    previousSerial?: string | undefined;
    configStatus?: string | undefined;
    emailAddress?: string | undefined;
    chargerStatus?: string | undefined;
    rollsReceived?: string | undefined;
    cableReceived?: string | undefined;
    ticketNumber?: string | undefined;
    previousMerchantId?: string | undefined;
    previousTerminalId?: string | undefined;
    currentStatusValue?: string | undefined;
    pendingRemovalReason?: RemovalStatusReason | undefined;
    statusUpdatedDate?: Date | undefined;
    statusUpdatedOn?: string | undefined;
    requestedOn?: string | undefined;
    isSupportPresent?: boolean;

    constructor(data?: IRemovalRequestDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.inventoryId = _data["inventoryId"];
            this.bankId = _data["bankId"];
            this.bankName = _data["bankName"];
            this.bankCode = _data["bankCode"];
            this.merchant = _data["merchant"];
            this.idMerchant = _data["idMerchant"];
            this.outlet = _data["outlet"];
            this.district = _data["district"];
            this.address = _data["address"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo = _data["contactNo"];
            this.contactNo1 = _data["contactNo1"];
            this.contactNo2 = _data["contactNo2"];
            this.idTerminal = _data["idTerminal"];
            this.terminalType = _data["terminalType"];
            this.item = _data["item"];
            this.currency = _data["currency"];
            this.tipAdjustment = _data["tipAdjustment"];
            this.manualTransaction = _data["manualTransaction"];
            this.preAuthorization = _data["preAuthorization"];
            this.refund = _data["refund"];
            this.primaryTxnNumber = _data["primaryTxnNumber"];
            this.branchName = _data["branchName"];
            this.secondaryTxnNumber = _data["secondaryTxnNumber"];
            this.province = _data["province"];
            this.merchantCategory = _data["merchantCategory"];
            this.primaryNacNumber = _data["primaryNacNumber"];
            this.secondaryNacNumber = _data["secondaryNacNumber"];
            this.component1 = _data["component1"];
            this.component2 = _data["component2"];
            this.combineValue = _data["combineValue"];
            this.finalValue = _data["finalValue"];
            this.kvc1 = _data["kvc1"];
            this.kvc2 = _data["kvc2"];
            this.priority = _data["priority"];
            this.remarks = _data["remarks"];
            this.currentStatus = _data["currentStatus"];
            this.statusId = _data["statusId"];
            this.statusName = _data["statusName"];
            this.requestName = _data["requestName"];
            this.remarksDeploy = _data["remarksDeploy"];
            this.serialNumberId = _data["serialNumberId"];
            this.serialKey = _data["serialKey"];
            this.depDate = _data["depDate"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.applicationVersionId = _data["applicationVersionId"];
            this.applicationVersion = _data["applicationVersion"];
            this.applicationDate = _data["applicationDate"] ? new Date(_data["applicationDate"].toString()) : <any>undefined;
            this.applicationDateVersion = _data["applicationDateVersion"];
            this.applicationFormat = _data["applicationFormat"];
            this.contactOfPos = _data["contactOfPos"];
            this.limit = _data["limit"];
            this.receivedBy = _data["receivedBy"];
            this.receivedContactNo = _data["receivedContactNo"];
            this.connectivity = _data["connectivity"];
            this.merchantLocation = _data["merchantLocation"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.image = _data["image"];
            this.verification = _data["verification"];
            this.scanned = _data["scanned"];
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            if (Array.isArray(_data["connectivities"])) {
                this.connectivities = [] as any;
                for (let item of _data["connectivities"])
                    this.connectivities!.push(item);
            }
            this.verifiedBy = _data["verifiedBy"];
            this.verifiedDate = _data["verifiedDate"] ? new Date(_data["verifiedDate"].toString()) : <any>undefined;
            this.deployDate = _data["deployDate"] ? new Date(_data["deployDate"].toString()) : <any>undefined;
            this.requestedDate = _data["requestedDate"] ? new Date(_data["requestedDate"].toString()) : <any>undefined;
            this.requestedDateInString = _data["requestedDateInString"];
            this.createdDateInString = _data["createdDateInString"];
            this.deployDateInString = _data["deployDateInString"];
            this.deployedby = _data["deployedby"];
            this.primaryItem = _data["primaryItem"];
            this.secondaryItem = _data["secondaryItem"];
            this.tertiaryItem = _data["tertiaryItem"];
            this.detailItem = _data["detailItem"];
            this.isReceived = _data["isReceived"];
            this.isSale = _data["isSale"];
            this.isSold = _data["isSold"];
            this.previousSerial = _data["previousSerial"];
            this.configStatus = _data["configStatus"];
            this.emailAddress = _data["emailAddress"];
            this.chargerStatus = _data["chargerStatus"];
            this.rollsReceived = _data["rollsReceived"];
            this.cableReceived = _data["cableReceived"];
            this.ticketNumber = _data["ticketNumber"];
            this.previousMerchantId = _data["previousMerchantId"];
            this.previousTerminalId = _data["previousTerminalId"];
            this.currentStatusValue = _data["currentStatusValue"];
            this.pendingRemovalReason = _data["pendingRemovalReason"];
            this.statusUpdatedDate = _data["statusUpdatedDate"] ? new Date(_data["statusUpdatedDate"].toString()) : <any>undefined;
            this.statusUpdatedOn = _data["statusUpdatedOn"];
            this.requestedOn = _data["requestedOn"];
            this.isSupportPresent = _data["isSupportPresent"];
        }
    }

    static fromJS(data: any): RemovalRequestDetails {
        data = typeof data === 'object' ? data : {};
        let result = new RemovalRequestDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["inventoryId"] = this.inventoryId;
        data["bankId"] = this.bankId;
        data["bankName"] = this.bankName;
        data["bankCode"] = this.bankCode;
        data["merchant"] = this.merchant;
        data["idMerchant"] = this.idMerchant;
        data["outlet"] = this.outlet;
        data["district"] = this.district;
        data["address"] = this.address;
        data["contactPerson"] = this.contactPerson;
        data["contactNo"] = this.contactNo;
        data["contactNo1"] = this.contactNo1;
        data["contactNo2"] = this.contactNo2;
        data["idTerminal"] = this.idTerminal;
        data["terminalType"] = this.terminalType;
        data["item"] = this.item;
        data["currency"] = this.currency;
        data["tipAdjustment"] = this.tipAdjustment;
        data["manualTransaction"] = this.manualTransaction;
        data["preAuthorization"] = this.preAuthorization;
        data["refund"] = this.refund;
        data["primaryTxnNumber"] = this.primaryTxnNumber;
        data["branchName"] = this.branchName;
        data["secondaryTxnNumber"] = this.secondaryTxnNumber;
        data["province"] = this.province;
        data["merchantCategory"] = this.merchantCategory;
        data["primaryNacNumber"] = this.primaryNacNumber;
        data["secondaryNacNumber"] = this.secondaryNacNumber;
        data["component1"] = this.component1;
        data["component2"] = this.component2;
        data["combineValue"] = this.combineValue;
        data["finalValue"] = this.finalValue;
        data["kvc1"] = this.kvc1;
        data["kvc2"] = this.kvc2;
        data["priority"] = this.priority;
        data["remarks"] = this.remarks;
        data["currentStatus"] = this.currentStatus;
        data["statusId"] = this.statusId;
        data["statusName"] = this.statusName;
        data["requestName"] = this.requestName;
        data["remarksDeploy"] = this.remarksDeploy;
        data["serialNumberId"] = this.serialNumberId;
        data["serialKey"] = this.serialKey;
        data["depDate"] = this.depDate;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["applicationVersionId"] = this.applicationVersionId;
        data["applicationVersion"] = this.applicationVersion;
        data["applicationDate"] = this.applicationDate ? this.applicationDate.toISOString() : <any>undefined;
        data["applicationDateVersion"] = this.applicationDateVersion;
        data["applicationFormat"] = this.applicationFormat;
        data["contactOfPos"] = this.contactOfPos;
        data["limit"] = this.limit;
        data["receivedBy"] = this.receivedBy;
        data["receivedContactNo"] = this.receivedContactNo;
        data["connectivity"] = this.connectivity;
        data["merchantLocation"] = this.merchantLocation;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["image"] = this.image;
        data["verification"] = this.verification;
        data["scanned"] = this.scanned;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        if (Array.isArray(this.connectivities)) {
            data["connectivities"] = [];
            for (let item of this.connectivities)
                data["connectivities"].push(item);
        }
        data["verifiedBy"] = this.verifiedBy;
        data["verifiedDate"] = this.verifiedDate ? this.verifiedDate.toISOString() : <any>undefined;
        data["deployDate"] = this.deployDate ? this.deployDate.toISOString() : <any>undefined;
        data["requestedDate"] = this.requestedDate ? this.requestedDate.toISOString() : <any>undefined;
        data["requestedDateInString"] = this.requestedDateInString;
        data["createdDateInString"] = this.createdDateInString;
        data["deployDateInString"] = this.deployDateInString;
        data["deployedby"] = this.deployedby;
        data["primaryItem"] = this.primaryItem;
        data["secondaryItem"] = this.secondaryItem;
        data["tertiaryItem"] = this.tertiaryItem;
        data["detailItem"] = this.detailItem;
        data["isReceived"] = this.isReceived;
        data["isSale"] = this.isSale;
        data["isSold"] = this.isSold;
        data["previousSerial"] = this.previousSerial;
        data["configStatus"] = this.configStatus;
        data["emailAddress"] = this.emailAddress;
        data["chargerStatus"] = this.chargerStatus;
        data["rollsReceived"] = this.rollsReceived;
        data["cableReceived"] = this.cableReceived;
        data["ticketNumber"] = this.ticketNumber;
        data["previousMerchantId"] = this.previousMerchantId;
        data["previousTerminalId"] = this.previousTerminalId;
        data["currentStatusValue"] = this.currentStatusValue;
        data["pendingRemovalReason"] = this.pendingRemovalReason;
        data["statusUpdatedDate"] = this.statusUpdatedDate ? this.statusUpdatedDate.toISOString() : <any>undefined;
        data["statusUpdatedOn"] = this.statusUpdatedOn;
        data["requestedOn"] = this.requestedOn;
        data["isSupportPresent"] = this.isSupportPresent;
        return data;
    }
}

export interface IRemovalRequestDetails {
    id?: string;
    deploymentRequestId?: string;
    inventoryId?: string;
    bankId?: string;
    bankName?: string | undefined;
    bankCode?: string | undefined;
    merchant?: string | undefined;
    idMerchant?: string | undefined;
    outlet?: string | undefined;
    district?: string | undefined;
    address?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    idTerminal?: string | undefined;
    terminalType?: string | undefined;
    item?: string | undefined;
    currency?: string | undefined;
    tipAdjustment?: boolean;
    manualTransaction?: boolean;
    preAuthorization?: boolean;
    refund?: boolean;
    primaryTxnNumber?: string | undefined;
    branchName?: string | undefined;
    secondaryTxnNumber?: string | undefined;
    province?: string | undefined;
    merchantCategory?: string | undefined;
    primaryNacNumber?: string | undefined;
    secondaryNacNumber?: string | undefined;
    component1?: string | undefined;
    component2?: string | undefined;
    combineValue?: string | undefined;
    finalValue?: string | undefined;
    kvc1?: string | undefined;
    kvc2?: string | undefined;
    priority?: boolean;
    remarks?: string | undefined;
    currentStatus?: string | undefined;
    statusId?: string;
    statusName?: string | undefined;
    requestName?: string | undefined;
    remarksDeploy?: string | undefined;
    serialNumberId?: string;
    serialKey?: string | undefined;
    depDate?: string | undefined;
    createdDate?: Date;
    applicationVersionId?: string;
    applicationVersion?: string | undefined;
    applicationDate?: Date | undefined;
    applicationDateVersion?: string | undefined;
    applicationFormat?: string | undefined;
    contactOfPos?: string | undefined;
    limit?: string | undefined;
    receivedBy?: string | undefined;
    receivedContactNo?: string | undefined;
    connectivity?: string | undefined;
    merchantLocation?: string | undefined;
    latitude?: string | undefined;
    longitude?: string | undefined;
    image?: string | undefined;
    verification?: string | undefined;
    scanned?: string | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    connectivities?: Connectivity[] | undefined;
    verifiedBy?: string | undefined;
    verifiedDate?: Date;
    deployDate?: Date;
    requestedDate?: Date;
    requestedDateInString?: string | undefined;
    createdDateInString?: string | undefined;
    deployDateInString?: string | undefined;
    deployedby?: string | undefined;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    isReceived?: string | undefined;
    isSale?: boolean;
    isSold?: boolean;
    previousSerial?: string | undefined;
    configStatus?: string | undefined;
    emailAddress?: string | undefined;
    chargerStatus?: string | undefined;
    rollsReceived?: string | undefined;
    cableReceived?: string | undefined;
    ticketNumber?: string | undefined;
    previousMerchantId?: string | undefined;
    previousTerminalId?: string | undefined;
    currentStatusValue?: string | undefined;
    pendingRemovalReason?: RemovalStatusReason | undefined;
    statusUpdatedDate?: Date | undefined;
    statusUpdatedOn?: string | undefined;
    requestedOn?: string | undefined;
    isSupportPresent?: boolean;
}

export class SpareRequestFromBankCommand implements ISpareRequestFromBankCommand {
    accessoryId?: string;
    location?: string | undefined;
    requested_Quantity?: number;

    constructor(data?: ISpareRequestFromBankCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessoryId = _data["accessoryId"];
            this.location = _data["location"];
            this.requested_Quantity = _data["requested_Quantity"];
        }
    }

    static fromJS(data: any): SpareRequestFromBankCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SpareRequestFromBankCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessoryId"] = this.accessoryId;
        data["location"] = this.location;
        data["requested_Quantity"] = this.requested_Quantity;
        return data;
    }
}

export interface ISpareRequestFromBankCommand {
    accessoryId?: string;
    location?: string | undefined;
    requested_Quantity?: number;
}

export class MerchantAccessoriesRequestViewModel implements IMerchantAccessoriesRequestViewModel {
    deploymentRequestId?: string | undefined;
    contactNumber?: string | undefined;
    contactPerson?: string | undefined;
    accessioresList?: Accessories[] | undefined;

    constructor(data?: IMerchantAccessoriesRequestViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.contactNumber = _data["contactNumber"];
            this.contactPerson = _data["contactPerson"];
            if (Array.isArray(_data["accessioresList"])) {
                this.accessioresList = [] as any;
                for (let item of _data["accessioresList"])
                    this.accessioresList!.push(Accessories.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MerchantAccessoriesRequestViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantAccessoriesRequestViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["contactNumber"] = this.contactNumber;
        data["contactPerson"] = this.contactPerson;
        if (Array.isArray(this.accessioresList)) {
            data["accessioresList"] = [];
            for (let item of this.accessioresList)
                data["accessioresList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMerchantAccessoriesRequestViewModel {
    deploymentRequestId?: string | undefined;
    contactNumber?: string | undefined;
    contactPerson?: string | undefined;
    accessioresList?: Accessories[] | undefined;
}

export class Accessories implements IAccessories {
    accessoryId?: string | undefined;
    quantity?: number;
    remarks?: string | undefined;

    constructor(data?: IAccessories) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessoryId = _data["accessoryId"];
            this.quantity = _data["quantity"];
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): Accessories {
        data = typeof data === 'object' ? data : {};
        let result = new Accessories();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessoryId"] = this.accessoryId;
        data["quantity"] = this.quantity;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface IAccessories {
    accessoryId?: string | undefined;
    quantity?: number;
    remarks?: string | undefined;
}

export class MerchantAccessoriesAndSupportRequestVm implements IMerchantAccessoriesAndSupportRequestVm {
    deploymentRequestId?: string | undefined;
    supports?: MerchantSupport | undefined;
    accessioresList?: Accessories[] | undefined;

    constructor(data?: IMerchantAccessoriesAndSupportRequestVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.supports = _data["supports"] ? MerchantSupport.fromJS(_data["supports"]) : <any>undefined;
            if (Array.isArray(_data["accessioresList"])) {
                this.accessioresList = [] as any;
                for (let item of _data["accessioresList"])
                    this.accessioresList!.push(Accessories.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MerchantAccessoriesAndSupportRequestVm {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantAccessoriesAndSupportRequestVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["supports"] = this.supports ? this.supports.toJSON() : <any>undefined;
        if (Array.isArray(this.accessioresList)) {
            data["accessioresList"] = [];
            for (let item of this.accessioresList)
                data["accessioresList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMerchantAccessoriesAndSupportRequestVm {
    deploymentRequestId?: string | undefined;
    supports?: MerchantSupport | undefined;
    accessioresList?: Accessories[] | undefined;
}

export class MerchantSupport implements IMerchantSupport {
    isFieldSupport?: boolean;
    priority?: boolean;
    issue?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    remarks?: string | undefined;

    constructor(data?: IMerchantSupport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isFieldSupport = _data["isFieldSupport"];
            this.priority = _data["priority"];
            this.issue = _data["issue"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo = _data["contactNo"];
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): MerchantSupport {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantSupport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFieldSupport"] = this.isFieldSupport;
        data["priority"] = this.priority;
        data["issue"] = this.issue;
        data["contactPerson"] = this.contactPerson;
        data["contactNo"] = this.contactNo;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface IMerchantSupport {
    isFieldSupport?: boolean;
    priority?: boolean;
    issue?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    remarks?: string | undefined;
}

export class SparesRequestViewModel implements ISparesRequestViewModel {
    id?: string;
    accessoryType?: string | undefined;
    accessoryId?: string;
    merchantId?: string | undefined;
    deploymentRequestId?: string;
    requested_Quantity?: number;
    dispatch_Quantity?: number;
    status?: boolean;
    requested_Date?: Date;
    dispatch_Date?: Date;
    spareRequestStatus?: string | undefined;
    location?: string | undefined;
    verification?: string | undefined;
    cancelRemarks?: string | undefined;

    constructor(data?: ISparesRequestViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accessoryType = _data["accessoryType"];
            this.accessoryId = _data["accessoryId"];
            this.merchantId = _data["merchantId"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.requested_Quantity = _data["requested_Quantity"];
            this.dispatch_Quantity = _data["dispatch_Quantity"];
            this.status = _data["status"];
            this.requested_Date = _data["requested_Date"] ? new Date(_data["requested_Date"].toString()) : <any>undefined;
            this.dispatch_Date = _data["dispatch_Date"] ? new Date(_data["dispatch_Date"].toString()) : <any>undefined;
            this.spareRequestStatus = _data["spareRequestStatus"];
            this.location = _data["location"];
            this.verification = _data["verification"];
            this.cancelRemarks = _data["cancelRemarks"];
        }
    }

    static fromJS(data: any): SparesRequestViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SparesRequestViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accessoryType"] = this.accessoryType;
        data["accessoryId"] = this.accessoryId;
        data["merchantId"] = this.merchantId;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["requested_Quantity"] = this.requested_Quantity;
        data["dispatch_Quantity"] = this.dispatch_Quantity;
        data["status"] = this.status;
        data["requested_Date"] = this.requested_Date ? this.requested_Date.toISOString() : <any>undefined;
        data["dispatch_Date"] = this.dispatch_Date ? this.dispatch_Date.toISOString() : <any>undefined;
        data["spareRequestStatus"] = this.spareRequestStatus;
        data["location"] = this.location;
        data["verification"] = this.verification;
        data["cancelRemarks"] = this.cancelRemarks;
        return data;
    }
}

export interface ISparesRequestViewModel {
    id?: string;
    accessoryType?: string | undefined;
    accessoryId?: string;
    merchantId?: string | undefined;
    deploymentRequestId?: string;
    requested_Quantity?: number;
    dispatch_Quantity?: number;
    status?: boolean;
    requested_Date?: Date;
    dispatch_Date?: Date;
    spareRequestStatus?: string | undefined;
    location?: string | undefined;
    verification?: string | undefined;
    cancelRemarks?: string | undefined;
}

export class AccessoryViewModel implements IAccessoryViewModel {
    item?: string | undefined;
    accessoryId?: string;

    constructor(data?: IAccessoryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item = _data["item"];
            this.accessoryId = _data["accessoryId"];
        }
    }

    static fromJS(data: any): AccessoryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccessoryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item"] = this.item;
        data["accessoryId"] = this.accessoryId;
        return data;
    }
}

export interface IAccessoryViewModel {
    item?: string | undefined;
    accessoryId?: string;
}

export class MerchantCategoryViewModel implements IMerchantCategoryViewModel {
    id?: string;
    merchantCategoryName?: string | undefined;
    mcc?: string | undefined;
    description?: string | undefined;

    constructor(data?: IMerchantCategoryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.merchantCategoryName = _data["merchantCategoryName"];
            this.mcc = _data["mcc"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): MerchantCategoryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantCategoryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["merchantCategoryName"] = this.merchantCategoryName;
        data["mcc"] = this.mcc;
        data["description"] = this.description;
        return data;
    }
}

export interface IMerchantCategoryViewModel {
    id?: string;
    merchantCategoryName?: string | undefined;
    mcc?: string | undefined;
    description?: string | undefined;
}

export class CategoryWithBankViewModel implements ICategoryWithBankViewModel {
    merchantCategoryId?: string;
    merchantCategoryName?: string | undefined;
    merchantCount?: number;
    bankId?: string;

    constructor(data?: ICategoryWithBankViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.merchantCategoryId = _data["merchantCategoryId"];
            this.merchantCategoryName = _data["merchantCategoryName"];
            this.merchantCount = _data["merchantCount"];
            this.bankId = _data["bankId"];
        }
    }

    static fromJS(data: any): CategoryWithBankViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryWithBankViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["merchantCategoryId"] = this.merchantCategoryId;
        data["merchantCategoryName"] = this.merchantCategoryName;
        data["merchantCount"] = this.merchantCount;
        data["bankId"] = this.bankId;
        return data;
    }
}

export interface ICategoryWithBankViewModel {
    merchantCategoryId?: string;
    merchantCategoryName?: string | undefined;
    merchantCount?: number;
    bankId?: string;
}

export class BankPortalDashboardViewModel implements IBankPortalDashboardViewModel {
    bankName?: string | undefined;
    maintenanceNumber?: number;
    deployDate?: Date;
    totalDeploy?: number;
    previousMonth?: number;
    currentMonth?: number;
    pendingDeployment?: number;
    pendingRemoval?: number;
    gem?: number;
    em?: number;
    iwl?: number;
    mem?: number;
    mgemtwog?: number;
    mgemthreeg?: number;
    miwltwog?: number;
    miwlthreeg?: number;
    miwlthreegwifi?: number;
    merchantCategoryName?: string | undefined;
    merchantCategoryCount?: number;
    districtName?: string | undefined;
    districtCount?: number;
    provinceName?: string | undefined;
    provinceCount?: number;
    monthName?: string | undefined;
    monthlyDeployCount?: number;
    supportCount?: number;
    pendingSupport?: number;

    constructor(data?: IBankPortalDashboardViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankName = _data["bankName"];
            this.maintenanceNumber = _data["maintenanceNumber"];
            this.deployDate = _data["deployDate"] ? new Date(_data["deployDate"].toString()) : <any>undefined;
            this.totalDeploy = _data["totalDeploy"];
            this.previousMonth = _data["previousMonth"];
            this.currentMonth = _data["currentMonth"];
            this.pendingDeployment = _data["pendingDeployment"];
            this.pendingRemoval = _data["pendingRemoval"];
            this.gem = _data["gem"];
            this.em = _data["em"];
            this.iwl = _data["iwl"];
            this.mem = _data["mem"];
            this.mgemtwog = _data["mgemtwog"];
            this.mgemthreeg = _data["mgemthreeg"];
            this.miwltwog = _data["miwltwog"];
            this.miwlthreeg = _data["miwlthreeg"];
            this.miwlthreegwifi = _data["miwlthreegwifi"];
            this.merchantCategoryName = _data["merchantCategoryName"];
            this.merchantCategoryCount = _data["merchantCategoryCount"];
            this.districtName = _data["districtName"];
            this.districtCount = _data["districtCount"];
            this.provinceName = _data["provinceName"];
            this.provinceCount = _data["provinceCount"];
            this.monthName = _data["monthName"];
            this.monthlyDeployCount = _data["monthlyDeployCount"];
            this.supportCount = _data["supportCount"];
            this.pendingSupport = _data["pendingSupport"];
        }
    }

    static fromJS(data: any): BankPortalDashboardViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BankPortalDashboardViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankName"] = this.bankName;
        data["maintenanceNumber"] = this.maintenanceNumber;
        data["deployDate"] = this.deployDate ? this.deployDate.toISOString() : <any>undefined;
        data["totalDeploy"] = this.totalDeploy;
        data["previousMonth"] = this.previousMonth;
        data["currentMonth"] = this.currentMonth;
        data["pendingDeployment"] = this.pendingDeployment;
        data["pendingRemoval"] = this.pendingRemoval;
        data["gem"] = this.gem;
        data["em"] = this.em;
        data["iwl"] = this.iwl;
        data["mem"] = this.mem;
        data["mgemtwog"] = this.mgemtwog;
        data["mgemthreeg"] = this.mgemthreeg;
        data["miwltwog"] = this.miwltwog;
        data["miwlthreeg"] = this.miwlthreeg;
        data["miwlthreegwifi"] = this.miwlthreegwifi;
        data["merchantCategoryName"] = this.merchantCategoryName;
        data["merchantCategoryCount"] = this.merchantCategoryCount;
        data["districtName"] = this.districtName;
        data["districtCount"] = this.districtCount;
        data["provinceName"] = this.provinceName;
        data["provinceCount"] = this.provinceCount;
        data["monthName"] = this.monthName;
        data["monthlyDeployCount"] = this.monthlyDeployCount;
        data["supportCount"] = this.supportCount;
        data["pendingSupport"] = this.pendingSupport;
        return data;
    }
}

export interface IBankPortalDashboardViewModel {
    bankName?: string | undefined;
    maintenanceNumber?: number;
    deployDate?: Date;
    totalDeploy?: number;
    previousMonth?: number;
    currentMonth?: number;
    pendingDeployment?: number;
    pendingRemoval?: number;
    gem?: number;
    em?: number;
    iwl?: number;
    mem?: number;
    mgemtwog?: number;
    mgemthreeg?: number;
    miwltwog?: number;
    miwlthreeg?: number;
    miwlthreegwifi?: number;
    merchantCategoryName?: string | undefined;
    merchantCategoryCount?: number;
    districtName?: string | undefined;
    districtCount?: number;
    provinceName?: string | undefined;
    provinceCount?: number;
    monthName?: string | undefined;
    monthlyDeployCount?: number;
    supportCount?: number;
    pendingSupport?: number;
}

export class ReplacementRequestCommand implements IReplacementRequestCommand {
    remarksDeploy?: string | undefined;
    component1?: string | undefined;
    component2?: string | undefined;
    combineValue?: string | undefined;
    finalValue?: string | undefined;
    kvc1?: string | undefined;
    kvc2?: string | undefined;
    panNumber?: string | undefined;
    terminalType?: string | undefined;
    replacementReason?: ReplacementReason;

    constructor(data?: IReplacementRequestCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.remarksDeploy = _data["remarksDeploy"];
            this.component1 = _data["component1"];
            this.component2 = _data["component2"];
            this.combineValue = _data["combineValue"];
            this.finalValue = _data["finalValue"];
            this.kvc1 = _data["kvc1"];
            this.kvc2 = _data["kvc2"];
            this.panNumber = _data["panNumber"];
            this.terminalType = _data["terminalType"];
            this.replacementReason = _data["replacementReason"];
        }
    }

    static fromJS(data: any): ReplacementRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReplacementRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["remarksDeploy"] = this.remarksDeploy;
        data["component1"] = this.component1;
        data["component2"] = this.component2;
        data["combineValue"] = this.combineValue;
        data["finalValue"] = this.finalValue;
        data["kvc1"] = this.kvc1;
        data["kvc2"] = this.kvc2;
        data["panNumber"] = this.panNumber;
        data["terminalType"] = this.terminalType;
        data["replacementReason"] = this.replacementReason;
        return data;
    }
}

export interface IReplacementRequestCommand {
    remarksDeploy?: string | undefined;
    component1?: string | undefined;
    component2?: string | undefined;
    combineValue?: string | undefined;
    finalValue?: string | undefined;
    kvc1?: string | undefined;
    kvc2?: string | undefined;
    panNumber?: string | undefined;
    terminalType?: string | undefined;
    replacementReason?: ReplacementReason;
}

export class UserNotificationViewModel implements IUserNotificationViewModel {
    id?: number;
    userNotificationId?: number;
    notificationId?: number;
    notificationType?: NotificationType;
    isSeen?: boolean;
    notifyType?: NotificationType;
    message?: string | undefined;
    deploymentRequestId?: string;
    timeDuration?: string | undefined;
    createdDate?: Date;
    crtDate?: string | undefined;
    spareRequestId?: string;
    unseenCount?: number;

    constructor(data?: IUserNotificationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userNotificationId = _data["userNotificationId"];
            this.notificationId = _data["notificationId"];
            this.notificationType = _data["notificationType"];
            this.isSeen = _data["isSeen"];
            this.notifyType = _data["notifyType"];
            this.message = _data["message"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.timeDuration = _data["timeDuration"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.crtDate = _data["crtDate"];
            this.spareRequestId = _data["spareRequestId"];
            this.unseenCount = _data["unseenCount"];
        }
    }

    static fromJS(data: any): UserNotificationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotificationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userNotificationId"] = this.userNotificationId;
        data["notificationId"] = this.notificationId;
        data["notificationType"] = this.notificationType;
        data["isSeen"] = this.isSeen;
        data["notifyType"] = this.notifyType;
        data["message"] = this.message;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["timeDuration"] = this.timeDuration;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["crtDate"] = this.crtDate;
        data["spareRequestId"] = this.spareRequestId;
        data["unseenCount"] = this.unseenCount;
        return data;
    }
}

export interface IUserNotificationViewModel {
    id?: number;
    userNotificationId?: number;
    notificationId?: number;
    notificationType?: NotificationType;
    isSeen?: boolean;
    notifyType?: NotificationType;
    message?: string | undefined;
    deploymentRequestId?: string;
    timeDuration?: string | undefined;
    createdDate?: Date;
    crtDate?: string | undefined;
    spareRequestId?: string;
    unseenCount?: number;
}

export enum NotificationType {
    New_Request = 1,
    Remove_Request = 2,
    Accessory_Request = 3,
    Support_Request = 4,
    Deployed_New = 5,
    Reconfigure_Request = 6,
    Accessory_Delivered = 7,
    Support_Provided = 8,
    Deployed_Reconfigure = 9,
    Device_Removed = 10,
    Remove_Cancel = 11,
    Application_Update = 12,
    Deploy_Rejected = 13,
    Spare_Request = 14,
    SpareAndSupport_Request = 15,
}

export class BranchViewModel implements IBranchViewModel {
    branchName?: string | undefined;
    branchCode?: string | undefined;

    constructor(data?: IBranchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchName = _data["branchName"];
            this.branchCode = _data["branchCode"];
        }
    }

    static fromJS(data: any): BranchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BranchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchName"] = this.branchName;
        data["branchCode"] = this.branchCode;
        return data;
    }
}

export interface IBranchViewModel {
    branchName?: string | undefined;
    branchCode?: string | undefined;
}

export class RemovalStatusViewModel implements IRemovalStatusViewModel {
    id?: string | undefined;
    deploymentRequestId?: string;
    removalStatusDisplayName?: string | undefined;
    removalStatus?: RemovalStatusReason;
    createdBy?: string | undefined;
    createdDate?: Date;
    updatedBy?: string | undefined;
    updatedDate?: Date;

    constructor(data?: IRemovalStatusViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.removalStatusDisplayName = _data["removalStatusDisplayName"];
            this.removalStatus = _data["removalStatus"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RemovalStatusViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RemovalStatusViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["removalStatusDisplayName"] = this.removalStatusDisplayName;
        data["removalStatus"] = this.removalStatus;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRemovalStatusViewModel {
    id?: string | undefined;
    deploymentRequestId?: string;
    removalStatusDisplayName?: string | undefined;
    removalStatus?: RemovalStatusReason;
    createdBy?: string | undefined;
    createdDate?: Date;
    updatedBy?: string | undefined;
    updatedDate?: Date;
}

export class CardRequestsViewModel implements ICardRequestsViewModel {
    bankId?: string | undefined;
    bankIdOfCardProduct?: string | undefined;
    cardProductId?: number;
    totalRequested?: number;
    fileName?: string | undefined;
    printCardsOfOtherBanks?: boolean;

    constructor(data?: ICardRequestsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankId = _data["bankId"];
            this.bankIdOfCardProduct = _data["bankIdOfCardProduct"];
            this.cardProductId = _data["cardProductId"];
            this.totalRequested = _data["totalRequested"];
            this.fileName = _data["fileName"];
            this.printCardsOfOtherBanks = _data["printCardsOfOtherBanks"];
        }
    }

    static fromJS(data: any): CardRequestsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CardRequestsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankId"] = this.bankId;
        data["bankIdOfCardProduct"] = this.bankIdOfCardProduct;
        data["cardProductId"] = this.cardProductId;
        data["totalRequested"] = this.totalRequested;
        data["fileName"] = this.fileName;
        data["printCardsOfOtherBanks"] = this.printCardsOfOtherBanks;
        return data;
    }
}

export interface ICardRequestsViewModel {
    bankId?: string | undefined;
    bankIdOfCardProduct?: string | undefined;
    cardProductId?: number;
    totalRequested?: number;
    fileName?: string | undefined;
    printCardsOfOtherBanks?: boolean;
}

export class BureauDetail implements IBureauDetail {
    printsOtherBankCards?: boolean;
    bureauBank?: string;
    banksUnderBureau?: BanksUnderBureauDto[] | undefined;

    constructor(data?: IBureauDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.printsOtherBankCards = _data["printsOtherBankCards"];
            this.bureauBank = _data["bureauBank"];
            if (Array.isArray(_data["banksUnderBureau"])) {
                this.banksUnderBureau = [] as any;
                for (let item of _data["banksUnderBureau"])
                    this.banksUnderBureau!.push(BanksUnderBureauDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BureauDetail {
        data = typeof data === 'object' ? data : {};
        let result = new BureauDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["printsOtherBankCards"] = this.printsOtherBankCards;
        data["bureauBank"] = this.bureauBank;
        if (Array.isArray(this.banksUnderBureau)) {
            data["banksUnderBureau"] = [];
            for (let item of this.banksUnderBureau)
                data["banksUnderBureau"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBureauDetail {
    printsOtherBankCards?: boolean;
    bureauBank?: string;
    banksUnderBureau?: BanksUnderBureauDto[] | undefined;
}

export class BanksUnderBureauDto implements IBanksUnderBureauDto {
    id?: string;
    name?: string | undefined;
    code?: string | undefined;

    constructor(data?: IBanksUnderBureauDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): BanksUnderBureauDto {
        data = typeof data === 'object' ? data : {};
        let result = new BanksUnderBureauDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }
}

export interface IBanksUnderBureauDto {
    id?: string;
    name?: string | undefined;
    code?: string | undefined;
}

export class CardProductViewModel implements ICardProductViewModel {
    id?: number;
    bankId?: string;
    bankName?: string | undefined;
    productCode?: string | undefined;
    productName?: string | undefined;
    type?: ProductType;
    productType?: string | undefined;
    productBrand?: string | undefined;
    brand?: ProductBrand;
    active?: boolean;

    constructor(data?: ICardProductViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bankId = _data["bankId"];
            this.bankName = _data["bankName"];
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.type = _data["type"];
            this.productType = _data["productType"];
            this.productBrand = _data["productBrand"];
            this.brand = _data["brand"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): CardProductViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CardProductViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankId"] = this.bankId;
        data["bankName"] = this.bankName;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["type"] = this.type;
        data["productType"] = this.productType;
        data["productBrand"] = this.productBrand;
        data["brand"] = this.brand;
        data["active"] = this.active;
        return data;
    }
}

export interface ICardProductViewModel {
    id?: number;
    bankId?: string;
    bankName?: string | undefined;
    productCode?: string | undefined;
    productName?: string | undefined;
    type?: ProductType;
    productType?: string | undefined;
    productBrand?: string | undefined;
    brand?: ProductBrand;
    active?: boolean;
}

export class CardRequestViewModel implements ICardRequestViewModel {
    id?: number;
    cardProductId?: number;
    totalRequested?: number;
    totalDamaged?: number;
    pending?: number;
    cardName?: string | undefined;
    totalPrinted?: number;
    fileName?: string | undefined;
    bankId?: string;
    hardwareId?: string;
    bureauId?: string;
    bureauName?: string | undefined;
    bankName?: string | undefined;
    productCode?: string | undefined;
    productName?: string | undefined;
    productType?: string | undefined;
    productBrand?: string | undefined;
    createdBy?: string | undefined;
    createdDate?: Date;
    requestDate?: string | undefined;

    constructor(data?: ICardRequestViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cardProductId = _data["cardProductId"];
            this.totalRequested = _data["totalRequested"];
            this.totalDamaged = _data["totalDamaged"];
            this.pending = _data["pending"];
            this.cardName = _data["cardName"];
            this.totalPrinted = _data["totalPrinted"];
            this.fileName = _data["fileName"];
            this.bankId = _data["bankId"];
            this.hardwareId = _data["hardwareId"];
            this.bureauId = _data["bureauId"];
            this.bureauName = _data["bureauName"];
            this.bankName = _data["bankName"];
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.productType = _data["productType"];
            this.productBrand = _data["productBrand"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.requestDate = _data["requestDate"];
        }
    }

    static fromJS(data: any): CardRequestViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CardRequestViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cardProductId"] = this.cardProductId;
        data["totalRequested"] = this.totalRequested;
        data["totalDamaged"] = this.totalDamaged;
        data["pending"] = this.pending;
        data["cardName"] = this.cardName;
        data["totalPrinted"] = this.totalPrinted;
        data["fileName"] = this.fileName;
        data["bankId"] = this.bankId;
        data["hardwareId"] = this.hardwareId;
        data["bureauId"] = this.bureauId;
        data["bureauName"] = this.bureauName;
        data["bankName"] = this.bankName;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["productType"] = this.productType;
        data["productBrand"] = this.productBrand;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["requestDate"] = this.requestDate;
        return data;
    }
}

export interface ICardRequestViewModel {
    id?: number;
    cardProductId?: number;
    totalRequested?: number;
    totalDamaged?: number;
    pending?: number;
    cardName?: string | undefined;
    totalPrinted?: number;
    fileName?: string | undefined;
    bankId?: string;
    hardwareId?: string;
    bureauId?: string;
    bureauName?: string | undefined;
    bankName?: string | undefined;
    productCode?: string | undefined;
    productName?: string | undefined;
    productType?: string | undefined;
    productBrand?: string | undefined;
    createdBy?: string | undefined;
    createdDate?: Date;
    requestDate?: string | undefined;
}

export class CardPrintReportVm implements ICardPrintReportVm {
    id?: number;
    bureauName?: string | undefined;
    bankName?: string | undefined;
    productType?: string | undefined;
    productCode?: string | undefined;
    totalPrinted?: number;
    totalDamaged?: number;
    totalRequested?: number;
    totalPending?: number;
    brand?: ProductBrand;
    productBrand?: string | undefined;
    createdOn?: string | undefined;

    constructor(data?: ICardPrintReportVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bureauName = _data["bureauName"];
            this.bankName = _data["bankName"];
            this.productType = _data["productType"];
            this.productCode = _data["productCode"];
            this.totalPrinted = _data["totalPrinted"];
            this.totalDamaged = _data["totalDamaged"];
            this.totalRequested = _data["totalRequested"];
            this.totalPending = _data["totalPending"];
            this.brand = _data["brand"];
            this.productBrand = _data["productBrand"];
            this.createdOn = _data["createdOn"];
        }
    }

    static fromJS(data: any): CardPrintReportVm {
        data = typeof data === 'object' ? data : {};
        let result = new CardPrintReportVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bureauName"] = this.bureauName;
        data["bankName"] = this.bankName;
        data["productType"] = this.productType;
        data["productCode"] = this.productCode;
        data["totalPrinted"] = this.totalPrinted;
        data["totalDamaged"] = this.totalDamaged;
        data["totalRequested"] = this.totalRequested;
        data["totalPending"] = this.totalPending;
        data["brand"] = this.brand;
        data["productBrand"] = this.productBrand;
        data["createdOn"] = this.createdOn;
        return data;
    }
}

export interface ICardPrintReportVm {
    id?: number;
    bureauName?: string | undefined;
    bankName?: string | undefined;
    productType?: string | undefined;
    productCode?: string | undefined;
    totalPrinted?: number;
    totalDamaged?: number;
    totalRequested?: number;
    totalPending?: number;
    brand?: ProductBrand;
    productBrand?: string | undefined;
    createdOn?: string | undefined;
}

export class TransactionViewModel implements ITransactionViewModel {
    id?: string;
    settlementDate?: string | undefined;
    trxDate?: string | undefined;
    merchantNumber?: string | undefined;
    terminalNumber?: string | undefined;
    cardMask?: string | undefined;
    rrn?: string | undefined;
    cardType?: string | undefined;
    network?: string | undefined;
    merchantName?: string | undefined;
    merchantAccount?: string | undefined;
    trxAmount?: string | undefined;
    mscRate?: string | undefined;
    mscAmount?: string | undefined;
    settlementAmount?: string | undefined;

    constructor(data?: ITransactionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.settlementDate = _data["settlementDate"];
            this.trxDate = _data["trxDate"];
            this.merchantNumber = _data["merchantNumber"];
            this.terminalNumber = _data["terminalNumber"];
            this.cardMask = _data["cardMask"];
            this.rrn = _data["rrn"];
            this.cardType = _data["cardType"];
            this.network = _data["network"];
            this.merchantName = _data["merchantName"];
            this.merchantAccount = _data["merchantAccount"];
            this.trxAmount = _data["trxAmount"];
            this.mscRate = _data["mscRate"];
            this.mscAmount = _data["mscAmount"];
            this.settlementAmount = _data["settlementAmount"];
        }
    }

    static fromJS(data: any): TransactionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["settlementDate"] = this.settlementDate;
        data["trxDate"] = this.trxDate;
        data["merchantNumber"] = this.merchantNumber;
        data["terminalNumber"] = this.terminalNumber;
        data["cardMask"] = this.cardMask;
        data["rrn"] = this.rrn;
        data["cardType"] = this.cardType;
        data["network"] = this.network;
        data["merchantName"] = this.merchantName;
        data["merchantAccount"] = this.merchantAccount;
        data["trxAmount"] = this.trxAmount;
        data["mscRate"] = this.mscRate;
        data["mscAmount"] = this.mscAmount;
        data["settlementAmount"] = this.settlementAmount;
        return data;
    }
}

export interface ITransactionViewModel {
    id?: string;
    settlementDate?: string | undefined;
    trxDate?: string | undefined;
    merchantNumber?: string | undefined;
    terminalNumber?: string | undefined;
    cardMask?: string | undefined;
    rrn?: string | undefined;
    cardType?: string | undefined;
    network?: string | undefined;
    merchantName?: string | undefined;
    merchantAccount?: string | undefined;
    trxAmount?: string | undefined;
    mscRate?: string | undefined;
    mscAmount?: string | undefined;
    settlementAmount?: string | undefined;
}

export class CreateTransactionRecordCommand implements ICreateTransactionRecordCommand {
    id?: string;
    settlementDate?: string | undefined;
    trxDate?: string | undefined;
    merchantNumber?: number;
    terminalNumber?: number;
    cardMask?: string | undefined;
    rrn?: string | undefined;
    cardType?: string | undefined;
    network?: string | undefined;
    merchantName?: string | undefined;
    merchantAccount?: string | undefined;
    trxAmount?: number;
    mscRate?: number;
    mscAmount?: number;
    settlementAmount?: number;
    bankId?: string;

    constructor(data?: ICreateTransactionRecordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.settlementDate = _data["settlementDate"];
            this.trxDate = _data["trxDate"];
            this.merchantNumber = _data["merchantNumber"];
            this.terminalNumber = _data["terminalNumber"];
            this.cardMask = _data["cardMask"];
            this.rrn = _data["rrn"];
            this.cardType = _data["cardType"];
            this.network = _data["network"];
            this.merchantName = _data["merchantName"];
            this.merchantAccount = _data["merchantAccount"];
            this.trxAmount = _data["trxAmount"];
            this.mscRate = _data["mscRate"];
            this.mscAmount = _data["mscAmount"];
            this.settlementAmount = _data["settlementAmount"];
            this.bankId = _data["bankId"];
        }
    }

    static fromJS(data: any): CreateTransactionRecordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTransactionRecordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["settlementDate"] = this.settlementDate;
        data["trxDate"] = this.trxDate;
        data["merchantNumber"] = this.merchantNumber;
        data["terminalNumber"] = this.terminalNumber;
        data["cardMask"] = this.cardMask;
        data["rrn"] = this.rrn;
        data["cardType"] = this.cardType;
        data["network"] = this.network;
        data["merchantName"] = this.merchantName;
        data["merchantAccount"] = this.merchantAccount;
        data["trxAmount"] = this.trxAmount;
        data["mscRate"] = this.mscRate;
        data["mscAmount"] = this.mscAmount;
        data["settlementAmount"] = this.settlementAmount;
        data["bankId"] = this.bankId;
        return data;
    }
}

export interface ICreateTransactionRecordCommand {
    id?: string;
    settlementDate?: string | undefined;
    trxDate?: string | undefined;
    merchantNumber?: number;
    terminalNumber?: number;
    cardMask?: string | undefined;
    rrn?: string | undefined;
    cardType?: string | undefined;
    network?: string | undefined;
    merchantName?: string | undefined;
    merchantAccount?: string | undefined;
    trxAmount?: number;
    mscRate?: number;
    mscAmount?: number;
    settlementAmount?: number;
    bankId?: string;
}

export class TransactionRecord extends AuditableEntity implements ITransactionRecord {
    id?: string;
    settlementDate?: string | undefined;
    trxDate?: string | undefined;
    merchantNumber?: number;
    terminalNumber?: number;
    cardMask?: string | undefined;
    rrn?: string | undefined;
    cardType?: string | undefined;
    network?: string | undefined;
    merchantName?: string | undefined;
    merchantAccount?: string | undefined;
    trxAmount?: number;
    mscRate?: number;
    mscAmount?: number;
    settlementAmount?: number;
    bankId?: string;

    constructor(data?: ITransactionRecord) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.settlementDate = _data["settlementDate"];
            this.trxDate = _data["trxDate"];
            this.merchantNumber = _data["merchantNumber"];
            this.terminalNumber = _data["terminalNumber"];
            this.cardMask = _data["cardMask"];
            this.rrn = _data["rrn"];
            this.cardType = _data["cardType"];
            this.network = _data["network"];
            this.merchantName = _data["merchantName"];
            this.merchantAccount = _data["merchantAccount"];
            this.trxAmount = _data["trxAmount"];
            this.mscRate = _data["mscRate"];
            this.mscAmount = _data["mscAmount"];
            this.settlementAmount = _data["settlementAmount"];
            this.bankId = _data["bankId"];
        }
    }

    static override fromJS(data: any): TransactionRecord {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionRecord();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["settlementDate"] = this.settlementDate;
        data["trxDate"] = this.trxDate;
        data["merchantNumber"] = this.merchantNumber;
        data["terminalNumber"] = this.terminalNumber;
        data["cardMask"] = this.cardMask;
        data["rrn"] = this.rrn;
        data["cardType"] = this.cardType;
        data["network"] = this.network;
        data["merchantName"] = this.merchantName;
        data["merchantAccount"] = this.merchantAccount;
        data["trxAmount"] = this.trxAmount;
        data["mscRate"] = this.mscRate;
        data["mscAmount"] = this.mscAmount;
        data["settlementAmount"] = this.settlementAmount;
        data["bankId"] = this.bankId;
        super.toJSON(data);
        return data;
    }
}

export interface ITransactionRecord extends IAuditableEntity {
    id?: string;
    settlementDate?: string | undefined;
    trxDate?: string | undefined;
    merchantNumber?: number;
    terminalNumber?: number;
    cardMask?: string | undefined;
    rrn?: string | undefined;
    cardType?: string | undefined;
    network?: string | undefined;
    merchantName?: string | undefined;
    merchantAccount?: string | undefined;
    trxAmount?: number;
    mscRate?: number;
    mscAmount?: number;
    settlementAmount?: number;
    bankId?: string;
}

export class TransactionHeaders extends AuditableEntity implements ITransactionHeaders {
    id?: string;
    settlementDate?: string | undefined;
    trxDate?: string | undefined;
    merchantNumber?: string | undefined;
    terminalNumber?: string | undefined;
    cardMask?: string | undefined;
    rrn?: string | undefined;
    cardType?: string | undefined;
    network?: string | undefined;
    merchantName?: string | undefined;
    merchantAccount?: string | undefined;
    trxAmount?: string | undefined;
    mscRate?: string | undefined;
    mscAmount?: string | undefined;
    settlementAmount?: string | undefined;
    bankId?: string;

    constructor(data?: ITransactionHeaders) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.settlementDate = _data["settlementDate"];
            this.trxDate = _data["trxDate"];
            this.merchantNumber = _data["merchantNumber"];
            this.terminalNumber = _data["terminalNumber"];
            this.cardMask = _data["cardMask"];
            this.rrn = _data["rrn"];
            this.cardType = _data["cardType"];
            this.network = _data["network"];
            this.merchantName = _data["merchantName"];
            this.merchantAccount = _data["merchantAccount"];
            this.trxAmount = _data["trxAmount"];
            this.mscRate = _data["mscRate"];
            this.mscAmount = _data["mscAmount"];
            this.settlementAmount = _data["settlementAmount"];
            this.bankId = _data["bankId"];
        }
    }

    static override fromJS(data: any): TransactionHeaders {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionHeaders();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["settlementDate"] = this.settlementDate;
        data["trxDate"] = this.trxDate;
        data["merchantNumber"] = this.merchantNumber;
        data["terminalNumber"] = this.terminalNumber;
        data["cardMask"] = this.cardMask;
        data["rrn"] = this.rrn;
        data["cardType"] = this.cardType;
        data["network"] = this.network;
        data["merchantName"] = this.merchantName;
        data["merchantAccount"] = this.merchantAccount;
        data["trxAmount"] = this.trxAmount;
        data["mscRate"] = this.mscRate;
        data["mscAmount"] = this.mscAmount;
        data["settlementAmount"] = this.settlementAmount;
        data["bankId"] = this.bankId;
        super.toJSON(data);
        return data;
    }
}

export interface ITransactionHeaders extends IAuditableEntity {
    id?: string;
    settlementDate?: string | undefined;
    trxDate?: string | undefined;
    merchantNumber?: string | undefined;
    terminalNumber?: string | undefined;
    cardMask?: string | undefined;
    rrn?: string | undefined;
    cardType?: string | undefined;
    network?: string | undefined;
    merchantName?: string | undefined;
    merchantAccount?: string | undefined;
    trxAmount?: string | undefined;
    mscRate?: string | undefined;
    mscAmount?: string | undefined;
    settlementAmount?: string | undefined;
    bankId?: string;
}

export class CreateTransactionHeaderCommand implements ICreateTransactionHeaderCommand {
    id?: string;
    settlementDate?: string | undefined;
    trxDate?: string | undefined;
    merchantNumber?: string | undefined;
    terminalNumber?: string | undefined;
    cardMask?: string | undefined;
    rrn?: string | undefined;
    cardType?: string | undefined;
    network?: string | undefined;
    merchantName?: string | undefined;
    merchantAccount?: string | undefined;
    trxAmount?: string | undefined;
    mscRate?: string | undefined;
    mscAmount?: string | undefined;
    settlementAmount?: string | undefined;

    constructor(data?: ICreateTransactionHeaderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.settlementDate = _data["settlementDate"];
            this.trxDate = _data["trxDate"];
            this.merchantNumber = _data["merchantNumber"];
            this.terminalNumber = _data["terminalNumber"];
            this.cardMask = _data["cardMask"];
            this.rrn = _data["rrn"];
            this.cardType = _data["cardType"];
            this.network = _data["network"];
            this.merchantName = _data["merchantName"];
            this.merchantAccount = _data["merchantAccount"];
            this.trxAmount = _data["trxAmount"];
            this.mscRate = _data["mscRate"];
            this.mscAmount = _data["mscAmount"];
            this.settlementAmount = _data["settlementAmount"];
        }
    }

    static fromJS(data: any): CreateTransactionHeaderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTransactionHeaderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["settlementDate"] = this.settlementDate;
        data["trxDate"] = this.trxDate;
        data["merchantNumber"] = this.merchantNumber;
        data["terminalNumber"] = this.terminalNumber;
        data["cardMask"] = this.cardMask;
        data["rrn"] = this.rrn;
        data["cardType"] = this.cardType;
        data["network"] = this.network;
        data["merchantName"] = this.merchantName;
        data["merchantAccount"] = this.merchantAccount;
        data["trxAmount"] = this.trxAmount;
        data["mscRate"] = this.mscRate;
        data["mscAmount"] = this.mscAmount;
        data["settlementAmount"] = this.settlementAmount;
        return data;
    }
}

export interface ICreateTransactionHeaderCommand {
    id?: string;
    settlementDate?: string | undefined;
    trxDate?: string | undefined;
    merchantNumber?: string | undefined;
    terminalNumber?: string | undefined;
    cardMask?: string | undefined;
    rrn?: string | undefined;
    cardType?: string | undefined;
    network?: string | undefined;
    merchantName?: string | undefined;
    merchantAccount?: string | undefined;
    trxAmount?: string | undefined;
    mscRate?: string | undefined;
    mscAmount?: string | undefined;
    settlementAmount?: string | undefined;
}

export class UpdateTransactionHeaderCommand implements IUpdateTransactionHeaderCommand {
    id?: string;
    settlementDate?: string | undefined;
    trxDate?: string | undefined;
    merchantNumber?: string | undefined;
    terminalNumber?: string | undefined;
    cardMask?: string | undefined;
    rrn?: string | undefined;
    cardType?: string | undefined;
    network?: string | undefined;
    merchantName?: string | undefined;
    merchantAccount?: string | undefined;
    trxAmount?: string | undefined;
    mscRate?: string | undefined;
    mscAmount?: string | undefined;
    settlementAmount?: string | undefined;

    constructor(data?: IUpdateTransactionHeaderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.settlementDate = _data["settlementDate"];
            this.trxDate = _data["trxDate"];
            this.merchantNumber = _data["merchantNumber"];
            this.terminalNumber = _data["terminalNumber"];
            this.cardMask = _data["cardMask"];
            this.rrn = _data["rrn"];
            this.cardType = _data["cardType"];
            this.network = _data["network"];
            this.merchantName = _data["merchantName"];
            this.merchantAccount = _data["merchantAccount"];
            this.trxAmount = _data["trxAmount"];
            this.mscRate = _data["mscRate"];
            this.mscAmount = _data["mscAmount"];
            this.settlementAmount = _data["settlementAmount"];
        }
    }

    static fromJS(data: any): UpdateTransactionHeaderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTransactionHeaderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["settlementDate"] = this.settlementDate;
        data["trxDate"] = this.trxDate;
        data["merchantNumber"] = this.merchantNumber;
        data["terminalNumber"] = this.terminalNumber;
        data["cardMask"] = this.cardMask;
        data["rrn"] = this.rrn;
        data["cardType"] = this.cardType;
        data["network"] = this.network;
        data["merchantName"] = this.merchantName;
        data["merchantAccount"] = this.merchantAccount;
        data["trxAmount"] = this.trxAmount;
        data["mscRate"] = this.mscRate;
        data["mscAmount"] = this.mscAmount;
        data["settlementAmount"] = this.settlementAmount;
        return data;
    }
}

export interface IUpdateTransactionHeaderCommand {
    id?: string;
    settlementDate?: string | undefined;
    trxDate?: string | undefined;
    merchantNumber?: string | undefined;
    terminalNumber?: string | undefined;
    cardMask?: string | undefined;
    rrn?: string | undefined;
    cardType?: string | undefined;
    network?: string | undefined;
    merchantName?: string | undefined;
    merchantAccount?: string | undefined;
    trxAmount?: string | undefined;
    mscRate?: string | undefined;
    mscAmount?: string | undefined;
    settlementAmount?: string | undefined;
}

export class TransactionDashBoardData implements ITransactionDashBoardData {
    totalTransaction?: number;
    todayTransaction?: number;

    constructor(data?: ITransactionDashBoardData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalTransaction = _data["totalTransaction"];
            this.todayTransaction = _data["todayTransaction"];
        }
    }

    static fromJS(data: any): TransactionDashBoardData {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionDashBoardData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalTransaction"] = this.totalTransaction;
        data["todayTransaction"] = this.todayTransaction;
        return data;
    }
}

export interface ITransactionDashBoardData {
    totalTransaction?: number;
    todayTransaction?: number;
}

export class MerchantAndTerminalVm implements IMerchantAndTerminalVm {
    totalMerchant?: number;
    totalActiveTerminals?: number;

    constructor(data?: IMerchantAndTerminalVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalMerchant = _data["totalMerchant"];
            this.totalActiveTerminals = _data["totalActiveTerminals"];
        }
    }

    static fromJS(data: any): MerchantAndTerminalVm {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantAndTerminalVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalMerchant"] = this.totalMerchant;
        data["totalActiveTerminals"] = this.totalActiveTerminals;
        return data;
    }
}

export interface IMerchantAndTerminalVm {
    totalMerchant?: number;
    totalActiveTerminals?: number;
}

export class TerminalTrends implements ITerminalTrends {
    deployDate?: Date;
    formattedDeployDate?: string | undefined;
    terminalCount?: number;

    constructor(data?: ITerminalTrends) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deployDate = _data["deployDate"] ? new Date(_data["deployDate"].toString()) : <any>undefined;
            this.formattedDeployDate = _data["formattedDeployDate"];
            this.terminalCount = _data["terminalCount"];
        }
    }

    static fromJS(data: any): TerminalTrends {
        data = typeof data === 'object' ? data : {};
        let result = new TerminalTrends();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deployDate"] = this.deployDate ? this.deployDate.toISOString() : <any>undefined;
        data["formattedDeployDate"] = this.formattedDeployDate;
        data["terminalCount"] = this.terminalCount;
        return data;
    }
}

export interface ITerminalTrends {
    deployDate?: Date;
    formattedDeployDate?: string | undefined;
    terminalCount?: number;
}

export class MerchantTransaction implements IMerchantTransaction {
    merchantId?: string | undefined;
    createdDate?: string | undefined;
    createdDay?: string | undefined;
    merchantName?: string | undefined;
    totalTransaction?: number;
    totalTransactionAmount?: number;

    constructor(data?: IMerchantTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.merchantId = _data["merchantId"];
            this.createdDate = _data["createdDate"];
            this.createdDay = _data["createdDay"];
            this.merchantName = _data["merchantName"];
            this.totalTransaction = _data["totalTransaction"];
            this.totalTransactionAmount = _data["totalTransactionAmount"];
        }
    }

    static fromJS(data: any): MerchantTransaction {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantTransaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["merchantId"] = this.merchantId;
        data["createdDate"] = this.createdDate;
        data["createdDay"] = this.createdDay;
        data["merchantName"] = this.merchantName;
        data["totalTransaction"] = this.totalTransaction;
        data["totalTransactionAmount"] = this.totalTransactionAmount;
        return data;
    }
}

export interface IMerchantTransaction {
    merchantId?: string | undefined;
    createdDate?: string | undefined;
    createdDay?: string | undefined;
    merchantName?: string | undefined;
    totalTransaction?: number;
    totalTransactionAmount?: number;
}

export class MerchantCategoryInfoVM implements IMerchantCategoryInfoVM {
    merchantCategory?: string | undefined;
    merchantCategoryAmount?: number;

    constructor(data?: IMerchantCategoryInfoVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.merchantCategory = _data["merchantCategory"];
            this.merchantCategoryAmount = _data["merchantCategoryAmount"];
        }
    }

    static fromJS(data: any): MerchantCategoryInfoVM {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantCategoryInfoVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["merchantCategory"] = this.merchantCategory;
        data["merchantCategoryAmount"] = this.merchantCategoryAmount;
        return data;
    }
}

export interface IMerchantCategoryInfoVM {
    merchantCategory?: string | undefined;
    merchantCategoryAmount?: number;
}

export class TransactionDetailDashboardVm implements ITransactionDetailDashboardVm {
    merchantId?: string | undefined;
    terminalId?: string | undefined;
    amount?: number;
    createdDate?: Date;
    transactionDate?: string | undefined;
    merchantName?: string | undefined;
    address?: string | undefined;
    networkType?: string | undefined;
    status?: string | undefined;
    remarks?: string | undefined;

    constructor(data?: ITransactionDetailDashboardVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.merchantId = _data["merchantId"];
            this.terminalId = _data["terminalId"];
            this.amount = _data["amount"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.transactionDate = _data["transactionDate"];
            this.merchantName = _data["merchantName"];
            this.address = _data["address"];
            this.networkType = _data["networkType"];
            this.status = _data["status"];
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): TransactionDetailDashboardVm {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionDetailDashboardVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["merchantId"] = this.merchantId;
        data["terminalId"] = this.terminalId;
        data["amount"] = this.amount;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["transactionDate"] = this.transactionDate;
        data["merchantName"] = this.merchantName;
        data["address"] = this.address;
        data["networkType"] = this.networkType;
        data["status"] = this.status;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface ITransactionDetailDashboardVm {
    merchantId?: string | undefined;
    terminalId?: string | undefined;
    amount?: number;
    createdDate?: Date;
    transactionDate?: string | undefined;
    merchantName?: string | undefined;
    address?: string | undefined;
    networkType?: string | undefined;
    status?: string | undefined;
    remarks?: string | undefined;
}

export class TransactionDetailViewModel implements ITransactionDetailViewModel {
    transactionId?: number;
    cardNumber?: string | undefined;
    terminalId?: string | undefined;
    merchantId?: string | undefined;
    amount?: string | undefined;
    createdDate?: string | undefined;
    merchantName?: string | undefined;
    address?: string | undefined;
    contactNumber?: string | undefined;
    status?: string | undefined;
    networkType?: string | undefined;

    constructor(data?: ITransactionDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.cardNumber = _data["cardNumber"];
            this.terminalId = _data["terminalId"];
            this.merchantId = _data["merchantId"];
            this.amount = _data["amount"];
            this.createdDate = _data["createdDate"];
            this.merchantName = _data["merchantName"];
            this.address = _data["address"];
            this.contactNumber = _data["contactNumber"];
            this.status = _data["status"];
            this.networkType = _data["networkType"];
        }
    }

    static fromJS(data: any): TransactionDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["cardNumber"] = this.cardNumber;
        data["terminalId"] = this.terminalId;
        data["merchantId"] = this.merchantId;
        data["amount"] = this.amount;
        data["createdDate"] = this.createdDate;
        data["merchantName"] = this.merchantName;
        data["address"] = this.address;
        data["contactNumber"] = this.contactNumber;
        data["status"] = this.status;
        data["networkType"] = this.networkType;
        return data;
    }
}

export interface ITransactionDetailViewModel {
    transactionId?: number;
    cardNumber?: string | undefined;
    terminalId?: string | undefined;
    merchantId?: string | undefined;
    amount?: string | undefined;
    createdDate?: string | undefined;
    merchantName?: string | undefined;
    address?: string | undefined;
    contactNumber?: string | undefined;
    status?: string | undefined;
    networkType?: string | undefined;
}

export class OtherStockAddViewModel implements IOtherStockAddViewModel {
    id?: string;
    deploymentRequestId?: string;
    deploymentRequest?: string | undefined;
    inventoryAddId?: string;
    inventoryAdd?: string | undefined;
    otherPartyId?: string | undefined;
    deployed?: number;
    otherParty?: string | undefined;
    stockDate?: Date;
    totalNumber?: number;
    buyDate?: Date;
    bankId?: string;
    bankName?: string | undefined;
    inventoryId?: string;
    inventory?: string | undefined;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    hasSerialNo?: boolean;
    partyName?: string | undefined;
    partyAddress?: string | undefined;
    phoneNo?: string | undefined;
    soldOut?: number;
    remarks?: string | undefined;
    remaining?: number;
    merchant?: string | undefined;
    idMerchant?: string | undefined;
    outlet?: string | undefined;
    district?: string | undefined;
    province?: string | undefined;
    address?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    idTerminal?: string | undefined;
    terminalType?: string | undefined;
    createdBy?: string | undefined;
    receivedBy?: string | undefined;
    updatedDate?: Date;
    distributedDate?: string | undefined;
    distributedBy?: string | undefined;
    stockDateInString?: string | undefined;
    spareList?: SpareListViewModel[] | undefined;

    constructor(data?: IOtherStockAddViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.deploymentRequest = _data["deploymentRequest"];
            this.inventoryAddId = _data["inventoryAddId"];
            this.inventoryAdd = _data["inventoryAdd"];
            this.otherPartyId = _data["otherPartyId"];
            this.deployed = _data["deployed"];
            this.otherParty = _data["otherParty"];
            this.stockDate = _data["stockDate"] ? new Date(_data["stockDate"].toString()) : <any>undefined;
            this.totalNumber = _data["totalNumber"];
            this.buyDate = _data["buyDate"] ? new Date(_data["buyDate"].toString()) : <any>undefined;
            this.bankId = _data["bankId"];
            this.bankName = _data["bankName"];
            this.inventoryId = _data["inventoryId"];
            this.inventory = _data["inventory"];
            this.primaryItem = _data["primaryItem"];
            this.secondaryItem = _data["secondaryItem"];
            this.tertiaryItem = _data["tertiaryItem"];
            this.detailItem = _data["detailItem"];
            this.hasSerialNo = _data["hasSerialNo"];
            this.partyName = _data["partyName"];
            this.partyAddress = _data["partyAddress"];
            this.phoneNo = _data["phoneNo"];
            this.soldOut = _data["soldOut"];
            this.remarks = _data["remarks"];
            this.remaining = _data["remaining"];
            this.merchant = _data["merchant"];
            this.idMerchant = _data["idMerchant"];
            this.outlet = _data["outlet"];
            this.district = _data["district"];
            this.province = _data["province"];
            this.address = _data["address"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo = _data["contactNo"];
            this.idTerminal = _data["idTerminal"];
            this.terminalType = _data["terminalType"];
            this.createdBy = _data["createdBy"];
            this.receivedBy = _data["receivedBy"];
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.distributedDate = _data["distributedDate"];
            this.distributedBy = _data["distributedBy"];
            this.stockDateInString = _data["stockDateInString"];
            if (Array.isArray(_data["spareList"])) {
                this.spareList = [] as any;
                for (let item of _data["spareList"])
                    this.spareList!.push(SpareListViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OtherStockAddViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OtherStockAddViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["deploymentRequest"] = this.deploymentRequest;
        data["inventoryAddId"] = this.inventoryAddId;
        data["inventoryAdd"] = this.inventoryAdd;
        data["otherPartyId"] = this.otherPartyId;
        data["deployed"] = this.deployed;
        data["otherParty"] = this.otherParty;
        data["stockDate"] = this.stockDate ? this.stockDate.toISOString() : <any>undefined;
        data["totalNumber"] = this.totalNumber;
        data["buyDate"] = this.buyDate ? this.buyDate.toISOString() : <any>undefined;
        data["bankId"] = this.bankId;
        data["bankName"] = this.bankName;
        data["inventoryId"] = this.inventoryId;
        data["inventory"] = this.inventory;
        data["primaryItem"] = this.primaryItem;
        data["secondaryItem"] = this.secondaryItem;
        data["tertiaryItem"] = this.tertiaryItem;
        data["detailItem"] = this.detailItem;
        data["hasSerialNo"] = this.hasSerialNo;
        data["partyName"] = this.partyName;
        data["partyAddress"] = this.partyAddress;
        data["phoneNo"] = this.phoneNo;
        data["soldOut"] = this.soldOut;
        data["remarks"] = this.remarks;
        data["remaining"] = this.remaining;
        data["merchant"] = this.merchant;
        data["idMerchant"] = this.idMerchant;
        data["outlet"] = this.outlet;
        data["district"] = this.district;
        data["province"] = this.province;
        data["address"] = this.address;
        data["contactPerson"] = this.contactPerson;
        data["contactNo"] = this.contactNo;
        data["idTerminal"] = this.idTerminal;
        data["terminalType"] = this.terminalType;
        data["createdBy"] = this.createdBy;
        data["receivedBy"] = this.receivedBy;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["distributedDate"] = this.distributedDate;
        data["distributedBy"] = this.distributedBy;
        data["stockDateInString"] = this.stockDateInString;
        if (Array.isArray(this.spareList)) {
            data["spareList"] = [];
            for (let item of this.spareList)
                data["spareList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOtherStockAddViewModel {
    id?: string;
    deploymentRequestId?: string;
    deploymentRequest?: string | undefined;
    inventoryAddId?: string;
    inventoryAdd?: string | undefined;
    otherPartyId?: string | undefined;
    deployed?: number;
    otherParty?: string | undefined;
    stockDate?: Date;
    totalNumber?: number;
    buyDate?: Date;
    bankId?: string;
    bankName?: string | undefined;
    inventoryId?: string;
    inventory?: string | undefined;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    hasSerialNo?: boolean;
    partyName?: string | undefined;
    partyAddress?: string | undefined;
    phoneNo?: string | undefined;
    soldOut?: number;
    remarks?: string | undefined;
    remaining?: number;
    merchant?: string | undefined;
    idMerchant?: string | undefined;
    outlet?: string | undefined;
    district?: string | undefined;
    province?: string | undefined;
    address?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    idTerminal?: string | undefined;
    terminalType?: string | undefined;
    createdBy?: string | undefined;
    receivedBy?: string | undefined;
    updatedDate?: Date;
    distributedDate?: string | undefined;
    distributedBy?: string | undefined;
    stockDateInString?: string | undefined;
    spareList?: SpareListViewModel[] | undefined;
}

export class SpareListViewModel implements ISpareListViewModel {
    id?: string;
    soldOut?: number;
    remarks?: string | undefined;
    receivedBy?: string | undefined;
    distributedBy?: string | undefined;
    contactNo?: string | undefined;
    accessoryId?: string;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;

    constructor(data?: ISpareListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.soldOut = _data["soldOut"];
            this.remarks = _data["remarks"];
            this.receivedBy = _data["receivedBy"];
            this.distributedBy = _data["distributedBy"];
            this.contactNo = _data["contactNo"];
            this.accessoryId = _data["accessoryId"];
            this.primaryItem = _data["primaryItem"];
            this.secondaryItem = _data["secondaryItem"];
            this.tertiaryItem = _data["tertiaryItem"];
            this.detailItem = _data["detailItem"];
        }
    }

    static fromJS(data: any): SpareListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SpareListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["soldOut"] = this.soldOut;
        data["remarks"] = this.remarks;
        data["receivedBy"] = this.receivedBy;
        data["distributedBy"] = this.distributedBy;
        data["contactNo"] = this.contactNo;
        data["accessoryId"] = this.accessoryId;
        data["primaryItem"] = this.primaryItem;
        data["secondaryItem"] = this.secondaryItem;
        data["tertiaryItem"] = this.tertiaryItem;
        data["detailItem"] = this.detailItem;
        return data;
    }
}

export interface ISpareListViewModel {
    id?: string;
    soldOut?: number;
    remarks?: string | undefined;
    receivedBy?: string | undefined;
    distributedBy?: string | undefined;
    contactNo?: string | undefined;
    accessoryId?: string;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
}

export class PagedResponseOfTerminalAssociatedWithMerchantVM implements IPagedResponseOfTerminalAssociatedWithMerchantVM {
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    totalRecords?: number;
    data?: TerminalAssociatedWithMerchantVM[] | undefined;
    message?: string | undefined;
    errors?: string[] | undefined;
    succeeded?: boolean;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPagedResponseOfTerminalAssociatedWithMerchantVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TerminalAssociatedWithMerchantVM.fromJS(item));
            }
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.succeeded = _data["succeeded"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PagedResponseOfTerminalAssociatedWithMerchantVM {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfTerminalAssociatedWithMerchantVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["succeeded"] = this.succeeded;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPagedResponseOfTerminalAssociatedWithMerchantVM {
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    totalRecords?: number;
    data?: TerminalAssociatedWithMerchantVM[] | undefined;
    message?: string | undefined;
    errors?: string[] | undefined;
    succeeded?: boolean;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class TerminalAssociatedWithMerchantVM implements ITerminalAssociatedWithMerchantVM {
    merchantId?: string | undefined;
    merchantName?: string | undefined;
    address?: string | undefined;
    district?: string | undefined;
    province?: string | undefined;
    merchantCategory?: string | undefined;
    contactPerson?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    createdDate?: Date;
    terminals?: TerminalInfo[] | undefined;

    constructor(data?: ITerminalAssociatedWithMerchantVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.merchantId = _data["merchantId"];
            this.merchantName = _data["merchantName"];
            this.address = _data["address"];
            this.district = _data["district"];
            this.province = _data["province"];
            this.merchantCategory = _data["merchantCategory"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo1 = _data["contactNo1"];
            this.contactNo2 = _data["contactNo2"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["terminals"])) {
                this.terminals = [] as any;
                for (let item of _data["terminals"])
                    this.terminals!.push(TerminalInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TerminalAssociatedWithMerchantVM {
        data = typeof data === 'object' ? data : {};
        let result = new TerminalAssociatedWithMerchantVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["merchantId"] = this.merchantId;
        data["merchantName"] = this.merchantName;
        data["address"] = this.address;
        data["district"] = this.district;
        data["province"] = this.province;
        data["merchantCategory"] = this.merchantCategory;
        data["contactPerson"] = this.contactPerson;
        data["contactNo1"] = this.contactNo1;
        data["contactNo2"] = this.contactNo2;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        if (Array.isArray(this.terminals)) {
            data["terminals"] = [];
            for (let item of this.terminals)
                data["terminals"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITerminalAssociatedWithMerchantVM {
    merchantId?: string | undefined;
    merchantName?: string | undefined;
    address?: string | undefined;
    district?: string | undefined;
    province?: string | undefined;
    merchantCategory?: string | undefined;
    contactPerson?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    createdDate?: Date;
    terminals?: TerminalInfo[] | undefined;
}

export class TerminalInfo implements ITerminalInfo {
    deploymentRequestId?: string;
    idTerminal?: string | undefined;
    deploymentStatus?: string | undefined;
    address?: string | undefined;
    district?: string | undefined;
    isActive?: boolean;

    constructor(data?: ITerminalInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.idTerminal = _data["idTerminal"];
            this.deploymentStatus = _data["deploymentStatus"];
            this.address = _data["address"];
            this.district = _data["district"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TerminalInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TerminalInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["idTerminal"] = this.idTerminal;
        data["deploymentStatus"] = this.deploymentStatus;
        data["address"] = this.address;
        data["district"] = this.district;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ITerminalInfo {
    deploymentRequestId?: string;
    idTerminal?: string | undefined;
    deploymentStatus?: string | undefined;
    address?: string | undefined;
    district?: string | undefined;
    isActive?: boolean;
}

export class MerchantInformationVM implements IMerchantInformationVM {
    deploymentRequestId?: string;
    merchantName?: string | undefined;
    address?: string | undefined;
    district?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    contactPerson?: string | undefined;
    merchantCategory?: string | undefined;
    province?: string | undefined;
    deploymentStatus?: string | undefined;
    mcc?: string | undefined;

    constructor(data?: IMerchantInformationVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.merchantName = _data["merchantName"];
            this.address = _data["address"];
            this.district = _data["district"];
            this.contactNo1 = _data["contactNo1"];
            this.contactNo2 = _data["contactNo2"];
            this.contactPerson = _data["contactPerson"];
            this.merchantCategory = _data["merchantCategory"];
            this.province = _data["province"];
            this.deploymentStatus = _data["deploymentStatus"];
            this.mcc = _data["mcc"];
        }
    }

    static fromJS(data: any): MerchantInformationVM {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantInformationVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["merchantName"] = this.merchantName;
        data["address"] = this.address;
        data["district"] = this.district;
        data["contactNo1"] = this.contactNo1;
        data["contactNo2"] = this.contactNo2;
        data["contactPerson"] = this.contactPerson;
        data["merchantCategory"] = this.merchantCategory;
        data["province"] = this.province;
        data["deploymentStatus"] = this.deploymentStatus;
        data["mcc"] = this.mcc;
        return data;
    }
}

export interface IMerchantInformationVM {
    deploymentRequestId?: string;
    merchantName?: string | undefined;
    address?: string | undefined;
    district?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    contactPerson?: string | undefined;
    merchantCategory?: string | undefined;
    province?: string | undefined;
    deploymentStatus?: string | undefined;
    mcc?: string | undefined;
}

export class TerminalHeartbeatList implements ITerminalHeartbeatList {
    terminalHeartBeatList?: HeartBeatCallsList[] | undefined;

    constructor(data?: ITerminalHeartbeatList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["terminalHeartBeatList"])) {
                this.terminalHeartBeatList = [] as any;
                for (let item of _data["terminalHeartBeatList"])
                    this.terminalHeartBeatList!.push(HeartBeatCallsList.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TerminalHeartbeatList {
        data = typeof data === 'object' ? data : {};
        let result = new TerminalHeartbeatList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.terminalHeartBeatList)) {
            data["terminalHeartBeatList"] = [];
            for (let item of this.terminalHeartBeatList)
                data["terminalHeartBeatList"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITerminalHeartbeatList {
    terminalHeartBeatList?: HeartBeatCallsList[] | undefined;
}

export class HeartBeatCallsList implements IHeartBeatCallsList {
    terminalName?: string | undefined;
    signature?: string | undefined;
    isActive?: boolean;
    tmsCalls?: HeartbeatBasedOnSerialkey[] | undefined;

    constructor(data?: IHeartBeatCallsList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.terminalName = _data["terminalName"];
            this.signature = _data["signature"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["tmsCalls"])) {
                this.tmsCalls = [] as any;
                for (let item of _data["tmsCalls"])
                    this.tmsCalls!.push(HeartbeatBasedOnSerialkey.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HeartBeatCallsList {
        data = typeof data === 'object' ? data : {};
        let result = new HeartBeatCallsList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["terminalName"] = this.terminalName;
        data["signature"] = this.signature;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.tmsCalls)) {
            data["tmsCalls"] = [];
            for (let item of this.tmsCalls)
                data["tmsCalls"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHeartBeatCallsList {
    terminalName?: string | undefined;
    signature?: string | undefined;
    isActive?: boolean;
    tmsCalls?: HeartbeatBasedOnSerialkey[] | undefined;
}

export class HeartbeatBasedOnSerialkey implements IHeartbeatBasedOnSerialkey {
    terminalName?: string | undefined;
    callTime?: Date;
    lastHeartBeatDate?: string | undefined;
    lastHeartBeatTime?: string | undefined;

    constructor(data?: IHeartbeatBasedOnSerialkey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.terminalName = _data["terminalName"];
            this.callTime = _data["callTime"] ? new Date(_data["callTime"].toString()) : <any>undefined;
            this.lastHeartBeatDate = _data["lastHeartBeatDate"];
            this.lastHeartBeatTime = _data["lastHeartBeatTime"];
        }
    }

    static fromJS(data: any): HeartbeatBasedOnSerialkey {
        data = typeof data === 'object' ? data : {};
        let result = new HeartbeatBasedOnSerialkey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["terminalName"] = this.terminalName;
        data["callTime"] = this.callTime ? this.callTime.toISOString() : <any>undefined;
        data["lastHeartBeatDate"] = this.lastHeartBeatDate;
        data["lastHeartBeatTime"] = this.lastHeartBeatTime;
        return data;
    }
}

export interface IHeartbeatBasedOnSerialkey {
    terminalName?: string | undefined;
    callTime?: Date;
    lastHeartBeatDate?: string | undefined;
    lastHeartBeatTime?: string | undefined;
}

export class DeploymentRequestId implements IDeploymentRequestId {
    deploymentRequestId?: string | undefined;

    constructor(data?: IDeploymentRequestId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deploymentRequestId = _data["deploymentRequestId"];
        }
    }

    static fromJS(data: any): DeploymentRequestId {
        data = typeof data === 'object' ? data : {};
        let result = new DeploymentRequestId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deploymentRequestId"] = this.deploymentRequestId;
        return data;
    }
}

export interface IDeploymentRequestId {
    deploymentRequestId?: string | undefined;
}

export class TerminalInformationViewModel implements ITerminalInformationViewModel {
    brandName?: string | undefined;
    model?: string | undefined;
    serialNumber?: string | undefined;
    os?: string | undefined;
    ram?: string | undefined;
    rom?: string | undefined;
    property?: string | undefined;

    constructor(data?: ITerminalInformationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.brandName = _data["brandName"];
            this.model = _data["model"];
            this.serialNumber = _data["serialNumber"];
            this.os = _data["os"];
            this.ram = _data["ram"];
            this.rom = _data["rom"];
            this.property = _data["property"];
        }
    }

    static fromJS(data: any): TerminalInformationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TerminalInformationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brandName"] = this.brandName;
        data["model"] = this.model;
        data["serialNumber"] = this.serialNumber;
        data["os"] = this.os;
        data["ram"] = this.ram;
        data["rom"] = this.rom;
        data["property"] = this.property;
        return data;
    }
}

export interface ITerminalInformationViewModel {
    brandName?: string | undefined;
    model?: string | undefined;
    serialNumber?: string | undefined;
    os?: string | undefined;
    ram?: string | undefined;
    rom?: string | undefined;
    property?: string | undefined;
}

export class DeploymentInformationVM implements IDeploymentInformationVM {
    deployedDate?: string | undefined;
    deploymentBy?: string | undefined;
    applicationVersion?: string | undefined;
    connectivity?: string | undefined;
    receivedContactNo?: string | undefined;
    deployedAt?: string | undefined;
    receivedBy?: string | undefined;
    deploymentRequestsStatus?: string | undefined;

    constructor(data?: IDeploymentInformationVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deployedDate = _data["deployedDate"];
            this.deploymentBy = _data["deploymentBy"];
            this.applicationVersion = _data["applicationVersion"];
            this.connectivity = _data["connectivity"];
            this.receivedContactNo = _data["receivedContactNo"];
            this.deployedAt = _data["deployedAt"];
            this.receivedBy = _data["receivedBy"];
            this.deploymentRequestsStatus = _data["deploymentRequestsStatus"];
        }
    }

    static fromJS(data: any): DeploymentInformationVM {
        data = typeof data === 'object' ? data : {};
        let result = new DeploymentInformationVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deployedDate"] = this.deployedDate;
        data["deploymentBy"] = this.deploymentBy;
        data["applicationVersion"] = this.applicationVersion;
        data["connectivity"] = this.connectivity;
        data["receivedContactNo"] = this.receivedContactNo;
        data["deployedAt"] = this.deployedAt;
        data["receivedBy"] = this.receivedBy;
        data["deploymentRequestsStatus"] = this.deploymentRequestsStatus;
        return data;
    }
}

export interface IDeploymentInformationVM {
    deployedDate?: string | undefined;
    deploymentBy?: string | undefined;
    applicationVersion?: string | undefined;
    connectivity?: string | undefined;
    receivedContactNo?: string | undefined;
    deployedAt?: string | undefined;
    receivedBy?: string | undefined;
    deploymentRequestsStatus?: string | undefined;
}

export class MerchnatsHistoryVM implements IMerchnatsHistoryVM {
    issue?: string | undefined;
    supportCreateDate?: string | undefined;
    supportCreateBy?: string | undefined;
    supportDate?: string | undefined;
    resolvedDate?: string | undefined;
    updatedDate?: string | undefined;
    remarks?: string | undefined;
    resolvedRemarks?: string | undefined;
    supportType?: string | undefined;
    resolvedBy?: string | undefined;
    updatedBy?: string | undefined;
    statusSupport?: string | undefined;
    createDate?: Date | undefined;

    constructor(data?: IMerchnatsHistoryVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issue = _data["issue"];
            this.supportCreateDate = _data["supportCreateDate"];
            this.supportCreateBy = _data["supportCreateBy"];
            this.supportDate = _data["supportDate"];
            this.resolvedDate = _data["resolvedDate"];
            this.updatedDate = _data["updatedDate"];
            this.remarks = _data["remarks"];
            this.resolvedRemarks = _data["resolvedRemarks"];
            this.supportType = _data["supportType"];
            this.resolvedBy = _data["resolvedBy"];
            this.updatedBy = _data["updatedBy"];
            this.statusSupport = _data["statusSupport"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MerchnatsHistoryVM {
        data = typeof data === 'object' ? data : {};
        let result = new MerchnatsHistoryVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issue"] = this.issue;
        data["supportCreateDate"] = this.supportCreateDate;
        data["supportCreateBy"] = this.supportCreateBy;
        data["supportDate"] = this.supportDate;
        data["resolvedDate"] = this.resolvedDate;
        data["updatedDate"] = this.updatedDate;
        data["remarks"] = this.remarks;
        data["resolvedRemarks"] = this.resolvedRemarks;
        data["supportType"] = this.supportType;
        data["resolvedBy"] = this.resolvedBy;
        data["updatedBy"] = this.updatedBy;
        data["statusSupport"] = this.statusSupport;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMerchnatsHistoryVM {
    issue?: string | undefined;
    supportCreateDate?: string | undefined;
    supportCreateBy?: string | undefined;
    supportDate?: string | undefined;
    resolvedDate?: string | undefined;
    updatedDate?: string | undefined;
    remarks?: string | undefined;
    resolvedRemarks?: string | undefined;
    supportType?: string | undefined;
    resolvedBy?: string | undefined;
    updatedBy?: string | undefined;
    statusSupport?: string | undefined;
    createDate?: Date | undefined;
}

export class MerchantsAccessoriesHistoryVM implements IMerchantsAccessoriesHistoryVM {
    accessoriesItemName?: string | undefined;
    createdDate?: Date | undefined;
    accessoriesCreateDate?: string | undefined;
    createBy?: string | undefined;
    requestQty?: number;
    dispatchQty?: number;
    dispatchDate?: string | undefined;
    dispatchBy?: string | undefined;
    spareRequestStatus?: string | undefined;

    constructor(data?: IMerchantsAccessoriesHistoryVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessoriesItemName = _data["accessoriesItemName"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.accessoriesCreateDate = _data["accessoriesCreateDate"];
            this.createBy = _data["createBy"];
            this.requestQty = _data["requestQty"];
            this.dispatchQty = _data["dispatchQty"];
            this.dispatchDate = _data["dispatchDate"];
            this.dispatchBy = _data["dispatchBy"];
            this.spareRequestStatus = _data["spareRequestStatus"];
        }
    }

    static fromJS(data: any): MerchantsAccessoriesHistoryVM {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantsAccessoriesHistoryVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessoriesItemName"] = this.accessoriesItemName;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["accessoriesCreateDate"] = this.accessoriesCreateDate;
        data["createBy"] = this.createBy;
        data["requestQty"] = this.requestQty;
        data["dispatchQty"] = this.dispatchQty;
        data["dispatchDate"] = this.dispatchDate;
        data["dispatchBy"] = this.dispatchBy;
        data["spareRequestStatus"] = this.spareRequestStatus;
        return data;
    }
}

export interface IMerchantsAccessoriesHistoryVM {
    accessoriesItemName?: string | undefined;
    createdDate?: Date | undefined;
    accessoriesCreateDate?: string | undefined;
    createBy?: string | undefined;
    requestQty?: number;
    dispatchQty?: number;
    dispatchDate?: string | undefined;
    dispatchBy?: string | undefined;
    spareRequestStatus?: string | undefined;
}

export class ImarkMidAndTidViewModel implements IImarkMidAndTidViewModel {
    iMid?: number;
    iTid?: number;

    constructor(data?: IImarkMidAndTidViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iMid = _data["iMid"];
            this.iTid = _data["iTid"];
        }
    }

    static fromJS(data: any): ImarkMidAndTidViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImarkMidAndTidViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iMid"] = this.iMid;
        data["iTid"] = this.iTid;
        return data;
    }
}

export interface IImarkMidAndTidViewModel {
    iMid?: number;
    iTid?: number;
}

export class MerchantsOtherHistoryVM implements IMerchantsOtherHistoryVM {
    requestName?: string | undefined;
    remarks?: string | undefined;
    otherCreatedDate?: string | undefined;
    createdDate?: Date | undefined;
    statusName?: string | undefined;
    createdBy?: string | undefined;

    constructor(data?: IMerchantsOtherHistoryVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestName = _data["requestName"];
            this.remarks = _data["remarks"];
            this.otherCreatedDate = _data["otherCreatedDate"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.statusName = _data["statusName"];
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): MerchantsOtherHistoryVM {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantsOtherHistoryVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestName"] = this.requestName;
        data["remarks"] = this.remarks;
        data["otherCreatedDate"] = this.otherCreatedDate;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["statusName"] = this.statusName;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface IMerchantsOtherHistoryVM {
    requestName?: string | undefined;
    remarks?: string | undefined;
    otherCreatedDate?: string | undefined;
    createdDate?: Date | undefined;
    statusName?: string | undefined;
    createdBy?: string | undefined;
}

export class MerchantConfigurationVM implements IMerchantConfigurationVM {
    id?: string;
    bankId?: string;
    idTerminal?: string | undefined;
    idMerchant?: string | undefined;
    currency?: string | undefined;
    cashAdvance?: boolean;
    tipAdjustment?: boolean;
    pinChange?: boolean;
    preAuthorization?: boolean;
    manualTransaction?: boolean;
    isConfigurations?: boolean;

    constructor(data?: IMerchantConfigurationVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bankId = _data["bankId"];
            this.idTerminal = _data["idTerminal"];
            this.idMerchant = _data["idMerchant"];
            this.currency = _data["currency"];
            this.cashAdvance = _data["cashAdvance"];
            this.tipAdjustment = _data["tipAdjustment"];
            this.pinChange = _data["pinChange"];
            this.preAuthorization = _data["preAuthorization"];
            this.manualTransaction = _data["manualTransaction"];
            this.isConfigurations = _data["isConfigurations"];
        }
    }

    static fromJS(data: any): MerchantConfigurationVM {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantConfigurationVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankId"] = this.bankId;
        data["idTerminal"] = this.idTerminal;
        data["idMerchant"] = this.idMerchant;
        data["currency"] = this.currency;
        data["cashAdvance"] = this.cashAdvance;
        data["tipAdjustment"] = this.tipAdjustment;
        data["pinChange"] = this.pinChange;
        data["preAuthorization"] = this.preAuthorization;
        data["manualTransaction"] = this.manualTransaction;
        data["isConfigurations"] = this.isConfigurations;
        return data;
    }
}

export interface IMerchantConfigurationVM {
    id?: string;
    bankId?: string;
    idTerminal?: string | undefined;
    idMerchant?: string | undefined;
    currency?: string | undefined;
    cashAdvance?: boolean;
    tipAdjustment?: boolean;
    pinChange?: boolean;
    preAuthorization?: boolean;
    manualTransaction?: boolean;
    isConfigurations?: boolean;
}

export class UpdateMerchantConfigurationCommand implements IUpdateMerchantConfigurationCommand {
    id?: string;
    idTerminal?: string | undefined;
    idMerchant?: string | undefined;
    currency?: string | undefined;
    cashAdvance?: boolean;
    tipAdjustment?: boolean;
    preAuthorization?: boolean;
    manualTransaction?: boolean;
    bankId?: string | undefined;

    constructor(data?: IUpdateMerchantConfigurationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idTerminal = _data["idTerminal"];
            this.idMerchant = _data["idMerchant"];
            this.currency = _data["currency"];
            this.cashAdvance = _data["cashAdvance"];
            this.tipAdjustment = _data["tipAdjustment"];
            this.preAuthorization = _data["preAuthorization"];
            this.manualTransaction = _data["manualTransaction"];
            this.bankId = _data["bankId"];
        }
    }

    static fromJS(data: any): UpdateMerchantConfigurationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMerchantConfigurationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idTerminal"] = this.idTerminal;
        data["idMerchant"] = this.idMerchant;
        data["currency"] = this.currency;
        data["cashAdvance"] = this.cashAdvance;
        data["tipAdjustment"] = this.tipAdjustment;
        data["preAuthorization"] = this.preAuthorization;
        data["manualTransaction"] = this.manualTransaction;
        data["bankId"] = this.bankId;
        return data;
    }
}

export interface IUpdateMerchantConfigurationCommand {
    id?: string;
    idTerminal?: string | undefined;
    idMerchant?: string | undefined;
    currency?: string | undefined;
    cashAdvance?: boolean;
    tipAdjustment?: boolean;
    preAuthorization?: boolean;
    manualTransaction?: boolean;
    bankId?: string | undefined;
}

export class MerchantLocationInformationVM implements IMerchantLocationInformationVM {
    latitude?: string | undefined;
    longitude?: string | undefined;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    merchantLocation?: string | undefined;

    constructor(data?: IMerchantLocationInformationVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.idMerchant = _data["idMerchant"];
            this.idTerminal = _data["idTerminal"];
            this.merchantLocation = _data["merchantLocation"];
        }
    }

    static fromJS(data: any): MerchantLocationInformationVM {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantLocationInformationVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["idMerchant"] = this.idMerchant;
        data["idTerminal"] = this.idTerminal;
        data["merchantLocation"] = this.merchantLocation;
        return data;
    }
}

export interface IMerchantLocationInformationVM {
    latitude?: string | undefined;
    longitude?: string | undefined;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    merchantLocation?: string | undefined;
}

export class ImarkTerminalAddCommands implements IImarkTerminalAddCommands {
    deploymentRequestId?: string;
    paymentProviderData?: CardPaymentServiceData | undefined;
    fonepayPaymentData?: FonePayPaymentServiceData | undefined;
    nepalpayPaymentData?: NepalPayPaymentServiceData | undefined;

    constructor(data?: IImarkTerminalAddCommands) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.paymentProviderData = _data["paymentProviderData"] ? CardPaymentServiceData.fromJS(_data["paymentProviderData"]) : <any>undefined;
            this.fonepayPaymentData = _data["fonepayPaymentData"] ? FonePayPaymentServiceData.fromJS(_data["fonepayPaymentData"]) : <any>undefined;
            this.nepalpayPaymentData = _data["nepalpayPaymentData"] ? NepalPayPaymentServiceData.fromJS(_data["nepalpayPaymentData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ImarkTerminalAddCommands {
        data = typeof data === 'object' ? data : {};
        let result = new ImarkTerminalAddCommands();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["paymentProviderData"] = this.paymentProviderData ? this.paymentProviderData.toJSON() : <any>undefined;
        data["fonepayPaymentData"] = this.fonepayPaymentData ? this.fonepayPaymentData.toJSON() : <any>undefined;
        data["nepalpayPaymentData"] = this.nepalpayPaymentData ? this.nepalpayPaymentData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IImarkTerminalAddCommands {
    deploymentRequestId?: string;
    paymentProviderData?: CardPaymentServiceData | undefined;
    fonepayPaymentData?: FonePayPaymentServiceData | undefined;
    nepalpayPaymentData?: NepalPayPaymentServiceData | undefined;
}

export class CardPaymentServiceData implements ICardPaymentServiceData {
    paymentScheme?: PaymentScheme;
    terminalId?: string | undefined;
    merchantId?: string | undefined;
    currency?: string | undefined;
    cashAdvance?: boolean;
    tipAdjustment?: boolean;
    manualTransaction?: boolean;
    preAuthorization?: boolean;

    constructor(data?: ICardPaymentServiceData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentScheme = _data["paymentScheme"];
            this.terminalId = _data["terminalId"];
            this.merchantId = _data["merchantId"];
            this.currency = _data["currency"];
            this.cashAdvance = _data["cashAdvance"];
            this.tipAdjustment = _data["tipAdjustment"];
            this.manualTransaction = _data["manualTransaction"];
            this.preAuthorization = _data["preAuthorization"];
        }
    }

    static fromJS(data: any): CardPaymentServiceData {
        data = typeof data === 'object' ? data : {};
        let result = new CardPaymentServiceData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentScheme"] = this.paymentScheme;
        data["terminalId"] = this.terminalId;
        data["merchantId"] = this.merchantId;
        data["currency"] = this.currency;
        data["cashAdvance"] = this.cashAdvance;
        data["tipAdjustment"] = this.tipAdjustment;
        data["manualTransaction"] = this.manualTransaction;
        data["preAuthorization"] = this.preAuthorization;
        return data;
    }
}

export interface ICardPaymentServiceData {
    paymentScheme?: PaymentScheme;
    terminalId?: string | undefined;
    merchantId?: string | undefined;
    currency?: string | undefined;
    cashAdvance?: boolean;
    tipAdjustment?: boolean;
    manualTransaction?: boolean;
    preAuthorization?: boolean;
}

export class FonePayPaymentServiceData implements IFonePayPaymentServiceData {
    paymentScheme?: PaymentScheme;
    terminalId?: string | undefined;
    merchantId?: string | undefined;
    currency?: string | undefined;
    merchantCategoryCode?: string | undefined;
    merchantCode?: string | undefined;
    secretKey?: string | undefined;

    constructor(data?: IFonePayPaymentServiceData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentScheme = _data["paymentScheme"];
            this.terminalId = _data["terminalId"];
            this.merchantId = _data["merchantId"];
            this.currency = _data["currency"];
            this.merchantCategoryCode = _data["merchantCategoryCode"];
            this.merchantCode = _data["merchantCode"];
            this.secretKey = _data["secretKey"];
        }
    }

    static fromJS(data: any): FonePayPaymentServiceData {
        data = typeof data === 'object' ? data : {};
        let result = new FonePayPaymentServiceData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentScheme"] = this.paymentScheme;
        data["terminalId"] = this.terminalId;
        data["merchantId"] = this.merchantId;
        data["currency"] = this.currency;
        data["merchantCategoryCode"] = this.merchantCategoryCode;
        data["merchantCode"] = this.merchantCode;
        data["secretKey"] = this.secretKey;
        return data;
    }
}

export interface IFonePayPaymentServiceData {
    paymentScheme?: PaymentScheme;
    terminalId?: string | undefined;
    merchantId?: string | undefined;
    currency?: string | undefined;
    merchantCategoryCode?: string | undefined;
    merchantCode?: string | undefined;
    secretKey?: string | undefined;
}

export class NepalPayPaymentServiceData implements INepalPayPaymentServiceData {
    paymentScheme?: PaymentScheme;
    terminalId?: string | undefined;
    merchantId?: string | undefined;
    currency?: string | undefined;
    merchantCategoryCode?: string | undefined;
    merchantStatus?: string | undefined;
    merchantPanNumber?: string | undefined;
    merchantName?: string | undefined;
    merchantAddress?: string | undefined;
    acquireInstrument?: string | undefined;

    constructor(data?: INepalPayPaymentServiceData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentScheme = _data["paymentScheme"];
            this.terminalId = _data["terminalId"];
            this.merchantId = _data["merchantId"];
            this.currency = _data["currency"];
            this.merchantCategoryCode = _data["merchantCategoryCode"];
            this.merchantStatus = _data["merchantStatus"];
            this.merchantPanNumber = _data["merchantPanNumber"];
            this.merchantName = _data["merchantName"];
            this.merchantAddress = _data["merchantAddress"];
            this.acquireInstrument = _data["acquireInstrument"];
        }
    }

    static fromJS(data: any): NepalPayPaymentServiceData {
        data = typeof data === 'object' ? data : {};
        let result = new NepalPayPaymentServiceData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentScheme"] = this.paymentScheme;
        data["terminalId"] = this.terminalId;
        data["merchantId"] = this.merchantId;
        data["currency"] = this.currency;
        data["merchantCategoryCode"] = this.merchantCategoryCode;
        data["merchantStatus"] = this.merchantStatus;
        data["merchantPanNumber"] = this.merchantPanNumber;
        data["merchantName"] = this.merchantName;
        data["merchantAddress"] = this.merchantAddress;
        data["acquireInstrument"] = this.acquireInstrument;
        return data;
    }
}

export interface INepalPayPaymentServiceData {
    paymentScheme?: PaymentScheme;
    terminalId?: string | undefined;
    merchantId?: string | undefined;
    currency?: string | undefined;
    merchantCategoryCode?: string | undefined;
    merchantStatus?: string | undefined;
    merchantPanNumber?: string | undefined;
    merchantName?: string | undefined;
    merchantAddress?: string | undefined;
    acquireInstrument?: string | undefined;
}

export class PaginatedListOfCardPersoRequestVm implements IPaginatedListOfCardPersoRequestVm {
    items?: CardPersoRequestVm[] | undefined;
    pageSize?: number;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfCardPersoRequestVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CardPersoRequestVm.fromJS(item));
            }
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfCardPersoRequestVm {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfCardPersoRequestVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfCardPersoRequestVm {
    items?: CardPersoRequestVm[] | undefined;
    pageSize?: number;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class CardPersoRequestVm implements ICardPersoRequestVm {
    id?: number;
    cardProductId?: number;
    totalRequested?: number;
    totalDamaged?: number;
    pending?: number;
    cardName?: string | undefined;
    totalPrinted?: number;
    fileName?: string | undefined;
    bankId?: string;
    hardwareId?: string;
    bureauId?: string;
    bureauName?: string | undefined;
    bankName?: string | undefined;
    productCode?: string | undefined;
    productName?: string | undefined;
    productType?: string | undefined;
    productBrand?: string | undefined;
    createdBy?: string | undefined;
    createdDate?: Date;
    requestDate?: string | undefined;
    hardware?: string | undefined;

    constructor(data?: ICardPersoRequestVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cardProductId = _data["cardProductId"];
            this.totalRequested = _data["totalRequested"];
            this.totalDamaged = _data["totalDamaged"];
            this.pending = _data["pending"];
            this.cardName = _data["cardName"];
            this.totalPrinted = _data["totalPrinted"];
            this.fileName = _data["fileName"];
            this.bankId = _data["bankId"];
            this.hardwareId = _data["hardwareId"];
            this.bureauId = _data["bureauId"];
            this.bureauName = _data["bureauName"];
            this.bankName = _data["bankName"];
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.productType = _data["productType"];
            this.productBrand = _data["productBrand"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.requestDate = _data["requestDate"];
            this.hardware = _data["hardware"];
        }
    }

    static fromJS(data: any): CardPersoRequestVm {
        data = typeof data === 'object' ? data : {};
        let result = new CardPersoRequestVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cardProductId"] = this.cardProductId;
        data["totalRequested"] = this.totalRequested;
        data["totalDamaged"] = this.totalDamaged;
        data["pending"] = this.pending;
        data["cardName"] = this.cardName;
        data["totalPrinted"] = this.totalPrinted;
        data["fileName"] = this.fileName;
        data["bankId"] = this.bankId;
        data["hardwareId"] = this.hardwareId;
        data["bureauId"] = this.bureauId;
        data["bureauName"] = this.bureauName;
        data["bankName"] = this.bankName;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["productType"] = this.productType;
        data["productBrand"] = this.productBrand;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["requestDate"] = this.requestDate;
        data["hardware"] = this.hardware;
        return data;
    }
}

export interface ICardPersoRequestVm {
    id?: number;
    cardProductId?: number;
    totalRequested?: number;
    totalDamaged?: number;
    pending?: number;
    cardName?: string | undefined;
    totalPrinted?: number;
    fileName?: string | undefined;
    bankId?: string;
    hardwareId?: string;
    bureauId?: string;
    bureauName?: string | undefined;
    bankName?: string | undefined;
    productCode?: string | undefined;
    productName?: string | undefined;
    productType?: string | undefined;
    productBrand?: string | undefined;
    createdBy?: string | undefined;
    createdDate?: Date;
    requestDate?: string | undefined;
    hardware?: string | undefined;
}

export class CustomizedValidationError implements ICustomizedValidationError {
    validatorKey?: string | undefined;
    message?: string | undefined;

    constructor(data?: ICustomizedValidationError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.validatorKey = _data["validatorKey"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): CustomizedValidationError {
        data = typeof data === 'object' ? data : {};
        let result = new CustomizedValidationError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validatorKey"] = this.validatorKey;
        data["message"] = this.message;
        return data;
    }
}

export interface ICustomizedValidationError {
    validatorKey?: string | undefined;
    message?: string | undefined;
}

export class PaginatedListOfHardwareListBanksVm implements IPaginatedListOfHardwareListBanksVm {
    items?: HardwareListBanksVm[] | undefined;
    pageSize?: number;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfHardwareListBanksVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HardwareListBanksVm.fromJS(item));
            }
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfHardwareListBanksVm {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfHardwareListBanksVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfHardwareListBanksVm {
    items?: HardwareListBanksVm[] | undefined;
    pageSize?: number;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class HardwareListBanksVm implements IHardwareListBanksVm {
    id?: string;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    serialNo?: string | undefined;
    purchaseDate?: Date;
    manufacturer?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    bankId?: string;
    bankName?: string | undefined;
    purDate?: string | undefined;

    constructor(data?: IHardwareListBanksVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.primaryItem = _data["primaryItem"];
            this.secondaryItem = _data["secondaryItem"];
            this.tertiaryItem = _data["tertiaryItem"];
            this.detailItem = _data["detailItem"];
            this.serialNo = _data["serialNo"];
            this.purchaseDate = _data["purchaseDate"] ? new Date(_data["purchaseDate"].toString()) : <any>undefined;
            this.manufacturer = _data["manufacturer"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo = _data["contactNo"];
            this.bankId = _data["bankId"];
            this.bankName = _data["bankName"];
            this.purDate = _data["purDate"];
        }
    }

    static fromJS(data: any): HardwareListBanksVm {
        data = typeof data === 'object' ? data : {};
        let result = new HardwareListBanksVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["primaryItem"] = this.primaryItem;
        data["secondaryItem"] = this.secondaryItem;
        data["tertiaryItem"] = this.tertiaryItem;
        data["detailItem"] = this.detailItem;
        data["serialNo"] = this.serialNo;
        data["purchaseDate"] = this.purchaseDate ? this.purchaseDate.toISOString() : <any>undefined;
        data["manufacturer"] = this.manufacturer;
        data["contactPerson"] = this.contactPerson;
        data["contactNo"] = this.contactNo;
        data["bankId"] = this.bankId;
        data["bankName"] = this.bankName;
        data["purDate"] = this.purDate;
        return data;
    }
}

export interface IHardwareListBanksVm {
    id?: string;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    serialNo?: string | undefined;
    purchaseDate?: Date;
    manufacturer?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    bankId?: string;
    bankName?: string | undefined;
    purDate?: string | undefined;
}

export class PaginatedListOfCardProductViewModel implements IPaginatedListOfCardProductViewModel {
    items?: CardProductViewModel[] | undefined;
    pageSize?: number;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfCardProductViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CardProductViewModel.fromJS(item));
            }
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfCardProductViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfCardProductViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfCardProductViewModel {
    items?: CardProductViewModel[] | undefined;
    pageSize?: number;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class PaginatedListOfBureauDetail implements IPaginatedListOfBureauDetail {
    items?: BureauDetail[] | undefined;
    pageSize?: number;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfBureauDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BureauDetail.fromJS(item));
            }
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfBureauDetail {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfBureauDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfBureauDetail {
    items?: BureauDetail[] | undefined;
    pageSize?: number;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class CreateCardRequestCommand implements ICreateCardRequestCommand {
    id?: number;
    cardProductId?: number;
    bId?: string | undefined;
    bureauId?: string;
    totalRequested?: number;
    fileName?: string | undefined;

    constructor(data?: ICreateCardRequestCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cardProductId = _data["cardProductId"];
            this.bId = _data["bId"];
            this.bureauId = _data["bureauId"];
            this.totalRequested = _data["totalRequested"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): CreateCardRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCardRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cardProductId"] = this.cardProductId;
        data["bId"] = this.bId;
        data["bureauId"] = this.bureauId;
        data["totalRequested"] = this.totalRequested;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface ICreateCardRequestCommand {
    id?: number;
    cardProductId?: number;
    bId?: string | undefined;
    bureauId?: string;
    totalRequested?: number;
    fileName?: string | undefined;
}

export class CardRequestTransactionViewModel implements ICardRequestTransactionViewModel {
    id?: number;
    bankId?: string;
    bankName?: string | undefined;
    cardProductName?: string | undefined;
    cardProductId?: number;
    hardwareName?: string | undefined;
    cardRequestId?: number;
    hardwareId?: string;
    totalPrinted?: number;
    totalRequested?: number;
    totalDamaged?: number;
    checkIn?: string;
    checkOut?: string;
    pending?: number;
    productCode?: string | undefined;
    productName?: string | undefined;
    productType?: string | undefined;
    productBrand?: string | undefined;
    createdBy?: string | undefined;
    requestDate?: string | undefined;
    printedDate?: string | undefined;
    bureauId?: string;
    bureauName?: string | undefined;
    ticketNumber?: string | undefined;

    constructor(data?: ICardRequestTransactionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bankId = _data["bankId"];
            this.bankName = _data["bankName"];
            this.cardProductName = _data["cardProductName"];
            this.cardProductId = _data["cardProductId"];
            this.hardwareName = _data["hardwareName"];
            this.cardRequestId = _data["cardRequestId"];
            this.hardwareId = _data["hardwareId"];
            this.totalPrinted = _data["totalPrinted"];
            this.totalRequested = _data["totalRequested"];
            this.totalDamaged = _data["totalDamaged"];
            this.checkIn = _data["checkIn"];
            this.checkOut = _data["checkOut"];
            this.pending = _data["pending"];
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.productType = _data["productType"];
            this.productBrand = _data["productBrand"];
            this.createdBy = _data["createdBy"];
            this.requestDate = _data["requestDate"];
            this.printedDate = _data["printedDate"];
            this.bureauId = _data["bureauId"];
            this.bureauName = _data["bureauName"];
            this.ticketNumber = _data["ticketNumber"];
        }
    }

    static fromJS(data: any): CardRequestTransactionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CardRequestTransactionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankId"] = this.bankId;
        data["bankName"] = this.bankName;
        data["cardProductName"] = this.cardProductName;
        data["cardProductId"] = this.cardProductId;
        data["hardwareName"] = this.hardwareName;
        data["cardRequestId"] = this.cardRequestId;
        data["hardwareId"] = this.hardwareId;
        data["totalPrinted"] = this.totalPrinted;
        data["totalRequested"] = this.totalRequested;
        data["totalDamaged"] = this.totalDamaged;
        data["checkIn"] = this.checkIn;
        data["checkOut"] = this.checkOut;
        data["pending"] = this.pending;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["productType"] = this.productType;
        data["productBrand"] = this.productBrand;
        data["createdBy"] = this.createdBy;
        data["requestDate"] = this.requestDate;
        data["printedDate"] = this.printedDate;
        data["bureauId"] = this.bureauId;
        data["bureauName"] = this.bureauName;
        data["ticketNumber"] = this.ticketNumber;
        return data;
    }
}

export interface ICardRequestTransactionViewModel {
    id?: number;
    bankId?: string;
    bankName?: string | undefined;
    cardProductName?: string | undefined;
    cardProductId?: number;
    hardwareName?: string | undefined;
    cardRequestId?: number;
    hardwareId?: string;
    totalPrinted?: number;
    totalRequested?: number;
    totalDamaged?: number;
    checkIn?: string;
    checkOut?: string;
    pending?: number;
    productCode?: string | undefined;
    productName?: string | undefined;
    productType?: string | undefined;
    productBrand?: string | undefined;
    createdBy?: string | undefined;
    requestDate?: string | undefined;
    printedDate?: string | undefined;
    bureauId?: string;
    bureauName?: string | undefined;
    ticketNumber?: string | undefined;
}

export class CheckerViewModel implements ICheckerViewModel {
    id?: string;
    name?: string | undefined;

    constructor(data?: ICheckerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CheckerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CheckerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ICheckerViewModel {
    id?: string;
    name?: string | undefined;
}

export class ConfigurationViewModel implements IConfigurationViewModel {
    id?: string;
    deploymentRequestId?: string;
    verification?: string | undefined;
    serialNumberId?: string;
    serialKey?: string | undefined;
    isSale?: boolean;
    previousSerial?: string | undefined;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    applicationVersionId?: string;
    bankCode?: string | undefined;
    applicationDate?: Date | undefined;
    applicationVersion?: string | undefined;
    kernelType?: string | undefined;
    remarks?: string | undefined;
    statusName?: string | undefined;
    inventoryId?: string;
    inventoryAddId?: string;
    status?: string | undefined;
    requestName?: string | undefined;
    version?: string | undefined;
    totalConfigSerial?: number;
    contactOfPos?: string | undefined;
    limit?: string | undefined;
    isReplacementRequired?: boolean;
    isMaintenanceRequired?: boolean;
    isReceivedPreviousSerial?: boolean;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;

    constructor(data?: IConfigurationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.verification = _data["verification"];
            this.serialNumberId = _data["serialNumberId"];
            this.serialKey = _data["serialKey"];
            this.isSale = _data["isSale"];
            this.previousSerial = _data["previousSerial"];
            this.primaryItem = _data["primaryItem"];
            this.secondaryItem = _data["secondaryItem"];
            this.tertiaryItem = _data["tertiaryItem"];
            this.detailItem = _data["detailItem"];
            this.applicationVersionId = _data["applicationVersionId"];
            this.bankCode = _data["bankCode"];
            this.applicationDate = _data["applicationDate"] ? new Date(_data["applicationDate"].toString()) : <any>undefined;
            this.applicationVersion = _data["applicationVersion"];
            this.kernelType = _data["kernelType"];
            this.remarks = _data["remarks"];
            this.statusName = _data["statusName"];
            this.inventoryId = _data["inventoryId"];
            this.inventoryAddId = _data["inventoryAddId"];
            this.status = _data["status"];
            this.requestName = _data["requestName"];
            this.version = _data["version"];
            this.totalConfigSerial = _data["totalConfigSerial"];
            this.contactOfPos = _data["contactOfPos"];
            this.limit = _data["limit"];
            this.isReplacementRequired = _data["isReplacementRequired"];
            this.isMaintenanceRequired = _data["isMaintenanceRequired"];
            this.isReceivedPreviousSerial = _data["isReceivedPreviousSerial"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo = _data["contactNo"];
        }
    }

    static fromJS(data: any): ConfigurationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["verification"] = this.verification;
        data["serialNumberId"] = this.serialNumberId;
        data["serialKey"] = this.serialKey;
        data["isSale"] = this.isSale;
        data["previousSerial"] = this.previousSerial;
        data["primaryItem"] = this.primaryItem;
        data["secondaryItem"] = this.secondaryItem;
        data["tertiaryItem"] = this.tertiaryItem;
        data["detailItem"] = this.detailItem;
        data["applicationVersionId"] = this.applicationVersionId;
        data["bankCode"] = this.bankCode;
        data["applicationDate"] = this.applicationDate ? this.applicationDate.toISOString() : <any>undefined;
        data["applicationVersion"] = this.applicationVersion;
        data["kernelType"] = this.kernelType;
        data["remarks"] = this.remarks;
        data["statusName"] = this.statusName;
        data["inventoryId"] = this.inventoryId;
        data["inventoryAddId"] = this.inventoryAddId;
        data["status"] = this.status;
        data["requestName"] = this.requestName;
        data["version"] = this.version;
        data["totalConfigSerial"] = this.totalConfigSerial;
        data["contactOfPos"] = this.contactOfPos;
        data["limit"] = this.limit;
        data["isReplacementRequired"] = this.isReplacementRequired;
        data["isMaintenanceRequired"] = this.isMaintenanceRequired;
        data["isReceivedPreviousSerial"] = this.isReceivedPreviousSerial;
        data["contactPerson"] = this.contactPerson;
        data["contactNo"] = this.contactNo;
        return data;
    }
}

export interface IConfigurationViewModel {
    id?: string;
    deploymentRequestId?: string;
    verification?: string | undefined;
    serialNumberId?: string;
    serialKey?: string | undefined;
    isSale?: boolean;
    previousSerial?: string | undefined;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    applicationVersionId?: string;
    bankCode?: string | undefined;
    applicationDate?: Date | undefined;
    applicationVersion?: string | undefined;
    kernelType?: string | undefined;
    remarks?: string | undefined;
    statusName?: string | undefined;
    inventoryId?: string;
    inventoryAddId?: string;
    status?: string | undefined;
    requestName?: string | undefined;
    version?: string | undefined;
    totalConfigSerial?: number;
    contactOfPos?: string | undefined;
    limit?: string | undefined;
    isReplacementRequired?: boolean;
    isMaintenanceRequired?: boolean;
    isReceivedPreviousSerial?: boolean;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
}

export class ApiResponseOfString implements IApiResponseOfString {
    success?: boolean;
    status?: string | undefined;
    message?: string | undefined;
    data?: string | undefined;

    constructor(data?: IApiResponseOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): ApiResponseOfString {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data;
        return data;
    }
}

export interface IApiResponseOfString {
    success?: boolean;
    status?: string | undefined;
    message?: string | undefined;
    data?: string | undefined;
}

export class CreateConfigurationCommand implements ICreateConfigurationCommand {
    applicationVersionId?: string;
    deploymentRequestId?: string;
    inventoryAddId?: string;
    inventoryId?: string;
    serialNumberId?: string;
    previousSerial?: string | undefined;
    rentalInventoryAdd?: string | undefined;
    serialKey?: string | undefined;
    contactOfPos?: string | undefined;
    limit?: string | undefined;

    constructor(data?: ICreateConfigurationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationVersionId = _data["applicationVersionId"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.inventoryAddId = _data["inventoryAddId"];
            this.inventoryId = _data["inventoryId"];
            this.serialNumberId = _data["serialNumberId"];
            this.previousSerial = _data["previousSerial"];
            this.rentalInventoryAdd = _data["rentalInventoryAdd"];
            this.serialKey = _data["serialKey"];
            this.contactOfPos = _data["contactOfPos"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): CreateConfigurationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateConfigurationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationVersionId"] = this.applicationVersionId;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["inventoryAddId"] = this.inventoryAddId;
        data["inventoryId"] = this.inventoryId;
        data["serialNumberId"] = this.serialNumberId;
        data["previousSerial"] = this.previousSerial;
        data["rentalInventoryAdd"] = this.rentalInventoryAdd;
        data["serialKey"] = this.serialKey;
        data["contactOfPos"] = this.contactOfPos;
        data["limit"] = this.limit;
        return data;
    }
}

export interface ICreateConfigurationCommand {
    applicationVersionId?: string;
    deploymentRequestId?: string;
    inventoryAddId?: string;
    inventoryId?: string;
    serialNumberId?: string;
    previousSerial?: string | undefined;
    rentalInventoryAdd?: string | undefined;
    serialKey?: string | undefined;
    contactOfPos?: string | undefined;
    limit?: string | undefined;
}

export class CustomerViewModel implements ICustomerViewModel {
    id?: number;
    name?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    gender?: string | undefined;
    orders?: OrderViewModel[] | undefined;

    constructor(data?: ICustomerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.gender = _data["gender"];
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(OrderViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["address"] = this.address;
        data["city"] = this.city;
        data["gender"] = this.gender;
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomerViewModel {
    id?: number;
    name?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    gender?: string | undefined;
    orders?: OrderViewModel[] | undefined;
}

export class OrderViewModel implements IOrderViewModel {
    id?: number;
    discount?: number;
    comments?: string | undefined;

    constructor(data?: IOrderViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.discount = _data["discount"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): OrderViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["discount"] = this.discount;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IOrderViewModel {
    id?: number;
    discount?: number;
    comments?: string | undefined;
}

export class DamagePoseViewModel implements IDamagePoseViewModel {
    id?: string;
    deploymentRequestId?: string;
    applicationVersionId?: string;
    inventoryId?: string;
    inventoryAddId?: string;
    status?: string | undefined;
    bankName?: string | undefined;
    bankCode?: string | undefined;
    merchant?: string | undefined;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    outlet?: string | undefined;
    address?: string | undefined;
    province?: string | undefined;
    merchantCategory?: string | undefined;
    applicationFormat?: string | undefined;
    district?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    serialKey?: string | undefined;
    item?: string | undefined;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    createdDate?: Date;
    updatedDate?: Date;
    serialNumberId?: string;

    constructor(data?: IDamagePoseViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.applicationVersionId = _data["applicationVersionId"];
            this.inventoryId = _data["inventoryId"];
            this.inventoryAddId = _data["inventoryAddId"];
            this.status = _data["status"];
            this.bankName = _data["bankName"];
            this.bankCode = _data["bankCode"];
            this.merchant = _data["merchant"];
            this.idMerchant = _data["idMerchant"];
            this.idTerminal = _data["idTerminal"];
            this.outlet = _data["outlet"];
            this.address = _data["address"];
            this.province = _data["province"];
            this.merchantCategory = _data["merchantCategory"];
            this.applicationFormat = _data["applicationFormat"];
            this.district = _data["district"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo = _data["contactNo"];
            this.serialKey = _data["serialKey"];
            this.item = _data["item"];
            this.primaryItem = _data["primaryItem"];
            this.secondaryItem = _data["secondaryItem"];
            this.tertiaryItem = _data["tertiaryItem"];
            this.detailItem = _data["detailItem"];
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.serialNumberId = _data["serialNumberId"];
        }
    }

    static fromJS(data: any): DamagePoseViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DamagePoseViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["applicationVersionId"] = this.applicationVersionId;
        data["inventoryId"] = this.inventoryId;
        data["inventoryAddId"] = this.inventoryAddId;
        data["status"] = this.status;
        data["bankName"] = this.bankName;
        data["bankCode"] = this.bankCode;
        data["merchant"] = this.merchant;
        data["idMerchant"] = this.idMerchant;
        data["idTerminal"] = this.idTerminal;
        data["outlet"] = this.outlet;
        data["address"] = this.address;
        data["province"] = this.province;
        data["merchantCategory"] = this.merchantCategory;
        data["applicationFormat"] = this.applicationFormat;
        data["district"] = this.district;
        data["contactPerson"] = this.contactPerson;
        data["contactNo"] = this.contactNo;
        data["serialKey"] = this.serialKey;
        data["item"] = this.item;
        data["primaryItem"] = this.primaryItem;
        data["secondaryItem"] = this.secondaryItem;
        data["tertiaryItem"] = this.tertiaryItem;
        data["detailItem"] = this.detailItem;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["serialNumberId"] = this.serialNumberId;
        return data;
    }
}

export interface IDamagePoseViewModel {
    id?: string;
    deploymentRequestId?: string;
    applicationVersionId?: string;
    inventoryId?: string;
    inventoryAddId?: string;
    status?: string | undefined;
    bankName?: string | undefined;
    bankCode?: string | undefined;
    merchant?: string | undefined;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    outlet?: string | undefined;
    address?: string | undefined;
    province?: string | undefined;
    merchantCategory?: string | undefined;
    applicationFormat?: string | undefined;
    district?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    serialKey?: string | undefined;
    item?: string | undefined;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    createdDate?: Date;
    updatedDate?: Date;
    serialNumberId?: string;
}

export class CreateDamagePosFromMaintenanceCommand implements ICreateDamagePosFromMaintenanceCommand {
    id?: string;
    deploymentRequestId?: string;
    applicationVersionId?: string;
    inventoryId?: string;
    inventoryAddId?: string;
    serialNumberId?: string;
    status?: string | undefined;
    bankName?: string | undefined;
    bankCode?: string | undefined;
    merchant?: string | undefined;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    outlet?: string | undefined;
    address?: string | undefined;
    province?: string | undefined;
    merchantCategory?: string | undefined;
    applicationFormat?: string | undefined;
    district?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    serialNumber?: string | undefined;
    item?: string | undefined;

    constructor(data?: ICreateDamagePosFromMaintenanceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.applicationVersionId = _data["applicationVersionId"];
            this.inventoryId = _data["inventoryId"];
            this.inventoryAddId = _data["inventoryAddId"];
            this.serialNumberId = _data["serialNumberId"];
            this.status = _data["status"];
            this.bankName = _data["bankName"];
            this.bankCode = _data["bankCode"];
            this.merchant = _data["merchant"];
            this.idMerchant = _data["idMerchant"];
            this.idTerminal = _data["idTerminal"];
            this.outlet = _data["outlet"];
            this.address = _data["address"];
            this.province = _data["province"];
            this.merchantCategory = _data["merchantCategory"];
            this.applicationFormat = _data["applicationFormat"];
            this.district = _data["district"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo = _data["contactNo"];
            this.serialNumber = _data["serialNumber"];
            this.item = _data["item"];
        }
    }

    static fromJS(data: any): CreateDamagePosFromMaintenanceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDamagePosFromMaintenanceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["applicationVersionId"] = this.applicationVersionId;
        data["inventoryId"] = this.inventoryId;
        data["inventoryAddId"] = this.inventoryAddId;
        data["serialNumberId"] = this.serialNumberId;
        data["status"] = this.status;
        data["bankName"] = this.bankName;
        data["bankCode"] = this.bankCode;
        data["merchant"] = this.merchant;
        data["idMerchant"] = this.idMerchant;
        data["idTerminal"] = this.idTerminal;
        data["outlet"] = this.outlet;
        data["address"] = this.address;
        data["province"] = this.province;
        data["merchantCategory"] = this.merchantCategory;
        data["applicationFormat"] = this.applicationFormat;
        data["district"] = this.district;
        data["contactPerson"] = this.contactPerson;
        data["contactNo"] = this.contactNo;
        data["serialNumber"] = this.serialNumber;
        data["item"] = this.item;
        return data;
    }
}

export interface ICreateDamagePosFromMaintenanceCommand {
    id?: string;
    deploymentRequestId?: string;
    applicationVersionId?: string;
    inventoryId?: string;
    inventoryAddId?: string;
    serialNumberId?: string;
    status?: string | undefined;
    bankName?: string | undefined;
    bankCode?: string | undefined;
    merchant?: string | undefined;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    outlet?: string | undefined;
    address?: string | undefined;
    province?: string | undefined;
    merchantCategory?: string | undefined;
    applicationFormat?: string | undefined;
    district?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    serialNumber?: string | undefined;
    item?: string | undefined;
}

export class BankWiseTerminalDataQuery implements IBankWiseTerminalDataQuery {
    bankName?: string | undefined;
    previousMonth?: number;
    currentMonth?: number;
    pendingDeployment?: number;
    total?: number;
    pendingRemoval?: number;
    maintenanceNumber?: number;
    em?: number;
    gem?: number;
    sofT_MUGU?: number;
    ictiwl?: number;
    t2MINI?: number;
    mgE4G?: number;
    mgeM2G?: number;
    mpos?: number;
    miwlwifI3G?: number;
    aposA8?: number;
    mem?: number;
    pA910?: number;
    miwL3G?: number;
    t2S_DUAL?: number;
    miwL2G?: number;
    dX8000?: number;
    p2000L?: number;
    sV2?: number;
    t2LITE?: number;
    mgeM3G?: number;
    apos?: number;
    miwlwifI4G?: number;
    t2S_SINGLE?: number;

    constructor(data?: IBankWiseTerminalDataQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankName = _data["bankName"];
            this.previousMonth = _data["previousMonth"];
            this.currentMonth = _data["currentMonth"];
            this.pendingDeployment = _data["pendingDeployment"];
            this.total = _data["total"];
            this.pendingRemoval = _data["pendingRemoval"];
            this.maintenanceNumber = _data["maintenanceNumber"];
            this.em = _data["em"];
            this.gem = _data["gem"];
            this.sofT_MUGU = _data["sofT_MUGU"];
            this.ictiwl = _data["ictiwl"];
            this.t2MINI = _data["t2MINI"];
            this.mgE4G = _data["mgE4G"];
            this.mgeM2G = _data["mgeM2G"];
            this.mpos = _data["mpos"];
            this.miwlwifI3G = _data["miwlwifI3G"];
            this.aposA8 = _data["aposA8"];
            this.mem = _data["mem"];
            this.pA910 = _data["pA910"];
            this.miwL3G = _data["miwL3G"];
            this.t2S_DUAL = _data["t2S_DUAL"];
            this.miwL2G = _data["miwL2G"];
            this.dX8000 = _data["dX8000"];
            this.p2000L = _data["p2000L"];
            this.sV2 = _data["sV2"];
            this.t2LITE = _data["t2LITE"];
            this.mgeM3G = _data["mgeM3G"];
            this.apos = _data["apos"];
            this.miwlwifI4G = _data["miwlwifI4G"];
            this.t2S_SINGLE = _data["t2S_SINGLE"];
        }
    }

    static fromJS(data: any): BankWiseTerminalDataQuery {
        data = typeof data === 'object' ? data : {};
        let result = new BankWiseTerminalDataQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankName"] = this.bankName;
        data["previousMonth"] = this.previousMonth;
        data["currentMonth"] = this.currentMonth;
        data["pendingDeployment"] = this.pendingDeployment;
        data["total"] = this.total;
        data["pendingRemoval"] = this.pendingRemoval;
        data["maintenanceNumber"] = this.maintenanceNumber;
        data["em"] = this.em;
        data["gem"] = this.gem;
        data["sofT_MUGU"] = this.sofT_MUGU;
        data["ictiwl"] = this.ictiwl;
        data["t2MINI"] = this.t2MINI;
        data["mgE4G"] = this.mgE4G;
        data["mgeM2G"] = this.mgeM2G;
        data["mpos"] = this.mpos;
        data["miwlwifI3G"] = this.miwlwifI3G;
        data["aposA8"] = this.aposA8;
        data["mem"] = this.mem;
        data["pA910"] = this.pA910;
        data["miwL3G"] = this.miwL3G;
        data["t2S_DUAL"] = this.t2S_DUAL;
        data["miwL2G"] = this.miwL2G;
        data["dX8000"] = this.dX8000;
        data["p2000L"] = this.p2000L;
        data["sV2"] = this.sV2;
        data["t2LITE"] = this.t2LITE;
        data["mgeM3G"] = this.mgeM3G;
        data["apos"] = this.apos;
        data["miwlwifI4G"] = this.miwlwifI4G;
        data["t2S_SINGLE"] = this.t2S_SINGLE;
        return data;
    }
}

export interface IBankWiseTerminalDataQuery {
    bankName?: string | undefined;
    previousMonth?: number;
    currentMonth?: number;
    pendingDeployment?: number;
    total?: number;
    pendingRemoval?: number;
    maintenanceNumber?: number;
    em?: number;
    gem?: number;
    sofT_MUGU?: number;
    ictiwl?: number;
    t2MINI?: number;
    mgE4G?: number;
    mgeM2G?: number;
    mpos?: number;
    miwlwifI3G?: number;
    aposA8?: number;
    mem?: number;
    pA910?: number;
    miwL3G?: number;
    t2S_DUAL?: number;
    miwL2G?: number;
    dX8000?: number;
    p2000L?: number;
    sV2?: number;
    t2LITE?: number;
    mgeM3G?: number;
    apos?: number;
    miwlwifI4G?: number;
    t2S_SINGLE?: number;
}

export class BankDashboardViewModel implements IBankDashboardViewModel {
    id?: string;
    deploymentRequestId?: string;
    bankId?: string;
    inventoryId?: string;
    maintenanceId?: string;
    bankName?: string | undefined;
    maintenanceNumber?: number;
    rollNumber?: number;
    soldNumber?: number;
    deployDate?: Date;
    total?: number;
    previousMonth?: number;
    currentMonth?: number;
    pendingDeployment?: number;
    pendingRemoval?: number;
    gem?: number;
    em?: number;
    iwl?: number;
    mem?: number;
    mgemtwog?: number;
    mgemthreeg?: number;
    miwltwog?: number;
    miwlthreeg?: number;
    miwlthreegwifi?: number;
    aposA8?: number;
    a910?: number;
    apos?: number;
    sunmI_D?: number;
    sunmiV2?: number;
    sunmI_S?: number;
    dX8000?: number;
    p2000L?: number;
    tertiaryGem?: string | undefined;
    tertiaryEm?: string | undefined;
    tertiaryIwl?: string | undefined;
    tertiartMem?: string | undefined;
    tertiaryMGemtwog?: string | undefined;
    tertiaryMGemthreeg?: string | undefined;
    tertiaryMIwltwog?: string | undefined;
    tertiaryMIwlthreeg?: string | undefined;
    tertiaryMIwlthreegWifi?: string | undefined;
    totalGem?: number;
    totalEm?: number;
    totalIwl?: number;
    totalMem?: number;
    totalMGemtwog?: number;
    totalMGemthreeg?: number;
    totalMIwltwog?: number;
    totalMIwlthreeg?: number;
    totalMIwlthreegWifi?: number;
    totalMaintenance?: number;
    totalPrevMonth?: number;
    totalCurrenMonth?: number;
    totalPending?: number;
    totalDeploy?: number;
    totalBank?: number;
    verification?: string | undefined;

    constructor(data?: IBankDashboardViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.bankId = _data["bankId"];
            this.inventoryId = _data["inventoryId"];
            this.maintenanceId = _data["maintenanceId"];
            this.bankName = _data["bankName"];
            this.maintenanceNumber = _data["maintenanceNumber"];
            this.rollNumber = _data["rollNumber"];
            this.soldNumber = _data["soldNumber"];
            this.deployDate = _data["deployDate"] ? new Date(_data["deployDate"].toString()) : <any>undefined;
            this.total = _data["total"];
            this.previousMonth = _data["previousMonth"];
            this.currentMonth = _data["currentMonth"];
            this.pendingDeployment = _data["pendingDeployment"];
            this.pendingRemoval = _data["pendingRemoval"];
            this.gem = _data["gem"];
            this.em = _data["em"];
            this.iwl = _data["iwl"];
            this.mem = _data["mem"];
            this.mgemtwog = _data["mgemtwog"];
            this.mgemthreeg = _data["mgemthreeg"];
            this.miwltwog = _data["miwltwog"];
            this.miwlthreeg = _data["miwlthreeg"];
            this.miwlthreegwifi = _data["miwlthreegwifi"];
            this.aposA8 = _data["aposA8"];
            this.a910 = _data["a910"];
            this.apos = _data["apos"];
            this.sunmI_D = _data["sunmI_D"];
            this.sunmiV2 = _data["sunmiV2"];
            this.sunmI_S = _data["sunmI_S"];
            this.dX8000 = _data["dX8000"];
            this.p2000L = _data["p2000L"];
            this.tertiaryGem = _data["tertiaryGem"];
            this.tertiaryEm = _data["tertiaryEm"];
            this.tertiaryIwl = _data["tertiaryIwl"];
            this.tertiartMem = _data["tertiartMem"];
            this.tertiaryMGemtwog = _data["tertiaryMGemtwog"];
            this.tertiaryMGemthreeg = _data["tertiaryMGemthreeg"];
            this.tertiaryMIwltwog = _data["tertiaryMIwltwog"];
            this.tertiaryMIwlthreeg = _data["tertiaryMIwlthreeg"];
            this.tertiaryMIwlthreegWifi = _data["tertiaryMIwlthreegWifi"];
            this.totalGem = _data["totalGem"];
            this.totalEm = _data["totalEm"];
            this.totalIwl = _data["totalIwl"];
            this.totalMem = _data["totalMem"];
            this.totalMGemtwog = _data["totalMGemtwog"];
            this.totalMGemthreeg = _data["totalMGemthreeg"];
            this.totalMIwltwog = _data["totalMIwltwog"];
            this.totalMIwlthreeg = _data["totalMIwlthreeg"];
            this.totalMIwlthreegWifi = _data["totalMIwlthreegWifi"];
            this.totalMaintenance = _data["totalMaintenance"];
            this.totalPrevMonth = _data["totalPrevMonth"];
            this.totalCurrenMonth = _data["totalCurrenMonth"];
            this.totalPending = _data["totalPending"];
            this.totalDeploy = _data["totalDeploy"];
            this.totalBank = _data["totalBank"];
            this.verification = _data["verification"];
        }
    }

    static fromJS(data: any): BankDashboardViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BankDashboardViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["bankId"] = this.bankId;
        data["inventoryId"] = this.inventoryId;
        data["maintenanceId"] = this.maintenanceId;
        data["bankName"] = this.bankName;
        data["maintenanceNumber"] = this.maintenanceNumber;
        data["rollNumber"] = this.rollNumber;
        data["soldNumber"] = this.soldNumber;
        data["deployDate"] = this.deployDate ? this.deployDate.toISOString() : <any>undefined;
        data["total"] = this.total;
        data["previousMonth"] = this.previousMonth;
        data["currentMonth"] = this.currentMonth;
        data["pendingDeployment"] = this.pendingDeployment;
        data["pendingRemoval"] = this.pendingRemoval;
        data["gem"] = this.gem;
        data["em"] = this.em;
        data["iwl"] = this.iwl;
        data["mem"] = this.mem;
        data["mgemtwog"] = this.mgemtwog;
        data["mgemthreeg"] = this.mgemthreeg;
        data["miwltwog"] = this.miwltwog;
        data["miwlthreeg"] = this.miwlthreeg;
        data["miwlthreegwifi"] = this.miwlthreegwifi;
        data["aposA8"] = this.aposA8;
        data["a910"] = this.a910;
        data["apos"] = this.apos;
        data["sunmI_D"] = this.sunmI_D;
        data["sunmiV2"] = this.sunmiV2;
        data["sunmI_S"] = this.sunmI_S;
        data["dX8000"] = this.dX8000;
        data["p2000L"] = this.p2000L;
        data["tertiaryGem"] = this.tertiaryGem;
        data["tertiaryEm"] = this.tertiaryEm;
        data["tertiaryIwl"] = this.tertiaryIwl;
        data["tertiartMem"] = this.tertiartMem;
        data["tertiaryMGemtwog"] = this.tertiaryMGemtwog;
        data["tertiaryMGemthreeg"] = this.tertiaryMGemthreeg;
        data["tertiaryMIwltwog"] = this.tertiaryMIwltwog;
        data["tertiaryMIwlthreeg"] = this.tertiaryMIwlthreeg;
        data["tertiaryMIwlthreegWifi"] = this.tertiaryMIwlthreegWifi;
        data["totalGem"] = this.totalGem;
        data["totalEm"] = this.totalEm;
        data["totalIwl"] = this.totalIwl;
        data["totalMem"] = this.totalMem;
        data["totalMGemtwog"] = this.totalMGemtwog;
        data["totalMGemthreeg"] = this.totalMGemthreeg;
        data["totalMIwltwog"] = this.totalMIwltwog;
        data["totalMIwlthreeg"] = this.totalMIwlthreeg;
        data["totalMIwlthreegWifi"] = this.totalMIwlthreegWifi;
        data["totalMaintenance"] = this.totalMaintenance;
        data["totalPrevMonth"] = this.totalPrevMonth;
        data["totalCurrenMonth"] = this.totalCurrenMonth;
        data["totalPending"] = this.totalPending;
        data["totalDeploy"] = this.totalDeploy;
        data["totalBank"] = this.totalBank;
        data["verification"] = this.verification;
        return data;
    }
}

export interface IBankDashboardViewModel {
    id?: string;
    deploymentRequestId?: string;
    bankId?: string;
    inventoryId?: string;
    maintenanceId?: string;
    bankName?: string | undefined;
    maintenanceNumber?: number;
    rollNumber?: number;
    soldNumber?: number;
    deployDate?: Date;
    total?: number;
    previousMonth?: number;
    currentMonth?: number;
    pendingDeployment?: number;
    pendingRemoval?: number;
    gem?: number;
    em?: number;
    iwl?: number;
    mem?: number;
    mgemtwog?: number;
    mgemthreeg?: number;
    miwltwog?: number;
    miwlthreeg?: number;
    miwlthreegwifi?: number;
    aposA8?: number;
    a910?: number;
    apos?: number;
    sunmI_D?: number;
    sunmiV2?: number;
    sunmI_S?: number;
    dX8000?: number;
    p2000L?: number;
    tertiaryGem?: string | undefined;
    tertiaryEm?: string | undefined;
    tertiaryIwl?: string | undefined;
    tertiartMem?: string | undefined;
    tertiaryMGemtwog?: string | undefined;
    tertiaryMGemthreeg?: string | undefined;
    tertiaryMIwltwog?: string | undefined;
    tertiaryMIwlthreeg?: string | undefined;
    tertiaryMIwlthreegWifi?: string | undefined;
    totalGem?: number;
    totalEm?: number;
    totalIwl?: number;
    totalMem?: number;
    totalMGemtwog?: number;
    totalMGemthreeg?: number;
    totalMIwltwog?: number;
    totalMIwlthreeg?: number;
    totalMIwlthreegWifi?: number;
    totalMaintenance?: number;
    totalPrevMonth?: number;
    totalCurrenMonth?: number;
    totalPending?: number;
    totalDeploy?: number;
    totalBank?: number;
    verification?: string | undefined;
}

export class TotalPosStatusQuery implements ITotalPosStatusQuery {
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    totalNumber?: number;
    soldNumber?: number;
    deployNumber?: number;
    totalSoldDeploy?: number;
    totalSoldUndeployed?: number;
    totalMaintenance?: number;
    totalDamage?: number;
    totalNotReceived?: number;
    totalStock?: number;
    totalDeploy?: number;
    total?: number;
    totalSold?: number;
    totalSoldUnDeployed?: number;
    maintenanceNumber?: number;
    notReceivedNumber?: number;
    damageNumber?: number;
    available?: number;
    pendingDeploymentRequest?: number;
    pendingDeploy?: number;

    constructor(data?: ITotalPosStatusQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primaryItem = _data["primaryItem"];
            this.secondaryItem = _data["secondaryItem"];
            this.tertiaryItem = _data["tertiaryItem"];
            this.detailItem = _data["detailItem"];
            this.totalNumber = _data["totalNumber"];
            this.soldNumber = _data["soldNumber"];
            this.deployNumber = _data["deployNumber"];
            this.totalSoldDeploy = _data["totalSoldDeploy"];
            this.totalSoldUndeployed = _data["totalSoldUndeployed"];
            this.totalMaintenance = _data["totalMaintenance"];
            this.totalDamage = _data["totalDamage"];
            this.totalNotReceived = _data["totalNotReceived"];
            this.totalStock = _data["totalStock"];
            this.totalDeploy = _data["totalDeploy"];
            this.total = _data["total"];
            this.totalSold = _data["totalSold"];
            this.totalSoldUnDeployed = _data["totalSoldUnDeployed"];
            this.maintenanceNumber = _data["maintenanceNumber"];
            this.notReceivedNumber = _data["notReceivedNumber"];
            this.damageNumber = _data["damageNumber"];
            this.available = _data["available"];
            this.pendingDeploymentRequest = _data["pendingDeploymentRequest"];
            this.pendingDeploy = _data["pendingDeploy"];
        }
    }

    static fromJS(data: any): TotalPosStatusQuery {
        data = typeof data === 'object' ? data : {};
        let result = new TotalPosStatusQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primaryItem"] = this.primaryItem;
        data["secondaryItem"] = this.secondaryItem;
        data["tertiaryItem"] = this.tertiaryItem;
        data["detailItem"] = this.detailItem;
        data["totalNumber"] = this.totalNumber;
        data["soldNumber"] = this.soldNumber;
        data["deployNumber"] = this.deployNumber;
        data["totalSoldDeploy"] = this.totalSoldDeploy;
        data["totalSoldUndeployed"] = this.totalSoldUndeployed;
        data["totalMaintenance"] = this.totalMaintenance;
        data["totalDamage"] = this.totalDamage;
        data["totalNotReceived"] = this.totalNotReceived;
        data["totalStock"] = this.totalStock;
        data["totalDeploy"] = this.totalDeploy;
        data["total"] = this.total;
        data["totalSold"] = this.totalSold;
        data["totalSoldUnDeployed"] = this.totalSoldUnDeployed;
        data["maintenanceNumber"] = this.maintenanceNumber;
        data["notReceivedNumber"] = this.notReceivedNumber;
        data["damageNumber"] = this.damageNumber;
        data["available"] = this.available;
        data["pendingDeploymentRequest"] = this.pendingDeploymentRequest;
        data["pendingDeploy"] = this.pendingDeploy;
        return data;
    }
}

export interface ITotalPosStatusQuery {
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    totalNumber?: number;
    soldNumber?: number;
    deployNumber?: number;
    totalSoldDeploy?: number;
    totalSoldUndeployed?: number;
    totalMaintenance?: number;
    totalDamage?: number;
    totalNotReceived?: number;
    totalStock?: number;
    totalDeploy?: number;
    total?: number;
    totalSold?: number;
    totalSoldUnDeployed?: number;
    maintenanceNumber?: number;
    notReceivedNumber?: number;
    damageNumber?: number;
    available?: number;
    pendingDeploymentRequest?: number;
    pendingDeploy?: number;
}

export class DashboardWeeklyQuery implements IDashboardWeeklyQuery {
    date?: string | undefined;
    totalDeploy?: number;
    totalRequested?: number;
    totalDeploymentPending?: number;

    constructor(data?: IDashboardWeeklyQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            this.totalDeploy = _data["totalDeploy"];
            this.totalRequested = _data["totalRequested"];
            this.totalDeploymentPending = _data["totalDeploymentPending"];
        }
    }

    static fromJS(data: any): DashboardWeeklyQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardWeeklyQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["totalDeploy"] = this.totalDeploy;
        data["totalRequested"] = this.totalRequested;
        data["totalDeploymentPending"] = this.totalDeploymentPending;
        return data;
    }
}

export interface IDashboardWeeklyQuery {
    date?: string | undefined;
    totalDeploy?: number;
    totalRequested?: number;
    totalDeploymentPending?: number;
}

export class PosDeploymentStageQuery implements IPosDeploymentStageQuery {
    newRequest?: number;
    configuration?: number;
    replacementRequest?: number;
    pendingDeployementStage?: number;
    todayNewRequest?: number;
    todayReplacementRequest?: number;
    totalDeploymentPending?: number;
    todayDeployed?: number;
    todayConfigured?: number;

    constructor(data?: IPosDeploymentStageQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newRequest = _data["newRequest"];
            this.configuration = _data["configuration"];
            this.replacementRequest = _data["replacementRequest"];
            this.pendingDeployementStage = _data["pendingDeployementStage"];
            this.todayNewRequest = _data["todayNewRequest"];
            this.todayReplacementRequest = _data["todayReplacementRequest"];
            this.totalDeploymentPending = _data["totalDeploymentPending"];
            this.todayDeployed = _data["todayDeployed"];
            this.todayConfigured = _data["todayConfigured"];
        }
    }

    static fromJS(data: any): PosDeploymentStageQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PosDeploymentStageQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newRequest"] = this.newRequest;
        data["configuration"] = this.configuration;
        data["replacementRequest"] = this.replacementRequest;
        data["pendingDeployementStage"] = this.pendingDeployementStage;
        data["todayNewRequest"] = this.todayNewRequest;
        data["todayReplacementRequest"] = this.todayReplacementRequest;
        data["totalDeploymentPending"] = this.totalDeploymentPending;
        data["todayDeployed"] = this.todayDeployed;
        data["todayConfigured"] = this.todayConfigured;
        return data;
    }
}

export interface IPosDeploymentStageQuery {
    newRequest?: number;
    configuration?: number;
    replacementRequest?: number;
    pendingDeployementStage?: number;
    todayNewRequest?: number;
    todayReplacementRequest?: number;
    totalDeploymentPending?: number;
    todayDeployed?: number;
    todayConfigured?: number;
}

export class SupportDataDashboardQuery implements ISupportDataDashboardQuery {
    phoneSupport?: number;
    fieldSupport?: number;
    pendingSupport?: number;
    requestedToday?: number;
    resolvedToday?: number;

    constructor(data?: ISupportDataDashboardQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneSupport = _data["phoneSupport"];
            this.fieldSupport = _data["fieldSupport"];
            this.pendingSupport = _data["pendingSupport"];
            this.requestedToday = _data["requestedToday"];
            this.resolvedToday = _data["resolvedToday"];
        }
    }

    static fromJS(data: any): SupportDataDashboardQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SupportDataDashboardQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneSupport"] = this.phoneSupport;
        data["fieldSupport"] = this.fieldSupport;
        data["pendingSupport"] = this.pendingSupport;
        data["requestedToday"] = this.requestedToday;
        data["resolvedToday"] = this.resolvedToday;
        return data;
    }
}

export interface ISupportDataDashboardQuery {
    phoneSupport?: number;
    fieldSupport?: number;
    pendingSupport?: number;
    requestedToday?: number;
    resolvedToday?: number;
}

export class BarsForDashboardQuery implements IBarsForDashboardQuery {
    totalRemovalPending?: number;
    removalPendingToday?: number;
    removalResolvedToday?: number;
    totalAppVerUpdate?: number;
    appVerUpdateToday?: number;
    totalReplacement?: number;
    replacementPendingToday?: number;
    replacementResolvedToday?: number;

    constructor(data?: IBarsForDashboardQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRemovalPending = _data["totalRemovalPending"];
            this.removalPendingToday = _data["removalPendingToday"];
            this.removalResolvedToday = _data["removalResolvedToday"];
            this.totalAppVerUpdate = _data["totalAppVerUpdate"];
            this.appVerUpdateToday = _data["appVerUpdateToday"];
            this.totalReplacement = _data["totalReplacement"];
            this.replacementPendingToday = _data["replacementPendingToday"];
            this.replacementResolvedToday = _data["replacementResolvedToday"];
        }
    }

    static fromJS(data: any): BarsForDashboardQuery {
        data = typeof data === 'object' ? data : {};
        let result = new BarsForDashboardQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRemovalPending"] = this.totalRemovalPending;
        data["removalPendingToday"] = this.removalPendingToday;
        data["removalResolvedToday"] = this.removalResolvedToday;
        data["totalAppVerUpdate"] = this.totalAppVerUpdate;
        data["appVerUpdateToday"] = this.appVerUpdateToday;
        data["totalReplacement"] = this.totalReplacement;
        data["replacementPendingToday"] = this.replacementPendingToday;
        data["replacementResolvedToday"] = this.replacementResolvedToday;
        return data;
    }
}

export interface IBarsForDashboardQuery {
    totalRemovalPending?: number;
    removalPendingToday?: number;
    removalResolvedToday?: number;
    totalAppVerUpdate?: number;
    appVerUpdateToday?: number;
    totalReplacement?: number;
    replacementPendingToday?: number;
    replacementResolvedToday?: number;
}

export class PendingDeploymentQuery implements IPendingDeploymentQuery {
    id?: string;
    bankId?: string | undefined;
    bankName?: string | undefined;
    bankAddress?: string | undefined;
    district?: string | undefined;
    requestedDate?: Date;
    bankCode?: string | undefined;
    merchant?: string | undefined;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    imid?: string | undefined;
    itid?: string | undefined;
    outlet?: string | undefined;
    address?: string | undefined;
    province?: string | undefined;
    merchantCategory?: string | undefined;
    contactPerson?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    terminalType?: string | undefined;
    item?: string | undefined;
    inventoryAddId?: string;
    inventoryId?: string | undefined;
    statusId?: string | undefined;
    statusName?: string | undefined;
    remarks?: string | undefined;
    requestTypeId?: string | undefined;
    requestName?: string | undefined;
    serialNumberId?: string | undefined;
    serialKey?: string | undefined;
    previousSerial?: string | undefined;
    configStatus?: string | undefined;
    applicationVersion?: string | undefined;
    applicationDate?: string | undefined;
    statusForDeploy?: string | undefined;
    updatedBy?: string | undefined;
    createdDate?: Date;
    requestedDateInString?: string | undefined;
    previousSerialStatus?: string | undefined;
    ownership?: string | undefined;
    contactOfPos?: string | undefined;
    property?: string | undefined;
    brandName?: string | undefined;
    panNumber?: string | undefined;
    deploymentStatus?: DeploymentStatus;
    connectivity?: Connectivity[] | undefined;

    constructor(data?: IPendingDeploymentQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bankId = _data["bankId"];
            this.bankName = _data["bankName"];
            this.bankAddress = _data["bankAddress"];
            this.district = _data["district"];
            this.requestedDate = _data["requestedDate"] ? new Date(_data["requestedDate"].toString()) : <any>undefined;
            this.bankCode = _data["bankCode"];
            this.merchant = _data["merchant"];
            this.idMerchant = _data["idMerchant"];
            this.idTerminal = _data["idTerminal"];
            this.imid = _data["imid"];
            this.itid = _data["itid"];
            this.outlet = _data["outlet"];
            this.address = _data["address"];
            this.province = _data["province"];
            this.merchantCategory = _data["merchantCategory"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo1 = _data["contactNo1"];
            this.contactNo2 = _data["contactNo2"];
            this.terminalType = _data["terminalType"];
            this.item = _data["item"];
            this.inventoryAddId = _data["inventoryAddId"];
            this.inventoryId = _data["inventoryId"];
            this.statusId = _data["statusId"];
            this.statusName = _data["statusName"];
            this.remarks = _data["remarks"];
            this.requestTypeId = _data["requestTypeId"];
            this.requestName = _data["requestName"];
            this.serialNumberId = _data["serialNumberId"];
            this.serialKey = _data["serialKey"];
            this.previousSerial = _data["previousSerial"];
            this.configStatus = _data["configStatus"];
            this.applicationVersion = _data["applicationVersion"];
            this.applicationDate = _data["applicationDate"];
            this.statusForDeploy = _data["statusForDeploy"];
            this.updatedBy = _data["updatedBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.requestedDateInString = _data["requestedDateInString"];
            this.previousSerialStatus = _data["previousSerialStatus"];
            this.ownership = _data["ownership"];
            this.contactOfPos = _data["contactOfPos"];
            this.property = _data["property"];
            this.brandName = _data["brandName"];
            this.panNumber = _data["panNumber"];
            this.deploymentStatus = _data["deploymentStatus"];
            if (Array.isArray(_data["connectivity"])) {
                this.connectivity = [] as any;
                for (let item of _data["connectivity"])
                    this.connectivity!.push(item);
            }
        }
    }

    static fromJS(data: any): PendingDeploymentQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PendingDeploymentQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankId"] = this.bankId;
        data["bankName"] = this.bankName;
        data["bankAddress"] = this.bankAddress;
        data["district"] = this.district;
        data["requestedDate"] = this.requestedDate ? this.requestedDate.toISOString() : <any>undefined;
        data["bankCode"] = this.bankCode;
        data["merchant"] = this.merchant;
        data["idMerchant"] = this.idMerchant;
        data["idTerminal"] = this.idTerminal;
        data["imid"] = this.imid;
        data["itid"] = this.itid;
        data["outlet"] = this.outlet;
        data["address"] = this.address;
        data["province"] = this.province;
        data["merchantCategory"] = this.merchantCategory;
        data["contactPerson"] = this.contactPerson;
        data["contactNo1"] = this.contactNo1;
        data["contactNo2"] = this.contactNo2;
        data["terminalType"] = this.terminalType;
        data["item"] = this.item;
        data["inventoryAddId"] = this.inventoryAddId;
        data["inventoryId"] = this.inventoryId;
        data["statusId"] = this.statusId;
        data["statusName"] = this.statusName;
        data["remarks"] = this.remarks;
        data["requestTypeId"] = this.requestTypeId;
        data["requestName"] = this.requestName;
        data["serialNumberId"] = this.serialNumberId;
        data["serialKey"] = this.serialKey;
        data["previousSerial"] = this.previousSerial;
        data["configStatus"] = this.configStatus;
        data["applicationVersion"] = this.applicationVersion;
        data["applicationDate"] = this.applicationDate;
        data["statusForDeploy"] = this.statusForDeploy;
        data["updatedBy"] = this.updatedBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["requestedDateInString"] = this.requestedDateInString;
        data["previousSerialStatus"] = this.previousSerialStatus;
        data["ownership"] = this.ownership;
        data["contactOfPos"] = this.contactOfPos;
        data["property"] = this.property;
        data["brandName"] = this.brandName;
        data["panNumber"] = this.panNumber;
        data["deploymentStatus"] = this.deploymentStatus;
        if (Array.isArray(this.connectivity)) {
            data["connectivity"] = [];
            for (let item of this.connectivity)
                data["connectivity"].push(item);
        }
        return data;
    }
}

export interface IPendingDeploymentQuery {
    id?: string;
    bankId?: string | undefined;
    bankName?: string | undefined;
    bankAddress?: string | undefined;
    district?: string | undefined;
    requestedDate?: Date;
    bankCode?: string | undefined;
    merchant?: string | undefined;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    imid?: string | undefined;
    itid?: string | undefined;
    outlet?: string | undefined;
    address?: string | undefined;
    province?: string | undefined;
    merchantCategory?: string | undefined;
    contactPerson?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    terminalType?: string | undefined;
    item?: string | undefined;
    inventoryAddId?: string;
    inventoryId?: string | undefined;
    statusId?: string | undefined;
    statusName?: string | undefined;
    remarks?: string | undefined;
    requestTypeId?: string | undefined;
    requestName?: string | undefined;
    serialNumberId?: string | undefined;
    serialKey?: string | undefined;
    previousSerial?: string | undefined;
    configStatus?: string | undefined;
    applicationVersion?: string | undefined;
    applicationDate?: string | undefined;
    statusForDeploy?: string | undefined;
    updatedBy?: string | undefined;
    createdDate?: Date;
    requestedDateInString?: string | undefined;
    previousSerialStatus?: string | undefined;
    ownership?: string | undefined;
    contactOfPos?: string | undefined;
    property?: string | undefined;
    brandName?: string | undefined;
    panNumber?: string | undefined;
    deploymentStatus?: DeploymentStatus;
    connectivity?: Connectivity[] | undefined;
}

export class DeploymentActivityLogs implements IDeploymentActivityLogs {
    id?: string;
    createdDate?: string | undefined;
    createdBy?: string | undefined;
    reamarks?: string | undefined;
    deploymentStatus?: DeploymentStatus;
    deploymentStatusDisplayName?: string | undefined;

    constructor(data?: IDeploymentActivityLogs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDate = _data["createdDate"];
            this.createdBy = _data["createdBy"];
            this.reamarks = _data["reamarks"];
            this.deploymentStatus = _data["deploymentStatus"];
            this.deploymentStatusDisplayName = _data["deploymentStatusDisplayName"];
        }
    }

    static fromJS(data: any): DeploymentActivityLogs {
        data = typeof data === 'object' ? data : {};
        let result = new DeploymentActivityLogs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDate"] = this.createdDate;
        data["createdBy"] = this.createdBy;
        data["reamarks"] = this.reamarks;
        data["deploymentStatus"] = this.deploymentStatus;
        data["deploymentStatusDisplayName"] = this.deploymentStatusDisplayName;
        return data;
    }
}

export interface IDeploymentActivityLogs {
    id?: string;
    createdDate?: string | undefined;
    createdBy?: string | undefined;
    reamarks?: string | undefined;
    deploymentStatus?: DeploymentStatus;
    deploymentStatusDisplayName?: string | undefined;
}

export class DeploymentViewModel implements IDeploymentViewModel {
    id?: string;
    receivedBy?: string | undefined;
    merchantLocation?: string | undefined;
    deployedBy?: string | undefined;
    receivedContactNo?: string | undefined;
    latitude?: string | undefined;
    longitude?: string | undefined;
    image?: string | undefined;
    scanned?: string | undefined;
    remarks?: string | undefined;
    statusForDeploy?: string | undefined;
    deploymentRequestId?: string;
    verification?: string | undefined;
    statusName?: string | undefined;
    requestName?: string | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    createdDate?: Date;
    deployDate?: Date;
    bankId?: string;
    inventoryId?: string;
    inventoryAddId?: string | undefined;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    bankName?: string | undefined;
    dispatch?: boolean;
    connectivities?: Connectivity[] | undefined;
    connectivity?: string | undefined;
    stickersleft?: string | undefined;
    rollsdelivered?: string | undefined;

    constructor(data?: IDeploymentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.receivedBy = _data["receivedBy"];
            this.merchantLocation = _data["merchantLocation"];
            this.deployedBy = _data["deployedBy"];
            this.receivedContactNo = _data["receivedContactNo"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.image = _data["image"];
            this.scanned = _data["scanned"];
            this.remarks = _data["remarks"];
            this.statusForDeploy = _data["statusForDeploy"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.verification = _data["verification"];
            this.statusName = _data["statusName"];
            this.requestName = _data["requestName"];
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.deployDate = _data["deployDate"] ? new Date(_data["deployDate"].toString()) : <any>undefined;
            this.bankId = _data["bankId"];
            this.inventoryId = _data["inventoryId"];
            this.inventoryAddId = _data["inventoryAddId"];
            this.primaryItem = _data["primaryItem"];
            this.secondaryItem = _data["secondaryItem"];
            this.tertiaryItem = _data["tertiaryItem"];
            this.detailItem = _data["detailItem"];
            this.bankName = _data["bankName"];
            this.dispatch = _data["dispatch"];
            if (Array.isArray(_data["connectivities"])) {
                this.connectivities = [] as any;
                for (let item of _data["connectivities"])
                    this.connectivities!.push(item);
            }
            this.connectivity = _data["connectivity"];
            this.stickersleft = _data["stickersleft"];
            this.rollsdelivered = _data["rollsdelivered"];
        }
    }

    static fromJS(data: any): DeploymentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeploymentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["receivedBy"] = this.receivedBy;
        data["merchantLocation"] = this.merchantLocation;
        data["deployedBy"] = this.deployedBy;
        data["receivedContactNo"] = this.receivedContactNo;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["image"] = this.image;
        data["scanned"] = this.scanned;
        data["remarks"] = this.remarks;
        data["statusForDeploy"] = this.statusForDeploy;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["verification"] = this.verification;
        data["statusName"] = this.statusName;
        data["requestName"] = this.requestName;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["deployDate"] = this.deployDate ? this.deployDate.toISOString() : <any>undefined;
        data["bankId"] = this.bankId;
        data["inventoryId"] = this.inventoryId;
        data["inventoryAddId"] = this.inventoryAddId;
        data["primaryItem"] = this.primaryItem;
        data["secondaryItem"] = this.secondaryItem;
        data["tertiaryItem"] = this.tertiaryItem;
        data["detailItem"] = this.detailItem;
        data["bankName"] = this.bankName;
        data["dispatch"] = this.dispatch;
        if (Array.isArray(this.connectivities)) {
            data["connectivities"] = [];
            for (let item of this.connectivities)
                data["connectivities"].push(item);
        }
        data["connectivity"] = this.connectivity;
        data["stickersleft"] = this.stickersleft;
        data["rollsdelivered"] = this.rollsdelivered;
        return data;
    }
}

export interface IDeploymentViewModel {
    id?: string;
    receivedBy?: string | undefined;
    merchantLocation?: string | undefined;
    deployedBy?: string | undefined;
    receivedContactNo?: string | undefined;
    latitude?: string | undefined;
    longitude?: string | undefined;
    image?: string | undefined;
    scanned?: string | undefined;
    remarks?: string | undefined;
    statusForDeploy?: string | undefined;
    deploymentRequestId?: string;
    verification?: string | undefined;
    statusName?: string | undefined;
    requestName?: string | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    createdDate?: Date;
    deployDate?: Date;
    bankId?: string;
    inventoryId?: string;
    inventoryAddId?: string | undefined;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    bankName?: string | undefined;
    dispatch?: boolean;
    connectivities?: Connectivity[] | undefined;
    connectivity?: string | undefined;
    stickersleft?: string | undefined;
    rollsdelivered?: string | undefined;
}

export class SP_DeployedTerminalListPOSReportVm implements ISP_DeployedTerminalListPOSReportVm {
    deploymentRequestId?: string | undefined;
    bankId?: string;
    bankName?: string | undefined;
    merchantName?: string | undefined;
    panNumber?: string | undefined;
    contactPerson?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    isTxnDbRegistered?: boolean;
    idMerchant?: string | undefined;
    merchantAddress?: string | undefined;
    idTerminal?: string | undefined;
    serialNumberId?: string | undefined;
    ownership?: string | undefined;
    district?: string | undefined;
    terminalType?: string | undefined;
    serialKey?: string | undefined;
    deploymentStatus?: string | undefined;
    deployDate?: string | undefined;
    cashAdvance?: boolean;
    pinChange?: boolean;
    fonepayIdMerchant?: string | undefined;
    fonepayIdTerminal?: string | undefined;
    nepalPayIdMerchant?: string | undefined;
    nepalPayIdTerminal?: string | undefined;
    imid?: number | undefined;
    itid?: number | undefined;

    constructor(data?: ISP_DeployedTerminalListPOSReportVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.bankId = _data["bankId"];
            this.bankName = _data["bankName"];
            this.merchantName = _data["merchantName"];
            this.panNumber = _data["panNumber"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo1 = _data["contactNo1"];
            this.contactNo2 = _data["contactNo2"];
            this.isTxnDbRegistered = _data["isTxnDbRegistered"];
            this.idMerchant = _data["idMerchant"];
            this.merchantAddress = _data["merchantAddress"];
            this.idTerminal = _data["idTerminal"];
            this.serialNumberId = _data["serialNumberId"];
            this.ownership = _data["ownership"];
            this.district = _data["district"];
            this.terminalType = _data["terminalType"];
            this.serialKey = _data["serialKey"];
            this.deploymentStatus = _data["deploymentStatus"];
            this.deployDate = _data["deployDate"];
            this.cashAdvance = _data["cashAdvance"];
            this.pinChange = _data["pinChange"];
            this.fonepayIdMerchant = _data["fonepayIdMerchant"];
            this.fonepayIdTerminal = _data["fonepayIdTerminal"];
            this.nepalPayIdMerchant = _data["nepalPayIdMerchant"];
            this.nepalPayIdTerminal = _data["nepalPayIdTerminal"];
            this.imid = _data["imid"];
            this.itid = _data["itid"];
        }
    }

    static fromJS(data: any): SP_DeployedTerminalListPOSReportVm {
        data = typeof data === 'object' ? data : {};
        let result = new SP_DeployedTerminalListPOSReportVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["bankId"] = this.bankId;
        data["bankName"] = this.bankName;
        data["merchantName"] = this.merchantName;
        data["panNumber"] = this.panNumber;
        data["contactPerson"] = this.contactPerson;
        data["contactNo1"] = this.contactNo1;
        data["contactNo2"] = this.contactNo2;
        data["isTxnDbRegistered"] = this.isTxnDbRegistered;
        data["idMerchant"] = this.idMerchant;
        data["merchantAddress"] = this.merchantAddress;
        data["idTerminal"] = this.idTerminal;
        data["serialNumberId"] = this.serialNumberId;
        data["ownership"] = this.ownership;
        data["district"] = this.district;
        data["terminalType"] = this.terminalType;
        data["serialKey"] = this.serialKey;
        data["deploymentStatus"] = this.deploymentStatus;
        data["deployDate"] = this.deployDate;
        data["cashAdvance"] = this.cashAdvance;
        data["pinChange"] = this.pinChange;
        data["fonepayIdMerchant"] = this.fonepayIdMerchant;
        data["fonepayIdTerminal"] = this.fonepayIdTerminal;
        data["nepalPayIdMerchant"] = this.nepalPayIdMerchant;
        data["nepalPayIdTerminal"] = this.nepalPayIdTerminal;
        data["imid"] = this.imid;
        data["itid"] = this.itid;
        return data;
    }
}

export interface ISP_DeployedTerminalListPOSReportVm {
    deploymentRequestId?: string | undefined;
    bankId?: string;
    bankName?: string | undefined;
    merchantName?: string | undefined;
    panNumber?: string | undefined;
    contactPerson?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    isTxnDbRegistered?: boolean;
    idMerchant?: string | undefined;
    merchantAddress?: string | undefined;
    idTerminal?: string | undefined;
    serialNumberId?: string | undefined;
    ownership?: string | undefined;
    district?: string | undefined;
    terminalType?: string | undefined;
    serialKey?: string | undefined;
    deploymentStatus?: string | undefined;
    deployDate?: string | undefined;
    cashAdvance?: boolean;
    pinChange?: boolean;
    fonepayIdMerchant?: string | undefined;
    fonepayIdTerminal?: string | undefined;
    nepalPayIdMerchant?: string | undefined;
    nepalPayIdTerminal?: string | undefined;
    imid?: number | undefined;
    itid?: number | undefined;
}

export class SP_BankWisePosReportVm implements ISP_BankWisePosReportVm {
    id?: string | undefined;
    bankId?: string | undefined;
    bankName?: string | undefined;
    merchant?: string | undefined;
    currency?: string | undefined;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    address?: string | undefined;
    province?: string | undefined;
    district?: string | undefined;
    merchantCategory?: string | undefined;
    contactPerson?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    requestVerifiedBy?: string | undefined;
    contactOfPos?: string | undefined;
    serialKey?: string | undefined;
    previousSerial?: string | undefined;
    status?: string | undefined;
    configuredBy?: string | undefined;
    applicationDate?: string | undefined;
    terminalType?: string | undefined;
    remarks?: string | undefined;
    receivedBy?: string | undefined;
    receivedContactNo?: string | undefined;
    connectivities?: Connectivity[] | undefined;
    createdBy?: string | undefined;
    deployedAt?: string | undefined;
    merchantLocation?: string | undefined;
    deployVerifiedBy?: string | undefined;
    updatedDate?: string | undefined;
    deployDate?: string | undefined;
    requestName?: string | undefined;
    deploymentStatus?: number;
    isSold?: boolean;
    deploymentCreatedBy?: string | undefined;
    deploymentsUpdatedBy?: string | undefined;
    deployedBy?: string | undefined;
    manualTransaction?: string | undefined;
    tipAdjustment?: string | undefined;
    preAuth?: string | undefined;
    cashAdvance?: string | undefined;
    pinChange?: string | undefined;
    panNumber?: string | undefined;

    constructor(data?: ISP_BankWisePosReportVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bankId = _data["bankId"];
            this.bankName = _data["bankName"];
            this.merchant = _data["merchant"];
            this.currency = _data["currency"];
            this.idMerchant = _data["idMerchant"];
            this.idTerminal = _data["idTerminal"];
            this.address = _data["address"];
            this.province = _data["province"];
            this.district = _data["district"];
            this.merchantCategory = _data["merchantCategory"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo1 = _data["contactNo1"];
            this.contactNo2 = _data["contactNo2"];
            this.requestVerifiedBy = _data["requestVerifiedBy"];
            this.contactOfPos = _data["contactOfPos"];
            this.serialKey = _data["serialKey"];
            this.previousSerial = _data["previousSerial"];
            this.status = _data["status"];
            this.configuredBy = _data["configuredBy"];
            this.applicationDate = _data["applicationDate"];
            this.terminalType = _data["terminalType"];
            this.remarks = _data["remarks"];
            this.receivedBy = _data["receivedBy"];
            this.receivedContactNo = _data["receivedContactNo"];
            if (Array.isArray(_data["connectivities"])) {
                this.connectivities = [] as any;
                for (let item of _data["connectivities"])
                    this.connectivities!.push(item);
            }
            this.createdBy = _data["createdBy"];
            this.deployedAt = _data["deployedAt"];
            this.merchantLocation = _data["merchantLocation"];
            this.deployVerifiedBy = _data["deployVerifiedBy"];
            this.updatedDate = _data["updatedDate"];
            this.deployDate = _data["deployDate"];
            this.requestName = _data["requestName"];
            this.deploymentStatus = _data["deploymentStatus"];
            this.isSold = _data["isSold"];
            this.deploymentCreatedBy = _data["deploymentCreatedBy"];
            this.deploymentsUpdatedBy = _data["deploymentsUpdatedBy"];
            this.deployedBy = _data["deployedBy"];
            this.manualTransaction = _data["manualTransaction"];
            this.tipAdjustment = _data["tipAdjustment"];
            this.preAuth = _data["preAuth"];
            this.cashAdvance = _data["cashAdvance"];
            this.pinChange = _data["pinChange"];
            this.panNumber = _data["panNumber"];
        }
    }

    static fromJS(data: any): SP_BankWisePosReportVm {
        data = typeof data === 'object' ? data : {};
        let result = new SP_BankWisePosReportVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankId"] = this.bankId;
        data["bankName"] = this.bankName;
        data["merchant"] = this.merchant;
        data["currency"] = this.currency;
        data["idMerchant"] = this.idMerchant;
        data["idTerminal"] = this.idTerminal;
        data["address"] = this.address;
        data["province"] = this.province;
        data["district"] = this.district;
        data["merchantCategory"] = this.merchantCategory;
        data["contactPerson"] = this.contactPerson;
        data["contactNo1"] = this.contactNo1;
        data["contactNo2"] = this.contactNo2;
        data["requestVerifiedBy"] = this.requestVerifiedBy;
        data["contactOfPos"] = this.contactOfPos;
        data["serialKey"] = this.serialKey;
        data["previousSerial"] = this.previousSerial;
        data["status"] = this.status;
        data["configuredBy"] = this.configuredBy;
        data["applicationDate"] = this.applicationDate;
        data["terminalType"] = this.terminalType;
        data["remarks"] = this.remarks;
        data["receivedBy"] = this.receivedBy;
        data["receivedContactNo"] = this.receivedContactNo;
        if (Array.isArray(this.connectivities)) {
            data["connectivities"] = [];
            for (let item of this.connectivities)
                data["connectivities"].push(item);
        }
        data["createdBy"] = this.createdBy;
        data["deployedAt"] = this.deployedAt;
        data["merchantLocation"] = this.merchantLocation;
        data["deployVerifiedBy"] = this.deployVerifiedBy;
        data["updatedDate"] = this.updatedDate;
        data["deployDate"] = this.deployDate;
        data["requestName"] = this.requestName;
        data["deploymentStatus"] = this.deploymentStatus;
        data["isSold"] = this.isSold;
        data["deploymentCreatedBy"] = this.deploymentCreatedBy;
        data["deploymentsUpdatedBy"] = this.deploymentsUpdatedBy;
        data["deployedBy"] = this.deployedBy;
        data["manualTransaction"] = this.manualTransaction;
        data["tipAdjustment"] = this.tipAdjustment;
        data["preAuth"] = this.preAuth;
        data["cashAdvance"] = this.cashAdvance;
        data["pinChange"] = this.pinChange;
        data["panNumber"] = this.panNumber;
        return data;
    }
}

export interface ISP_BankWisePosReportVm {
    id?: string | undefined;
    bankId?: string | undefined;
    bankName?: string | undefined;
    merchant?: string | undefined;
    currency?: string | undefined;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    address?: string | undefined;
    province?: string | undefined;
    district?: string | undefined;
    merchantCategory?: string | undefined;
    contactPerson?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    requestVerifiedBy?: string | undefined;
    contactOfPos?: string | undefined;
    serialKey?: string | undefined;
    previousSerial?: string | undefined;
    status?: string | undefined;
    configuredBy?: string | undefined;
    applicationDate?: string | undefined;
    terminalType?: string | undefined;
    remarks?: string | undefined;
    receivedBy?: string | undefined;
    receivedContactNo?: string | undefined;
    connectivities?: Connectivity[] | undefined;
    createdBy?: string | undefined;
    deployedAt?: string | undefined;
    merchantLocation?: string | undefined;
    deployVerifiedBy?: string | undefined;
    updatedDate?: string | undefined;
    deployDate?: string | undefined;
    requestName?: string | undefined;
    deploymentStatus?: number;
    isSold?: boolean;
    deploymentCreatedBy?: string | undefined;
    deploymentsUpdatedBy?: string | undefined;
    deployedBy?: string | undefined;
    manualTransaction?: string | undefined;
    tipAdjustment?: string | undefined;
    preAuth?: string | undefined;
    cashAdvance?: string | undefined;
    pinChange?: string | undefined;
    panNumber?: string | undefined;
}

export class CreateDeploymentCommand implements ICreateDeploymentCommand {
    bankId?: string;
    bankName?: string | undefined;
    connectivity?: Connectivity[] | undefined;
    deployDate?: Date;
    deploymentRequestId?: string;
    inventoryAddId?: string;
    inventoryId?: string;
    serialNumberId?: string;
    deployedBy?: string | undefined;
    receivedContactNo?: string | undefined;
    merchantLocation?: string | undefined;
    receivedBy?: string | undefined;
    remarks?: string | undefined;
    stickersleft?: string | undefined;
    rollsdelivered?: string | undefined;
    deployedAt?: DeployedAtLocation;

    constructor(data?: ICreateDeploymentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankId = _data["bankId"];
            this.bankName = _data["bankName"];
            if (Array.isArray(_data["connectivity"])) {
                this.connectivity = [] as any;
                for (let item of _data["connectivity"])
                    this.connectivity!.push(item);
            }
            this.deployDate = _data["deployDate"] ? new Date(_data["deployDate"].toString()) : <any>undefined;
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.inventoryAddId = _data["inventoryAddId"];
            this.inventoryId = _data["inventoryId"];
            this.serialNumberId = _data["serialNumberId"];
            this.deployedBy = _data["deployedBy"];
            this.receivedContactNo = _data["receivedContactNo"];
            this.merchantLocation = _data["merchantLocation"];
            this.receivedBy = _data["receivedBy"];
            this.remarks = _data["remarks"];
            this.stickersleft = _data["stickersleft"];
            this.rollsdelivered = _data["rollsdelivered"];
            this.deployedAt = _data["deployedAt"];
        }
    }

    static fromJS(data: any): CreateDeploymentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDeploymentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankId"] = this.bankId;
        data["bankName"] = this.bankName;
        if (Array.isArray(this.connectivity)) {
            data["connectivity"] = [];
            for (let item of this.connectivity)
                data["connectivity"].push(item);
        }
        data["deployDate"] = this.deployDate ? this.deployDate.toISOString() : <any>undefined;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["inventoryAddId"] = this.inventoryAddId;
        data["inventoryId"] = this.inventoryId;
        data["serialNumberId"] = this.serialNumberId;
        data["deployedBy"] = this.deployedBy;
        data["receivedContactNo"] = this.receivedContactNo;
        data["merchantLocation"] = this.merchantLocation;
        data["receivedBy"] = this.receivedBy;
        data["remarks"] = this.remarks;
        data["stickersleft"] = this.stickersleft;
        data["rollsdelivered"] = this.rollsdelivered;
        data["deployedAt"] = this.deployedAt;
        return data;
    }
}

export interface ICreateDeploymentCommand {
    bankId?: string;
    bankName?: string | undefined;
    connectivity?: Connectivity[] | undefined;
    deployDate?: Date;
    deploymentRequestId?: string;
    inventoryAddId?: string;
    inventoryId?: string;
    serialNumberId?: string;
    deployedBy?: string | undefined;
    receivedContactNo?: string | undefined;
    merchantLocation?: string | undefined;
    receivedBy?: string | undefined;
    remarks?: string | undefined;
    stickersleft?: string | undefined;
    rollsdelivered?: string | undefined;
    deployedAt?: DeployedAtLocation;
}

export class UpdateDeploymentCommand implements IUpdateDeploymentCommand {
    connectivity?: Connectivity[] | undefined;
    deployDate?: Date;
    deploymentRequestId?: string;
    inventoryAddId?: string;
    inventoryId?: string;
    serialNumberId?: string;
    deployedBy?: string | undefined;
    receivedContactNo?: string | undefined;
    merchantLocation?: string | undefined;
    receivedBy?: string | undefined;
    remarks?: string | undefined;
    stickersleft?: string | undefined;
    rollsdelivered?: string | undefined;
    deployedAt?: DeployedAtLocation;

    constructor(data?: IUpdateDeploymentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["connectivity"])) {
                this.connectivity = [] as any;
                for (let item of _data["connectivity"])
                    this.connectivity!.push(item);
            }
            this.deployDate = _data["deployDate"] ? new Date(_data["deployDate"].toString()) : <any>undefined;
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.inventoryAddId = _data["inventoryAddId"];
            this.inventoryId = _data["inventoryId"];
            this.serialNumberId = _data["serialNumberId"];
            this.deployedBy = _data["deployedBy"];
            this.receivedContactNo = _data["receivedContactNo"];
            this.merchantLocation = _data["merchantLocation"];
            this.receivedBy = _data["receivedBy"];
            this.remarks = _data["remarks"];
            this.stickersleft = _data["stickersleft"];
            this.rollsdelivered = _data["rollsdelivered"];
            this.deployedAt = _data["deployedAt"];
        }
    }

    static fromJS(data: any): UpdateDeploymentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDeploymentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.connectivity)) {
            data["connectivity"] = [];
            for (let item of this.connectivity)
                data["connectivity"].push(item);
        }
        data["deployDate"] = this.deployDate ? this.deployDate.toISOString() : <any>undefined;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["inventoryAddId"] = this.inventoryAddId;
        data["inventoryId"] = this.inventoryId;
        data["serialNumberId"] = this.serialNumberId;
        data["deployedBy"] = this.deployedBy;
        data["receivedContactNo"] = this.receivedContactNo;
        data["merchantLocation"] = this.merchantLocation;
        data["receivedBy"] = this.receivedBy;
        data["remarks"] = this.remarks;
        data["stickersleft"] = this.stickersleft;
        data["rollsdelivered"] = this.rollsdelivered;
        data["deployedAt"] = this.deployedAt;
        return data;
    }
}

export interface IUpdateDeploymentCommand {
    connectivity?: Connectivity[] | undefined;
    deployDate?: Date;
    deploymentRequestId?: string;
    inventoryAddId?: string;
    inventoryId?: string;
    serialNumberId?: string;
    deployedBy?: string | undefined;
    receivedContactNo?: string | undefined;
    merchantLocation?: string | undefined;
    receivedBy?: string | undefined;
    remarks?: string | undefined;
    stickersleft?: string | undefined;
    rollsdelivered?: string | undefined;
    deployedAt?: DeployedAtLocation;
}

export class AllDeploymentRequestVm implements IAllDeploymentRequestVm {
    id?: string;
    idTerminal?: string | undefined;

    constructor(data?: IAllDeploymentRequestVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idTerminal = _data["idTerminal"];
        }
    }

    static fromJS(data: any): AllDeploymentRequestVm {
        data = typeof data === 'object' ? data : {};
        let result = new AllDeploymentRequestVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idTerminal"] = this.idTerminal;
        return data;
    }
}

export interface IAllDeploymentRequestVm {
    id?: string;
    idTerminal?: string | undefined;
}

export class DeploymentRequestListViewModel implements IDeploymentRequestListViewModel {
    id?: string;
    requestedDate?: string | undefined;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    merchant?: string | undefined;
    bankName?: string | undefined;
    branchName?: string | undefined;
    address?: string | undefined;
    district?: string | undefined;
    province?: string | undefined;
    item?: string | undefined;
    serialKey?: string | undefined;
    requestName?: string | undefined;
    statusName?: string | undefined;
    merchantCategory?: string | undefined;
    emailAddress?: string | undefined;
    contactPerson?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    ticketNumber?: string | undefined;
    bankRemarks?: string | undefined;
    currency?: string | undefined;
    panNumber?: string | undefined;
    merchantCategoryId?: string | undefined;
    inventoryId?: string | undefined;
    bankId?: string | undefined;
    priority?: boolean;
    refund?: boolean;
    cashAdvance?: boolean;
    pinChange?: boolean;
    manualTransaction?: boolean;
    tipAdjustment?: boolean;
    preAuthorization?: boolean;

    constructor(data?: IDeploymentRequestListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.requestedDate = _data["requestedDate"];
            this.idMerchant = _data["idMerchant"];
            this.idTerminal = _data["idTerminal"];
            this.merchant = _data["merchant"];
            this.bankName = _data["bankName"];
            this.branchName = _data["branchName"];
            this.address = _data["address"];
            this.district = _data["district"];
            this.province = _data["province"];
            this.item = _data["item"];
            this.serialKey = _data["serialKey"];
            this.requestName = _data["requestName"];
            this.statusName = _data["statusName"];
            this.merchantCategory = _data["merchantCategory"];
            this.emailAddress = _data["emailAddress"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo1 = _data["contactNo1"];
            this.contactNo2 = _data["contactNo2"];
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.ticketNumber = _data["ticketNumber"];
            this.bankRemarks = _data["bankRemarks"];
            this.currency = _data["currency"];
            this.panNumber = _data["panNumber"];
            this.merchantCategoryId = _data["merchantCategoryId"];
            this.inventoryId = _data["inventoryId"];
            this.bankId = _data["bankId"];
            this.priority = _data["priority"];
            this.refund = _data["refund"];
            this.cashAdvance = _data["cashAdvance"];
            this.pinChange = _data["pinChange"];
            this.manualTransaction = _data["manualTransaction"];
            this.tipAdjustment = _data["tipAdjustment"];
            this.preAuthorization = _data["preAuthorization"];
        }
    }

    static fromJS(data: any): DeploymentRequestListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeploymentRequestListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["requestedDate"] = this.requestedDate;
        data["idMerchant"] = this.idMerchant;
        data["idTerminal"] = this.idTerminal;
        data["merchant"] = this.merchant;
        data["bankName"] = this.bankName;
        data["branchName"] = this.branchName;
        data["address"] = this.address;
        data["district"] = this.district;
        data["province"] = this.province;
        data["item"] = this.item;
        data["serialKey"] = this.serialKey;
        data["requestName"] = this.requestName;
        data["statusName"] = this.statusName;
        data["merchantCategory"] = this.merchantCategory;
        data["emailAddress"] = this.emailAddress;
        data["contactPerson"] = this.contactPerson;
        data["contactNo1"] = this.contactNo1;
        data["contactNo2"] = this.contactNo2;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["ticketNumber"] = this.ticketNumber;
        data["bankRemarks"] = this.bankRemarks;
        data["currency"] = this.currency;
        data["panNumber"] = this.panNumber;
        data["merchantCategoryId"] = this.merchantCategoryId;
        data["inventoryId"] = this.inventoryId;
        data["bankId"] = this.bankId;
        data["priority"] = this.priority;
        data["refund"] = this.refund;
        data["cashAdvance"] = this.cashAdvance;
        data["pinChange"] = this.pinChange;
        data["manualTransaction"] = this.manualTransaction;
        data["tipAdjustment"] = this.tipAdjustment;
        data["preAuthorization"] = this.preAuthorization;
        return data;
    }
}

export interface IDeploymentRequestListViewModel {
    id?: string;
    requestedDate?: string | undefined;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    merchant?: string | undefined;
    bankName?: string | undefined;
    branchName?: string | undefined;
    address?: string | undefined;
    district?: string | undefined;
    province?: string | undefined;
    item?: string | undefined;
    serialKey?: string | undefined;
    requestName?: string | undefined;
    statusName?: string | undefined;
    merchantCategory?: string | undefined;
    emailAddress?: string | undefined;
    contactPerson?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    ticketNumber?: string | undefined;
    bankRemarks?: string | undefined;
    currency?: string | undefined;
    panNumber?: string | undefined;
    merchantCategoryId?: string | undefined;
    inventoryId?: string | undefined;
    bankId?: string | undefined;
    priority?: boolean;
    refund?: boolean;
    cashAdvance?: boolean;
    pinChange?: boolean;
    manualTransaction?: boolean;
    tipAdjustment?: boolean;
    preAuthorization?: boolean;
}

export class DeploymentRequestConfigurationViewModel implements IDeploymentRequestConfigurationViewModel {
    id?: string;
    requestedDate?: string | undefined;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    merchant?: string | undefined;
    bankName?: string | undefined;
    bankStatus?: string | undefined;
    address?: string | undefined;
    district?: string | undefined;
    province?: string | undefined;
    item?: string | undefined;
    serialKey?: string | undefined;
    requestName?: string | undefined;
    statusName?: string | undefined;
    merchantCategory?: string | undefined;
    emailAddress?: string | undefined;
    contactPerson?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    ticketNumber?: string | undefined;
    bankRemarks?: string | undefined;
    currency?: string | undefined;
    kvc1?: string | undefined;
    kvc2?: string | undefined;
    component1?: string | undefined;
    component2?: string | undefined;
    combineValue?: string | undefined;
    finalValue?: string | undefined;
    merchantCategoryId?: string | undefined;
    inventoryId?: string | undefined;
    bankId?: string | undefined;

    constructor(data?: IDeploymentRequestConfigurationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.requestedDate = _data["requestedDate"];
            this.idMerchant = _data["idMerchant"];
            this.idTerminal = _data["idTerminal"];
            this.merchant = _data["merchant"];
            this.bankName = _data["bankName"];
            this.bankStatus = _data["bankStatus"];
            this.address = _data["address"];
            this.district = _data["district"];
            this.province = _data["province"];
            this.item = _data["item"];
            this.serialKey = _data["serialKey"];
            this.requestName = _data["requestName"];
            this.statusName = _data["statusName"];
            this.merchantCategory = _data["merchantCategory"];
            this.emailAddress = _data["emailAddress"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo1 = _data["contactNo1"];
            this.contactNo2 = _data["contactNo2"];
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.ticketNumber = _data["ticketNumber"];
            this.bankRemarks = _data["bankRemarks"];
            this.currency = _data["currency"];
            this.kvc1 = _data["kvc1"];
            this.kvc2 = _data["kvc2"];
            this.component1 = _data["component1"];
            this.component2 = _data["component2"];
            this.combineValue = _data["combineValue"];
            this.finalValue = _data["finalValue"];
            this.merchantCategoryId = _data["merchantCategoryId"];
            this.inventoryId = _data["inventoryId"];
            this.bankId = _data["bankId"];
        }
    }

    static fromJS(data: any): DeploymentRequestConfigurationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeploymentRequestConfigurationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["requestedDate"] = this.requestedDate;
        data["idMerchant"] = this.idMerchant;
        data["idTerminal"] = this.idTerminal;
        data["merchant"] = this.merchant;
        data["bankName"] = this.bankName;
        data["bankStatus"] = this.bankStatus;
        data["address"] = this.address;
        data["district"] = this.district;
        data["province"] = this.province;
        data["item"] = this.item;
        data["serialKey"] = this.serialKey;
        data["requestName"] = this.requestName;
        data["statusName"] = this.statusName;
        data["merchantCategory"] = this.merchantCategory;
        data["emailAddress"] = this.emailAddress;
        data["contactPerson"] = this.contactPerson;
        data["contactNo1"] = this.contactNo1;
        data["contactNo2"] = this.contactNo2;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["ticketNumber"] = this.ticketNumber;
        data["bankRemarks"] = this.bankRemarks;
        data["currency"] = this.currency;
        data["kvc1"] = this.kvc1;
        data["kvc2"] = this.kvc2;
        data["component1"] = this.component1;
        data["component2"] = this.component2;
        data["combineValue"] = this.combineValue;
        data["finalValue"] = this.finalValue;
        data["merchantCategoryId"] = this.merchantCategoryId;
        data["inventoryId"] = this.inventoryId;
        data["bankId"] = this.bankId;
        return data;
    }
}

export interface IDeploymentRequestConfigurationViewModel {
    id?: string;
    requestedDate?: string | undefined;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    merchant?: string | undefined;
    bankName?: string | undefined;
    bankStatus?: string | undefined;
    address?: string | undefined;
    district?: string | undefined;
    province?: string | undefined;
    item?: string | undefined;
    serialKey?: string | undefined;
    requestName?: string | undefined;
    statusName?: string | undefined;
    merchantCategory?: string | undefined;
    emailAddress?: string | undefined;
    contactPerson?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    ticketNumber?: string | undefined;
    bankRemarks?: string | undefined;
    currency?: string | undefined;
    kvc1?: string | undefined;
    kvc2?: string | undefined;
    component1?: string | undefined;
    component2?: string | undefined;
    combineValue?: string | undefined;
    finalValue?: string | undefined;
    merchantCategoryId?: string | undefined;
    inventoryId?: string | undefined;
    bankId?: string | undefined;
}

export class ReplacementRequestViewModel implements IReplacementRequestViewModel {
    id?: string;
    requestedDate?: string | undefined;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    merchant?: string | undefined;
    bankName?: string | undefined;
    address?: string | undefined;
    district?: string | undefined;
    province?: string | undefined;
    item?: string | undefined;
    previousSerial?: string | undefined;
    requestName?: string | undefined;
    statusName?: string | undefined;
    merchantCategory?: string | undefined;
    emailAddress?: string | undefined;
    contactPerson?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    bankRemarks?: string | undefined;
    panNumber?: string | undefined;
    merchantCategoryId?: string | undefined;
    inventoryId?: string | undefined;
    bankId?: string | undefined;
    property?: string | undefined;
    contactOfPos?: string | undefined;
    limit?: string | undefined;
    connectivity?: Connectivity[] | undefined;
    applicationVersionId?: string;
    deploymentRequestId?: string;
    inventoryAddId?: string;
    previousSerialNumberId?: string;
    receivedBy?: string | undefined;
    receivedContactNo?: string | undefined;
    deployedLocation?: string | undefined;
    kvc1?: string | undefined;
    kvc2?: string | undefined;
    component1?: string | undefined;
    component2?: string | undefined;
    combineValue?: string | undefined;
    finalValue?: string | undefined;
    bankBusinessPlan?: string | undefined;
    currency?: string | undefined;

    constructor(data?: IReplacementRequestViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.requestedDate = _data["requestedDate"];
            this.idMerchant = _data["idMerchant"];
            this.idTerminal = _data["idTerminal"];
            this.merchant = _data["merchant"];
            this.bankName = _data["bankName"];
            this.address = _data["address"];
            this.district = _data["district"];
            this.province = _data["province"];
            this.item = _data["item"];
            this.previousSerial = _data["previousSerial"];
            this.requestName = _data["requestName"];
            this.statusName = _data["statusName"];
            this.merchantCategory = _data["merchantCategory"];
            this.emailAddress = _data["emailAddress"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo1 = _data["contactNo1"];
            this.contactNo2 = _data["contactNo2"];
            this.bankRemarks = _data["bankRemarks"];
            this.panNumber = _data["panNumber"];
            this.merchantCategoryId = _data["merchantCategoryId"];
            this.inventoryId = _data["inventoryId"];
            this.bankId = _data["bankId"];
            this.property = _data["property"];
            this.contactOfPos = _data["contactOfPos"];
            this.limit = _data["limit"];
            if (Array.isArray(_data["connectivity"])) {
                this.connectivity = [] as any;
                for (let item of _data["connectivity"])
                    this.connectivity!.push(item);
            }
            this.applicationVersionId = _data["applicationVersionId"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.inventoryAddId = _data["inventoryAddId"];
            this.previousSerialNumberId = _data["previousSerialNumberId"];
            this.receivedBy = _data["receivedBy"];
            this.receivedContactNo = _data["receivedContactNo"];
            this.deployedLocation = _data["deployedLocation"];
            this.kvc1 = _data["kvc1"];
            this.kvc2 = _data["kvc2"];
            this.component1 = _data["component1"];
            this.component2 = _data["component2"];
            this.combineValue = _data["combineValue"];
            this.finalValue = _data["finalValue"];
            this.bankBusinessPlan = _data["bankBusinessPlan"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): ReplacementRequestViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReplacementRequestViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["requestedDate"] = this.requestedDate;
        data["idMerchant"] = this.idMerchant;
        data["idTerminal"] = this.idTerminal;
        data["merchant"] = this.merchant;
        data["bankName"] = this.bankName;
        data["address"] = this.address;
        data["district"] = this.district;
        data["province"] = this.province;
        data["item"] = this.item;
        data["previousSerial"] = this.previousSerial;
        data["requestName"] = this.requestName;
        data["statusName"] = this.statusName;
        data["merchantCategory"] = this.merchantCategory;
        data["emailAddress"] = this.emailAddress;
        data["contactPerson"] = this.contactPerson;
        data["contactNo1"] = this.contactNo1;
        data["contactNo2"] = this.contactNo2;
        data["bankRemarks"] = this.bankRemarks;
        data["panNumber"] = this.panNumber;
        data["merchantCategoryId"] = this.merchantCategoryId;
        data["inventoryId"] = this.inventoryId;
        data["bankId"] = this.bankId;
        data["property"] = this.property;
        data["contactOfPos"] = this.contactOfPos;
        data["limit"] = this.limit;
        if (Array.isArray(this.connectivity)) {
            data["connectivity"] = [];
            for (let item of this.connectivity)
                data["connectivity"].push(item);
        }
        data["applicationVersionId"] = this.applicationVersionId;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["inventoryAddId"] = this.inventoryAddId;
        data["previousSerialNumberId"] = this.previousSerialNumberId;
        data["receivedBy"] = this.receivedBy;
        data["receivedContactNo"] = this.receivedContactNo;
        data["deployedLocation"] = this.deployedLocation;
        data["kvc1"] = this.kvc1;
        data["kvc2"] = this.kvc2;
        data["component1"] = this.component1;
        data["component2"] = this.component2;
        data["combineValue"] = this.combineValue;
        data["finalValue"] = this.finalValue;
        data["bankBusinessPlan"] = this.bankBusinessPlan;
        data["currency"] = this.currency;
        return data;
    }
}

export interface IReplacementRequestViewModel {
    id?: string;
    requestedDate?: string | undefined;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    merchant?: string | undefined;
    bankName?: string | undefined;
    address?: string | undefined;
    district?: string | undefined;
    province?: string | undefined;
    item?: string | undefined;
    previousSerial?: string | undefined;
    requestName?: string | undefined;
    statusName?: string | undefined;
    merchantCategory?: string | undefined;
    emailAddress?: string | undefined;
    contactPerson?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    bankRemarks?: string | undefined;
    panNumber?: string | undefined;
    merchantCategoryId?: string | undefined;
    inventoryId?: string | undefined;
    bankId?: string | undefined;
    property?: string | undefined;
    contactOfPos?: string | undefined;
    limit?: string | undefined;
    connectivity?: Connectivity[] | undefined;
    applicationVersionId?: string;
    deploymentRequestId?: string;
    inventoryAddId?: string;
    previousSerialNumberId?: string;
    receivedBy?: string | undefined;
    receivedContactNo?: string | undefined;
    deployedLocation?: string | undefined;
    kvc1?: string | undefined;
    kvc2?: string | undefined;
    component1?: string | undefined;
    component2?: string | undefined;
    combineValue?: string | undefined;
    finalValue?: string | undefined;
    bankBusinessPlan?: string | undefined;
    currency?: string | undefined;
}

export class InventoryandAddViewModel implements IInventoryandAddViewModel {
    id?: string;
    totalNumber?: number;
    totalSoldDeploy?: number;
    totalSoldUnDeployed?: number;
    item?: string | undefined;
    remainingNumber?: number;
    soldNumber?: number;
    soldOut?: number;
    deployNumber?: number;
    maintenanceNumber?: number;
    notReceivedNumber?: number;
    damageNumber?: number;
    availableAfterConfiguration?: number;
    availableAfterSold?: number;
    availableAfterDeploy?: number;
    available?: number;
    pendingDeploy?: number;
    configureNumber?: number;
    pendingDeploymentRequest?: number;
    reConfigureNumber?: number;
    buyDate?: Date;
    shortName?: string | undefined;
    vendorName?: string | undefined;
    deploymentRequestId?: string;
    inventoryId?: string;
    bankId?: string;
    serialNumberId?: string;
    serialNumber?: string | undefined;
    serialCount?: number;
    serialKey?: string | undefined;
    inventoryAddId?: string;
    inventory?: string | undefined;
    os?: string | undefined;
    series?: string | undefined;
    model?: string | undefined;
    description?: string | undefined;
    mainItem?: string | undefined;
    subItem?: string | undefined;
    thirdItem?: string | undefined;
    detailInventoryAddItem?: string | undefined;
    hasSerialNo?: boolean;
    stock?: number;
    unDeployed?: number;
    deployed?: number;
    total?: number;
    bankName?: string | undefined;
    bankStatus?: string | undefined;
    serialLength?: string | undefined;
    merchantSold?: number;
    bankSold?: number;
    delieveredatDelivery?: number;
    stickersDelivered?: number;
    remainingNumberRolls?: number;
    soldNumberRolls?: number;
    bankSoldRolls?: number;
    rollsatDelivery?: number;
    merchantSoldRolls?: number;
    totalNumberRolls?: number;
    rollsRemaining?: number;
    bankStickerRemaining?: number;
    bankSoldSticker?: number;
    soldNumberStickcer?: number;

    constructor(data?: IInventoryandAddViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.totalNumber = _data["totalNumber"];
            this.totalSoldDeploy = _data["totalSoldDeploy"];
            this.totalSoldUnDeployed = _data["totalSoldUnDeployed"];
            this.item = _data["item"];
            this.remainingNumber = _data["remainingNumber"];
            this.soldNumber = _data["soldNumber"];
            this.soldOut = _data["soldOut"];
            this.deployNumber = _data["deployNumber"];
            this.maintenanceNumber = _data["maintenanceNumber"];
            this.notReceivedNumber = _data["notReceivedNumber"];
            this.damageNumber = _data["damageNumber"];
            this.availableAfterConfiguration = _data["availableAfterConfiguration"];
            this.availableAfterSold = _data["availableAfterSold"];
            this.availableAfterDeploy = _data["availableAfterDeploy"];
            this.available = _data["available"];
            this.pendingDeploy = _data["pendingDeploy"];
            this.configureNumber = _data["configureNumber"];
            this.pendingDeploymentRequest = _data["pendingDeploymentRequest"];
            this.reConfigureNumber = _data["reConfigureNumber"];
            this.buyDate = _data["buyDate"] ? new Date(_data["buyDate"].toString()) : <any>undefined;
            this.shortName = _data["shortName"];
            this.vendorName = _data["vendorName"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.inventoryId = _data["inventoryId"];
            this.bankId = _data["bankId"];
            this.serialNumberId = _data["serialNumberId"];
            this.serialNumber = _data["serialNumber"];
            this.serialCount = _data["serialCount"];
            this.serialKey = _data["serialKey"];
            this.inventoryAddId = _data["inventoryAddId"];
            this.inventory = _data["inventory"];
            this.os = _data["os"];
            this.series = _data["series"];
            this.model = _data["model"];
            this.description = _data["description"];
            this.mainItem = _data["mainItem"];
            this.subItem = _data["subItem"];
            this.thirdItem = _data["thirdItem"];
            this.detailInventoryAddItem = _data["detailInventoryAddItem"];
            this.hasSerialNo = _data["hasSerialNo"];
            this.stock = _data["stock"];
            this.unDeployed = _data["unDeployed"];
            this.deployed = _data["deployed"];
            this.total = _data["total"];
            this.bankName = _data["bankName"];
            this.bankStatus = _data["bankStatus"];
            this.serialLength = _data["serialLength"];
            this.merchantSold = _data["merchantSold"];
            this.bankSold = _data["bankSold"];
            this.delieveredatDelivery = _data["delieveredatDelivery"];
            this.stickersDelivered = _data["stickersDelivered"];
            this.remainingNumberRolls = _data["remainingNumberRolls"];
            this.soldNumberRolls = _data["soldNumberRolls"];
            this.bankSoldRolls = _data["bankSoldRolls"];
            this.rollsatDelivery = _data["rollsatDelivery"];
            this.merchantSoldRolls = _data["merchantSoldRolls"];
            this.totalNumberRolls = _data["totalNumberRolls"];
            this.rollsRemaining = _data["rollsRemaining"];
            this.bankStickerRemaining = _data["bankStickerRemaining"];
            this.bankSoldSticker = _data["bankSoldSticker"];
            this.soldNumberStickcer = _data["soldNumberStickcer"];
        }
    }

    static fromJS(data: any): InventoryandAddViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryandAddViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["totalNumber"] = this.totalNumber;
        data["totalSoldDeploy"] = this.totalSoldDeploy;
        data["totalSoldUnDeployed"] = this.totalSoldUnDeployed;
        data["item"] = this.item;
        data["remainingNumber"] = this.remainingNumber;
        data["soldNumber"] = this.soldNumber;
        data["soldOut"] = this.soldOut;
        data["deployNumber"] = this.deployNumber;
        data["maintenanceNumber"] = this.maintenanceNumber;
        data["notReceivedNumber"] = this.notReceivedNumber;
        data["damageNumber"] = this.damageNumber;
        data["availableAfterConfiguration"] = this.availableAfterConfiguration;
        data["availableAfterSold"] = this.availableAfterSold;
        data["availableAfterDeploy"] = this.availableAfterDeploy;
        data["available"] = this.available;
        data["pendingDeploy"] = this.pendingDeploy;
        data["configureNumber"] = this.configureNumber;
        data["pendingDeploymentRequest"] = this.pendingDeploymentRequest;
        data["reConfigureNumber"] = this.reConfigureNumber;
        data["buyDate"] = this.buyDate ? this.buyDate.toISOString() : <any>undefined;
        data["shortName"] = this.shortName;
        data["vendorName"] = this.vendorName;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["inventoryId"] = this.inventoryId;
        data["bankId"] = this.bankId;
        data["serialNumberId"] = this.serialNumberId;
        data["serialNumber"] = this.serialNumber;
        data["serialCount"] = this.serialCount;
        data["serialKey"] = this.serialKey;
        data["inventoryAddId"] = this.inventoryAddId;
        data["inventory"] = this.inventory;
        data["os"] = this.os;
        data["series"] = this.series;
        data["model"] = this.model;
        data["description"] = this.description;
        data["mainItem"] = this.mainItem;
        data["subItem"] = this.subItem;
        data["thirdItem"] = this.thirdItem;
        data["detailInventoryAddItem"] = this.detailInventoryAddItem;
        data["hasSerialNo"] = this.hasSerialNo;
        data["stock"] = this.stock;
        data["unDeployed"] = this.unDeployed;
        data["deployed"] = this.deployed;
        data["total"] = this.total;
        data["bankName"] = this.bankName;
        data["bankStatus"] = this.bankStatus;
        data["serialLength"] = this.serialLength;
        data["merchantSold"] = this.merchantSold;
        data["bankSold"] = this.bankSold;
        data["delieveredatDelivery"] = this.delieveredatDelivery;
        data["stickersDelivered"] = this.stickersDelivered;
        data["remainingNumberRolls"] = this.remainingNumberRolls;
        data["soldNumberRolls"] = this.soldNumberRolls;
        data["bankSoldRolls"] = this.bankSoldRolls;
        data["rollsatDelivery"] = this.rollsatDelivery;
        data["merchantSoldRolls"] = this.merchantSoldRolls;
        data["totalNumberRolls"] = this.totalNumberRolls;
        data["rollsRemaining"] = this.rollsRemaining;
        data["bankStickerRemaining"] = this.bankStickerRemaining;
        data["bankSoldSticker"] = this.bankSoldSticker;
        data["soldNumberStickcer"] = this.soldNumberStickcer;
        return data;
    }
}

export interface IInventoryandAddViewModel {
    id?: string;
    totalNumber?: number;
    totalSoldDeploy?: number;
    totalSoldUnDeployed?: number;
    item?: string | undefined;
    remainingNumber?: number;
    soldNumber?: number;
    soldOut?: number;
    deployNumber?: number;
    maintenanceNumber?: number;
    notReceivedNumber?: number;
    damageNumber?: number;
    availableAfterConfiguration?: number;
    availableAfterSold?: number;
    availableAfterDeploy?: number;
    available?: number;
    pendingDeploy?: number;
    configureNumber?: number;
    pendingDeploymentRequest?: number;
    reConfigureNumber?: number;
    buyDate?: Date;
    shortName?: string | undefined;
    vendorName?: string | undefined;
    deploymentRequestId?: string;
    inventoryId?: string;
    bankId?: string;
    serialNumberId?: string;
    serialNumber?: string | undefined;
    serialCount?: number;
    serialKey?: string | undefined;
    inventoryAddId?: string;
    inventory?: string | undefined;
    os?: string | undefined;
    series?: string | undefined;
    model?: string | undefined;
    description?: string | undefined;
    mainItem?: string | undefined;
    subItem?: string | undefined;
    thirdItem?: string | undefined;
    detailInventoryAddItem?: string | undefined;
    hasSerialNo?: boolean;
    stock?: number;
    unDeployed?: number;
    deployed?: number;
    total?: number;
    bankName?: string | undefined;
    bankStatus?: string | undefined;
    serialLength?: string | undefined;
    merchantSold?: number;
    bankSold?: number;
    delieveredatDelivery?: number;
    stickersDelivered?: number;
    remainingNumberRolls?: number;
    soldNumberRolls?: number;
    bankSoldRolls?: number;
    rollsatDelivery?: number;
    merchantSoldRolls?: number;
    totalNumberRolls?: number;
    rollsRemaining?: number;
    bankStickerRemaining?: number;
    bankSoldSticker?: number;
    soldNumberStickcer?: number;
}

export class DeploymentRequestByIdTerminalQuery implements IDeploymentRequestByIdTerminalQuery {
    requestedDate?: string | undefined;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    merchant?: string | undefined;
    bankName?: string | undefined;
    branchName?: string | undefined;
    address?: string | undefined;
    district?: string | undefined;
    province?: string | undefined;
    item?: string | undefined;
    serialKey?: string | undefined;
    requestName?: string | undefined;
    statusName?: string | undefined;
    merchantCategory?: string | undefined;
    emailAddress?: string | undefined;
    contactPerson?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    updatedBy?: string | undefined;
    latitude?: string | undefined;
    longitude?: string | undefined;
    deploymentActivityLogs?: DeploymentActivityLogData[] | undefined;

    constructor(data?: IDeploymentRequestByIdTerminalQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestedDate = _data["requestedDate"];
            this.idMerchant = _data["idMerchant"];
            this.idTerminal = _data["idTerminal"];
            this.merchant = _data["merchant"];
            this.bankName = _data["bankName"];
            this.branchName = _data["branchName"];
            this.address = _data["address"];
            this.district = _data["district"];
            this.province = _data["province"];
            this.item = _data["item"];
            this.serialKey = _data["serialKey"];
            this.requestName = _data["requestName"];
            this.statusName = _data["statusName"];
            this.merchantCategory = _data["merchantCategory"];
            this.emailAddress = _data["emailAddress"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo1 = _data["contactNo1"];
            this.contactNo2 = _data["contactNo2"];
            this.updatedBy = _data["updatedBy"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            if (Array.isArray(_data["deploymentActivityLogs"])) {
                this.deploymentActivityLogs = [] as any;
                for (let item of _data["deploymentActivityLogs"])
                    this.deploymentActivityLogs!.push(DeploymentActivityLogData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeploymentRequestByIdTerminalQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DeploymentRequestByIdTerminalQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestedDate"] = this.requestedDate;
        data["idMerchant"] = this.idMerchant;
        data["idTerminal"] = this.idTerminal;
        data["merchant"] = this.merchant;
        data["bankName"] = this.bankName;
        data["branchName"] = this.branchName;
        data["address"] = this.address;
        data["district"] = this.district;
        data["province"] = this.province;
        data["item"] = this.item;
        data["serialKey"] = this.serialKey;
        data["requestName"] = this.requestName;
        data["statusName"] = this.statusName;
        data["merchantCategory"] = this.merchantCategory;
        data["emailAddress"] = this.emailAddress;
        data["contactPerson"] = this.contactPerson;
        data["contactNo1"] = this.contactNo1;
        data["contactNo2"] = this.contactNo2;
        data["updatedBy"] = this.updatedBy;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        if (Array.isArray(this.deploymentActivityLogs)) {
            data["deploymentActivityLogs"] = [];
            for (let item of this.deploymentActivityLogs)
                data["deploymentActivityLogs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDeploymentRequestByIdTerminalQuery {
    requestedDate?: string | undefined;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    merchant?: string | undefined;
    bankName?: string | undefined;
    branchName?: string | undefined;
    address?: string | undefined;
    district?: string | undefined;
    province?: string | undefined;
    item?: string | undefined;
    serialKey?: string | undefined;
    requestName?: string | undefined;
    statusName?: string | undefined;
    merchantCategory?: string | undefined;
    emailAddress?: string | undefined;
    contactPerson?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    updatedBy?: string | undefined;
    latitude?: string | undefined;
    longitude?: string | undefined;
    deploymentActivityLogs?: DeploymentActivityLogData[] | undefined;
}

export class DeploymentActivityLogData implements IDeploymentActivityLogData {
    id?: string;
    createdDate?: string | undefined;
    createdBy?: string | undefined;
    deploymentStatus?: DeploymentStatus;
    deploymentStatusDisplayName?: string | undefined;

    constructor(data?: IDeploymentActivityLogData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDate = _data["createdDate"];
            this.createdBy = _data["createdBy"];
            this.deploymentStatus = _data["deploymentStatus"];
            this.deploymentStatusDisplayName = _data["deploymentStatusDisplayName"];
        }
    }

    static fromJS(data: any): DeploymentActivityLogData {
        data = typeof data === 'object' ? data : {};
        let result = new DeploymentActivityLogData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDate"] = this.createdDate;
        data["createdBy"] = this.createdBy;
        data["deploymentStatus"] = this.deploymentStatus;
        data["deploymentStatusDisplayName"] = this.deploymentStatusDisplayName;
        return data;
    }
}

export interface IDeploymentActivityLogData {
    id?: string;
    createdDate?: string | undefined;
    createdBy?: string | undefined;
    deploymentStatus?: DeploymentStatus;
    deploymentStatusDisplayName?: string | undefined;
}

export class DeploymentRequestViewModel implements IDeploymentRequestViewModel {
    id?: string | undefined;
    bankId?: string;
    bankAddress?: string | undefined;
    bankRemarks?: string | undefined;
    merchant?: string | undefined;
    idMerchant?: string | undefined;
    outlet?: string | undefined;
    district?: string | undefined;
    address?: string | undefined;
    province?: string | undefined;
    merchantCategory?: string | undefined;
    contactPerson?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    idTerminal?: string | undefined;
    terminalType?: string | undefined;
    inventoryId?: string;
    inventoryAddId?: string | undefined;
    rentalInventoryAdd?: string | undefined;
    item?: string | undefined;
    currency?: string | undefined;
    tipAdjustment?: boolean;
    requestedDate?: Date | undefined;
    manualTransaction?: boolean;
    preAuthorization?: boolean;
    cashAdvance?: boolean;
    pinChange?: boolean;
    component1?: string | undefined;
    component2?: string | undefined;
    combineValue?: string | undefined;
    finalValue?: string | undefined;
    kvc1?: string | undefined;
    kvc2?: string | undefined;
    branchName?: string | undefined;
    mcc?: string | undefined;
    businessNature?: string | undefined;
    refNumberPrint?: string | undefined;
    emailAddress?: string | undefined;
    priority?: boolean;
    statusId?: string | undefined;
    remarks?: string | undefined;
    statusForDeploy?: string | undefined;
    remarksForDeploy?: string | undefined;
    verification?: string | undefined;
    requestTypeId?: string | undefined;
    applicationVersionId?: string | undefined;
    applicationVersion?: string | undefined;
    checkerId?: string | undefined;
    refund?: boolean;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    requestName?: string | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    createdDate?: Date | undefined;
    configBy?: string | undefined;
    updatedDate?: Date | undefined;
    serialKey?: string | undefined;
    previousSerialKey?: string | undefined;
    previousSerialStatus?: string | undefined;
    statusName?: string | undefined;
    bankName?: string | undefined;
    merchantLocation?: string | undefined;
    serialNumberId?: string | undefined;
    panNumber?: string | undefined;
    contactOfPos?: string | undefined;
    property?: string | undefined;
    serialNumber?: string | undefined;
    locationForPartialRental?: string | undefined;
    remarksForPartialRental?: string | undefined;
    soldDate?: Date | undefined;
    receivedBy?: string | undefined;
    receivedContactNo?: string | undefined;
    connectivities?: string | undefined;
    settlementPrimaryId?: string | undefined;
    settlementSecondaryId?: string | undefined;
    transactionPrimaryId?: string | undefined;
    transactionSecondaryId?: string | undefined;
    merchantCategoryId?: string | undefined;
    pendingSupports?: StatusPending[] | undefined;

    constructor(data?: IDeploymentRequestViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bankId = _data["bankId"];
            this.bankAddress = _data["bankAddress"];
            this.bankRemarks = _data["bankRemarks"];
            this.merchant = _data["merchant"];
            this.idMerchant = _data["idMerchant"];
            this.outlet = _data["outlet"];
            this.district = _data["district"];
            this.address = _data["address"];
            this.province = _data["province"];
            this.merchantCategory = _data["merchantCategory"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo1 = _data["contactNo1"];
            this.contactNo2 = _data["contactNo2"];
            this.idTerminal = _data["idTerminal"];
            this.terminalType = _data["terminalType"];
            this.inventoryId = _data["inventoryId"];
            this.inventoryAddId = _data["inventoryAddId"];
            this.rentalInventoryAdd = _data["rentalInventoryAdd"];
            this.item = _data["item"];
            this.currency = _data["currency"];
            this.tipAdjustment = _data["tipAdjustment"];
            this.requestedDate = _data["requestedDate"] ? new Date(_data["requestedDate"].toString()) : <any>undefined;
            this.manualTransaction = _data["manualTransaction"];
            this.preAuthorization = _data["preAuthorization"];
            this.cashAdvance = _data["cashAdvance"];
            this.pinChange = _data["pinChange"];
            this.component1 = _data["component1"];
            this.component2 = _data["component2"];
            this.combineValue = _data["combineValue"];
            this.finalValue = _data["finalValue"];
            this.kvc1 = _data["kvc1"];
            this.kvc2 = _data["kvc2"];
            this.branchName = _data["branchName"];
            this.mcc = _data["mcc"];
            this.businessNature = _data["businessNature"];
            this.refNumberPrint = _data["refNumberPrint"];
            this.emailAddress = _data["emailAddress"];
            this.priority = _data["priority"];
            this.statusId = _data["statusId"];
            this.remarks = _data["remarks"];
            this.statusForDeploy = _data["statusForDeploy"];
            this.remarksForDeploy = _data["remarksForDeploy"];
            this.verification = _data["verification"];
            this.requestTypeId = _data["requestTypeId"];
            this.applicationVersionId = _data["applicationVersionId"];
            this.applicationVersion = _data["applicationVersion"];
            this.checkerId = _data["checkerId"];
            this.refund = _data["refund"];
            this.primaryItem = _data["primaryItem"];
            this.secondaryItem = _data["secondaryItem"];
            this.tertiaryItem = _data["tertiaryItem"];
            this.detailItem = _data["detailItem"];
            this.requestName = _data["requestName"];
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.configBy = _data["configBy"];
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.serialKey = _data["serialKey"];
            this.previousSerialKey = _data["previousSerialKey"];
            this.previousSerialStatus = _data["previousSerialStatus"];
            this.statusName = _data["statusName"];
            this.bankName = _data["bankName"];
            this.merchantLocation = _data["merchantLocation"];
            this.serialNumberId = _data["serialNumberId"];
            this.panNumber = _data["panNumber"];
            this.contactOfPos = _data["contactOfPos"];
            this.property = _data["property"];
            this.serialNumber = _data["serialNumber"];
            this.locationForPartialRental = _data["locationForPartialRental"];
            this.remarksForPartialRental = _data["remarksForPartialRental"];
            this.soldDate = _data["soldDate"] ? new Date(_data["soldDate"].toString()) : <any>undefined;
            this.receivedBy = _data["receivedBy"];
            this.receivedContactNo = _data["receivedContactNo"];
            this.connectivities = _data["connectivities"];
            this.settlementPrimaryId = _data["settlementPrimaryId"];
            this.settlementSecondaryId = _data["settlementSecondaryId"];
            this.transactionPrimaryId = _data["transactionPrimaryId"];
            this.transactionSecondaryId = _data["transactionSecondaryId"];
            this.merchantCategoryId = _data["merchantCategoryId"];
            if (Array.isArray(_data["pendingSupports"])) {
                this.pendingSupports = [] as any;
                for (let item of _data["pendingSupports"])
                    this.pendingSupports!.push(StatusPending.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeploymentRequestViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeploymentRequestViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankId"] = this.bankId;
        data["bankAddress"] = this.bankAddress;
        data["bankRemarks"] = this.bankRemarks;
        data["merchant"] = this.merchant;
        data["idMerchant"] = this.idMerchant;
        data["outlet"] = this.outlet;
        data["district"] = this.district;
        data["address"] = this.address;
        data["province"] = this.province;
        data["merchantCategory"] = this.merchantCategory;
        data["contactPerson"] = this.contactPerson;
        data["contactNo1"] = this.contactNo1;
        data["contactNo2"] = this.contactNo2;
        data["idTerminal"] = this.idTerminal;
        data["terminalType"] = this.terminalType;
        data["inventoryId"] = this.inventoryId;
        data["inventoryAddId"] = this.inventoryAddId;
        data["rentalInventoryAdd"] = this.rentalInventoryAdd;
        data["item"] = this.item;
        data["currency"] = this.currency;
        data["tipAdjustment"] = this.tipAdjustment;
        data["requestedDate"] = this.requestedDate ? this.requestedDate.toISOString() : <any>undefined;
        data["manualTransaction"] = this.manualTransaction;
        data["preAuthorization"] = this.preAuthorization;
        data["cashAdvance"] = this.cashAdvance;
        data["pinChange"] = this.pinChange;
        data["component1"] = this.component1;
        data["component2"] = this.component2;
        data["combineValue"] = this.combineValue;
        data["finalValue"] = this.finalValue;
        data["kvc1"] = this.kvc1;
        data["kvc2"] = this.kvc2;
        data["branchName"] = this.branchName;
        data["mcc"] = this.mcc;
        data["businessNature"] = this.businessNature;
        data["refNumberPrint"] = this.refNumberPrint;
        data["emailAddress"] = this.emailAddress;
        data["priority"] = this.priority;
        data["statusId"] = this.statusId;
        data["remarks"] = this.remarks;
        data["statusForDeploy"] = this.statusForDeploy;
        data["remarksForDeploy"] = this.remarksForDeploy;
        data["verification"] = this.verification;
        data["requestTypeId"] = this.requestTypeId;
        data["applicationVersionId"] = this.applicationVersionId;
        data["applicationVersion"] = this.applicationVersion;
        data["checkerId"] = this.checkerId;
        data["refund"] = this.refund;
        data["primaryItem"] = this.primaryItem;
        data["secondaryItem"] = this.secondaryItem;
        data["tertiaryItem"] = this.tertiaryItem;
        data["detailItem"] = this.detailItem;
        data["requestName"] = this.requestName;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["configBy"] = this.configBy;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["serialKey"] = this.serialKey;
        data["previousSerialKey"] = this.previousSerialKey;
        data["previousSerialStatus"] = this.previousSerialStatus;
        data["statusName"] = this.statusName;
        data["bankName"] = this.bankName;
        data["merchantLocation"] = this.merchantLocation;
        data["serialNumberId"] = this.serialNumberId;
        data["panNumber"] = this.panNumber;
        data["contactOfPos"] = this.contactOfPos;
        data["property"] = this.property;
        data["serialNumber"] = this.serialNumber;
        data["locationForPartialRental"] = this.locationForPartialRental;
        data["remarksForPartialRental"] = this.remarksForPartialRental;
        data["soldDate"] = this.soldDate ? this.soldDate.toISOString() : <any>undefined;
        data["receivedBy"] = this.receivedBy;
        data["receivedContactNo"] = this.receivedContactNo;
        data["connectivities"] = this.connectivities;
        data["settlementPrimaryId"] = this.settlementPrimaryId;
        data["settlementSecondaryId"] = this.settlementSecondaryId;
        data["transactionPrimaryId"] = this.transactionPrimaryId;
        data["transactionSecondaryId"] = this.transactionSecondaryId;
        data["merchantCategoryId"] = this.merchantCategoryId;
        if (Array.isArray(this.pendingSupports)) {
            data["pendingSupports"] = [];
            for (let item of this.pendingSupports)
                data["pendingSupports"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDeploymentRequestViewModel {
    id?: string | undefined;
    bankId?: string;
    bankAddress?: string | undefined;
    bankRemarks?: string | undefined;
    merchant?: string | undefined;
    idMerchant?: string | undefined;
    outlet?: string | undefined;
    district?: string | undefined;
    address?: string | undefined;
    province?: string | undefined;
    merchantCategory?: string | undefined;
    contactPerson?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    idTerminal?: string | undefined;
    terminalType?: string | undefined;
    inventoryId?: string;
    inventoryAddId?: string | undefined;
    rentalInventoryAdd?: string | undefined;
    item?: string | undefined;
    currency?: string | undefined;
    tipAdjustment?: boolean;
    requestedDate?: Date | undefined;
    manualTransaction?: boolean;
    preAuthorization?: boolean;
    cashAdvance?: boolean;
    pinChange?: boolean;
    component1?: string | undefined;
    component2?: string | undefined;
    combineValue?: string | undefined;
    finalValue?: string | undefined;
    kvc1?: string | undefined;
    kvc2?: string | undefined;
    branchName?: string | undefined;
    mcc?: string | undefined;
    businessNature?: string | undefined;
    refNumberPrint?: string | undefined;
    emailAddress?: string | undefined;
    priority?: boolean;
    statusId?: string | undefined;
    remarks?: string | undefined;
    statusForDeploy?: string | undefined;
    remarksForDeploy?: string | undefined;
    verification?: string | undefined;
    requestTypeId?: string | undefined;
    applicationVersionId?: string | undefined;
    applicationVersion?: string | undefined;
    checkerId?: string | undefined;
    refund?: boolean;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    requestName?: string | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    createdDate?: Date | undefined;
    configBy?: string | undefined;
    updatedDate?: Date | undefined;
    serialKey?: string | undefined;
    previousSerialKey?: string | undefined;
    previousSerialStatus?: string | undefined;
    statusName?: string | undefined;
    bankName?: string | undefined;
    merchantLocation?: string | undefined;
    serialNumberId?: string | undefined;
    panNumber?: string | undefined;
    contactOfPos?: string | undefined;
    property?: string | undefined;
    serialNumber?: string | undefined;
    locationForPartialRental?: string | undefined;
    remarksForPartialRental?: string | undefined;
    soldDate?: Date | undefined;
    receivedBy?: string | undefined;
    receivedContactNo?: string | undefined;
    connectivities?: string | undefined;
    settlementPrimaryId?: string | undefined;
    settlementSecondaryId?: string | undefined;
    transactionPrimaryId?: string | undefined;
    transactionSecondaryId?: string | undefined;
    merchantCategoryId?: string | undefined;
    pendingSupports?: StatusPending[] | undefined;
}

export class StatusPending implements IStatusPending {
    value?: number;
    text?: string | undefined;

    constructor(data?: IStatusPending) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): StatusPending {
        data = typeof data === 'object' ? data : {};
        let result = new StatusPending();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["text"] = this.text;
        return data;
    }
}

export interface IStatusPending {
    value?: number;
    text?: string | undefined;
}

export class UpdateAndVerifyNewDeploymentrequestCommand implements IUpdateAndVerifyNewDeploymentrequestCommand {
    id?: string;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    merchant?: string | undefined;
    bankName?: string | undefined;
    address?: string | undefined;
    district?: string | undefined;
    province?: string | undefined;
    item?: string | undefined;
    serialKey?: string | undefined;
    requestName?: string | undefined;
    statusName?: string | undefined;
    merchantCategory?: string | undefined;
    emailAddress?: string | undefined;
    contactPerson?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    updatedBy?: string | undefined;
    bankRemarks?: string | undefined;
    panNumber?: string | undefined;
    merchantCategoryId?: string | undefined;
    inventoryId?: string | undefined;
    bankId?: string | undefined;
    priority?: boolean;
    refund?: boolean;
    cashAdvance?: boolean;
    pinChange?: boolean;
    manualTransaction?: boolean;
    tipAdjustment?: boolean;
    preAuthorization?: boolean;
    imarkMerchantId?: string | undefined;

    constructor(data?: IUpdateAndVerifyNewDeploymentrequestCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idMerchant = _data["idMerchant"];
            this.idTerminal = _data["idTerminal"];
            this.merchant = _data["merchant"];
            this.bankName = _data["bankName"];
            this.address = _data["address"];
            this.district = _data["district"];
            this.province = _data["province"];
            this.item = _data["item"];
            this.serialKey = _data["serialKey"];
            this.requestName = _data["requestName"];
            this.statusName = _data["statusName"];
            this.merchantCategory = _data["merchantCategory"];
            this.emailAddress = _data["emailAddress"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo1 = _data["contactNo1"];
            this.contactNo2 = _data["contactNo2"];
            this.updatedBy = _data["updatedBy"];
            this.bankRemarks = _data["bankRemarks"];
            this.panNumber = _data["panNumber"];
            this.merchantCategoryId = _data["merchantCategoryId"];
            this.inventoryId = _data["inventoryId"];
            this.bankId = _data["bankId"];
            this.priority = _data["priority"];
            this.refund = _data["refund"];
            this.cashAdvance = _data["cashAdvance"];
            this.pinChange = _data["pinChange"];
            this.manualTransaction = _data["manualTransaction"];
            this.tipAdjustment = _data["tipAdjustment"];
            this.preAuthorization = _data["preAuthorization"];
            this.imarkMerchantId = _data["imarkMerchantId"];
        }
    }

    static fromJS(data: any): UpdateAndVerifyNewDeploymentrequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAndVerifyNewDeploymentrequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idMerchant"] = this.idMerchant;
        data["idTerminal"] = this.idTerminal;
        data["merchant"] = this.merchant;
        data["bankName"] = this.bankName;
        data["address"] = this.address;
        data["district"] = this.district;
        data["province"] = this.province;
        data["item"] = this.item;
        data["serialKey"] = this.serialKey;
        data["requestName"] = this.requestName;
        data["statusName"] = this.statusName;
        data["merchantCategory"] = this.merchantCategory;
        data["emailAddress"] = this.emailAddress;
        data["contactPerson"] = this.contactPerson;
        data["contactNo1"] = this.contactNo1;
        data["contactNo2"] = this.contactNo2;
        data["updatedBy"] = this.updatedBy;
        data["bankRemarks"] = this.bankRemarks;
        data["panNumber"] = this.panNumber;
        data["merchantCategoryId"] = this.merchantCategoryId;
        data["inventoryId"] = this.inventoryId;
        data["bankId"] = this.bankId;
        data["priority"] = this.priority;
        data["refund"] = this.refund;
        data["cashAdvance"] = this.cashAdvance;
        data["pinChange"] = this.pinChange;
        data["manualTransaction"] = this.manualTransaction;
        data["tipAdjustment"] = this.tipAdjustment;
        data["preAuthorization"] = this.preAuthorization;
        data["imarkMerchantId"] = this.imarkMerchantId;
        return data;
    }
}

export interface IUpdateAndVerifyNewDeploymentrequestCommand {
    id?: string;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    merchant?: string | undefined;
    bankName?: string | undefined;
    address?: string | undefined;
    district?: string | undefined;
    province?: string | undefined;
    item?: string | undefined;
    serialKey?: string | undefined;
    requestName?: string | undefined;
    statusName?: string | undefined;
    merchantCategory?: string | undefined;
    emailAddress?: string | undefined;
    contactPerson?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    updatedBy?: string | undefined;
    bankRemarks?: string | undefined;
    panNumber?: string | undefined;
    merchantCategoryId?: string | undefined;
    inventoryId?: string | undefined;
    bankId?: string | undefined;
    priority?: boolean;
    refund?: boolean;
    cashAdvance?: boolean;
    pinChange?: boolean;
    manualTransaction?: boolean;
    tipAdjustment?: boolean;
    preAuthorization?: boolean;
    imarkMerchantId?: string | undefined;
}

export class UpdateReplacementRequestCommand implements IUpdateReplacementRequestCommand {
    inventoryId?: string;
    previousSerial?: string | undefined;
    serialKey?: string | undefined;
    isReceived?: boolean;
    isSendToStock?: boolean;
    serialNumberId?: string;
    merchantCategory?: string | undefined;
    merchant?: string | undefined;
    emailAddress?: string | undefined;
    contactPerson?: string | undefined;
    contactNo1?: string | undefined;
    address?: string | undefined;
    district?: string | undefined;
    province?: string | undefined;
    applicationVersionId?: string;
    deploymentRequestId?: string;
    inventoryAddId?: string;
    previousSerialNumberId?: string;
    bankId?: string;
    receivedBy?: string | undefined;
    receivedContactNo?: string | undefined;
    deployedLocation?: string | undefined;
    contactOfPos?: string | undefined;
    limit?: string | undefined;
    terminalType?: string | undefined;

    constructor(data?: IUpdateReplacementRequestCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inventoryId = _data["inventoryId"];
            this.previousSerial = _data["previousSerial"];
            this.serialKey = _data["serialKey"];
            this.isReceived = _data["isReceived"];
            this.isSendToStock = _data["isSendToStock"];
            this.serialNumberId = _data["serialNumberId"];
            this.merchantCategory = _data["merchantCategory"];
            this.merchant = _data["merchant"];
            this.emailAddress = _data["emailAddress"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo1 = _data["contactNo1"];
            this.address = _data["address"];
            this.district = _data["district"];
            this.province = _data["province"];
            this.applicationVersionId = _data["applicationVersionId"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.inventoryAddId = _data["inventoryAddId"];
            this.previousSerialNumberId = _data["previousSerialNumberId"];
            this.bankId = _data["bankId"];
            this.receivedBy = _data["receivedBy"];
            this.receivedContactNo = _data["receivedContactNo"];
            this.deployedLocation = _data["deployedLocation"];
            this.contactOfPos = _data["contactOfPos"];
            this.limit = _data["limit"];
            this.terminalType = _data["terminalType"];
        }
    }

    static fromJS(data: any): UpdateReplacementRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReplacementRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inventoryId"] = this.inventoryId;
        data["previousSerial"] = this.previousSerial;
        data["serialKey"] = this.serialKey;
        data["isReceived"] = this.isReceived;
        data["isSendToStock"] = this.isSendToStock;
        data["serialNumberId"] = this.serialNumberId;
        data["merchantCategory"] = this.merchantCategory;
        data["merchant"] = this.merchant;
        data["emailAddress"] = this.emailAddress;
        data["contactPerson"] = this.contactPerson;
        data["contactNo1"] = this.contactNo1;
        data["address"] = this.address;
        data["district"] = this.district;
        data["province"] = this.province;
        data["applicationVersionId"] = this.applicationVersionId;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["inventoryAddId"] = this.inventoryAddId;
        data["previousSerialNumberId"] = this.previousSerialNumberId;
        data["bankId"] = this.bankId;
        data["receivedBy"] = this.receivedBy;
        data["receivedContactNo"] = this.receivedContactNo;
        data["deployedLocation"] = this.deployedLocation;
        data["contactOfPos"] = this.contactOfPos;
        data["limit"] = this.limit;
        data["terminalType"] = this.terminalType;
        return data;
    }
}

export interface IUpdateReplacementRequestCommand {
    inventoryId?: string;
    previousSerial?: string | undefined;
    serialKey?: string | undefined;
    isReceived?: boolean;
    isSendToStock?: boolean;
    serialNumberId?: string;
    merchantCategory?: string | undefined;
    merchant?: string | undefined;
    emailAddress?: string | undefined;
    contactPerson?: string | undefined;
    contactNo1?: string | undefined;
    address?: string | undefined;
    district?: string | undefined;
    province?: string | undefined;
    applicationVersionId?: string;
    deploymentRequestId?: string;
    inventoryAddId?: string;
    previousSerialNumberId?: string;
    bankId?: string;
    receivedBy?: string | undefined;
    receivedContactNo?: string | undefined;
    deployedLocation?: string | undefined;
    contactOfPos?: string | undefined;
    limit?: string | undefined;
    terminalType?: string | undefined;
}

export class UpdateKeyComponentCommand implements IUpdateKeyComponentCommand {
    id?: string;
    component1?: string | undefined;
    component2?: string | undefined;
    kvc1?: string | undefined;
    kvc2?: string | undefined;
    combineValue?: string | undefined;
    finalValue?: string | undefined;

    constructor(data?: IUpdateKeyComponentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.component1 = _data["component1"];
            this.component2 = _data["component2"];
            this.kvc1 = _data["kvc1"];
            this.kvc2 = _data["kvc2"];
            this.combineValue = _data["combineValue"];
            this.finalValue = _data["finalValue"];
        }
    }

    static fromJS(data: any): UpdateKeyComponentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateKeyComponentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["component1"] = this.component1;
        data["component2"] = this.component2;
        data["kvc1"] = this.kvc1;
        data["kvc2"] = this.kvc2;
        data["combineValue"] = this.combineValue;
        data["finalValue"] = this.finalValue;
        return data;
    }
}

export interface IUpdateKeyComponentCommand {
    id?: string;
    component1?: string | undefined;
    component2?: string | undefined;
    kvc1?: string | undefined;
    kvc2?: string | undefined;
    combineValue?: string | undefined;
    finalValue?: string | undefined;
}

export class UpdateReplacementDeploymentRequestCommand implements IUpdateReplacementDeploymentRequestCommand {
    id?: string;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    merchant?: string | undefined;
    bankName?: string | undefined;
    address?: string | undefined;
    district?: string | undefined;
    province?: string | undefined;
    item?: string | undefined;
    serialKey?: string | undefined;
    requestName?: string | undefined;
    statusName?: string | undefined;
    merchantCategory?: string | undefined;
    emailAddress?: string | undefined;
    contactPerson?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    panNumber?: string | undefined;
    updatedBy?: string | undefined;
    bankRemarks?: string | undefined;
    imarkMerchantId?: string;
    merchantCategoryId?: string | undefined;
    inventoryId?: string | undefined;
    bankId?: string | undefined;

    constructor(data?: IUpdateReplacementDeploymentRequestCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idMerchant = _data["idMerchant"];
            this.idTerminal = _data["idTerminal"];
            this.merchant = _data["merchant"];
            this.bankName = _data["bankName"];
            this.address = _data["address"];
            this.district = _data["district"];
            this.province = _data["province"];
            this.item = _data["item"];
            this.serialKey = _data["serialKey"];
            this.requestName = _data["requestName"];
            this.statusName = _data["statusName"];
            this.merchantCategory = _data["merchantCategory"];
            this.emailAddress = _data["emailAddress"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo1 = _data["contactNo1"];
            this.contactNo2 = _data["contactNo2"];
            this.panNumber = _data["panNumber"];
            this.updatedBy = _data["updatedBy"];
            this.bankRemarks = _data["bankRemarks"];
            this.imarkMerchantId = _data["imarkMerchantId"];
            this.merchantCategoryId = _data["merchantCategoryId"];
            this.inventoryId = _data["inventoryId"];
            this.bankId = _data["bankId"];
        }
    }

    static fromJS(data: any): UpdateReplacementDeploymentRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReplacementDeploymentRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idMerchant"] = this.idMerchant;
        data["idTerminal"] = this.idTerminal;
        data["merchant"] = this.merchant;
        data["bankName"] = this.bankName;
        data["address"] = this.address;
        data["district"] = this.district;
        data["province"] = this.province;
        data["item"] = this.item;
        data["serialKey"] = this.serialKey;
        data["requestName"] = this.requestName;
        data["statusName"] = this.statusName;
        data["merchantCategory"] = this.merchantCategory;
        data["emailAddress"] = this.emailAddress;
        data["contactPerson"] = this.contactPerson;
        data["contactNo1"] = this.contactNo1;
        data["contactNo2"] = this.contactNo2;
        data["panNumber"] = this.panNumber;
        data["updatedBy"] = this.updatedBy;
        data["bankRemarks"] = this.bankRemarks;
        data["imarkMerchantId"] = this.imarkMerchantId;
        data["merchantCategoryId"] = this.merchantCategoryId;
        data["inventoryId"] = this.inventoryId;
        data["bankId"] = this.bankId;
        return data;
    }
}

export interface IUpdateReplacementDeploymentRequestCommand {
    id?: string;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    merchant?: string | undefined;
    bankName?: string | undefined;
    address?: string | undefined;
    district?: string | undefined;
    province?: string | undefined;
    item?: string | undefined;
    serialKey?: string | undefined;
    requestName?: string | undefined;
    statusName?: string | undefined;
    merchantCategory?: string | undefined;
    emailAddress?: string | undefined;
    contactPerson?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    panNumber?: string | undefined;
    updatedBy?: string | undefined;
    bankRemarks?: string | undefined;
    imarkMerchantId?: string;
    merchantCategoryId?: string | undefined;
    inventoryId?: string | undefined;
    bankId?: string | undefined;
}

export class UpdateMerchantDetailsCommand implements IUpdateMerchantDetailsCommand {
    id?: string;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    bankId?: string;
    fonepayIdMerchant?: string | undefined;
    fonepayIdTerminal?: string | undefined;
    nepalPayIdTerminal?: string | undefined;
    nepalPayIdMerchant?: string | undefined;
    nepalPay?: boolean;
    fonepay?: boolean;

    constructor(data?: IUpdateMerchantDetailsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idMerchant = _data["idMerchant"];
            this.idTerminal = _data["idTerminal"];
            this.bankId = _data["bankId"];
            this.fonepayIdMerchant = _data["fonepayIdMerchant"];
            this.fonepayIdTerminal = _data["fonepayIdTerminal"];
            this.nepalPayIdTerminal = _data["nepalPayIdTerminal"];
            this.nepalPayIdMerchant = _data["nepalPayIdMerchant"];
            this.nepalPay = _data["nepalPay"];
            this.fonepay = _data["fonepay"];
        }
    }

    static fromJS(data: any): UpdateMerchantDetailsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMerchantDetailsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idMerchant"] = this.idMerchant;
        data["idTerminal"] = this.idTerminal;
        data["bankId"] = this.bankId;
        data["fonepayIdMerchant"] = this.fonepayIdMerchant;
        data["fonepayIdTerminal"] = this.fonepayIdTerminal;
        data["nepalPayIdTerminal"] = this.nepalPayIdTerminal;
        data["nepalPayIdMerchant"] = this.nepalPayIdMerchant;
        data["nepalPay"] = this.nepalPay;
        data["fonepay"] = this.fonepay;
        return data;
    }
}

export interface IUpdateMerchantDetailsCommand {
    id?: string;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    bankId?: string;
    fonepayIdMerchant?: string | undefined;
    fonepayIdTerminal?: string | undefined;
    nepalPayIdTerminal?: string | undefined;
    nepalPayIdMerchant?: string | undefined;
    nepalPay?: boolean;
    fonepay?: boolean;
}

export class SyncMerchantCommand implements ISyncMerchantCommand {
    deploymentRequestId?: string;
    bankId?: string;
    merchantName?: string | undefined;
    merchantAddress?: string | undefined;
    contactNumber?: string | undefined;
    phoneNumber?: string | undefined;
    panNumber?: string | undefined;
    contactPerson?: string | undefined;
    district?: string | undefined;
    merchantId?: string | undefined;
    terminalId?: string | undefined;
    imid?: string | undefined;
    itid?: string | undefined;
    createNewITID?: boolean;
    createNewIMID?: boolean;
    serialNumber?: string | undefined;

    constructor(data?: ISyncMerchantCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.bankId = _data["bankId"];
            this.merchantName = _data["merchantName"];
            this.merchantAddress = _data["merchantAddress"];
            this.contactNumber = _data["contactNumber"];
            this.phoneNumber = _data["phoneNumber"];
            this.panNumber = _data["panNumber"];
            this.contactPerson = _data["contactPerson"];
            this.district = _data["district"];
            this.merchantId = _data["merchantId"];
            this.terminalId = _data["terminalId"];
            this.imid = _data["imid"];
            this.itid = _data["itid"];
            this.createNewITID = _data["createNewITID"];
            this.createNewIMID = _data["createNewIMID"];
            this.serialNumber = _data["serialNumber"];
        }
    }

    static fromJS(data: any): SyncMerchantCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SyncMerchantCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["bankId"] = this.bankId;
        data["merchantName"] = this.merchantName;
        data["merchantAddress"] = this.merchantAddress;
        data["contactNumber"] = this.contactNumber;
        data["phoneNumber"] = this.phoneNumber;
        data["panNumber"] = this.panNumber;
        data["contactPerson"] = this.contactPerson;
        data["district"] = this.district;
        data["merchantId"] = this.merchantId;
        data["terminalId"] = this.terminalId;
        data["imid"] = this.imid;
        data["itid"] = this.itid;
        data["createNewITID"] = this.createNewITID;
        data["createNewIMID"] = this.createNewIMID;
        data["serialNumber"] = this.serialNumber;
        return data;
    }
}

export interface ISyncMerchantCommand {
    deploymentRequestId?: string;
    bankId?: string;
    merchantName?: string | undefined;
    merchantAddress?: string | undefined;
    contactNumber?: string | undefined;
    phoneNumber?: string | undefined;
    panNumber?: string | undefined;
    contactPerson?: string | undefined;
    district?: string | undefined;
    merchantId?: string | undefined;
    terminalId?: string | undefined;
    imid?: string | undefined;
    itid?: string | undefined;
    createNewITID?: boolean;
    createNewIMID?: boolean;
    serialNumber?: string | undefined;
}

export class RejectDeploymentRequestCommand implements IRejectDeploymentRequestCommand {
    deploymentRequestId?: string;
    remarks?: string | undefined;

    constructor(data?: IRejectDeploymentRequestCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): RejectDeploymentRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RejectDeploymentRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface IRejectDeploymentRequestCommand {
    deploymentRequestId?: string;
    remarks?: string | undefined;
}

export class RejectDeploymentRequestVm implements IRejectDeploymentRequestVm {
    id?: string;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    merchant?: string | undefined;
    bankName?: string | undefined;
    address?: string | undefined;
    rejectedRemarks?: string | undefined;

    constructor(data?: IRejectDeploymentRequestVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idMerchant = _data["idMerchant"];
            this.idTerminal = _data["idTerminal"];
            this.merchant = _data["merchant"];
            this.bankName = _data["bankName"];
            this.address = _data["address"];
            this.rejectedRemarks = _data["rejectedRemarks"];
        }
    }

    static fromJS(data: any): RejectDeploymentRequestVm {
        data = typeof data === 'object' ? data : {};
        let result = new RejectDeploymentRequestVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idMerchant"] = this.idMerchant;
        data["idTerminal"] = this.idTerminal;
        data["merchant"] = this.merchant;
        data["bankName"] = this.bankName;
        data["address"] = this.address;
        data["rejectedRemarks"] = this.rejectedRemarks;
        return data;
    }
}

export interface IRejectDeploymentRequestVm {
    id?: string;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    merchant?: string | undefined;
    bankName?: string | undefined;
    address?: string | undefined;
    rejectedRemarks?: string | undefined;
}

export class ImarkTerminalIdListViewModel implements IImarkTerminalIdListViewModel {
    imarkTerminalId?: ImarkTerminalList[] | undefined;

    constructor(data?: IImarkTerminalIdListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["imarkTerminalId"])) {
                this.imarkTerminalId = [] as any;
                for (let item of _data["imarkTerminalId"])
                    this.imarkTerminalId!.push(ImarkTerminalList.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImarkTerminalIdListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImarkTerminalIdListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.imarkTerminalId)) {
            data["imarkTerminalId"] = [];
            for (let item of this.imarkTerminalId)
                data["imarkTerminalId"].push(item.toJSON());
        }
        return data;
    }
}

export interface IImarkTerminalIdListViewModel {
    imarkTerminalId?: ImarkTerminalList[] | undefined;
}

export class ImarkTerminalList implements IImarkTerminalList {
    terminalType?: string | undefined;
    deploymentStatus?: string | undefined;
    imarkTId?: number;

    constructor(data?: IImarkTerminalList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.terminalType = _data["terminalType"];
            this.deploymentStatus = _data["deploymentStatus"];
            this.imarkTId = _data["imarkTId"];
        }
    }

    static fromJS(data: any): ImarkTerminalList {
        data = typeof data === 'object' ? data : {};
        let result = new ImarkTerminalList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["terminalType"] = this.terminalType;
        data["deploymentStatus"] = this.deploymentStatus;
        data["imarkTId"] = this.imarkTId;
        return data;
    }
}

export interface IImarkTerminalList {
    terminalType?: string | undefined;
    deploymentStatus?: string | undefined;
    imarkTId?: number;
}

export class MerchantwiseSupportList implements IMerchantwiseSupportList {
    merchantSupports?: MerchantSupportListVM[][] | undefined;

    constructor(data?: IMerchantwiseSupportList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["merchantSupports"])) {
                this.merchantSupports = [] as any;
                for (let item of _data["merchantSupports"])
                    this.merchantSupports!.push(item);
            }
        }
    }

    static fromJS(data: any): MerchantwiseSupportList {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantwiseSupportList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.merchantSupports)) {
            data["merchantSupports"] = [];
            for (let item of this.merchantSupports)
                data["merchantSupports"].push(item);
        }
        return data;
    }
}

export interface IMerchantwiseSupportList {
    merchantSupports?: MerchantSupportListVM[][] | undefined;
}

export class MerchantSupportListVM implements IMerchantSupportListVM {
    imarkTerminalId?: string | undefined;
    issue?: string | undefined;
    resolvedBy?: string | undefined;
    resolvedRemark?: string | undefined;
    resolvedDate?: string | undefined;
    requestDate?: string | undefined;
    status?: string | undefined;
    createdDate?: Date;

    constructor(data?: IMerchantSupportListVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imarkTerminalId = _data["imarkTerminalId"];
            this.issue = _data["issue"];
            this.resolvedBy = _data["resolvedBy"];
            this.resolvedRemark = _data["resolvedRemark"];
            this.resolvedDate = _data["resolvedDate"];
            this.requestDate = _data["requestDate"];
            this.status = _data["status"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MerchantSupportListVM {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantSupportListVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imarkTerminalId"] = this.imarkTerminalId;
        data["issue"] = this.issue;
        data["resolvedBy"] = this.resolvedBy;
        data["resolvedRemark"] = this.resolvedRemark;
        data["resolvedDate"] = this.resolvedDate;
        data["requestDate"] = this.requestDate;
        data["status"] = this.status;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMerchantSupportListVM {
    imarkTerminalId?: string | undefined;
    issue?: string | undefined;
    resolvedBy?: string | undefined;
    resolvedRemark?: string | undefined;
    resolvedDate?: string | undefined;
    requestDate?: string | undefined;
    status?: string | undefined;
    createdDate?: Date;
}

export class CreateMerchantSupportCommand implements ICreateMerchantSupportCommand {
    phone?: boolean;
    field?: boolean;
    priority?: boolean;
    issue?: string | undefined;
    imarkTerminalId?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    remarks?: string | undefined;

    constructor(data?: ICreateMerchantSupportCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phone = _data["phone"];
            this.field = _data["field"];
            this.priority = _data["priority"];
            this.issue = _data["issue"];
            this.imarkTerminalId = _data["imarkTerminalId"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo = _data["contactNo"];
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): CreateMerchantSupportCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMerchantSupportCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phone"] = this.phone;
        data["field"] = this.field;
        data["priority"] = this.priority;
        data["issue"] = this.issue;
        data["imarkTerminalId"] = this.imarkTerminalId;
        data["contactPerson"] = this.contactPerson;
        data["contactNo"] = this.contactNo;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface ICreateMerchantSupportCommand {
    phone?: boolean;
    field?: boolean;
    priority?: boolean;
    issue?: string | undefined;
    imarkTerminalId?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    remarks?: string | undefined;
}

export class CreateMerchantSpareRequestCommand implements ICreateMerchantSpareRequestCommand {
    contactPerson?: string | undefined;
    contactNumber?: string | undefined;
    accessoryId?: string | undefined;
    bankId?: string | undefined;
    quantity?: number;
    remarks?: string | undefined;
    imarkTerminalId?: string | undefined;
    imarkMerchantId?: string | undefined;

    constructor(data?: ICreateMerchantSpareRequestCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactPerson = _data["contactPerson"];
            this.contactNumber = _data["contactNumber"];
            this.accessoryId = _data["accessoryId"];
            this.bankId = _data["bankId"];
            this.quantity = _data["quantity"];
            this.remarks = _data["remarks"];
            this.imarkTerminalId = _data["imarkTerminalId"];
            this.imarkMerchantId = _data["imarkMerchantId"];
        }
    }

    static fromJS(data: any): CreateMerchantSpareRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMerchantSpareRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactPerson"] = this.contactPerson;
        data["contactNumber"] = this.contactNumber;
        data["accessoryId"] = this.accessoryId;
        data["bankId"] = this.bankId;
        data["quantity"] = this.quantity;
        data["remarks"] = this.remarks;
        data["imarkTerminalId"] = this.imarkTerminalId;
        data["imarkMerchantId"] = this.imarkMerchantId;
        return data;
    }
}

export interface ICreateMerchantSpareRequestCommand {
    contactPerson?: string | undefined;
    contactNumber?: string | undefined;
    accessoryId?: string | undefined;
    bankId?: string | undefined;
    quantity?: number;
    remarks?: string | undefined;
    imarkTerminalId?: string | undefined;
    imarkMerchantId?: string | undefined;
}

export class MerchantwiseSpareRequestListVM implements IMerchantwiseSpareRequestListVM {
    merchantSpareRequests?: MerchantSpareRequestListVM[][] | undefined;

    constructor(data?: IMerchantwiseSpareRequestListVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["merchantSpareRequests"])) {
                this.merchantSpareRequests = [] as any;
                for (let item of _data["merchantSpareRequests"])
                    this.merchantSpareRequests!.push(item);
            }
        }
    }

    static fromJS(data: any): MerchantwiseSpareRequestListVM {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantwiseSpareRequestListVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.merchantSpareRequests)) {
            data["merchantSpareRequests"] = [];
            for (let item of this.merchantSpareRequests)
                data["merchantSpareRequests"].push(item);
        }
        return data;
    }
}

export interface IMerchantwiseSpareRequestListVM {
    merchantSpareRequests?: MerchantSpareRequestListVM[][] | undefined;
}

export class MerchantSpareRequestListVM implements IMerchantSpareRequestListVM {
    imarkTerminalId?: string | undefined;
    terminalType?: string | undefined;
    requested_Date?: string | undefined;
    dispatch_Date?: string | undefined;
    spareRequestStatus?: string | undefined;
    createdDate?: Date | undefined;
    requestedQuantity?: number;
    pendingQuantity?: number;

    constructor(data?: IMerchantSpareRequestListVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imarkTerminalId = _data["imarkTerminalId"];
            this.terminalType = _data["terminalType"];
            this.requested_Date = _data["requested_Date"];
            this.dispatch_Date = _data["dispatch_Date"];
            this.spareRequestStatus = _data["spareRequestStatus"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.requestedQuantity = _data["requestedQuantity"];
            this.pendingQuantity = _data["pendingQuantity"];
        }
    }

    static fromJS(data: any): MerchantSpareRequestListVM {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantSpareRequestListVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imarkTerminalId"] = this.imarkTerminalId;
        data["terminalType"] = this.terminalType;
        data["requested_Date"] = this.requested_Date;
        data["dispatch_Date"] = this.dispatch_Date;
        data["spareRequestStatus"] = this.spareRequestStatus;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["requestedQuantity"] = this.requestedQuantity;
        data["pendingQuantity"] = this.pendingQuantity;
        return data;
    }
}

export interface IMerchantSpareRequestListVM {
    imarkTerminalId?: string | undefined;
    terminalType?: string | undefined;
    requested_Date?: string | undefined;
    dispatch_Date?: string | undefined;
    spareRequestStatus?: string | undefined;
    createdDate?: Date | undefined;
    requestedQuantity?: number;
    pendingQuantity?: number;
}

export class AuthenticationRequest2 implements IAuthenticationRequest2 {
    userName?: string | undefined;
    password?: string | undefined;

    constructor(data?: IAuthenticationRequest2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): AuthenticationRequest2 {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticationRequest2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }
}

export interface IAuthenticationRequest2 {
    userName?: string | undefined;
    password?: string | undefined;
}

export class TransactionSummaryVM implements ITransactionSummaryVM {
    totalTransactionAmount?: number | undefined;
    totalTransactionCount?: number | undefined;
    totalRemainaingSettlementAmount?: number | undefined;
    totalPendingSettlementCount?: number | undefined;
    todaysTransactionSummary?: TodayTransactionSummary | undefined;
    yesterDaysTransactionSummary?: YesterDayTransactionSummary | undefined;

    constructor(data?: ITransactionSummaryVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalTransactionAmount = _data["totalTransactionAmount"];
            this.totalTransactionCount = _data["totalTransactionCount"];
            this.totalRemainaingSettlementAmount = _data["totalRemainaingSettlementAmount"];
            this.totalPendingSettlementCount = _data["totalPendingSettlementCount"];
            this.todaysTransactionSummary = _data["todaysTransactionSummary"] ? TodayTransactionSummary.fromJS(_data["todaysTransactionSummary"]) : <any>undefined;
            this.yesterDaysTransactionSummary = _data["yesterDaysTransactionSummary"] ? YesterDayTransactionSummary.fromJS(_data["yesterDaysTransactionSummary"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TransactionSummaryVM {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionSummaryVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalTransactionAmount"] = this.totalTransactionAmount;
        data["totalTransactionCount"] = this.totalTransactionCount;
        data["totalRemainaingSettlementAmount"] = this.totalRemainaingSettlementAmount;
        data["totalPendingSettlementCount"] = this.totalPendingSettlementCount;
        data["todaysTransactionSummary"] = this.todaysTransactionSummary ? this.todaysTransactionSummary.toJSON() : <any>undefined;
        data["yesterDaysTransactionSummary"] = this.yesterDaysTransactionSummary ? this.yesterDaysTransactionSummary.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITransactionSummaryVM {
    totalTransactionAmount?: number | undefined;
    totalTransactionCount?: number | undefined;
    totalRemainaingSettlementAmount?: number | undefined;
    totalPendingSettlementCount?: number | undefined;
    todaysTransactionSummary?: TodayTransactionSummary | undefined;
    yesterDaysTransactionSummary?: YesterDayTransactionSummary | undefined;
}

export class TodayTransactionSummary implements ITodayTransactionSummary {
    transactionAmount?: number | undefined;
    totalTodayTransactionCount?: number | undefined;
    settlementAmount?: number | undefined;
    totalTodaySettledTransactionCount?: number | undefined;

    constructor(data?: ITodayTransactionSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionAmount = _data["transactionAmount"];
            this.totalTodayTransactionCount = _data["totalTodayTransactionCount"];
            this.settlementAmount = _data["settlementAmount"];
            this.totalTodaySettledTransactionCount = _data["totalTodaySettledTransactionCount"];
        }
    }

    static fromJS(data: any): TodayTransactionSummary {
        data = typeof data === 'object' ? data : {};
        let result = new TodayTransactionSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionAmount"] = this.transactionAmount;
        data["totalTodayTransactionCount"] = this.totalTodayTransactionCount;
        data["settlementAmount"] = this.settlementAmount;
        data["totalTodaySettledTransactionCount"] = this.totalTodaySettledTransactionCount;
        return data;
    }
}

export interface ITodayTransactionSummary {
    transactionAmount?: number | undefined;
    totalTodayTransactionCount?: number | undefined;
    settlementAmount?: number | undefined;
    totalTodaySettledTransactionCount?: number | undefined;
}

export class YesterDayTransactionSummary implements IYesterDayTransactionSummary {
    transactionAmount?: number | undefined;
    totalYesterdayTransactionCount?: number | undefined;
    settlementAmount?: number | undefined;
    totalYesterdaySettledCount?: number | undefined;

    constructor(data?: IYesterDayTransactionSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionAmount = _data["transactionAmount"];
            this.totalYesterdayTransactionCount = _data["totalYesterdayTransactionCount"];
            this.settlementAmount = _data["settlementAmount"];
            this.totalYesterdaySettledCount = _data["totalYesterdaySettledCount"];
        }
    }

    static fromJS(data: any): YesterDayTransactionSummary {
        data = typeof data === 'object' ? data : {};
        let result = new YesterDayTransactionSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionAmount"] = this.transactionAmount;
        data["totalYesterdayTransactionCount"] = this.totalYesterdayTransactionCount;
        data["settlementAmount"] = this.settlementAmount;
        data["totalYesterdaySettledCount"] = this.totalYesterdaySettledCount;
        return data;
    }
}

export interface IYesterDayTransactionSummary {
    transactionAmount?: number | undefined;
    totalYesterdayTransactionCount?: number | undefined;
    settlementAmount?: number | undefined;
    totalYesterdaySettledCount?: number | undefined;
}

export class PagedResponseOfTransactionListVM implements IPagedResponseOfTransactionListVM {
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    totalRecords?: number;
    data?: TransactionListVM[] | undefined;
    message?: string | undefined;
    errors?: string[] | undefined;
    succeeded?: boolean;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPagedResponseOfTransactionListVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TransactionListVM.fromJS(item));
            }
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.succeeded = _data["succeeded"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PagedResponseOfTransactionListVM {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfTransactionListVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["succeeded"] = this.succeeded;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPagedResponseOfTransactionListVM {
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    totalRecords?: number;
    data?: TransactionListVM[] | undefined;
    message?: string | undefined;
    errors?: string[] | undefined;
    succeeded?: boolean;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class TransactionListVM implements ITransactionListVM {
    imerchantId?: number;
    iterminalId?: number;
    acquirerMerchantId?: string | undefined;
    acquirerTerminalId?: string | undefined;
    referenceId?: string | undefined;
    aid?: string | undefined;
    batchNumber?: string | undefined;
    traceNo?: string | undefined;
    cardNo?: string | undefined;
    rrn?: string | undefined;
    cardType?: string | undefined;
    authCode?: string | undefined;
    tc?: string | undefined;
    tvr?: string | undefined;
    tsi?: string | undefined;
    statusMessage?: string | undefined;
    merchantName?: string | undefined;
    merchantAddress?: string | undefined;
    entryMode?: string | undefined;
    transactionType?: string | undefined;
    paymentScheme?: string | undefined;
    currencyCode?: string | undefined;
    transactionAmount?: number;
    totalAmount?: number;
    posSerialNumber?: string | undefined;
    transactionStatusCode?: string | undefined;
    transactionDate?: string | undefined;
    transactionTime?: string | undefined;

    constructor(data?: ITransactionListVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imerchantId = _data["imerchantId"];
            this.iterminalId = _data["iterminalId"];
            this.acquirerMerchantId = _data["acquirerMerchantId"];
            this.acquirerTerminalId = _data["acquirerTerminalId"];
            this.referenceId = _data["referenceId"];
            this.aid = _data["aid"];
            this.batchNumber = _data["batchNumber"];
            this.traceNo = _data["traceNo"];
            this.cardNo = _data["cardNo"];
            this.rrn = _data["rrn"];
            this.cardType = _data["cardType"];
            this.authCode = _data["authCode"];
            this.tc = _data["tc"];
            this.tvr = _data["tvr"];
            this.tsi = _data["tsi"];
            this.statusMessage = _data["statusMessage"];
            this.merchantName = _data["merchantName"];
            this.merchantAddress = _data["merchantAddress"];
            this.entryMode = _data["entryMode"];
            this.transactionType = _data["transactionType"];
            this.paymentScheme = _data["paymentScheme"];
            this.currencyCode = _data["currencyCode"];
            this.transactionAmount = _data["transactionAmount"];
            this.totalAmount = _data["totalAmount"];
            this.posSerialNumber = _data["posSerialNumber"];
            this.transactionStatusCode = _data["transactionStatusCode"];
            this.transactionDate = _data["transactionDate"];
            this.transactionTime = _data["transactionTime"];
        }
    }

    static fromJS(data: any): TransactionListVM {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionListVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imerchantId"] = this.imerchantId;
        data["iterminalId"] = this.iterminalId;
        data["acquirerMerchantId"] = this.acquirerMerchantId;
        data["acquirerTerminalId"] = this.acquirerTerminalId;
        data["referenceId"] = this.referenceId;
        data["aid"] = this.aid;
        data["batchNumber"] = this.batchNumber;
        data["traceNo"] = this.traceNo;
        data["cardNo"] = this.cardNo;
        data["rrn"] = this.rrn;
        data["cardType"] = this.cardType;
        data["authCode"] = this.authCode;
        data["tc"] = this.tc;
        data["tvr"] = this.tvr;
        data["tsi"] = this.tsi;
        data["statusMessage"] = this.statusMessage;
        data["merchantName"] = this.merchantName;
        data["merchantAddress"] = this.merchantAddress;
        data["entryMode"] = this.entryMode;
        data["transactionType"] = this.transactionType;
        data["paymentScheme"] = this.paymentScheme;
        data["currencyCode"] = this.currencyCode;
        data["transactionAmount"] = this.transactionAmount;
        data["totalAmount"] = this.totalAmount;
        data["posSerialNumber"] = this.posSerialNumber;
        data["transactionStatusCode"] = this.transactionStatusCode;
        data["transactionDate"] = this.transactionDate;
        data["transactionTime"] = this.transactionTime;
        return data;
    }
}

export interface ITransactionListVM {
    imerchantId?: number;
    iterminalId?: number;
    acquirerMerchantId?: string | undefined;
    acquirerTerminalId?: string | undefined;
    referenceId?: string | undefined;
    aid?: string | undefined;
    batchNumber?: string | undefined;
    traceNo?: string | undefined;
    cardNo?: string | undefined;
    rrn?: string | undefined;
    cardType?: string | undefined;
    authCode?: string | undefined;
    tc?: string | undefined;
    tvr?: string | undefined;
    tsi?: string | undefined;
    statusMessage?: string | undefined;
    merchantName?: string | undefined;
    merchantAddress?: string | undefined;
    entryMode?: string | undefined;
    transactionType?: string | undefined;
    paymentScheme?: string | undefined;
    currencyCode?: string | undefined;
    transactionAmount?: number;
    totalAmount?: number;
    posSerialNumber?: string | undefined;
    transactionStatusCode?: string | undefined;
    transactionDate?: string | undefined;
    transactionTime?: string | undefined;
}

export class ResponseViewModelOfTransactionListVM implements IResponseViewModelOfTransactionListVM {
    data?: TransactionListVM[] | undefined;
    succeeded?: boolean;
    errors?: string[] | undefined;
    message?: string | undefined;

    constructor(data?: IResponseViewModelOfTransactionListVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TransactionListVM.fromJS(item));
            }
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ResponseViewModelOfTransactionListVM {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseViewModelOfTransactionListVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}

export interface IResponseViewModelOfTransactionListVM {
    data?: TransactionListVM[] | undefined;
    succeeded?: boolean;
    errors?: string[] | undefined;
    message?: string | undefined;
}

export class PagedResponseOfSettlementListVM implements IPagedResponseOfSettlementListVM {
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    totalRecords?: number;
    data?: SettlementListVM[] | undefined;
    message?: string | undefined;
    errors?: string[] | undefined;
    succeeded?: boolean;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPagedResponseOfSettlementListVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SettlementListVM.fromJS(item));
            }
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.succeeded = _data["succeeded"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PagedResponseOfSettlementListVM {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfSettlementListVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["succeeded"] = this.succeeded;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPagedResponseOfSettlementListVM {
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    totalRecords?: number;
    data?: SettlementListVM[] | undefined;
    message?: string | undefined;
    errors?: string[] | undefined;
    succeeded?: boolean;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class SettlementListVM implements ISettlementListVM {
    rrn?: string | undefined;
    transactionType?: string | undefined;
    referenceId?: string | undefined;
    batchNumber?: string | undefined;
    transactionStatus?: string | undefined;
    statusMessage?: string | undefined;
    totalAmount?: number;
    transactionDate?: string | undefined;
    transactionTime?: string | undefined;

    constructor(data?: ISettlementListVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rrn = _data["rrn"];
            this.transactionType = _data["transactionType"];
            this.referenceId = _data["referenceId"];
            this.batchNumber = _data["batchNumber"];
            this.transactionStatus = _data["transactionStatus"];
            this.statusMessage = _data["statusMessage"];
            this.totalAmount = _data["totalAmount"];
            this.transactionDate = _data["transactionDate"];
            this.transactionTime = _data["transactionTime"];
        }
    }

    static fromJS(data: any): SettlementListVM {
        data = typeof data === 'object' ? data : {};
        let result = new SettlementListVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rrn"] = this.rrn;
        data["transactionType"] = this.transactionType;
        data["referenceId"] = this.referenceId;
        data["batchNumber"] = this.batchNumber;
        data["transactionStatus"] = this.transactionStatus;
        data["statusMessage"] = this.statusMessage;
        data["totalAmount"] = this.totalAmount;
        data["transactionDate"] = this.transactionDate;
        data["transactionTime"] = this.transactionTime;
        return data;
    }
}

export interface ISettlementListVM {
    rrn?: string | undefined;
    transactionType?: string | undefined;
    referenceId?: string | undefined;
    batchNumber?: string | undefined;
    transactionStatus?: string | undefined;
    statusMessage?: string | undefined;
    totalAmount?: number;
    transactionDate?: string | undefined;
    transactionTime?: string | undefined;
}

export class HardwareViewModel implements IHardwareViewModel {
    id?: string;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    serialNo?: string | undefined;
    purchaseDate?: Date;
    createdDate?: Date;
    manufacturer?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    bankId?: string;
    bankName?: string | undefined;
    purDate?: string | undefined;

    constructor(data?: IHardwareViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.primaryItem = _data["primaryItem"];
            this.secondaryItem = _data["secondaryItem"];
            this.tertiaryItem = _data["tertiaryItem"];
            this.detailItem = _data["detailItem"];
            this.serialNo = _data["serialNo"];
            this.purchaseDate = _data["purchaseDate"] ? new Date(_data["purchaseDate"].toString()) : <any>undefined;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.manufacturer = _data["manufacturer"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo = _data["contactNo"];
            this.bankId = _data["bankId"];
            this.bankName = _data["bankName"];
            this.purDate = _data["purDate"];
        }
    }

    static fromJS(data: any): HardwareViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new HardwareViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["primaryItem"] = this.primaryItem;
        data["secondaryItem"] = this.secondaryItem;
        data["tertiaryItem"] = this.tertiaryItem;
        data["detailItem"] = this.detailItem;
        data["serialNo"] = this.serialNo;
        data["purchaseDate"] = this.purchaseDate ? this.purchaseDate.toISOString() : <any>undefined;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["manufacturer"] = this.manufacturer;
        data["contactPerson"] = this.contactPerson;
        data["contactNo"] = this.contactNo;
        data["bankId"] = this.bankId;
        data["bankName"] = this.bankName;
        data["purDate"] = this.purDate;
        return data;
    }
}

export interface IHardwareViewModel {
    id?: string;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    serialNo?: string | undefined;
    purchaseDate?: Date;
    createdDate?: Date;
    manufacturer?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    bankId?: string;
    bankName?: string | undefined;
    purDate?: string | undefined;
}

export class GetAllHardwareQuery implements IGetAllHardwareQuery {
    id?: string;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    serialNo?: string | undefined;
    manufacturer?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    bankId?: string;
    bankName?: string | undefined;
    purDate?: string | undefined;

    constructor(data?: IGetAllHardwareQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.primaryItem = _data["primaryItem"];
            this.secondaryItem = _data["secondaryItem"];
            this.serialNo = _data["serialNo"];
            this.manufacturer = _data["manufacturer"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo = _data["contactNo"];
            this.bankId = _data["bankId"];
            this.bankName = _data["bankName"];
            this.purDate = _data["purDate"];
        }
    }

    static fromJS(data: any): GetAllHardwareQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllHardwareQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["primaryItem"] = this.primaryItem;
        data["secondaryItem"] = this.secondaryItem;
        data["serialNo"] = this.serialNo;
        data["manufacturer"] = this.manufacturer;
        data["contactPerson"] = this.contactPerson;
        data["contactNo"] = this.contactNo;
        data["bankId"] = this.bankId;
        data["bankName"] = this.bankName;
        data["purDate"] = this.purDate;
        return data;
    }
}

export interface IGetAllHardwareQuery {
    id?: string;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    serialNo?: string | undefined;
    manufacturer?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    bankId?: string;
    bankName?: string | undefined;
    purDate?: string | undefined;
}

export class CreateHardwareCommand implements ICreateHardwareCommand {
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    serialNo?: string | undefined;
    purchaseDate?: Date;
    manufacturer?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    bankId?: string;

    constructor(data?: ICreateHardwareCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primaryItem = _data["primaryItem"];
            this.secondaryItem = _data["secondaryItem"];
            this.tertiaryItem = _data["tertiaryItem"];
            this.detailItem = _data["detailItem"];
            this.serialNo = _data["serialNo"];
            this.purchaseDate = _data["purchaseDate"] ? new Date(_data["purchaseDate"].toString()) : <any>undefined;
            this.manufacturer = _data["manufacturer"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo = _data["contactNo"];
            this.bankId = _data["bankId"];
        }
    }

    static fromJS(data: any): CreateHardwareCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateHardwareCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primaryItem"] = this.primaryItem;
        data["secondaryItem"] = this.secondaryItem;
        data["tertiaryItem"] = this.tertiaryItem;
        data["detailItem"] = this.detailItem;
        data["serialNo"] = this.serialNo;
        data["purchaseDate"] = this.purchaseDate ? this.purchaseDate.toISOString() : <any>undefined;
        data["manufacturer"] = this.manufacturer;
        data["contactPerson"] = this.contactPerson;
        data["contactNo"] = this.contactNo;
        data["bankId"] = this.bankId;
        return data;
    }
}

export interface ICreateHardwareCommand {
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    serialNo?: string | undefined;
    purchaseDate?: Date;
    manufacturer?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    bankId?: string;
}

export class UpdateHardwareCommand implements IUpdateHardwareCommand {
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    serialNo?: string | undefined;
    purchaseDate?: Date;
    manufacturer?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    bankId?: string;

    constructor(data?: IUpdateHardwareCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primaryItem = _data["primaryItem"];
            this.secondaryItem = _data["secondaryItem"];
            this.tertiaryItem = _data["tertiaryItem"];
            this.detailItem = _data["detailItem"];
            this.serialNo = _data["serialNo"];
            this.purchaseDate = _data["purchaseDate"] ? new Date(_data["purchaseDate"].toString()) : <any>undefined;
            this.manufacturer = _data["manufacturer"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo = _data["contactNo"];
            this.bankId = _data["bankId"];
        }
    }

    static fromJS(data: any): UpdateHardwareCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateHardwareCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primaryItem"] = this.primaryItem;
        data["secondaryItem"] = this.secondaryItem;
        data["tertiaryItem"] = this.tertiaryItem;
        data["detailItem"] = this.detailItem;
        data["serialNo"] = this.serialNo;
        data["purchaseDate"] = this.purchaseDate ? this.purchaseDate.toISOString() : <any>undefined;
        data["manufacturer"] = this.manufacturer;
        data["contactPerson"] = this.contactPerson;
        data["contactNo"] = this.contactNo;
        data["bankId"] = this.bankId;
        return data;
    }
}

export interface IUpdateHardwareCommand {
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    serialNo?: string | undefined;
    purchaseDate?: Date;
    manufacturer?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    bankId?: string;
}

export class MerchantDetailsAddCommands implements IMerchantDetailsAddCommands {
    id?: string;
    address?: string | undefined;
    panNumber?: string | undefined;

    constructor(data?: IMerchantDetailsAddCommands) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.address = _data["address"];
            this.panNumber = _data["panNumber"];
        }
    }

    static fromJS(data: any): MerchantDetailsAddCommands {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantDetailsAddCommands();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["address"] = this.address;
        data["panNumber"] = this.panNumber;
        return data;
    }
}

export interface IMerchantDetailsAddCommands {
    id?: string;
    address?: string | undefined;
    panNumber?: string | undefined;
}

export class ImarkMerchantListVM implements IImarkMerchantListVM {
    id?: string | undefined;
    merchantName?: string | undefined;
    userId?: string;
    terminalId?: string;
    createdDate?: Date;

    constructor(data?: IImarkMerchantListVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.merchantName = _data["merchantName"];
            this.userId = _data["userId"];
            this.terminalId = _data["terminalId"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ImarkMerchantListVM {
        data = typeof data === 'object' ? data : {};
        let result = new ImarkMerchantListVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["merchantName"] = this.merchantName;
        data["userId"] = this.userId;
        data["terminalId"] = this.terminalId;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IImarkMerchantListVM {
    id?: string | undefined;
    merchantName?: string | undefined;
    userId?: string;
    terminalId?: string;
    createdDate?: Date;
}

export class MerchantImarkTidAndImarkMidVM implements IMerchantImarkTidAndImarkMidVM {
    imarkTerminalId?: number;
    imarkMerchantId?: number;
    paymentProviderScheme?: string | undefined;

    constructor(data?: IMerchantImarkTidAndImarkMidVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imarkTerminalId = _data["imarkTerminalId"];
            this.imarkMerchantId = _data["imarkMerchantId"];
            this.paymentProviderScheme = _data["paymentProviderScheme"];
        }
    }

    static fromJS(data: any): MerchantImarkTidAndImarkMidVM {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantImarkTidAndImarkMidVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imarkTerminalId"] = this.imarkTerminalId;
        data["imarkMerchantId"] = this.imarkMerchantId;
        data["paymentProviderScheme"] = this.paymentProviderScheme;
        return data;
    }
}

export interface IMerchantImarkTidAndImarkMidVM {
    imarkTerminalId?: number;
    imarkMerchantId?: number;
    paymentProviderScheme?: string | undefined;
}

export class InventoryAddPosSalesViewModel implements IInventoryAddPosSalesViewModel {
    id?: string;
    item?: string | undefined;
    buyDate?: Date;
    serialLength?: string | undefined;
    soldNumber?: number;
    totalPos?: number;
    availableSerialNoToBeSold?: number;

    constructor(data?: IInventoryAddPosSalesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.item = _data["item"];
            this.buyDate = _data["buyDate"] ? new Date(_data["buyDate"].toString()) : <any>undefined;
            this.serialLength = _data["serialLength"];
            this.soldNumber = _data["soldNumber"];
            this.totalPos = _data["totalPos"];
            this.availableSerialNoToBeSold = _data["availableSerialNoToBeSold"];
        }
    }

    static fromJS(data: any): InventoryAddPosSalesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryAddPosSalesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["item"] = this.item;
        data["buyDate"] = this.buyDate ? this.buyDate.toISOString() : <any>undefined;
        data["serialLength"] = this.serialLength;
        data["soldNumber"] = this.soldNumber;
        data["totalPos"] = this.totalPos;
        data["availableSerialNoToBeSold"] = this.availableSerialNoToBeSold;
        return data;
    }
}

export interface IInventoryAddPosSalesViewModel {
    id?: string;
    item?: string | undefined;
    buyDate?: Date;
    serialLength?: string | undefined;
    soldNumber?: number;
    totalPos?: number;
    availableSerialNoToBeSold?: number;
}

export class InventoryAddViewModel implements IInventoryAddViewModel {
    id?: string;
    totalNumber?: number;
    buyDate?: Date;
    vendorName?: string | undefined;
    inventoryId?: string;
    inventory?: string | undefined;
    remainingNumber?: number;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    serialLength?: string | undefined;
    soldNumber?: any | undefined;

    constructor(data?: IInventoryAddViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.totalNumber = _data["totalNumber"];
            this.buyDate = _data["buyDate"] ? new Date(_data["buyDate"].toString()) : <any>undefined;
            this.vendorName = _data["vendorName"];
            this.inventoryId = _data["inventoryId"];
            this.inventory = _data["inventory"];
            this.remainingNumber = _data["remainingNumber"];
            this.primaryItem = _data["primaryItem"];
            this.secondaryItem = _data["secondaryItem"];
            this.tertiaryItem = _data["tertiaryItem"];
            this.detailItem = _data["detailItem"];
            this.serialLength = _data["serialLength"];
            this.soldNumber = _data["soldNumber"];
        }
    }

    static fromJS(data: any): InventoryAddViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryAddViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["totalNumber"] = this.totalNumber;
        data["buyDate"] = this.buyDate ? this.buyDate.toISOString() : <any>undefined;
        data["vendorName"] = this.vendorName;
        data["inventoryId"] = this.inventoryId;
        data["inventory"] = this.inventory;
        data["remainingNumber"] = this.remainingNumber;
        data["primaryItem"] = this.primaryItem;
        data["secondaryItem"] = this.secondaryItem;
        data["tertiaryItem"] = this.tertiaryItem;
        data["detailItem"] = this.detailItem;
        data["serialLength"] = this.serialLength;
        data["soldNumber"] = this.soldNumber;
        return data;
    }
}

export interface IInventoryAddViewModel {
    id?: string;
    totalNumber?: number;
    buyDate?: Date;
    vendorName?: string | undefined;
    inventoryId?: string;
    inventory?: string | undefined;
    remainingNumber?: number;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    serialLength?: string | undefined;
    soldNumber?: any | undefined;
}

export class SparesForPosViewModel implements ISparesForPosViewModel {
    inventory?: string | undefined;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    buyDate?: string | undefined;
    available?: number;
    remainingNumber?: number;
    soldNumber?: number;
    id?: string;
    inventoryId?: string;
    totalNumber?: number;

    constructor(data?: ISparesForPosViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inventory = _data["inventory"];
            this.primaryItem = _data["primaryItem"];
            this.secondaryItem = _data["secondaryItem"];
            this.tertiaryItem = _data["tertiaryItem"];
            this.detailItem = _data["detailItem"];
            this.buyDate = _data["buyDate"];
            this.available = _data["available"];
            this.remainingNumber = _data["remainingNumber"];
            this.soldNumber = _data["soldNumber"];
            this.id = _data["id"];
            this.inventoryId = _data["inventoryId"];
            this.totalNumber = _data["totalNumber"];
        }
    }

    static fromJS(data: any): SparesForPosViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SparesForPosViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inventory"] = this.inventory;
        data["primaryItem"] = this.primaryItem;
        data["secondaryItem"] = this.secondaryItem;
        data["tertiaryItem"] = this.tertiaryItem;
        data["detailItem"] = this.detailItem;
        data["buyDate"] = this.buyDate;
        data["available"] = this.available;
        data["remainingNumber"] = this.remainingNumber;
        data["soldNumber"] = this.soldNumber;
        data["id"] = this.id;
        data["inventoryId"] = this.inventoryId;
        data["totalNumber"] = this.totalNumber;
        return data;
    }
}

export interface ISparesForPosViewModel {
    inventory?: string | undefined;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    buyDate?: string | undefined;
    available?: number;
    remainingNumber?: number;
    soldNumber?: number;
    id?: string;
    inventoryId?: string;
    totalNumber?: number;
}

export class AccessoryDistributtonViewModel implements IAccessoryDistributtonViewModel {
    id?: string;
    accessoryId?: string;
    accessoryName?: string | undefined;
    accessoryType?: string | undefined;
    accessoryDetail?: string | undefined;
    primaryItem?: string | undefined;
    totalNumber?: number;
    buyDate?: string | undefined;
    model?: string | undefined;
    merchantSold?: string | undefined;
    remainingNumber?: number;
    bankSold?: number;
    soldNumber?: number;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;

    constructor(data?: IAccessoryDistributtonViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accessoryId = _data["accessoryId"];
            this.accessoryName = _data["accessoryName"];
            this.accessoryType = _data["accessoryType"];
            this.accessoryDetail = _data["accessoryDetail"];
            this.primaryItem = _data["primaryItem"];
            this.totalNumber = _data["totalNumber"];
            this.buyDate = _data["buyDate"];
            this.model = _data["model"];
            this.merchantSold = _data["merchantSold"];
            this.remainingNumber = _data["remainingNumber"];
            this.bankSold = _data["bankSold"];
            this.soldNumber = _data["soldNumber"];
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): AccessoryDistributtonViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccessoryDistributtonViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accessoryId"] = this.accessoryId;
        data["accessoryName"] = this.accessoryName;
        data["accessoryType"] = this.accessoryType;
        data["accessoryDetail"] = this.accessoryDetail;
        data["primaryItem"] = this.primaryItem;
        data["totalNumber"] = this.totalNumber;
        data["buyDate"] = this.buyDate;
        data["model"] = this.model;
        data["merchantSold"] = this.merchantSold;
        data["remainingNumber"] = this.remainingNumber;
        data["bankSold"] = this.bankSold;
        data["soldNumber"] = this.soldNumber;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IAccessoryDistributtonViewModel {
    id?: string;
    accessoryId?: string;
    accessoryName?: string | undefined;
    accessoryType?: string | undefined;
    accessoryDetail?: string | undefined;
    primaryItem?: string | undefined;
    totalNumber?: number;
    buyDate?: string | undefined;
    model?: string | undefined;
    merchantSold?: string | undefined;
    remainingNumber?: number;
    bankSold?: number;
    soldNumber?: number;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
}

export class UpdateAccessoryAddCommand implements IUpdateAccessoryAddCommand {
    id?: string;
    totalNumber?: number;
    buyDate?: Date;

    constructor(data?: IUpdateAccessoryAddCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.totalNumber = _data["totalNumber"];
            this.buyDate = _data["buyDate"] ? new Date(_data["buyDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateAccessoryAddCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAccessoryAddCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["totalNumber"] = this.totalNumber;
        data["buyDate"] = this.buyDate ? this.buyDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpdateAccessoryAddCommand {
    id?: string;
    totalNumber?: number;
    buyDate?: Date;
}

export class GetInventroysAddQuery implements IGetInventroysAddQuery {
    id?: string;
    inventoryId?: string;
    inventoryAddId?: string;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    item?: string | undefined;
    buyDate?: Date;
    serialLength?: string | undefined;
    totalNumber?: number;
    soldNumber?: number;
    totalSoldDeploy?: number;
    configureNumber?: number;
    reConfigureNumber?: number;
    deployNumber?: number;
    pendingDeploy?: number;
    maintenanceNumber?: number;
    notReceivedNumber?: number;
    damageNumber?: number;
    remainingNumber?: number;

    constructor(data?: IGetInventroysAddQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.inventoryId = _data["inventoryId"];
            this.inventoryAddId = _data["inventoryAddId"];
            this.primaryItem = _data["primaryItem"];
            this.secondaryItem = _data["secondaryItem"];
            this.tertiaryItem = _data["tertiaryItem"];
            this.detailItem = _data["detailItem"];
            this.item = _data["item"];
            this.buyDate = _data["buyDate"] ? new Date(_data["buyDate"].toString()) : <any>undefined;
            this.serialLength = _data["serialLength"];
            this.totalNumber = _data["totalNumber"];
            this.soldNumber = _data["soldNumber"];
            this.totalSoldDeploy = _data["totalSoldDeploy"];
            this.configureNumber = _data["configureNumber"];
            this.reConfigureNumber = _data["reConfigureNumber"];
            this.deployNumber = _data["deployNumber"];
            this.pendingDeploy = _data["pendingDeploy"];
            this.maintenanceNumber = _data["maintenanceNumber"];
            this.notReceivedNumber = _data["notReceivedNumber"];
            this.damageNumber = _data["damageNumber"];
            this.remainingNumber = _data["remainingNumber"];
        }
    }

    static fromJS(data: any): GetInventroysAddQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetInventroysAddQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["inventoryId"] = this.inventoryId;
        data["inventoryAddId"] = this.inventoryAddId;
        data["primaryItem"] = this.primaryItem;
        data["secondaryItem"] = this.secondaryItem;
        data["tertiaryItem"] = this.tertiaryItem;
        data["detailItem"] = this.detailItem;
        data["item"] = this.item;
        data["buyDate"] = this.buyDate ? this.buyDate.toISOString() : <any>undefined;
        data["serialLength"] = this.serialLength;
        data["totalNumber"] = this.totalNumber;
        data["soldNumber"] = this.soldNumber;
        data["totalSoldDeploy"] = this.totalSoldDeploy;
        data["configureNumber"] = this.configureNumber;
        data["reConfigureNumber"] = this.reConfigureNumber;
        data["deployNumber"] = this.deployNumber;
        data["pendingDeploy"] = this.pendingDeploy;
        data["maintenanceNumber"] = this.maintenanceNumber;
        data["notReceivedNumber"] = this.notReceivedNumber;
        data["damageNumber"] = this.damageNumber;
        data["remainingNumber"] = this.remainingNumber;
        return data;
    }
}

export interface IGetInventroysAddQuery {
    id?: string;
    inventoryId?: string;
    inventoryAddId?: string;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    item?: string | undefined;
    buyDate?: Date;
    serialLength?: string | undefined;
    totalNumber?: number;
    soldNumber?: number;
    totalSoldDeploy?: number;
    configureNumber?: number;
    reConfigureNumber?: number;
    deployNumber?: number;
    pendingDeploy?: number;
    maintenanceNumber?: number;
    notReceivedNumber?: number;
    damageNumber?: number;
    remainingNumber?: number;
}

export class InventoryViewModel implements IInventoryViewModel {
    id?: string;
    brandName?: string | undefined;
    os?: string | undefined;
    series?: string | undefined;
    model?: string | undefined;
    ram?: string | undefined;
    rom?: string | undefined;
    osVersion?: string | undefined;
    description?: string | undefined;
    connectivities?: Connectivity[] | undefined;
    serialLength?: string | undefined;
    shortName?: string | undefined;
    isConfigurations?: boolean;

    constructor(data?: IInventoryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.brandName = _data["brandName"];
            this.os = _data["os"];
            this.series = _data["series"];
            this.model = _data["model"];
            this.ram = _data["ram"];
            this.rom = _data["rom"];
            this.osVersion = _data["osVersion"];
            this.description = _data["description"];
            if (Array.isArray(_data["connectivities"])) {
                this.connectivities = [] as any;
                for (let item of _data["connectivities"])
                    this.connectivities!.push(item);
            }
            this.serialLength = _data["serialLength"];
            this.shortName = _data["shortName"];
            this.isConfigurations = _data["isConfigurations"];
        }
    }

    static fromJS(data: any): InventoryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["brandName"] = this.brandName;
        data["os"] = this.os;
        data["series"] = this.series;
        data["model"] = this.model;
        data["ram"] = this.ram;
        data["rom"] = this.rom;
        data["osVersion"] = this.osVersion;
        data["description"] = this.description;
        if (Array.isArray(this.connectivities)) {
            data["connectivities"] = [];
            for (let item of this.connectivities)
                data["connectivities"].push(item);
        }
        data["serialLength"] = this.serialLength;
        data["shortName"] = this.shortName;
        data["isConfigurations"] = this.isConfigurations;
        return data;
    }
}

export interface IInventoryViewModel {
    id?: string;
    brandName?: string | undefined;
    os?: string | undefined;
    series?: string | undefined;
    model?: string | undefined;
    ram?: string | undefined;
    rom?: string | undefined;
    osVersion?: string | undefined;
    description?: string | undefined;
    connectivities?: Connectivity[] | undefined;
    serialLength?: string | undefined;
    shortName?: string | undefined;
    isConfigurations?: boolean;
}

export class InventoryCommand implements IInventoryCommand {
    brandName?: string | undefined;
    os?: string | undefined;
    series?: string | undefined;
    model?: string | undefined;
    ram?: string | undefined;
    rom?: string | undefined;
    osVersion?: string | undefined;
    shortName?: string | undefined;
    description?: string | undefined;
    connectivities?: Connectivity[] | undefined;
    serialLength?: string | undefined;
    isConfigurations?: boolean | undefined;
    isCless?: boolean | undefined;

    constructor(data?: IInventoryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.brandName = _data["brandName"];
            this.os = _data["os"];
            this.series = _data["series"];
            this.model = _data["model"];
            this.ram = _data["ram"];
            this.rom = _data["rom"];
            this.osVersion = _data["osVersion"];
            this.shortName = _data["shortName"];
            this.description = _data["description"];
            if (Array.isArray(_data["connectivities"])) {
                this.connectivities = [] as any;
                for (let item of _data["connectivities"])
                    this.connectivities!.push(item);
            }
            this.serialLength = _data["serialLength"];
            this.isConfigurations = _data["isConfigurations"];
            this.isCless = _data["isCless"];
        }
    }

    static fromJS(data: any): InventoryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brandName"] = this.brandName;
        data["os"] = this.os;
        data["series"] = this.series;
        data["model"] = this.model;
        data["ram"] = this.ram;
        data["rom"] = this.rom;
        data["osVersion"] = this.osVersion;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        if (Array.isArray(this.connectivities)) {
            data["connectivities"] = [];
            for (let item of this.connectivities)
                data["connectivities"].push(item);
        }
        data["serialLength"] = this.serialLength;
        data["isConfigurations"] = this.isConfigurations;
        data["isCless"] = this.isCless;
        return data;
    }
}

export interface IInventoryCommand {
    brandName?: string | undefined;
    os?: string | undefined;
    series?: string | undefined;
    model?: string | undefined;
    ram?: string | undefined;
    rom?: string | undefined;
    osVersion?: string | undefined;
    shortName?: string | undefined;
    description?: string | undefined;
    connectivities?: Connectivity[] | undefined;
    serialLength?: string | undefined;
    isConfigurations?: boolean | undefined;
    isCless?: boolean | undefined;
}

export class AcccesssoryCommand implements IAcccesssoryCommand {
    detailItem?: string | undefined;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;

    constructor(data?: IAcccesssoryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.detailItem = _data["detailItem"];
            this.primaryItem = _data["primaryItem"];
            this.secondaryItem = _data["secondaryItem"];
            this.tertiaryItem = _data["tertiaryItem"];
        }
    }

    static fromJS(data: any): AcccesssoryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AcccesssoryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["detailItem"] = this.detailItem;
        data["primaryItem"] = this.primaryItem;
        data["secondaryItem"] = this.secondaryItem;
        data["tertiaryItem"] = this.tertiaryItem;
        return data;
    }
}

export interface IAcccesssoryCommand {
    detailItem?: string | undefined;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
}

export class MaintenanceViewModel implements IMaintenanceViewModel {
    id?: string;
    serialNumberId?: string;
    bankId?: string;
    serialNumber?: string | undefined;
    deploymentRequestId?: string;
    applicationVersionId?: string;
    status?: string | undefined;
    terminate?: string | undefined;
    issue?: string | undefined;
    resolvedBy?: string | undefined;
    remarks?: string | undefined;
    verification?: string | undefined;
    verifiedBy?: string | undefined;
    verifiedDate?: Date;
    itemRow?: ItemRowViewModel | undefined;
    maintenanceVM?: MaintenanceIssueViewModel[] | undefined;
    itemRows?: ItemRowViewModel[] | undefined;
    inventoryId?: string;
    inventoryAddId?: string;
    inventoryName?: string | undefined;
    merchant?: string | undefined;
    deployDate?: Date;
    buyDate?: Date;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    bankName?: string | undefined;
    idTerminal?: string | undefined;
    idMerchant?: string | undefined;
    bankCode?: string | undefined;
    item?: string | undefined;
    applicationFormat?: string | undefined;
    outlet?: string | undefined;
    district?: string | undefined;
    address?: string | undefined;
    province?: string | undefined;
    merchantCategory?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    createdDate?: string | undefined;

    constructor(data?: IMaintenanceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serialNumberId = _data["serialNumberId"];
            this.bankId = _data["bankId"];
            this.serialNumber = _data["serialNumber"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.applicationVersionId = _data["applicationVersionId"];
            this.status = _data["status"];
            this.terminate = _data["terminate"];
            this.issue = _data["issue"];
            this.resolvedBy = _data["resolvedBy"];
            this.remarks = _data["remarks"];
            this.verification = _data["verification"];
            this.verifiedBy = _data["verifiedBy"];
            this.verifiedDate = _data["verifiedDate"] ? new Date(_data["verifiedDate"].toString()) : <any>undefined;
            this.itemRow = _data["itemRow"] ? ItemRowViewModel.fromJS(_data["itemRow"]) : <any>undefined;
            if (Array.isArray(_data["maintenanceVM"])) {
                this.maintenanceVM = [] as any;
                for (let item of _data["maintenanceVM"])
                    this.maintenanceVM!.push(MaintenanceIssueViewModel.fromJS(item));
            }
            if (Array.isArray(_data["itemRows"])) {
                this.itemRows = [] as any;
                for (let item of _data["itemRows"])
                    this.itemRows!.push(ItemRowViewModel.fromJS(item));
            }
            this.inventoryId = _data["inventoryId"];
            this.inventoryAddId = _data["inventoryAddId"];
            this.inventoryName = _data["inventoryName"];
            this.merchant = _data["merchant"];
            this.deployDate = _data["deployDate"] ? new Date(_data["deployDate"].toString()) : <any>undefined;
            this.buyDate = _data["buyDate"] ? new Date(_data["buyDate"].toString()) : <any>undefined;
            this.primaryItem = _data["primaryItem"];
            this.secondaryItem = _data["secondaryItem"];
            this.tertiaryItem = _data["tertiaryItem"];
            this.detailItem = _data["detailItem"];
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.bankName = _data["bankName"];
            this.idTerminal = _data["idTerminal"];
            this.idMerchant = _data["idMerchant"];
            this.bankCode = _data["bankCode"];
            this.item = _data["item"];
            this.applicationFormat = _data["applicationFormat"];
            this.outlet = _data["outlet"];
            this.district = _data["district"];
            this.address = _data["address"];
            this.province = _data["province"];
            this.merchantCategory = _data["merchantCategory"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo = _data["contactNo"];
            this.createdDate = _data["createdDate"];
        }
    }

    static fromJS(data: any): MaintenanceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serialNumberId"] = this.serialNumberId;
        data["bankId"] = this.bankId;
        data["serialNumber"] = this.serialNumber;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["applicationVersionId"] = this.applicationVersionId;
        data["status"] = this.status;
        data["terminate"] = this.terminate;
        data["issue"] = this.issue;
        data["resolvedBy"] = this.resolvedBy;
        data["remarks"] = this.remarks;
        data["verification"] = this.verification;
        data["verifiedBy"] = this.verifiedBy;
        data["verifiedDate"] = this.verifiedDate ? this.verifiedDate.toISOString() : <any>undefined;
        data["itemRow"] = this.itemRow ? this.itemRow.toJSON() : <any>undefined;
        if (Array.isArray(this.maintenanceVM)) {
            data["maintenanceVM"] = [];
            for (let item of this.maintenanceVM)
                data["maintenanceVM"].push(item.toJSON());
        }
        if (Array.isArray(this.itemRows)) {
            data["itemRows"] = [];
            for (let item of this.itemRows)
                data["itemRows"].push(item.toJSON());
        }
        data["inventoryId"] = this.inventoryId;
        data["inventoryAddId"] = this.inventoryAddId;
        data["inventoryName"] = this.inventoryName;
        data["merchant"] = this.merchant;
        data["deployDate"] = this.deployDate ? this.deployDate.toISOString() : <any>undefined;
        data["buyDate"] = this.buyDate ? this.buyDate.toISOString() : <any>undefined;
        data["primaryItem"] = this.primaryItem;
        data["secondaryItem"] = this.secondaryItem;
        data["tertiaryItem"] = this.tertiaryItem;
        data["detailItem"] = this.detailItem;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["bankName"] = this.bankName;
        data["idTerminal"] = this.idTerminal;
        data["idMerchant"] = this.idMerchant;
        data["bankCode"] = this.bankCode;
        data["item"] = this.item;
        data["applicationFormat"] = this.applicationFormat;
        data["outlet"] = this.outlet;
        data["district"] = this.district;
        data["address"] = this.address;
        data["province"] = this.province;
        data["merchantCategory"] = this.merchantCategory;
        data["contactPerson"] = this.contactPerson;
        data["contactNo"] = this.contactNo;
        data["createdDate"] = this.createdDate;
        return data;
    }
}

export interface IMaintenanceViewModel {
    id?: string;
    serialNumberId?: string;
    bankId?: string;
    serialNumber?: string | undefined;
    deploymentRequestId?: string;
    applicationVersionId?: string;
    status?: string | undefined;
    terminate?: string | undefined;
    issue?: string | undefined;
    resolvedBy?: string | undefined;
    remarks?: string | undefined;
    verification?: string | undefined;
    verifiedBy?: string | undefined;
    verifiedDate?: Date;
    itemRow?: ItemRowViewModel | undefined;
    maintenanceVM?: MaintenanceIssueViewModel[] | undefined;
    itemRows?: ItemRowViewModel[] | undefined;
    inventoryId?: string;
    inventoryAddId?: string;
    inventoryName?: string | undefined;
    merchant?: string | undefined;
    deployDate?: Date;
    buyDate?: Date;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    bankName?: string | undefined;
    idTerminal?: string | undefined;
    idMerchant?: string | undefined;
    bankCode?: string | undefined;
    item?: string | undefined;
    applicationFormat?: string | undefined;
    outlet?: string | undefined;
    district?: string | undefined;
    address?: string | undefined;
    province?: string | undefined;
    merchantCategory?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    createdDate?: string | undefined;
}

export class ItemRowViewModel implements IItemRowViewModel {
    itemRows?: ItemRowsViewModel[] | undefined;

    constructor(data?: IItemRowViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["itemRows"])) {
                this.itemRows = [] as any;
                for (let item of _data["itemRows"])
                    this.itemRows!.push(ItemRowsViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ItemRowViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ItemRowViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.itemRows)) {
            data["itemRows"] = [];
            for (let item of this.itemRows)
                data["itemRows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IItemRowViewModel {
    itemRows?: ItemRowsViewModel[] | undefined;
}

export class ItemRowsViewModel implements IItemRowsViewModel {
    id?: number;
    maintenanceId?: string;
    issue?: string | undefined;
    maintenanceViewModel?: MaintenanceViewModel | undefined;
    remarks?: string | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    createdDate?: Date;

    constructor(data?: IItemRowsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.maintenanceId = _data["maintenanceId"];
            this.issue = _data["issue"];
            this.maintenanceViewModel = _data["maintenanceViewModel"] ? MaintenanceViewModel.fromJS(_data["maintenanceViewModel"]) : <any>undefined;
            this.remarks = _data["remarks"];
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ItemRowsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ItemRowsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["maintenanceId"] = this.maintenanceId;
        data["issue"] = this.issue;
        data["maintenanceViewModel"] = this.maintenanceViewModel ? this.maintenanceViewModel.toJSON() : <any>undefined;
        data["remarks"] = this.remarks;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IItemRowsViewModel {
    id?: number;
    maintenanceId?: string;
    issue?: string | undefined;
    maintenanceViewModel?: MaintenanceViewModel | undefined;
    remarks?: string | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    createdDate?: Date;
}

export class MaintenanceIssueViewModel implements IMaintenanceIssueViewModel {
    id?: number;
    issue?: string | undefined;
    remarks?: string | undefined;
    maintenanceViewModel?: MaintenanceViewModel | undefined;
    itemRowViewModel?: ItemRowViewModel | undefined;
    maintenanceId?: string;

    constructor(data?: IMaintenanceIssueViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.issue = _data["issue"];
            this.remarks = _data["remarks"];
            this.maintenanceViewModel = _data["maintenanceViewModel"] ? MaintenanceViewModel.fromJS(_data["maintenanceViewModel"]) : <any>undefined;
            this.itemRowViewModel = _data["itemRowViewModel"] ? ItemRowViewModel.fromJS(_data["itemRowViewModel"]) : <any>undefined;
            this.maintenanceId = _data["maintenanceId"];
        }
    }

    static fromJS(data: any): MaintenanceIssueViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceIssueViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["issue"] = this.issue;
        data["remarks"] = this.remarks;
        data["maintenanceViewModel"] = this.maintenanceViewModel ? this.maintenanceViewModel.toJSON() : <any>undefined;
        data["itemRowViewModel"] = this.itemRowViewModel ? this.itemRowViewModel.toJSON() : <any>undefined;
        data["maintenanceId"] = this.maintenanceId;
        return data;
    }
}

export interface IMaintenanceIssueViewModel {
    id?: number;
    issue?: string | undefined;
    remarks?: string | undefined;
    maintenanceViewModel?: MaintenanceViewModel | undefined;
    itemRowViewModel?: ItemRowViewModel | undefined;
    maintenanceId?: string;
}

export class MaintenanceIssuesQuery implements IMaintenanceIssuesQuery {
    createdDate?: string | undefined;
    createdBy?: string | undefined;
    issues?: string | undefined;
    remarks?: string | undefined;

    constructor(data?: IMaintenanceIssuesQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdDate = _data["createdDate"];
            this.createdBy = _data["createdBy"];
            this.issues = _data["issues"];
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): MaintenanceIssuesQuery {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceIssuesQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdDate"] = this.createdDate;
        data["createdBy"] = this.createdBy;
        data["issues"] = this.issues;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface IMaintenanceIssuesQuery {
    createdDate?: string | undefined;
    createdBy?: string | undefined;
    issues?: string | undefined;
    remarks?: string | undefined;
}

export class CreateMaintenanceFromNotReceivedPosCommand implements ICreateMaintenanceFromNotReceivedPosCommand {
    id?: string;
    deploymentRequestId?: string;
    bankId?: string;
    serialNumberId?: string;
    inventoryId?: string;
    inventoryAddId?: string;
    applicationVersionId?: string;
    status?: string | undefined;
    remarks?: string | undefined;
    verifiedBy?: string | undefined;
    address?: string | undefined;
    district?: string | undefined;
    province?: string | undefined;
    merchant?: string | undefined;
    merchantCategory?: string | undefined;
    contactNo?: string | undefined;
    contactPerson?: string | undefined;
    serialNumber?: string | undefined;

    constructor(data?: ICreateMaintenanceFromNotReceivedPosCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.bankId = _data["bankId"];
            this.serialNumberId = _data["serialNumberId"];
            this.inventoryId = _data["inventoryId"];
            this.inventoryAddId = _data["inventoryAddId"];
            this.applicationVersionId = _data["applicationVersionId"];
            this.status = _data["status"];
            this.remarks = _data["remarks"];
            this.verifiedBy = _data["verifiedBy"];
            this.address = _data["address"];
            this.district = _data["district"];
            this.province = _data["province"];
            this.merchant = _data["merchant"];
            this.merchantCategory = _data["merchantCategory"];
            this.contactNo = _data["contactNo"];
            this.contactPerson = _data["contactPerson"];
            this.serialNumber = _data["serialNumber"];
        }
    }

    static fromJS(data: any): CreateMaintenanceFromNotReceivedPosCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMaintenanceFromNotReceivedPosCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["bankId"] = this.bankId;
        data["serialNumberId"] = this.serialNumberId;
        data["inventoryId"] = this.inventoryId;
        data["inventoryAddId"] = this.inventoryAddId;
        data["applicationVersionId"] = this.applicationVersionId;
        data["status"] = this.status;
        data["remarks"] = this.remarks;
        data["verifiedBy"] = this.verifiedBy;
        data["address"] = this.address;
        data["district"] = this.district;
        data["province"] = this.province;
        data["merchant"] = this.merchant;
        data["merchantCategory"] = this.merchantCategory;
        data["contactNo"] = this.contactNo;
        data["contactPerson"] = this.contactPerson;
        data["serialNumber"] = this.serialNumber;
        return data;
    }
}

export interface ICreateMaintenanceFromNotReceivedPosCommand {
    id?: string;
    deploymentRequestId?: string;
    bankId?: string;
    serialNumberId?: string;
    inventoryId?: string;
    inventoryAddId?: string;
    applicationVersionId?: string;
    status?: string | undefined;
    remarks?: string | undefined;
    verifiedBy?: string | undefined;
    address?: string | undefined;
    district?: string | undefined;
    province?: string | undefined;
    merchant?: string | undefined;
    merchantCategory?: string | undefined;
    contactNo?: string | undefined;
    contactPerson?: string | undefined;
    serialNumber?: string | undefined;
}

export class CreateMaintenanceIssueFromMaintenanceCommand implements ICreateMaintenanceIssueFromMaintenanceCommand {
    deploymentRequestId?: string;
    bankId?: string;
    inventoryId?: string;
    inventryAddId?: string;
    serialNumberId?: string;
    applicationVersionId?: string;
    status?: string | undefined;
    remarks?: string | undefined;
    resolvedBy?: string | undefined;
    terminate?: string | undefined;
    serialNumber?: string | undefined;
    maintenanceIssues?: MaintenanceIssues[] | undefined;

    constructor(data?: ICreateMaintenanceIssueFromMaintenanceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.bankId = _data["bankId"];
            this.inventoryId = _data["inventoryId"];
            this.inventryAddId = _data["inventryAddId"];
            this.serialNumberId = _data["serialNumberId"];
            this.applicationVersionId = _data["applicationVersionId"];
            this.status = _data["status"];
            this.remarks = _data["remarks"];
            this.resolvedBy = _data["resolvedBy"];
            this.terminate = _data["terminate"];
            this.serialNumber = _data["serialNumber"];
            if (Array.isArray(_data["maintenanceIssues"])) {
                this.maintenanceIssues = [] as any;
                for (let item of _data["maintenanceIssues"])
                    this.maintenanceIssues!.push(MaintenanceIssues.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateMaintenanceIssueFromMaintenanceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMaintenanceIssueFromMaintenanceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["bankId"] = this.bankId;
        data["inventoryId"] = this.inventoryId;
        data["inventryAddId"] = this.inventryAddId;
        data["serialNumberId"] = this.serialNumberId;
        data["applicationVersionId"] = this.applicationVersionId;
        data["status"] = this.status;
        data["remarks"] = this.remarks;
        data["resolvedBy"] = this.resolvedBy;
        data["terminate"] = this.terminate;
        data["serialNumber"] = this.serialNumber;
        if (Array.isArray(this.maintenanceIssues)) {
            data["maintenanceIssues"] = [];
            for (let item of this.maintenanceIssues)
                data["maintenanceIssues"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateMaintenanceIssueFromMaintenanceCommand {
    deploymentRequestId?: string;
    bankId?: string;
    inventoryId?: string;
    inventryAddId?: string;
    serialNumberId?: string;
    applicationVersionId?: string;
    status?: string | undefined;
    remarks?: string | undefined;
    resolvedBy?: string | undefined;
    terminate?: string | undefined;
    serialNumber?: string | undefined;
    maintenanceIssues?: MaintenanceIssues[] | undefined;
}

export class MaintenanceIssues implements IMaintenanceIssues {
    id?: number;
    issue?: string | undefined;
    remarks?: string | undefined;

    constructor(data?: IMaintenanceIssues) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.issue = _data["issue"];
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): MaintenanceIssues {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceIssues();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["issue"] = this.issue;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface IMaintenanceIssues {
    id?: number;
    issue?: string | undefined;
    remarks?: string | undefined;
}

export class CreateMerchantCategoryCommand implements ICreateMerchantCategoryCommand {
    mcc?: string | undefined;
    merchantCategoryName?: string | undefined;
    description?: string | undefined;

    constructor(data?: ICreateMerchantCategoryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mcc = _data["mcc"];
            this.merchantCategoryName = _data["merchantCategoryName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateMerchantCategoryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMerchantCategoryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mcc"] = this.mcc;
        data["merchantCategoryName"] = this.merchantCategoryName;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateMerchantCategoryCommand {
    mcc?: string | undefined;
    merchantCategoryName?: string | undefined;
    description?: string | undefined;
}

export class UpdateMerchantCategoryCommand implements IUpdateMerchantCategoryCommand {
    id?: string;
    merchantCategoryName?: string | undefined;
    description?: string | undefined;

    constructor(data?: IUpdateMerchantCategoryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.merchantCategoryName = _data["merchantCategoryName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdateMerchantCategoryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMerchantCategoryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["merchantCategoryName"] = this.merchantCategoryName;
        data["description"] = this.description;
        return data;
    }
}

export interface IUpdateMerchantCategoryCommand {
    id?: string;
    merchantCategoryName?: string | undefined;
    description?: string | undefined;
}

export class MerchantInfoViewModel implements IMerchantInfoViewModel {
    id?: string;
    name?: string | undefined;
    latitude?: string | undefined;
    longitude?: string | undefined;
    province?: string | undefined;
    district?: string | undefined;
    municipality?: string | undefined;
    ward?: string | undefined;
    merchantContactNo?: string | undefined;
    issueContactNo?: string | undefined;
    contactPerson?: string | undefined;
    logo?: string | undefined;
    email?: string | undefined;
    mid?: string | undefined;
    tid?: string | undefined;
    optionalContactNo?: string | undefined;
    isLogoUploaded?: boolean;

    constructor(data?: IMerchantInfoViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.province = _data["province"];
            this.district = _data["district"];
            this.municipality = _data["municipality"];
            this.ward = _data["ward"];
            this.merchantContactNo = _data["merchantContactNo"];
            this.issueContactNo = _data["issueContactNo"];
            this.contactPerson = _data["contactPerson"];
            this.logo = _data["logo"];
            this.email = _data["email"];
            this.mid = _data["mid"];
            this.tid = _data["tid"];
            this.optionalContactNo = _data["optionalContactNo"];
            this.isLogoUploaded = _data["isLogoUploaded"];
        }
    }

    static fromJS(data: any): MerchantInfoViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantInfoViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["province"] = this.province;
        data["district"] = this.district;
        data["municipality"] = this.municipality;
        data["ward"] = this.ward;
        data["merchantContactNo"] = this.merchantContactNo;
        data["issueContactNo"] = this.issueContactNo;
        data["contactPerson"] = this.contactPerson;
        data["logo"] = this.logo;
        data["email"] = this.email;
        data["mid"] = this.mid;
        data["tid"] = this.tid;
        data["optionalContactNo"] = this.optionalContactNo;
        data["isLogoUploaded"] = this.isLogoUploaded;
        return data;
    }
}

export interface IMerchantInfoViewModel {
    id?: string;
    name?: string | undefined;
    latitude?: string | undefined;
    longitude?: string | undefined;
    province?: string | undefined;
    district?: string | undefined;
    municipality?: string | undefined;
    ward?: string | undefined;
    merchantContactNo?: string | undefined;
    issueContactNo?: string | undefined;
    contactPerson?: string | undefined;
    logo?: string | undefined;
    email?: string | undefined;
    mid?: string | undefined;
    tid?: string | undefined;
    optionalContactNo?: string | undefined;
    isLogoUploaded?: boolean;
}

export class TransactionSummary implements ITransactionSummary {
    totalTransactions?: number;
    todayTransactions?: number;

    constructor(data?: ITransactionSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalTransactions = _data["totalTransactions"];
            this.todayTransactions = _data["todayTransactions"];
        }
    }

    static fromJS(data: any): TransactionSummary {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalTransactions"] = this.totalTransactions;
        data["todayTransactions"] = this.todayTransactions;
        return data;
    }
}

export interface ITransactionSummary {
    totalTransactions?: number;
    todayTransactions?: number;
}

export class PaginatedListOfTransactionDetail implements IPaginatedListOfTransactionDetail {
    items?: TransactionDetail[] | undefined;
    pageSize?: number;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfTransactionDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TransactionDetail.fromJS(item));
            }
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfTransactionDetail {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfTransactionDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfTransactionDetail {
    items?: TransactionDetail[] | undefined;
    pageSize?: number;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class TransactionDetail implements ITransactionDetail {
    cardNumber?: string | undefined;
    amount?: number;
    transactionDate?: string | undefined;

    constructor(data?: ITransactionDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardNumber = _data["cardNumber"];
            this.amount = _data["amount"];
            this.transactionDate = _data["transactionDate"];
        }
    }

    static fromJS(data: any): TransactionDetail {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardNumber"] = this.cardNumber;
        data["amount"] = this.amount;
        data["transactionDate"] = this.transactionDate;
        return data;
    }
}

export interface ITransactionDetail {
    cardNumber?: string | undefined;
    amount?: number;
    transactionDate?: string | undefined;
}

export class IssuesViewModel implements IIssuesViewModel {
    id?: string;
    inventorysId?: string | undefined;
    issueDetails?: string | undefined;
    bankName?: string | undefined;
    inventoryType?: string | undefined;
    contactNumber?: string | undefined;
    name?: string | undefined;
    remarks?: string | undefined;
    streetTole?: string | undefined;
    createdDate?: Date;
    issueResolvedDate?: Date;
    issueResolvedBy?: string | undefined;
    bankId?: string | undefined;
    issueType?: IssueType;
    urgency?: Urgency;
    status?: MerchantStatus;
    day?: Date;
    month?: string | undefined;
    year?: number;

    constructor(data?: IIssuesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.inventorysId = _data["inventorysId"];
            this.issueDetails = _data["issueDetails"];
            this.bankName = _data["bankName"];
            this.inventoryType = _data["inventoryType"];
            this.contactNumber = _data["contactNumber"];
            this.name = _data["name"];
            this.remarks = _data["remarks"];
            this.streetTole = _data["streetTole"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.issueResolvedDate = _data["issueResolvedDate"] ? new Date(_data["issueResolvedDate"].toString()) : <any>undefined;
            this.issueResolvedBy = _data["issueResolvedBy"];
            this.bankId = _data["bankId"];
            this.issueType = _data["issueType"];
            this.urgency = _data["urgency"];
            this.status = _data["status"];
            this.day = _data["day"] ? new Date(_data["day"].toString()) : <any>undefined;
            this.month = _data["month"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): IssuesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new IssuesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["inventorysId"] = this.inventorysId;
        data["issueDetails"] = this.issueDetails;
        data["bankName"] = this.bankName;
        data["inventoryType"] = this.inventoryType;
        data["contactNumber"] = this.contactNumber;
        data["name"] = this.name;
        data["remarks"] = this.remarks;
        data["streetTole"] = this.streetTole;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["issueResolvedDate"] = this.issueResolvedDate ? this.issueResolvedDate.toISOString() : <any>undefined;
        data["issueResolvedBy"] = this.issueResolvedBy;
        data["bankId"] = this.bankId;
        data["issueType"] = this.issueType;
        data["urgency"] = this.urgency;
        data["status"] = this.status;
        data["day"] = this.day ? this.day.toISOString() : <any>undefined;
        data["month"] = this.month;
        data["year"] = this.year;
        return data;
    }
}

export interface IIssuesViewModel {
    id?: string;
    inventorysId?: string | undefined;
    issueDetails?: string | undefined;
    bankName?: string | undefined;
    inventoryType?: string | undefined;
    contactNumber?: string | undefined;
    name?: string | undefined;
    remarks?: string | undefined;
    streetTole?: string | undefined;
    createdDate?: Date;
    issueResolvedDate?: Date;
    issueResolvedBy?: string | undefined;
    bankId?: string | undefined;
    issueType?: IssueType;
    urgency?: Urgency;
    status?: MerchantStatus;
    day?: Date;
    month?: string | undefined;
    year?: number;
}

export enum IssueType {
    Technical = 0,
    SalesMarketing = 1,
    AccountBilling = 2,
    Others = 3,
}

export enum Urgency {
    Normal = 0,
    High = 1,
    Urgent = 2,
}

export enum MerchantStatus {
    Completed = 0,
    InComplete = 1,
    OnHold = 2,
    OnProgress = 3,
}

export class SliderViewModel implements ISliderViewModel {
    id?: string;
    sliderCategoryId?: number;
    slidertitle?: string | undefined;
    description?: string | undefined;
    urls?: string | undefined;
    image?: string | undefined;
    role?: string | undefined;
    status?: number;
    isSliderUploaded?: boolean;
    sliderPath?: string | undefined;

    constructor(data?: ISliderViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sliderCategoryId = _data["sliderCategoryId"];
            this.slidertitle = _data["slidertitle"];
            this.description = _data["description"];
            this.urls = _data["urls"];
            this.image = _data["image"];
            this.role = _data["role"];
            this.status = _data["status"];
            this.isSliderUploaded = _data["isSliderUploaded"];
            this.sliderPath = _data["sliderPath"];
        }
    }

    static fromJS(data: any): SliderViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SliderViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sliderCategoryId"] = this.sliderCategoryId;
        data["slidertitle"] = this.slidertitle;
        data["description"] = this.description;
        data["urls"] = this.urls;
        data["image"] = this.image;
        data["role"] = this.role;
        data["status"] = this.status;
        data["isSliderUploaded"] = this.isSliderUploaded;
        data["sliderPath"] = this.sliderPath;
        return data;
    }
}

export interface ISliderViewModel {
    id?: string;
    sliderCategoryId?: number;
    slidertitle?: string | undefined;
    description?: string | undefined;
    urls?: string | undefined;
    image?: string | undefined;
    role?: string | undefined;
    status?: number;
    isSliderUploaded?: boolean;
    sliderPath?: string | undefined;
}

export class RollRequestViewModel implements IRollRequestViewModel {
    id?: string;
    noOfRoll?: number;
    deliveryLongitude?: string | undefined;
    deliveryLatitude?: string | undefined;
    address?: string | undefined;
    remarks?: string | undefined;
    deliveryDate?: Date;
    requestedDate?: Date;
    merchantId?: string | undefined;
    status?: MerchantStatus;
    contactName?: string | undefined;
    contactNumber?: string | undefined;
    pendingRoll?: number;
    delveredRolls?: number;

    constructor(data?: IRollRequestViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.noOfRoll = _data["noOfRoll"];
            this.deliveryLongitude = _data["deliveryLongitude"];
            this.deliveryLatitude = _data["deliveryLatitude"];
            this.address = _data["address"];
            this.remarks = _data["remarks"];
            this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : <any>undefined;
            this.requestedDate = _data["requestedDate"] ? new Date(_data["requestedDate"].toString()) : <any>undefined;
            this.merchantId = _data["merchantId"];
            this.status = _data["status"];
            this.contactName = _data["contactName"];
            this.contactNumber = _data["contactNumber"];
            this.pendingRoll = _data["pendingRoll"];
            this.delveredRolls = _data["delveredRolls"];
        }
    }

    static fromJS(data: any): RollRequestViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RollRequestViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["noOfRoll"] = this.noOfRoll;
        data["deliveryLongitude"] = this.deliveryLongitude;
        data["deliveryLatitude"] = this.deliveryLatitude;
        data["address"] = this.address;
        data["remarks"] = this.remarks;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["requestedDate"] = this.requestedDate ? this.requestedDate.toISOString() : <any>undefined;
        data["merchantId"] = this.merchantId;
        data["status"] = this.status;
        data["contactName"] = this.contactName;
        data["contactNumber"] = this.contactNumber;
        data["pendingRoll"] = this.pendingRoll;
        data["delveredRolls"] = this.delveredRolls;
        return data;
    }
}

export interface IRollRequestViewModel {
    id?: string;
    noOfRoll?: number;
    deliveryLongitude?: string | undefined;
    deliveryLatitude?: string | undefined;
    address?: string | undefined;
    remarks?: string | undefined;
    deliveryDate?: Date;
    requestedDate?: Date;
    merchantId?: string | undefined;
    status?: MerchantStatus;
    contactName?: string | undefined;
    contactNumber?: string | undefined;
    pendingRoll?: number;
    delveredRolls?: number;
}

export class CreateMerchantTerminalMapCommand implements ICreateMerchantTerminalMapCommand {
    userId?: string | undefined;
    idTerminal?: string | undefined;

    constructor(data?: ICreateMerchantTerminalMapCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.idTerminal = _data["idTerminal"];
        }
    }

    static fromJS(data: any): CreateMerchantTerminalMapCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMerchantTerminalMapCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["idTerminal"] = this.idTerminal;
        return data;
    }
}

export interface ICreateMerchantTerminalMapCommand {
    userId?: string | undefined;
    idTerminal?: string | undefined;
}

export class MerchantTerminalMapVm implements IMerchantTerminalMapVm {
    terminalId?: string | undefined;
    merchantId?: string | undefined;
    serialKey?: string | undefined;

    constructor(data?: IMerchantTerminalMapVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.terminalId = _data["terminalId"];
            this.merchantId = _data["merchantId"];
            this.serialKey = _data["serialKey"];
        }
    }

    static fromJS(data: any): MerchantTerminalMapVm {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantTerminalMapVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["terminalId"] = this.terminalId;
        data["merchantId"] = this.merchantId;
        data["serialKey"] = this.serialKey;
        return data;
    }
}

export interface IMerchantTerminalMapVm {
    terminalId?: string | undefined;
    merchantId?: string | undefined;
    serialKey?: string | undefined;
}

export class MobileCardRequest implements IMobileCardRequest {
    id?: number;
    bureauId?: string | undefined;
    bankId?: string | undefined;
    cardRequestId?: number;
    hardwareId?: string | undefined;
    cardProductId?: number;
    totalPrinted?: number;
    totalDamaged?: number;
    cardType?: string | undefined;
    totalRequest?: number;
    fileName?: string | undefined;

    constructor(data?: IMobileCardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bureauId = _data["bureauId"];
            this.bankId = _data["bankId"];
            this.cardRequestId = _data["cardRequestId"];
            this.hardwareId = _data["hardwareId"];
            this.cardProductId = _data["cardProductId"];
            this.totalPrinted = _data["totalPrinted"];
            this.totalDamaged = _data["totalDamaged"];
            this.cardType = _data["cardType"];
            this.totalRequest = _data["totalRequest"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): MobileCardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MobileCardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bureauId"] = this.bureauId;
        data["bankId"] = this.bankId;
        data["cardRequestId"] = this.cardRequestId;
        data["hardwareId"] = this.hardwareId;
        data["cardProductId"] = this.cardProductId;
        data["totalPrinted"] = this.totalPrinted;
        data["totalDamaged"] = this.totalDamaged;
        data["cardType"] = this.cardType;
        data["totalRequest"] = this.totalRequest;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IMobileCardRequest {
    id?: number;
    bureauId?: string | undefined;
    bankId?: string | undefined;
    cardRequestId?: number;
    hardwareId?: string | undefined;
    cardProductId?: number;
    totalPrinted?: number;
    totalDamaged?: number;
    cardType?: string | undefined;
    totalRequest?: number;
    fileName?: string | undefined;
}

export class NacNumberVm implements INacNumberVm {
    bankId?: string;
    phoneNumber?: string | undefined;
    status?: string | undefined;

    constructor(data?: INacNumberVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankId = _data["bankId"];
            this.phoneNumber = _data["phoneNumber"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): NacNumberVm {
        data = typeof data === 'object' ? data : {};
        let result = new NacNumberVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankId"] = this.bankId;
        data["phoneNumber"] = this.phoneNumber;
        data["status"] = this.status;
        return data;
    }
}

export interface INacNumberVm {
    bankId?: string;
    phoneNumber?: string | undefined;
    status?: string | undefined;
}

export class AccessoryAddViewModel implements IAccessoryAddViewModel {
    id?: string;
    accessoryName?: string | undefined;
    accessoryId?: string;
    accessoryType?: string | undefined;
    accessoryDetail?: string | undefined;
    totalNumber?: number;
    buyDate?: Date;
    model?: string | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    merchantSold?: string | undefined;
    remainingNumber?: string | undefined;

    constructor(data?: IAccessoryAddViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accessoryName = _data["accessoryName"];
            this.accessoryId = _data["accessoryId"];
            this.accessoryType = _data["accessoryType"];
            this.accessoryDetail = _data["accessoryDetail"];
            this.totalNumber = _data["totalNumber"];
            this.buyDate = _data["buyDate"] ? new Date(_data["buyDate"].toString()) : <any>undefined;
            this.model = _data["model"];
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.merchantSold = _data["merchantSold"];
            this.remainingNumber = _data["remainingNumber"];
        }
    }

    static fromJS(data: any): AccessoryAddViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccessoryAddViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accessoryName"] = this.accessoryName;
        data["accessoryId"] = this.accessoryId;
        data["accessoryType"] = this.accessoryType;
        data["accessoryDetail"] = this.accessoryDetail;
        data["totalNumber"] = this.totalNumber;
        data["buyDate"] = this.buyDate ? this.buyDate.toISOString() : <any>undefined;
        data["model"] = this.model;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["merchantSold"] = this.merchantSold;
        data["remainingNumber"] = this.remainingNumber;
        return data;
    }
}

export interface IAccessoryAddViewModel {
    id?: string;
    accessoryName?: string | undefined;
    accessoryId?: string;
    accessoryType?: string | undefined;
    accessoryDetail?: string | undefined;
    totalNumber?: number;
    buyDate?: Date;
    model?: string | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    merchantSold?: string | undefined;
    remainingNumber?: string | undefined;
}

export class AccessoryListVM implements IAccessoryListVM {
    id?: string;
    accessoryType?: string | undefined;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;

    constructor(data?: IAccessoryListVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accessoryType = _data["accessoryType"];
            this.primaryItem = _data["primaryItem"];
            this.secondaryItem = _data["secondaryItem"];
            this.tertiaryItem = _data["tertiaryItem"];
            this.detailItem = _data["detailItem"];
        }
    }

    static fromJS(data: any): AccessoryListVM {
        data = typeof data === 'object' ? data : {};
        let result = new AccessoryListVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accessoryType"] = this.accessoryType;
        data["primaryItem"] = this.primaryItem;
        data["secondaryItem"] = this.secondaryItem;
        data["tertiaryItem"] = this.tertiaryItem;
        data["detailItem"] = this.detailItem;
        return data;
    }
}

export interface IAccessoryListVM {
    id?: string;
    accessoryType?: string | undefined;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
}

export class GetPosAccessorySalesQuery implements IGetPosAccessorySalesQuery {
    id?: string;
    item?: string | undefined;
    merchantSold?: number;
    totalNumber?: number;
    remainingNumber?: number;
    bankSold?: number;
    soldNumber?: number;

    constructor(data?: IGetPosAccessorySalesQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.item = _data["item"];
            this.merchantSold = _data["merchantSold"];
            this.totalNumber = _data["totalNumber"];
            this.remainingNumber = _data["remainingNumber"];
            this.bankSold = _data["bankSold"];
            this.soldNumber = _data["soldNumber"];
        }
    }

    static fromJS(data: any): GetPosAccessorySalesQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetPosAccessorySalesQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["item"] = this.item;
        data["merchantSold"] = this.merchantSold;
        data["totalNumber"] = this.totalNumber;
        data["remainingNumber"] = this.remainingNumber;
        data["bankSold"] = this.bankSold;
        data["soldNumber"] = this.soldNumber;
        return data;
    }
}

export interface IGetPosAccessorySalesQuery {
    id?: string;
    item?: string | undefined;
    merchantSold?: number;
    totalNumber?: number;
    remainingNumber?: number;
    bankSold?: number;
    soldNumber?: number;
}

export class MarkAsSeenViewModel implements IMarkAsSeenViewModel {
    userNotificationId?: number;

    constructor(data?: IMarkAsSeenViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNotificationId = _data["userNotificationId"];
        }
    }

    static fromJS(data: any): MarkAsSeenViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarkAsSeenViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNotificationId"] = this.userNotificationId;
        return data;
    }
}

export interface IMarkAsSeenViewModel {
    userNotificationId?: number;
}

export class NotReceivedPosViewModel implements INotReceivedPosViewModel {
    id?: string;
    deploymentRequestId?: string;
    configurationId?: string;
    inventoryId?: string;
    bankId?: string;
    inventoryAddId?: string;
    status?: string | undefined;
    configStatus?: string | undefined;
    bankName?: string | undefined;
    bankCode?: string | undefined;
    merchant?: string | undefined;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    outlet?: string | undefined;
    address?: string | undefined;
    district?: string | undefined;
    province?: string | undefined;
    merchantCategory?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    serialKey?: string | undefined;
    item?: string | undefined;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    createdBy?: string | undefined;
    createdDate?: Date;
    updatedDate?: Date;
    serialNumberId?: string;
    applicationVersionId?: string;
    deployedLocation?: string | undefined;
    receivedBy?: string | undefined;
    remark?: string | undefined;
    receivedContactNo?: string | undefined;
    applicationFormat?: string | undefined;
    statusDisplayName?: string | undefined;
    posNotReceivedStatus?: PosNotReceivedStatus | undefined;

    constructor(data?: INotReceivedPosViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.configurationId = _data["configurationId"];
            this.inventoryId = _data["inventoryId"];
            this.bankId = _data["bankId"];
            this.inventoryAddId = _data["inventoryAddId"];
            this.status = _data["status"];
            this.configStatus = _data["configStatus"];
            this.bankName = _data["bankName"];
            this.bankCode = _data["bankCode"];
            this.merchant = _data["merchant"];
            this.idMerchant = _data["idMerchant"];
            this.idTerminal = _data["idTerminal"];
            this.outlet = _data["outlet"];
            this.address = _data["address"];
            this.district = _data["district"];
            this.province = _data["province"];
            this.merchantCategory = _data["merchantCategory"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo = _data["contactNo"];
            this.serialKey = _data["serialKey"];
            this.item = _data["item"];
            this.primaryItem = _data["primaryItem"];
            this.secondaryItem = _data["secondaryItem"];
            this.tertiaryItem = _data["tertiaryItem"];
            this.detailItem = _data["detailItem"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.serialNumberId = _data["serialNumberId"];
            this.applicationVersionId = _data["applicationVersionId"];
            this.deployedLocation = _data["deployedLocation"];
            this.receivedBy = _data["receivedBy"];
            this.remark = _data["remark"];
            this.receivedContactNo = _data["receivedContactNo"];
            this.applicationFormat = _data["applicationFormat"];
            this.statusDisplayName = _data["statusDisplayName"];
            this.posNotReceivedStatus = _data["posNotReceivedStatus"];
        }
    }

    static fromJS(data: any): NotReceivedPosViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new NotReceivedPosViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["configurationId"] = this.configurationId;
        data["inventoryId"] = this.inventoryId;
        data["bankId"] = this.bankId;
        data["inventoryAddId"] = this.inventoryAddId;
        data["status"] = this.status;
        data["configStatus"] = this.configStatus;
        data["bankName"] = this.bankName;
        data["bankCode"] = this.bankCode;
        data["merchant"] = this.merchant;
        data["idMerchant"] = this.idMerchant;
        data["idTerminal"] = this.idTerminal;
        data["outlet"] = this.outlet;
        data["address"] = this.address;
        data["district"] = this.district;
        data["province"] = this.province;
        data["merchantCategory"] = this.merchantCategory;
        data["contactPerson"] = this.contactPerson;
        data["contactNo"] = this.contactNo;
        data["serialKey"] = this.serialKey;
        data["item"] = this.item;
        data["primaryItem"] = this.primaryItem;
        data["secondaryItem"] = this.secondaryItem;
        data["tertiaryItem"] = this.tertiaryItem;
        data["detailItem"] = this.detailItem;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["serialNumberId"] = this.serialNumberId;
        data["applicationVersionId"] = this.applicationVersionId;
        data["deployedLocation"] = this.deployedLocation;
        data["receivedBy"] = this.receivedBy;
        data["remark"] = this.remark;
        data["receivedContactNo"] = this.receivedContactNo;
        data["applicationFormat"] = this.applicationFormat;
        data["statusDisplayName"] = this.statusDisplayName;
        data["posNotReceivedStatus"] = this.posNotReceivedStatus;
        return data;
    }
}

export interface INotReceivedPosViewModel {
    id?: string;
    deploymentRequestId?: string;
    configurationId?: string;
    inventoryId?: string;
    bankId?: string;
    inventoryAddId?: string;
    status?: string | undefined;
    configStatus?: string | undefined;
    bankName?: string | undefined;
    bankCode?: string | undefined;
    merchant?: string | undefined;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    outlet?: string | undefined;
    address?: string | undefined;
    district?: string | undefined;
    province?: string | undefined;
    merchantCategory?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    serialKey?: string | undefined;
    item?: string | undefined;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    createdBy?: string | undefined;
    createdDate?: Date;
    updatedDate?: Date;
    serialNumberId?: string;
    applicationVersionId?: string;
    deployedLocation?: string | undefined;
    receivedBy?: string | undefined;
    remark?: string | undefined;
    receivedContactNo?: string | undefined;
    applicationFormat?: string | undefined;
    statusDisplayName?: string | undefined;
    posNotReceivedStatus?: PosNotReceivedStatus | undefined;
}

export class PosNotReceivedVm implements IPosNotReceivedVm {
    id?: string;
    bankId?: string | undefined;
    deploymentRequestId?: string | undefined;
    serialNumberId?: string | undefined;
    applicationVersionId?: string | undefined;
    inventoryId?: string | undefined;
    inventoryAddId?: string | undefined;
    createdDate?: string | undefined;
    bankName?: string | undefined;
    merchant?: string | undefined;
    merchantCategory?: string | undefined;
    merchantId?: string | undefined;
    terminalId?: string | undefined;
    terminalType?: string | undefined;
    applicationVersion?: string | undefined;
    posNotReceivedStatus?: string | undefined;
    serialNumber?: string | undefined;
    district?: string | undefined;
    address?: string | undefined;
    province?: string | undefined;
    deployedLocation?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    receivedBy?: string | undefined;
    receivedContactNo?: string | undefined;
    createdBy?: string | undefined;
    createdDates?: Date;
    terminalProperty?: string | undefined;
    statusReason?: string | undefined;
    updatedOn?: Date;

    constructor(data?: IPosNotReceivedVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bankId = _data["bankId"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.serialNumberId = _data["serialNumberId"];
            this.applicationVersionId = _data["applicationVersionId"];
            this.inventoryId = _data["inventoryId"];
            this.inventoryAddId = _data["inventoryAddId"];
            this.createdDate = _data["createdDate"];
            this.bankName = _data["bankName"];
            this.merchant = _data["merchant"];
            this.merchantCategory = _data["merchantCategory"];
            this.merchantId = _data["merchantId"];
            this.terminalId = _data["terminalId"];
            this.terminalType = _data["terminalType"];
            this.applicationVersion = _data["applicationVersion"];
            this.posNotReceivedStatus = _data["posNotReceivedStatus"];
            this.serialNumber = _data["serialNumber"];
            this.district = _data["district"];
            this.address = _data["address"];
            this.province = _data["province"];
            this.deployedLocation = _data["deployedLocation"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo = _data["contactNo"];
            this.receivedBy = _data["receivedBy"];
            this.receivedContactNo = _data["receivedContactNo"];
            this.createdBy = _data["createdBy"];
            this.createdDates = _data["createdDates"] ? new Date(_data["createdDates"].toString()) : <any>undefined;
            this.terminalProperty = _data["terminalProperty"];
            this.statusReason = _data["statusReason"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PosNotReceivedVm {
        data = typeof data === 'object' ? data : {};
        let result = new PosNotReceivedVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankId"] = this.bankId;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["serialNumberId"] = this.serialNumberId;
        data["applicationVersionId"] = this.applicationVersionId;
        data["inventoryId"] = this.inventoryId;
        data["inventoryAddId"] = this.inventoryAddId;
        data["createdDate"] = this.createdDate;
        data["bankName"] = this.bankName;
        data["merchant"] = this.merchant;
        data["merchantCategory"] = this.merchantCategory;
        data["merchantId"] = this.merchantId;
        data["terminalId"] = this.terminalId;
        data["terminalType"] = this.terminalType;
        data["applicationVersion"] = this.applicationVersion;
        data["posNotReceivedStatus"] = this.posNotReceivedStatus;
        data["serialNumber"] = this.serialNumber;
        data["district"] = this.district;
        data["address"] = this.address;
        data["province"] = this.province;
        data["deployedLocation"] = this.deployedLocation;
        data["contactPerson"] = this.contactPerson;
        data["contactNo"] = this.contactNo;
        data["receivedBy"] = this.receivedBy;
        data["receivedContactNo"] = this.receivedContactNo;
        data["createdBy"] = this.createdBy;
        data["createdDates"] = this.createdDates ? this.createdDates.toISOString() : <any>undefined;
        data["terminalProperty"] = this.terminalProperty;
        data["statusReason"] = this.statusReason;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPosNotReceivedVm {
    id?: string;
    bankId?: string | undefined;
    deploymentRequestId?: string | undefined;
    serialNumberId?: string | undefined;
    applicationVersionId?: string | undefined;
    inventoryId?: string | undefined;
    inventoryAddId?: string | undefined;
    createdDate?: string | undefined;
    bankName?: string | undefined;
    merchant?: string | undefined;
    merchantCategory?: string | undefined;
    merchantId?: string | undefined;
    terminalId?: string | undefined;
    terminalType?: string | undefined;
    applicationVersion?: string | undefined;
    posNotReceivedStatus?: string | undefined;
    serialNumber?: string | undefined;
    district?: string | undefined;
    address?: string | undefined;
    province?: string | undefined;
    deployedLocation?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    receivedBy?: string | undefined;
    receivedContactNo?: string | undefined;
    createdBy?: string | undefined;
    createdDates?: Date;
    terminalProperty?: string | undefined;
    statusReason?: string | undefined;
    updatedOn?: Date;
}

export class SendToStockFomNotReceivedPosCommand implements ISendToStockFomNotReceivedPosCommand {
    id?: string;
    deploymentRequestId?: string;
    bankId?: string;
    serialNumberId?: string;
    status?: string | undefined;
    remarks?: string | undefined;
    receivedBy?: string | undefined;

    constructor(data?: ISendToStockFomNotReceivedPosCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.bankId = _data["bankId"];
            this.serialNumberId = _data["serialNumberId"];
            this.status = _data["status"];
            this.remarks = _data["remarks"];
            this.receivedBy = _data["receivedBy"];
        }
    }

    static fromJS(data: any): SendToStockFomNotReceivedPosCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendToStockFomNotReceivedPosCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["bankId"] = this.bankId;
        data["serialNumberId"] = this.serialNumberId;
        data["status"] = this.status;
        data["remarks"] = this.remarks;
        data["receivedBy"] = this.receivedBy;
        return data;
    }
}

export interface ISendToStockFomNotReceivedPosCommand {
    id?: string;
    deploymentRequestId?: string;
    bankId?: string;
    serialNumberId?: string;
    status?: string | undefined;
    remarks?: string | undefined;
    receivedBy?: string | undefined;
}

export class OtherPartyViewModel implements IOtherPartyViewModel {
    id?: string;
    partyName?: string | undefined;
    partyAddress?: string | undefined;
    phoneNo?: string | undefined;

    constructor(data?: IOtherPartyViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.partyName = _data["partyName"];
            this.partyAddress = _data["partyAddress"];
            this.phoneNo = _data["phoneNo"];
        }
    }

    static fromJS(data: any): OtherPartyViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OtherPartyViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["partyName"] = this.partyName;
        data["partyAddress"] = this.partyAddress;
        data["phoneNo"] = this.phoneNo;
        return data;
    }
}

export interface IOtherPartyViewModel {
    id?: string;
    partyName?: string | undefined;
    partyAddress?: string | undefined;
    phoneNo?: string | undefined;
}

export class CreateOtherStockCommand implements ICreateOtherStockCommand {
    soldOut?: number;
    remarks?: string | undefined;
    receivedBy?: string | undefined;
    distributedBy?: string | undefined;
    contactNo?: string | undefined;
    accessoryId?: string;

    constructor(data?: ICreateOtherStockCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.soldOut = _data["soldOut"];
            this.remarks = _data["remarks"];
            this.receivedBy = _data["receivedBy"];
            this.distributedBy = _data["distributedBy"];
            this.contactNo = _data["contactNo"];
            this.accessoryId = _data["accessoryId"];
        }
    }

    static fromJS(data: any): CreateOtherStockCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOtherStockCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["soldOut"] = this.soldOut;
        data["remarks"] = this.remarks;
        data["receivedBy"] = this.receivedBy;
        data["distributedBy"] = this.distributedBy;
        data["contactNo"] = this.contactNo;
        data["accessoryId"] = this.accessoryId;
        return data;
    }
}

export interface ICreateOtherStockCommand {
    soldOut?: number;
    remarks?: string | undefined;
    receivedBy?: string | undefined;
    distributedBy?: string | undefined;
    contactNo?: string | undefined;
    accessoryId?: string;
}

export class AccessoryRequestDetailsFormData implements IAccessoryRequestDetailsFormData {
    id?: string;
    bankId?: string;
    applicationVersionId?: string;
    bankName?: string | undefined;
    merchantName?: string | undefined;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    contactPerson?: string | undefined;
    merchantCategory?: string | undefined;
    district?: string | undefined;
    address?: string | undefined;
    contactNo1?: string | undefined;
    item?: string | undefined;
    receivedBy?: string | undefined;
    serialKey?: string | undefined;
    terminalType?: string | undefined;
    receivedContactNo?: string | undefined;
    connectivity?: string | undefined;
    merchantLocation?: string | undefined;
    contactOfPos?: string | undefined;
    manualTransaction?: boolean;

    constructor(data?: IAccessoryRequestDetailsFormData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bankId = _data["bankId"];
            this.applicationVersionId = _data["applicationVersionId"];
            this.bankName = _data["bankName"];
            this.merchantName = _data["merchantName"];
            this.idMerchant = _data["idMerchant"];
            this.idTerminal = _data["idTerminal"];
            this.contactPerson = _data["contactPerson"];
            this.merchantCategory = _data["merchantCategory"];
            this.district = _data["district"];
            this.address = _data["address"];
            this.contactNo1 = _data["contactNo1"];
            this.item = _data["item"];
            this.receivedBy = _data["receivedBy"];
            this.serialKey = _data["serialKey"];
            this.terminalType = _data["terminalType"];
            this.receivedContactNo = _data["receivedContactNo"];
            this.connectivity = _data["connectivity"];
            this.merchantLocation = _data["merchantLocation"];
            this.contactOfPos = _data["contactOfPos"];
            this.manualTransaction = _data["manualTransaction"];
        }
    }

    static fromJS(data: any): AccessoryRequestDetailsFormData {
        data = typeof data === 'object' ? data : {};
        let result = new AccessoryRequestDetailsFormData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankId"] = this.bankId;
        data["applicationVersionId"] = this.applicationVersionId;
        data["bankName"] = this.bankName;
        data["merchantName"] = this.merchantName;
        data["idMerchant"] = this.idMerchant;
        data["idTerminal"] = this.idTerminal;
        data["contactPerson"] = this.contactPerson;
        data["merchantCategory"] = this.merchantCategory;
        data["district"] = this.district;
        data["address"] = this.address;
        data["contactNo1"] = this.contactNo1;
        data["item"] = this.item;
        data["receivedBy"] = this.receivedBy;
        data["serialKey"] = this.serialKey;
        data["terminalType"] = this.terminalType;
        data["receivedContactNo"] = this.receivedContactNo;
        data["connectivity"] = this.connectivity;
        data["merchantLocation"] = this.merchantLocation;
        data["contactOfPos"] = this.contactOfPos;
        data["manualTransaction"] = this.manualTransaction;
        return data;
    }
}

export interface IAccessoryRequestDetailsFormData {
    id?: string;
    bankId?: string;
    applicationVersionId?: string;
    bankName?: string | undefined;
    merchantName?: string | undefined;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    contactPerson?: string | undefined;
    merchantCategory?: string | undefined;
    district?: string | undefined;
    address?: string | undefined;
    contactNo1?: string | undefined;
    item?: string | undefined;
    receivedBy?: string | undefined;
    serialKey?: string | undefined;
    terminalType?: string | undefined;
    receivedContactNo?: string | undefined;
    connectivity?: string | undefined;
    merchantLocation?: string | undefined;
    contactOfPos?: string | undefined;
    manualTransaction?: boolean;
}

export class AccessoriesHistoryViewModel implements IAccessoriesHistoryViewModel {
    id?: string;
    deploymentRequestId?: string;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    detailItem?: string | undefined;
    bankName?: string | undefined;
    merchant?: string | undefined;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    soldOut?: number;
    distributedBy?: string | undefined;
    remarks?: string | undefined;
    receivedBy?: string | undefined;
    contactNo?: string | undefined;
    stockDate?: Date;
    stockDateInString?: string | undefined;
    createdBy?: string | undefined;
    tertiaryItem?: string | undefined;
    terminalType?: string | undefined;
    address?: string | undefined;

    constructor(data?: IAccessoriesHistoryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.primaryItem = _data["primaryItem"];
            this.secondaryItem = _data["secondaryItem"];
            this.detailItem = _data["detailItem"];
            this.bankName = _data["bankName"];
            this.merchant = _data["merchant"];
            this.idMerchant = _data["idMerchant"];
            this.idTerminal = _data["idTerminal"];
            this.soldOut = _data["soldOut"];
            this.distributedBy = _data["distributedBy"];
            this.remarks = _data["remarks"];
            this.receivedBy = _data["receivedBy"];
            this.contactNo = _data["contactNo"];
            this.stockDate = _data["stockDate"] ? new Date(_data["stockDate"].toString()) : <any>undefined;
            this.stockDateInString = _data["stockDateInString"];
            this.createdBy = _data["createdBy"];
            this.tertiaryItem = _data["tertiaryItem"];
            this.terminalType = _data["terminalType"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): AccessoriesHistoryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccessoriesHistoryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["primaryItem"] = this.primaryItem;
        data["secondaryItem"] = this.secondaryItem;
        data["detailItem"] = this.detailItem;
        data["bankName"] = this.bankName;
        data["merchant"] = this.merchant;
        data["idMerchant"] = this.idMerchant;
        data["idTerminal"] = this.idTerminal;
        data["soldOut"] = this.soldOut;
        data["distributedBy"] = this.distributedBy;
        data["remarks"] = this.remarks;
        data["receivedBy"] = this.receivedBy;
        data["contactNo"] = this.contactNo;
        data["stockDate"] = this.stockDate ? this.stockDate.toISOString() : <any>undefined;
        data["stockDateInString"] = this.stockDateInString;
        data["createdBy"] = this.createdBy;
        data["tertiaryItem"] = this.tertiaryItem;
        data["terminalType"] = this.terminalType;
        data["address"] = this.address;
        return data;
    }
}

export interface IAccessoriesHistoryViewModel {
    id?: string;
    deploymentRequestId?: string;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    detailItem?: string | undefined;
    bankName?: string | undefined;
    merchant?: string | undefined;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    soldOut?: number;
    distributedBy?: string | undefined;
    remarks?: string | undefined;
    receivedBy?: string | undefined;
    contactNo?: string | undefined;
    stockDate?: Date;
    stockDateInString?: string | undefined;
    createdBy?: string | undefined;
    tertiaryItem?: string | undefined;
    terminalType?: string | undefined;
    address?: string | undefined;
}

export class PaginatedListOfRemovalRequestViewModel implements IPaginatedListOfRemovalRequestViewModel {
    items?: RemovalRequestViewModel[] | undefined;
    pageSize?: number;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfRemovalRequestViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RemovalRequestViewModel.fromJS(item));
            }
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfRemovalRequestViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfRemovalRequestViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfRemovalRequestViewModel {
    items?: RemovalRequestViewModel[] | undefined;
    pageSize?: number;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class RemovalRequestViewModel implements IRemovalRequestViewModel {
    deploymentRequestId?: string | undefined;
    inventoryId?: string | undefined;
    bankId?: string | undefined;
    bankName?: string | undefined;
    bankCode?: string | undefined;
    merchant?: string | undefined;
    idMerchant?: string | undefined;
    district?: string | undefined;
    address?: string | undefined;
    contactPerson?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    idTerminal?: string | undefined;
    province?: string | undefined;
    merchantCategory?: string | undefined;
    merchantLocation?: string | undefined;
    terminalType?: string | undefined;
    remarks?: string | undefined;
    statusName?: string | undefined;
    requestName?: string | undefined;
    serialNumberId?: string | undefined;
    serialKey?: string | undefined;
    createdDate?: string | undefined;
    applicationVersionId?: string | undefined;
    updatedBy?: string | undefined;
    verifiedBy?: string | undefined;
    requestedOn?: string | undefined;
    previousSerial?: string | undefined;
    currentStatusValue?: string | undefined;
    statusUpdatedOn?: string | undefined;
    statusUpdatedDate?: string | undefined;
    receivedContactNo?: string | undefined;
    receivedBy?: string | undefined;
    pendingRemovalReason?: RemovalStatusReason | undefined;
    item?: string | undefined;
    requestedDate?: Date;
    latitude?: string | undefined;
    longitude?: string | undefined;
    terminalProperty?: string | undefined;

    constructor(data?: IRemovalRequestViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.inventoryId = _data["inventoryId"];
            this.bankId = _data["bankId"];
            this.bankName = _data["bankName"];
            this.bankCode = _data["bankCode"];
            this.merchant = _data["merchant"];
            this.idMerchant = _data["idMerchant"];
            this.district = _data["district"];
            this.address = _data["address"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo1 = _data["contactNo1"];
            this.contactNo2 = _data["contactNo2"];
            this.idTerminal = _data["idTerminal"];
            this.province = _data["province"];
            this.merchantCategory = _data["merchantCategory"];
            this.merchantLocation = _data["merchantLocation"];
            this.terminalType = _data["terminalType"];
            this.remarks = _data["remarks"];
            this.statusName = _data["statusName"];
            this.requestName = _data["requestName"];
            this.serialNumberId = _data["serialNumberId"];
            this.serialKey = _data["serialKey"];
            this.createdDate = _data["createdDate"];
            this.applicationVersionId = _data["applicationVersionId"];
            this.updatedBy = _data["updatedBy"];
            this.verifiedBy = _data["verifiedBy"];
            this.requestedOn = _data["requestedOn"];
            this.previousSerial = _data["previousSerial"];
            this.currentStatusValue = _data["currentStatusValue"];
            this.statusUpdatedOn = _data["statusUpdatedOn"];
            this.statusUpdatedDate = _data["statusUpdatedDate"];
            this.receivedContactNo = _data["receivedContactNo"];
            this.receivedBy = _data["receivedBy"];
            this.pendingRemovalReason = _data["pendingRemovalReason"];
            this.item = _data["item"];
            this.requestedDate = _data["requestedDate"] ? new Date(_data["requestedDate"].toString()) : <any>undefined;
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.terminalProperty = _data["terminalProperty"];
        }
    }

    static fromJS(data: any): RemovalRequestViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RemovalRequestViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["inventoryId"] = this.inventoryId;
        data["bankId"] = this.bankId;
        data["bankName"] = this.bankName;
        data["bankCode"] = this.bankCode;
        data["merchant"] = this.merchant;
        data["idMerchant"] = this.idMerchant;
        data["district"] = this.district;
        data["address"] = this.address;
        data["contactPerson"] = this.contactPerson;
        data["contactNo1"] = this.contactNo1;
        data["contactNo2"] = this.contactNo2;
        data["idTerminal"] = this.idTerminal;
        data["province"] = this.province;
        data["merchantCategory"] = this.merchantCategory;
        data["merchantLocation"] = this.merchantLocation;
        data["terminalType"] = this.terminalType;
        data["remarks"] = this.remarks;
        data["statusName"] = this.statusName;
        data["requestName"] = this.requestName;
        data["serialNumberId"] = this.serialNumberId;
        data["serialKey"] = this.serialKey;
        data["createdDate"] = this.createdDate;
        data["applicationVersionId"] = this.applicationVersionId;
        data["updatedBy"] = this.updatedBy;
        data["verifiedBy"] = this.verifiedBy;
        data["requestedOn"] = this.requestedOn;
        data["previousSerial"] = this.previousSerial;
        data["currentStatusValue"] = this.currentStatusValue;
        data["statusUpdatedOn"] = this.statusUpdatedOn;
        data["statusUpdatedDate"] = this.statusUpdatedDate;
        data["receivedContactNo"] = this.receivedContactNo;
        data["receivedBy"] = this.receivedBy;
        data["pendingRemovalReason"] = this.pendingRemovalReason;
        data["item"] = this.item;
        data["requestedDate"] = this.requestedDate ? this.requestedDate.toISOString() : <any>undefined;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["terminalProperty"] = this.terminalProperty;
        return data;
    }
}

export interface IRemovalRequestViewModel {
    deploymentRequestId?: string | undefined;
    inventoryId?: string | undefined;
    bankId?: string | undefined;
    bankName?: string | undefined;
    bankCode?: string | undefined;
    merchant?: string | undefined;
    idMerchant?: string | undefined;
    district?: string | undefined;
    address?: string | undefined;
    contactPerson?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    idTerminal?: string | undefined;
    province?: string | undefined;
    merchantCategory?: string | undefined;
    merchantLocation?: string | undefined;
    terminalType?: string | undefined;
    remarks?: string | undefined;
    statusName?: string | undefined;
    requestName?: string | undefined;
    serialNumberId?: string | undefined;
    serialKey?: string | undefined;
    createdDate?: string | undefined;
    applicationVersionId?: string | undefined;
    updatedBy?: string | undefined;
    verifiedBy?: string | undefined;
    requestedOn?: string | undefined;
    previousSerial?: string | undefined;
    currentStatusValue?: string | undefined;
    statusUpdatedOn?: string | undefined;
    statusUpdatedDate?: string | undefined;
    receivedContactNo?: string | undefined;
    receivedBy?: string | undefined;
    pendingRemovalReason?: RemovalStatusReason | undefined;
    item?: string | undefined;
    requestedDate?: Date;
    latitude?: string | undefined;
    longitude?: string | undefined;
    terminalProperty?: string | undefined;
}

export class PendingRemovalByIdViewModel implements IPendingRemovalByIdViewModel {
    deploymentRequestId?: string | undefined;
    bankName?: string | undefined;
    merchant?: string | undefined;
    idTerminal?: string | undefined;
    idMerchant?: string | undefined;
    address?: string | undefined;
    terminalType?: string | undefined;
    contactPerson?: string | undefined;
    contactNo2?: string | undefined;
    serialNumberId?: string;
    serialKey?: string | undefined;
    pendingRemovalReason?: RemovalStatusReason | undefined;
    currentStatusValue?: string | undefined;
    receivedContactNo?: string | undefined;
    receivedBy?: string | undefined;

    constructor(data?: IPendingRemovalByIdViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.bankName = _data["bankName"];
            this.merchant = _data["merchant"];
            this.idTerminal = _data["idTerminal"];
            this.idMerchant = _data["idMerchant"];
            this.address = _data["address"];
            this.terminalType = _data["terminalType"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo2 = _data["contactNo2"];
            this.serialNumberId = _data["serialNumberId"];
            this.serialKey = _data["serialKey"];
            this.pendingRemovalReason = _data["pendingRemovalReason"];
            this.currentStatusValue = _data["currentStatusValue"];
            this.receivedContactNo = _data["receivedContactNo"];
            this.receivedBy = _data["receivedBy"];
        }
    }

    static fromJS(data: any): PendingRemovalByIdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PendingRemovalByIdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["bankName"] = this.bankName;
        data["merchant"] = this.merchant;
        data["idTerminal"] = this.idTerminal;
        data["idMerchant"] = this.idMerchant;
        data["address"] = this.address;
        data["terminalType"] = this.terminalType;
        data["contactPerson"] = this.contactPerson;
        data["contactNo2"] = this.contactNo2;
        data["serialNumberId"] = this.serialNumberId;
        data["serialKey"] = this.serialKey;
        data["pendingRemovalReason"] = this.pendingRemovalReason;
        data["currentStatusValue"] = this.currentStatusValue;
        data["receivedContactNo"] = this.receivedContactNo;
        data["receivedBy"] = this.receivedBy;
        return data;
    }
}

export interface IPendingRemovalByIdViewModel {
    deploymentRequestId?: string | undefined;
    bankName?: string | undefined;
    merchant?: string | undefined;
    idTerminal?: string | undefined;
    idMerchant?: string | undefined;
    address?: string | undefined;
    terminalType?: string | undefined;
    contactPerson?: string | undefined;
    contactNo2?: string | undefined;
    serialNumberId?: string;
    serialKey?: string | undefined;
    pendingRemovalReason?: RemovalStatusReason | undefined;
    currentStatusValue?: string | undefined;
    receivedContactNo?: string | undefined;
    receivedBy?: string | undefined;
}

export class AddRemovalStatusViewModel implements IAddRemovalStatusViewModel {
    deploymentRequestId?: string | undefined;
    pendingRemovalReason?: RemovalStatusReason;

    constructor(data?: IAddRemovalStatusViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.pendingRemovalReason = _data["pendingRemovalReason"];
        }
    }

    static fromJS(data: any): AddRemovalStatusViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddRemovalStatusViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["pendingRemovalReason"] = this.pendingRemovalReason;
        return data;
    }
}

export interface IAddRemovalStatusViewModel {
    deploymentRequestId?: string | undefined;
    pendingRemovalReason?: RemovalStatusReason;
}

export class RetrieveTerminalViewModel implements IRetrieveTerminalViewModel {
    id?: string | undefined;
    bankId?: string | undefined;
    merchant?: string | undefined;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    address?: string | undefined;
    district?: string | undefined;
    ownership?: string | undefined;
    merchantCategory?: string | undefined;
    contactPerson?: string | undefined;
    terminalType?: string | undefined;
    bankName?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    remarks?: string | undefined;
    teminalStatus?: string | undefined;
    serialNumber?: string | undefined;
    createdBy?: string | undefined;
    updatedDate?: string | undefined;
    cashAdvance?: boolean;
    pinChange?: boolean;

    constructor(data?: IRetrieveTerminalViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bankId = _data["bankId"];
            this.merchant = _data["merchant"];
            this.idMerchant = _data["idMerchant"];
            this.idTerminal = _data["idTerminal"];
            this.address = _data["address"];
            this.district = _data["district"];
            this.ownership = _data["ownership"];
            this.merchantCategory = _data["merchantCategory"];
            this.contactPerson = _data["contactPerson"];
            this.terminalType = _data["terminalType"];
            this.bankName = _data["bankName"];
            this.contactNo1 = _data["contactNo1"];
            this.contactNo2 = _data["contactNo2"];
            this.remarks = _data["remarks"];
            this.teminalStatus = _data["teminalStatus"];
            this.serialNumber = _data["serialNumber"];
            this.createdBy = _data["createdBy"];
            this.updatedDate = _data["updatedDate"];
            this.cashAdvance = _data["cashAdvance"];
            this.pinChange = _data["pinChange"];
        }
    }

    static fromJS(data: any): RetrieveTerminalViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RetrieveTerminalViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankId"] = this.bankId;
        data["merchant"] = this.merchant;
        data["idMerchant"] = this.idMerchant;
        data["idTerminal"] = this.idTerminal;
        data["address"] = this.address;
        data["district"] = this.district;
        data["ownership"] = this.ownership;
        data["merchantCategory"] = this.merchantCategory;
        data["contactPerson"] = this.contactPerson;
        data["terminalType"] = this.terminalType;
        data["bankName"] = this.bankName;
        data["contactNo1"] = this.contactNo1;
        data["contactNo2"] = this.contactNo2;
        data["remarks"] = this.remarks;
        data["teminalStatus"] = this.teminalStatus;
        data["serialNumber"] = this.serialNumber;
        data["createdBy"] = this.createdBy;
        data["updatedDate"] = this.updatedDate;
        data["cashAdvance"] = this.cashAdvance;
        data["pinChange"] = this.pinChange;
        return data;
    }
}

export interface IRetrieveTerminalViewModel {
    id?: string | undefined;
    bankId?: string | undefined;
    merchant?: string | undefined;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    address?: string | undefined;
    district?: string | undefined;
    ownership?: string | undefined;
    merchantCategory?: string | undefined;
    contactPerson?: string | undefined;
    terminalType?: string | undefined;
    bankName?: string | undefined;
    contactNo1?: string | undefined;
    contactNo2?: string | undefined;
    remarks?: string | undefined;
    teminalStatus?: string | undefined;
    serialNumber?: string | undefined;
    createdBy?: string | undefined;
    updatedDate?: string | undefined;
    cashAdvance?: boolean;
    pinChange?: boolean;
}

export class CreatePosHistoryCommand implements ICreatePosHistoryCommand {
    deploymentRequestId?: string;
    serialKey?: string | undefined;
    applicationVersionId?: string;
    contactPerson?: string | undefined;
    contactNo1?: string | undefined;
    limit?: string | undefined;
    contactOfPos?: string | undefined;
    manualTransaction?: boolean;

    constructor(data?: ICreatePosHistoryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.serialKey = _data["serialKey"];
            this.applicationVersionId = _data["applicationVersionId"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo1 = _data["contactNo1"];
            this.limit = _data["limit"];
            this.contactOfPos = _data["contactOfPos"];
            this.manualTransaction = _data["manualTransaction"];
        }
    }

    static fromJS(data: any): CreatePosHistoryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePosHistoryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["serialKey"] = this.serialKey;
        data["applicationVersionId"] = this.applicationVersionId;
        data["contactPerson"] = this.contactPerson;
        data["contactNo1"] = this.contactNo1;
        data["limit"] = this.limit;
        data["contactOfPos"] = this.contactOfPos;
        data["manualTransaction"] = this.manualTransaction;
        return data;
    }
}

export interface ICreatePosHistoryCommand {
    deploymentRequestId?: string;
    serialKey?: string | undefined;
    applicationVersionId?: string;
    contactPerson?: string | undefined;
    contactNo1?: string | undefined;
    limit?: string | undefined;
    contactOfPos?: string | undefined;
    manualTransaction?: boolean;
}

export class RetrieveTerminalCommand implements IRetrieveTerminalCommand {
    deploymentRequestId?: string;
    chargerStatus?: string | undefined;
    cableReceived?: string | undefined;
    rollsReceived?: string | undefined;

    constructor(data?: IRetrieveTerminalCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.chargerStatus = _data["chargerStatus"];
            this.cableReceived = _data["cableReceived"];
            this.rollsReceived = _data["rollsReceived"];
        }
    }

    static fromJS(data: any): RetrieveTerminalCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RetrieveTerminalCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["chargerStatus"] = this.chargerStatus;
        data["cableReceived"] = this.cableReceived;
        data["rollsReceived"] = this.rollsReceived;
        return data;
    }
}

export interface IRetrieveTerminalCommand {
    deploymentRequestId?: string;
    chargerStatus?: string | undefined;
    cableReceived?: string | undefined;
    rollsReceived?: string | undefined;
}

export class PosStockViewModel implements IPosStockViewModel {
    id?: string;
    bankId?: string;
    bankName?: string | undefined;
    terminalType?: string | undefined;
    serialNumberId?: string;
    inventoryId?: string;
    inventoryAddId?: string;
    deploymentId?: string | undefined;
    serialNumber?: string | undefined;
    serialKey?: string | undefined;
    stockDate?: Date;
    status?: string | undefined;
    remarks?: string | undefined;
    location?: string | undefined;
    createdBy?: string | undefined;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    bankStatus?: string | undefined;
    total?: number;
    deployed?: number;
    available?: number;

    constructor(data?: IPosStockViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bankId = _data["bankId"];
            this.bankName = _data["bankName"];
            this.terminalType = _data["terminalType"];
            this.serialNumberId = _data["serialNumberId"];
            this.inventoryId = _data["inventoryId"];
            this.inventoryAddId = _data["inventoryAddId"];
            this.deploymentId = _data["deploymentId"];
            this.serialNumber = _data["serialNumber"];
            this.serialKey = _data["serialKey"];
            this.stockDate = _data["stockDate"] ? new Date(_data["stockDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.remarks = _data["remarks"];
            this.location = _data["location"];
            this.createdBy = _data["createdBy"];
            this.primaryItem = _data["primaryItem"];
            this.secondaryItem = _data["secondaryItem"];
            this.tertiaryItem = _data["tertiaryItem"];
            this.detailItem = _data["detailItem"];
            this.bankStatus = _data["bankStatus"];
            this.total = _data["total"];
            this.deployed = _data["deployed"];
            this.available = _data["available"];
        }
    }

    static fromJS(data: any): PosStockViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PosStockViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankId"] = this.bankId;
        data["bankName"] = this.bankName;
        data["terminalType"] = this.terminalType;
        data["serialNumberId"] = this.serialNumberId;
        data["inventoryId"] = this.inventoryId;
        data["inventoryAddId"] = this.inventoryAddId;
        data["deploymentId"] = this.deploymentId;
        data["serialNumber"] = this.serialNumber;
        data["serialKey"] = this.serialKey;
        data["stockDate"] = this.stockDate ? this.stockDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["remarks"] = this.remarks;
        data["location"] = this.location;
        data["createdBy"] = this.createdBy;
        data["primaryItem"] = this.primaryItem;
        data["secondaryItem"] = this.secondaryItem;
        data["tertiaryItem"] = this.tertiaryItem;
        data["detailItem"] = this.detailItem;
        data["bankStatus"] = this.bankStatus;
        data["total"] = this.total;
        data["deployed"] = this.deployed;
        data["available"] = this.available;
        return data;
    }
}

export interface IPosStockViewModel {
    id?: string;
    bankId?: string;
    bankName?: string | undefined;
    terminalType?: string | undefined;
    serialNumberId?: string;
    inventoryId?: string;
    inventoryAddId?: string;
    deploymentId?: string | undefined;
    serialNumber?: string | undefined;
    serialKey?: string | undefined;
    stockDate?: Date;
    status?: string | undefined;
    remarks?: string | undefined;
    location?: string | undefined;
    createdBy?: string | undefined;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    bankStatus?: string | undefined;
    total?: number;
    deployed?: number;
    available?: number;
}

export class BulkSaleCommand implements IBulkSaleCommand {
    bankId?: string;
    remarks?: string | undefined;
    location?: string | undefined;
    inventoryId?: string;
    serialNumberIds?: string[] | undefined;

    constructor(data?: IBulkSaleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankId = _data["bankId"];
            this.remarks = _data["remarks"];
            this.location = _data["location"];
            this.inventoryId = _data["inventoryId"];
            if (Array.isArray(_data["serialNumberIds"])) {
                this.serialNumberIds = [] as any;
                for (let item of _data["serialNumberIds"])
                    this.serialNumberIds!.push(item);
            }
        }
    }

    static fromJS(data: any): BulkSaleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BulkSaleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankId"] = this.bankId;
        data["remarks"] = this.remarks;
        data["location"] = this.location;
        data["inventoryId"] = this.inventoryId;
        if (Array.isArray(this.serialNumberIds)) {
            data["serialNumberIds"] = [];
            for (let item of this.serialNumberIds)
                data["serialNumberIds"].push(item);
        }
        return data;
    }
}

export interface IBulkSaleCommand {
    bankId?: string;
    remarks?: string | undefined;
    location?: string | undefined;
    inventoryId?: string;
    serialNumberIds?: string[] | undefined;
}

export class PrintReceiptViewModel implements IPrintReceiptViewModel {
    id?: number;
    deploymentRequestId?: string;
    printCount?: number;
    referenceNumber?: string | undefined;

    constructor(data?: IPrintReceiptViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.printCount = _data["printCount"];
            this.referenceNumber = _data["referenceNumber"];
        }
    }

    static fromJS(data: any): PrintReceiptViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PrintReceiptViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["printCount"] = this.printCount;
        data["referenceNumber"] = this.referenceNumber;
        return data;
    }
}

export interface IPrintReceiptViewModel {
    id?: number;
    deploymentRequestId?: string;
    printCount?: number;
    referenceNumber?: string | undefined;
}

export class CreatePrintReceiptCommand implements ICreatePrintReceiptCommand {
    deploymentRequestId?: string;
    printCount?: number;
    referenceNumber?: string | undefined;

    constructor(data?: ICreatePrintReceiptCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.printCount = _data["printCount"];
            this.referenceNumber = _data["referenceNumber"];
        }
    }

    static fromJS(data: any): CreatePrintReceiptCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePrintReceiptCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["printCount"] = this.printCount;
        data["referenceNumber"] = this.referenceNumber;
        return data;
    }
}

export interface ICreatePrintReceiptCommand {
    deploymentRequestId?: string;
    printCount?: number;
    referenceNumber?: string | undefined;
}

export class RequestTypeViewModel implements IRequestTypeViewModel {
    id?: string;
    requestName?: string | undefined;

    constructor(data?: IRequestTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.requestName = _data["requestName"];
        }
    }

    static fromJS(data: any): RequestTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequestTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["requestName"] = this.requestName;
        return data;
    }
}

export interface IRequestTypeViewModel {
    id?: string;
    requestName?: string | undefined;
}

export class SerialNumberViewModel implements ISerialNumberViewModel {
    id?: string;
    serialKey?: string | undefined;
    inventoryAddId?: string;
    isSold?: boolean;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    bankName?: string | undefined;
    status?: string | undefined;
    maintenanceSerial?: string | undefined;
    totalSerialKey?: number;
    remainingSerialKey?: number;
    serialNumberId?: string;
    isDeployed?: boolean;
    serialLength?: string | undefined;
    item?: string | undefined;
    createdDate?: string | undefined;
    fileName?: string | undefined;
    serialStatus?: SerialStatus;
    inventory?: Inventory | undefined;
    inventoryId?: string;

    constructor(data?: ISerialNumberViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serialKey = _data["serialKey"];
            this.inventoryAddId = _data["inventoryAddId"];
            this.isSold = _data["isSold"];
            this.primaryItem = _data["primaryItem"];
            this.secondaryItem = _data["secondaryItem"];
            this.tertiaryItem = _data["tertiaryItem"];
            this.detailItem = _data["detailItem"];
            this.bankName = _data["bankName"];
            this.status = _data["status"];
            this.maintenanceSerial = _data["maintenanceSerial"];
            this.totalSerialKey = _data["totalSerialKey"];
            this.remainingSerialKey = _data["remainingSerialKey"];
            this.serialNumberId = _data["serialNumberId"];
            this.isDeployed = _data["isDeployed"];
            this.serialLength = _data["serialLength"];
            this.item = _data["item"];
            this.createdDate = _data["createdDate"];
            this.fileName = _data["fileName"];
            this.serialStatus = _data["serialStatus"];
            this.inventory = _data["inventory"] ? Inventory.fromJS(_data["inventory"]) : <any>undefined;
            this.inventoryId = _data["inventoryId"];
        }
    }

    static fromJS(data: any): SerialNumberViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SerialNumberViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serialKey"] = this.serialKey;
        data["inventoryAddId"] = this.inventoryAddId;
        data["isSold"] = this.isSold;
        data["primaryItem"] = this.primaryItem;
        data["secondaryItem"] = this.secondaryItem;
        data["tertiaryItem"] = this.tertiaryItem;
        data["detailItem"] = this.detailItem;
        data["bankName"] = this.bankName;
        data["status"] = this.status;
        data["maintenanceSerial"] = this.maintenanceSerial;
        data["totalSerialKey"] = this.totalSerialKey;
        data["remainingSerialKey"] = this.remainingSerialKey;
        data["serialNumberId"] = this.serialNumberId;
        data["isDeployed"] = this.isDeployed;
        data["serialLength"] = this.serialLength;
        data["item"] = this.item;
        data["createdDate"] = this.createdDate;
        data["fileName"] = this.fileName;
        data["serialStatus"] = this.serialStatus;
        data["inventory"] = this.inventory ? this.inventory.toJSON() : <any>undefined;
        data["inventoryId"] = this.inventoryId;
        return data;
    }
}

export interface ISerialNumberViewModel {
    id?: string;
    serialKey?: string | undefined;
    inventoryAddId?: string;
    isSold?: boolean;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    bankName?: string | undefined;
    status?: string | undefined;
    maintenanceSerial?: string | undefined;
    totalSerialKey?: number;
    remainingSerialKey?: number;
    serialNumberId?: string;
    isDeployed?: boolean;
    serialLength?: string | undefined;
    item?: string | undefined;
    createdDate?: string | undefined;
    fileName?: string | undefined;
    serialStatus?: SerialStatus;
    inventory?: Inventory | undefined;
    inventoryId?: string;
}

export class SerialNumberConfigurationViewModel implements ISerialNumberConfigurationViewModel {
    id?: string;
    serialKey?: string | undefined;
    isSold?: boolean;
    inventoryAddId?: string;
    serialNumberId?: string;
    bankStatus?: string | undefined;

    constructor(data?: ISerialNumberConfigurationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serialKey = _data["serialKey"];
            this.isSold = _data["isSold"];
            this.inventoryAddId = _data["inventoryAddId"];
            this.serialNumberId = _data["serialNumberId"];
            this.bankStatus = _data["bankStatus"];
        }
    }

    static fromJS(data: any): SerialNumberConfigurationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SerialNumberConfigurationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serialKey"] = this.serialKey;
        data["isSold"] = this.isSold;
        data["inventoryAddId"] = this.inventoryAddId;
        data["serialNumberId"] = this.serialNumberId;
        data["bankStatus"] = this.bankStatus;
        return data;
    }
}

export interface ISerialNumberConfigurationViewModel {
    id?: string;
    serialKey?: string | undefined;
    isSold?: boolean;
    inventoryAddId?: string;
    serialNumberId?: string;
    bankStatus?: string | undefined;
}

export class AllSerialNumberListVm implements IAllSerialNumberListVm {
    serialKey?: string | undefined;
    item?: string | undefined;
    isSold?: boolean;
    status?: string | undefined;

    constructor(data?: IAllSerialNumberListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serialKey = _data["serialKey"];
            this.item = _data["item"];
            this.isSold = _data["isSold"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): AllSerialNumberListVm {
        data = typeof data === 'object' ? data : {};
        let result = new AllSerialNumberListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialKey"] = this.serialKey;
        data["item"] = this.item;
        data["isSold"] = this.isSold;
        data["status"] = this.status;
        return data;
    }
}

export interface IAllSerialNumberListVm {
    serialKey?: string | undefined;
    item?: string | undefined;
    isSold?: boolean;
    status?: string | undefined;
}

export class SerialNumberEntryCommand implements ISerialNumberEntryCommand {
    inventoryAddId?: string;
    serialKey?: string | undefined;

    constructor(data?: ISerialNumberEntryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inventoryAddId = _data["inventoryAddId"];
            this.serialKey = _data["serialKey"];
        }
    }

    static fromJS(data: any): SerialNumberEntryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SerialNumberEntryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inventoryAddId"] = this.inventoryAddId;
        data["serialKey"] = this.serialKey;
        return data;
    }
}

export interface ISerialNumberEntryCommand {
    inventoryAddId?: string;
    serialKey?: string | undefined;
}

export class BulkSerialEntryCommand implements IBulkSerialEntryCommand {
    inventoryAddId?: string;
    serialKey?: string | undefined;
    fileName?: string | undefined;
    remainingNumber?: number;
    serialLength?: number;

    constructor(data?: IBulkSerialEntryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inventoryAddId = _data["inventoryAddId"];
            this.serialKey = _data["serialKey"];
            this.fileName = _data["fileName"];
            this.remainingNumber = _data["remainingNumber"];
            this.serialLength = _data["serialLength"];
        }
    }

    static fromJS(data: any): BulkSerialEntryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BulkSerialEntryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inventoryAddId"] = this.inventoryAddId;
        data["serialKey"] = this.serialKey;
        data["fileName"] = this.fileName;
        data["remainingNumber"] = this.remainingNumber;
        data["serialLength"] = this.serialLength;
        return data;
    }
}

export interface IBulkSerialEntryCommand {
    inventoryAddId?: string;
    serialKey?: string | undefined;
    fileName?: string | undefined;
    remainingNumber?: number;
    serialLength?: number;
}

export class GetAllSpareRequestQuery implements IGetAllSpareRequestQuery {
    id?: string;
    bankId?: string;
    accessoryId?: string;
    merchantId?: string | undefined;
    bankName?: string | undefined;
    terminalType?: string | undefined;
    terminalId?: string | undefined;
    location?: string | undefined;
    requested_Quantity?: number;
    dispatch_Quantity?: number;
    requested_Date?: string | undefined;
    dispatch_Date?: string | undefined;
    verification?: string | undefined;
    status?: boolean;
    cancelRemarks?: string | undefined;
    spareRequestStatus?: SpareRequestStatus;

    constructor(data?: IGetAllSpareRequestQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bankId = _data["bankId"];
            this.accessoryId = _data["accessoryId"];
            this.merchantId = _data["merchantId"];
            this.bankName = _data["bankName"];
            this.terminalType = _data["terminalType"];
            this.terminalId = _data["terminalId"];
            this.location = _data["location"];
            this.requested_Quantity = _data["requested_Quantity"];
            this.dispatch_Quantity = _data["dispatch_Quantity"];
            this.requested_Date = _data["requested_Date"];
            this.dispatch_Date = _data["dispatch_Date"];
            this.verification = _data["verification"];
            this.status = _data["status"];
            this.cancelRemarks = _data["cancelRemarks"];
            this.spareRequestStatus = _data["spareRequestStatus"];
        }
    }

    static fromJS(data: any): GetAllSpareRequestQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSpareRequestQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankId"] = this.bankId;
        data["accessoryId"] = this.accessoryId;
        data["merchantId"] = this.merchantId;
        data["bankName"] = this.bankName;
        data["terminalType"] = this.terminalType;
        data["terminalId"] = this.terminalId;
        data["location"] = this.location;
        data["requested_Quantity"] = this.requested_Quantity;
        data["dispatch_Quantity"] = this.dispatch_Quantity;
        data["requested_Date"] = this.requested_Date;
        data["dispatch_Date"] = this.dispatch_Date;
        data["verification"] = this.verification;
        data["status"] = this.status;
        data["cancelRemarks"] = this.cancelRemarks;
        data["spareRequestStatus"] = this.spareRequestStatus;
        return data;
    }
}

export interface IGetAllSpareRequestQuery {
    id?: string;
    bankId?: string;
    accessoryId?: string;
    merchantId?: string | undefined;
    bankName?: string | undefined;
    terminalType?: string | undefined;
    terminalId?: string | undefined;
    location?: string | undefined;
    requested_Quantity?: number;
    dispatch_Quantity?: number;
    requested_Date?: string | undefined;
    dispatch_Date?: string | undefined;
    verification?: string | undefined;
    status?: boolean;
    cancelRemarks?: string | undefined;
    spareRequestStatus?: SpareRequestStatus;
}

export class PendingSpareRequestViewModel implements IPendingSpareRequestViewModel {
    deploymentRequestId?: string | undefined;
    serialNumberId?: string;
    spareRequestId?: string;
    bankName?: string | undefined;
    bankCode?: string | undefined;
    merchant?: string | undefined;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    outlet?: string | undefined;
    address?: string | undefined;
    createdBy?: string | undefined;
    province?: string | undefined;
    merchantLocation?: string | undefined;
    merchantCategory?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    createdDate?: Date;
    verification?: string | undefined;
    district?: string | undefined;
    serialKey?: string | undefined;
    item?: string | undefined;
    requestedDate?: string | undefined;
    spareRequestStatus?: SpareRequestStatus;

    constructor(data?: IPendingSpareRequestViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.serialNumberId = _data["serialNumberId"];
            this.spareRequestId = _data["spareRequestId"];
            this.bankName = _data["bankName"];
            this.bankCode = _data["bankCode"];
            this.merchant = _data["merchant"];
            this.idMerchant = _data["idMerchant"];
            this.idTerminal = _data["idTerminal"];
            this.outlet = _data["outlet"];
            this.address = _data["address"];
            this.createdBy = _data["createdBy"];
            this.province = _data["province"];
            this.merchantLocation = _data["merchantLocation"];
            this.merchantCategory = _data["merchantCategory"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo = _data["contactNo"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.verification = _data["verification"];
            this.district = _data["district"];
            this.serialKey = _data["serialKey"];
            this.item = _data["item"];
            this.requestedDate = _data["requestedDate"];
            this.spareRequestStatus = _data["spareRequestStatus"];
        }
    }

    static fromJS(data: any): PendingSpareRequestViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PendingSpareRequestViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["serialNumberId"] = this.serialNumberId;
        data["spareRequestId"] = this.spareRequestId;
        data["bankName"] = this.bankName;
        data["bankCode"] = this.bankCode;
        data["merchant"] = this.merchant;
        data["idMerchant"] = this.idMerchant;
        data["idTerminal"] = this.idTerminal;
        data["outlet"] = this.outlet;
        data["address"] = this.address;
        data["createdBy"] = this.createdBy;
        data["province"] = this.province;
        data["merchantLocation"] = this.merchantLocation;
        data["merchantCategory"] = this.merchantCategory;
        data["contactPerson"] = this.contactPerson;
        data["contactNo"] = this.contactNo;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["verification"] = this.verification;
        data["district"] = this.district;
        data["serialKey"] = this.serialKey;
        data["item"] = this.item;
        data["requestedDate"] = this.requestedDate;
        data["spareRequestStatus"] = this.spareRequestStatus;
        return data;
    }
}

export interface IPendingSpareRequestViewModel {
    deploymentRequestId?: string | undefined;
    serialNumberId?: string;
    spareRequestId?: string;
    bankName?: string | undefined;
    bankCode?: string | undefined;
    merchant?: string | undefined;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    outlet?: string | undefined;
    address?: string | undefined;
    createdBy?: string | undefined;
    province?: string | undefined;
    merchantLocation?: string | undefined;
    merchantCategory?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    createdDate?: Date;
    verification?: string | undefined;
    district?: string | undefined;
    serialKey?: string | undefined;
    item?: string | undefined;
    requestedDate?: string | undefined;
    spareRequestStatus?: SpareRequestStatus;
}

export class AccessoriesDispatchViewModel implements IAccessoriesDispatchViewModel {
    id?: string;
    accessoryId?: string;
    dispatchedQuantity?: number;

    constructor(data?: IAccessoriesDispatchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accessoryId = _data["accessoryId"];
            this.dispatchedQuantity = _data["dispatchedQuantity"];
        }
    }

    static fromJS(data: any): AccessoriesDispatchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccessoriesDispatchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accessoryId"] = this.accessoryId;
        data["dispatchedQuantity"] = this.dispatchedQuantity;
        return data;
    }
}

export interface IAccessoriesDispatchViewModel {
    id?: string;
    accessoryId?: string;
    dispatchedQuantity?: number;
}

export class CancelSpareRequestCommand implements ICancelSpareRequestCommand {
    id?: string;
    cancelRemarks?: string | undefined;

    constructor(data?: ICancelSpareRequestCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cancelRemarks = _data["cancelRemarks"];
        }
    }

    static fromJS(data: any): CancelSpareRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CancelSpareRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cancelRemarks"] = this.cancelRemarks;
        return data;
    }
}

export interface ICancelSpareRequestCommand {
    id?: string;
    cancelRemarks?: string | undefined;
}

export class CreateSpareSalesFromSpareRequestCommand implements ICreateSpareSalesFromSpareRequestCommand {
    id?: string;
    bankId?: string;
    bankName?: string | undefined;
    accessoryId?: string;
    requested_Quantity?: number;
    dispatchQuantity?: number;
    location?: string | undefined;
    dispatch_Date?: Date;

    constructor(data?: ICreateSpareSalesFromSpareRequestCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bankId = _data["bankId"];
            this.bankName = _data["bankName"];
            this.accessoryId = _data["accessoryId"];
            this.requested_Quantity = _data["requested_Quantity"];
            this.dispatchQuantity = _data["dispatchQuantity"];
            this.location = _data["location"];
            this.dispatch_Date = _data["dispatch_Date"] ? new Date(_data["dispatch_Date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateSpareSalesFromSpareRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSpareSalesFromSpareRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankId"] = this.bankId;
        data["bankName"] = this.bankName;
        data["accessoryId"] = this.accessoryId;
        data["requested_Quantity"] = this.requested_Quantity;
        data["dispatchQuantity"] = this.dispatchQuantity;
        data["location"] = this.location;
        data["dispatch_Date"] = this.dispatch_Date ? this.dispatch_Date.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateSpareSalesFromSpareRequestCommand {
    id?: string;
    bankId?: string;
    bankName?: string | undefined;
    accessoryId?: string;
    requested_Quantity?: number;
    dispatchQuantity?: number;
    location?: string | undefined;
    dispatch_Date?: Date;
}

export class SparesSalesViewModel implements ISparesSalesViewModel {
    id?: string;
    bankId?: string;
    bankName?: string | undefined;
    terminalType?: string | undefined;
    soldDate?: Date;
    inventoryId?: string;
    status?: string | undefined;
    remarks?: string | undefined;
    createdBy?: string | undefined;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    totalSold?: number;

    constructor(data?: ISparesSalesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bankId = _data["bankId"];
            this.bankName = _data["bankName"];
            this.terminalType = _data["terminalType"];
            this.soldDate = _data["soldDate"] ? new Date(_data["soldDate"].toString()) : <any>undefined;
            this.inventoryId = _data["inventoryId"];
            this.status = _data["status"];
            this.remarks = _data["remarks"];
            this.createdBy = _data["createdBy"];
            this.primaryItem = _data["primaryItem"];
            this.secondaryItem = _data["secondaryItem"];
            this.tertiaryItem = _data["tertiaryItem"];
            this.detailItem = _data["detailItem"];
            this.totalSold = _data["totalSold"];
        }
    }

    static fromJS(data: any): SparesSalesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SparesSalesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankId"] = this.bankId;
        data["bankName"] = this.bankName;
        data["terminalType"] = this.terminalType;
        data["soldDate"] = this.soldDate ? this.soldDate.toISOString() : <any>undefined;
        data["inventoryId"] = this.inventoryId;
        data["status"] = this.status;
        data["remarks"] = this.remarks;
        data["createdBy"] = this.createdBy;
        data["primaryItem"] = this.primaryItem;
        data["secondaryItem"] = this.secondaryItem;
        data["tertiaryItem"] = this.tertiaryItem;
        data["detailItem"] = this.detailItem;
        data["totalSold"] = this.totalSold;
        return data;
    }
}

export interface ISparesSalesViewModel {
    id?: string;
    bankId?: string;
    bankName?: string | undefined;
    terminalType?: string | undefined;
    soldDate?: Date;
    inventoryId?: string;
    status?: string | undefined;
    remarks?: string | undefined;
    createdBy?: string | undefined;
    primaryItem?: string | undefined;
    secondaryItem?: string | undefined;
    tertiaryItem?: string | undefined;
    detailItem?: string | undefined;
    totalSold?: number;
}

export class GetSparesHistoryQuery implements IGetSparesHistoryQuery {
    terminalType?: string | undefined;
    bankName?: string | undefined;
    totalNumber?: number;
    deliveredBy?: string | undefined;
    deliveredDate?: string | undefined;

    constructor(data?: IGetSparesHistoryQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.terminalType = _data["terminalType"];
            this.bankName = _data["bankName"];
            this.totalNumber = _data["totalNumber"];
            this.deliveredBy = _data["deliveredBy"];
            this.deliveredDate = _data["deliveredDate"];
        }
    }

    static fromJS(data: any): GetSparesHistoryQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetSparesHistoryQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["terminalType"] = this.terminalType;
        data["bankName"] = this.bankName;
        data["totalNumber"] = this.totalNumber;
        data["deliveredBy"] = this.deliveredBy;
        data["deliveredDate"] = this.deliveredDate;
        return data;
    }
}

export interface IGetSparesHistoryQuery {
    terminalType?: string | undefined;
    bankName?: string | undefined;
    totalNumber?: number;
    deliveredBy?: string | undefined;
    deliveredDate?: string | undefined;
}

export class CreateSpareSalesCommand implements ICreateSpareSalesCommand {
    bankId?: string;
    totalSold?: number;
    status?: string | undefined;
    remarks?: string | undefined;
    soldDate?: Date;

    constructor(data?: ICreateSpareSalesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankId = _data["bankId"];
            this.totalSold = _data["totalSold"];
            this.status = _data["status"];
            this.remarks = _data["remarks"];
            this.soldDate = _data["soldDate"] ? new Date(_data["soldDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateSpareSalesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSpareSalesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankId"] = this.bankId;
        data["totalSold"] = this.totalSold;
        data["status"] = this.status;
        data["remarks"] = this.remarks;
        data["soldDate"] = this.soldDate ? this.soldDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateSpareSalesCommand {
    bankId?: string;
    totalSold?: number;
    status?: string | undefined;
    remarks?: string | undefined;
    soldDate?: Date;
}

export class StatusViewModel implements IStatusViewModel {
    id?: string;
    statusName?: string | undefined;

    constructor(data?: IStatusViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.statusName = _data["statusName"];
        }
    }

    static fromJS(data: any): StatusViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new StatusViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statusName"] = this.statusName;
        return data;
    }
}

export interface IStatusViewModel {
    id?: string;
    statusName?: string | undefined;
}

export class GetAllPendingSupportVm implements IGetAllPendingSupportVm {
    id?: string;
    deploymentRequestId?: string;
    phone?: boolean;
    field?: boolean;
    status?: boolean;
    priority?: boolean;
    issue?: string | undefined;
    contactPerson?: string | undefined;
    createdBy?: string | undefined;
    contactNo?: string | undefined;
    resolvedBy?: string | undefined;
    remarks?: string | undefined;
    resolvedRemarks?: string | undefined;
    verification?: string | undefined;
    verifiedBy?: string | undefined;
    verifiedDate?: Date;
    bankName?: string | undefined;
    merchant?: string | undefined;
    merchantLocation?: string | undefined;
    idMerchant?: string | undefined;
    outlet?: string | undefined;
    idTerminal?: string | undefined;
    address?: string | undefined;
    province?: string | undefined;
    merchantCategory?: string | undefined;
    serialKey?: string | undefined;
    item?: string | undefined;
    applicationVersionId?: string;
    applicationFormat?: string | undefined;
    receivedContactNo?: string | undefined;
    supportDate?: Date;
    createdDate?: Date;
    district?: string | undefined;
    serialNumberId?: string;
    ticketNumber?: string | undefined;
    supportStatus?: SupportStatus;
    pendingSupport?: SupportPendingReason | undefined;
    accesoriesRequestCount?: number;

    constructor(data?: IGetAllPendingSupportVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.phone = _data["phone"];
            this.field = _data["field"];
            this.status = _data["status"];
            this.priority = _data["priority"];
            this.issue = _data["issue"];
            this.contactPerson = _data["contactPerson"];
            this.createdBy = _data["createdBy"];
            this.contactNo = _data["contactNo"];
            this.resolvedBy = _data["resolvedBy"];
            this.remarks = _data["remarks"];
            this.resolvedRemarks = _data["resolvedRemarks"];
            this.verification = _data["verification"];
            this.verifiedBy = _data["verifiedBy"];
            this.verifiedDate = _data["verifiedDate"] ? new Date(_data["verifiedDate"].toString()) : <any>undefined;
            this.bankName = _data["bankName"];
            this.merchant = _data["merchant"];
            this.merchantLocation = _data["merchantLocation"];
            this.idMerchant = _data["idMerchant"];
            this.outlet = _data["outlet"];
            this.idTerminal = _data["idTerminal"];
            this.address = _data["address"];
            this.province = _data["province"];
            this.merchantCategory = _data["merchantCategory"];
            this.serialKey = _data["serialKey"];
            this.item = _data["item"];
            this.applicationVersionId = _data["applicationVersionId"];
            this.applicationFormat = _data["applicationFormat"];
            this.receivedContactNo = _data["receivedContactNo"];
            this.supportDate = _data["supportDate"] ? new Date(_data["supportDate"].toString()) : <any>undefined;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.district = _data["district"];
            this.serialNumberId = _data["serialNumberId"];
            this.ticketNumber = _data["ticketNumber"];
            this.supportStatus = _data["supportStatus"];
            this.pendingSupport = _data["pendingSupport"];
            this.accesoriesRequestCount = _data["accesoriesRequestCount"];
        }
    }

    static fromJS(data: any): GetAllPendingSupportVm {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllPendingSupportVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["phone"] = this.phone;
        data["field"] = this.field;
        data["status"] = this.status;
        data["priority"] = this.priority;
        data["issue"] = this.issue;
        data["contactPerson"] = this.contactPerson;
        data["createdBy"] = this.createdBy;
        data["contactNo"] = this.contactNo;
        data["resolvedBy"] = this.resolvedBy;
        data["remarks"] = this.remarks;
        data["resolvedRemarks"] = this.resolvedRemarks;
        data["verification"] = this.verification;
        data["verifiedBy"] = this.verifiedBy;
        data["verifiedDate"] = this.verifiedDate ? this.verifiedDate.toISOString() : <any>undefined;
        data["bankName"] = this.bankName;
        data["merchant"] = this.merchant;
        data["merchantLocation"] = this.merchantLocation;
        data["idMerchant"] = this.idMerchant;
        data["outlet"] = this.outlet;
        data["idTerminal"] = this.idTerminal;
        data["address"] = this.address;
        data["province"] = this.province;
        data["merchantCategory"] = this.merchantCategory;
        data["serialKey"] = this.serialKey;
        data["item"] = this.item;
        data["applicationVersionId"] = this.applicationVersionId;
        data["applicationFormat"] = this.applicationFormat;
        data["receivedContactNo"] = this.receivedContactNo;
        data["supportDate"] = this.supportDate ? this.supportDate.toISOString() : <any>undefined;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["district"] = this.district;
        data["serialNumberId"] = this.serialNumberId;
        data["ticketNumber"] = this.ticketNumber;
        data["supportStatus"] = this.supportStatus;
        data["pendingSupport"] = this.pendingSupport;
        data["accesoriesRequestCount"] = this.accesoriesRequestCount;
        return data;
    }
}

export interface IGetAllPendingSupportVm {
    id?: string;
    deploymentRequestId?: string;
    phone?: boolean;
    field?: boolean;
    status?: boolean;
    priority?: boolean;
    issue?: string | undefined;
    contactPerson?: string | undefined;
    createdBy?: string | undefined;
    contactNo?: string | undefined;
    resolvedBy?: string | undefined;
    remarks?: string | undefined;
    resolvedRemarks?: string | undefined;
    verification?: string | undefined;
    verifiedBy?: string | undefined;
    verifiedDate?: Date;
    bankName?: string | undefined;
    merchant?: string | undefined;
    merchantLocation?: string | undefined;
    idMerchant?: string | undefined;
    outlet?: string | undefined;
    idTerminal?: string | undefined;
    address?: string | undefined;
    province?: string | undefined;
    merchantCategory?: string | undefined;
    serialKey?: string | undefined;
    item?: string | undefined;
    applicationVersionId?: string;
    applicationFormat?: string | undefined;
    receivedContactNo?: string | undefined;
    supportDate?: Date;
    createdDate?: Date;
    district?: string | undefined;
    serialNumberId?: string;
    ticketNumber?: string | undefined;
    supportStatus?: SupportStatus;
    pendingSupport?: SupportPendingReason | undefined;
    accesoriesRequestCount?: number;
}

export class SupportRequestDetailsFormData implements ISupportRequestDetailsFormData {
    id?: string;
    bankId?: string;
    applicationVersionId?: string;
    bankName?: string | undefined;
    merchantName?: string | undefined;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    contactPerson?: string | undefined;
    merchantCategory?: string | undefined;
    district?: string | undefined;
    address?: string | undefined;
    contactNo1?: string | undefined;
    item?: string | undefined;
    receivedBy?: string | undefined;
    serialKey?: string | undefined;
    terminalType?: string | undefined;
    receivedContactNo?: string | undefined;
    connectivity?: string | undefined;
    merchantLocation?: string | undefined;
    contactOfPos?: string | undefined;
    manualTransaction?: boolean;

    constructor(data?: ISupportRequestDetailsFormData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bankId = _data["bankId"];
            this.applicationVersionId = _data["applicationVersionId"];
            this.bankName = _data["bankName"];
            this.merchantName = _data["merchantName"];
            this.idMerchant = _data["idMerchant"];
            this.idTerminal = _data["idTerminal"];
            this.contactPerson = _data["contactPerson"];
            this.merchantCategory = _data["merchantCategory"];
            this.district = _data["district"];
            this.address = _data["address"];
            this.contactNo1 = _data["contactNo1"];
            this.item = _data["item"];
            this.receivedBy = _data["receivedBy"];
            this.serialKey = _data["serialKey"];
            this.terminalType = _data["terminalType"];
            this.receivedContactNo = _data["receivedContactNo"];
            this.connectivity = _data["connectivity"];
            this.merchantLocation = _data["merchantLocation"];
            this.contactOfPos = _data["contactOfPos"];
            this.manualTransaction = _data["manualTransaction"];
        }
    }

    static fromJS(data: any): SupportRequestDetailsFormData {
        data = typeof data === 'object' ? data : {};
        let result = new SupportRequestDetailsFormData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankId"] = this.bankId;
        data["applicationVersionId"] = this.applicationVersionId;
        data["bankName"] = this.bankName;
        data["merchantName"] = this.merchantName;
        data["idMerchant"] = this.idMerchant;
        data["idTerminal"] = this.idTerminal;
        data["contactPerson"] = this.contactPerson;
        data["merchantCategory"] = this.merchantCategory;
        data["district"] = this.district;
        data["address"] = this.address;
        data["contactNo1"] = this.contactNo1;
        data["item"] = this.item;
        data["receivedBy"] = this.receivedBy;
        data["serialKey"] = this.serialKey;
        data["terminalType"] = this.terminalType;
        data["receivedContactNo"] = this.receivedContactNo;
        data["connectivity"] = this.connectivity;
        data["merchantLocation"] = this.merchantLocation;
        data["contactOfPos"] = this.contactOfPos;
        data["manualTransaction"] = this.manualTransaction;
        return data;
    }
}

export interface ISupportRequestDetailsFormData {
    id?: string;
    bankId?: string;
    applicationVersionId?: string;
    bankName?: string | undefined;
    merchantName?: string | undefined;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    contactPerson?: string | undefined;
    merchantCategory?: string | undefined;
    district?: string | undefined;
    address?: string | undefined;
    contactNo1?: string | undefined;
    item?: string | undefined;
    receivedBy?: string | undefined;
    serialKey?: string | undefined;
    terminalType?: string | undefined;
    receivedContactNo?: string | undefined;
    connectivity?: string | undefined;
    merchantLocation?: string | undefined;
    contactOfPos?: string | undefined;
    manualTransaction?: boolean;
}

export class UpdateSupportCommand implements IUpdateSupportCommand {
    id?: string;
    phone?: boolean;
    field?: boolean;
    priority?: boolean;
    issue?: string | undefined;
    pendingReason?: SupportPendingReason;
    contactPerson?: string | undefined;
    createdBy?: string | undefined;
    contactNo?: string | undefined;
    resolvedRemarks?: string | undefined;
    ticketNumber?: string | undefined;
    supportStatus?: SupportStatus;
    pendingSupport?: SupportPendingReason | undefined;
    description?: string | undefined;

    constructor(data?: IUpdateSupportCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.phone = _data["phone"];
            this.field = _data["field"];
            this.priority = _data["priority"];
            this.issue = _data["issue"];
            this.pendingReason = _data["pendingReason"];
            this.contactPerson = _data["contactPerson"];
            this.createdBy = _data["createdBy"];
            this.contactNo = _data["contactNo"];
            this.resolvedRemarks = _data["resolvedRemarks"];
            this.ticketNumber = _data["ticketNumber"];
            this.supportStatus = _data["supportStatus"];
            this.pendingSupport = _data["pendingSupport"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdateSupportCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSupportCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["phone"] = this.phone;
        data["field"] = this.field;
        data["priority"] = this.priority;
        data["issue"] = this.issue;
        data["pendingReason"] = this.pendingReason;
        data["contactPerson"] = this.contactPerson;
        data["createdBy"] = this.createdBy;
        data["contactNo"] = this.contactNo;
        data["resolvedRemarks"] = this.resolvedRemarks;
        data["ticketNumber"] = this.ticketNumber;
        data["supportStatus"] = this.supportStatus;
        data["pendingSupport"] = this.pendingSupport;
        data["description"] = this.description;
        return data;
    }
}

export interface IUpdateSupportCommand {
    id?: string;
    phone?: boolean;
    field?: boolean;
    priority?: boolean;
    issue?: string | undefined;
    pendingReason?: SupportPendingReason;
    contactPerson?: string | undefined;
    createdBy?: string | undefined;
    contactNo?: string | undefined;
    resolvedRemarks?: string | undefined;
    ticketNumber?: string | undefined;
    supportStatus?: SupportStatus;
    pendingSupport?: SupportPendingReason | undefined;
    description?: string | undefined;
}

export class PaginatedListOfMerchantSupportsVm implements IPaginatedListOfMerchantSupportsVm {
    items?: MerchantSupportsVm[] | undefined;
    pageSize?: number;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfMerchantSupportsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MerchantSupportsVm.fromJS(item));
            }
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfMerchantSupportsVm {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfMerchantSupportsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfMerchantSupportsVm {
    items?: MerchantSupportsVm[] | undefined;
    pageSize?: number;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class MerchantSupportsVm implements IMerchantSupportsVm {
    deploymentRequestId?: string;
    supportId?: string;
    deploymentId?: string;
    ticketNumber?: string | undefined;
    merchant?: string | undefined;
    terminalOwner?: string | undefined;
    requestedDate?: Date;
    latitude?: string | undefined;
    longitude?: string | undefined;
    terminalId?: string | undefined;
    serialNumber?: string | undefined;
    address?: string | undefined;
    issue?: string | undefined;
    contactNo?: string | undefined;
    contactPerson?: string | undefined;
    pendingReason?: string | undefined;

    constructor(data?: IMerchantSupportsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.supportId = _data["supportId"];
            this.deploymentId = _data["deploymentId"];
            this.ticketNumber = _data["ticketNumber"];
            this.merchant = _data["merchant"];
            this.terminalOwner = _data["terminalOwner"];
            this.requestedDate = _data["requestedDate"] ? new Date(_data["requestedDate"].toString()) : <any>undefined;
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.terminalId = _data["terminalId"];
            this.serialNumber = _data["serialNumber"];
            this.address = _data["address"];
            this.issue = _data["issue"];
            this.contactNo = _data["contactNo"];
            this.contactPerson = _data["contactPerson"];
            this.pendingReason = _data["pendingReason"];
        }
    }

    static fromJS(data: any): MerchantSupportsVm {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantSupportsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["supportId"] = this.supportId;
        data["deploymentId"] = this.deploymentId;
        data["ticketNumber"] = this.ticketNumber;
        data["merchant"] = this.merchant;
        data["terminalOwner"] = this.terminalOwner;
        data["requestedDate"] = this.requestedDate ? this.requestedDate.toISOString() : <any>undefined;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["terminalId"] = this.terminalId;
        data["serialNumber"] = this.serialNumber;
        data["address"] = this.address;
        data["issue"] = this.issue;
        data["contactNo"] = this.contactNo;
        data["contactPerson"] = this.contactPerson;
        data["pendingReason"] = this.pendingReason;
        return data;
    }
}

export interface IMerchantSupportsVm {
    deploymentRequestId?: string;
    supportId?: string;
    deploymentId?: string;
    ticketNumber?: string | undefined;
    merchant?: string | undefined;
    terminalOwner?: string | undefined;
    requestedDate?: Date;
    latitude?: string | undefined;
    longitude?: string | undefined;
    terminalId?: string | undefined;
    serialNumber?: string | undefined;
    address?: string | undefined;
    issue?: string | undefined;
    contactNo?: string | undefined;
    contactPerson?: string | undefined;
    pendingReason?: string | undefined;
}

export class MerchantDetailsVm implements IMerchantDetailsVm {
    bankName?: string | undefined;
    merchant?: string | undefined;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    terminalType?: string | undefined;
    serialNumber?: string | undefined;
    address?: string | undefined;
    terminalOwner?: string | undefined;
    connection?: string | undefined;
    applicationDate?: Date | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    ticketNumber?: string | undefined;
    supportId?: string;
    deploymentRequestId?: string;
    deploymentId?: string;
    phone?: boolean;
    field?: boolean;
    remarks?: string | undefined;
    issue?: string | undefined;

    constructor(data?: IMerchantDetailsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankName = _data["bankName"];
            this.merchant = _data["merchant"];
            this.idMerchant = _data["idMerchant"];
            this.idTerminal = _data["idTerminal"];
            this.terminalType = _data["terminalType"];
            this.serialNumber = _data["serialNumber"];
            this.address = _data["address"];
            this.terminalOwner = _data["terminalOwner"];
            this.connection = _data["connection"];
            this.applicationDate = _data["applicationDate"] ? new Date(_data["applicationDate"].toString()) : <any>undefined;
            this.contactPerson = _data["contactPerson"];
            this.contactNo = _data["contactNo"];
            this.ticketNumber = _data["ticketNumber"];
            this.supportId = _data["supportId"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.deploymentId = _data["deploymentId"];
            this.phone = _data["phone"];
            this.field = _data["field"];
            this.remarks = _data["remarks"];
            this.issue = _data["issue"];
        }
    }

    static fromJS(data: any): MerchantDetailsVm {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantDetailsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankName"] = this.bankName;
        data["merchant"] = this.merchant;
        data["idMerchant"] = this.idMerchant;
        data["idTerminal"] = this.idTerminal;
        data["terminalType"] = this.terminalType;
        data["serialNumber"] = this.serialNumber;
        data["address"] = this.address;
        data["terminalOwner"] = this.terminalOwner;
        data["connection"] = this.connection;
        data["applicationDate"] = this.applicationDate ? this.applicationDate.toISOString() : <any>undefined;
        data["contactPerson"] = this.contactPerson;
        data["contactNo"] = this.contactNo;
        data["ticketNumber"] = this.ticketNumber;
        data["supportId"] = this.supportId;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["deploymentId"] = this.deploymentId;
        data["phone"] = this.phone;
        data["field"] = this.field;
        data["remarks"] = this.remarks;
        data["issue"] = this.issue;
        return data;
    }
}

export interface IMerchantDetailsVm {
    bankName?: string | undefined;
    merchant?: string | undefined;
    idMerchant?: string | undefined;
    idTerminal?: string | undefined;
    terminalType?: string | undefined;
    serialNumber?: string | undefined;
    address?: string | undefined;
    terminalOwner?: string | undefined;
    connection?: string | undefined;
    applicationDate?: Date | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    ticketNumber?: string | undefined;
    supportId?: string;
    deploymentRequestId?: string;
    deploymentId?: string;
    phone?: boolean;
    field?: boolean;
    remarks?: string | undefined;
    issue?: string | undefined;
}

export class SupportResolvedVm implements ISupportResolvedVm {
    medium?: SupportMedium | undefined;
    issueType?: SupportIssue;
    remarks?: string | undefined;

    constructor(data?: ISupportResolvedVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medium = _data["medium"];
            this.issueType = _data["issueType"];
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): SupportResolvedVm {
        data = typeof data === 'object' ? data : {};
        let result = new SupportResolvedVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medium"] = this.medium;
        data["issueType"] = this.issueType;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface ISupportResolvedVm {
    medium?: SupportMedium | undefined;
    issueType?: SupportIssue;
    remarks?: string | undefined;
}

export enum SupportMedium {
    Phone = "Phone",
    Field = "Field",
}

export enum SupportIssue {
    AccountRelated = 1,
    AlertIrruption = 2,
    BatteryProblem = 3,
    CableDamaged = 4,
    CallHelp06 = 5,
    ChargerIssue = 6,
    ChipReaderDamaged = 7,
    CommunicationChannelIssue = 8,
    DelReversal = 9,
    DisplayIssueBlinking = 10,
    DoubleTxn = 11,
    EthernetportDamaged = 12,
    GprsError = 13,
    InvalidMsg = 14,
    IpAddress = 15,
    KeypadIssue = 16,
    LogonFailure = 17,
    Manualtxn = 18,
    NetworkIssue = 19,
    NewSetUp = 20,
    NoSim = 21,
    PendingSettlement = 22,
    RemoveCard = 23,
    Roll = 24,
    RollAndSupport = 25,
    RollerPrinterIssue = 26,
    Security63 = 27,
    Simlocked = 28,
    SimRelatedIssue = 29,
    SimSlotDamaged = 30,
    SimStocked = 31,
    SockerError = 32,
    Sticket = 33,
    Support = 34,
    SystemError = 35,
    SystemMalfunction = 36,
    Timeout = 37,
    TotalMismatch = 38,
    TransactionDeclined = 39,
    Unauthorized = 40,
    UnknownError = 41,
    VoildIssue = 42,
    WifiSetup = 43,
    Accessories = 44,
    Hardwareissue = 45,
    OperationAssistance = 46,
    PowerIssue = 47,
    SettlementIssue = 48,
    TechnicalIssue = 49,
    MerchantActivation = 50,
    InactiveMerchant = 51,
    DeploymentVerification = 52,
}

export class LocationVm implements ILocationVm {
    latitude?: string | undefined;
    longitude?: string | undefined;
    address?: string | undefined;

    constructor(data?: ILocationVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): LocationVm {
        data = typeof data === 'object' ? data : {};
        let result = new LocationVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["address"] = this.address;
        return data;
    }
}

export interface ILocationVm {
    latitude?: string | undefined;
    longitude?: string | undefined;
    address?: string | undefined;
}

export class DeploymentPendingVm implements IDeploymentPendingVm {
    latitude?: string | undefined;
    longitude?: string | undefined;
    merchantLocation?: string | undefined;

    constructor(data?: IDeploymentPendingVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.merchantLocation = _data["merchantLocation"];
        }
    }

    static fromJS(data: any): DeploymentPendingVm {
        data = typeof data === 'object' ? data : {};
        let result = new DeploymentPendingVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["merchantLocation"] = this.merchantLocation;
        return data;
    }
}

export interface IDeploymentPendingVm {
    latitude?: string | undefined;
    longitude?: string | undefined;
    merchantLocation?: string | undefined;
}

export class UpdateMerchantVm implements IUpdateMerchantVm {
    merchant?: string | undefined;
    connection?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    deploymentRequestId?: string;
    merchantLocation?: string | undefined;

    constructor(data?: IUpdateMerchantVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.merchant = _data["merchant"];
            this.connection = _data["connection"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo = _data["contactNo"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.merchantLocation = _data["merchantLocation"];
        }
    }

    static fromJS(data: any): UpdateMerchantVm {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMerchantVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["merchant"] = this.merchant;
        data["connection"] = this.connection;
        data["contactPerson"] = this.contactPerson;
        data["contactNo"] = this.contactNo;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["merchantLocation"] = this.merchantLocation;
        return data;
    }
}

export interface IUpdateMerchantVm {
    merchant?: string | undefined;
    connection?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    deploymentRequestId?: string;
    merchantLocation?: string | undefined;
}

export class TerminalVm implements ITerminalVm {
    deploymentId?: string;
    merchant?: string | undefined;
    longitude?: string | undefined;
    latitude?: string | undefined;
    terminalId?: string | undefined;
    address?: string | undefined;
    bankName?: string | undefined;
    terminalOwner?: string | undefined;
    serialNumber?: string | undefined;
    merchantId?: string | undefined;

    constructor(data?: ITerminalVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deploymentId = _data["deploymentId"];
            this.merchant = _data["merchant"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.terminalId = _data["terminalId"];
            this.address = _data["address"];
            this.bankName = _data["bankName"];
            this.terminalOwner = _data["terminalOwner"];
            this.serialNumber = _data["serialNumber"];
            this.merchantId = _data["merchantId"];
        }
    }

    static fromJS(data: any): TerminalVm {
        data = typeof data === 'object' ? data : {};
        let result = new TerminalVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deploymentId"] = this.deploymentId;
        data["merchant"] = this.merchant;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["terminalId"] = this.terminalId;
        data["address"] = this.address;
        data["bankName"] = this.bankName;
        data["terminalOwner"] = this.terminalOwner;
        data["serialNumber"] = this.serialNumber;
        data["merchantId"] = this.merchantId;
        return data;
    }
}

export interface ITerminalVm {
    deploymentId?: string;
    merchant?: string | undefined;
    longitude?: string | undefined;
    latitude?: string | undefined;
    terminalId?: string | undefined;
    address?: string | undefined;
    bankName?: string | undefined;
    terminalOwner?: string | undefined;
    serialNumber?: string | undefined;
    merchantId?: string | undefined;
}

export class SupportPendingVm implements ISupportPendingVm {
    remarks?: string | undefined;
    pendingSupport?: SupportPendingReason | undefined;

    constructor(data?: ISupportPendingVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.remarks = _data["remarks"];
            this.pendingSupport = _data["pendingSupport"];
        }
    }

    static fromJS(data: any): SupportPendingVm {
        data = typeof data === 'object' ? data : {};
        let result = new SupportPendingVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["remarks"] = this.remarks;
        data["pendingSupport"] = this.pendingSupport;
        return data;
    }
}

export interface ISupportPendingVm {
    remarks?: string | undefined;
    pendingSupport?: SupportPendingReason | undefined;
}

export class SupportCloseCommand implements ISupportCloseCommand {
    pendingSupport?: SupportPendingReason | undefined;
    updatedBy?: string | undefined;

    constructor(data?: ISupportCloseCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pendingSupport = _data["pendingSupport"];
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): SupportCloseCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SupportCloseCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pendingSupport"] = this.pendingSupport;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ISupportCloseCommand {
    pendingSupport?: SupportPendingReason | undefined;
    updatedBy?: string | undefined;
}

export class ISupportPendingDeploymentViewModel implements IISupportPendingDeploymentViewModel {
    bankName?: string | undefined;
    deploymentRequestId?: string;
    merchantName?: string | undefined;
    address?: string | undefined;
    district?: string | undefined;
    terminalId?: string | undefined;
    merchantId?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    terminalType?: string | undefined;
    currency?: string | undefined;
    requestName?: string | undefined;

    constructor(data?: IISupportPendingDeploymentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankName = _data["bankName"];
            this.deploymentRequestId = _data["deploymentRequestId"];
            this.merchantName = _data["merchantName"];
            this.address = _data["address"];
            this.district = _data["district"];
            this.terminalId = _data["terminalId"];
            this.merchantId = _data["merchantId"];
            this.contactPerson = _data["contactPerson"];
            this.contactNo = _data["contactNo"];
            this.terminalType = _data["terminalType"];
            this.currency = _data["currency"];
            this.requestName = _data["requestName"];
        }
    }

    static fromJS(data: any): ISupportPendingDeploymentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ISupportPendingDeploymentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankName"] = this.bankName;
        data["deploymentRequestId"] = this.deploymentRequestId;
        data["merchantName"] = this.merchantName;
        data["address"] = this.address;
        data["district"] = this.district;
        data["terminalId"] = this.terminalId;
        data["merchantId"] = this.merchantId;
        data["contactPerson"] = this.contactPerson;
        data["contactNo"] = this.contactNo;
        data["terminalType"] = this.terminalType;
        data["currency"] = this.currency;
        data["requestName"] = this.requestName;
        return data;
    }
}

export interface IISupportPendingDeploymentViewModel {
    bankName?: string | undefined;
    deploymentRequestId?: string;
    merchantName?: string | undefined;
    address?: string | undefined;
    district?: string | undefined;
    terminalId?: string | undefined;
    merchantId?: string | undefined;
    contactPerson?: string | undefined;
    contactNo?: string | undefined;
    terminalType?: string | undefined;
    currency?: string | undefined;
    requestName?: string | undefined;
}

export class CreateISupportDeploymentCommand implements ICreateISupportDeploymentCommand {
    connectivity?: Connectivity[] | undefined;
    deployedAt?: DeployedAtLocation;
    deployDate?: Date;
    location?: string | undefined;
    noOfStickers?: string | undefined;
    noOfRoles?: string | undefined;
    deployedBy?: string | undefined;
    receiverContactNo?: string | undefined;
    receivedBy?: string | undefined;
    remarks?: string | undefined;
    longitude?: string | undefined;
    lattitude?: string | undefined;

    constructor(data?: ICreateISupportDeploymentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["connectivity"])) {
                this.connectivity = [] as any;
                for (let item of _data["connectivity"])
                    this.connectivity!.push(item);
            }
            this.deployedAt = _data["deployedAt"];
            this.deployDate = _data["deployDate"] ? new Date(_data["deployDate"].toString()) : <any>undefined;
            this.location = _data["location"];
            this.noOfStickers = _data["noOfStickers"];
            this.noOfRoles = _data["noOfRoles"];
            this.deployedBy = _data["deployedBy"];
            this.receiverContactNo = _data["receiverContactNo"];
            this.receivedBy = _data["receivedBy"];
            this.remarks = _data["remarks"];
            this.longitude = _data["longitude"];
            this.lattitude = _data["lattitude"];
        }
    }

    static fromJS(data: any): CreateISupportDeploymentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateISupportDeploymentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.connectivity)) {
            data["connectivity"] = [];
            for (let item of this.connectivity)
                data["connectivity"].push(item);
        }
        data["deployedAt"] = this.deployedAt;
        data["deployDate"] = this.deployDate ? this.deployDate.toISOString() : <any>undefined;
        data["location"] = this.location;
        data["noOfStickers"] = this.noOfStickers;
        data["noOfRoles"] = this.noOfRoles;
        data["deployedBy"] = this.deployedBy;
        data["receiverContactNo"] = this.receiverContactNo;
        data["receivedBy"] = this.receivedBy;
        data["remarks"] = this.remarks;
        data["longitude"] = this.longitude;
        data["lattitude"] = this.lattitude;
        return data;
    }
}

export interface ICreateISupportDeploymentCommand {
    connectivity?: Connectivity[] | undefined;
    deployedAt?: DeployedAtLocation;
    deployDate?: Date;
    location?: string | undefined;
    noOfStickers?: string | undefined;
    noOfRoles?: string | undefined;
    deployedBy?: string | undefined;
    receiverContactNo?: string | undefined;
    receivedBy?: string | undefined;
    remarks?: string | undefined;
    longitude?: string | undefined;
    lattitude?: string | undefined;
}

export class ApiResponseOfPagedResponsesOfSupportForMerchantVM implements IApiResponseOfPagedResponsesOfSupportForMerchantVM {
    success?: boolean;
    status?: string | undefined;
    message?: string | undefined;
    data?: PagedResponsesOfSupportForMerchantVM | undefined;

    constructor(data?: IApiResponseOfPagedResponsesOfSupportForMerchantVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? PagedResponsesOfSupportForMerchantVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ApiResponseOfPagedResponsesOfSupportForMerchantVM {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfPagedResponsesOfSupportForMerchantVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IApiResponseOfPagedResponsesOfSupportForMerchantVM {
    success?: boolean;
    status?: string | undefined;
    message?: string | undefined;
    data?: PagedResponsesOfSupportForMerchantVM | undefined;
}

export class PagedDataOfSupportForMerchantVM implements IPagedDataOfSupportForMerchantVM {
    content?: SupportForMerchantVM[] | undefined;
    page?: PageInfo | undefined;

    constructor(data?: IPagedDataOfSupportForMerchantVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["content"])) {
                this.content = [] as any;
                for (let item of _data["content"])
                    this.content!.push(SupportForMerchantVM.fromJS(item));
            }
            this.page = _data["page"] ? PageInfo.fromJS(_data["page"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PagedDataOfSupportForMerchantVM {
        data = typeof data === 'object' ? data : {};
        let result = new PagedDataOfSupportForMerchantVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.content)) {
            data["content"] = [];
            for (let item of this.content)
                data["content"].push(item.toJSON());
        }
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPagedDataOfSupportForMerchantVM {
    content?: SupportForMerchantVM[] | undefined;
    page?: PageInfo | undefined;
}

export class PagedResponsesOfSupportForMerchantVM extends PagedDataOfSupportForMerchantVM implements IPagedResponsesOfSupportForMerchantVM {

    constructor(data?: IPagedResponsesOfSupportForMerchantVM) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PagedResponsesOfSupportForMerchantVM {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponsesOfSupportForMerchantVM();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPagedResponsesOfSupportForMerchantVM extends IPagedDataOfSupportForMerchantVM {
}

export class SupportForMerchantVM implements ISupportForMerchantVM {
    id?: string;
    contactName?: string | undefined;
    contactNumber?: string | undefined;
    supportMedium?: string | undefined;
    supportIssue?: string | undefined;
    terminalId?: string | undefined;
    remarks?: string | undefined;
    status?: string | undefined;
    priority?: boolean;
    issuedDate?: string | undefined;
    resolvedDate?: string | undefined;
    resolvedBy?: string | undefined;

    constructor(data?: ISupportForMerchantVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contactName = _data["contactName"];
            this.contactNumber = _data["contactNumber"];
            this.supportMedium = _data["supportMedium"];
            this.supportIssue = _data["supportIssue"];
            this.terminalId = _data["terminalId"];
            this.remarks = _data["remarks"];
            this.status = _data["status"];
            this.priority = _data["priority"];
            this.issuedDate = _data["issuedDate"];
            this.resolvedDate = _data["resolvedDate"];
            this.resolvedBy = _data["resolvedBy"];
        }
    }

    static fromJS(data: any): SupportForMerchantVM {
        data = typeof data === 'object' ? data : {};
        let result = new SupportForMerchantVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contactName"] = this.contactName;
        data["contactNumber"] = this.contactNumber;
        data["supportMedium"] = this.supportMedium;
        data["supportIssue"] = this.supportIssue;
        data["terminalId"] = this.terminalId;
        data["remarks"] = this.remarks;
        data["status"] = this.status;
        data["priority"] = this.priority;
        data["issuedDate"] = this.issuedDate;
        data["resolvedDate"] = this.resolvedDate;
        data["resolvedBy"] = this.resolvedBy;
        return data;
    }
}

export interface ISupportForMerchantVM {
    id?: string;
    contactName?: string | undefined;
    contactNumber?: string | undefined;
    supportMedium?: string | undefined;
    supportIssue?: string | undefined;
    terminalId?: string | undefined;
    remarks?: string | undefined;
    status?: string | undefined;
    priority?: boolean;
    issuedDate?: string | undefined;
    resolvedDate?: string | undefined;
    resolvedBy?: string | undefined;
}

export class PageInfo implements IPageInfo {
    size?: number;
    totalElements?: number;
    totalPages?: number;
    number?: number;

    constructor(data?: IPageInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.size = _data["size"];
            this.totalElements = _data["totalElements"];
            this.totalPages = _data["totalPages"];
            this.number = _data["number"];
        }
    }

    static fromJS(data: any): PageInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PageInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["size"] = this.size;
        data["totalElements"] = this.totalElements;
        data["totalPages"] = this.totalPages;
        data["number"] = this.number;
        return data;
    }
}

export interface IPageInfo {
    size?: number;
    totalElements?: number;
    totalPages?: number;
    number?: number;
}

export class ApiResponseOfListOfSupportIssueTypeVM implements IApiResponseOfListOfSupportIssueTypeVM {
    success?: boolean;
    status?: string | undefined;
    message?: string | undefined;
    data?: SupportIssueTypeVM[] | undefined;

    constructor(data?: IApiResponseOfListOfSupportIssueTypeVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.status = _data["status"];
            this.message = _data["message"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SupportIssueTypeVM.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApiResponseOfListOfSupportIssueTypeVM {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfListOfSupportIssueTypeVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["status"] = this.status;
        data["message"] = this.message;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IApiResponseOfListOfSupportIssueTypeVM {
    success?: boolean;
    status?: string | undefined;
    message?: string | undefined;
    data?: SupportIssueTypeVM[] | undefined;
}

export class SupportIssueTypeVM implements ISupportIssueTypeVM {
    name?: string | undefined;
    value?: number;

    constructor(data?: ISupportIssueTypeVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SupportIssueTypeVM {
        data = typeof data === 'object' ? data : {};
        let result = new SupportIssueTypeVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface ISupportIssueTypeVM {
    name?: string | undefined;
    value?: number;
}

export class ApiResponseOfListOfTerminalForMerchantVM implements IApiResponseOfListOfTerminalForMerchantVM {
    success?: boolean;
    status?: string | undefined;
    message?: string | undefined;
    data?: TerminalForMerchantVM[] | undefined;

    constructor(data?: IApiResponseOfListOfTerminalForMerchantVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.status = _data["status"];
            this.message = _data["message"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TerminalForMerchantVM.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApiResponseOfListOfTerminalForMerchantVM {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfListOfTerminalForMerchantVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["status"] = this.status;
        data["message"] = this.message;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IApiResponseOfListOfTerminalForMerchantVM {
    success?: boolean;
    status?: string | undefined;
    message?: string | undefined;
    data?: TerminalForMerchantVM[] | undefined;
}

export class TerminalForMerchantVM implements ITerminalForMerchantVM {
    id?: string;
    aTid?: string | undefined;
    iTid?: string | undefined;

    constructor(data?: ITerminalForMerchantVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.aTid = _data["aTid"];
            this.iTid = _data["iTid"];
        }
    }

    static fromJS(data: any): TerminalForMerchantVM {
        data = typeof data === 'object' ? data : {};
        let result = new TerminalForMerchantVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["aTid"] = this.aTid;
        data["iTid"] = this.iTid;
        return data;
    }
}

export interface ITerminalForMerchantVM {
    id?: string;
    aTid?: string | undefined;
    iTid?: string | undefined;
}

export class ApiResponseOfListOfAccessoryViewModel implements IApiResponseOfListOfAccessoryViewModel {
    success?: boolean;
    status?: string | undefined;
    message?: string | undefined;
    data?: AccessoryViewModel[] | undefined;

    constructor(data?: IApiResponseOfListOfAccessoryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.status = _data["status"];
            this.message = _data["message"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AccessoryViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApiResponseOfListOfAccessoryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfListOfAccessoryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["status"] = this.status;
        data["message"] = this.message;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IApiResponseOfListOfAccessoryViewModel {
    success?: boolean;
    status?: string | undefined;
    message?: string | undefined;
    data?: AccessoryViewModel[] | undefined;
}

export class CreateAccessoriesRequestCommand implements ICreateAccessoriesRequestCommand {
    imarkTerminalId?: string | undefined;
    contactNumber?: string | undefined;
    contactPerson?: string | undefined;
    accessoryId?: string | undefined;
    quantity?: number;
    remarks?: string | undefined;

    constructor(data?: ICreateAccessoriesRequestCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imarkTerminalId = _data["imarkTerminalId"];
            this.contactNumber = _data["contactNumber"];
            this.contactPerson = _data["contactPerson"];
            this.accessoryId = _data["accessoryId"];
            this.quantity = _data["quantity"];
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): CreateAccessoriesRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAccessoriesRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imarkTerminalId"] = this.imarkTerminalId;
        data["contactNumber"] = this.contactNumber;
        data["contactPerson"] = this.contactPerson;
        data["accessoryId"] = this.accessoryId;
        data["quantity"] = this.quantity;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface ICreateAccessoriesRequestCommand {
    imarkTerminalId?: string | undefined;
    contactNumber?: string | undefined;
    contactPerson?: string | undefined;
    accessoryId?: string | undefined;
    quantity?: number;
    remarks?: string | undefined;
}

export class ApiResponseOfPagedResponsesOfAccessoriesListForMerchantVM implements IApiResponseOfPagedResponsesOfAccessoriesListForMerchantVM {
    success?: boolean;
    status?: string | undefined;
    message?: string | undefined;
    data?: PagedResponsesOfAccessoriesListForMerchantVM | undefined;

    constructor(data?: IApiResponseOfPagedResponsesOfAccessoriesListForMerchantVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? PagedResponsesOfAccessoriesListForMerchantVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ApiResponseOfPagedResponsesOfAccessoriesListForMerchantVM {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfPagedResponsesOfAccessoriesListForMerchantVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IApiResponseOfPagedResponsesOfAccessoriesListForMerchantVM {
    success?: boolean;
    status?: string | undefined;
    message?: string | undefined;
    data?: PagedResponsesOfAccessoriesListForMerchantVM | undefined;
}

export class PagedDataOfAccessoriesListForMerchantVM implements IPagedDataOfAccessoriesListForMerchantVM {
    content?: AccessoriesListForMerchantVM[] | undefined;
    page?: PageInfo | undefined;

    constructor(data?: IPagedDataOfAccessoriesListForMerchantVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["content"])) {
                this.content = [] as any;
                for (let item of _data["content"])
                    this.content!.push(AccessoriesListForMerchantVM.fromJS(item));
            }
            this.page = _data["page"] ? PageInfo.fromJS(_data["page"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PagedDataOfAccessoriesListForMerchantVM {
        data = typeof data === 'object' ? data : {};
        let result = new PagedDataOfAccessoriesListForMerchantVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.content)) {
            data["content"] = [];
            for (let item of this.content)
                data["content"].push(item.toJSON());
        }
        data["page"] = this.page ? this.page.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPagedDataOfAccessoriesListForMerchantVM {
    content?: AccessoriesListForMerchantVM[] | undefined;
    page?: PageInfo | undefined;
}

export class PagedResponsesOfAccessoriesListForMerchantVM extends PagedDataOfAccessoriesListForMerchantVM implements IPagedResponsesOfAccessoriesListForMerchantVM {

    constructor(data?: IPagedResponsesOfAccessoriesListForMerchantVM) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PagedResponsesOfAccessoriesListForMerchantVM {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponsesOfAccessoriesListForMerchantVM();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPagedResponsesOfAccessoriesListForMerchantVM extends IPagedDataOfAccessoriesListForMerchantVM {
}

export class AccessoriesListForMerchantVM implements IAccessoriesListForMerchantVM {
    id?: string;
    accessoriesType?: string | undefined;
    contactName?: string | undefined;
    contactNumber?: string | undefined;
    bank?: string | undefined;
    tid?: string | undefined;
    quantity?: number;
    remarks?: string | undefined;
    status?: string | undefined;
    issuedDate?: string | undefined;
    resolvedDate?: string | undefined;
    resolvedBy?: string | undefined;
    receivedBy?: string | undefined;

    constructor(data?: IAccessoriesListForMerchantVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accessoriesType = _data["accessoriesType"];
            this.contactName = _data["contactName"];
            this.contactNumber = _data["contactNumber"];
            this.bank = _data["bank"];
            this.tid = _data["tid"];
            this.quantity = _data["quantity"];
            this.remarks = _data["remarks"];
            this.status = _data["status"];
            this.issuedDate = _data["issuedDate"];
            this.resolvedDate = _data["resolvedDate"];
            this.resolvedBy = _data["resolvedBy"];
            this.receivedBy = _data["receivedBy"];
        }
    }

    static fromJS(data: any): AccessoriesListForMerchantVM {
        data = typeof data === 'object' ? data : {};
        let result = new AccessoriesListForMerchantVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accessoriesType"] = this.accessoriesType;
        data["contactName"] = this.contactName;
        data["contactNumber"] = this.contactNumber;
        data["bank"] = this.bank;
        data["tid"] = this.tid;
        data["quantity"] = this.quantity;
        data["remarks"] = this.remarks;
        data["status"] = this.status;
        data["issuedDate"] = this.issuedDate;
        data["resolvedDate"] = this.resolvedDate;
        data["resolvedBy"] = this.resolvedBy;
        data["receivedBy"] = this.receivedBy;
        return data;
    }
}

export interface IAccessoriesListForMerchantVM {
    id?: string;
    accessoriesType?: string | undefined;
    contactName?: string | undefined;
    contactNumber?: string | undefined;
    bank?: string | undefined;
    tid?: string | undefined;
    quantity?: number;
    remarks?: string | undefined;
    status?: string | undefined;
    issuedDate?: string | undefined;
    resolvedDate?: string | undefined;
    resolvedBy?: string | undefined;
    receivedBy?: string | undefined;
}

export class ApiResponseOfAccountAndSettingForMerchantVM implements IApiResponseOfAccountAndSettingForMerchantVM {
    success?: boolean;
    status?: string | undefined;
    message?: string | undefined;
    data?: AccountAndSettingForMerchantVM | undefined;

    constructor(data?: IApiResponseOfAccountAndSettingForMerchantVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? AccountAndSettingForMerchantVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ApiResponseOfAccountAndSettingForMerchantVM {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfAccountAndSettingForMerchantVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IApiResponseOfAccountAndSettingForMerchantVM {
    success?: boolean;
    status?: string | undefined;
    message?: string | undefined;
    data?: AccountAndSettingForMerchantVM | undefined;
}

export class AccountAndSettingForMerchantVM implements IAccountAndSettingForMerchantVM {
    paymentMethods?: EnumOptionDto[] | undefined;
    notifications?: EnumOptionDto[] | undefined;
    details?: DetailsDto | undefined;
    address?: AddressDto | undefined;
    merchantIncomeDetails?: MerchantIncomeDetailsDto | undefined;
    msfPlans?: MsfPlanDto[] | undefined;

    constructor(data?: IAccountAndSettingForMerchantVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["paymentMethods"])) {
                this.paymentMethods = [] as any;
                for (let item of _data["paymentMethods"])
                    this.paymentMethods!.push(EnumOptionDto.fromJS(item));
            }
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications!.push(EnumOptionDto.fromJS(item));
            }
            this.details = _data["details"] ? DetailsDto.fromJS(_data["details"]) : <any>undefined;
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : <any>undefined;
            this.merchantIncomeDetails = _data["merchantIncomeDetails"] ? MerchantIncomeDetailsDto.fromJS(_data["merchantIncomeDetails"]) : <any>undefined;
            if (Array.isArray(_data["msfPlans"])) {
                this.msfPlans = [] as any;
                for (let item of _data["msfPlans"])
                    this.msfPlans!.push(MsfPlanDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccountAndSettingForMerchantVM {
        data = typeof data === 'object' ? data : {};
        let result = new AccountAndSettingForMerchantVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.paymentMethods)) {
            data["paymentMethods"] = [];
            for (let item of this.paymentMethods)
                data["paymentMethods"].push(item.toJSON());
        }
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        data["details"] = this.details ? this.details.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["merchantIncomeDetails"] = this.merchantIncomeDetails ? this.merchantIncomeDetails.toJSON() : <any>undefined;
        if (Array.isArray(this.msfPlans)) {
            data["msfPlans"] = [];
            for (let item of this.msfPlans)
                data["msfPlans"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAccountAndSettingForMerchantVM {
    paymentMethods?: EnumOptionDto[] | undefined;
    notifications?: EnumOptionDto[] | undefined;
    details?: DetailsDto | undefined;
    address?: AddressDto | undefined;
    merchantIncomeDetails?: MerchantIncomeDetailsDto | undefined;
    msfPlans?: MsfPlanDto[] | undefined;
}

export class EnumOptionDto implements IEnumOptionDto {
    name?: string | undefined;
    isActive?: boolean;

    constructor(data?: IEnumOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): EnumOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnumOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IEnumOptionDto {
    name?: string | undefined;
    isActive?: boolean;
}

export class DetailsDto implements IDetailsDto {
    dba?: string | undefined;
    businessName?: string | undefined;
    owner?: string | undefined;
    contactPerson?: string | undefined;
    merchantLevel?: string | undefined;
    mid?: string | undefined;
    mcc?: string | undefined;
    natureofBusiness?: string | undefined;
    registrationId?: string | undefined;
    panId?: string | undefined;
    dbnId?: string | undefined;
    oid?: string | undefined;
    merchantName?: string | undefined;
    numberOfTerminals?: number;
    legalType?: string | undefined;
    registeredDate?: string | undefined;
    activationDate?: string | undefined;
    residenceType?: string | undefined;
    businessStatus?: string | undefined;

    constructor(data?: IDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dba = _data["dba"];
            this.businessName = _data["businessName"];
            this.owner = _data["owner"];
            this.contactPerson = _data["contactPerson"];
            this.merchantLevel = _data["merchantLevel"];
            this.mid = _data["mid"];
            this.mcc = _data["mcc"];
            this.natureofBusiness = _data["natureofBusiness"];
            this.registrationId = _data["registrationId"];
            this.panId = _data["panId"];
            this.dbnId = _data["dbnId"];
            this.oid = _data["oid"];
            this.merchantName = _data["merchantName"];
            this.numberOfTerminals = _data["numberOfTerminals"];
            this.legalType = _data["legalType"];
            this.registeredDate = _data["registeredDate"];
            this.activationDate = _data["activationDate"];
            this.residenceType = _data["residenceType"];
            this.businessStatus = _data["businessStatus"];
        }
    }

    static fromJS(data: any): DetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new DetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dba"] = this.dba;
        data["businessName"] = this.businessName;
        data["owner"] = this.owner;
        data["contactPerson"] = this.contactPerson;
        data["merchantLevel"] = this.merchantLevel;
        data["mid"] = this.mid;
        data["mcc"] = this.mcc;
        data["natureofBusiness"] = this.natureofBusiness;
        data["registrationId"] = this.registrationId;
        data["panId"] = this.panId;
        data["dbnId"] = this.dbnId;
        data["oid"] = this.oid;
        data["merchantName"] = this.merchantName;
        data["numberOfTerminals"] = this.numberOfTerminals;
        data["legalType"] = this.legalType;
        data["registeredDate"] = this.registeredDate;
        data["activationDate"] = this.activationDate;
        data["residenceType"] = this.residenceType;
        data["businessStatus"] = this.businessStatus;
        return data;
    }
}

export interface IDetailsDto {
    dba?: string | undefined;
    businessName?: string | undefined;
    owner?: string | undefined;
    contactPerson?: string | undefined;
    merchantLevel?: string | undefined;
    mid?: string | undefined;
    mcc?: string | undefined;
    natureofBusiness?: string | undefined;
    registrationId?: string | undefined;
    panId?: string | undefined;
    dbnId?: string | undefined;
    oid?: string | undefined;
    merchantName?: string | undefined;
    numberOfTerminals?: number;
    legalType?: string | undefined;
    registeredDate?: string | undefined;
    activationDate?: string | undefined;
    residenceType?: string | undefined;
    businessStatus?: string | undefined;
}

export class AddressDto implements IAddressDto {
    province?: string | undefined;
    district?: string | undefined;
    municipality?: string | undefined;
    addressLine1?: string | undefined;
    ward?: SByte;
    address?: string | undefined;
    addressLine2?: string | undefined;
    email?: string | undefined;
    notificationEmail?: string | undefined;
    primaryContactNumber?: string | undefined;
    secondaryContactNumber?: string | undefined;

    constructor(data?: IAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.province = _data["province"];
            this.district = _data["district"];
            this.municipality = _data["municipality"];
            this.addressLine1 = _data["addressLine1"];
            this.ward = _data["ward"] ? SByte.fromJS(_data["ward"]) : <any>undefined;
            this.address = _data["address"];
            this.addressLine2 = _data["addressLine2"];
            this.email = _data["email"];
            this.notificationEmail = _data["notificationEmail"];
            this.primaryContactNumber = _data["primaryContactNumber"];
            this.secondaryContactNumber = _data["secondaryContactNumber"];
        }
    }

    static fromJS(data: any): AddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["province"] = this.province;
        data["district"] = this.district;
        data["municipality"] = this.municipality;
        data["addressLine1"] = this.addressLine1;
        data["ward"] = this.ward ? this.ward.toJSON() : <any>undefined;
        data["address"] = this.address;
        data["addressLine2"] = this.addressLine2;
        data["email"] = this.email;
        data["notificationEmail"] = this.notificationEmail;
        data["primaryContactNumber"] = this.primaryContactNumber;
        data["secondaryContactNumber"] = this.secondaryContactNumber;
        return data;
    }
}

export interface IAddressDto {
    province?: string | undefined;
    district?: string | undefined;
    municipality?: string | undefined;
    addressLine1?: string | undefined;
    ward?: SByte;
    address?: string | undefined;
    addressLine2?: string | undefined;
    email?: string | undefined;
    notificationEmail?: string | undefined;
    primaryContactNumber?: string | undefined;
    secondaryContactNumber?: string | undefined;
}

export class SByte implements ISByte {

    constructor(data?: ISByte) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SByte {
        data = typeof data === 'object' ? data : {};
        let result = new SByte();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ISByte {
}

export class MerchantIncomeDetailsDto implements IMerchantIncomeDetailsDto {
    settlementBank?: string | undefined;
    branch?: string | undefined;
    accountType?: string | undefined;
    accountNumber?: string | undefined;
    swiftCode?: string | undefined;
    currency?: string | undefined;
    paymentCode?: string | undefined;
    transferMode?: string | undefined;
    walledId?: string | undefined;
    walletName?: string | undefined;

    constructor(data?: IMerchantIncomeDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.settlementBank = _data["settlementBank"];
            this.branch = _data["branch"];
            this.accountType = _data["accountType"];
            this.accountNumber = _data["accountNumber"];
            this.swiftCode = _data["swiftCode"];
            this.currency = _data["currency"];
            this.paymentCode = _data["paymentCode"];
            this.transferMode = _data["transferMode"];
            this.walledId = _data["walledId"];
            this.walletName = _data["walletName"];
        }
    }

    static fromJS(data: any): MerchantIncomeDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantIncomeDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["settlementBank"] = this.settlementBank;
        data["branch"] = this.branch;
        data["accountType"] = this.accountType;
        data["accountNumber"] = this.accountNumber;
        data["swiftCode"] = this.swiftCode;
        data["currency"] = this.currency;
        data["paymentCode"] = this.paymentCode;
        data["transferMode"] = this.transferMode;
        data["walledId"] = this.walledId;
        data["walletName"] = this.walletName;
        return data;
    }
}

export interface IMerchantIncomeDetailsDto {
    settlementBank?: string | undefined;
    branch?: string | undefined;
    accountType?: string | undefined;
    accountNumber?: string | undefined;
    swiftCode?: string | undefined;
    currency?: string | undefined;
    paymentCode?: string | undefined;
    transferMode?: string | undefined;
    walledId?: string | undefined;
    walletName?: string | undefined;
}

export class MsfPlanDto implements IMsfPlanDto {
    name?: string | undefined;
    msfPlanId?: string;
    schemes?: string[] | undefined;
    fixedFee?: number | undefined;
    percentage?: number | undefined;
    msfMinAmount?: number | undefined;
    msfMaxAmount?: number | undefined;
    slabDetails?: SlabDetailsDTO[] | undefined;
    channels?: string[] | undefined;
    pricingType?: string | undefined;
    transactionOriginTypes?: string[] | undefined;
    waivedAmount?: number | undefined;
    waivedVolume?: number | undefined;
    isWaivedAmountInPercentage?: boolean;
    isWaivedVolumeInPercentage?: boolean;

    constructor(data?: IMsfPlanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.msfPlanId = _data["msfPlanId"];
            if (Array.isArray(_data["schemes"])) {
                this.schemes = [] as any;
                for (let item of _data["schemes"])
                    this.schemes!.push(item);
            }
            this.fixedFee = _data["fixedFee"];
            this.percentage = _data["percentage"];
            this.msfMinAmount = _data["msfMinAmount"];
            this.msfMaxAmount = _data["msfMaxAmount"];
            if (Array.isArray(_data["slabDetails"])) {
                this.slabDetails = [] as any;
                for (let item of _data["slabDetails"])
                    this.slabDetails!.push(SlabDetailsDTO.fromJS(item));
            }
            if (Array.isArray(_data["channels"])) {
                this.channels = [] as any;
                for (let item of _data["channels"])
                    this.channels!.push(item);
            }
            this.pricingType = _data["pricingType"];
            if (Array.isArray(_data["transactionOriginTypes"])) {
                this.transactionOriginTypes = [] as any;
                for (let item of _data["transactionOriginTypes"])
                    this.transactionOriginTypes!.push(item);
            }
            this.waivedAmount = _data["waivedAmount"];
            this.waivedVolume = _data["waivedVolume"];
            this.isWaivedAmountInPercentage = _data["isWaivedAmountInPercentage"];
            this.isWaivedVolumeInPercentage = _data["isWaivedVolumeInPercentage"];
        }
    }

    static fromJS(data: any): MsfPlanDto {
        data = typeof data === 'object' ? data : {};
        let result = new MsfPlanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["msfPlanId"] = this.msfPlanId;
        if (Array.isArray(this.schemes)) {
            data["schemes"] = [];
            for (let item of this.schemes)
                data["schemes"].push(item);
        }
        data["fixedFee"] = this.fixedFee;
        data["percentage"] = this.percentage;
        data["msfMinAmount"] = this.msfMinAmount;
        data["msfMaxAmount"] = this.msfMaxAmount;
        if (Array.isArray(this.slabDetails)) {
            data["slabDetails"] = [];
            for (let item of this.slabDetails)
                data["slabDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.channels)) {
            data["channels"] = [];
            for (let item of this.channels)
                data["channels"].push(item);
        }
        data["pricingType"] = this.pricingType;
        if (Array.isArray(this.transactionOriginTypes)) {
            data["transactionOriginTypes"] = [];
            for (let item of this.transactionOriginTypes)
                data["transactionOriginTypes"].push(item);
        }
        data["waivedAmount"] = this.waivedAmount;
        data["waivedVolume"] = this.waivedVolume;
        data["isWaivedAmountInPercentage"] = this.isWaivedAmountInPercentage;
        data["isWaivedVolumeInPercentage"] = this.isWaivedVolumeInPercentage;
        return data;
    }
}

export interface IMsfPlanDto {
    name?: string | undefined;
    msfPlanId?: string;
    schemes?: string[] | undefined;
    fixedFee?: number | undefined;
    percentage?: number | undefined;
    msfMinAmount?: number | undefined;
    msfMaxAmount?: number | undefined;
    slabDetails?: SlabDetailsDTO[] | undefined;
    channels?: string[] | undefined;
    pricingType?: string | undefined;
    transactionOriginTypes?: string[] | undefined;
    waivedAmount?: number | undefined;
    waivedVolume?: number | undefined;
    isWaivedAmountInPercentage?: boolean;
    isWaivedVolumeInPercentage?: boolean;
}

export class SlabDetailsDTO implements ISlabDetailsDTO {
    slabType?: string | undefined;
    fixedFee?: number | undefined;
    percentage?: number | undefined;
    msfMinAmount?: number | undefined;
    msfMaxAmount?: number | undefined;
    slabMinAmount?: number;
    slabMaxAmount?: number | undefined;

    constructor(data?: ISlabDetailsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.slabType = _data["slabType"];
            this.fixedFee = _data["fixedFee"];
            this.percentage = _data["percentage"];
            this.msfMinAmount = _data["msfMinAmount"];
            this.msfMaxAmount = _data["msfMaxAmount"];
            this.slabMinAmount = _data["slabMinAmount"];
            this.slabMaxAmount = _data["slabMaxAmount"];
        }
    }

    static fromJS(data: any): SlabDetailsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SlabDetailsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["slabType"] = this.slabType;
        data["fixedFee"] = this.fixedFee;
        data["percentage"] = this.percentage;
        data["msfMinAmount"] = this.msfMinAmount;
        data["msfMaxAmount"] = this.msfMaxAmount;
        data["slabMinAmount"] = this.slabMinAmount;
        data["slabMaxAmount"] = this.slabMaxAmount;
        return data;
    }
}

export interface ISlabDetailsDTO {
    slabType?: string | undefined;
    fixedFee?: number | undefined;
    percentage?: number | undefined;
    msfMinAmount?: number | undefined;
    msfMaxAmount?: number | undefined;
    slabMinAmount?: number;
    slabMaxAmount?: number | undefined;
}

export class CreateMemberBankCommand implements ICreateMemberBankCommand {
    bankName?: string | undefined;
    swiftCode?: string | undefined;

    constructor(data?: ICreateMemberBankCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankName = _data["bankName"];
            this.swiftCode = _data["swiftCode"];
        }
    }

    static fromJS(data: any): CreateMemberBankCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMemberBankCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankName"] = this.bankName;
        data["swiftCode"] = this.swiftCode;
        return data;
    }
}

export interface ICreateMemberBankCommand {
    bankName?: string | undefined;
    swiftCode?: string | undefined;
}

export class ApiResponseOfListOfIssuerBankVM implements IApiResponseOfListOfIssuerBankVM {
    success?: boolean;
    status?: string | undefined;
    message?: string | undefined;
    data?: IssuerBankVM[] | undefined;

    constructor(data?: IApiResponseOfListOfIssuerBankVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.status = _data["status"];
            this.message = _data["message"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(IssuerBankVM.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApiResponseOfListOfIssuerBankVM {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfListOfIssuerBankVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["status"] = this.status;
        data["message"] = this.message;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IApiResponseOfListOfIssuerBankVM {
    success?: boolean;
    status?: string | undefined;
    message?: string | undefined;
    data?: IssuerBankVM[] | undefined;
}

export class IssuerBankVM implements IIssuerBankVM {
    id?: string;
    bankName?: string | undefined;
    swiftCode?: string | undefined;
    isActive?: boolean;

    constructor(data?: IIssuerBankVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bankName = _data["bankName"];
            this.swiftCode = _data["swiftCode"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): IssuerBankVM {
        data = typeof data === 'object' ? data : {};
        let result = new IssuerBankVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankName"] = this.bankName;
        data["swiftCode"] = this.swiftCode;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IIssuerBankVM {
    id?: string;
    bankName?: string | undefined;
    swiftCode?: string | undefined;
    isActive?: boolean;
}

export class UpdateMemberBankCommand implements IUpdateMemberBankCommand {
    id?: string;
    bankName?: string | undefined;
    isActive?: boolean;

    constructor(data?: IUpdateMemberBankCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bankName = _data["bankName"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateMemberBankCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMemberBankCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankName"] = this.bankName;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUpdateMemberBankCommand {
    id?: string;
    bankName?: string | undefined;
    isActive?: boolean;
}

export class CreateUserCommand2 implements ICreateUserCommand2 {
    memberBankId?: string | undefined;
    outletId?: string | undefined;
    userName?: string | undefined;
    userType?: UserType;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: ICreateUserCommand2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberBankId = _data["memberBankId"];
            this.outletId = _data["outletId"];
            this.userName = _data["userName"];
            this.userType = _data["userType"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): CreateUserCommand2 {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserCommand2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberBankId"] = this.memberBankId;
        data["outletId"] = this.outletId;
        data["userName"] = this.userName;
        data["userType"] = this.userType;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface ICreateUserCommand2 {
    memberBankId?: string | undefined;
    outletId?: string | undefined;
    userName?: string | undefined;
    userType?: UserType;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
}

export class ApiResponseOfListOfIssuerMemberBankUserViewModel implements IApiResponseOfListOfIssuerMemberBankUserViewModel {
    success?: boolean;
    status?: string | undefined;
    message?: string | undefined;
    data?: IssuerMemberBankUserViewModel[] | undefined;

    constructor(data?: IApiResponseOfListOfIssuerMemberBankUserViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.status = _data["status"];
            this.message = _data["message"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(IssuerMemberBankUserViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApiResponseOfListOfIssuerMemberBankUserViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfListOfIssuerMemberBankUserViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["status"] = this.status;
        data["message"] = this.message;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IApiResponseOfListOfIssuerMemberBankUserViewModel {
    success?: boolean;
    status?: string | undefined;
    message?: string | undefined;
    data?: IssuerMemberBankUserViewModel[] | undefined;
}

export class IssuerMemberBankUserViewModel implements IIssuerMemberBankUserViewModel {
    id?: string | undefined;
    userName?: string | undefined;
    email?: string | undefined;
    userType?: UserType | undefined;
    outletName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    memberBankId?: string | undefined;
    oid?: string | undefined;
    swiftCode?: string | undefined;
    status?: string | undefined;
    isActive?: boolean;
    phoneNumber?: string | undefined;
    address?: string | undefined;

    constructor(data?: IIssuerMemberBankUserViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.userType = _data["userType"];
            this.outletName = _data["outletName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.memberBankId = _data["memberBankId"];
            this.oid = _data["oid"];
            this.swiftCode = _data["swiftCode"];
            this.status = _data["status"];
            this.isActive = _data["isActive"];
            this.phoneNumber = _data["phoneNumber"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): IssuerMemberBankUserViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new IssuerMemberBankUserViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["userType"] = this.userType;
        data["outletName"] = this.outletName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["memberBankId"] = this.memberBankId;
        data["oid"] = this.oid;
        data["swiftCode"] = this.swiftCode;
        data["status"] = this.status;
        data["isActive"] = this.isActive;
        data["phoneNumber"] = this.phoneNumber;
        data["address"] = this.address;
        return data;
    }
}

export interface IIssuerMemberBankUserViewModel {
    id?: string | undefined;
    userName?: string | undefined;
    email?: string | undefined;
    userType?: UserType | undefined;
    outletName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    memberBankId?: string | undefined;
    oid?: string | undefined;
    swiftCode?: string | undefined;
    status?: string | undefined;
    isActive?: boolean;
    phoneNumber?: string | undefined;
    address?: string | undefined;
}

export class ApiResponseOfListOfIssuerBankDropdownVM implements IApiResponseOfListOfIssuerBankDropdownVM {
    success?: boolean;
    status?: string | undefined;
    message?: string | undefined;
    data?: IssuerBankDropdownVM[] | undefined;

    constructor(data?: IApiResponseOfListOfIssuerBankDropdownVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.status = _data["status"];
            this.message = _data["message"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(IssuerBankDropdownVM.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApiResponseOfListOfIssuerBankDropdownVM {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfListOfIssuerBankDropdownVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["status"] = this.status;
        data["message"] = this.message;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IApiResponseOfListOfIssuerBankDropdownVM {
    success?: boolean;
    status?: string | undefined;
    message?: string | undefined;
    data?: IssuerBankDropdownVM[] | undefined;
}

export class IssuerBankDropdownVM implements IIssuerBankDropdownVM {
    id?: string;
    bankName?: string | undefined;
    swiftCode?: string | undefined;

    constructor(data?: IIssuerBankDropdownVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bankName = _data["bankName"];
            this.swiftCode = _data["swiftCode"];
        }
    }

    static fromJS(data: any): IssuerBankDropdownVM {
        data = typeof data === 'object' ? data : {};
        let result = new IssuerBankDropdownVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankName"] = this.bankName;
        data["swiftCode"] = this.swiftCode;
        return data;
    }
}

export interface IIssuerBankDropdownVM {
    id?: string;
    bankName?: string | undefined;
    swiftCode?: string | undefined;
}

export class UpdateUserOfMerchantCommand implements IUpdateUserOfMerchantCommand {
    id?: string;
    userName?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: IUpdateUserOfMerchantCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): UpdateUserOfMerchantCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserOfMerchantCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IUpdateUserOfMerchantCommand {
    id?: string;
    userName?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
}

export class ThirdPartyApiResponseOfAuthenticateSetupViewModel implements IThirdPartyApiResponseOfAuthenticateSetupViewModel {
    success?: boolean;
    status?: string | undefined;
    message?: string | undefined;
    data?: AuthenticateSetupViewModel | undefined;

    constructor(data?: IThirdPartyApiResponseOfAuthenticateSetupViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? AuthenticateSetupViewModel.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ThirdPartyApiResponseOfAuthenticateSetupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ThirdPartyApiResponseOfAuthenticateSetupViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IThirdPartyApiResponseOfAuthenticateSetupViewModel {
    success?: boolean;
    status?: string | undefined;
    message?: string | undefined;
    data?: AuthenticateSetupViewModel | undefined;
}

export class AuthenticateSetupViewModel implements IAuthenticateSetupViewModel {
    qrCodeSetupImageUrl?: string | undefined;
    email?: string | undefined;
    isQRScanned?: boolean;
    isEmailConfirmed?: boolean;
    isValidUser?: boolean;
    is2FAEnabled?: boolean;
    userId?: string;

    constructor(data?: IAuthenticateSetupViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qrCodeSetupImageUrl = _data["qrCodeSetupImageUrl"];
            this.email = _data["email"];
            this.isQRScanned = _data["isQRScanned"];
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.isValidUser = _data["isValidUser"];
            this.is2FAEnabled = _data["is2FAEnabled"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AuthenticateSetupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateSetupViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        data["email"] = this.email;
        data["isQRScanned"] = this.isQRScanned;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["isValidUser"] = this.isValidUser;
        data["is2FAEnabled"] = this.is2FAEnabled;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IAuthenticateSetupViewModel {
    qrCodeSetupImageUrl?: string | undefined;
    email?: string | undefined;
    isQRScanned?: boolean;
    isEmailConfirmed?: boolean;
    isValidUser?: boolean;
    is2FAEnabled?: boolean;
    userId?: string;
}

export class ThirdPartyApiResponseOfAuthResponseDTO implements IThirdPartyApiResponseOfAuthResponseDTO {
    success?: boolean;
    status?: string | undefined;
    message?: string | undefined;
    data?: AuthResponseDTO2 | undefined;

    constructor(data?: IThirdPartyApiResponseOfAuthResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? AuthResponseDTO2.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ThirdPartyApiResponseOfAuthResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ThirdPartyApiResponseOfAuthResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IThirdPartyApiResponseOfAuthResponseDTO {
    success?: boolean;
    status?: string | undefined;
    message?: string | undefined;
    data?: AuthResponseDTO2 | undefined;
}

export class AuthResponseDTO2 implements IAuthResponseDTO2 {
    token?: string | undefined;
    signature?: string | undefined;
    activeBaseUrl?: string | undefined;
    user?: UserInfo2 | undefined;
    expireAt?: string | undefined;
    banks?: BankList2[] | undefined;

    constructor(data?: IAuthResponseDTO2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.signature = _data["signature"];
            this.activeBaseUrl = _data["activeBaseUrl"];
            this.user = _data["user"] ? UserInfo2.fromJS(_data["user"]) : <any>undefined;
            this.expireAt = _data["expireAt"];
            if (Array.isArray(_data["banks"])) {
                this.banks = [] as any;
                for (let item of _data["banks"])
                    this.banks!.push(BankList2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuthResponseDTO2 {
        data = typeof data === 'object' ? data : {};
        let result = new AuthResponseDTO2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["signature"] = this.signature;
        data["activeBaseUrl"] = this.activeBaseUrl;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["expireAt"] = this.expireAt;
        if (Array.isArray(this.banks)) {
            data["banks"] = [];
            for (let item of this.banks)
                data["banks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAuthResponseDTO2 {
    token?: string | undefined;
    signature?: string | undefined;
    activeBaseUrl?: string | undefined;
    user?: UserInfo2 | undefined;
    expireAt?: string | undefined;
    banks?: BankList2[] | undefined;
}

export class UserInfo2 implements IUserInfo2 {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    address?: string | undefined;
    email?: string | undefined;
    userName?: string | undefined;
    mid?: string | undefined;
    oid?: string | undefined;
    merchantName?: string | undefined;
    outletName?: string | undefined;
    userType?: UserType;
    userTypeName?: string | undefined;
    phoneNumber?: string | undefined;
    iBankId?: string | undefined;

    constructor(data?: IUserInfo2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.address = _data["address"];
            this.email = _data["email"];
            this.userName = _data["userName"];
            this.mid = _data["mid"];
            this.oid = _data["oid"];
            this.merchantName = _data["merchantName"];
            this.outletName = _data["outletName"];
            this.userType = _data["userType"];
            this.userTypeName = _data["userTypeName"];
            this.phoneNumber = _data["phoneNumber"];
            this.iBankId = _data["iBankId"];
        }
    }

    static fromJS(data: any): UserInfo2 {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfo2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["address"] = this.address;
        data["email"] = this.email;
        data["userName"] = this.userName;
        data["mid"] = this.mid;
        data["oid"] = this.oid;
        data["merchantName"] = this.merchantName;
        data["outletName"] = this.outletName;
        data["userType"] = this.userType;
        data["userTypeName"] = this.userTypeName;
        data["phoneNumber"] = this.phoneNumber;
        data["iBankId"] = this.iBankId;
        return data;
    }
}

export interface IUserInfo2 {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    address?: string | undefined;
    email?: string | undefined;
    userName?: string | undefined;
    mid?: string | undefined;
    oid?: string | undefined;
    merchantName?: string | undefined;
    outletName?: string | undefined;
    userType?: UserType;
    userTypeName?: string | undefined;
    phoneNumber?: string | undefined;
    iBankId?: string | undefined;
}

export class BankList2 implements IBankList2 {
    iBankId?: string | undefined;
    name?: string | undefined;

    constructor(data?: IBankList2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iBankId = _data["iBankId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): BankList2 {
        data = typeof data === 'object' ? data : {};
        let result = new BankList2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iBankId"] = this.iBankId;
        data["name"] = this.name;
        return data;
    }
}

export interface IBankList2 {
    iBankId?: string | undefined;
    name?: string | undefined;
}

export class ThirdPartyApiResponseOfChangeBankDTO implements IThirdPartyApiResponseOfChangeBankDTO {
    success?: boolean;
    status?: string | undefined;
    message?: string | undefined;
    data?: ChangeBankDTO | undefined;

    constructor(data?: IThirdPartyApiResponseOfChangeBankDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? ChangeBankDTO.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ThirdPartyApiResponseOfChangeBankDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ThirdPartyApiResponseOfChangeBankDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IThirdPartyApiResponseOfChangeBankDTO {
    success?: boolean;
    status?: string | undefined;
    message?: string | undefined;
    data?: ChangeBankDTO | undefined;
}

export class ChangeBankDTO implements IChangeBankDTO {
    signature?: string | undefined;
    user?: UserInfo2 | undefined;
    activeBaseUrl?: string | undefined;

    constructor(data?: IChangeBankDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signature = _data["signature"];
            this.user = _data["user"] ? UserInfo2.fromJS(_data["user"]) : <any>undefined;
            this.activeBaseUrl = _data["activeBaseUrl"];
        }
    }

    static fromJS(data: any): ChangeBankDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeBankDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signature"] = this.signature;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["activeBaseUrl"] = this.activeBaseUrl;
        return data;
    }
}

export interface IChangeBankDTO {
    signature?: string | undefined;
    user?: UserInfo2 | undefined;
    activeBaseUrl?: string | undefined;
}

export class TwoFactorAuthentication implements ITwoFactorAuthentication {
    userName!: string;
    otp!: string;

    constructor(data?: ITwoFactorAuthentication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.otp = _data["otp"];
        }
    }

    static fromJS(data: any): TwoFactorAuthentication {
        data = typeof data === 'object' ? data : {};
        let result = new TwoFactorAuthentication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["otp"] = this.otp;
        return data;
    }
}

export interface ITwoFactorAuthentication {
    userName: string;
    otp: string;
}

export class TransactionDashboardSummaryViewModel implements ITransactionDashboardSummaryViewModel {
    totalRemainingSettlementAmount?: number | undefined;
    totalTransactionAmount?: number | undefined;
    totalTransactionCount?: number | undefined;
    totalTodayTransactionAmount?: number | undefined;
    totalTodayTransactionCount?: number | undefined;
    totalYesterdayTransactionAmount?: number | undefined;
    totalTodaySettledTransactionAmount?: number | undefined;
    totalYesterdaySettledTransactionAmount?: number | undefined;

    constructor(data?: ITransactionDashboardSummaryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRemainingSettlementAmount = _data["totalRemainingSettlementAmount"];
            this.totalTransactionAmount = _data["totalTransactionAmount"];
            this.totalTransactionCount = _data["totalTransactionCount"];
            this.totalTodayTransactionAmount = _data["totalTodayTransactionAmount"];
            this.totalTodayTransactionCount = _data["totalTodayTransactionCount"];
            this.totalYesterdayTransactionAmount = _data["totalYesterdayTransactionAmount"];
            this.totalTodaySettledTransactionAmount = _data["totalTodaySettledTransactionAmount"];
            this.totalYesterdaySettledTransactionAmount = _data["totalYesterdaySettledTransactionAmount"];
        }
    }

    static fromJS(data: any): TransactionDashboardSummaryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionDashboardSummaryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRemainingSettlementAmount"] = this.totalRemainingSettlementAmount;
        data["totalTransactionAmount"] = this.totalTransactionAmount;
        data["totalTransactionCount"] = this.totalTransactionCount;
        data["totalTodayTransactionAmount"] = this.totalTodayTransactionAmount;
        data["totalTodayTransactionCount"] = this.totalTodayTransactionCount;
        data["totalYesterdayTransactionAmount"] = this.totalYesterdayTransactionAmount;
        data["totalTodaySettledTransactionAmount"] = this.totalTodaySettledTransactionAmount;
        data["totalYesterdaySettledTransactionAmount"] = this.totalYesterdaySettledTransactionAmount;
        return data;
    }
}

export interface ITransactionDashboardSummaryViewModel {
    totalRemainingSettlementAmount?: number | undefined;
    totalTransactionAmount?: number | undefined;
    totalTransactionCount?: number | undefined;
    totalTodayTransactionAmount?: number | undefined;
    totalTodayTransactionCount?: number | undefined;
    totalYesterdayTransactionAmount?: number | undefined;
    totalTodaySettledTransactionAmount?: number | undefined;
    totalYesterdaySettledTransactionAmount?: number | undefined;
}

export class SwitchTransactionEntryCommand implements ISwitchTransactionEntryCommand {
    addSwitchTransactionLogs?: AddSwitchTransactionLogCommand[] | undefined;

    constructor(data?: ISwitchTransactionEntryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["addSwitchTransactionLogs"])) {
                this.addSwitchTransactionLogs = [] as any;
                for (let item of _data["addSwitchTransactionLogs"])
                    this.addSwitchTransactionLogs!.push(AddSwitchTransactionLogCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SwitchTransactionEntryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchTransactionEntryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.addSwitchTransactionLogs)) {
            data["addSwitchTransactionLogs"] = [];
            for (let item of this.addSwitchTransactionLogs)
                data["addSwitchTransactionLogs"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISwitchTransactionEntryCommand {
    addSwitchTransactionLogs?: AddSwitchTransactionLogCommand[] | undefined;
}

export class AddSwitchTransactionLogCommand implements IAddSwitchTransactionLogCommand {
    merchantId?: string | undefined;
    merchantName?: string | undefined;
    transactionType?: string | undefined;
    responseCode?: string | undefined;
    responseLabel?: string | undefined;
    referenceNumber?: string | undefined;
    currencyCode?: CurrencyCode;
    transactionAmount?: number;
    transactionDate?: Date;
    batchNumber?: string | undefined;
    remarks?: string | undefined;
    posEntryMode?: string | undefined;
    stanNumber?: string | undefined;
    cardType?: string | undefined;
    terminalId?: string | undefined;

    constructor(data?: IAddSwitchTransactionLogCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.merchantId = _data["merchantId"];
            this.merchantName = _data["merchantName"];
            this.transactionType = _data["transactionType"];
            this.responseCode = _data["responseCode"];
            this.responseLabel = _data["responseLabel"];
            this.referenceNumber = _data["referenceNumber"];
            this.currencyCode = _data["currencyCode"];
            this.transactionAmount = _data["transactionAmount"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.batchNumber = _data["batchNumber"];
            this.remarks = _data["remarks"];
            this.posEntryMode = _data["posEntryMode"];
            this.stanNumber = _data["stanNumber"];
            this.cardType = _data["cardType"];
            this.terminalId = _data["terminalId"];
        }
    }

    static fromJS(data: any): AddSwitchTransactionLogCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddSwitchTransactionLogCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["merchantId"] = this.merchantId;
        data["merchantName"] = this.merchantName;
        data["transactionType"] = this.transactionType;
        data["responseCode"] = this.responseCode;
        data["responseLabel"] = this.responseLabel;
        data["referenceNumber"] = this.referenceNumber;
        data["currencyCode"] = this.currencyCode;
        data["transactionAmount"] = this.transactionAmount;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["batchNumber"] = this.batchNumber;
        data["remarks"] = this.remarks;
        data["posEntryMode"] = this.posEntryMode;
        data["stanNumber"] = this.stanNumber;
        data["cardType"] = this.cardType;
        data["terminalId"] = this.terminalId;
        return data;
    }
}

export interface IAddSwitchTransactionLogCommand {
    merchantId?: string | undefined;
    merchantName?: string | undefined;
    transactionType?: string | undefined;
    responseCode?: string | undefined;
    responseLabel?: string | undefined;
    referenceNumber?: string | undefined;
    currencyCode?: CurrencyCode;
    transactionAmount?: number;
    transactionDate?: Date;
    batchNumber?: string | undefined;
    remarks?: string | undefined;
    posEntryMode?: string | undefined;
    stanNumber?: string | undefined;
    cardType?: string | undefined;
    terminalId?: string | undefined;
}

export enum CurrencyCode {
    BDT = 50,
    BTN = 64,
    INR = 356,
    NPR = 524,
    USD = 840,
}

export class PagedResponseOfTransactionDashboardViewModel implements IPagedResponseOfTransactionDashboardViewModel {
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    totalRecords?: number;
    data?: TransactionDashboardViewModel[] | undefined;
    message?: string | undefined;
    errors?: string[] | undefined;
    succeeded?: boolean;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPagedResponseOfTransactionDashboardViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TransactionDashboardViewModel.fromJS(item));
            }
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.succeeded = _data["succeeded"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PagedResponseOfTransactionDashboardViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfTransactionDashboardViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["succeeded"] = this.succeeded;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPagedResponseOfTransactionDashboardViewModel {
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    totalRecords?: number;
    data?: TransactionDashboardViewModel[] | undefined;
    message?: string | undefined;
    errors?: string[] | undefined;
    succeeded?: boolean;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class TransactionDashboardViewModel implements ITransactionDashboardViewModel {
    imerchantId?: string | undefined;
    iterminalId?: string | undefined;
    acquirerMerchantId?: string | undefined;
    acquirerTerminalId?: string | undefined;
    referenceId?: string | undefined;
    aid?: string | undefined;
    batchNumber?: string | undefined;
    traceNo?: string | undefined;
    cardNo?: string | undefined;
    rrn?: string | undefined;
    cardType?: string | undefined;
    authCode?: string | undefined;
    tc?: string | undefined;
    tvr?: string | undefined;
    tsi?: string | undefined;
    statusMessage?: string | undefined;
    merchantName?: string | undefined;
    merchantAddress?: string | undefined;
    entryMode?: string | undefined;
    transactionType?: string | undefined;
    paymentScheme?: string | undefined;
    currencyCode?: string | undefined;
    transactionAmount?: number;
    totalAmount?: number;
    posSerialNumber?: string | undefined;
    transactionStatusCode?: string | undefined;
    transactionDate?: string | undefined;
    transactionTime?: string | undefined;
    tipsAmount?: number | undefined;
    cardHolderName?: string | undefined;
    installmentPeriod?: number | undefined;
    monthlyInstallmentAmount?: number | undefined;
    firstInstallmentAmount?: number | undefined;
    invoiceNumber?: string | undefined;

    constructor(data?: ITransactionDashboardViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imerchantId = _data["imerchantId"];
            this.iterminalId = _data["iterminalId"];
            this.acquirerMerchantId = _data["acquirerMerchantId"];
            this.acquirerTerminalId = _data["acquirerTerminalId"];
            this.referenceId = _data["referenceId"];
            this.aid = _data["aid"];
            this.batchNumber = _data["batchNumber"];
            this.traceNo = _data["traceNo"];
            this.cardNo = _data["cardNo"];
            this.rrn = _data["rrn"];
            this.cardType = _data["cardType"];
            this.authCode = _data["authCode"];
            this.tc = _data["tc"];
            this.tvr = _data["tvr"];
            this.tsi = _data["tsi"];
            this.statusMessage = _data["statusMessage"];
            this.merchantName = _data["merchantName"];
            this.merchantAddress = _data["merchantAddress"];
            this.entryMode = _data["entryMode"];
            this.transactionType = _data["transactionType"];
            this.paymentScheme = _data["paymentScheme"];
            this.currencyCode = _data["currencyCode"];
            this.transactionAmount = _data["transactionAmount"];
            this.totalAmount = _data["totalAmount"];
            this.posSerialNumber = _data["posSerialNumber"];
            this.transactionStatusCode = _data["transactionStatusCode"];
            this.transactionDate = _data["transactionDate"];
            this.transactionTime = _data["transactionTime"];
            this.tipsAmount = _data["tipsAmount"];
            this.cardHolderName = _data["cardHolderName"];
            this.installmentPeriod = _data["installmentPeriod"];
            this.monthlyInstallmentAmount = _data["monthlyInstallmentAmount"];
            this.firstInstallmentAmount = _data["firstInstallmentAmount"];
            this.invoiceNumber = _data["invoiceNumber"];
        }
    }

    static fromJS(data: any): TransactionDashboardViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionDashboardViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imerchantId"] = this.imerchantId;
        data["iterminalId"] = this.iterminalId;
        data["acquirerMerchantId"] = this.acquirerMerchantId;
        data["acquirerTerminalId"] = this.acquirerTerminalId;
        data["referenceId"] = this.referenceId;
        data["aid"] = this.aid;
        data["batchNumber"] = this.batchNumber;
        data["traceNo"] = this.traceNo;
        data["cardNo"] = this.cardNo;
        data["rrn"] = this.rrn;
        data["cardType"] = this.cardType;
        data["authCode"] = this.authCode;
        data["tc"] = this.tc;
        data["tvr"] = this.tvr;
        data["tsi"] = this.tsi;
        data["statusMessage"] = this.statusMessage;
        data["merchantName"] = this.merchantName;
        data["merchantAddress"] = this.merchantAddress;
        data["entryMode"] = this.entryMode;
        data["transactionType"] = this.transactionType;
        data["paymentScheme"] = this.paymentScheme;
        data["currencyCode"] = this.currencyCode;
        data["transactionAmount"] = this.transactionAmount;
        data["totalAmount"] = this.totalAmount;
        data["posSerialNumber"] = this.posSerialNumber;
        data["transactionStatusCode"] = this.transactionStatusCode;
        data["transactionDate"] = this.transactionDate;
        data["transactionTime"] = this.transactionTime;
        data["tipsAmount"] = this.tipsAmount;
        data["cardHolderName"] = this.cardHolderName;
        data["installmentPeriod"] = this.installmentPeriod;
        data["monthlyInstallmentAmount"] = this.monthlyInstallmentAmount;
        data["firstInstallmentAmount"] = this.firstInstallmentAmount;
        data["invoiceNumber"] = this.invoiceNumber;
        return data;
    }
}

export interface ITransactionDashboardViewModel {
    imerchantId?: string | undefined;
    iterminalId?: string | undefined;
    acquirerMerchantId?: string | undefined;
    acquirerTerminalId?: string | undefined;
    referenceId?: string | undefined;
    aid?: string | undefined;
    batchNumber?: string | undefined;
    traceNo?: string | undefined;
    cardNo?: string | undefined;
    rrn?: string | undefined;
    cardType?: string | undefined;
    authCode?: string | undefined;
    tc?: string | undefined;
    tvr?: string | undefined;
    tsi?: string | undefined;
    statusMessage?: string | undefined;
    merchantName?: string | undefined;
    merchantAddress?: string | undefined;
    entryMode?: string | undefined;
    transactionType?: string | undefined;
    paymentScheme?: string | undefined;
    currencyCode?: string | undefined;
    transactionAmount?: number;
    totalAmount?: number;
    posSerialNumber?: string | undefined;
    transactionStatusCode?: string | undefined;
    transactionDate?: string | undefined;
    transactionTime?: string | undefined;
    tipsAmount?: number | undefined;
    cardHolderName?: string | undefined;
    installmentPeriod?: number | undefined;
    monthlyInstallmentAmount?: number | undefined;
    firstInstallmentAmount?: number | undefined;
    invoiceNumber?: string | undefined;
}

export class TidMidSpecifiedDashboardSummaryViewModel implements ITidMidSpecifiedDashboardSummaryViewModel {
    totalTransactionAmount?: number | undefined;
    totalTransactionCount?: number | undefined;
    totalRemainaingSettlementAmount?: number | undefined;
    totalPendingSettlementCount?: number | undefined;
    todaysTransactionSummary?: TodayTransactionSummary2 | undefined;
    yesterDaysTransactionSummary?: YesterDayTransactionSummary2 | undefined;

    constructor(data?: ITidMidSpecifiedDashboardSummaryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalTransactionAmount = _data["totalTransactionAmount"];
            this.totalTransactionCount = _data["totalTransactionCount"];
            this.totalRemainaingSettlementAmount = _data["totalRemainaingSettlementAmount"];
            this.totalPendingSettlementCount = _data["totalPendingSettlementCount"];
            this.todaysTransactionSummary = _data["todaysTransactionSummary"] ? TodayTransactionSummary2.fromJS(_data["todaysTransactionSummary"]) : <any>undefined;
            this.yesterDaysTransactionSummary = _data["yesterDaysTransactionSummary"] ? YesterDayTransactionSummary2.fromJS(_data["yesterDaysTransactionSummary"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TidMidSpecifiedDashboardSummaryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TidMidSpecifiedDashboardSummaryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalTransactionAmount"] = this.totalTransactionAmount;
        data["totalTransactionCount"] = this.totalTransactionCount;
        data["totalRemainaingSettlementAmount"] = this.totalRemainaingSettlementAmount;
        data["totalPendingSettlementCount"] = this.totalPendingSettlementCount;
        data["todaysTransactionSummary"] = this.todaysTransactionSummary ? this.todaysTransactionSummary.toJSON() : <any>undefined;
        data["yesterDaysTransactionSummary"] = this.yesterDaysTransactionSummary ? this.yesterDaysTransactionSummary.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITidMidSpecifiedDashboardSummaryViewModel {
    totalTransactionAmount?: number | undefined;
    totalTransactionCount?: number | undefined;
    totalRemainaingSettlementAmount?: number | undefined;
    totalPendingSettlementCount?: number | undefined;
    todaysTransactionSummary?: TodayTransactionSummary2 | undefined;
    yesterDaysTransactionSummary?: YesterDayTransactionSummary2 | undefined;
}

export class TodayTransactionSummary2 implements ITodayTransactionSummary2 {
    transactionAmount?: number | undefined;
    totalTodayTransactionCount?: number | undefined;
    settlementAmount?: number | undefined;
    totalTodaySettledTransactionCount?: number | undefined;

    constructor(data?: ITodayTransactionSummary2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionAmount = _data["transactionAmount"];
            this.totalTodayTransactionCount = _data["totalTodayTransactionCount"];
            this.settlementAmount = _data["settlementAmount"];
            this.totalTodaySettledTransactionCount = _data["totalTodaySettledTransactionCount"];
        }
    }

    static fromJS(data: any): TodayTransactionSummary2 {
        data = typeof data === 'object' ? data : {};
        let result = new TodayTransactionSummary2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionAmount"] = this.transactionAmount;
        data["totalTodayTransactionCount"] = this.totalTodayTransactionCount;
        data["settlementAmount"] = this.settlementAmount;
        data["totalTodaySettledTransactionCount"] = this.totalTodaySettledTransactionCount;
        return data;
    }
}

export interface ITodayTransactionSummary2 {
    transactionAmount?: number | undefined;
    totalTodayTransactionCount?: number | undefined;
    settlementAmount?: number | undefined;
    totalTodaySettledTransactionCount?: number | undefined;
}

export class YesterDayTransactionSummary2 implements IYesterDayTransactionSummary2 {
    transactionAmount?: number | undefined;
    totalYesterdayTransactionCount?: number | undefined;
    settlementAmount?: number | undefined;
    totalYesterdaySettledCount?: number | undefined;

    constructor(data?: IYesterDayTransactionSummary2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionAmount = _data["transactionAmount"];
            this.totalYesterdayTransactionCount = _data["totalYesterdayTransactionCount"];
            this.settlementAmount = _data["settlementAmount"];
            this.totalYesterdaySettledCount = _data["totalYesterdaySettledCount"];
        }
    }

    static fromJS(data: any): YesterDayTransactionSummary2 {
        data = typeof data === 'object' ? data : {};
        let result = new YesterDayTransactionSummary2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionAmount"] = this.transactionAmount;
        data["totalYesterdayTransactionCount"] = this.totalYesterdayTransactionCount;
        data["settlementAmount"] = this.settlementAmount;
        data["totalYesterdaySettledCount"] = this.totalYesterdaySettledCount;
        return data;
    }
}

export interface IYesterDayTransactionSummary2 {
    transactionAmount?: number | undefined;
    totalYesterdayTransactionCount?: number | undefined;
    settlementAmount?: number | undefined;
    totalYesterdaySettledCount?: number | undefined;
}

export class CardTransactionSummaryViewModel implements ICardTransactionSummaryViewModel {
    totalTransactionAmount?: number | undefined;
    totalTransactionCount?: number | undefined;
    totalTodayTransactionAmount?: number | undefined;
    totalTodayTransactionCount?: number | undefined;

    constructor(data?: ICardTransactionSummaryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalTransactionAmount = _data["totalTransactionAmount"];
            this.totalTransactionCount = _data["totalTransactionCount"];
            this.totalTodayTransactionAmount = _data["totalTodayTransactionAmount"];
            this.totalTodayTransactionCount = _data["totalTodayTransactionCount"];
        }
    }

    static fromJS(data: any): CardTransactionSummaryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CardTransactionSummaryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalTransactionAmount"] = this.totalTransactionAmount;
        data["totalTransactionCount"] = this.totalTransactionCount;
        data["totalTodayTransactionAmount"] = this.totalTodayTransactionAmount;
        data["totalTodayTransactionCount"] = this.totalTodayTransactionCount;
        return data;
    }
}

export interface ICardTransactionSummaryViewModel {
    totalTransactionAmount?: number | undefined;
    totalTransactionCount?: number | undefined;
    totalTodayTransactionAmount?: number | undefined;
    totalTodayTransactionCount?: number | undefined;
}

export class QRTransactionSummaryViewModel implements IQRTransactionSummaryViewModel {
    totalTransactionAmount?: number | undefined;
    totalTransactionCount?: number | undefined;
    totalTodayTransactionAmount?: number | undefined;
    totalTodayTransactionCount?: number | undefined;

    constructor(data?: IQRTransactionSummaryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalTransactionAmount = _data["totalTransactionAmount"];
            this.totalTransactionCount = _data["totalTransactionCount"];
            this.totalTodayTransactionAmount = _data["totalTodayTransactionAmount"];
            this.totalTodayTransactionCount = _data["totalTodayTransactionCount"];
        }
    }

    static fromJS(data: any): QRTransactionSummaryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QRTransactionSummaryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalTransactionAmount"] = this.totalTransactionAmount;
        data["totalTransactionCount"] = this.totalTransactionCount;
        data["totalTodayTransactionAmount"] = this.totalTodayTransactionAmount;
        data["totalTodayTransactionCount"] = this.totalTodayTransactionCount;
        return data;
    }
}

export interface IQRTransactionSummaryViewModel {
    totalTransactionAmount?: number | undefined;
    totalTransactionCount?: number | undefined;
    totalTodayTransactionAmount?: number | undefined;
    totalTodayTransactionCount?: number | undefined;
}

export class TransactionTrendsViewModel implements ITransactionTrendsViewModel {
    formattedTransactionDate?: string | undefined;
    transactionDate?: Date;
    transactionAmount?: number;
    transactionCount?: number;

    constructor(data?: ITransactionTrendsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formattedTransactionDate = _data["formattedTransactionDate"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.transactionAmount = _data["transactionAmount"];
            this.transactionCount = _data["transactionCount"];
        }
    }

    static fromJS(data: any): TransactionTrendsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionTrendsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formattedTransactionDate"] = this.formattedTransactionDate;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["transactionAmount"] = this.transactionAmount;
        data["transactionCount"] = this.transactionCount;
        return data;
    }
}

export interface ITransactionTrendsViewModel {
    formattedTransactionDate?: string | undefined;
    transactionDate?: Date;
    transactionAmount?: number;
    transactionCount?: number;
}

export class TransactionSpecificTerminalStatusViewModel implements ITransactionSpecificTerminalStatusViewModel {
    active?: number;
    idle?: number;
    inActive?: number;

    constructor(data?: ITransactionSpecificTerminalStatusViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.idle = _data["idle"];
            this.inActive = _data["inActive"];
        }
    }

    static fromJS(data: any): TransactionSpecificTerminalStatusViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionSpecificTerminalStatusViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["idle"] = this.idle;
        data["inActive"] = this.inActive;
        return data;
    }
}

export interface ITransactionSpecificTerminalStatusViewModel {
    active?: number;
    idle?: number;
    inActive?: number;
}

export class TransactionRateViewModel implements ITransactionRateViewModel {
    transactionCategory?: string | undefined;
    terminalCount?: number;

    constructor(data?: ITransactionRateViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionCategory = _data["transactionCategory"];
            this.terminalCount = _data["terminalCount"];
        }
    }

    static fromJS(data: any): TransactionRateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionRateViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionCategory"] = this.transactionCategory;
        data["terminalCount"] = this.terminalCount;
        return data;
    }
}

export interface ITransactionRateViewModel {
    transactionCategory?: string | undefined;
    terminalCount?: number;
}

export class MerchantTransactionStatus implements IMerchantTransactionStatus {
    success?: number;
    failure?: number;
    pending?: number;

    constructor(data?: IMerchantTransactionStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.failure = _data["failure"];
            this.pending = _data["pending"];
        }
    }

    static fromJS(data: any): MerchantTransactionStatus {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantTransactionStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["failure"] = this.failure;
        data["pending"] = this.pending;
        return data;
    }
}

export interface IMerchantTransactionStatus {
    success?: number;
    failure?: number;
    pending?: number;
}

export class TransactionDetailsViewModel implements ITransactionDetailsViewModel {
    acquirerMerchantId?: string | undefined;
    acquirerTerminalId?: string | undefined;
    merchantName?: string | undefined;
    merchantAddress?: string | undefined;
    transactionLogId?: string;
    cardNumber?: string | undefined;
    invoiceNumber?: string | undefined;
    transactionType?: string | undefined;
    approvalCode?: string | undefined;
    transactionAmount?: number;
    expirationDate?: Date;
    transactionDate?: string | undefined;
    transactionTime?: string | undefined;
    cardType?: number;
    rrn?: string | undefined;
    origRrn?: string | undefined;

    constructor(data?: ITransactionDetailsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acquirerMerchantId = _data["acquirerMerchantId"];
            this.acquirerTerminalId = _data["acquirerTerminalId"];
            this.merchantName = _data["merchantName"];
            this.merchantAddress = _data["merchantAddress"];
            this.transactionLogId = _data["transactionLogId"];
            this.cardNumber = _data["cardNumber"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.transactionType = _data["transactionType"];
            this.approvalCode = _data["approvalCode"];
            this.transactionAmount = _data["transactionAmount"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.transactionDate = _data["transactionDate"];
            this.transactionTime = _data["transactionTime"];
            this.cardType = _data["cardType"];
            this.rrn = _data["rrn"];
            this.origRrn = _data["origRrn"];
        }
    }

    static fromJS(data: any): TransactionDetailsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionDetailsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acquirerMerchantId"] = this.acquirerMerchantId;
        data["acquirerTerminalId"] = this.acquirerTerminalId;
        data["merchantName"] = this.merchantName;
        data["merchantAddress"] = this.merchantAddress;
        data["transactionLogId"] = this.transactionLogId;
        data["cardNumber"] = this.cardNumber;
        data["invoiceNumber"] = this.invoiceNumber;
        data["transactionType"] = this.transactionType;
        data["approvalCode"] = this.approvalCode;
        data["transactionAmount"] = this.transactionAmount;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["transactionDate"] = this.transactionDate;
        data["transactionTime"] = this.transactionTime;
        data["cardType"] = this.cardType;
        data["rrn"] = this.rrn;
        data["origRrn"] = this.origRrn;
        return data;
    }
}

export interface ITransactionDetailsViewModel {
    acquirerMerchantId?: string | undefined;
    acquirerTerminalId?: string | undefined;
    merchantName?: string | undefined;
    merchantAddress?: string | undefined;
    transactionLogId?: string;
    cardNumber?: string | undefined;
    invoiceNumber?: string | undefined;
    transactionType?: string | undefined;
    approvalCode?: string | undefined;
    transactionAmount?: number;
    expirationDate?: Date;
    transactionDate?: string | undefined;
    transactionTime?: string | undefined;
    cardType?: number;
    rrn?: string | undefined;
    origRrn?: string | undefined;
}

export class TransactionLogReceiptViewModel implements ITransactionLogReceiptViewModel {
    acquirerMerchantId?: string | undefined;
    acquirerTerminalId?: string | undefined;
    referenceId?: string | undefined;
    aid?: string | undefined;
    batchNumber?: string | undefined;
    traceNo?: string | undefined;
    origTraceNo?: string | undefined;
    cardNo?: string | undefined;
    rrn?: string | undefined;
    cardType?: string | undefined;
    authCode?: string | undefined;
    tc?: string | undefined;
    tvr?: string | undefined;
    tsi?: string | undefined;
    merchantName?: string | undefined;
    merchantAddress?: string | undefined;
    entryMode?: string | undefined;
    transactionType?: number;
    appLabel?: string | undefined;
    currencyCode?: CurrencyCode;
    transactionAmount?: number;
    totalAmount?: number;
    transactionDate?: string | undefined;
    transactionTime?: string | undefined;

    constructor(data?: ITransactionLogReceiptViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acquirerMerchantId = _data["acquirerMerchantId"];
            this.acquirerTerminalId = _data["acquirerTerminalId"];
            this.referenceId = _data["referenceId"];
            this.aid = _data["aid"];
            this.batchNumber = _data["batchNumber"];
            this.traceNo = _data["traceNo"];
            this.origTraceNo = _data["origTraceNo"];
            this.cardNo = _data["cardNo"];
            this.rrn = _data["rrn"];
            this.cardType = _data["cardType"];
            this.authCode = _data["authCode"];
            this.tc = _data["tc"];
            this.tvr = _data["tvr"];
            this.tsi = _data["tsi"];
            this.merchantName = _data["merchantName"];
            this.merchantAddress = _data["merchantAddress"];
            this.entryMode = _data["entryMode"];
            this.transactionType = _data["transactionType"];
            this.appLabel = _data["appLabel"];
            this.currencyCode = _data["currencyCode"];
            this.transactionAmount = _data["transactionAmount"];
            this.totalAmount = _data["totalAmount"];
            this.transactionDate = _data["transactionDate"];
            this.transactionTime = _data["transactionTime"];
        }
    }

    static fromJS(data: any): TransactionLogReceiptViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionLogReceiptViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acquirerMerchantId"] = this.acquirerMerchantId;
        data["acquirerTerminalId"] = this.acquirerTerminalId;
        data["referenceId"] = this.referenceId;
        data["aid"] = this.aid;
        data["batchNumber"] = this.batchNumber;
        data["traceNo"] = this.traceNo;
        data["origTraceNo"] = this.origTraceNo;
        data["cardNo"] = this.cardNo;
        data["rrn"] = this.rrn;
        data["cardType"] = this.cardType;
        data["authCode"] = this.authCode;
        data["tc"] = this.tc;
        data["tvr"] = this.tvr;
        data["tsi"] = this.tsi;
        data["merchantName"] = this.merchantName;
        data["merchantAddress"] = this.merchantAddress;
        data["entryMode"] = this.entryMode;
        data["transactionType"] = this.transactionType;
        data["appLabel"] = this.appLabel;
        data["currencyCode"] = this.currencyCode;
        data["transactionAmount"] = this.transactionAmount;
        data["totalAmount"] = this.totalAmount;
        data["transactionDate"] = this.transactionDate;
        data["transactionTime"] = this.transactionTime;
        return data;
    }
}

export interface ITransactionLogReceiptViewModel {
    acquirerMerchantId?: string | undefined;
    acquirerTerminalId?: string | undefined;
    referenceId?: string | undefined;
    aid?: string | undefined;
    batchNumber?: string | undefined;
    traceNo?: string | undefined;
    origTraceNo?: string | undefined;
    cardNo?: string | undefined;
    rrn?: string | undefined;
    cardType?: string | undefined;
    authCode?: string | undefined;
    tc?: string | undefined;
    tvr?: string | undefined;
    tsi?: string | undefined;
    merchantName?: string | undefined;
    merchantAddress?: string | undefined;
    entryMode?: string | undefined;
    transactionType?: number;
    appLabel?: string | undefined;
    currencyCode?: CurrencyCode;
    transactionAmount?: number;
    totalAmount?: number;
    transactionDate?: string | undefined;
    transactionTime?: string | undefined;
}

export class NepalpayTransactionReceiptVM implements INepalpayTransactionReceiptVM {
    merchantName?: string | undefined;
    merchantAddress?: string | undefined;
    referenceId?: string | undefined;
    acquirerMerchantId?: string | undefined;
    acquirerTerminalId?: string | undefined;
    transactionDate?: string | undefined;
    transactionTime?: string | undefined;
    payerName?: string | undefined;
    initiatorId?: string | undefined;
    amount?: number;

    constructor(data?: INepalpayTransactionReceiptVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.merchantName = _data["merchantName"];
            this.merchantAddress = _data["merchantAddress"];
            this.referenceId = _data["referenceId"];
            this.acquirerMerchantId = _data["acquirerMerchantId"];
            this.acquirerTerminalId = _data["acquirerTerminalId"];
            this.transactionDate = _data["transactionDate"];
            this.transactionTime = _data["transactionTime"];
            this.payerName = _data["payerName"];
            this.initiatorId = _data["initiatorId"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): NepalpayTransactionReceiptVM {
        data = typeof data === 'object' ? data : {};
        let result = new NepalpayTransactionReceiptVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["merchantName"] = this.merchantName;
        data["merchantAddress"] = this.merchantAddress;
        data["referenceId"] = this.referenceId;
        data["acquirerMerchantId"] = this.acquirerMerchantId;
        data["acquirerTerminalId"] = this.acquirerTerminalId;
        data["transactionDate"] = this.transactionDate;
        data["transactionTime"] = this.transactionTime;
        data["payerName"] = this.payerName;
        data["initiatorId"] = this.initiatorId;
        data["amount"] = this.amount;
        return data;
    }
}

export interface INepalpayTransactionReceiptVM {
    merchantName?: string | undefined;
    merchantAddress?: string | undefined;
    referenceId?: string | undefined;
    acquirerMerchantId?: string | undefined;
    acquirerTerminalId?: string | undefined;
    transactionDate?: string | undefined;
    transactionTime?: string | undefined;
    payerName?: string | undefined;
    initiatorId?: string | undefined;
    amount?: number;
}

export class FonepayTransactionReceiptVM implements IFonepayTransactionReceiptVM {
    merchantName?: string | undefined;
    merchantAddress?: string | undefined;
    referenceId?: string | undefined;
    acquirerMerchantId?: string | undefined;
    acquirerTerminalId?: string | undefined;
    transactionDate?: string | undefined;
    transactionTime?: string | undefined;
    amount?: number;

    constructor(data?: IFonepayTransactionReceiptVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.merchantName = _data["merchantName"];
            this.merchantAddress = _data["merchantAddress"];
            this.referenceId = _data["referenceId"];
            this.acquirerMerchantId = _data["acquirerMerchantId"];
            this.acquirerTerminalId = _data["acquirerTerminalId"];
            this.transactionDate = _data["transactionDate"];
            this.transactionTime = _data["transactionTime"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): FonepayTransactionReceiptVM {
        data = typeof data === 'object' ? data : {};
        let result = new FonepayTransactionReceiptVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["merchantName"] = this.merchantName;
        data["merchantAddress"] = this.merchantAddress;
        data["referenceId"] = this.referenceId;
        data["acquirerMerchantId"] = this.acquirerMerchantId;
        data["acquirerTerminalId"] = this.acquirerTerminalId;
        data["transactionDate"] = this.transactionDate;
        data["transactionTime"] = this.transactionTime;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IFonepayTransactionReceiptVM {
    merchantName?: string | undefined;
    merchantAddress?: string | undefined;
    referenceId?: string | undefined;
    acquirerMerchantId?: string | undefined;
    acquirerTerminalId?: string | undefined;
    transactionDate?: string | undefined;
    transactionTime?: string | undefined;
    amount?: number;
}

export class PagedResponseOfAllTransactionsVM implements IPagedResponseOfAllTransactionsVM {
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    totalRecords?: number;
    data?: AllTransactionsVM[] | undefined;
    message?: string | undefined;
    errors?: string[] | undefined;
    succeeded?: boolean;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPagedResponseOfAllTransactionsVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AllTransactionsVM.fromJS(item));
            }
            this.message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.succeeded = _data["succeeded"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PagedResponseOfAllTransactionsVM {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfAllTransactionsVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["succeeded"] = this.succeeded;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPagedResponseOfAllTransactionsVM {
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    totalRecords?: number;
    data?: AllTransactionsVM[] | undefined;
    message?: string | undefined;
    errors?: string[] | undefined;
    succeeded?: boolean;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class AllTransactionsVM implements IAllTransactionsVM {
    mid?: string | undefined;
    tid?: string | undefined;
    merchant?: string | undefined;
    address?: string | undefined;
    referenceId?: string | undefined;
    rrn?: string | undefined;
    statusMessage?: string | undefined;
    transactionDate?: string | undefined;
    transactionTime?: string | undefined;
    appLabel?: string | undefined;
    totalAmount?: number;
    transactionStatusCode?: string | undefined;
    batchNumber?: string | undefined;
    transactionType?: string | undefined;
    currencyCode?: string | undefined;
    transactionEntryModeType?: string | undefined;
    txnType?: number;
    entryMode?: number;
    tipsAmount?: number | undefined;
    cardHolderName?: string | undefined;
    installmentPeriod?: number | undefined;
    monthlyInstallmentAmount?: number | undefined;
    firstInstallmentAmount?: number | undefined;
    invoiceNumber?: string | undefined;

    constructor(data?: IAllTransactionsVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mid = _data["mid"];
            this.tid = _data["tid"];
            this.merchant = _data["merchant"];
            this.address = _data["address"];
            this.referenceId = _data["referenceId"];
            this.rrn = _data["rrn"];
            this.statusMessage = _data["statusMessage"];
            this.transactionDate = _data["transactionDate"];
            this.transactionTime = _data["transactionTime"];
            this.appLabel = _data["appLabel"];
            this.totalAmount = _data["totalAmount"];
            this.transactionStatusCode = _data["transactionStatusCode"];
            this.batchNumber = _data["batchNumber"];
            this.transactionType = _data["transactionType"];
            this.currencyCode = _data["currencyCode"];
            this.transactionEntryModeType = _data["transactionEntryModeType"];
            this.txnType = _data["txnType"];
            this.entryMode = _data["entryMode"];
            this.tipsAmount = _data["tipsAmount"];
            this.cardHolderName = _data["cardHolderName"];
            this.installmentPeriod = _data["installmentPeriod"];
            this.monthlyInstallmentAmount = _data["monthlyInstallmentAmount"];
            this.firstInstallmentAmount = _data["firstInstallmentAmount"];
            this.invoiceNumber = _data["invoiceNumber"];
        }
    }

    static fromJS(data: any): AllTransactionsVM {
        data = typeof data === 'object' ? data : {};
        let result = new AllTransactionsVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mid"] = this.mid;
        data["tid"] = this.tid;
        data["merchant"] = this.merchant;
        data["address"] = this.address;
        data["referenceId"] = this.referenceId;
        data["rrn"] = this.rrn;
        data["statusMessage"] = this.statusMessage;
        data["transactionDate"] = this.transactionDate;
        data["transactionTime"] = this.transactionTime;
        data["appLabel"] = this.appLabel;
        data["totalAmount"] = this.totalAmount;
        data["transactionStatusCode"] = this.transactionStatusCode;
        data["batchNumber"] = this.batchNumber;
        data["transactionType"] = this.transactionType;
        data["currencyCode"] = this.currencyCode;
        data["transactionEntryModeType"] = this.transactionEntryModeType;
        data["txnType"] = this.txnType;
        data["entryMode"] = this.entryMode;
        data["tipsAmount"] = this.tipsAmount;
        data["cardHolderName"] = this.cardHolderName;
        data["installmentPeriod"] = this.installmentPeriod;
        data["monthlyInstallmentAmount"] = this.monthlyInstallmentAmount;
        data["firstInstallmentAmount"] = this.firstInstallmentAmount;
        data["invoiceNumber"] = this.invoiceNumber;
        return data;
    }
}

export interface IAllTransactionsVM {
    mid?: string | undefined;
    tid?: string | undefined;
    merchant?: string | undefined;
    address?: string | undefined;
    referenceId?: string | undefined;
    rrn?: string | undefined;
    statusMessage?: string | undefined;
    transactionDate?: string | undefined;
    transactionTime?: string | undefined;
    appLabel?: string | undefined;
    totalAmount?: number;
    transactionStatusCode?: string | undefined;
    batchNumber?: string | undefined;
    transactionType?: string | undefined;
    currencyCode?: string | undefined;
    transactionEntryModeType?: string | undefined;
    txnType?: number;
    entryMode?: number;
    tipsAmount?: number | undefined;
    cardHolderName?: string | undefined;
    installmentPeriod?: number | undefined;
    monthlyInstallmentAmount?: number | undefined;
    firstInstallmentAmount?: number | undefined;
    invoiceNumber?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}